/* eslint-disable */
import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { supabase } from './supabaseClient';

const FONT_LINK = `@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@300;400;500;600;700&family=Barlow+Condensed:wght@400;600;700&family=Inter:wght@300;400;500;600;700&family=DM+Sans:wght@300;400;500;600;700&family=Outfit:wght@300;400;500;600;700&display=swap');`;
const EIA_KEY = process.env.REACT_APP_EIA_KEY || "";
const ORS_KEY = process.env.REACT_APP_ORS_KEY || "";
const STORE_KEY = "rv-trip-planner-v3";
const KOFI_URL = "https://ko-fi.com/rvtripplanner";

const STATE_TO_EIA_REGION = {
  ME:"R10",NH:"R10",VT:"R10",MA:"R10",RI:"R10",CT:"R10",NY:"R10",NJ:"R10",PA:"R10",DE:"R10",MD:"R10",VA:"R10",WV:"R10",NC:"R10",SC:"R10",GA:"R10",FL:"R10",
  OH:"R20",MI:"R20",IN:"R20",IL:"R20",WI:"R20",MN:"R20",IA:"R20",MO:"R20",ND:"R20",SD:"R20",NE:"R20",KS:"R20",
  TX:"R30",LA:"R30",MS:"R30",AL:"R30",AR:"R30",TN:"R30",KY:"R30",OK:"R30",
  MT:"R40",ID:"R40",WY:"R40",CO:"R40",UT:"R40",NV:"R40",AZ:"R40",NM:"R40",
  WA:"R50",OR:"R50",CA:"R50",AK:"R50",HI:"R50",
};

// ── THEMES ─────────────────────────────────────────────────────────
const THEMES = {
  cream: {
    name:"🤍 Cream",font:"Georgia",
    bg:"#faf8f4",bgMid:"#f5f1eb",bgLite:"#ede9e1",
    text:"#2c2416",muted:"#7a6e60",border:"#d4ccbe",
    accent:"#8b6914",blue:"#3b6b9e",danger:"#c0392b",
    free:"#2d7a4f",headerGrad:"linear-gradient(135deg,#e8dfd0,#d4c9b5)",
    cardShadow:"0 1px 4px rgba(0,0,0,0.08)",
  },
  asphalt: {
    name:"🖤 Asphalt", font:"Barlow",
    bg:"#1a1a1e", bgMid:"#26262c", bgLite:"#32323a",
    accent:"#f5c518", accentAlt:"#e8a30a", border:"#4a4a56",
    green:"#2a8a54", blue:"#2255a4",
    danger:"#c0392b", text:"#f8f8f0", muted:"#9494a0", free:"#27ae60",
    headerGrad:"linear-gradient(135deg,#26262c 0%,#0d0d10 100%)",
    stripe:`repeating-linear-gradient(90deg,#26262c 0,#26262c 40px,#f5c518 40px,#f5c518 80px,#26262c 80px,#26262c 120px)`,
  },
  midnight: {
    name:"🌙 Midnight", font:"Inter",
    bg:"#0d1117", bgMid:"#161b22", bgLite:"#21262d",
    accent:"#58a6ff", accentAlt:"#1f6feb", border:"#30363d",
    green:"#3fb950", blue:"#388bfd",
    danger:"#f85149", text:"#e6edf3", muted:"#8b949e", free:"#3fb950",
    headerGrad:"linear-gradient(135deg,#161b22 0%,#0d1117 100%)",
    stripe:`repeating-linear-gradient(90deg,#161b22 0,#161b22 40px,#58a6ff 40px,#58a6ff 80px,#161b22 80px,#161b22 120px)`,
  },
  clean: {
    name:"🤍 Clean Light", font:"Inter",
    bg:"#ffffff", bgMid:"#f8fafc", bgLite:"#f1f5f9",
    accent:"#1d6ed8", accentAlt:"#1558b0", border:"#cbd5e1",
    green:"#16a34a", blue:"#1d6ed8",
    danger:"#dc2626", text:"#0f172a", muted:"#64748b", free:"#16a34a",
    headerGrad:"linear-gradient(135deg,#ffffff 0%,#eff6ff 100%)",
    stripe:`repeating-linear-gradient(90deg,#dbeafe 0,#dbeafe 40px,#1d6ed8 40px,#1d6ed8 80px,#dbeafe 80px,#dbeafe 120px)`,
  },
  forest: {
    name:"🌲 Forest", font:"Outfit",
    bg:"#0d1f0d", bgMid:"#152215", bgLite:"#1e2e1e",
    accent:"#4ade80", accentAlt:"#22c55e", border:"#2d4a2d",
    green:"#4ade80", blue:"#38bdf8",
    danger:"#f87171", text:"#f0fdf4", muted:"#86efac", free:"#4ade80",
    headerGrad:"linear-gradient(135deg,#152215 0%,#0d1f0d 100%)",
    stripe:`repeating-linear-gradient(90deg,#152215 0,#152215 40px,#4ade80 40px,#4ade80 80px,#152215 80px,#152215 120px)`,
  },
  desert: {
    name:"🏜 Desert", font:"Outfit",
    bg:"#1c1409", bgMid:"#26190a", bgLite:"#332210",
    accent:"#fb923c", accentAlt:"#f97316", border:"#4a3520",
    green:"#84cc16", blue:"#38bdf8",
    danger:"#ef4444", text:"#fef3c7", muted:"#d97706", free:"#84cc16",
    headerGrad:"linear-gradient(135deg,#26190a 0%,#1c1409 100%)",
    stripe:`repeating-linear-gradient(90deg,#26190a 0,#26190a 40px,#fb923c 40px,#fb923c 80px,#26190a 80px,#26190a 120px)`,
  },};

const FONTS = {
  Barlow:   {name:"Barlow - Classic RV", body:"'Barlow',sans-serif",   head:"'Bebas Neue',sans-serif", cond:"'Barlow Condensed',sans-serif"},
  Inter:    {name:"Inter - Modern Clean", body:"'Inter',sans-serif",     head:"'Inter',sans-serif",       cond:"'Inter',sans-serif"},
  "DM Sans":{name:"DM Sans - Friendly",  body:"'DM Sans',sans-serif",   head:"'DM Sans',sans-serif",     cond:"'DM Sans',sans-serif"},
  Outfit:   {name:"Outfit - Bold Modern", body:"'Outfit',sans-serif",    head:"'Outfit',sans-serif",      cond:"'Outfit',sans-serif"},
};

// ThemeContext
const ThemeContext = React.createContext(null);
const useTheme = () => React.useContext(ThemeContext);

const fmt$ = n => n==null?"-":"$"+Number(n).toLocaleString("en-US",{minimumFractionDigits:0,maximumFractionDigits:0});
const fmtDec = (n,d=1) => n==null?"-":Number(n).toFixed(d);
const addDays = (s,d) => { if(!s)return""; const dt=new Date(s+"T00:00:00"); dt.setDate(dt.getDate()+d); return dt.toISOString().slice(0,10); };
const daysBetween = (a,b) => { if(!a||!b)return 0; return Math.round((new Date(b+"T00:00:00")-new Date(a+"T00:00:00"))/86400000); };
const fmtDate = s => { if(!s)return"-"; return new Date(s+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}); };
const uid = () => Math.random().toString(36).slice(2,9);
const DOW = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

function nextTravelDay(fromDate, travelDays) {
  if(!fromDate) return fromDate;
  const d = new Date(fromDate+"T00:00:00");
  for(let i=0;i<7;i++){
    const dow=d.getDay();
    const ok=travelDays==="any"?true:travelDays==="weekends"?(dow===0||dow===6):travelDays==="weekdays"?(dow>=1&&dow<=5):travelDays==="friday"?(dow===5||dow===0||dow===6):true;
    if(ok) return d.toISOString().slice(0,10);
    d.setDate(d.getDate()+1);
  }
  return fromDate;
}
function driveDaysNeeded(miles,maxDailyMiles){if(!miles||miles<=0)return 0;return Math.ceil(miles/Math.max(maxDailyMiles,1));}

const mkStop=(o={})=>({id:uid(),name:"",type:"family",active:true,fixedDates:false,arriveDate:"",departDate:"",minNights:3,maxNights:7,nightlyRate:45,isFree:false,isMonthlyRate:false,monthlyRate:600,numMonths:1,distFromPrev:0,fuelPriceOverride:"",preferDepartTime:"07:00",state:"",homeCity:"",address:"",lat:null,lon:null,notes:"",sideTrips:[],localFavorites:[],...o});

// ── Shared geocoding utility ──────────────────────────────────────
// Used everywhere in the app. ORS first (fast, no rate limit),
// Nominatim fallback. Returns [lat, lon] or null.
// ── Geocoding queue + cache ───────────────────────────────────────
// Serializes all geocoding requests to stay within Nominatim's 1 req/sec limit.
// Caches results so repeated queries for the same place don't hit the network.
const _geoCache=new Map();
// Module-level route geometry cache — updated whenever OSRM route is drawn
// Used by AI context builder to give accurate along-route suggestions
let _currentRouteCoords=null; // array of [lon,lat] from OSRM
let _currentRouteStops=[]; // stop names in order for context
// Cache filter results so returning to map tab doesn't re-fetch
const _filterCache=new Map(); // key: "filterKey:lat:lon" → elements[]
const _filterCacheTime=new Map(); // key → timestamp
const FILTER_CACHE_MS=30*60*1000; // 30 minutes
let _geoLastCall=0;
const _GEO_MIN_GAP=1100; // ms between Nominatim calls (slightly over 1 sec)
async function geocodePlace(query){
  if(!query||!query.trim()) return null;
  const q=query.trim();
  if(_geoCache.has(q)) return _geoCache.get(q);
  // Try ORS first (faster, no rate limit issue from browser when key works)
  if(ORS_KEY){
    try{
      const r=await fetch(
        `https://api.openrouteservice.org/geocode/search?text=${encodeURIComponent(q)}&size=1&boundary.country=US`,
        {headers:{"Accept":"application/json","Authorization":ORS_KEY}}
      );
      if(r.ok){
        const d=await r.json();
        const f=d?.features?.[0];
        if(f){
          const result=[parseFloat(f.geometry.coordinates[1]),parseFloat(f.geometry.coordinates[0])];
          _geoCache.set(q,result);
          return result;
        }
      }
    }catch(e){/* ORS blocked - fall through to Nominatim */}
  }
  // Rate-limited Nominatim fallback — enforce 1 req/sec gap
  const now=Date.now();
  const wait=Math.max(0,_GEO_MIN_GAP-(now-_geoLastCall));
  if(wait>0) await new Promise(r=>setTimeout(r,wait));
  _geoLastCall=Date.now();
  try{
    const r=await fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q)}&format=json&limit=1&countrycodes=us`,
      {headers:{"Accept-Language":"en","User-Agent":"RVTravelMate/1.0"}}
    );
    if(r.ok){
      const d=await r.json();
      if(d?.length){
        const result=[parseFloat(d[0].lat),parseFloat(d[0].lon)];
        _geoCache.set(q,result);
        return result;
      }
    }
  }catch(e){/* network error */}
  // Do NOT cache null — network errors are transient, allow retry
  return null;
}

// Build a geocodable query string from a stop object
function stopQuery(s){
  const st=(s.state||"").trim();
  const stIn=(str)=>{
    if(!st||!str)return false;
    const u=str.toUpperCase(),su=st.toUpperCase();
    return u.includes(","+su)||u.includes(", "+su)||u.endsWith(" "+su)||u.includes("("+su+")");
  };
  const ws=(str)=>str+(st&&!stIn(str)?", "+st:"")+", USA";
  if(s.type==="home"){
    const addr=(s.address||"").trim();
    const city=(s.homeCity||"").trim();
    const nm=(s.name||"").trim();
    // "Home / Departure" is generic — but the name might ALSO contain a real city
    // e.g. name="Foley" or homeCity="Foley" — check both
    const generic=!nm||nm.toLowerCase().includes("home")||nm.toLowerCase().includes("departure");
    const parsed=generic?"":nm.split(",")[0].trim();
    // Try to extract city even from generic names by looking for non-generic words
    const nmParts=nm.split(/[\/,]+/).map(p=>p.trim()).filter(p=>p&&!/^(home|departure|start|origin)$/i.test(p));
    const extractedCity=nmParts.length>0?nmParts[0]:"";
    if(addr)return ws(addr);
    if(city)return ws(city);
    if(parsed)return ws(parsed);
    if(extractedCity)return ws(extractedCity);
    return st?st+", USA":"";
  }
  const addr=(s.address||"").trim();
  if(addr)return ws(addr);
  const nm=(s.name||"").trim();
  if(!nm||nm==="Boondock / Overnight Stop"||nm==="Transit Stop")return st?st+", USA":"";
  return ws(nm);
}

// Geocode a stop with fallback chain (campground name → city part → state)
async function geocodeStop(s){
  const q=stopQuery(s);
  if(q){const r=await geocodePlace(q);if(r)return r;}
  // Fallback A: strip to city portion of campground name
  const nm=(s.name||"").trim();
  const st=(s.state||"").trim();
  if(nm&&st&&nm!=="Boondock / Overnight Stop"&&nm!=="Transit Stop"){
    const base=nm.includes(",")?nm.split(",")[0].trim():nm;
    if(base!==nm){const r=await geocodePlace(base+", "+st+", USA");if(r)return r;}
    // Fallback B: just city+state as last-word approach
    const r=await geocodePlace(base+" "+st+", USA");if(r)return r;
  }
  // Fallback C: state center
  if(s.state){const r=await geocodePlace(s.state+", USA");if(r)return r;}
  return null;
}

const DEF={
  vehicle:{rvType:"Class A Motorhome",fuelType:"Diesel",mpg:8,tankGallons:100,rvLength:36,rvHeightFt:13,rvHeightIn:0,towVehicle:false,towLength:15,towTruckMake:"",towTruckModel:"",towTruckYear:"",towTruckOdometer:"",gvwr:0,gcwr:0,dryWeight:0,payload:0,towCapacity:0,tongueWeight:0,loadedWeightRV:0,loadedWeightTow:0,lastWeighDate:"",weightStationName:""},
  prefs:{maxDriveHours:7,avgSpeedMph:60,travelDays:"weekends",preferDepartTime:"07:00",avoidHolidays:true,boondockComfort:"ok",hookupPref:"full",multiDriver:false},
  finance:{monthlyTakeHome:"",budgetLodgingPct:35,budgetFuelPct:12,budgetGroceryPct:20,budgetUtilityPct:4,budgetEntertainPct:8,budgetMaintPct:7,budgetPersonalPct:6,budgetSavingsPct:8},
  fuel:{avgPricePerGallon:3.30,fuelStrategy:"fill-when-cheap"},
  memberships:{goodSam:false,passportAmerica:false,harvestHosts:false,koaValueKard:false,thousandTrails:false},
  settings:{themeKey:"clean",fontKey:"Inter",compactMode:typeof window!=="undefined"&&window.innerWidth<768?true:false,continuousTracking:false,tipsEnabled:true,huntingEnabled:false,fontScale:"normal",fuelApps:{gasbuddy:true,truckerpath:true,waze:false,upside:false,mudflap:false,routefuel:false,colonialcoin:false}},
  stops:[
    mkStop({name:"Home / Departure",type:"home",minNights:0,maxNights:0,nightlyRate:0,distFromPrev:0}),
    mkStop({name:"",type:"family",minNights:7,maxNights:21}),
    mkStop({name:"",type:"family",minNights:7,maxNights:21}),
  ],
  actuals:{fuel:0,food:0,activities:0,maintenance:0,other:0},
  finances:{
    mode:"expenses", // "expenses" | "full"
    months:{}, // keyed by "YYYY-MM"
  },
  emergency:{
    roadside:[],
    insurance:[],
    contacts:[],
    documents:[],
    vin:"",
    plate:"",
    plateState:"",
  },
  rvMaintenance:{
    currentOdometer:0,
    generatorHours:0,
    tireDotCode:"",
    tireInstallDate:"",
    logs:[],
    fillups:[],
  },
  toys:[],
  propane:{tanks:[],dailyUsageGals:0.5,notes:""},
  pets:[],
  gymMemberships:{memberships:[],notes:""},
  causes:[],
  motoEvents:[],
  cellNotes:{},
  dumpNotes:{},
  tripSplitTravelers:[],
  campgroundJournal:[],
  homeWatch:{tasks:[],contacts:[],mailHold:{startDate:"",endDate:"",confirmationNum:""},notes:""},
  medications:[],
  tirePressure:{frontPsi:"",rearPsi:"",sparePsi:"",frontInnerPsi:"",rearInnerPsi:"",lastCheckDate:"",lastCheckOdometer:"",notes:"",targetFront:"",targetRear:""},
  fuelCards:[],
  mapFilters:{campgrounds:false,fuel:false,golf:false,trails:false,rvparks:false,weather:false,
    fullHookups:false,electric:false,water:false,amp50:false,dumpStation:false,
    propane:false,showers:false,laundry:false,pool:false,petFriendly:false,
    wifi:false,cableTV:false,firewood:false,rvStorage:false},
  quickLinks:[
    {id:"ql1",name:"Campendium",url:"https://www.campendium.com",icon:"🏕",category:"Camping"},
    {id:"ql2",name:"Recreation.gov",url:"https://www.recreation.gov",icon:"🌲",category:"Camping"},
    {id:"ql3",name:"Hipcamp",url:"https://www.hipcamp.com",icon:"⛺",category:"Camping"},
    {id:"ql4",name:"Harvest Hosts",url:"https://harvesthosts.com",icon:"🍷",category:"Camping"},
    {id:"ql5",name:"Campnow",url:"https://www.campnow.com",icon:"🔥",category:"Camping"},
    {id:"ql6",name:"AllStays",url:"https://www.allstays.com",icon:"🅿",category:"Camping"},
    {id:"ql7",name:"GasBuddy",url:"https://www.gasbuddy.com",icon:"⛽",category:"Fuel"},
    {id:"ql8",name:"Trucker Path",url:"https://truckerpath.com",icon:"🚛",category:"Fuel"},
    {id:"ql9",name:"Waze",url:"https://www.waze.com",icon:"🗺",category:"Navigation"},
    {id:"ql10",name:"Roadtrippers",url:"https://roadtrippers.com",icon:"🛣",category:"Navigation"},
    {id:"ql11",name:"AllTrails",url:"https://www.alltrails.com",icon:"🥾",category:"Activities"},
    {id:"ql12",name:"GolfNow",url:"https://www.golfnow.com",icon:"⛳",category:"Activities"},
  ],
};

function injectStyles(T,F){
  let el=document.getElementById("rv-styles");
  if(!el){el=document.createElement("style");el.id="rv-styles";document.head.appendChild(el);}
  el.textContent=FONT_LINK+`
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    body{background:${T.bg};color:${T.text};font-family:${F.body};overflow-x:hidden}
    ::-webkit-scrollbar{width:8px;height:8px}::-webkit-scrollbar-track{background:${T.bgMid}}
    ::-webkit-scrollbar-thumb{background:${T.accent}88;border-radius:4px}::-webkit-scrollbar-thumb:hover{background:${T.accent}}
    input,select,textarea{font-family:${F.body}}
    input[type=range]{-webkit-appearance:none;height:6px;border-radius:3px;background:${T.border};outline:none;width:100%}
    input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:20px;height:20px;border-radius:50%;background:${T.accent};cursor:pointer}
    input[type=date]{color-scheme:${T.bg==="#ffffff"||T.bg==="#fafaf8"?"light":"dark"}}
    input[type=date]::-webkit-calendar-picker-indicator{filter:${T.bg==="#ffffff"||T.bg==="#fafaf8"?"none":"invert(1) opacity(0.7)"};cursor:pointer}
    @keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
    @keyframes saveFlash{0%{opacity:0;transform:scale(.9)}30%{opacity:1;transform:scale(1.02)}80%{opacity:1}100%{opacity:0}}
    @keyframes modalIn{from{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}
    @keyframes pulse{0%{box-shadow:0 0 0 0 ${T.blue}88}70%{box-shadow:0 0 0 10px ${T.blue}00}100%{box-shadow:0 0 0 0 ${T.blue}00}}
    @keyframes rvDrive{0%{left:-80px;transform:scaleX(-1)}95%{left:calc(100% + 80px);transform:scaleX(-1)}95.01%{left:-80px;transform:scaleX(-1)}100%{left:-80px;transform:scaleX(-1)}}
    @keyframes cloudDrift{0%{transform:translateX(0)}100%{transform:translateX(120px)}}
    @keyframes cloudDrift2{0%{transform:translateX(0)}100%{transform:translateX(-90px)}}
    @keyframes sunPulse{0%,100%{opacity:.85;transform:scale(1)}50%{opacity:1;transform:scale(1.08)}}
    .anim{animation:fadeIn .3s ease both}
    .save-toast{animation:saveFlash 2.2s ease forwards}
    .modal-anim{animation:modalIn .2s ease both}
    .rv-anim{position:absolute;animation:rvDrive 18s linear infinite;font-size:32px;bottom:10px;will-change:left,transform;line-height:1}
    .cloud1{position:absolute;animation:cloudDrift 22s ease-in-out infinite alternate;font-size:22px;top:10px;left:15%;opacity:.7}
    .cloud2{position:absolute;animation:cloudDrift2 28s ease-in-out infinite alternate;font-size:16px;top:6px;left:55%;opacity:.5}
    .sun-anim{position:absolute;animation:sunPulse 4s ease-in-out infinite;font-size:28px;top:8px;right:20px;opacity:.85}
    @media(prefers-reduced-motion:reduce){.rv-anim,.cloud1,.cloud2,.sun-anim{animation:none!important}}
    .tab-group-btn{background:none;border:none;cursor:pointer;font-family:${F.cond};font-weight:700;font-size:11px;letter-spacing:.3px;text-transform:uppercase;padding:12px 12px;border-bottom:3px solid transparent;transition:color .15s,border-color .15s,background .15s;white-space:nowrap;display:flex;align-items:center;gap:4px;border-radius:0}
    .tab-group-btn:hover{color:${T.text}!important;background:${T.accent}0d}
    @media(min-width:768px){#main-content{margin-left:220px}body.sidebar-collapsed #main-content{margin-left:52px}}
    @media(max-width:767px){#main-content{margin-left:0!important}}
    .tab-group-btn.active{color:${T.accent}!important;border-bottom-color:${T.accent}!important;background:${T.accent}0d}
    @keyframes tabScrollHint{0%,100%{transform:translateX(0);opacity:1}50%{transform:translateX(4px);opacity:.6}}@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
    /* tab-dropdown now uses inline styles */
    ::-webkit-scrollbar{width:8px;height:8px}
    ::-webkit-scrollbar-track{background:${T.bgLite};border-radius:4px}
    ::-webkit-scrollbar-thumb{background:${T.accent};border-radius:4px;border:2px solid ${T.bgLite}}
    ::-webkit-scrollbar-thumb:hover{background:${T.accentAlt}}
  `;
}

// ── UI Atoms (theme-aware) ─────────────────────────────────────────
const Label=({children})=>{const T=useTheme();return<div style={{marginBottom:4,fontFamily:T.F.cond,fontWeight:600,fontSize:11,letterSpacing:1,textTransform:"uppercase",color:T.muted}}>{children}</div>;};
const Inp=({style,onFocus:onFocusProp,...p})=>{const T=useTheme();return<input {...p} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,width:"100%",outline:"none",transition:'border-color .15s',...style}} onFocus={e=>{e.target.style.borderColor=T.accent;e.target.style.boxShadow=`0 0 0 3px ${T.accent}22`;if(e.target.type==="number")e.target.select();if(onFocusProp)onFocusProp(e);}} onBlur={e=>{e.target.style.borderColor=T.border;e.target.style.boxShadow='none';}}/>;};
const Sel=({children,style,...p})=>{const T=useTheme();return<select {...p} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,width:"100%",outline:"none",cursor:"pointer",transition:'border-color .15s',...style}} onFocus={e=>e.target.style.borderColor=T.accent} onBlur={e=>e.target.style.borderColor=T.border}>{children}</select>;};
const Btn=({variant="primary",children,style,...p})=>{const T=useTheme();const bg=variant==="primary"?T.accent:variant==="danger"?T.danger:variant==="success"?T.free:variant==="ghost"?"transparent":T.bgLite;const col=variant==="ghost"?T.text:"#fff";return<button {...p} style={{background:bg,color:col,border:variant==="ghost"?`1px solid ${T.border}`:"none",borderRadius:8,padding:"9px 18px",fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:.5,textTransform:"uppercase",cursor:"pointer",display:"flex",alignItems:"center",gap:6,transition:'all .15s',...style}} onMouseEnter={e=>{e.currentTarget.style.opacity=".85";e.currentTarget.style.transform="translateY(-1px)";}} onMouseLeave={e=>{e.currentTarget.style.opacity="1";e.currentTarget.style.transform="translateY(0)";}}>{children}</button>;};
const Card=({children,style,accent})=>{const T=useTheme();return<div style={{background:T.bgMid,border:`1px solid ${accent||T.border}`,borderRadius:14,padding:20,borderLeft:accent?`4px solid ${accent}`:undefined,boxShadow:`0 1px 4px ${T.bg==='#ffffff'?'rgba(0,0,0,0.06)':'rgba(0,0,0,0.2)'}`,transition:'box-shadow .2s',...style}}>{children}</div>;};
const SecHead=({icon,title,sub})=>{const T=useTheme();return<div style={{marginBottom:24}}><div style={{display:"flex",alignItems:"center",gap:12,marginBottom:6}}><div style={{width:40,height:40,borderRadius:10,background:T.accent+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{icon}</div><div><h2 style={{fontFamily:T.F.head,fontSize:26,letterSpacing:1.5,color:T.accent,lineHeight:1.1}}>{title}</h2>{sub&&<p style={{fontSize:13,color:T.muted,marginTop:2,lineHeight:1.5}}>{sub}</p>}</div></div><div style={{height:2,background:`linear-gradient(90deg,${T.accent}88,transparent)`,marginTop:8}}/></div>;};
const Tog=({value,onChange,label})=>{const T=useTheme();return<button onClick={()=>onChange(!value)} style={{display:"flex",alignItems:"center",gap:8,background:"none",border:"none",cursor:"pointer",color:T.text,padding:0}}><div style={{width:44,height:24,borderRadius:12,background:value?T.accent:T.border,position:"relative",transition:"background .2s",flexShrink:0}}><div style={{position:"absolute",top:2,left:value?22:2,width:20,height:20,borderRadius:"50%",background:value?(T.bg.startsWith("#f")||T.bg.startsWith("#e")?"#fff":T.bg):T.muted,transition:"left .2s"}}/></div>{label&&<span style={{fontSize:13,fontWeight:500}}>{label}</span>}</button>;};
const StatBox=({label,value,sub,accent})=>{const T=useTheme();const ac=accent||T.accent;return<div style={{background:T.bgMid,borderRadius:12,padding:"16px 20px",borderTop:`3px solid ${ac}`,boxShadow:`0 1px 4px ${T.bg==='#ffffff'?'rgba(0,0,0,0.06)':'rgba(0,0,0,0.2)'}`}}><div style={{fontFamily:T.F.cond,fontSize:10,textTransform:"uppercase",letterSpacing:1.5,color:T.muted,marginBottom:6}}>{label}</div><div style={{fontFamily:T.F.head,fontSize:32,color:ac,lineHeight:1,fontWeight:900}}>{value}</div>{sub&&<div style={{fontSize:11,color:T.muted,marginTop:5,lineHeight:1.4}}>{sub}</div>}</div>;};
const Badge=({children,color})=>{const T=useTheme();const c=color||T.border;return<span style={{display:"inline-block",padding:"2px 7px",borderRadius:4,background:c+"22",color:c,border:`1px solid ${c}44`,fontSize:11,fontWeight:600,fontFamily:T.F.cond,textTransform:"uppercase",letterSpacing:.5,whiteSpace:"nowrap"}}>{children}</span>;};
const WarnBadge=({children})=>{const T=useTheme();return<span style={{display:"inline-flex",alignItems:"center",gap:4,padding:"3px 8px",borderRadius:4,background:T.danger+"22",color:T.danger,border:`1px solid ${T.danger}44`,fontSize:11,fontWeight:700,fontFamily:T.F.cond,flexWrap:"wrap",wordBreak:"break-word",maxWidth:"100%"}}>⚠ {children}</span>;};

// ── Tooltip component ──────────────────────────────────────────────
function Tooltip({text,children,position="top"}){
  const T=useTheme();
  const [show,setShow]=useState(false);
  const posStyle=position==="top"?{bottom:"calc(100% + 6px)",left:"50%",transform:"translateX(-50%)"}:
    position==="bottom"?{top:"calc(100% + 6px)",left:"50%",transform:"translateX(-50%)"}:
    position==="right"?{left:"calc(100% + 6px)",top:"50%",transform:"translateY(-50%)"}:
    {right:"calc(100% + 6px)",top:"50%",transform:"translateY(-50%)"};
  return<div style={{position:"relative",display:"inline-flex"}} onMouseEnter={()=>setShow(true)} onMouseLeave={()=>setShow(false)}>
    {children}
    {show&&<div style={{position:"absolute",...posStyle,background:T.bg==="##ffffff"?T.bgMid:"#1a1a2e",color:T.text,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",fontSize:12,lineHeight:1.5,maxWidth:220,whiteSpace:"normal",zIndex:9999,boxShadow:"0 4px 16px rgba(0,0,0,0.25)",pointerEvents:"none",fontFamily:"sans-serif",fontWeight:400}}>
      {text}
      <div style={{position:"absolute",...(position==="top"?{top:"100%",left:"50%",transform:"translateX(-50%)",borderLeft:"6px solid transparent",borderRight:"6px solid transparent",borderTop:`6px solid ${T.border}`}:position==="bottom"?{bottom:"100%",left:"50%",transform:"translateX(-50%)",borderLeft:"6px solid transparent",borderRight:"6px solid transparent",borderBottom:`6px solid ${T.border}`}:{})}} />
    </div>}
  </div>;
}


// ── QuickTip component ─────────────────────────────────────────────
const QUICK_TIPS={
  vehicle:{
    tip:"Set your vehicle type first - MPG and tank size drive all fuel cost estimates. Non-RV types (Motorcycle, Car, Bicycle) show a warning - trip summary always uses your primary RV specs.",
    link:"tabs"
  },
  prefs:{
    tip:"Max drive hours and preferred travel days control how your itinerary dates auto-chain. Set these before adding stops.",
    link:"tabs"
  },
  finance:{
    tip:"Monthly income is never saved and resets each visit. Budget % splits determine how costs are categorized in your summary.",
    link:"tabs"
  },
  fuel:{
    tip:"Fuel price auto-fills from EIA regional data based on your home state. You can override it per-stop too.",
    link:"tabs"
  },
  memberships:{
    tip:"Active memberships show as quick-search links on every stop card and map pin. Toggle them here - no charges are made.",
    link:"memberships"
  },
  stops:{
    tip:"Every stop needs a Name and Miles from Prev Stop. Use ▲▼ to reorder - map recalculates automatically. Expand any stop and click '🏍 + Add Side Trip' to plan a day excursion.",
    link:"stops"
  },
  lookahead:{
    tip:"Searches a 60-mile radius around each stop for campgrounds, RV parks, fuel, trails and more. Uses live OpenStreetMap data.",
    link:"lookahead"
  },
  boondocking:{
    tip:"Free camping saves $300-$1,500+ on a long trip. Walmart, BLM, casinos, and rest areas are all options.",
    link:"tabs"
  },
  map:{
    tip:"Map auto-recalculates when you add, delete, reorder, or edit+save any stop. Use Map Filters to show campgrounds, fuel, trails and more along your route.",
    link:"map"
  },
  weather:{
    tip:"14-day forecasts per stop. Your planned stay dates are highlighted - yellow=arrive, blue=staying, red=depart. Click Load Forecast on any stop.",
    link:"weather"
  },
  results:{
    tip:"All numbers update live. Enter Actual Paid amounts on each stop card to track real vs estimated spending.",
    link:"actuals"
  },
  print:{
    tip:"Print your full itinerary as a PDF. Optionally include a map image and turn-by-turn directions. Choose Full Route or a specific leg. Map filters are hidden from the printed map automatically.",
    link:"print"
  },
  quicklinks:{
    tip:"One-tap links to your favorite RV apps. Add custom links with any URL, icon emoji and category.",
    link:"tabs"
  },
  history:{
    tip:"Archive completed trips to compare estimated vs actual spending. Your planner resets after archiving so you can start fresh.",
    link:"history"
  },
  returnhome:{
    tip:"Two options: 🔄 Inverse Trip reverses your stop order for the return journey, or 🏠 Route Home plans the fastest drive back split into daily legs.",
    link:"returnhome"
  },
  exportimport:{
    tip:"Export saves your full trip as a .json file. Import restores it. Cloud sync keeps web and phone in sync when logged in.",
    link:"saving"
  },
  settings:{
    tip:"5 themes, 4 fonts, compact mode. Theme and font choices are saved with your trip data.",
    link:"themes"
  },
};

function QuickTipBar({tabId,onOpenHowTo}){
  const T=useTheme();
  const [show,setShow]=useState(false);
  const qt=QUICK_TIPS[tabId];
  if(!qt) return null;
  return<div style={{marginBottom:16,display:"flex",alignItems:"flex-start",gap:10,background:T.accent+"12",border:`1px solid ${T.accent}33`,borderRadius:10,padding:"10px 14px"}}>
    <span style={{fontSize:16,flexShrink:0,marginTop:1}}>💡</span>
    <div style={{flex:1,fontSize:12,color:T.muted,lineHeight:1.6}}>{qt.tip}</div>
    <button onClick={()=>onOpenHowTo&&onOpenHowTo(qt.link)} style={{background:"none",border:`1px solid ${T.accent}55`,borderRadius:6,padding:"3px 10px",color:T.accent,fontSize:11,fontWeight:700,cursor:"pointer",flexShrink:0,fontFamily:"sans-serif"}}>
      ? How To
    </button>
  </div>;
}


// ── Tips Modal ─────────────────────────────────────────────────────
const ALL_TIPS = [
  {cat:"🗺 Map", tip:"After adding or editing stops, the map auto-recalculates your route. No need to refresh - it updates within a second."},
  {cat:"📍 Stops", tip:"Use the ▲▼ buttons to reorder stops. The map and dates recalculate automatically after moving a stop."},
  {cat:"📍 Stops", tip:"Click ✏️ Edit on a stop card to enter draft mode. Changes don't save until you click ✓ Save - so you can edit freely."},
  {cat:"💰 Saving Money", tip:"Even 4-5 Walmart overnight stops on a long trip saves $180-225. Toggle 'Free camping?' on transit stops."},
  {cat:"💰 Saving Money", tip:"Good Sam membership ($44/yr) saves 10-15% at thousands of parks. Harvest Hosts ($99/yr) gives free stays at farms and wineries."},
  {cat:"🗺 Map", tip:"Map layers (campgrounds, fuel, trails) load live data from OpenStreetMap. Toggle them on the Map tab - each searches a 30-mile radius around your stops."},
  {cat:"🖨 Print", tip:"The Print tab can include a map image and turn-by-turn directions in your PDF. Choose Full Route or a specific leg before printing."},
  {cat:"📊 Summary", tip:"Enter Actual Paid amounts on each stop card to track real vs estimated spending. The header updates to show ✓ Actual Total in green."},
  {cat:"🌤 Weather", tip:"The Weather tab shows 14-day forecasts per stop. Your planned arrival day is highlighted in yellow so you can see what to expect."},
  {cat:"📍 Stops", tip:"Import stops from a CSV file - download the template from the Import modal for the correct column format including state and free camping flag."},
  {cat:"📍 Stops", tip:"The text parser (✨ Parse Stops) understands natural language: 'Austin TX 4 nights $45/night family visit' - one stop per line."},
  {cat:"🗺 Map", tip:"Click '📍 Add Stop via Map' on the Map tab to place a new stop by clicking anywhere on the map. It reverse-geocodes the location automatically."},
  {cat:"🔍 Look Ahead", tip:"Look Ahead searches a 60-mile radius around each stop for campgrounds, fuel, trails, federal parks, and Walmarts using live OpenStreetMap data."},
  {cat:"🏠 Return Home", tip:"Use '🔄 Inverse Trip' in the Return Home tab to reverse your entire stop order for the return journey. Miles and dates clear for recalculation."},
  {cat:"🚐 Vehicle", tip:"Switching to Motorcycle, Car, or Bicycle shows a side vehicle warning. Your main trip summary always uses your primary RV specs."},
  {cat:"🗺 Map", tip:"Tap 📍 Enable GPS on the Map tab to show your location and start auto-tracking. Then tap 🛣 Start Travel Mode for live nearby stops, AI Co-Pilot, and ETA updates."},
  {cat:"💾 Saving", tip:"Cloud sync has a 12-second debounce - it waits for you to stop making changes before saving. This prevents rapid device switching from overwriting data."},
  {cat:"📍 Stops", tip:"Set a Departure Date on your Home stop and all arrival/departure dates chain forward automatically based on your drive time + min nights settings."},
  {cat:"🗺 Map", tip:"The map uses RV-safe routing (avoiding low bridges and weight limits) when calculating routes and directions."},
  {cat:"🏕 Side Trips", tip:"Add a side trip to any stop for a motorcycle day ride or car excursion. Choose to add its costs to the overall trip or keep it as a standalone plan."},
];

function TipsModal({onClose}){
  const T=useTheme();
  const [tipIdx,setTipIdx]=useState(()=>{
    try{const i=parseInt(localStorage.getItem("rv-tip-idx")||"0");return i%ALL_TIPS.length;}catch{return 0;}
  });
  const tip=ALL_TIPS[tipIdx%ALL_TIPS.length];
  const next=()=>{const ni=(tipIdx+1)%ALL_TIPS.length;setTipIdx(ni);try{localStorage.setItem("rv-tip-idx",String(ni));}catch{}};
  const prev=()=>{const ni=(tipIdx-1+ALL_TIPS.length)%ALL_TIPS.length;setTipIdx(ni);try{localStorage.setItem("rv-tip-idx",String(ni));}catch{}};
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:10000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:440,padding:28,boxShadow:"0 8px 40px rgba(0,0,0,0.4)",border:`1px solid ${T.border}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div style={{fontFamily:T.F.head,fontSize:22,color:T.accent,letterSpacing:1}}>💡 Quick Tip</div>
          <div style={{fontSize:11,color:T.muted,fontFamily:T.F.cond}}>{tipIdx+1} / {ALL_TIPS.length}</div>
        </div>
        <div style={{background:T.accent+"15",border:`1px solid ${T.accent}33`,borderRadius:12,padding:"8px 14px",marginBottom:16,display:"inline-block"}}>
          <span style={{fontSize:12,fontWeight:700,color:T.accent}}>{tip.cat}</span>
        </div>
        <div style={{fontSize:15,color:T.text,lineHeight:1.7,marginBottom:24,minHeight:80}}>{tip.tip}</div>
        <div style={{display:"flex",gap:8,justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",gap:6}}>
            <button onClick={prev} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 16px",color:T.muted,fontSize:13,cursor:"pointer",minHeight:44}}>← Prev</button>
            <button onClick={next} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 16px",color:T.muted,fontSize:13,cursor:"pointer",minHeight:44}}>Next →</button>
          </div>
          <button onClick={onClose} style={{background:T.accent,border:"none",borderRadius:10,padding:"12px 28px",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:T.F.cond,letterSpacing:.5,minWidth:120,minHeight:44}}>Got it! ✓</button>
        </div>
      </div>
    </div>
  );
}

// ── Per-Tab First-Visit Tips ───────────────────────────────────────
const PAGE_TIPS={
  vehicle:{
    icon:"🚗",
    title:"Your RV Details",
    lines:[
      "Tell us about your RV here — the type, fuel, and how many miles per gallon it gets.",
      "Don't worry about being exact. A rough MPG estimate is fine and you can always change it later.",
      "This information is used to calculate your fuel costs for the whole trip.",
    ],
  },
  prefs:{
    icon:"🗺",
    title:"Travel Preferences",
    lines:[
      "This is where you tell the app how you like to travel — for example, how many hours you prefer to drive in a day.",
      "You can choose which days of the week you prefer to travel, like weekends only or any day.",
      "The app uses these preferences to automatically suggest arrival and departure dates for each stop.",
    ],
  },
  finance:{
    icon:"💵",
    title:"Your Budget",
    lines:[
      "Optionally enter your monthly take-home income and the app will show how your trip fits your budget.",
      "The budget sliders let you decide how much of your income goes toward things like lodging, food, and fuel.",
      "Your income is never saved or stored — it resets every time you open the app.",
    ],
  },
  fuel:{
    icon:"⛽",
    title:"Fuel Prices",
    lines:[
      "The app automatically looks up average fuel prices in each region of the country.",
      "You can override the price for any individual stop if you know prices are higher or lower there.",
      "There's also a fuel strategy setting — for example, filling up whenever you find a cheap price.",
    ],
  },
  memberships:{
    icon:"🎫",
    title:"RV Memberships & Discount Clubs",
    lines:[
      "If you belong to clubs like Good Sam, Passport America, or Harvest Hosts, turn them on here.",
      "Active memberships show up as handy search links on each stop card so you can quickly find member campgrounds.",
      "Not sure? You can always come back and add memberships later.",
    ],
  },
  stops:{
    icon:"📍",
    title:"Your Trip Stops",
    lines:[
      "This is the heart of the app — add every place you plan to stay, starting with your home.",
      "For each stop, enter the name of the city or campground, how many nights you plan to stay, and the miles from your previous stop.",
      "Use the ▲ ▼ arrows to reorder stops. Dates and costs recalculate automatically whenever you make a change.",
    ],
  },
  map:{
    icon:"🗺",
    title:"Your Route Map",
    lines:[
      "This map shows your entire route drawn out with a line connecting all your stops.",
      "Use the filter buttons at the top to show nearby campgrounds, fuel stations, hiking trails, and more along your route.",
      "You can also tap anywhere on the map to add a new stop at that location.",
    ],
  },
  lookahead:{
    icon:"🔍",
    title:"What's Near Each Stop",
    lines:[
      "This page searches for useful places within 60 miles of each of your stops.",
      "You'll find campgrounds, RV parks, fuel stations, Walmart stores, and national parks nearby.",
      "Tap 'Search Near This Stop' on any stop to load the results. It uses live map data so results are always current.",
    ],
  },
  boondocking:{
    icon:"🌲",
    title:"Free Camping",
    lines:[
      "Free camping (also called boondocking) means staying overnight without paying campground fees.",
      "Common free spots include Walmart parking lots, BLM (Bureau of Land Management) land, rest areas, and casinos.",
      "This page has links and tips to help you find free spots near your route. It can save hundreds of dollars on a long trip.",
    ],
  },
  weather:{
    icon:"🌤",
    title:"Weather Along Your Route",
    lines:[
      "This page shows a 14-day weather forecast for each of your stops.",
      "Tap 'Load Forecast' on any stop to see the forecast. Your planned arrival and departure days are highlighted so you can see what weather to expect.",
      "Weather is loaded fresh from the internet each time, so it's always up to date.",
    ],
  },
  returnhome:{
    icon:"🏠",
    title:"Planning Your Return Trip",
    lines:[
      "When you're ready to head home, this page helps you plan the return journey.",
      "You can reverse your entire stop order with one tap — great if you want to retrace your route home.",
      "Or choose 'Route Home' to plan the fastest drive back, automatically split into manageable daily legs.",
    ],
  },
  results:{
    icon:"📊",
    title:"Your Trip Summary",
    lines:[
      "This page shows a complete cost breakdown for your entire trip — fuel, lodging, food, and more.",
      "As you travel, you can enter what you actually spent on each stop and compare it to the estimate.",
      "The summary updates automatically whenever you change anything in your trip plan.",
    ],
  },
  print:{
    icon:"🖨",
    title:"Printing Your Itinerary",
    lines:[
      "This page lets you print or save a PDF of your full trip itinerary to take with you on the road.",
      "You can choose to include a map image and turn-by-turn directions in the printout.",
      "It's a good idea to have a printed copy as a backup in case you don't have phone or internet service.",
    ],
  },
  quicklinks:{
    icon:"🔗",
    title:"Your Favorite Links",
    lines:[
      "Keep all your most-used RV websites in one place — things like campground booking sites, weather apps, or your bank.",
      "The app comes with a few popular links already added. You can remove ones you don't need and add your own.",
      "Tap any link to open the website. You can organize links into categories to keep things tidy.",
    ],
  },
  monthly:{
    icon:"📅",
    title:"Monthly Expense Tracker",
    lines:[
      "This page lets you track what you actually spend each month while on the road.",
      "Enter expenses in categories like fuel, groceries, dining, and campground fees.",
      "Over time you'll build a clear picture of your real monthly living costs as a full-time or part-time RVer.",
    ],
  },
  annual:{
    icon:"📊",
    title:"Annual Spending Overview",
    lines:[
      "This page adds up all your monthly expenses into a yearly total so you can see the big picture.",
      "It's helpful for planning ahead — for example, seeing if your annual RV costs fit within your retirement income.",
      "Numbers here come from what you enter in the Monthly tracker.",
    ],
  },
  budget:{
    icon:"🎯",
    title:"Budget Planner",
    lines:[
      "Set spending targets for each category — like how much you want to spend on campgrounds per month.",
      "The app will show you a green or red indicator as you enter actual expenses, so you can see at a glance if you're on track.",
      "Think of it like a simple envelope budgeting system, but built for RV life.",
    ],
  },
  maintenance:{
    icon:"🔧",
    title:"RV Maintenance Log",
    lines:[
      "Keep a record of all the maintenance and repairs done on your RV — oil changes, tire rotations, generator service, and more.",
      "Enter your current odometer reading and the app will remind you when service intervals are coming up.",
      "Having a maintenance log is also helpful if you ever sell your RV — it shows buyers you took good care of it.",
    ],
  },
  fillups:{
    icon:"⛽",
    title:"Fuel Fill-Up Log",
    lines:[
      "Record every time you fill up your gas or diesel tank here.",
      "The app calculates your real-world MPG from your fill-up history, which is often more accurate than the manufacturer's estimate.",
      "Over a long trip this data helps you predict fuel costs more accurately.",
    ],
  },
  checklist:{
    icon:"✅",
    title:"Pre-Trip Checklist",
    lines:[
      "Use this checklist before every departure to make sure your RV is safe and ready to roll.",
      "It covers things like checking tire pressure, securing cabinet doors, retracting the awning, and disconnecting hookups.",
      "Check off each item as you go. The list resets for your next departure.",
    ],
  },
  exportimport:{
    icon:"💾",
    title:"Save & Load Your Trip",
    lines:[
      "This page lets you save your entire trip plan to a file on your phone or computer as a backup.",
      "You can also load a previously saved trip file to pick up right where you left off.",
      "If you're logged in, your trip also syncs automatically to the cloud so it's available on any device.",
    ],
  },
  pets:{
    icon:"🐾",
    title:"Travel Companions",
    lines:[
      "Add your pets here to track their vet info, vaccinations, medications, and health records all in one place.",
      "The potty break tracker reminds you when your pet is due for a stop — set the interval and tap Log Stop each time.",
      "The Nearby tab finds dog parks, emergency vets, pet supply stores, and pet-friendly campgrounds near each of your stops.",
    ],
  },
  gym:{
    icon:"🏋️",
    title:"Gym Memberships",
    lines:[
      "Toggle on the gym chains you belong to and store your member number so it is handy at the front desk.",
      "The app generates one-tap Google Maps searches for each of your active gyms near every stop on your route.",
      "Many chains like Planet Fitness Black Card and Anytime Fitness include nationwide access — tap Visit to confirm your plan includes travel.",
    ],
  },
  events:{
    icon:"🎪",
    title:"Events & Causes",
    lines:[
      "Dough 4 Joe is featured here — a 501(c)(3) charity motorcycle run held every July in Fergus Falls MN that helps families battling illness. Every dollar goes directly to families in need.",
      "Add your own favorite charities and causes with a name, description, and website link.",
      "Use the event search links to find motorcycle rallies, charity rides, ATV trails, and toy rentals near each of your stops.",
    ],
  },
  ai:{
    icon:"🤖",
    title:"AI Route Planner",
    lines:[
      "Your personal RV trip planning expert. Tell it where you want to go and it plans your route — fuel stops, free overnight spots, campgrounds, and scenic detours — all added to your trip with one tap.",
      "The AI automatically calculates your route when you open this tab so suggestions are based on your actual road path, not guesses.",
      "Try: 'Make my trip to Fergus Falls more leisurely with boondocking stops' or 'Add fuel stops based on my tank range' — it understands your specific trip.",
    ],
  },
  cellcoverage:{
    icon:"📶",
    title:"Cell Coverage",
    lines:[
      "Check your carrier's interactive coverage map for each leg of your route before you leave — especially in rural areas, mountain passes, and National Parks.",
      "Log your personal coverage notes at each stop so you remember what worked and what didn't for your next trip.",
      "The tips section covers cell boosters, Starlink, offline maps, and how to stay safe in dead zones.",
    ],
  },
  dumpstations:{
    icon:"🪣",
    title:"Dump Stations",
    lines:[
      "Search for dump stations near each of your stops using Sanidumps, RV Dump Sites, and Google Maps links.",
      "Log your personal notes at each stop — cost, hours, access codes, and quality — so the information is ready for your next trip.",
      "The tips section covers what to bring, seasonal closures, membership discounts, and safe practices.",
    ],
  },
  tripsplit:{
    icon:"🤝",
    title:"Trip Cost Split",
    lines:[
      "Divide your trip costs fairly among everyone traveling — families, friends, or caravan groups.",
      "Choose equal split, split by shares (great for children at half share), or add custom amounts per person.",
      "Tap Copy Summary to share the breakdown via text or email so everyone knows what they owe.",
    ],
  },
  propane:{
    icon:"🔥",
    title:"Propane Tracker",
    lines:[
      "Track how much propane is left in each tank and estimate how many days you have remaining.",
      "The usage estimator helps you figure out daily consumption based on your appliances — furnace, fridge, stove, and water heater.",
      "Plan fill-ups along your route before you run low, especially in remote areas where propane can be hard to find.",
    ],
  },
  journal:{
    icon:"📓",
    title:"Campground Journal",
    lines:[
      "Write about your experiences at each campground — what you loved, what to watch out for, and tips for other RVers.",
      "Rate each campground 1-5 stars and mark whether you'd return. Over time this becomes a personal travel diary.",
      "Your notes and tips are saved with the rest of your trip data and can be printed in your trip summary.",
    ],
  },
  narrative:{
    icon:"✨",
    title:"AI Trip Story",
    lines:[
      "After your trip, tap Generate and the app writes a warm travel story based on all your stops.",
      "It reads like a travel blog entry — perfect to email to family, post online, or print as a keepsake.",
      "You can regenerate as many times as you like until it sounds just right.",
    ],
  },
  homewatch:{
    icon:"🏠",
    title:"Home Watch & Mail",
    lines:[
      "Set up a mail hold, record your USPS confirmation number, and track who is watching your home while you travel.",
      "Add tasks for home watchers — watering plants, running the HVAC, collecting packages — with frequency and assignee.",
      "Keep alarm codes, utility shut-offs, and other home access information in the notes so your home watchers have everything they need.",
    ],
  },
  medications:{
    icon:"💊",
    title:"Medication Tracker",
    lines:[
      "Track all your medications, dosages, and refill dates in one place so nothing gets forgotten on the road.",
      "The app warns you when a refill is coming up within 14 days — especially important in remote areas.",
      "When crossing time zones, follow the time zone reminder at the bottom of this page to adjust your schedule safely.",
    ],
  },
  tirepressure:{
    icon:"🛞",
    title:"Tire Pressure Log",
    lines:[
      "Enter your target cold-inflation pressures from your door placard, then log actual readings at each stop.",
      "The temperature correction table shows how pressure changes in hot or cold weather — tire pressure shifts about 1 PSI per 10 degrees.",
      "The app flags tires that are too low or too high compared to your target and shows warnings for dual-rear-wheel setups.",
    ],
  },
  fuelcards:{
    icon:"💳",
    title:"Fuel Cards & Discounts",
    lines:[
      "Track all your fuel discount programs in one place — Good Sam, Love's Connect, Pilot myRewards, GasBuddy, Mudflap, and more.",
      "Enter your card or member numbers so they are handy at the pump, and log how much you save on each fill-up.",
      "The total savings tracker adds up everything you have saved across all programs over the life of the app.",
    ],
  },
  toys:{
    icon:"🏍",
    title:"Toys & Recreational Vehicles",
    lines:[
      "Keep track of your motorcycle, ATV, side-by-side, boat, or any other recreational vehicle you bring along.",
      "For each toy you can record the brand, model, VIN, insurance details, and current mileage or hours.",
      "Log every service visit — oil changes, tire rotations, repairs — and the app will warn you when service is coming due.",
    ],
  },
  settings:{
    icon:"⚙️",
    title:"App Settings",
    lines:[
      "Customize the look and feel of the app here — choose from several color themes and font styles.",
      "You can also turn on Compact Mode if you prefer a tighter layout, or enable the Tips feature to get helpful reminders each time the app loads.",
      "All settings are saved automatically.",
    ],
  },
  emergency:{
    icon:"🆘",
    title:"Emergency Information",
    lines:[
      "Store your roadside assistance, insurance, and emergency contact information here so it's always at your fingertips.",
      "In a stressful breakdown situation, having your policy numbers and phone numbers in one place makes a big difference.",
      "You can also save important document numbers like your registration, passport, and insurance cards.",
    ],
  },
  history:{
    icon:"📚",
    title:"Trip History",
    lines:[
      "When you finish a trip, you can archive it here to save a permanent record of where you went and what you spent.",
      "Archived trips let you compare estimated vs. actual costs, which helps you plan future trips more accurately.",
      "After archiving, your planner resets so you can start planning your next adventure.",
    ],
  },
};

function PageTipModal({tabId, onClose}){
  const T=useTheme();
  const tip=PAGE_TIPS[tabId];
  if(!tip) return null;
  return(
    <div
      style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:10100,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
      onClick={e=>{if(e.target===e.currentTarget)onClose();}}
    >
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:460,padding:32,boxShadow:"0 12px 60px rgba(0,0,0,0.5)",border:`1px solid ${T.border}`}}>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
          <div style={{fontSize:36,lineHeight:1}}>{tip.icon}</div>
          <div>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,letterSpacing:1,textTransform:"uppercase",marginBottom:2}}>What is this page?</div>
            <div style={{fontSize:22,fontWeight:800,color:T.accent,lineHeight:1.2}}>{tip.title}</div>
          </div>
        </div>
        {/* Tip lines */}
        <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:28}}>
          {tip.lines.map((line,i)=>(
            <div key={i} style={{display:"flex",gap:12,alignItems:"flex-start"}}>
              <div style={{width:24,height:24,borderRadius:"50%",background:T.accent+"22",border:`1px solid ${T.accent}44`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
                <span style={{fontSize:11,fontWeight:800,color:T.accent}}>{i+1}</span>
              </div>
              <div style={{fontSize:16,color:T.text,lineHeight:1.65,flex:1}}>{line}</div>
            </div>
          ))}
        </div>
        {/* Footer */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
          <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>This tip won't show again for this page.</div>
          <button
            onClick={onClose}
            style={{background:T.accent,border:"none",borderRadius:12,padding:"14px 32px",color:"#fff",fontSize:16,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap",minHeight:48}}
          >
            Got it! ✓
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Shared road-distance helper ──────────────────────────────────
// Uses OSRM (no key, no CORS issues) with ORS fallback, then straight-line
async function roadMiles(lat1,lon1,lat2,lon2){
  // 1. Try OSRM — free, open, no CORS restrictions
  try{
    const r=await fetch(
      `https://router.project-osrm.org/route/v1/driving/${lon1},${lat1};${lon2},${lat2}?overview=false`,
      {headers:{"Accept":"application/json"}}
    );
    if(r.ok){
      const d=await r.json();
      const meters=d?.routes?.[0]?.distance;
      if(meters>0) return Math.round(meters/1609.34);
    }
  }catch(e){console.warn("OSRM failed:",e.message);}
  // 2. Try ORS if key available
  if(ORS_KEY){
    try{
      const r=await fetch("https://api.openrouteservice.org/v2/directions/driving-car/json",{
        method:"POST",
        headers:{"Content-Type":"application/json","Authorization":ORS_KEY},
        body:JSON.stringify({coordinates:[[lon1,lat1],[lon2,lat2]]})
      });
      if(r.ok){
        const d=await r.json();
        const meters=d?.routes?.[0]?.summary?.distance;
        if(meters>0) return Math.round(meters/1609.34);
      }
    }catch(e){console.warn("ORS routing failed:",e.message);}
  }
  // 3. Straight-line × 1.25
  const R=3959,toR=Math.PI/180;
  const dLat=(lat2-lat1)*toR,dLon=(lon2-lon1)*toR;
  const a=Math.sin(dLat/2)**2+Math.cos(lat1*toR)*Math.cos(lat2*toR)*Math.sin(dLon/2)**2;
  return Math.round(R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a))*1.25);
}

// Multi-point road route (for map drawing) — OSRM full geometry
// coordPairs: array of [lon,lat]
async function roadRoute(coordPairs){
  if(coordPairs.length<2) return null;
  // OSRM handles max 100 waypoints; for multi-stop trips route leg by leg and stitch
  const allCoords=[];
  const pairs=coordPairs.length>25
    // For many waypoints, do leg-by-leg to stay within OSRM limits
    ? coordPairs.map((_,i)=>i<coordPairs.length-1?[coordPairs[i],coordPairs[i+1]]:null).filter(Boolean)
    : [[...coordPairs]]; // single call for short routes
  for(const leg of pairs){
    try{
      const waypoints=leg.map(([lon,lat])=>`${lon},${lat}`).join(";");
      const r=await fetch(
        `https://router.project-osrm.org/route/v1/driving/${waypoints}?overview=full&geometries=geojson`,
        {headers:{"Accept":"application/json"}}
      );
      if(r.ok){
        const d=await r.json();
        if(d?.code==="Ok"){
          const legCoords=d?.routes?.[0]?.geometry?.coordinates;
          if(legCoords&&legCoords.length>0){
            // Avoid duplicate junction points between legs
            if(allCoords.length>0) allCoords.push(...legCoords.slice(1));
            else allCoords.push(...legCoords);
          }
        } else {
          console.warn("OSRM error:",d?.code,d?.message,"for leg",leg.map(c=>c.join(",")).join(" → "));
        }
      }
    }catch(e){console.warn("OSRM leg failed:",e.message);}
  }
  if(allCoords.length>1){
    return allCoords;
  }
  return null;
}

// ── CoachMark ─────────────────────────────────────────────────────
// Wraps a button or element with a pulsing ring + tooltip bubble.
// Shows once per coachId, then never again.
function CoachMark({coachId,message,position="top",children,active=true,autoClose=5000}){
  const T=useTheme();
  const [seen,setSeen]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("rv-coach-seen")||"{}")[coachId]===true;}catch{return false;}
  });
  const dismiss=()=>{
    try{
      const s=JSON.parse(localStorage.getItem("rv-coach-seen")||"{}");
      s[coachId]=true;
      localStorage.setItem("rv-coach-seen",JSON.stringify(s));
    }catch{}
    setSeen(true);
  };
  // Auto-dismiss after autoClose ms
  useEffect(()=>{
    if(seen||!active) return;
    const t=setTimeout(dismiss,autoClose);
    return()=>clearTimeout(t);
  },[seen,active]);
  if(seen||!active) return children;
  const bubbleStyle={
    position:"absolute",
    [position==="top"?"bottom":"top"]:"calc(100% + 10px)",
    left:"50%",transform:"translateX(-50%)",
    background:"#7c3aed",color:"#fff",
    borderRadius:10,padding:"8px 12px",
    fontSize:12,fontWeight:600,lineHeight:1.4,
    whiteSpace:"nowrap",zIndex:9000,
    boxShadow:"0 4px 16px rgba(124,58,237,0.4)",
    pointerEvents:"none",
    maxWidth:240,whiteSpace:"normal",textAlign:"center",
  };
  const arrowStyle={
    position:"absolute",
    [position==="top"?"top":"bottom"]:"100%",
    left:"50%",transform:"translateX(-50%)",
    width:0,height:0,
    borderLeft:"6px solid transparent",
    borderRight:"6px solid transparent",
    [position==="top"?"borderBottom":"borderTop"]:"6px solid #7c3aed",
  };
  return(
    <div style={{position:"relative",display:"inline-flex"}} onClick={dismiss}>
      <div style={{
        position:"absolute",inset:-4,borderRadius:10,
        border:"2px solid #7c3aed",
        animation:"coachPulse 1.5s ease-in-out infinite",
        pointerEvents:"none",zIndex:8999,
      }}/>
      {children}
      <div style={bubbleStyle}>
        {message}
        <div style={arrowStyle}/>
      </div>
      <style>{`@keyframes coachPulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.5;transform:scale(1.05)}}`}</style>
    </div>
  );
}

// ── ToysSection ────────────────────────────────────────────────────
const TOY_TYPES=["Motorcycle","Side-by-Side (SxS)","ATV / Quad","Golf Cart","Boat","Jet Ski","Snowmobile","Bicycle / E-Bike","Dirt Bike","Other"];
const TOY_SERVICE_TYPES=["Oil Change","Filter Change","Tire Rotation","Tire Replacement","Brake Service","Chain/Belt Service","Air Filter","Spark Plugs","Battery","Coolant","Transmission Service","Full Inspection","Registration/Insurance","Repair","Other"];
const mkToy=()=>({
  id:uid(),name:"",brand:"",model:"",year:"",type:"Motorcycle",
  vin:"",licensePlate:"",color:"",purchaseDate:"",
  odometerUnit:"miles", // miles or hours
  currentOdometer:0,
  insuranceCompany:"",insurancePolicy:"",insurancePhone:"",
  registrationExpiry:"",
  notes:"",
  logs:[],
});
const mkToyLog=()=>({
  id:uid(),date:new Date().toISOString().slice(0,10),
  serviceType:"Oil Change",odometer:"",cost:"",notes:"",nextDue:"",
});

function ToysSection({toys=[],onChange}){
  const T=useTheme();
  const [selectedId,setSelectedId]=useState(toys[0]?.id||null);
  const [addingLog,setAddingLog]=useState(false);
  const [newLog,setNewLog]=useState(mkToyLog());
  const [editProfile,setEditProfile]=useState(false);

  const selected=toys.find(t=>t.id===selectedId)||null;

  const addToy=()=>{
    const t=mkToy();
    onChange([...toys,t]);
    setSelectedId(t.id);
    setEditProfile(true);
  };

  const updateToy=(updated)=>{
    onChange(toys.map(t=>t.id===updated.id?updated:t));
  };

  const deleteToy=(id)=>{
    const next=toys.filter(t=>t.id!==id);
    onChange(next);
    setSelectedId(next[0]?.id||null);
  };

  const addLog=()=>{
    if(!selected||!newLog.date) return;
    const updated={...selected,logs:[newLog,...(selected.logs||[])]};
    updateToy(updated);
    setNewLog(mkToyLog());
    setAddingLog(false);
  };

  const deleteLog=(logId)=>{
    if(!selected) return;
    updateToy({...selected,logs:(selected.logs||[]).filter(l=>l.id!==logId)});
  };

  const fToy=(k,v)=>{if(selected)updateToy({...selected,[k]:v});};

  return(
    <div>
      <SecHead icon="🏍" title="Toys & Recreational Vehicles" sub="Track maintenance and details for motorcycles, side-by-sides, ATVs, boats, and other recreational vehicles"/>

      {/* Toy selector + Add button */}
      <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{display:"flex",gap:8,flex:1,flexWrap:"wrap"}}>
          {toys.map(t=>(
            <button key={t.id} onClick={()=>{setSelectedId(t.id);setEditProfile(false);setAddingLog(false);}}
              style={{padding:"8px 16px",borderRadius:10,border:`2px solid ${t.id===selectedId?T.accent:T.border}`,
                background:t.id===selectedId?T.accent+"18":T.bgLite,
                color:t.id===selectedId?T.accent:T.text,
                fontWeight:700,fontSize:13,cursor:"pointer"}}>
              {t.name||t.brand+" "+t.model||"New Toy"}
            </button>
          ))}
        </div>
        <button onClick={addToy} style={{padding:"8px 16px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer",flexShrink:0}}>
          + Add Toy
        </button>
      </div>

      {!selected&&<Card><div style={{textAlign:"center",padding:32,color:T.muted}}>
        <div style={{fontSize:48,marginBottom:12}}>🏍</div>
        <div style={{fontSize:16,fontWeight:700,marginBottom:8}}>No toys added yet</div>
        <div style={{fontSize:13,marginBottom:20}}>Add your motorcycle, SxS, ATV, boat, or other recreational vehicle to track maintenance.</div>
        <button onClick={addToy} style={{padding:"10px 24px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:"pointer"}}>+ Add Your First Toy</button>
      </div></Card>}

      {selected&&<>
        {/* Profile card */}
        <Card style={{marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:editProfile?16:0}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <span style={{fontSize:28}}>{
                selected.type==="Motorcycle"?"🏍":selected.type==="Side-by-Side (SxS)"?"🚗":
                selected.type==="ATV / Quad"?"🏎":selected.type==="Boat"?"⛵":
                selected.type==="Jet Ski"?"🌊":selected.type==="Snowmobile"?"❄️":
                selected.type==="Golf Cart"?"⛳":selected.type==="Bicycle / E-Bike"?"🚲":"🏍"
              }</span>
              <div>
                <div style={{fontSize:16,fontWeight:800,color:T.text}}>{selected.name||selected.brand+" "+selected.model||"Unnamed"}</div>
                <div style={{fontSize:12,color:T.muted}}>{selected.year} {selected.brand} {selected.model} · {selected.type}</div>
              </div>
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setEditProfile(e=>!e)} style={{padding:"6px 12px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer",color:T.text}}>
                {editProfile?"✓ Done":"✏️ Edit"}
              </button>
              <button onClick={()=>{if(window.confirm("Delete "+( selected.name||"this toy")+"?"))deleteToy(selected.id);}} style={{padding:"6px 12px",background:"none",border:`1px solid ${T.danger}44`,borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer",color:T.danger}}>
                🗑
              </button>
            </div>
          </div>

          {editProfile&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:12,marginTop:12}}>
            <div><Label>Nickname / Name</Label><Inp value={selected.name||""} onChange={e=>fToy("name",e.target.value)} placeholder="e.g. My Harley"/></div>
            <div><Label>Type</Label><Sel value={selected.type} onChange={e=>fToy("type",e.target.value)}>{TOY_TYPES.map(t=><option key={t} value={t}>{t}</option>)}</Sel></div>
            <div><Label>Brand / Make</Label><Inp value={selected.brand||""} onChange={e=>fToy("brand",e.target.value)} placeholder="e.g. Harley-Davidson"/></div>
            <div><Label>Model</Label><Inp value={selected.model||""} onChange={e=>fToy("model",e.target.value)} placeholder="e.g. Road Glide"/></div>
            <div><Label>Year</Label><Inp type="number" value={selected.year||""} onChange={e=>fToy("year",e.target.value)} placeholder="e.g. 2022"/></div>
            <div><Label>Color</Label><Inp value={selected.color||""} onChange={e=>fToy("color",e.target.value)} placeholder="e.g. Vivid Black"/></div>
            <div><Label>VIN / Serial #</Label><Inp value={selected.vin||""} onChange={e=>fToy("vin",e.target.value)} placeholder="VIN or Serial Number"/></div>
            <div><Label>License Plate</Label><Inp value={selected.licensePlate||""} onChange={e=>fToy("licensePlate",e.target.value)} placeholder="Plate number"/></div>
            <div><Label>Purchase Date</Label><Inp type="date" value={selected.purchaseDate||""} onChange={e=>fToy("purchaseDate",e.target.value)}/></div>
            <div><Label>Registration Expiry</Label><Inp type="date" value={selected.registrationExpiry||""} onChange={e=>fToy("registrationExpiry",e.target.value)}/></div>
            <div><Label>Odometer / Hours</Label>
              <div style={{display:"flex",gap:6}}>
                <Inp type="number" value={selected.currentOdometer||""} onChange={e=>fToy("currentOdometer",e.target.value)} placeholder="Current reading" style={{flex:1}}/>
                <Sel value={selected.odometerUnit||"miles"} onChange={e=>fToy("odometerUnit",e.target.value)} style={{width:90}}>
                  <option value="miles">Miles</option>
                  <option value="hours">Hours</option>
                </Sel>
              </div>
            </div>
            <div><Label>Insurance Company</Label><Inp value={selected.insuranceCompany||""} onChange={e=>fToy("insuranceCompany",e.target.value)} placeholder="e.g. Progressive"/></div>
            <div><Label>Policy Number</Label><Inp value={selected.insurancePolicy||""} onChange={e=>fToy("insurancePolicy",e.target.value)} placeholder="Policy #"/></div>
            <div><Label>Insurance Phone</Label><Inp value={selected.insurancePhone||""} onChange={e=>fToy("insurancePhone",e.target.value)} placeholder="Claims/roadside #"/></div>
            <div style={{gridColumn:"1/-1"}}><Label>Notes</Label><Inp value={selected.notes||""} onChange={e=>fToy("notes",e.target.value)} placeholder="Mods, known issues, storage location..."/></div>
          </div>}

          {!editProfile&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:10,marginTop:12}}>
            {[
              {l:"Odometer",v:(selected.currentOdometer||0).toLocaleString()+" "+(selected.odometerUnit||"mi")},
              {l:"VIN",v:selected.vin||"—"},
              {l:"Plate",v:selected.licensePlate||"—"},
              {l:"Registration",v:selected.registrationExpiry?new Date(selected.registrationExpiry+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}):"—"},
              {l:"Insurance",v:selected.insuranceCompany||"—"},
              {l:"Policy #",v:selected.insurancePolicy||"—"},
            ].map(({l,v})=>(
              <div key={l} style={{background:T.bgLite,borderRadius:8,padding:"8px 10px"}}>
                <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5,marginBottom:2}}>{l}</div>
                <div style={{fontSize:13,fontWeight:600,color:T.text,wordBreak:"break-all"}}>{v}</div>
              </div>
            ))}
          </div>}
        </Card>

        {/* Maintenance log */}
        <Card>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted}}>🔧 Maintenance Log</div>
            <button onClick={()=>{setAddingLog(a=>!a);setNewLog(mkToyLog());}}
              style={{padding:"6px 14px",background:addingLog?"none":T.accent,color:addingLog?T.muted:"#fff",border:addingLog?`1px solid ${T.border}`:"none",borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer"}}>
              {addingLog?"✕ Cancel":"+ Log Service"}
            </button>
          </div>

          {addingLog&&<div style={{background:T.bgLite,borderRadius:10,padding:14,marginBottom:14,border:`1px solid ${T.border}`}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(170px,1fr))",gap:10,marginBottom:10}}>
              <div><Label>Date</Label><Inp type="date" value={newLog.date} onChange={e=>setNewLog(l=>({...l,date:e.target.value}))}/></div>
              <div><Label>Service Type</Label><Sel value={newLog.serviceType} onChange={e=>setNewLog(l=>({...l,serviceType:e.target.value}))}>{TOY_SERVICE_TYPES.map(t=><option key={t} value={t}>{t}</option>)}</Sel></div>
              <div><Label>{selected.odometerUnit==="hours"?"Hours":"Odometer"} at Service</Label><Inp type="number" value={newLog.odometer} onChange={e=>setNewLog(l=>({...l,odometer:e.target.value}))} placeholder="Reading"/></div>
              <div><Label>Cost ($)</Label><Inp type="number" value={newLog.cost} onChange={e=>setNewLog(l=>({...l,cost:e.target.value}))} placeholder="0.00"/></div>
              <div><Label>Next Service Due</Label><Inp type="date" value={newLog.nextDue} onChange={e=>setNewLog(l=>({...l,nextDue:e.target.value}))}/></div>
              <div style={{gridColumn:"1/-1"}}><Label>Notes</Label><Inp value={newLog.notes} onChange={e=>setNewLog(l=>({...l,notes:e.target.value}))} placeholder="What was done, parts used, shop name..."/></div>
            </div>
            <button onClick={addLog} style={{background:T.free,color:"#fff",border:"none",borderRadius:8,padding:"9px 20px",fontSize:13,fontWeight:700,cursor:"pointer"}}>✓ Save Log Entry</button>
          </div>}

          {(selected.logs||[]).length===0&&!addingLog&&(
            <div style={{textAlign:"center",padding:"24px 0",color:T.muted,fontSize:13}}>No maintenance logged yet. Tap "+ Log Service" to add your first entry.</div>
          )}

          {(selected.logs||[]).map((log,i)=>{
            const nextDueDate=log.nextDue?new Date(log.nextDue+"T00:00:00"):null;
            const isDue=nextDueDate&&nextDueDate<=new Date();
            const isDueSoon=nextDueDate&&!isDue&&(nextDueDate-new Date())<30*24*60*60*1000;
            return(
              <div key={log.id} style={{display:"flex",gap:12,alignItems:"flex-start",padding:"10px 0",borderBottom:i<(selected.logs.length-1)?`1px solid ${T.border}44`:"none"}}>
                <div style={{width:42,height:42,borderRadius:8,background:T.accent+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>🔧</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:2}}>
                    <span style={{fontSize:13,fontWeight:700,color:T.text}}>{log.serviceType}</span>
                    {log.cost&&<span style={{fontSize:11,color:T.free,fontWeight:600}}>${parseFloat(log.cost).toFixed(2)}</span>}
                    {log.odometer&&<span style={{fontSize:11,color:T.muted}}>{parseInt(log.odometer).toLocaleString()} {selected.odometerUnit||"mi"}</span>}
                    {isDue&&<span style={{fontSize:10,background:T.danger+"22",color:T.danger,padding:"1px 6px",borderRadius:4,fontWeight:700}}>⚠ OVERDUE</span>}
                    {isDueSoon&&<span style={{fontSize:10,background:"#f59e0b22",color:"#f59e0b",padding:"1px 6px",borderRadius:4,fontWeight:700}}>Due Soon</span>}
                  </div>
                  <div style={{fontSize:11,color:T.muted,marginBottom:log.notes?2:0}}>
                    {new Date(log.date+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}
                    {log.nextDue&&<span> · Next due: {new Date(log.nextDue+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</span>}
                  </div>
                  {log.notes&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic"}}>{log.notes}</div>}
                </div>
                <button onClick={()=>deleteLog(log.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,padding:"2px 4px",flexShrink:0}}>✕</button>
              </div>
            );
          })}

          {/* Cost summary */}
          {(selected.logs||[]).length>0&&(()=>{
            const total=(selected.logs||[]).reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
            const thisYear=(selected.logs||[]).filter(l=>l.date&&new Date(l.date).getFullYear()===new Date().getFullYear()).reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
            return(
              <div style={{display:"flex",gap:10,marginTop:12,flexWrap:"wrap"}}>
                <div style={{background:T.bgLite,borderRadius:8,padding:"8px 14px",flex:1}}>
                  <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Total Spent</div>
                  <div style={{fontSize:18,fontWeight:800,color:T.accent}}>${total.toFixed(2)}</div>
                </div>
                <div style={{background:T.bgLite,borderRadius:8,padding:"8px 14px",flex:1}}>
                  <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>This Year</div>
                  <div style={{fontSize:18,fontWeight:800,color:T.free}}>${thisYear.toFixed(2)}</div>
                </div>
                <div style={{background:T.bgLite,borderRadius:8,padding:"8px 14px",flex:1}}>
                  <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Log Entries</div>
                  <div style={{fontSize:18,fontWeight:800,color:T.text}}>{selected.logs.length}</div>
                </div>
              </div>
            );
          })()}
        </Card>
      </>}
    </div>
  );
}


// ── PropaneTracker ─────────────────────────────────────────────────
const PROPANE_APPLIANCES=[
  {id:"furnace",label:"Furnace",gph:0.1,icon:"🔥"},
  {id:"fridge",label:"Refrigerator",gph:0.04,icon:"❄️"},
  {id:"stove",label:"Stove (per use)",gph:0.03,icon:"🍳"},
  {id:"water",label:"Water Heater",gph:0.06,icon:"🚿"},
  {id:"genset",label:"Generator",gph:0.15,icon:"⚡"},
];
function PropaneSection({propane={},onChange,stops=[],weather={}}){
  const T=useTheme();
  const f=(k,v)=>onChange({...propane,[k]:v});
  const tanks=propane.tanks||[];
  const addTank=()=>onChange({...propane,tanks:[...tanks,{id:uid(),size:20,current:100,unit:"pct",label:""}]});
  const updTank=(id,k,v)=>onChange({...propane,tanks:tanks.map(t=>t.id===id?{...t,[k]:v}:t)});
  const delTank=(id)=>onChange({...propane,tanks:tanks.filter(t=>t.id!==id)});

  // Calculate total propane in gallons
  const totalGals=tanks.reduce((sum,t)=>{
    const cap={11:2.7,20:4.7,30:7.1,40:9.4,100:23.6}[t.size]||t.size*0.236;
    const pct=t.unit==="pct"?(parseFloat(t.current)||0)/100:(parseFloat(t.current)||0)/(cap||1);
    return sum+(cap*Math.min(pct,1));
  },0);
  const dailyUse=parseFloat(propane.dailyUsageGals)||0.5;
  const daysLeft=dailyUse>0?Math.floor(totalGals/dailyUse):null;

  return(
    <div>
      <SecHead icon="🔥" title="Propane Tracker" sub="Monitor tank levels, estimate days remaining, and plan fill-ups along your route"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16}}>
        {/* Tank cards */}
        <Card>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>🔥 My Tanks</div>
            <button onClick={addTank} style={{padding:"5px 12px",background:T.accent,color:"#fff",border:"none",borderRadius:7,fontSize:11,fontWeight:700,cursor:"pointer"}}>+ Add Tank</button>
          </div>
          {tanks.length===0&&<div style={{textAlign:"center",padding:20,color:T.muted,fontSize:13}}>No tanks added yet. Most RVs have one or two 20-lb tanks.</div>}
          {tanks.map(t=>{
            const cap={11:2.7,20:4.7,30:7.1,40:9.4,100:23.6}[t.size]||t.size*0.236;
            const gals=t.unit==="pct"?(parseFloat(t.current)||0)/100*cap:(parseFloat(t.current)||0);
            const pct=Math.min((gals/cap)*100,100);
            const color=pct<20?T.danger:pct<40?"#f59e0b":T.free;
            return(
              <div key={t.id} style={{marginBottom:12,padding:12,background:T.bgLite,borderRadius:10,border:`1px solid ${T.border}`}}>
                <div style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}>
                  <Inp value={t.label||""} onChange={e=>updTank(t.id,"label",e.target.value)} placeholder={`Tank ${tanks.indexOf(t)+1}`} style={{flex:1,fontSize:13,padding:"5px 8px"}}/>
                  <Sel value={t.size} onChange={e=>updTank(t.id,"size",e.target.value)} style={{width:80,padding:"5px 8px",fontSize:12}}>
                    {[11,20,30,40,100].map(s=><option key={s} value={s}>{s} lb</option>)}
                  </Sel>
                  <button onClick={()=>delTank(t.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14}}>✕</button>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:8}}>
                  <Inp type="number" min={0} max={t.unit==="pct"?100:cap} value={t.current||""} onChange={e=>updTank(t.id,"current",e.target.value)} placeholder={t.unit==="pct"?"0-100":cap.toFixed(1)} style={{flex:1,fontSize:13,padding:"5px 8px"}}/>
                  <Sel value={t.unit||"pct"} onChange={e=>updTank(t.id,"unit",e.target.value)} style={{width:80,padding:"5px 8px",fontSize:12}}>
                    <option value="pct">%</option>
                    <option value="gals">Gals</option>
                  </Sel>
                </div>
                <div style={{height:12,background:T.border,borderRadius:6,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${pct}%`,background:color,borderRadius:6,transition:"width .3s"}}/>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:4,fontSize:11,color:T.muted}}>
                  <span style={{color}}>{Math.round(pct)}% full</span>
                  <span>{gals.toFixed(1)} gals of {cap.toFixed(1)}</span>
                </div>
              </div>
            );
          })}
          {/* Summary */}
          {tanks.length>0&&<div style={{marginTop:8,padding:"10px 12px",background:T.accent+"11",borderRadius:8,border:`1px solid ${T.accent}33`}}>
            <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
              <div><div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Total Remaining</div><div style={{fontSize:20,fontWeight:800,color:T.accent}}>{totalGals.toFixed(1)} gals</div></div>
              {daysLeft!==null&&<div><div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Est. Days Left</div><div style={{fontSize:20,fontWeight:800,color:daysLeft<3?T.danger:daysLeft<7?"#f59e0b":T.free}}>{daysLeft} days</div></div>}
            </div>
          </div>}
        </Card>
        {/* Usage estimator */}
        <Card>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>📊 Usage Estimator</div>
          <div style={{marginBottom:12}}>
            <Label>Estimated Daily Use (gallons)</Label>
            <Inp type="number" min={0} step={0.1} value={propane.dailyUsageGals||""} onChange={e=>f("dailyUsageGals",e.target.value)} placeholder="0.5"/>
            <div style={{fontSize:11,color:T.muted,marginTop:3}}>Average daily consumption across all appliances</div>
          </div>
          <div style={{fontFamily:T.F.cond,fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:.5,marginBottom:8}}>Quick Estimates by Appliance</div>
          {PROPANE_APPLIANCES.map(a=>(
            <div key={a.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:`1px solid ${T.border}44`}}>
              <span style={{fontSize:13}}>{a.icon} {a.label}</span>
              <span style={{fontSize:12,color:T.muted}}>{a.gph} gal/hr</span>
            </div>
          ))}
          <div style={{marginTop:12}}>
            <Label>Notes</Label>
            <Inp value={propane.notes||""} onChange={e=>f("notes",e.target.value)} placeholder="e.g. Fill up at Flying J Tuscaloosa — cheapest on route"/>
          </div>
        </Card>
      </div>
    </div>
  );
}

// ── CampgroundJournal ──────────────────────────────────────────────
function CampgroundJournal({journal=[],onChange,stops=[],onPublish}){
  const T=useTheme();
  const [editId,setEditId]=useState(null);
  const [newEntry,setNewEntry]=useState(null);
  const mkEntry=(stop)=>({id:uid(),stopId:stop?.id||"",stopName:stop?.name||"",date:new Date().toISOString().slice(0,10),rating:5,title:"",body:"",campground:"",siteNumber:"",hookups:"Full",wouldReturn:true,tips:"",photos:[]});

  const saveEntry=(entry)=>{
    if(editId){onChange(journal.map(e=>e.id===editId?entry:e));setEditId(null);}
    else{onChange([entry,...journal]);}
    setNewEntry(null);
  };
  const deleteEntry=(id)=>onChange(journal.filter(e=>e.id!==id));

  const EntryForm=({entry,onSave,onCancel})=>{
    const [e,setE]=useState(entry);
    const fe=(k,v)=>setE(p=>({...p,[k]:v}));
    return(
      <div style={{background:T.bgLite,borderRadius:12,padding:16,border:`1px solid ${T.accent}44`,marginBottom:12}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10,marginBottom:10}}>
          <div><Label>Stop / Location</Label>
            <Sel value={e.stopId||""} onChange={ev=>{const s=stops.find(s=>s.id===ev.target.value);fe("stopId",ev.target.value);if(s)fe("stopName",s.name);}}>
              <option value="">-- Select stop --</option>
              {stops.filter(s=>s.name&&s.type!=="home").map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
            </Sel>
          </div>
          <div><Label>Campground Name</Label><Inp value={e.campground||""} onChange={ev=>fe("campground",ev.target.value)} placeholder="e.g. KOA Hill City"/></div>
          <div><Label>Site #</Label><Inp value={e.siteNumber||""} onChange={ev=>fe("siteNumber",ev.target.value)} placeholder="e.g. 42B"/></div>
          <div><Label>Date</Label><Inp type="date" value={e.date} onChange={ev=>fe("date",ev.target.value)}/></div>
          <div><Label>Hookups</Label><Sel value={e.hookups||"Full"} onChange={ev=>fe("hookups",ev.target.value)}>{["Full (50A)","Full (30A)","Electric Only","Water Only","No Hookups","Boondock"].map(h=><option key={h}>{h}</option>)}</Sel></div>
          <div><Label>Rating</Label>
            <div style={{display:"flex",gap:4,marginTop:6}}>
              {[1,2,3,4,5].map(n=>(
                <button key={n} onClick={()=>fe("rating",n)} style={{fontSize:20,background:"none",border:"none",cursor:"pointer",opacity:n<=e.rating?1:.3}}>⭐</button>
              ))}
            </div>
          </div>
        </div>
        <div style={{marginBottom:8}}><Label>Entry Title</Label><Inp value={e.title||""} onChange={ev=>fe("title",ev.target.value)} placeholder="e.g. Perfect fall weekend at the Badlands"/></div>
        <div style={{marginBottom:8}}><Label>Journal Entry</Label>
          <textarea value={e.body||""} onChange={ev=>fe("body",ev.target.value)} placeholder="Write about your experience — what you saw, did, ate, who you met..." rows={4}
            style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,fontFamily:"inherit",resize:"vertical"}}/>
        </div>
        <div style={{marginBottom:12}}><Label>Tips for Other RVers</Label><Inp value={e.tips||""} onChange={ev=>fe("tips",ev.target.value)} placeholder="e.g. Arrive before 2pm, site 14 has best shade, grocery 2mi east"/></div>
        <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:12}}>
          <Tog value={e.wouldReturn} onChange={v=>fe("wouldReturn",v)} label="Would return here"/>
        </div>
        {/* Photo upload */}
        <div style={{marginBottom:12}}>
          <Label>📸 Photos</Label>
          <div style={{fontSize:11,color:T.muted,marginBottom:6}}>Add up to 6 photos. Images are compressed automatically before upload.</div>
          <label style={{display:"inline-flex",alignItems:"center",gap:8,padding:"8px 14px",background:T.bgLite,border:`1px dashed ${T.border}`,borderRadius:8,cursor:"pointer",fontSize:12,color:T.accent,fontWeight:600}}>
            📷 Add Photos
            <input type="file" accept="image/*" multiple style={{display:"none"}} onChange={async ev=>{
              const files=Array.from(ev.target.files||[]);
              const existing=e.photos||[];
              if(existing.length>=6){alert("Maximum 6 photos per entry.");return;}
              const toAdd=files.slice(0,6-existing.length);
              const compressed=await Promise.all(toAdd.map(file=>new Promise((resolve)=>{
                const reader=new FileReader();
                reader.onload=re=>{
                  const img=new Image();
                  img.onload=()=>{
                    const MAX=1200;
                    let w=img.width,h=img.height;
                    if(w>MAX||h>MAX){if(w>h){h=Math.round(h*MAX/w);w=MAX;}else{w=Math.round(w*MAX/h);h=MAX;}}
                    const canvas=document.createElement("canvas");
                    canvas.width=w;canvas.height=h;
                    canvas.getContext("2d").drawImage(img,0,0,w,h);
                    const compressed=canvas.toDataURL("image/jpeg",0.75);
                    // Upload to Supabase Storage
                    const filename=`${Date.now()}-${Math.random().toString(36).slice(2)}.jpg`;
                    const base64=compressed.split(",")[1];
                    const bytes=Uint8Array.from(atob(base64),c=>c.charCodeAt(0));
                    supabase.storage.from("journal-photos").upload(filename,bytes,{contentType:"image/jpeg",upsert:true})
                      .then(({data,error})=>{
                        if(error){resolve({url:compressed,local:true});}
                        else{
                          const {data:{publicUrl}}=supabase.storage.from("journal-photos").getPublicUrl(filename);
                          resolve({url:publicUrl,local:false,filename});
                        }
                      });
                  };
                  img.src=re.target.result;
                };
                reader.readAsDataURL(file);
              })));
              fe("photos",[...existing,...compressed]);
              ev.target.value="";
            }}/>
          </label>
          {(e.photos||[]).length>0&&<div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:10}}>
            {(e.photos||[]).map((p,i)=>(
              <div key={i} style={{position:"relative",flexShrink:0}}>
                <img src={p.url} alt="" style={{width:80,height:80,objectFit:"cover",borderRadius:8,border:`1px solid ${T.border}`}}/>
                <button onClick={()=>{
                  // Remove from Supabase if uploaded
                  if(!p.local&&p.filename) supabase.storage.from("journal-photos").remove([p.filename]).catch(()=>{});
                  fe("photos",(e.photos||[]).filter((_,j)=>j!==i));
                }} style={{position:"absolute",top:-6,right:-6,width:18,height:18,borderRadius:"50%",background:T.danger,color:"#fff",border:"none",cursor:"pointer",fontSize:11,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700}}>✕</button>
              </div>
            ))}
          </div>}
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>onSave(e)} style={{flex:1,background:T.free,color:"#fff",border:"none",borderRadius:8,padding:"9px 0",fontWeight:700,fontSize:13,cursor:"pointer"}}>✓ Save Entry</button>
          <button onClick={onCancel} style={{flex:1,background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 0",fontWeight:700,fontSize:13,cursor:"pointer",color:T.muted}}>Cancel</button>
        </div>
      </div>
    );
  };

  return(
    <div>
      <SecHead icon="📓" title="Campground Journal" sub="Record your experiences, rate campgrounds, and leave tips for your future self"/>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div style={{fontSize:13,color:T.muted}}>{journal.length} {journal.length===1?"entry":"entries"} · {journal.filter(e=>e.wouldReturn).length} would-return</div>
        <div style={{display:"flex",gap:8}}>
          {journal.length>0&&onPublish&&<button onClick={onPublish} style={{padding:"8px 16px",background:"#16a34a",color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>📤 Share Journal</button>}
          <button onClick={()=>{setNewEntry(mkEntry());setEditId(null);}} style={{padding:"8px 16px",background:T.accent,color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>✏️ New Entry</button>
        </div>
      </div>
      {newEntry&&<EntryForm entry={newEntry} onSave={saveEntry} onCancel={()=>setNewEntry(null)}/>}
      {journal.length===0&&!newEntry&&<Card><div style={{textAlign:"center",padding:32,color:T.muted}}>
        <div style={{fontSize:48,marginBottom:12}}>📓</div>
        <div style={{fontSize:16,fontWeight:700,marginBottom:8}}>Your travel journal is empty</div>
        <div style={{fontSize:13,marginBottom:20}}>Record your campground experiences — ratings, tips, and memories from each stop.</div>
        <button onClick={()=>setNewEntry(mkEntry())} style={{padding:"10px 24px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,cursor:"pointer"}}>✏️ Write First Entry</button>
      </div></Card>}
      {journal.map(e=>{
        if(editId===e.id) return<EntryForm key={e.id} entry={e} onSave={saveEntry} onCancel={()=>setEditId(null)}/>;
        return(
          <Card key={e.id} style={{marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,gap:8}}>
              <div style={{flex:1}}>
                <div style={{fontSize:15,fontWeight:800,color:T.text,marginBottom:2}}>{e.title||e.campground||e.stopName||"Untitled Entry"}</div>
                <div style={{fontSize:11,color:T.muted,display:"flex",gap:10,flexWrap:"wrap"}}>
                  {e.campground&&<span>🏕 {e.campground}</span>}
                  {e.siteNumber&&<span>Site #{e.siteNumber}</span>}
                  {e.hookups&&<span>{e.hookups}</span>}
                  <span>{new Date(e.date+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</span>
                  {e.wouldReturn&&<span style={{color:T.free}}>✓ Would return</span>}
                </div>
              </div>
              <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                <span style={{fontSize:14}}>{["","⭐","⭐⭐","⭐⭐⭐","⭐⭐⭐⭐","⭐⭐⭐⭐⭐"][e.rating||5]}</span>
                <button onClick={()=>setEditId(e.id)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:6,padding:"3px 8px",fontSize:11,cursor:"pointer",color:T.muted}}>✏️</button>
                <button onClick={()=>deleteEntry(e.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14}}>✕</button>
              </div>
            </div>
            {e.body&&<div style={{fontSize:13,color:T.text,lineHeight:1.7,marginBottom:e.tips?8:0,whiteSpace:"pre-wrap"}}>{e.body}</div>}
            {(e.photos||[]).length>0&&<div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8,marginBottom:e.tips?8:0}}>
              {(e.photos||[]).map((p,i)=>(
                <img key={i} src={p.url} alt="" onClick={()=>window.open(p.url,"_blank")}
                  style={{width:90,height:90,objectFit:"cover",borderRadius:8,border:`1px solid ${T.border}`,cursor:"pointer"}}/>
              ))}
            </div>}
            {e.tips&&<div style={{marginTop:8,padding:"8px 10px",background:"#f59e0b11",border:"1px solid #f59e0b33",borderRadius:8}}>
              <div style={{fontSize:10,color:"#f59e0b",fontWeight:700,textTransform:"uppercase",letterSpacing:.5,marginBottom:3}}>💡 Tips for RVers</div>
              <div style={{fontSize:12,color:T.text}}>{e.tips}</div>
            </div>}
          </Card>
        );
      })}
    </div>
  );
}

// ── HomeWatch ──────────────────────────────────────────────────────
function HomeWatchSection({homeWatch={},onChange}){
  const T=useTheme();
  const f=(k,v)=>onChange({...homeWatch,[k]:v});
  const tasks=homeWatch.tasks||[];
  const contacts=homeWatch.contacts||[];
  const mail=homeWatch.mailHold||{};

  const addTask=()=>f("tasks",[...tasks,{id:uid(),text:"",freq:"weekly",lastDone:"",assignee:"",done:false}]);
  const updTask=(id,k,v)=>f("tasks",tasks.map(t=>t.id===id?{...t,[k]:v}:t));
  const delTask=(id)=>f("tasks",tasks.filter(t=>t.id!==id));
  const addContact=()=>f("contacts",[...contacts,{id:uid(),name:"",role:"",phone:"",email:"",notes:""}]);
  const updContact=(id,k,v)=>f("contacts",contacts.map(c=>c.id===id?{...c,[k]:v}:c));
  const delContact=(id)=>f("contacts",contacts.filter(c=>c.id!==id));

  return(
    <div>
      <SecHead icon="🏠" title="Home Watch & Mail" sub="Manage everything happening at home while you're on the road"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16}}>
        {/* Mail hold */}
        <Card>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>✉️ Mail Hold / Forward</div>
          <div style={{display:"grid",gap:10}}>
            <div><Label>Hold Start Date</Label><Inp type="date" value={mail.startDate||""} onChange={e=>f("mailHold",{...mail,startDate:e.target.value})}/></div>
            <div><Label>Hold End Date</Label><Inp type="date" value={mail.endDate||""} onChange={e=>f("mailHold",{...mail,endDate:e.target.value})}/></div>
            <div><Label>USPS Confirmation #</Label><Inp value={mail.confirmationNum||""} onChange={e=>f("mailHold",{...mail,confirmationNum:e.target.value})} placeholder="Confirmation number"/></div>
            <div><Label>Forward Address (if any)</Label><Inp value={mail.forwardAddress||""} onChange={e=>f("mailHold",{...mail,forwardAddress:e.target.value})} placeholder="e.g. 123 RV Park Rd, Tucson AZ"/></div>
          </div>
          {mail.startDate&&mail.endDate&&(
            <div style={{marginTop:10,padding:"8px 12px",background:T.free+"11",borderRadius:8,fontSize:12,color:T.free,fontWeight:600}}>
              ✓ Hold for {Math.ceil((new Date(mail.endDate)-new Date(mail.startDate))/(1000*60*60*24))} days
            </div>
          )}
        </Card>
        {/* Home watch contacts */}
        <Card>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>👤 Home Watchers</div>
            <button onClick={addContact} style={{padding:"4px 10px",background:T.accent,color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>+ Add</button>
          </div>
          {contacts.map(c=>(
            <div key={c.id} style={{marginBottom:10,padding:10,background:T.bgLite,borderRadius:8,border:`1px solid ${T.border}`}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:6}}>
                <Inp value={c.name||""} onChange={e=>updContact(c.id,"name",e.target.value)} placeholder="Name" style={{fontSize:12,padding:"5px 8px"}}/>
                <Inp value={c.role||""} onChange={e=>updContact(c.id,"role",e.target.value)} placeholder="Role (neighbor, family)" style={{fontSize:12,padding:"5px 8px"}}/>
                <Inp value={c.phone||""} onChange={e=>updContact(c.id,"phone",e.target.value)} placeholder="Phone" style={{fontSize:12,padding:"5px 8px"}}/>
                <Inp value={c.email||""} onChange={e=>updContact(c.id,"email",e.target.value)} placeholder="Email" style={{fontSize:12,padding:"5px 8px"}}/>
              </div>
              <div style={{display:"flex",gap:8}}>
                <Inp value={c.notes||""} onChange={e=>updContact(c.id,"notes",e.target.value)} placeholder="Notes (key location, alarm code, etc)" style={{flex:1,fontSize:12,padding:"5px 8px"}}/>
                <button onClick={()=>delContact(c.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,flexShrink:0}}>✕</button>
              </div>
            </div>
          ))}
          {contacts.length===0&&<div style={{textAlign:"center",padding:16,color:T.muted,fontSize:12}}>Add neighbors, family, or property managers watching your home.</div>}
        </Card>
        {/* Home tasks */}
        <Card style={{gridColumn:"1/-1"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>✅ Home Tasks While Away</div>
            <button onClick={addTask} style={{padding:"4px 10px",background:T.accent,color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>+ Add Task</button>
          </div>
          {tasks.map(t=>(
            <div key={t.id} style={{display:"flex",gap:10,alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${T.border}44`,flexWrap:"wrap"}}>
              <input type="checkbox" checked={t.done||false} onChange={e=>updTask(t.id,"done",e.target.checked)} style={{width:18,height:18,cursor:"pointer",flexShrink:0}}/>
              <Inp value={t.text||""} onChange={e=>updTask(t.id,"text",e.target.value)} placeholder="e.g. Water plants, check mail, run HVAC" style={{flex:1,minWidth:140,fontSize:12,padding:"5px 8px",textDecoration:t.done?"line-through":""}}/>
              <Sel value={t.freq||"weekly"} onChange={e=>updTask(t.id,"freq",e.target.value)} style={{width:100,padding:"5px 8px",fontSize:11}}>
                {["once","daily","weekly","biweekly","monthly"].map(f=><option key={f} value={f}>{f}</option>)}
              </Sel>
              <Inp value={t.assignee||""} onChange={e=>updTask(t.id,"assignee",e.target.value)} placeholder="Who?" style={{width:100,fontSize:12,padding:"5px 8px"}}/>
              <button onClick={()=>delTask(t.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,flexShrink:0}}>✕</button>
            </div>
          ))}
          {tasks.length===0&&<div style={{textAlign:"center",padding:16,color:T.muted,fontSize:12}}>Add recurring tasks — watering plants, checking on pets, running the AC, etc.</div>}
          <div style={{marginTop:12}}><Label>Notes</Label><Inp value={homeWatch.notes||""} onChange={e=>f("notes",e.target.value)} placeholder="Alarm codes, utility shut-offs, emergency info for home watchers..."/></div>
        </Card>
      </div>
    </div>
  );
}

// ── MedicationTracker ──────────────────────────────────────────────
function MedicationSection({medications=[],onChange,stops=[]}){
  const T=useTheme();
  const addMed=()=>onChange([...medications,{id:uid(),name:"",dosage:"",frequency:"daily",times:[],prescriber:"",pharmacy:"",rxNumber:"",refillDate:"",notes:"",controlled:false}]);
  const updMed=(id,k,v)=>onChange(medications.map(m=>m.id===id?{...m,[k]:v}:m));
  const delMed=(id)=>onChange(medications.filter(m=>m.id!==id));

  const nearbyPharmacies=stops.filter(s=>s.name&&s.type!=="home").slice(0,3);

  return(
    <div>
      <SecHead icon="💊" title="Medication Tracker" sub="Keep track of medications, dosages, and refill dates while traveling across time zones"/>
      <div style={{background:"#3b82f611",border:"1px solid #3b82f633",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#3b82f6",lineHeight:1.6}}>
        🔒 Medication information is stored only on this device and never transmitted or shared.
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontSize:13,color:T.muted}}>{medications.length} medication{medications.length!==1?"s":""} tracked</div>
        <button onClick={addMed} style={{padding:"8px 16px",background:T.accent,color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>+ Add Medication</button>
      </div>
      {medications.length===0&&<Card><div style={{textAlign:"center",padding:32,color:T.muted}}>
        <div style={{fontSize:48,marginBottom:12}}>💊</div>
        <div style={{fontSize:15,fontWeight:700,marginBottom:8}}>No medications tracked</div>
        <div style={{fontSize:13,marginBottom:20}}>Track medications, dosage schedules, and refill dates — especially important when crossing time zones.</div>
        <button onClick={addMed} style={{padding:"10px 24px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,cursor:"pointer"}}>+ Add Medication</button>
      </div></Card>}
      <div style={{display:"grid",gap:12}}>
        {medications.map(m=>{
          const refillDt=m.refillDate?new Date(m.refillDate+"T00:00:00"):null;
          const daysToRefill=refillDt?Math.ceil((refillDt-new Date())/(1000*60*60*24)):null;
          const refillWarn=daysToRefill!==null&&daysToRefill<=14;
          return(
            <Card key={m.id} accent={refillWarn?T.danger:undefined}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12,gap:8}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:16,fontWeight:800,color:T.text}}>{m.name||"New Medication"}</div>
                  {m.dosage&&<div style={{fontSize:12,color:T.muted}}>{m.dosage} · {m.frequency}</div>}
                  {refillWarn&&<div style={{fontSize:11,color:T.danger,fontWeight:700,marginTop:3}}>⚠ Refill needed in {daysToRefill<=0?"OVERDUE — refill now":`${daysToRefill} days`}</div>}
                </div>
                <button onClick={()=>delMed(m.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,flexShrink:0}}>✕</button>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:8}}>
                <div><Label>Medication Name</Label><Inp value={m.name||""} onChange={e=>updMed(m.id,"name",e.target.value)} placeholder="e.g. Metformin"/></div>
                <div><Label>Dosage</Label><Inp value={m.dosage||""} onChange={e=>updMed(m.id,"dosage",e.target.value)} placeholder="e.g. 500mg"/></div>
                <div><Label>Frequency</Label><Sel value={m.frequency||"daily"} onChange={e=>updMed(m.id,"frequency",e.target.value)}>
                  {["once daily","twice daily","3x daily","4x daily","weekly","as needed","other"].map(f=><option key={f}>{f}</option>)}
                </Sel></div>
                <div><Label>Refill Date</Label><Inp type="date" value={m.refillDate||""} onChange={e=>updMed(m.id,"refillDate",e.target.value)}/></div>
                <div><Label>Prescribing Doctor</Label><Inp value={m.prescriber||""} onChange={e=>updMed(m.id,"prescriber",e.target.value)} placeholder="Dr. Smith · 555-1234"/></div>
                <div><Label>Pharmacy / Rx #</Label><Inp value={m.pharmacy||""} onChange={e=>updMed(m.id,"pharmacy",e.target.value)} placeholder="CVS · Rx# 12345"/></div>
                <div style={{gridColumn:"1/-1"}}><Label>Notes</Label><Inp value={m.notes||""} onChange={e=>updMed(m.id,"notes",e.target.value)} placeholder="Take with food, refrigerate, time zone adjustments..."/></div>
              </div>
            </Card>
          );
        })}
      </div>
      {/* Time zone reminder */}
      {medications.filter(m=>m.frequency&&m.frequency.includes("daily")).length>0&&(
        <Card style={{marginTop:16}} accent="#f59e0b">
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:"#f59e0b",textTransform:"uppercase",letterSpacing:.5,marginBottom:6}}>⏰ Time Zone Reminder</div>
          <div style={{fontSize:13,color:T.text,lineHeight:1.6}}>When crossing time zones, adjust medication times gradually — 30 minutes per day toward the new local time — unless your doctor advises otherwise. Keep medications in their original labeled containers when traveling.</div>
        </Card>
      )}
    </div>
  );
}

// ── TirePressureLog ────────────────────────────────────────────────
function TirePressureSection({tirePressure={},onChange,vehicle={},stops=[],weather={}}){
  const T=useTheme();
  const f=(k,v)=>onChange({...tirePressure,[k]:v});
  const isTrailer=["Fifth Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer"].includes(vehicle.rvType);
  const hasDuals=["Class A Motorhome","Class C Motorhome","Fifth Wheel"].includes(vehicle.rvType);

  const front=parseFloat(tirePressure.frontPsi)||0;
  const rear=parseFloat(tirePressure.rearPsi)||0;
  const targetF=parseFloat(tirePressure.targetFront)||0;
  const targetR=parseFloat(tirePressure.targetRear)||0;

  // Temperature correction: ~1 PSI per 10°F change from 70°F baseline
  const tempCorrect=(psi,tempF)=>{
    if(!psi||!tempF) return null;
    const delta=Math.round((tempF-70)/10);
    return psi+delta;
  };

  const PsiField=({label,field,target,hint})=>{
    const val=parseFloat(tirePressure[field])||0;
    const tgt=parseFloat(target)||0;
    const low=tgt&&val<tgt-4;
    const high=tgt&&val>tgt+4;
    return(
      <div>
        <Label>{label}</Label>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          <Inp type="number" min={0} max={200} value={tirePressure[field]||""} onChange={e=>f(field,e.target.value)} placeholder="PSI" style={{flex:1}}/>
          <span style={{fontSize:11,color:low?T.danger:high?"#f59e0b":T.free,fontWeight:700,flexShrink:0,width:40,textAlign:"center"}}>
            {val?low?"LOW":high?"HIGH":"OK":""}
          </span>
        </div>
        {hint&&<div style={{fontSize:10,color:T.muted,marginTop:2}}>{hint}</div>}
      </div>
    );
  };

  return(
    <div>
      <SecHead icon="🛞" title="Tire Pressure Log" sub="Track tire pressures, get temperature correction reminders, and log checks at each stop"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16}}>
        {/* Target pressures */}
        <Card>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>📋 Target Pressures (Cold)</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:12,lineHeight:1.5}}>Enter recommended cold-inflation pressures from your door placard or owner's manual.</div>
          <div style={{display:"grid",gap:10}}>
            <div><Label>Front / Steer Axle Target (PSI)</Label><Inp type="number" value={tirePressure.targetFront||""} onChange={e=>f("targetFront",e.target.value)} placeholder="e.g. 110"/></div>
            <div><Label>Rear / Drive Axle Target (PSI)</Label><Inp type="number" value={tirePressure.targetRear||""} onChange={e=>f("targetRear",e.target.value)} placeholder="e.g. 110"/></div>
            {isTrailer&&<div><Label>Trailer Tire Target (PSI)</Label><Inp type="number" value={tirePressure.trailerTarget||""} onChange={e=>f("trailerTarget",e.target.value)} placeholder="e.g. 65"/></div>}
            <div><Label>Spare Target (PSI)</Label><Inp type="number" value={tirePressure.sparePsi||""} onChange={e=>f("sparePsi",e.target.value)} placeholder="e.g. 110"/></div>
          </div>
        </Card>
        {/* Current pressures */}
        <Card>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>⚖️ Current Readings</div>
          <div style={{display:"grid",gap:10}}>
            <PsiField label="Front Left (PSI)" field="frontPsi" target={tirePressure.targetFront}/>
            {hasDuals&&<PsiField label="Front Right (PSI)" field="frontRightPsi" target={tirePressure.targetFront}/>}
            <PsiField label="Rear (or Rear Left) PSI" field="rearPsi" target={tirePressure.targetRear}/>
            {hasDuals&&<PsiField label="Rear Right (PSI)" field="rearRightPsi" target={tirePressure.targetRear}/>}
            {hasDuals&&<PsiField label="Rear Inner Left (PSI)" field="rearInnerPsi" target={tirePressure.targetRear}/>}
            {hasDuals&&<PsiField label="Rear Inner Right (PSI)" field="rearInnerRightPsi" target={tirePressure.targetRear}/>}
            {isTrailer&&<PsiField label="Trailer (PSI)" field="trailerPsi" target={tirePressure.trailerTarget}/>}
            <div><Label>Checked Date</Label><Inp type="date" value={tirePressure.lastCheckDate||""} onChange={e=>f("lastCheckDate",e.target.value)}/></div>
            <div><Label>Odometer at Check</Label><Inp type="number" value={tirePressure.lastCheckOdometer||""} onChange={e=>f("lastCheckOdometer",e.target.value)} placeholder="Miles"/></div>
            <div><Label>Notes</Label><Inp value={tirePressure.notes||""} onChange={e=>f("notes",e.target.value)} placeholder="Gauge used, location, any issues..."/></div>
          </div>
        </Card>
        {/* Temp correction card */}
        <Card style={{gridColumn:"1/-1"}} accent="#f59e0b">
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#f59e0b",textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>🌡 Temperature Correction</div>
          <div style={{fontSize:12,color:T.text,lineHeight:1.7,marginBottom:10}}>
            Tire pressure changes approximately <strong>1 PSI for every 10°F</strong> change in temperature. Always check pressure when tires are cold (not driven in 3+ hours). If outside temp changes significantly from where you last checked, adjust accordingly.
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:10}}>
            {[0,20,32,50,70,90,100,110].map(temp=>{
              const correctedF=targetF?tempCorrect(targetF,temp):null;
              const correctedR=targetR?tempCorrect(targetR,temp):null;
              return(
                <div key={temp} style={{background:temp===70?T.accent+"22":T.bgLite,border:`1px solid ${temp===70?T.accent+"44":T.border}`,borderRadius:8,padding:"8px 10px",textAlign:"center"}}>
                  <div style={{fontSize:11,color:T.muted,marginBottom:2}}>{temp}°F {temp===70?"(baseline)":temp<32?"❄️":temp>90?"☀️":""}</div>
                  {correctedF&&<div style={{fontSize:12,fontWeight:700,color:T.accent}}>F: {correctedF} PSI</div>}
                  {correctedR&&<div style={{fontSize:12,fontWeight:700,color:T.accentAlt}}>R: {correctedR} PSI</div>}
                  {!correctedF&&!correctedR&&<div style={{fontSize:11,color:T.muted}}>Set targets →</div>}
                </div>
              );
            })}
          </div>
        </Card>
      </div>
    </div>
  );
}

// ── FuelCards ──────────────────────────────────────────────────────
const FUEL_CARD_PROGRAMS=[
  {id:"goodsam",name:"Good Sam Fuel",icon:"⭐",network:"Pilot/Flying J/Love's",disc:"$0.05-0.08/gal",url:"https://www.goodsam.com/fuel-savings/"},
  {id:"pilot",name:"Pilot Flying J myRewards+",icon:"✈️",network:"Pilot/Flying J",disc:"Points + fuel discounts",url:"https://mypilot.com/"},
  {id:"loves",name:"Love's Connect",icon:"❤️",network:"Love's Travel Stops",disc:"Points + showers",url:"https://www.loves.com/en/loyalty"},
  {id:"fleetcard",name:"EFS / Fleetcard",icon:"💳",network:"Multi-network",disc:"Fleet pricing",url:"https://www.efsllc.com/"},
  {id:"wexcard",name:"WEX Fleet Card",icon:"🔵",network:"Multi-network",disc:"Fleet pricing",url:"https://www.wexinc.com/"},
  {id:"mudflap",name:"Mudflap",icon:"🚛",network:"Independent/Flying J",disc:"Real-time price lock",url:"https://www.mudflap.com/"},
  {id:"gasbuddy",name:"GasBuddy Pay",icon:"⛽",network:"Nationwide",disc:"Up to $0.25/gal",url:"https://www.gasbuddy.com/"},
  {id:"upside",name:"GetUpside",icon:"📱",network:"Nationwide",disc:"Cashback on fuel",url:"https://upside.com/"},
  {id:"colonialcoin",name:"Colonial Coin",icon:"🏅",network:"Pilot/Flying J",disc:"Member discounts",url:"https://colonialcoin.com/"},
  {id:"samsclub",name:"Sam's Club Plus",icon:"🔵",network:"Sam's Club stations",disc:"$0.05/gal off",url:"https://www.samsclub.com/"},
];

function FuelCardsSection({fuelCards=[],onChange}){
  const T=useTheme();
  const toggleCard=(id)=>{
    const existing=fuelCards.find(c=>c.id===id);
    if(existing){
      onChange(fuelCards.map(c=>c.id===id?{...c,active:!c.active}:c));
    } else {
      const prog=FUEL_CARD_PROGRAMS.find(p=>p.id===id);
      onChange([...fuelCards,{...prog,active:true,cardNumber:"",memberNumber:"",notes:"",totalSaved:0}]);
    }
  };
  const updCard=(id,k,v)=>onChange(fuelCards.map(c=>c.id===id?{...c,[k]:v}:c));
  const activeCards=fuelCards.filter(c=>c.active);
  const totalSaved=fuelCards.reduce((s,c)=>s+(parseFloat(c.totalSaved)||0),0);

  return(
    <div>
      <SecHead icon="💳" title="Fuel Cards & Discount Programs" sub="Track your fuel savings programs and estimate trip savings"/>
      {totalSaved>0&&<Card style={{marginBottom:16}} accent={T.free}>
        <div style={{display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
          <div><div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Total Fuel Savings Tracked</div><div style={{fontSize:28,fontWeight:900,color:T.free}}>${totalSaved.toFixed(2)}</div></div>
          <div style={{fontSize:13,color:T.muted,flex:1}}>Across {activeCards.length} active program{activeCards.length!==1?"s":""}. Keep logging savings after each fill-up to track your real discount over time.</div>
        </div>
      </Card>}
      <div style={{marginBottom:16}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Available Programs</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:10}}>
          {FUEL_CARD_PROGRAMS.map(prog=>{
            const card=fuelCards.find(c=>c.id===prog.id);
            const active=card?.active||false;
            return(
              <div key={prog.id} style={{padding:"10px 14px",borderRadius:10,border:`2px solid ${active?T.accent:T.border}`,background:active?T.accent+"0d":T.bgMid,cursor:"pointer",transition:"all .15s"}}
                onClick={()=>toggleCard(prog.id)}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:active?8:0}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:active?T.accent:T.text,display:"flex",alignItems:"center",gap:6}}>{prog.icon} {prog.name}</div>
                    <div style={{fontSize:11,color:T.muted,marginTop:2}}>{prog.network}</div>
                    <div style={{fontSize:11,color:T.free,fontWeight:600,marginTop:1}}>{prog.disc}</div>
                  </div>
                  <div style={{width:22,height:22,borderRadius:"50%",border:`2px solid ${active?T.accent:T.border}`,background:active?T.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    {active&&<span style={{fontSize:12,color:"#fff",fontWeight:900}}>✓</span>}
                  </div>
                </div>
                {active&&card&&<div onClick={e=>e.stopPropagation()} style={{display:"grid",gap:6,marginTop:4}}>
                  <Inp value={card.cardNumber||""} onChange={e=>updCard(prog.id,"cardNumber",e.target.value)} placeholder="Card / Member number" style={{fontSize:11,padding:"5px 8px"}}/>
                  <div style={{display:"flex",gap:6}}>
                    <Inp type="number" value={card.totalSaved||""} onChange={e=>updCard(prog.id,"totalSaved",e.target.value)} placeholder="$ saved so far" style={{flex:1,fontSize:11,padding:"5px 8px"}}/>
                    <a href={prog.url} target="_blank" rel="noopener noreferrer" style={{padding:"5px 10px",background:T.accent+"22",border:`1px solid ${T.accent}44`,borderRadius:6,color:T.accent,fontSize:11,fontWeight:700,textDecoration:"none",whiteSpace:"nowrap",display:"flex",alignItems:"center"}}>Open →</a>
                  </div>
                </div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── EmergencyResponseCard ──────────────────────────────────────────
// (Enhances existing EmergencySection with a printable response card)
function EmergencyResponseCard({emergency={},vehicle={},stops=[]}){
  const T=useTheme();

  const printCard=()=>{
    const currentStop=stops.find(s=>s.type!=="home"&&s.active&&s.name)||null;
    const html=`<!DOCTYPE html><html><head><title>Emergency Response Card</title>
    <style>body{font-family:Arial,sans-serif;max-width:400px;margin:20px auto;font-size:12px;color:#1a1a2e}
    .header{background:#dc2626;color:#fff;padding:12px;border-radius:8px 8px 0 0;text-align:center}
    .header h1{font-size:18px;margin:0}
    .section{border:1px solid #e2e8f0;border-top:none;padding:10px 12px}
    .section h2{font-size:11px;text-transform:uppercase;letter-spacing:1px;color:#64748b;margin:0 0 6px}
    .row{display:flex;justify-content:space-between;margin-bottom:4px}
    .label{color:#64748b;font-size:11px}.value{font-weight:700;font-size:12px}
    .location{background:#fef9c3;border:1px solid #fde047;padding:8px;margin-top:8px;border-radius:6px;font-size:11px}
    @media print{button{display:none}}</style></head><body>
    <div class="header"><h1>🆘 Emergency Response Card</h1><div style="font-size:11px;opacity:.9">RV Travel Mate · ${new Date().toLocaleDateString()}</div></div>
    <div class="section"><h2>Vehicle</h2>
    <div class="row"><span class="label">RV Type</span><span class="value">${vehicle.rvType||"—"}</span></div>
    <div class="row"><span class="label">VIN</span><span class="value">${emergency.vin||"—"}</span></div>
    <div class="row"><span class="label">Plate</span><span class="value">${emergency.plate||"—"} ${emergency.plateState||""}</span></div>
    </div>
    ${(emergency.contacts||[]).length>0?`<div class="section"><h2>Emergency Contacts</h2>
    ${emergency.contacts.map(c=>`<div class="row"><span class="label">${c.name||""} ${c.relationship?`(${c.relationship})`:""}</span><span class="value">${c.phone||"—"}</span></div>`).join("")}
    </div>`:""}
    ${(emergency.roadside||[]).length>0?`<div class="section"><h2>Roadside Assistance</h2>
    ${emergency.roadside.map(r=>`<div class="row"><span class="label">${r.provider||""}</span><span class="value">${r.phone||"—"}</span></div><div style="font-size:10px;color:#64748b">Policy: ${r.policyNumber||"—"}</div>`).join("")}
    </div>`:""}
    ${(emergency.insurance||[]).length>0?`<div class="section"><h2>Insurance</h2>
    ${emergency.insurance.map(i=>`<div class="row"><span class="label">${i.company||""}</span><span class="value">${i.phone||"—"}</span></div><div style="font-size:10px;color:#64748b">Policy: ${i.policyNumber||"—"}</div>`).join("")}
    </div>`:""}
    ${currentStop?`<div class="location">📍 Current Location: <strong>${currentStop.name||""}</strong>${currentStop.state?", "+currentStop.state:""}</div>`:""}
    <div class="section" style="border-radius:0 0 8px 8px"><div style="font-size:10px;color:#94a3b8;text-align:center">Keep this card in your glove box and share with family before departing.</div></div>
    <script>window.onload=()=>window.print();</script></body></html>`;
    const w=window.open("","_blank","width=500,height=700");
    if(w){w.document.write(html);w.document.close();}
  };

  return(
    <Card style={{marginTop:16}} accent={T.danger}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.danger,textTransform:"uppercase",letterSpacing:1,marginBottom:4}}>🆘 Emergency Response Card</div>
          <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>Generate a printable emergency card with your contacts, insurance, roadside assistance, and current location. Keep one in your glove box.</div>
        </div>
        <button onClick={printCard} style={{padding:"10px 20px",background:T.danger,color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer",flexShrink:0}}>🖨 Print Card</button>
      </div>
    </Card>
  );
}

// ── AITripNarrative ────────────────────────────────────────────────
function AITripNarrativeCard({stops=[],callAI,aiPurchased,aiFreeCalls,onShowAIUpgrade}){
  const T=useTheme();
  const [narrative,setNarrative]=useState("");
  const [loading,setLoading]=useState(false);
  const [copied,setCopied]=useState(false);

  const generate=async()=>{
    if(!callAI) return;
    const canUse=aiPurchased||(aiFreeCalls>0);
    if(!canUse){onShowAIUpgrade&&onShowAIUpgrade();return;}
    setLoading(true);
    const namedStops=stops.filter(s=>s.name&&s.active&&s.type!=="home");
    const homeStop=stops.find(s=>s.type==="home");
    const stopList=namedStops.map((s,i)=>`${i+1}. ${s.name}${s.state?", "+s.state:""} (${s.nights||s.minNights||"?"} nights)`).join(", ");
    const prompt=`Write a warm, engaging travel narrative for an RV trip. Starting point: ${homeStop?.homeCity||homeStop?.name||"home"}. Stops: ${stopList}. Write 2-3 paragraphs in first-person past tense, like a travel blog entry. Mention the destinations naturally. Keep it friendly and relatable for retiree RVers. About 150-200 words.`;
    const result=await callAI(prompt,"You are a travel writer specializing in RV and road trip stories. Write warmly and authentically.");
    setNarrative(result||"");
    setLoading(false);
  };

  const copy=()=>{
    navigator.clipboard.writeText(narrative).then(()=>{setCopied(true);setTimeout(()=>setCopied(false),2000);});
  };

  return(
    <Card style={{marginTop:16}} accent="#7c3aed">
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#7c3aed",textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>✨ AI Trip Narrative</div>
      <div style={{fontSize:12,color:T.muted,lineHeight:1.5,marginBottom:12}}>Generate a shareable travel story from your trip stops — perfect for family emails, a travel blog, or a keepsake printout.</div>
      {!narrative&&<button onClick={generate} disabled={loading} style={{width:"100%",padding:"10px",background:"#7c3aed",color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:loading?"not-allowed":"pointer"}}>
        {loading?"✍️ Writing your story...":"✨ Generate Trip Story"}
      </button>}
      {narrative&&<>
        <div style={{background:T.bgLite,borderRadius:10,padding:"14px 16px",fontSize:13,color:T.text,lineHeight:1.8,marginBottom:10,fontStyle:"italic",whiteSpace:"pre-wrap"}}>{narrative}</div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={copy} style={{flex:1,padding:"8px",background:copied?T.free:"#7c3aed",color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:12,cursor:"pointer"}}>{copied?"✓ Copied!":"📋 Copy Story"}</button>
          <button onClick={()=>setNarrative("")} style={{flex:1,padding:"8px",background:"none",border:`1px solid ${T.border}`,borderRadius:8,fontWeight:700,fontSize:12,cursor:"pointer",color:T.muted}}>🔄 Regenerate</button>
        </div>
      </>}
    </Card>
  );
}


// ── PetSection ─────────────────────────────────────────────────────
const PET_TYPES=["Dog","Cat","Bird","Fish","Rabbit","Hamster/Guinea Pig","Reptile","Other"];
const mkPet=()=>({id:uid(),name:"",type:"Dog",breed:"",age:"",weight:"",color:"",microchipId:"",
  vetName:"",vetPhone:"",vetCity:"",emergencyVet:"",
  vaccinations:[],medications:[],
  dietNotes:"",allergies:"",specialNeeds:"",
  lastPottyStop:"",pottyIntervalHrs:3,
  rabiesExpiry:"",dhppExpiry:"",bordettellaExpiry:"",
  notes:""});
const mkVaccine=()=>({id:uid(),name:"",date:"",expiry:"",vet:""});
const mkPetMed=()=>({id:uid(),name:"",dosage:"",frequency:"daily",refillDate:"",notes:""});

function PetSection({pets=[],onChange,stops=[]}){
  const T=useTheme();
  const [selId,setSelId]=useState(pets[0]?.id||null);
  const [tab,setTab]=useState("profile");
  const [addingVax,setAddingVax]=useState(false);
  const [addingMed,setAddingMed]=useState(false);
  const [newVax,setNewVax]=useState(mkVaccine());
  const [newMed,setNewMed]=useState(mkPetMed());
  const sel=pets.find(p=>p.id===selId)||null;

  const addPet=()=>{const p=mkPet();onChange([...pets,p]);setSelId(p.id);setTab("profile");};
  const upd=(k,v)=>{if(!sel)return;onChange(pets.map(p=>p.id===sel.id?{...p,[k]:v}:p));};
  const delPet=(id)=>{const n=pets.filter(p=>p.id!==id);onChange(n);setSelId(n[0]?.id||null);};

  // Last potty stop timer
  const logPottyStop=()=>{upd("lastPottyStop",new Date().toISOString());};
  const lastStop=sel?.lastPottyStop?new Date(sel.lastPottyStop):null;
  const minsAgo=lastStop?Math.floor((Date.now()-lastStop)/60000):null;
  const hrsAgo=minsAgo!==null?minsAgo/60:null;
  const interval=parseFloat(sel?.pottyIntervalHrs)||3;
  const pottyDue=hrsAgo!==null&&hrsAgo>=interval;
  const pottySoon=hrsAgo!==null&&!pottyDue&&hrsAgo>=(interval-0.5);

  const petEmoji=(type)=>({Dog:"🐕",Cat:"🐱",Bird:"🐦",Fish:"🐟",Rabbit:"🐰"}[type]||"🐾");

  return(
    <div>
      <SecHead icon="🐾" title="Travel Companions" sub="Keep your pets safe and healthy on the road — vet info, vaccinations, medications, and potty break reminders"/>
      <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        {pets.map(p=>(
          <button key={p.id} onClick={()=>setSelId(p.id)}
            style={{padding:"7px 16px",borderRadius:10,border:`2px solid ${p.id===selId?T.accent:T.border}`,
              background:p.id===selId?T.accent+"18":T.bgLite,color:p.id===selId?T.accent:T.text,fontWeight:700,fontSize:13,cursor:"pointer"}}>
            {petEmoji(p.type)} {p.name||"New Pet"}
          </button>
        ))}
        <button onClick={addPet} style={{padding:"7px 14px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer"}}>+ Add Pet</button>
      </div>

      {!sel&&<Card><div style={{textAlign:"center",padding:32,color:T.muted}}>
        <div style={{fontSize:48,marginBottom:12}}>🐾</div>
        <div style={{fontSize:16,fontWeight:700,marginBottom:8}}>No pets added yet</div>
        <div style={{fontSize:13,marginBottom:20}}>Add your travel companions to track their health info, vet contacts, vaccinations, and get potty break reminders on the road.</div>
        <button onClick={addPet} style={{padding:"10px 24px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,cursor:"pointer"}}>+ Add Your Pet</button>
      </div></Card>}

      {sel&&<>
        {/* Potty break reminder — always at top */}
        <Card style={{marginBottom:12,background:pottyDue?T.danger+"11":pottySoon?"#f59e0b11":T.accent+"0a"}} accent={pottyDue?T.danger:pottySoon?"#f59e0b":T.accent}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:pottyDue?T.danger:pottySoon?"#f59e0b":T.accent,textTransform:"uppercase",letterSpacing:.5,marginBottom:3}}>
                {pottyDue?"🚨 Potty Break OVERDUE":pottySoon?"⚠️ Potty Break Due Soon":"🐾 Potty Break Tracker"}
              </div>
              {lastStop?(
                <div style={{fontSize:12,color:T.muted}}>
                  Last stop: {minsAgo<60?`${minsAgo} min ago`:`${Math.floor(hrsAgo)}h ${minsAgo%60}m ago`}
                  {" · "} Interval: every {interval}h
                  {pottyDue&&<span style={{color:T.danger,fontWeight:700}}>{" · "}{sel.name||"Your pet"} needs to go!</span>}
                </div>
              ):(
                <div style={{fontSize:12,color:T.muted}}>Tap to log first stop of the day</div>
              )}
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{fontSize:12,color:T.muted}}>Every</span>
                <Inp type="number" min={0.5} max={12} step={0.5} value={sel.pottyIntervalHrs||3} onChange={e=>upd("pottyIntervalHrs",e.target.value)} style={{width:50,textAlign:"center",padding:"4px 6px",fontSize:12}}/>
                <span style={{fontSize:12,color:T.muted}}>hrs</span>
              </div>
              <button onClick={logPottyStop} style={{padding:"8px 16px",background:pottyDue?T.danger:T.accent,color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:12,cursor:"pointer"}}>🐾 Log Stop</button>
            </div>
          </div>
        </Card>

        {/* Sub-tabs */}
        <div style={{display:"flex",gap:4,marginBottom:12,overflowX:"auto",scrollbarWidth:"none",paddingBottom:2}}>
          {[["profile","👤 Profile"],["health","💉 Health"],["meds","💊 Meds"],["nearby","📍 Nearby"]].map(([id,label])=>(
            <button key={id} onClick={()=>setTab(id)} style={{padding:"6px 14px",borderRadius:8,border:`1px solid ${tab===id?T.accent:T.border}`,background:tab===id?T.accent+"18":"none",color:tab===id?T.accent:T.muted,fontSize:12,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap",flexShrink:0}}>
              {label}
            </button>
          ))}
          <button onClick={()=>delPet(sel.id)} style={{marginLeft:"auto",padding:"6px 10px",background:"none",border:`1px solid ${T.danger}44`,borderRadius:8,color:T.danger,fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0}}>🗑 Remove</button>
        </div>

        {tab==="profile"&&<Card>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10}}>
            <div><Label>Pet Name</Label><Inp value={sel.name||""} onChange={e=>upd("name",e.target.value)} placeholder="e.g. Buddy"/></div>
            <div><Label>Type</Label><Sel value={sel.type||"Dog"} onChange={e=>upd("type",e.target.value)}>{PET_TYPES.map(t=><option key={t}>{t}</option>)}</Sel></div>
            <div><Label>Breed</Label><Inp value={sel.breed||""} onChange={e=>upd("breed",e.target.value)} placeholder="e.g. Golden Retriever"/></div>
            <div><Label>Age</Label><Inp value={sel.age||""} onChange={e=>upd("age",e.target.value)} placeholder="e.g. 3 years"/></div>
            <div><Label>Weight (lbs)</Label><Inp type="number" value={sel.weight||""} onChange={e=>upd("weight",e.target.value)} placeholder="e.g. 65"/></div>
            <div><Label>Color / Markings</Label><Inp value={sel.color||""} onChange={e=>upd("color",e.target.value)} placeholder="e.g. Golden"/></div>
            <div><Label>Microchip ID</Label><Inp value={sel.microchipId||""} onChange={e=>upd("microchipId",e.target.value)} placeholder="Chip number"/></div>
            <div style={{gridColumn:"1/-1"}}><div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:.5,marginBottom:8,marginTop:4}}>🏥 Vet Information</div></div>
            <div><Label>Primary Vet</Label><Inp value={sel.vetName||""} onChange={e=>upd("vetName",e.target.value)} placeholder="Dr. Smith Animal Clinic"/></div>
            <div><Label>Vet Phone</Label><Inp value={sel.vetPhone||""} onChange={e=>upd("vetPhone",e.target.value)} placeholder="555-1234"/></div>
            <div><Label>Vet City</Label><Inp value={sel.vetCity||""} onChange={e=>upd("vetCity",e.target.value)} placeholder="Foley, AL"/></div>
            <div><Label>Emergency Vet (travel)</Label><Inp value={sel.emergencyVet||""} onChange={e=>upd("emergencyVet",e.target.value)} placeholder="24hr emergency clinic name/number"/></div>
            <div style={{gridColumn:"1/-1"}}><Label>Diet & Allergies</Label><Inp value={sel.dietNotes||""} onChange={e=>upd("dietNotes",e.target.value)} placeholder="Food brand, portions, allergies, restrictions..."/></div>
            <div style={{gridColumn:"1/-1"}}><Label>Special Needs / Notes</Label><Inp value={sel.specialNeeds||""} onChange={e=>upd("specialNeeds",e.target.value)} placeholder="Anxiety, mobility issues, temperature sensitivity..."/></div>
          </div>
        </Card>}

        {tab==="health"&&<Card>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>💉 Vaccinations</div>
          {/* Quick expiry check */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10,marginBottom:14}}>
            {[{l:"Rabies Expiry",k:"rabiesExpiry"},{l:"DHPP/FVRCP Expiry",k:"dhppExpiry"},{l:"Bordetella Expiry",k:"bordettellaExpiry"}].map(({l,k})=>{
              const dt=sel[k]?new Date(sel[k]+"T00:00:00"):null;
              const days=dt?Math.ceil((dt-new Date())/(1000*60*60*24)):null;
              const warn=days!==null&&days<60;
              return<div key={k}>
                <Label>{l}</Label>
                <Inp type="date" value={sel[k]||""} onChange={e=>upd(k,e.target.value)}/>
                {warn&&days!==null&&<div style={{fontSize:10,color:days<0?T.danger:"#f59e0b",fontWeight:700,marginTop:2}}>{days<0?"EXPIRED":"Expires in "+days+" days"}</div>}
              </div>;
            })}
          </div>
          {/* Custom vaccine log */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div style={{fontSize:12,color:T.muted}}>Additional vaccines / records</div>
            <button onClick={()=>setAddingVax(a=>!a)} style={{padding:"4px 10px",background:addingVax?"none":T.accent,color:addingVax?T.muted:"#fff",border:addingVax?`1px solid ${T.border}`:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{addingVax?"Cancel":"+ Add"}</button>
          </div>
          {addingVax&&<div style={{background:T.bgLite,borderRadius:8,padding:10,marginBottom:10,display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            <Inp value={newVax.name||""} onChange={e=>setNewVax(v=>({...v,name:e.target.value}))} placeholder="Vaccine name" style={{fontSize:12,padding:"5px 8px"}}/>
            <Inp value={newVax.vet||""} onChange={e=>setNewVax(v=>({...v,vet:e.target.value}))} placeholder="Given by" style={{fontSize:12,padding:"5px 8px"}}/>
            <div><div style={{fontSize:10,color:T.muted,marginBottom:2}}>Date given</div><Inp type="date" value={newVax.date||""} onChange={e=>setNewVax(v=>({...v,date:e.target.value}))} style={{fontSize:12,padding:"5px 8px"}}/></div>
            <div><div style={{fontSize:10,color:T.muted,marginBottom:2}}>Expiry date</div><Inp type="date" value={newVax.expiry||""} onChange={e=>setNewVax(v=>({...v,expiry:e.target.value}))} style={{fontSize:12,padding:"5px 8px"}}/></div>
            <button onClick={()=>{upd("vaccinations",[...(sel.vaccinations||[]),newVax]);setNewVax(mkVaccine());setAddingVax(false);}} style={{gridColumn:"1/-1",padding:"7px",background:T.free,color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>✓ Save</button>
          </div>}
          {(sel.vaccinations||[]).map((v,i)=>(
            <div key={v.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:`1px solid ${T.border}44`,fontSize:12}}>
              <div><strong style={{color:T.text}}>{v.name}</strong>{v.vet&&<span style={{color:T.muted}}> · {v.vet}</span>}</div>
              <div style={{display:"flex",gap:8,alignItems:"center",color:T.muted,fontSize:11}}>
                {v.date&&<span>{new Date(v.date+"T00:00:00").toLocaleDateString("en-US",{month:"short",year:"numeric"})}</span>}
                {v.expiry&&<span style={{color:new Date(v.expiry)<new Date()?T.danger:"#f59e0b"}}>Exp: {new Date(v.expiry+"T00:00:00").toLocaleDateString("en-US",{month:"short",year:"numeric"})}</span>}
                <button onClick={()=>upd("vaccinations",(sel.vaccinations||[]).filter((_,j)=>j!==i))} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:13}}>✕</button>
              </div>
            </div>
          ))}
        </Card>}

        {tab==="meds"&&<Card>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>💊 Medications</div>
            <button onClick={()=>setAddingMed(a=>!a)} style={{padding:"4px 10px",background:addingMed?"none":T.accent,color:addingMed?T.muted:"#fff",border:addingMed?`1px solid ${T.border}`:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{addingMed?"Cancel":"+ Add Med"}</button>
          </div>
          {addingMed&&<div style={{background:T.bgLite,borderRadius:8,padding:10,marginBottom:12,display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:8}}>
            <Inp value={newMed.name||""} onChange={e=>setNewMed(m=>({...m,name:e.target.value}))} placeholder="Medication name" style={{fontSize:12,padding:"5px 8px"}}/>
            <Inp value={newMed.dosage||""} onChange={e=>setNewMed(m=>({...m,dosage:e.target.value}))} placeholder="Dosage (e.g. 25mg)" style={{fontSize:12,padding:"5px 8px"}}/>
            <Sel value={newMed.frequency||"daily"} onChange={e=>setNewMed(m=>({...m,frequency:e.target.value}))} style={{padding:"5px 8px",fontSize:12}}>
              {["once daily","twice daily","3x daily","weekly","as needed","other"].map(f=><option key={f}>{f}</option>)}
            </Sel>
            <div><div style={{fontSize:10,color:T.muted,marginBottom:2}}>Refill date</div><Inp type="date" value={newMed.refillDate||""} onChange={e=>setNewMed(m=>({...m,refillDate:e.target.value}))} style={{fontSize:12,padding:"5px 8px"}}/></div>
            <Inp value={newMed.notes||""} onChange={e=>setNewMed(m=>({...m,notes:e.target.value}))} placeholder="Notes (give with food, refrigerate...)" style={{gridColumn:"1/-1",fontSize:12,padding:"5px 8px"}}/>
            <button onClick={()=>{upd("medications",[...(sel.medications||[]),newMed]);setNewMed(mkPetMed());setAddingMed(false);}} style={{gridColumn:"1/-1",padding:"7px",background:T.free,color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>✓ Save</button>
          </div>}
          {(sel.medications||[]).length===0&&!addingMed&&<div style={{textAlign:"center",padding:20,color:T.muted,fontSize:12}}>No medications logged. Add flea/tick prevention, heartworm, prescriptions, etc.</div>}
          {(sel.medications||[]).map((m,i)=>{
            const refillDt=m.refillDate?new Date(m.refillDate+"T00:00:00"):null;
            const days=refillDt?Math.ceil((refillDt-new Date())/(1000*60*60*24)):null;
            return<div key={m.id} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",padding:"8px 0",borderBottom:`1px solid ${T.border}44`}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text}}>{m.name} {m.dosage&&<span style={{fontWeight:400,color:T.muted}}>· {m.dosage}</span>}</div>
                <div style={{fontSize:11,color:T.muted}}>{m.frequency}{m.notes&&" · "+m.notes}</div>
                {days!==null&&days<14&&<div style={{fontSize:10,color:days<0?T.danger:"#f59e0b",fontWeight:700,marginTop:2}}>{days<0?"REFILL OVERDUE":"Refill in "+days+" days"}</div>}
              </div>
              <button onClick={()=>upd("medications",(sel.medications||[]).filter((_,j)=>j!==i))} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,flexShrink:0}}>✕</button>
            </div>;
          })}
        </Card>}

        {tab==="nearby"&&<Card>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>📍 Pet-Friendly Nearby</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.5}}>Find pet services near your stops. Links open a targeted Google Maps or web search.</div>
          {stops.filter(s=>s.name&&s.type!=="home"&&s.active).slice(0,4).map(stop=>{
            const q=encodeURIComponent((stop.name||"")+(stop.state?", "+stop.state:""));
            return<div key={stop.id} style={{marginBottom:14,padding:"10px 12px",background:T.bgLite,borderRadius:10,border:`1px solid ${T.border}`}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8}}>📍 {stop.name}{stop.state?", "+stop.state:""}</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {[
                  {label:"🐕 Dog Parks",url:`https://www.google.com/maps/search/dog+park+near+${q}`},
                  {label:"🏥 Emergency Vet",url:`https://www.google.com/maps/search/emergency+veterinarian+near+${q}`},
                  {label:"🛁 Pet Grooming",url:`https://www.google.com/maps/search/pet+grooming+near+${q}`},
                  {label:"🐾 Pet Supply",url:`https://www.google.com/maps/search/pet+supply+store+near+${q}`},
                  {label:"⛺ Pet-Friendly RV Parks",url:`https://www.petfriendlytravel.com/rv_parks/${(stop.state||"").toLowerCase()}`},
                  {label:"🏩 Loves Dog Walk",url:`https://www.loves.com/en/fuel-stops`},
                ].map(({label,url})=>(
                  <a key={label} href={url} target="_blank" rel="noopener noreferrer"
                    style={{padding:"4px 10px",background:T.accent+"18",border:`1px solid ${T.accent}33`,borderRadius:6,color:T.accent,fontSize:11,fontWeight:700,textDecoration:"none"}}>
                    {label}
                  </a>
                ))}
              </div>
            </div>;
          })}
          {stops.filter(s=>s.name&&s.type!=="home"&&s.active).length===0&&<div style={{textAlign:"center",padding:20,color:T.muted,fontSize:12}}>Add stops to your trip to see nearby pet services.</div>}
        </Card>}
      </>}
    </div>
  );
}

// ── GymSection ─────────────────────────────────────────────────────
const GYM_CHAINS=[
  {id:"planetfitness",name:"Planet Fitness",icon:"💜",note:"Black Card = any location ($25/mo)",url:"https://www.planetfitness.com/gymfinder",color:"#7c3aed"},
  {id:"anytime",name:"Anytime Fitness",icon:"💪",note:"Worldwide access included",url:"https://www.anytimefitness.com/find-a-gym/",color:"#dc2626"},
  {id:"ymca",name:"YMCA",icon:"🏊",note:"Away Network at participating Ys",url:"https://www.ymca.org/find-your-y",color:"#1d4ed8"},
  {id:"lafitness",name:"LA Fitness",icon:"🏋️",note:"Reciprocal access",url:"https://www.lafitness.com/Pages/clublocation.aspx",color:"#f59e0b"},
  {id:"crunch",name:"Crunch Fitness",icon:"🔥",note:"Multi-club access on Peak plan",url:"https://www.crunch.com/locations",color:"#dc2626"},
  {id:"golds",name:"Gold's Gym",icon:"🥇",note:"Multi-location with membership",url:"https://www.goldsgym.com/gyms/",color:"#f59e0b"},
  {id:"24hour",name:"24 Hour Fitness",icon:"⏰",note:"Multi-club with All-Club plan",url:"https://www.24hourfitness.com/gyms/",color:"#1d6ed8"},
  {id:"lifetime",name:"Life Time Fitness",icon:"🌟",note:"All-access membership",url:"https://www.lifetime.life/find-a-gym.html",color:"#16a34a"},
  {id:"equinox",name:"Equinox",icon:"⚡",note:"All-access membership",url:"https://www.equinox.com/clubs",color:"#1a1a2e"},
];

function GymSection({gymMemberships={},onChange,stops=[]}){
  const T=useTheme();
  const mems=gymMemberships.memberships||[];
  const toggle=(id)=>{
    const ex=mems.find(m=>m.id===id);
    if(ex){onChange({...gymMemberships,memberships:mems.map(m=>m.id===id?{...m,active:!m.active}:m)});}
    else{const g=GYM_CHAINS.find(g=>g.id===id);onChange({...gymMemberships,memberships:[...mems,{...g,active:true,memberNum:"",homeLoc:"",notes:""}]});}
  };
  const upd=(id,k,v)=>onChange({...gymMemberships,memberships:mems.map(m=>m.id===id?{...m,[k]:v}:m)});
  const active=mems.filter(m=>m.active);

  return(
    <div>
      <SecHead icon="🏋️" title="Gym Memberships" sub="Track your fitness memberships and find locations near every stop"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:10,marginBottom:20}}>
        {GYM_CHAINS.map(g=>{
          const mem=mems.find(m=>m.id===g.id);
          const isActive=mem?.active||false;
          return(
            <div key={g.id} style={{padding:"10px 14px",borderRadius:10,border:`2px solid ${isActive?g.color:T.border}`,background:isActive?g.color+"0d":T.bgMid,cursor:"pointer",transition:"all .15s"}}
              onClick={()=>toggle(g.id)}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:isActive?8:0}}>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:isActive?g.color:T.text,display:"flex",alignItems:"center",gap:6}}>{g.icon} {g.name}</div>
                  <div style={{fontSize:11,color:T.muted,marginTop:2}}>{g.note}</div>
                </div>
                <div style={{width:22,height:22,borderRadius:"50%",border:`2px solid ${isActive?g.color:T.border}`,background:isActive?g.color:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {isActive&&<span style={{fontSize:12,color:"#fff",fontWeight:900}}>✓</span>}
                </div>
              </div>
              {isActive&&mem&&<div onClick={e=>e.stopPropagation()} style={{display:"grid",gap:6}}>
                <Inp value={mem.memberNum||""} onChange={e=>upd(g.id,"memberNum",e.target.value)} placeholder="Member / Barcode number" style={{fontSize:11,padding:"5px 8px"}}/>
                <Inp value={mem.homeLoc||""} onChange={e=>upd(g.id,"homeLoc",e.target.value)} placeholder="Home location (city)" style={{fontSize:11,padding:"5px 8px"}}/>
                <a href={g.url} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()}
                  style={{padding:"5px 10px",background:g.color+"22",border:`1px solid ${g.color}44`,borderRadius:6,color:g.color,fontSize:11,fontWeight:700,textDecoration:"none",textAlign:"center"}}>
                  🔍 Find Locations Near My Stops →
                </a>
              </div>}
            </div>
          );
        })}
      </div>
      {/* Nearby gym search per stop */}
      {active.length>0&&stops.filter(s=>s.name&&s.active&&s.type!=="home").length>0&&<Card>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>📍 Find Your Gyms Near Stops</div>
        {stops.filter(s=>s.name&&s.active&&s.type!=="home").map(stop=>(
          <div key={stop.id} style={{marginBottom:12,padding:"10px 12px",background:T.bgLite,borderRadius:10,border:`1px solid ${T.border}`}}>
            <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8}}>📍 {stop.name}{stop.state?", "+stop.state:""}</div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {active.map(m=>{
                const q=encodeURIComponent(m.name+" near "+(stop.name||"")+(stop.state?", "+stop.state:""));
                return<a key={m.id} href={`https://www.google.com/maps/search/${q}`} target="_blank" rel="noopener noreferrer"
                  style={{padding:"4px 10px",background:m.color+"18",border:`1px solid ${m.color}33`,borderRadius:6,color:m.color,fontSize:11,fontWeight:700,textDecoration:"none"}}>
                  {m.icon} {m.name}
                </a>;
              })}
              <a href={`https://www.google.com/maps/search/gym+near+${encodeURIComponent((stop.name||"")+(stop.state?", "+stop.state:""))}`} target="_blank" rel="noopener noreferrer"
                style={{padding:"4px 10px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:6,color:T.muted,fontSize:11,fontWeight:700,textDecoration:"none"}}>
                🏋️ All Gyms
              </a>
            </div>
          </div>
        ))}
      </Card>}
      <div style={{marginTop:16}}><Label>Notes</Label><Inp value={gymMemberships.notes||""} onChange={e=>onChange({...gymMemberships,notes:e.target.value})} placeholder="Guest pass policies, class schedules, day pass costs..."/></div>
    </div>
  );
}

// ── EventsSection ──────────────────────────────────────────────────
const MOTO_EVENT_RESOURCES=[
  {label:"CycleFish Events",url:"https://www.cyclefish.com/motorcycle_events",icon:"🏍",desc:"Largest motorcycle event calendar"},
  {label:"AMA Events",url:"https://www.americanmotorcyclist.com/Events",icon:"🏁",desc:"American Motorcyclist Association"},
  {label:"Motorcycle.com Events",url:"https://www.motorcycle.com/events",icon:"📅",desc:"National events calendar"},
  {label:"Biker Switchboard",url:"https://www.bikerswitchboard.com/events",icon:"🔊",desc:"Charity rides and rallies"},
  {label:"Rider Justice Events",url:"https://riderjustice.com/events",icon:"⚖️",desc:"Toy runs and charity rides"},
  {label:"ATV Rider Events",url:"https://www.atvrider.com/events",icon:"🏎",desc:"ATV and off-road events"},
  {label:"Outdoor Power Events",url:"https://www.outdoorpowerequipment.com",icon:"🌲",desc:"SxS and trail events"},
];

function EventsSection({stops=[],causes=[],onCauses,motoEvents=[],onMotoEvents}){
  const T=useTheme();
  const [addingCause,setAddingCause]=useState(false);
  const [newCause,setNewCause]=useState({id:"",name:"",url:"",description:"",icon:"❤️"});

  const saveCause=()=>{
    if(!newCause.name) return;
    onCauses([...causes,{...newCause,id:uid()}]);
    setNewCause({id:"",name:"",url:"",description:"",icon:"❤️"});
    setAddingCause(false);
  };

  return(
    <div>
      <SecHead icon="🎪" title="Events & Causes" sub="Motorcycle events, charity rides, and causes close to your heart"/>

      {/* ── FEATURED: Dough 4 Joe ── */}
      <Card style={{marginBottom:20,border:"2px solid #dc2626",background:"linear-gradient(135deg,#dc262608,#f59e0b08)"}} accent="#dc2626">
        <div style={{display:"flex",gap:14,alignItems:"flex-start",flexWrap:"wrap"}}>
          <div style={{fontSize:48,flexShrink:0}}>❤️🏍</div>
          <div style={{flex:1,minWidth:220}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4,flexWrap:"wrap"}}>
              <div style={{fontFamily:T.F.head,fontWeight:900,fontSize:22,color:"#dc2626",letterSpacing:1}}>DOUGH 4 JOE</div>
              <div style={{background:"#dc2626",color:"#fff",borderRadius:6,padding:"2px 8px",fontSize:10,fontWeight:700,letterSpacing:.5}}>FEATURED CAUSE</div>
              <div style={{background:T.free+"22",color:T.free,borderRadius:6,padding:"2px 8px",fontSize:10,fontWeight:700}}>501(c)(3) · Board Members Unpaid</div>
            </div>
            <div style={{fontSize:13,color:T.text,lineHeight:1.7,marginBottom:10}}>
              Started in 2005 to help Joe Sampson and his family battle cancer, <strong>Dough 4 Joe</strong> has grown into an annual motorcycle run that raises funds for families in the surrounding communities suffering from illness. Every dollar donated goes directly to families in need — no board member takes a penny. Their motto says it all: <em>"Where Friends of Friends Become Family."</em>
            </div>
            <div style={{background:"#dc262611",border:"1px solid #dc262633",borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12}}>
              <div style={{fontWeight:700,color:"#dc2626",marginBottom:4}}>🏍 2025 Event — 20th Anniversary!</div>
              <div style={{color:T.text,lineHeight:1.6}}>
                📅 <strong>July 24–26, 2025</strong><br/>
                📍 21756 County Highway 22, Fergus Falls, MN 56537<br/>
                🎵 Live music · Camping · Motorcycle fun run · Vendors · Kids activities · Food trucks<br/>
                🎁 Free will donation gets you: free meal, free t-shirt, shuttle, 3-night primitive camping
              </div>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <a href="https://www.dough4joe.com" target="_blank" rel="noopener noreferrer"
                style={{padding:"9px 18px",background:"#dc2626",color:"#fff",borderRadius:8,fontWeight:700,fontSize:13,textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6}}>
                ❤️ Visit Dough4Joe.com
              </a>
              <a href="https://www.facebook.com/dough4joe" target="_blank" rel="noopener noreferrer"
                style={{padding:"9px 18px",background:"#1877f2",color:"#fff",borderRadius:8,fontWeight:700,fontSize:13,textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6}}>
                👍 Follow on Facebook
              </a>
              <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent("21756 County Highway 22, Fergus Falls, MN 56537")}`} target="_blank" rel="noopener noreferrer"
                style={{padding:"9px 18px",background:"#16a34a",color:"#fff",borderRadius:8,fontWeight:700,fontSize:13,textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6}}>
                🗺 Directions
              </a>
            </div>
          </div>
        </div>
      </Card>

      {/* User's own causes */}
      <Card style={{marginBottom:20}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>❤️ My Causes</div>
          <button onClick={()=>setAddingCause(a=>!a)} style={{padding:"4px 10px",background:addingCause?"none":T.accent,color:addingCause?T.muted:"#fff",border:addingCause?`1px solid ${T.border}`:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{addingCause?"Cancel":"+ Add Cause"}</button>
        </div>
        {addingCause&&<div style={{background:T.bgLite,borderRadius:8,padding:12,marginBottom:12,display:"grid",gap:8}}>
          <div style={{display:"grid",gridTemplateColumns:"48px 1fr",gap:8}}>
            <Inp value={newCause.icon||"❤️"} onChange={e=>setNewCause(c=>({...c,icon:e.target.value}))} placeholder="🏍" style={{fontSize:20,textAlign:"center",padding:"5px 4px"}}/>
            <Inp value={newCause.name||""} onChange={e=>setNewCause(c=>({...c,name:e.target.value}))} placeholder="Charity or organization name" style={{fontSize:13,padding:"5px 8px"}}/>
          </div>
          <Inp value={newCause.url||""} onChange={e=>setNewCause(c=>({...c,url:e.target.value}))} placeholder="Website URL" style={{fontSize:12,padding:"5px 8px"}}/>
          <Inp value={newCause.description||""} onChange={e=>setNewCause(c=>({...c,description:e.target.value}))} placeholder="Brief description" style={{fontSize:12,padding:"5px 8px"}}/>
          <button onClick={saveCause} style={{padding:"7px",background:T.free,color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>✓ Add Cause</button>
        </div>}
        {causes.length===0&&!addingCause&&<div style={{textAlign:"center",padding:16,color:T.muted,fontSize:12}}>Add charities and causes you support on the road.</div>}
        {causes.map(c=>(
          <div key={c.id} style={{display:"flex",gap:12,alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${T.border}44`}}>
            <span style={{fontSize:24,flexShrink:0}}>{c.icon||"❤️"}</span>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text}}>{c.name}</div>
              {c.description&&<div style={{fontSize:11,color:T.muted}}>{c.description}</div>}
            </div>
            {c.url&&<a href={c.url.startsWith("http")?c.url:"https://"+c.url} target="_blank" rel="noopener noreferrer"
              style={{padding:"4px 10px",background:T.accent+"18",border:`1px solid ${T.accent}33`,borderRadius:6,color:T.accent,fontSize:11,fontWeight:700,textDecoration:"none",flexShrink:0}}>
              Visit →
            </a>}
            <button onClick={()=>onCauses(causes.filter(x=>x.id!==c.id))} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,flexShrink:0}}>✕</button>
          </div>
        ))}
      </Card>

      {/* Motorcycle events */}
      <Card>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>🏍 Motorcycle & ATV Events</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.5}}>Find charity rides, rallies, and events near your stops. These links open the best event calendars searchable by your location.</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:10,marginBottom:16}}>
          {MOTO_EVENT_RESOURCES.map(r=>(
            <a key={r.label} href={r.url} target="_blank" rel="noopener noreferrer"
              style={{padding:"10px 14px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:10,textDecoration:"none",display:"block",transition:"all .15s"}}>
              <div style={{fontSize:13,fontWeight:700,color:T.accent,marginBottom:2}}>{r.icon} {r.label}</div>
              <div style={{fontSize:11,color:T.muted}}>{r.desc}</div>
            </a>
          ))}
        </div>
        {/* Search near stops */}
        {stops.filter(s=>s.name&&s.active&&s.type!=="home").length>0&&<>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:.5,marginBottom:10}}>🔍 Search Events Near My Stops</div>
          {stops.filter(s=>s.name&&s.active&&s.type!=="home").map(stop=>{
            const loc=(stop.name||"")+(stop.state?", "+stop.state:"");
            const q=encodeURIComponent(loc);
            return<div key={stop.id} style={{marginBottom:10,padding:"10px 12px",background:T.bgLite,borderRadius:10,border:`1px solid ${T.border}`}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8}}>📍 {loc}</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                <a href={`https://www.cyclefish.com/motorcycle_events?location=${q}`} target="_blank" rel="noopener noreferrer" style={{padding:"4px 10px",background:T.accent+"18",border:`1px solid ${T.accent}33`,borderRadius:6,color:T.accent,fontSize:11,fontWeight:700,textDecoration:"none"}}>🏍 Moto Events</a>
                <a href={`https://www.google.com/search?q=motorcycle+charity+ride+near+${q}`} target="_blank" rel="noopener noreferrer" style={{padding:"4px 10px",background:"#dc262618",border:"1px solid #dc262633",borderRadius:6,color:"#dc2626",fontSize:11,fontWeight:700,textDecoration:"none"}}>❤️ Charity Rides</a>
                <a href={`https://www.google.com/search?q=ATV+SxS+trail+riding+near+${q}`} target="_blank" rel="noopener noreferrer" style={{padding:"4px 10px",background:"#16a34a18",border:"1px solid #16a34a33",borderRadius:6,color:"#16a34a",fontSize:11,fontWeight:700,textDecoration:"none"}}>🏎 ATV/SxS Trails</a>
                <a href={`https://www.google.com/maps/search/motorcycle+rental+near+${q}`} target="_blank" rel="noopener noreferrer" style={{padding:"4px 10px",background:"#f59e0b18",border:"1px solid #f59e0b33",borderRadius:6,color:"#b45309",fontSize:11,fontWeight:700,textDecoration:"none"}}>🏍 Rentals</a>
                <a href={`https://www.outdoorsy.com/rv-rental?address=${q}`} target="_blank" rel="noopener noreferrer" style={{padding:"4px 10px",background:"#7c3aed18",border:"1px solid #7c3aed33",borderRadius:6,color:"#7c3aed",fontSize:11,fontWeight:700,textDecoration:"none"}}>🚗 Toy Rentals</a>
              </div>
            </div>;
          })}
        </>}
      </Card>
    </div>
  );
}


// ── Journal Publishing ─────────────────────────────────────────────
const JOURNAL_SUPABASE_URL="https://qpxxfdnzglnxyryawujz.supabase.co";
const JOURNAL_ANON_KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFweHhmZG56Z2xueHlyeWF3dWp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5MzA0MTYsImV4cCI6MjA4ODUwNjQxNn0.mI71JjApI_OV2Wq9vm8EibwZQvot3EVtvdfgRpVJZL0";

async function publishJournal({userId,slug,title,journal,stops}){
  const cleanSlug=slug.trim().toLowerCase().replace(/[^a-z0-9-]/g,"-").replace(/-+/g,"-");
  const payload={
    user_id:userId,
    slug:cleanSlug,
    title:title||"My RV Travel Journal",
    data:{journal,stops:stops.map(s=>({name:s.name,state:s.state,type:s.type,nights:s.nights||s.minNights||0}))},
    published:true,
    updated_at:new Date().toISOString(),
  };
  // Use supabase client so user auth session is included automatically
  const {data,error}=await supabase
    .from("journals")
    .upsert(payload,{onConflict:"slug"})
    .select();
  if(error) throw new Error(error.message||"Failed to publish");
  return data;
}

async function unpublishJournal(slug){
  const {error}=await supabase.from("journals").delete().eq("slug",slug);
  return !error;
}

async function fetchJournal(slug){
  const res=await fetch(`${JOURNAL_SUPABASE_URL}/rest/v1/journals?slug=eq.${encodeURIComponent(slug)}&published=eq.true&select=*`,{
    headers:{"apikey":JOURNAL_ANON_KEY,"Authorization":`Bearer ${JOURNAL_ANON_KEY}`},
  });
  if(!res.ok) return null;
  const data=await res.json();
  return data?.[0]||null;
}

// ── PublishJournalModal ────────────────────────────────────────────
function PublishJournalModal({journal=[],stops=[],user,onClose}){
  const T=useTheme();
  const [title,setTitle]=useState("My RV Travel Journal");
  const [slug,setSlug]=useState(()=>{
    const base=(user?.email||"rv-traveler").split("@")[0].toLowerCase().replace(/[^a-z0-9]/g,"-");
    return base+"-journal";
  });
  const [publishing,setPublishing]=useState(false);
  const [published,setPublished]=useState(false);
  const [error,setError]=useState("");
  const [copied,setCopied]=useState(false);

  const cleanSlug=slug.trim().toLowerCase().replace(/[^a-z0-9-]/g,"-").replace(/-+/g,"-");
  const shareUrl=`${window.location.origin}/journal/${cleanSlug}`;

  const handlePublish=async()=>{
    if(!user){setError("You must be logged in to publish a journal.");return;}
    if(!cleanSlug){setError("Please enter a URL name.");return;}
    setPublishing(true);setError("");
    try{
      await publishJournal({userId:user.id,slug:cleanSlug,title,journal,stops});
      setPublished(true);
    }catch(e){
      setError(e.message||"Something went wrong. Please try again.");
    }
    setPublishing(false);
  };

  const copyLink=()=>{
    navigator.clipboard.writeText(shareUrl).then(()=>{setCopied(true);setTimeout(()=>setCopied(false),2000);});
  };

  const share=()=>{
    if(navigator.share){
      navigator.share({title,url:shareUrl,text:`Check out my RV travel journal: ${title}`,}).catch(()=>{});
    } else copyLink();
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:10200,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
      onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:480,padding:28,boxShadow:"0 12px 60px rgba(0,0,0,0.5)",border:`1px solid ${T.border}`}}>
        {!published?(
          <>
            <div style={{fontSize:22,fontWeight:800,color:T.text,marginBottom:4}}>📤 Publish Your Journal</div>
            <div style={{fontSize:13,color:T.muted,lineHeight:1.6,marginBottom:20}}>Share your travel journal with family and friends via a unique link. They can read your entries, ratings, and tips without needing an account.</div>
            <div style={{marginBottom:14}}>
              <Label>Journal Title</Label>
              <Inp value={title} onChange={e=>setTitle(e.target.value)} placeholder="e.g. Our 2025 Summer Adventure"/>
            </div>
            <div style={{marginBottom:6}}>
              <Label>Your Journal URL</Label>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{fontSize:12,color:T.muted,flexShrink:0,whiteSpace:"nowrap"}}>...app/journal/</span>
                <Inp value={slug} onChange={e=>setSlug(e.target.value)} placeholder="your-name-2025" style={{flex:1}}/>
              </div>
              <div style={{fontSize:11,color:T.muted,marginTop:4}}>Letters, numbers, and dashes only. This becomes your shareable link.</div>
            </div>
            <div style={{marginBottom:16,padding:"8px 12px",background:T.bgLite,borderRadius:8,fontSize:12,color:T.accent,wordBreak:"break-all"}}>
              🔗 {shareUrl}
            </div>
            <div style={{marginBottom:16,fontSize:12,color:T.muted,lineHeight:1.6}}>
              <strong>{journal.length} journal {journal.length===1?"entry":"entries"}</strong> will be published · Anyone with the link can read it · You can update or unpublish anytime
            </div>
            {error&&<div style={{marginBottom:12,padding:"8px 12px",background:T.danger+"18",border:`1px solid ${T.danger}44`,borderRadius:8,fontSize:12,color:T.danger}}>⚠ {error}</div>}
            <div style={{display:"flex",gap:10}}>
              <button onClick={handlePublish} disabled={publishing} style={{flex:1,padding:"12px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:publishing?"not-allowed":"pointer"}}>
                {publishing?"⏳ Publishing...":"📤 Publish Journal"}
              </button>
              <button onClick={onClose} style={{flex:1,padding:"12px",background:"none",border:`1px solid ${T.border}`,borderRadius:10,fontWeight:700,fontSize:14,cursor:"pointer",color:T.muted}}>Cancel</button>
            </div>
          </>
        ):(
          <>
            <div style={{fontSize:36,textAlign:"center",marginBottom:8}}>🎉</div>
            <div style={{fontSize:20,fontWeight:800,color:T.free,textAlign:"center",marginBottom:8}}>Journal Published!</div>
            <div style={{fontSize:13,color:T.muted,textAlign:"center",lineHeight:1.6,marginBottom:20}}>Your journal is live. Share this link with family and friends — they don't need an account to read it.</div>
            <div style={{padding:"10px 14px",background:T.bgLite,borderRadius:10,fontSize:13,color:T.accent,wordBreak:"break-all",marginBottom:16,textAlign:"center",fontWeight:600}}>
              🔗 {shareUrl}
            </div>
            <div style={{display:"flex",gap:10,marginBottom:12}}>
              <button onClick={copyLink} style={{flex:1,padding:"11px",background:copied?T.free:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer"}}>
                {copied?"✓ Copied!":"📋 Copy Link"}
              </button>
              <button onClick={share} style={{flex:1,padding:"11px",background:"#1877f2",color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer"}}>
                📤 Share...
              </button>
            </div>
            <a href={shareUrl} target="_blank" rel="noopener noreferrer"
              style={{display:"block",textAlign:"center",padding:"10px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:10,color:T.accent,textDecoration:"none",fontWeight:600,fontSize:13,marginBottom:12}}>
              👁 Preview Your Journal →
            </a>
            <button onClick={onClose} style={{width:"100%",padding:"10px",background:"none",border:`1px solid ${T.border}`,borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer",color:T.muted}}>Done</button>
          </>
        )}
      </div>
    </div>
  );
}

// ── PublicJournalViewer ────────────────────────────────────────────
function PublicJournalViewer({slug}){
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [notFound,setNotFound]=useState(false);

  useEffect(()=>{
    fetchJournal(slug).then(j=>{
      if(j)setData(j);
      else setNotFound(true);
      setLoading(false);
    }).catch(()=>{setNotFound(true);setLoading(false);});
  },[slug]);

  const journal=data?.data?.journal||[];
  const stops=data?.data?.stops||[];

  if(loading) return(
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#0f172a",color:"#94a3b8",fontFamily:"Inter,sans-serif"}}>
      <div style={{textAlign:"center"}}><div style={{fontSize:48,marginBottom:16}}>🏕</div><div style={{fontSize:18}}>Loading journal...</div></div>
    </div>
  );

  if(notFound) return(
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#0f172a",color:"#94a3b8",fontFamily:"Inter,sans-serif"}}>
      <div style={{textAlign:"center"}}>
        <div style={{fontSize:48,marginBottom:16}}>🗺</div>
        <div style={{fontSize:22,fontWeight:700,marginBottom:8,color:"#fff"}}>Journal Not Found</div>
        <div>This journal may have been unpublished or the link may be incorrect.</div>
      </div>
    </div>
  );

  return(
    <div style={{minHeight:"100vh",background:"#0f172a",fontFamily:"Inter,sans-serif",color:"#e2e8f0"}}>
      <div style={{background:"linear-gradient(135deg,#1e293b,#0f172a)",borderBottom:"1px solid #1e293b",padding:"20px 24px",textAlign:"center"}}>
        <div style={{fontSize:14,color:"#64748b",marginBottom:4}}>🚐 RV Travel Mate</div>
        <div style={{fontSize:28,fontWeight:900,color:"#f1f5f9",letterSpacing:.5,marginBottom:6}}>{data?.title||"Travel Journal"}</div>
        {stops.length>0&&<div style={{fontSize:13,color:"#64748b"}}>
          {stops.filter(s=>s.type!=="home"&&s.name).map(s=>s.name).join(" → ")}
        </div>}
        <div style={{fontSize:11,color:"#475569",marginTop:8}}>
          Last updated {new Date(data?.updated_at).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})}
        </div>
      </div>
      <div style={{maxWidth:720,margin:"0 auto",padding:"24px 20px"}}>
        {journal.length===0&&<div style={{textAlign:"center",padding:48,color:"#64748b"}}>
          <div style={{fontSize:48,marginBottom:12}}>📓</div><div>No journal entries yet.</div>
        </div>}
        {journal.map((e,i)=>(
          <div key={e.id||i} style={{marginBottom:24,background:"#1e293b",borderRadius:16,overflow:"hidden",border:"1px solid #334155"}}>
            <div style={{padding:"16px 20px",borderBottom:"1px solid #334155",display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
              <div style={{flex:1}}>
                <div style={{fontSize:18,fontWeight:700,color:"#f1f5f9",marginBottom:3}}>{e.title||e.campground||e.stopName||"Journal Entry"}</div>
                <div style={{fontSize:12,color:"#64748b",display:"flex",gap:12,flexWrap:"wrap"}}>
                  {e.campground&&<span>🏕 {e.campground}</span>}
                  {e.siteNumber&&<span>Site #{e.siteNumber}</span>}
                  {e.hookups&&<span>{e.hookups}</span>}
                  {e.date&&<span>{new Date(e.date+"T00:00:00").toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})}</span>}
                  {e.wouldReturn&&<span style={{color:"#22c55e"}}>✓ Would return</span>}
                </div>
              </div>
              <div style={{fontSize:20,flexShrink:0}}>{["","⭐","⭐⭐","⭐⭐⭐","⭐⭐⭐⭐","⭐⭐⭐⭐⭐"][e.rating||5]}</div>
            </div>
            {e.body&&<div style={{padding:"16px 20px",fontSize:15,color:"#cbd5e1",lineHeight:1.8,whiteSpace:"pre-wrap"}}>{e.body}</div>}
            {(e.photos||[]).length>0&&<div style={{display:"flex",gap:10,flexWrap:"wrap",padding:"0 20px 16px"}}>
              {(e.photos||[]).map((p,i)=>(
                <a key={i} href={p.url} target="_blank" rel="noopener noreferrer">
                  <img src={p.url} alt="" style={{width:120,height:120,objectFit:"cover",borderRadius:10,border:"1px solid #334155",cursor:"pointer"}}/>
                </a>
              ))}
            </div>}
            {e.tips&&<div style={{margin:"0 20px 16px",padding:"10px 14px",background:"#f59e0b14",border:"1px solid #f59e0b33",borderRadius:10}}>
              <div style={{fontSize:11,color:"#f59e0b",fontWeight:700,textTransform:"uppercase",letterSpacing:.5,marginBottom:4}}>💡 Tips for RVers</div>
              <div style={{fontSize:13,color:"#e2e8f0"}}>{e.tips}</div>
            </div>}
          </div>
        ))}
        <div style={{textAlign:"center",padding:"24px 0",borderTop:"1px solid #1e293b",marginTop:24}}>
          <div style={{fontSize:13,color:"#475569",marginBottom:8}}>Created with RV Travel Mate</div>
          <a href={window.location.origin} style={{padding:"10px 24px",background:"#3b82f6",color:"#fff",borderRadius:8,textDecoration:"none",fontWeight:700,fontSize:13}}>
            🚐 Plan Your Own RV Trip
          </a>
        </div>
      </div>
    </div>
  );
}


// ── CellCoverageSection ────────────────────────────────────────────
// Uses cell coverage data from OpenCelliD / carrier coverage APIs
// Since real coverage APIs require keys, we use carrier map links
// and a manual "known dead zones" log per stop
const CARRIERS=[
  {id:"verizon",name:"Verizon",color:"#cd040b",url:"https://www.verizon.com/coverage-map/"},
  {id:"att",name:"AT&T",color:"#009fdb",url:"https://www.att.com/maps/wireless-coverage-map.html"},
  {id:"tmobile",name:"T-Mobile",color:"#e20074",url:"https://www.t-mobile.com/coverage/coverage-map"},
  {id:"cricket",name:"Cricket",color:"#00a94f",url:"https://www.cricketwireless.com/coverage-map"},
  {id:"boost",name:"Boost Mobile",color:"#f7941d",url:"https://www.boostmobile.com/coverage.html"},
];

function CellCoverageSection({stops=[],vehicle={},onChange,cellNotes={}}){
  const T=useTheme();
  const [carrier,setCarrier]=useState("verizon");
  const notes=cellNotes||{};
  const updNote=(stopId,v)=>onChange&&onChange({...notes,[stopId]:v});
  const namedStops=stops.filter(s=>s.name&&s.active);
  const sel=CARRIERS.find(c=>c.id===carrier);

  return(
    <div>
      <SecHead icon="📶" title="Cell Coverage" sub="Check carrier coverage along your route and log known dead zones at each stop"/>
      <Card style={{marginBottom:16}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>📡 Check Coverage Maps</div>
        <div style={{fontSize:12,color:T.muted,lineHeight:1.5,marginBottom:14}}>Select your carrier to open their interactive coverage map. Check each leg of your route — especially in rural areas, mountain passes, and National Parks where coverage drops significantly.</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
          {CARRIERS.map(c=>(
            <button key={c.id} onClick={()=>setCarrier(c.id)}
              style={{padding:"7px 14px",borderRadius:8,border:`2px solid ${carrier===c.id?c.color:T.border}`,background:carrier===c.id?c.color+"18":"transparent",color:carrier===c.id?c.color:T.muted,fontWeight:700,fontSize:12,cursor:"pointer"}}>
              {c.name}
            </button>
          ))}
        </div>
        {sel&&<>
          <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
            <a href={sel.url} target="_blank" rel="noopener noreferrer"
              style={{padding:"10px 20px",background:sel.color,color:"#fff",borderRadius:8,fontWeight:700,fontSize:13,textDecoration:"none",display:"inline-flex",alignItems:"center",gap:8}}>
              📡 Open {sel.name} Coverage Map →
            </a>
            {namedStops.length>0&&namedStops.slice(0,3).map(s=>{
              const q=encodeURIComponent((s.name||"")+(s.state?", "+s.state:""));
              return<a key={s.id} href={`${sel.url}?location=${q}`} target="_blank" rel="noopener noreferrer"
                style={{padding:"10px 14px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.accent,fontWeight:600,fontSize:12,textDecoration:"none"}}>
                📍 {(s.name||"").split(",")[0]}
              </a>;
            })}
          </div>
        </>}
      </Card>

      {/* Dead zone tips by stop */}
      <Card style={{marginBottom:16}} accent="#f59e0b">
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#f59e0b",textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>⚠️ Known Dead Zones & Tips</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.5}}>Log your personal coverage notes at each stop — useful for your next trip and for other RVers.</div>
        {namedStops.length===0&&<div style={{textAlign:"center",padding:16,color:T.muted,fontSize:12}}>Add stops to your trip to log coverage notes.</div>}
        {namedStops.map(s=>(
          <div key={s.id} style={{marginBottom:12,padding:"10px 12px",background:T.bgLite,borderRadius:10,border:`1px solid ${T.border}`}}>
            <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:6}}>📍 {s.name}{s.state?", "+s.state:""}</div>
            <Inp value={notes[s.id]||""} onChange={e=>updNote(s.id,e.target.value)}
              placeholder="e.g. Verizon weak indoors, AT&T dead. WiFi calling works. Starlink recommended."/>
          </div>
        ))}
      </Card>

      {/* General tips */}
      <Card>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>💡 RV Cell Coverage Tips</div>
        {[
          {icon:"📡",tip:"A cell booster (WeBoost, SureCall) can significantly improve weak signal — many RVers consider it essential gear."},
          {icon:"🛰",tip:"Starlink RV is the most reliable option for rural and remote areas — $150/mo but works almost anywhere with clear sky."},
          {icon:"📱",tip:"Download offline maps (Google Maps, Maps.me) for your route before departing — navigation works without signal."},
          {icon:"🏕",tip:"Most campgrounds with hookups have WiFi — it's often slow but adequate for calls. Ask for the password at check-in."},
          {icon:"🆘",tip:"Always tell someone your route and check-in schedule when traveling through known dead zones."},
          {icon:"📻",tip:"A NOAA weather radio receives emergency alerts even with no cell signal — pick one up for about $30."},
        ].map((t,i)=>(
          <div key={i} style={{display:"flex",gap:12,alignItems:"flex-start",padding:"8px 0",borderBottom:i<5?`1px solid ${T.border}44`:"none"}}>
            <span style={{fontSize:20,flexShrink:0}}>{t.icon}</span>
            <div style={{fontSize:13,color:T.text,lineHeight:1.6}}>{t.tip}</div>
          </div>
        ))}
      </Card>
    </div>
  );
}

// ── TripSplitCalculator ────────────────────────────────────────────
function TripSplitSection({trip={},stops=[],vehicle={}}){
  const T=useTheme();
  const [travelers,setTravelers]=useState([{id:uid(),name:"",share:1}]);
  const [customCosts,setCustomCosts]=useState([]);
  const [splitMode,setSplitMode]=useState("equal"); // equal | custom | shares

  const addTraveler=()=>setTravelers(t=>[...t,{id:uid(),name:"",share:1}]);
  const updTraveler=(id,k,v)=>setTravelers(t=>t.map(x=>x.id===id?{...x,[k]:v}:x));
  const delTraveler=(id)=>setTravelers(t=>t.filter(x=>x.id!==id));
  const addCost=()=>setCustomCosts(c=>[...c,{id:uid(),label:"",amount:0,splitWith:"all"}]);
  const updCost=(id,k,v)=>setCustomCosts(c=>c.map(x=>x.id===id?{...x,[k]:v}:x));
  const delCost=(id)=>setCustomCosts(c=>c.filter(x=>x.id!==id));

  const totalFuel=trip.totalFuelCost||0;
  const totalLodging=trip.totalLodgingCost||0;
  const customTotal=customCosts.reduce((s,c)=>s+(parseFloat(c.amount)||0),0);
  const grandTotal=totalFuel+totalLodging+customTotal;

  const totalShares=travelers.reduce((s,t)=>s+(parseFloat(t.share)||1),0);

  const perPerson=(name,share)=>{
    if(splitMode==="equal") return travelers.length?grandTotal/travelers.length:0;
    if(splitMode==="shares") return totalShares?(grandTotal*(parseFloat(share)||1)/totalShares):0;
    return 0;
  };

  return(
    <div>
      <SecHead icon="🤝" title="Trip Cost Split" sub="Divide trip costs fairly among travelers, families, or caravans"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16}}>

        {/* Travelers */}
        <Card>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>👥 Travelers</div>
            <button onClick={addTraveler} style={{padding:"4px 10px",background:T.accent,color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>+ Add</button>
          </div>
          <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
            {[{id:"equal",label:"Split Equally"},{ id:"shares",label:"By Shares"},{id:"custom",label:"Custom"}].map(m=>(
              <button key={m.id} onClick={()=>setSplitMode(m.id)}
                style={{padding:"5px 12px",borderRadius:7,border:`1px solid ${splitMode===m.id?T.accent:T.border}`,background:splitMode===m.id?T.accent+"18":"none",color:splitMode===m.id?T.accent:T.muted,fontSize:11,fontWeight:700,cursor:"pointer"}}>
                {m.label}
              </button>
            ))}
          </div>
          {travelers.map(t=>(
            <div key={t.id} style={{display:"flex",gap:8,alignItems:"center",marginBottom:8}}>
              <Inp value={t.name||""} onChange={e=>updTraveler(t.id,"name",e.target.value)} placeholder="Name" style={{flex:1,fontSize:12,padding:"5px 8px"}}/>
              {splitMode==="shares"&&<Inp type="number" min={0.5} step={0.5} value={t.share||1} onChange={e=>updTraveler(t.id,"share",e.target.value)} style={{width:60,fontSize:12,padding:"5px 6px",textAlign:"center"}}/>}
              {travelers.length>1&&<button onClick={()=>delTraveler(t.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,flexShrink:0}}>✕</button>}
            </div>
          ))}
          {splitMode==="shares"&&<div style={{fontSize:11,color:T.muted,marginTop:4}}>Share value: 1 = full share, 0.5 = half share (e.g. child)</div>}
        </Card>

        {/* Costs */}
        <Card>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>💰 Trip Costs</div>
          <div style={{display:"grid",gap:8,marginBottom:12}}>
            <div style={{display:"flex",justifyContent:"space-between",padding:"8px 10px",background:T.bgLite,borderRadius:8}}>
              <span style={{fontSize:13,color:T.text}}>⛽ Fuel</span>
              <span style={{fontSize:13,fontWeight:700,color:T.accent}}>${totalFuel.toFixed(2)}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",padding:"8px 10px",background:T.bgLite,borderRadius:8}}>
              <span style={{fontSize:13,color:T.text}}>🏕 Lodging</span>
              <span style={{fontSize:13,fontWeight:700,color:T.accent}}>${totalLodging.toFixed(2)}</span>
            </div>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div style={{fontSize:12,color:T.muted}}>Additional costs</div>
            <button onClick={addCost} style={{padding:"3px 8px",background:"none",border:`1px solid ${T.border}`,borderRadius:5,fontSize:11,color:T.muted,cursor:"pointer"}}>+ Add</button>
          </div>
          {customCosts.map(c=>(
            <div key={c.id} style={{display:"flex",gap:6,alignItems:"center",marginBottom:6}}>
              <Inp value={c.label||""} onChange={e=>updCost(c.id,"label",e.target.value)} placeholder="e.g. Groceries, Activities" style={{flex:1,fontSize:12,padding:"4px 7px"}}/>
              <Inp type="number" value={c.amount||""} onChange={e=>updCost(c.id,"amount",e.target.value)} placeholder="$" style={{width:70,fontSize:12,padding:"4px 7px"}}/>
              <button onClick={()=>delCost(c.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:13,flexShrink:0}}>✕</button>
            </div>
          ))}
          <div style={{borderTop:`1px solid ${T.border}`,paddingTop:10,marginTop:8,display:"flex",justifyContent:"space-between"}}>
            <span style={{fontSize:14,fontWeight:700,color:T.text}}>Total Trip Cost</span>
            <span style={{fontSize:18,fontWeight:900,color:T.accent}}>${grandTotal.toFixed(2)}</span>
          </div>
        </Card>

        {/* Per-person breakdown */}
        {travelers.length>0&&grandTotal>0&&<Card style={{gridColumn:"1/-1"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:14}}>📊 Breakdown Per Person</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:10}}>
            {travelers.map(t=>{
              const amt=perPerson(t.name,t.share);
              return(
                <div key={t.id} style={{background:T.bgLite,borderRadius:10,padding:"14px 16px",textAlign:"center",border:`1px solid ${T.border}`}}>
                  <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>{t.name||"Traveler"}</div>
                  {splitMode==="shares"&&<div style={{fontSize:11,color:T.muted,marginBottom:4}}>{t.share||1} share{(t.share||1)!==1?"s":""}</div>}
                  <div style={{fontSize:24,fontWeight:900,color:T.accent}}>${amt.toFixed(2)}</div>
                  <div style={{fontSize:10,color:T.muted,marginTop:4}}>of ${grandTotal.toFixed(2)} total</div>
                </div>
              );
            })}
          </div>
          {/* Copy summary */}
          <button onClick={()=>{
            const lines=["🚐 RV Trip Cost Split — $"+grandTotal.toFixed(2)+" total",""];
            lines.push("⛽ Fuel: $"+totalFuel.toFixed(2));
            lines.push("🏕 Lodging: $"+totalLodging.toFixed(2));
            customCosts.forEach(c=>{if(c.label)lines.push("• "+c.label+": $"+(parseFloat(c.amount)||0).toFixed(2));});
            lines.push("");
            travelers.forEach(t=>{lines.push((t.name||"Traveler")+": $"+perPerson(t.name,t.share).toFixed(2));});
            navigator.clipboard.writeText(lines.join("\n")).then(()=>alert("Cost breakdown copied to clipboard!"));
          }} style={{marginTop:14,width:"100%",padding:"10px",background:T.accent,color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>
            📋 Copy Summary to Share
          </button>
        </Card>}
      </div>
    </div>
  );
}

// ── DumpStationSection ─────────────────────────────────────────────
function DumpStationSection({stops=[],dumpNotes={},onChange}){
  const T=useTheme();
  const notes=dumpNotes||{};
  const updNote=(id,v)=>onChange&&onChange({...notes,[id]:v});
  const namedStops=stops.filter(s=>s.name&&s.active);

  const DUMP_RESOURCES=[
    {label:"Sanidumps.com",url:"https://www.sanidumps.com",icon:"🗺",desc:"Largest dump station database"},
    {label:"RV Dump Sites",url:"https://rvdumpsites.net",icon:"📍",desc:"User-reviewed locations"},
    {label:"Love's Travel Stops",url:"https://www.loves.com/en/travel-stops/rv-services",icon:"❤️",desc:"Dump + water at most locations ($10-15)"},
    {label:"Pilot Flying J",url:"https://www.pilotflyingj.com/services/rv",icon:"✈️",desc:"RV services including dump stations"},
    {label:"KOA Kampgrounds",url:"https://koa.com/campgrounds/",icon:"🏕",desc:"Most KOAs have dump stations ($10-20)"},
    {label:"Campendium",url:"https://www.campendium.com",icon:"🌲",desc:"Filter by dump station amenity"},
  ];

  return(
    <div>
      <SecHead icon="🪣" title="Dump Stations" sub="Find dump stations along your route and log your personal notes"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:10,marginBottom:20}}>
        {DUMP_RESOURCES.map(r=>(
          <a key={r.label} href={r.url} target="_blank" rel="noopener noreferrer"
            style={{padding:"12px 14px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:10,textDecoration:"none",display:"block"}}>
            <div style={{fontSize:13,fontWeight:700,color:T.accent,marginBottom:3}}>{r.icon} {r.label}</div>
            <div style={{fontSize:11,color:T.muted}}>{r.desc}</div>
          </a>
        ))}
      </div>

      {/* Per-stop search + notes */}
      <Card>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:6}}>📍 Near Your Stops</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.5}}>Search for dump stations near each stop and log your notes — cost, hours, access code, quality. Saves you time on future trips.</div>
        {namedStops.length===0&&<div style={{textAlign:"center",padding:16,color:T.muted,fontSize:12}}>Add stops to your trip to search nearby dump stations.</div>}
        {namedStops.map(s=>{
          const q=encodeURIComponent((s.name||"")+(s.state?", "+s.state:""));
          return(
            <div key={s.id} style={{marginBottom:14,padding:"12px 14px",background:T.bgLite,borderRadius:10,border:`1px solid ${T.border}`}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8}}>📍 {s.name}{s.state?", "+s.state:""}</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
                <a href={`https://www.sanidumps.com/search.php?location=${q}`} target="_blank" rel="noopener noreferrer"
                  style={{padding:"4px 10px",background:T.accent+"18",border:`1px solid ${T.accent}33`,borderRadius:6,color:T.accent,fontSize:11,fontWeight:700,textDecoration:"none"}}>
                  🗺 Sanidumps Near Here
                </a>
                <a href={`https://www.google.com/maps/search/RV+dump+station+near+${q}`} target="_blank" rel="noopener noreferrer"
                  style={{padding:"4px 10px",background:"#16a34a18",border:"1px solid #16a34a33",borderRadius:6,color:"#16a34a",fontSize:11,fontWeight:700,textDecoration:"none"}}>
                  📍 Google Maps
                </a>
                <a href={`https://rvdumpsites.net/?s=${q}`} target="_blank" rel="noopener noreferrer"
                  style={{padding:"4px 10px",background:"#f59e0b18",border:"1px solid #f59e0b33",borderRadius:6,color:"#b45309",fontSize:11,fontWeight:700,textDecoration:"none"}}>
                  🪣 RV Dump Sites
                </a>
              </div>
              <Inp value={notes[s.id]||""} onChange={e=>updNote(s.id,e.target.value)}
                placeholder="Your notes: cost, hours, location details, access code, quality rating..."/>
            </div>
          );
        })}
      </Card>

      {/* Tips */}
      <Card style={{marginTop:16}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>💡 Dump Station Tips</div>
        {[
          {i:"💧",t:"Always bring your own sewer hose, gloves, and a spray nozzle — not all stations provide them."},
          {i:"🕐",t:"Many public dump stations (rest areas, state parks) are seasonal — call ahead in winter months."},
          {i:"💵",t:"Cost ranges from free (some rest areas, Camping World) to $10-20 at travel stops. Memberships like Good Sam often include free dumping."},
          {i:"🏪",t:"Camping World locations offer free dump to Good Sam members — use the store locator to find one near your route."},
          {i:"🚰",t:"Fill your fresh water AFTER dumping — never before. And never use your fresh water hose near the dump station."},
        ].map((t,i)=>(
          <div key={i} style={{display:"flex",gap:10,alignItems:"flex-start",padding:"7px 0",borderBottom:i<4?`1px solid ${T.border}44`:"none"}}>
            <span style={{fontSize:18,flexShrink:0}}>{t.i}</span>
            <div style={{fontSize:12,color:T.text,lineHeight:1.6}}>{t.t}</div>
          </div>
        ))}
      </Card>
    </div>
  );
}


// ── WelcomeModal ───────────────────────────────────────────────────
// Shown once after first login — gives users a quick feature tour
const WELCOME_FEATURES=[
  {icon:"📍",group:"Trip Planning",desc:"Add stops, auto-calculate driving miles, and view your full route on an interactive map with fuel stops, campgrounds, and RV parks marked along the way."},
  {icon:"🔧",group:"My RV",desc:"Track maintenance, tire pressure, propane levels, fill-ups, and toy/motorcycle maintenance — everything about your rig and gear in one place."},
  {icon:"💰",group:"Finances",desc:"Log monthly expenses by category, view annual trends, and set a travel budget. The AI can analyze your spending and suggest ways to cut costs."},
  {icon:"📍",group:"Near Stops",desc:"Find campgrounds, fuel stops, dog parks, gyms, Cabela's, Scheels, and Bass Pro Shops near each destination. One tap opens directions."},
  {icon:"🐾",group:"Pets & Lifestyle",desc:"Track your pets' vet info, vaccinations, and medications. Get potty break reminders on the road. Find dog parks and emergency vets near your stops."},
  {icon:"📓",group:"Travel Journal",desc:"Write journal entries at each stop with ratings, photos, and tips. Publish your journal to a shareable web link so family can follow your adventure."},
  {icon:"🏍",group:"Events & Causes",desc:"Find motorcycle rallies, charity rides, and ATV trail events near your route. Includes Dough 4 Joe — a 501(c)(3) motorcycle charity run in Fergus Falls, MN."},
  {icon:"🆘",group:"Emergency",desc:"Store all your emergency contacts, insurance, roadside assistance, and VIN in one place. Print a wallet card to keep in your glove box."},
  {icon:"🤖",group:"AI Route Planner",desc:"Tell the AI where you want to go and it plans your entire route — fuel stops, boondocking spots, campgrounds, and scenic detours — then adds them to your trip with one tap. Your personal RV trip planning expert."},
  {icon:"⚖️",group:"Weight & Safety",desc:"Enter your GVWR and dry weight to calculate payload capacity. Log weigh-in results from CAT scales and get instant warnings if you're over legal limits."},
];

function WelcomeModal({onClose,onStartWizard}){
  const T=useTheme();
  const [step,setStep]=useState(0);
  const TOTAL=WELCOME_FEATURES.length;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:10500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:T.bgMid,borderRadius:24,width:"100%",maxWidth:520,maxHeight:"90vh",overflow:"hidden",display:"flex",flexDirection:"column",border:`1px solid ${T.border}`,boxShadow:"0 20px 80px rgba(0,0,0,0.6)"}}>
        
        {/* Header */}
        <div style={{padding:"28px 28px 20px",background:`linear-gradient(135deg,${T.accent}22,${T.accentAlt||T.accent}11)`,borderBottom:`1px solid ${T.border}`}}>
          <div style={{fontSize:36,textAlign:"center",marginBottom:8}}>🚐</div>
          <div style={{fontFamily:T.F.head,fontWeight:900,fontSize:24,color:T.accent,textAlign:"center",letterSpacing:1,marginBottom:6}}>Welcome to RV Travel Mate</div>
          <div style={{fontSize:13,color:T.muted,textAlign:"center",lineHeight:1.6}}>
            The complete RV planning app — from route planning to life on the road. Here's a quick look at what's inside.
          </div>
        </div>

        {/* Feature carousel */}
        <div style={{flex:1,overflowY:"auto",padding:"20px 28px"}}>
          {/* Progress dots */}
          <div style={{display:"flex",justifyContent:"center",gap:6,marginBottom:20}}>
            {WELCOME_FEATURES.map((_,i)=>(
              <button key={i} onClick={()=>setStep(i)} style={{width:i===step?24:8,height:8,borderRadius:4,background:i===step?T.accent:T.border,border:"none",cursor:"pointer",transition:"all .2s",padding:0}}/>
            ))}
          </div>

          {/* Current feature */}
          <div style={{textAlign:"center",padding:"8px 0 20px"}}>
            <div style={{fontSize:56,marginBottom:12}}>{WELCOME_FEATURES[step].icon}</div>
            <div style={{fontFamily:T.F.cond,fontWeight:800,fontSize:20,color:T.accent,marginBottom:10,letterSpacing:.5}}>{WELCOME_FEATURES[step].group}</div>
            <div style={{fontSize:14,color:T.text,lineHeight:1.8}}>{WELCOME_FEATURES[step].desc}</div>
          </div>

          {/* All features grid — shown after carousel */}
          <div style={{borderTop:`1px solid ${T.border}`,paddingTop:16,marginTop:4}}>
            <div style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:.5,fontWeight:700,marginBottom:10,textAlign:"center"}}>Everything in the app</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:8}}>
              {WELCOME_FEATURES.map((f,i)=>(
                <button key={i} onClick={()=>setStep(i)}
                  style={{padding:"10px 8px",background:i===step?T.accent+"18":T.bgLite,border:`1px solid ${i===step?T.accent+"44":T.border}`,borderRadius:10,cursor:"pointer",textAlign:"left",transition:"all .15s"}}>
                  <div style={{fontSize:18,marginBottom:4}}>{f.icon}</div>
                  <div style={{fontSize:11,fontWeight:700,color:i===step?T.accent:T.text,lineHeight:1.3}}>{f.group}</div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{padding:"16px 28px 24px",borderTop:`1px solid ${T.border}`,display:"flex",gap:10,flexDirection:"column"}}>
          <div style={{display:"flex",gap:10}}>
            {step>0&&<button onClick={()=>setStep(s=>s-1)} style={{flex:1,padding:"11px",background:"none",border:`1px solid ${T.border}`,borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer",color:T.muted}}>← Back</button>}
            {step<TOTAL-1?(
              <button onClick={()=>setStep(s=>s+1)} style={{flex:2,padding:"11px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:"pointer"}}>Next →</button>
            ):(
              <button onClick={onStartWizard} style={{flex:2,padding:"11px",background:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:"pointer"}}>🚀 Set Up My First Trip</button>
            )}
          </div>
          <button onClick={onClose} style={{width:"100%",padding:"9px",background:"none",border:"none",color:T.muted,fontSize:12,cursor:"pointer"}}>Skip — I'll explore on my own</button>
        </div>
      </div>
    </div>
  );
}

// ── JournalManageCard ──────────────────────────────────────────────
// Lets users see their published journal, update it, or unpublish it
function JournalManageCard({journal=[],stops=[],user,publishedSlug,publishedTitle,onPublished}){
  const T=useTheme();
  const [checking,setChecking]=useState(false);
  const [existing,setExisting]=useState(null);
  const [checkedSlug,setCheckedSlug]=useState(null);
  const [unpublishing,setUnpublishing]=useState(false);
  const [republishing,setRepublishing]=useState(false);
  const [done,setDone]=useState("");

  // Check if user has any published journals
  const checkPublished=async()=>{
    if(!user) return;
    setChecking(true);
    try{
      const {data}=await supabase.from("journals").select("slug,title,updated_at,data").eq("user_id",user.id).eq("published",true);
      setExisting(data||[]);
    }catch{}
    setChecking(false);
  };

  useEffect(()=>{checkPublished();},[user]);

  const doUnpublish=async(slug)=>{
    setUnpublishing(true);
    await unpublishJournal(slug);
    setDone("unpublished");
    await checkPublished();
    setUnpublishing(false);
  };

  const doRepublish=async(slug,title)=>{
    setRepublishing(true);
    try{
      await publishJournal({userId:user.id,slug,title,journal,stops});
      setDone("updated");
      await checkPublished();
    }catch(e){setDone("error: "+e.message);}
    setRepublishing(false);
  };

  if(!user) return null;
  if(checking) return<div style={{textAlign:"center",padding:16,color:T.muted,fontSize:12}}>⏳ Checking published journals...</div>;
  if(!existing||existing.length===0) return null;

  return(
    <Card style={{marginTop:16}} accent={T.free}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.free,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>📡 Your Published Journals</div>
      {done&&<div style={{marginBottom:10,padding:"6px 10px",background:T.free+"18",borderRadius:6,fontSize:12,color:T.free,fontWeight:600}}>✓ {done==="updated"?"Journal updated successfully!":done==="unpublished"?"Journal unpublished.":done}</div>}
      {existing.map(j=>{
        const publishedEntries=(j.data?.journal||[]).length;
        const currentEntries=journal.length;
        const hasNew=currentEntries>publishedEntries;
        const shareUrl=`${window.location.origin}/journal/${j.slug}`;
        return(
          <div key={j.slug} style={{marginBottom:12,padding:"12px 14px",background:T.bgLite,borderRadius:10,border:`1px solid ${T.border}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,flexWrap:"wrap",marginBottom:8}}>
              <div>
                <div style={{fontSize:14,fontWeight:700,color:T.text}}>{j.title}</div>
                <div style={{fontSize:11,color:T.muted,marginTop:2}}>
                  {publishedEntries} {publishedEntries===1?"entry":"entries"} · Updated {new Date(j.updated_at).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}
                </div>
                {hasNew&&<div style={{fontSize:11,color:"#f59e0b",fontWeight:700,marginTop:3}}>⚠ {currentEntries-publishedEntries} new {currentEntries-publishedEntries===1?"entry":"entries"} since last publish</div>}
              </div>
              <div style={{display:"flex",gap:6,flexShrink:0}}>
                <a href={shareUrl} target="_blank" rel="noopener noreferrer"
                  style={{padding:"5px 10px",background:T.accent+"18",border:`1px solid ${T.accent}33`,borderRadius:6,color:T.accent,fontSize:11,fontWeight:700,textDecoration:"none"}}>👁 View</a>
                <button onClick={()=>navigator.clipboard.writeText(shareUrl).then(()=>setDone("Link copied!"))}
                  style={{padding:"5px 10px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:6,color:T.muted,fontSize:11,fontWeight:700,cursor:"pointer"}}>📋 Copy</button>
              </div>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {hasNew&&<button onClick={()=>doRepublish(j.slug,j.title)} disabled={republishing}
                style={{padding:"6px 14px",background:T.free,color:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer"}}>
                {republishing?"⏳ Updating...":"📤 Update Journal"}
              </button>}
              <button onClick={()=>{if(window.confirm("Unpublish "+j.title+"? The link will stop working."))doUnpublish(j.slug);}} disabled={unpublishing}
                style={{padding:"6px 14px",background:"none",border:`1px solid ${T.danger}44`,borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer",color:T.danger}}>
                {unpublishing?"⏳ Removing...":"🗑 Unpublish"}
              </button>
            </div>
          </div>
        );
      })}
    </Card>
  );
}


// ── PWAInstallPrompt ───────────────────────────────────────────────
function PWAInstallPrompt(){
  const T=useTheme();
  const [deferredPrompt,setDeferredPrompt]=useState(null);
  const [show,setShow]=useState(false);
  const [dismissed,setDismissed]=useState(()=>{
    try{return localStorage.getItem("rv-pwa-dismissed")==="1";}catch{return false;}
  });
  const [isIOS,setIsIOS]=useState(false);
  const [isInstalled,setIsInstalled]=useState(false);

  useEffect(()=>{
    // Check if already installed
    if(window.matchMedia("(display-mode: standalone)").matches){setIsInstalled(true);return;}
    // Detect iOS
    const ios=/iphone|ipad|ipod/i.test(navigator.userAgent)&&!window.MSStream;
    setIsIOS(ios);
    if(ios&&!dismissed){
      // Show iOS instructions after 30 seconds
      setTimeout(()=>setShow(true),30000);
    }
    // Listen for Chrome/Android install prompt
    const handler=(e)=>{
      e.preventDefault();
      setDeferredPrompt(e);
      if(!dismissed) setTimeout(()=>setShow(true),5000);
    };
    window.addEventListener("beforeinstallprompt",handler);
    return()=>window.removeEventListener("beforeinstallprompt",handler);
  },[dismissed]);

  const dismiss=()=>{
    try{localStorage.setItem("rv-pwa-dismissed","1");}catch{}
    setDismissed(true);setShow(false);
  };

  const install=async()=>{
    if(deferredPrompt){
      deferredPrompt.prompt();
      const{outcome}=await deferredPrompt.userChoice;
      if(outcome==="accepted")setIsInstalled(true);
      setDeferredPrompt(null);
    }
    setShow(false);
  };

  if(!show||dismissed||isInstalled) return null;

  return(
    <div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",zIndex:9500,width:"calc(100% - 32px)",maxWidth:380,background:T.bgMid,borderRadius:16,border:`1px solid ${T.accent}44`,boxShadow:"0 8px 40px rgba(0,0,0,0.4)",padding:16,animation:"slideUp .3s ease"}}>
      <style>{`@keyframes slideUp{from{transform:translateX(-50%) translateY(20px);opacity:0}to{transform:translateX(-50%) translateY(0);opacity:1}}`}</style>
      <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
        {/* App icon */}
        <div style={{width:52,height:52,borderRadius:12,background:"linear-gradient(135deg,#0a1628,#1a3a5c)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,border:`1px solid ${T.accent}33`}}>
          <span style={{fontSize:28}}>🚐</span>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:2}}>Add to Home Screen</div>
          <div style={{fontSize:12,color:T.muted,lineHeight:1.5,marginBottom:10}}>
            {isIOS
              ?"Tap the share button below then 'Add to Home Screen' to install RV Travel Mate on your iPhone."
              :"Install RV Travel Mate for quick access — works offline and launches like a native app."
            }
          </div>
          {isIOS?(
            <div style={{fontSize:11,color:T.muted,background:T.bgLite,borderRadius:8,padding:"8px 10px",lineHeight:1.6}}>
              1. Tap <strong>Share</strong> (the box with arrow ↑)<br/>
              2. Scroll down and tap <strong>Add to Home Screen</strong><br/>
              3. Tap <strong>Add</strong> in the top right
            </div>
          ):(
            <div style={{display:"flex",gap:8}}>
              <button onClick={install} style={{flex:1,padding:"9px",background:T.accent,color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>
                📲 Install App
              </button>
            </div>
          )}
        </div>
        <button onClick={dismiss} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:18,flexShrink:0,padding:"0 2px",lineHeight:1}}>✕</button>
      </div>
    </div>
  );
}


// ── Route Path Analyzer ───────────────────────────────────────────
// Samples key cities along the OSRM route using reverse geocoding
// Returns a string like "I-65 N through Birmingham AL, Nashville TN, Louisville KY"
async function analyzeRoutePath(routeCoords, stopNames=[]){
  if(!routeCoords||routeCoords.length<2) return null;
  try{
    // Sample ~8 evenly spaced points along the route (skip start/end — those are stops)
    const total=routeCoords.length;
    const step=Math.floor(total/9);
    const sampleIndices=[step,step*2,step*3,step*4,step*5,step*6,step*7,step*8]
      .filter(i=>i>0&&i<total-1);

    const cities=[];
    for(const idx of sampleIndices){
      const [lon,lat]=routeCoords[idx];
      try{
        await new Promise(r=>setTimeout(r,300)); // rate limit Nominatim
        const r=await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&zoom=8`,
          {headers:{"Accept-Language":"en","User-Agent":"RVTravelMate/1.0"}}
        );
        if(r.ok){
          const d=await r.json();
          const city=d.address?.city||d.address?.town||d.address?.county||"";
          const state=d.address?.state_code||d.address?.state||"";
          if(city&&state){
            const label=city+", "+state;
            if(!cities.includes(label)&&!stopNames.some(s=>s.toLowerCase().includes(city.toLowerCase()))){
              cities.push(label);
            }
          }
        }
      }catch{}
    }
    return cities.length>0?cities.join(" → "):null;
  }catch{return null;}
}

// ── AI Context Builder ─────────────────────────────────────────────
// Builds a rich context string from user's trip data for every AI call
function buildTripContext({stops=[],vehicle={},prefs={},fuel={},finance={},memberships={},trip={}}){
  const home=stops.find(s=>s.type==="home");
  const activeStops=stops.filter(s=>s.active&&s.name&&s.type!=="home");
  const stopList=activeStops.map((s,i)=>`${i+1}. ${s.name}${s.state?", "+s.state:""} (${s.minNights||s.nights||0} nights${s.distFromPrev?", "+Math.round(s.distFromPrev)+" mi from prev":""})${s.notes?" — "+s.notes:""}`).join("\n");
  const clubs=[
    memberships.goodSam&&"Good Sam",
    memberships.harvestHosts&&"Harvest Hosts",
    memberships.passportAmerica&&"Passport America",
    memberships.thousandTrails&&"Thousand Trails",
    memberships.koa&&"KOA Rewards",
  ].filter(Boolean).join(", ")||"None";
  const pets=(memberships.pets||[]).map(p=>p.name).join(", ")||"None";
  // Include route path cities if available from OSRM
  const routePath=_currentRouteCoords&&_currentRouteCoords.length>2
    ?`

ACTUAL ROAD ROUTE (from GPS routing):
Route passes through: ${
        _currentRouteStops.length>0?_currentRouteStops.join(" → "):"see stops above"
      }
Cities along the way will be determined from the map route. Use this to suggest stops that are ACTUALLY on the route, not off to the side.`
    :"";

  // Build leg-by-leg distances and directions
  const legInfo=activeStops.map((s,i)=>{
    const prev=i===0?home:activeStops[i-1];
    const mi=Math.round(s.distFromPrev||0);
    const tankMi=Math.round((vehicle.mpg||8)*(vehicle.tankGallons||100)*0.85);
    const needsFuel=mi>tankMi*0.8;
    return `  Stop ${i+1}: ${prev?.name||"Home"} → ${s.name}${s.state?", "+s.state:""} (${mi} mi${needsFuel?" — ⚠ EXCEEDS 80% TANK RANGE, fuel stop needed":""})`
  }).join("\n");

  return `
RV TRAVEL MATE — USER TRIP CONTEXT
====================================
VEHICLE: ${vehicle.rvType||"RV"}, ${vehicle.fuelType||"Diesel"}, ${vehicle.mpg||8} MPG, ${vehicle.tankGallons||100} gal tank (~${Math.round((vehicle.mpg||8)*(vehicle.tankGallons||100)*0.85)} mile range on 85% tank)
RV LENGTH: ${vehicle.rvLength||36} ft, HEIGHT: ${vehicle.rvHeightFt||13}ft ${vehicle.rvHeightIn||0}in
TOWING: ${vehicle.towVehicle?"Yes — "+vehicle.towTruckMake+" "+vehicle.towTruckModel:"No"}
HOME BASE: ${home?.homeCity||home?.name||"Not set"}${home?.state?", "+home.state:""}
DEPARTURE DATE: ${home?.arriveDate||"Not set"}
TOTAL STOPS: ${activeStops.length}
TOTAL MILES: ${Math.round(trip.totMi||0)} mi
BUDGET: $${prefs?.dailyBudget||0}/day target
MEMBERSHIPS: ${clubs}
PETS: ${pets}
MAX DAILY DRIVE: ${prefs?.maxDailyMiles||500} miles
AVG SPEED: ${prefs?.avgSpeed||60} mph

ROUTE STOPS AND DISTANCES:
${legInfo||stopList||"No stops added yet"}${routePath}

IMPORTANT: Only suggest stops that are geographically BETWEEN the listed stops in the direction of travel. Do NOT suggest stops south or east of the home base when traveling north. The route goes from ${home?.homeCity||home?.name||"home"} northward through the stops listed above.

APP FEATURES AVAILABLE:
- Trip planning with unlimited stops and auto-calculated driving miles
- Interactive map with campground, fuel stop, and RV park filters
- Near Stops finder (Cabela's, Bass Pro, Scheels, dog parks, gyms, emergency vet)
- Free camping / boondocking finder
- Fuel calculator with tank range warnings
- Weight & load calculator (GVWR, payload, tongue weight)
- Propane tracker with days-remaining estimate
- Tire pressure log with temperature correction
- Campground journal with photo uploads and shareable public link
- Maintenance log for RV and toys (motorcycles, ATVs, SxS)
- Pet section with potty break reminders and nearby vet/park finder
- Gym membership tracker with nearby location finder
- Home watch and mail hold manager
- Medication tracker with refill reminders
- Emergency contacts with printable response card
- Cell coverage notes and dead zone log
- Dump station finder with personal notes
- Trip cost split calculator
- Fuel card and discount program tracker
- AI trip narrative generator
- Events and causes (Dough 4 Joe charity motorcycle run featured)
`.trim();
}

// ── APP SYSTEM PROMPT ──────────────────────────────────────────────
const APP_SYSTEM_PROMPT=`You are the RV Travel Mate AI assistant — a knowledgeable, friendly co-pilot built into the RV Travel Mate app by Horizn Software.

You know everything about the app's features and help users get the most out of it. You also have deep expertise in RV travel, full-time RV living, trip planning, boondocking, campground selection, fuel optimization, RV maintenance, and the RV lifestyle.

PERSONALITY: Warm, practical, and conversational. You speak like an experienced RVer who also happens to know the app inside and out. Use bullet points for lists. Be concise — RVers are busy people.

WHEN SUGGESTING STOPS OR LOCATIONS:
- Always consider the user's route and suggest places that are near or on their path
- Mention distance from their route (e.g. "0.3 miles off I-70")
- Include practical details: hours, cost, pet policy, hookups available
- For boondocking: mention BLM land, Harvest Hosts, Cracker Barrel, Walmart, Cabela's, Bass Pro Shops (most allow free overnight), Flying J/Pilot (some allow), rest areas (state-dependent)
- For Cabela's specifically: most locations allow free overnight parking in designated RV spots — always worth checking their lot

CRITICAL RULE — ALWAYS USE JSON BLOCKS:
Whenever you suggest ANY specific stops, locations, or route changes — you MUST include the appropriate JSON block. Never just describe stops in text without the JSON. The user cannot add stops with one tap unless you include the JSON.

FOR ADDING NEW STOPS — use ADD_STOPS:
<ADD_STOPS>
[
  {"name":"Location Name","state":"ST","minNights":1,"notes":"Why this stop is great","lat":0.0,"lng":0.0,"afterStop":"Name of existing stop this should go after, or first, or last"}
]
</ADD_STOPS>

FOR MODIFYING EXISTING STOP NIGHTS/DETAILS — use MODIFY_STOPS:
<MODIFY_STOPS>
[
  {"name":"Exact name of existing stop","minNights":3,"notes":"Updated notes if any"}
]
</MODIFY_STOPS>

You can use BOTH blocks in the same response — first ADD_STOPS for new stops, then MODIFY_STOPS for changes to existing ones.

RULES:
- ALWAYS include ADD_STOPS when you suggest any new location, even if the user just says "make it more leisurely" or "add a boondocking stop"
- ALWAYS include MODIFY_STOPS when you suggest changing nights at existing stops
- "afterStop" = exact name of the stop to insert after, or "home", or "last"
- Use real coordinates (lat/lng) — approximate is fine, just not 0.0
- minNights: 0=fuel only, 1=one night, 2-3=short stay, 4-7=extended stay
- For "more leisurely" trips: increase minNights on existing stops AND add boondocking/scenic stops between them
- For boondocking stops: use real Cabela's, Walmart, Cracker Barrel, or BLM locations near the route

COST AWARENESS: The user's trip data and route is provided with each question. Use it to give personalized, specific suggestions rather than generic advice.

DIRECTION OF TRAVEL IS CRITICAL:
- Always read the route stops in ORDER — that is the direction of travel
- NEVER suggest stops that are in the WRONG direction (e.g. south of home when traveling north)
- When adding stops "between" two existing stops, they must be geographically between those two stops
- If the route goes Foley AL → Louisville KY → Fergus Falls MN → Sturgis SD, stops must be along that path ONLY
- Ardmore OK, Dodge City KS, or any city not on the route path should NEVER be suggested unless the user explicitly asks about them`;

// ── Specialized AI call functions ──────────────────────────────────
async function callAIWithContext(callAI, prompt, tripContext, mode="general"){
  const systemPrompts={
    planner: APP_SYSTEM_PROMPT+"\n\nFOCUS: You are an expert RV route planner. When asked to plan a route or add stops, ALWAYS respond with an ADD_STOPS block containing all suggested stops. Plan geographically logical routes. For fuel stops: calculate based on the vehicle MPG and tank size to determine where refueling is needed. For multi-day routes: suggest a mix of free camping (Cabela's, Walmart, BLM) and paid campgrounds. Be specific about locations with real place names and accurate coordinates. After the ADD_STOPS block, briefly explain your reasoning for each stop choice.",
    fuel: APP_SYSTEM_PROMPT+"\n\nFOCUS: Fuel stop planning. Calculate exactly where the vehicle needs to refuel based on its MPG, tank size, and the distances between stops. Suggest fuel stops at major truck stop chains (Love's, Pilot, Flying J, TA) where Good Sam and other cards apply. ALWAYS include an ADD_STOPS block with the fuel stops inserted at the correct positions in the route.",
    boondock: APP_SYSTEM_PROMPT+"\n\nFOCUS: Free and low-cost overnight camping. Prioritize: 1) Cabela's/Bass Pro (free, most locations), 2) Cracker Barrel (free, call ahead), 3) Walmart (free where allowed, call ahead), 4) BLM/National Forest land (free, dispersed camping), 5) Harvest Hosts (membership required). When suggesting boondocking spots, ALWAYS include an ADD_STOPS block so user can add them with one tap.",
    campground: APP_SYSTEM_PROMPT+"\n\nFOCUS: Campground recommendations. Consider the user's memberships (Good Sam, KOA, Thousand Trails, Passport America, Harvest Hosts). When suggesting specific campgrounds, include an ADD_STOPS block.",
    budget: APP_SYSTEM_PROMPT+"\n\nFOCUS: Budget analysis and cost reduction. Compare the user's planned costs to typical full-time RVer averages ($1,500-3,000/month). Give specific, actionable suggestions.",
    general: APP_SYSTEM_PROMPT,
  };
  const fullPrompt=`${tripContext}\n\nUSER QUESTION:\n${prompt}`;
  return await callAI(fullPrompt, systemPrompts[mode]||systemPrompts.general);
}

// ── Parse AI response for stop suggestions (single or multiple) ───
function parseAIStopSuggestions(aiResponse){
  if(!aiResponse) return null;
  // Try new multi-stop format first
  const multiMatch=aiResponse.match(/<ADD_STOPS>([\s\S]*?)<\/ADD_STOPS>/);
  if(multiMatch){
    try{
      const arr=JSON.parse(multiMatch[1].trim());
      if(Array.isArray(arr)&&arr.length>0){
        return arr.map(data=>({
          id:uid(),
          name:data.name||"AI Suggested Stop",
          state:data.state||"",
          type:"stop",
          active:true,
          minNights:parseInt(data.minNights)||1,
          maxNights:parseInt(data.minNights)||1,
          notes:data.notes||"",
          lat:parseFloat(data.lat)||null,
          lng:parseFloat(data.lng)||null,
          afterStop:data.afterStop||"last",
          arriveDate:"",departDate:"",
          fixedDates:false,distFromPrev:0,
        }));
      }
    }catch(e){console.warn("Failed to parse ADD_STOPS JSON:",e);}
  }
  // Fall back to legacy single-stop format
  const match=aiResponse.match(/<ADD_STOP>([\s\S]*?)<\/ADD_STOP>/);
  if(match){
    try{
      const data=JSON.parse(match[1].trim());
      return[{
        id:uid(),
        name:data.name||"AI Suggested Stop",
        state:data.state||"",
        type:"stop",active:true,
        minNights:parseInt(data.minNights)||1,
        maxNights:parseInt(data.minNights)||1,
        notes:data.notes||"",
        lat:parseFloat(data.lat)||null,
        lng:parseFloat(data.lng)||null,
        afterStop:"last",
        arriveDate:"",departDate:"",
        fixedDates:false,distFromPrev:0,
      }];
    }catch{}
  }
  return null;
}

// Parse MODIFY_STOPS block from AI response
function parseAIStopModifications(aiResponse){
  if(!aiResponse) return null;
  const match=aiResponse.match(/<MODIFY_STOPS>([\s\S]*?)<\/MODIFY_STOPS>/);
  if(!match) return null;
  try{
    const arr=JSON.parse(match[1].trim());
    return Array.isArray(arr)?arr:null;
  }catch{return null;}
}

// Apply AI modifications to existing stops
function applyAIModifications(existingStops, modifications){
  if(!modifications||!modifications.length) return existingStops;
  return existingStops.map(stop=>{
    const mod=modifications.find(m=>
      m.name&&stop.name&&
      stop.name.toLowerCase().includes(m.name.toLowerCase())
    );
    if(!mod) return stop;
    return{
      ...stop,
      minNights:mod.minNights!==undefined?parseInt(mod.minNights):stop.minNights,
      maxNights:mod.minNights!==undefined?parseInt(mod.minNights):stop.maxNights,
      notes:mod.notes||stop.notes,
    };
  });
}

// Smart stop insertion — respects "afterStop" field from AI
function insertAIStops(existingStops, newStops){
  let result=[...existingStops];
  for(const ns of newStops){
    const after=(ns.afterStop||"last").toLowerCase();
    if(after==="last"||after==="end"){
      // Append before any return-home stop, otherwise at end
      result=[...result,ns];
    } else if(after==="home"||after==="first"){
      // Insert right after home stop
      const homeIdx=result.findIndex(s=>s.type==="home");
      const insertAt=homeIdx>=0?homeIdx+1:1;
      result=[...result.slice(0,insertAt),ns,...result.slice(insertAt)];
    } else {
      // Find the named stop and insert after it
      const idx=result.findIndex(s=>
        s.name&&s.name.toLowerCase().includes(after.toLowerCase())
      );
      if(idx>=0){
        result=[...result.slice(0,idx+1),ns,...result.slice(idx+1)];
      } else {
        // Fallback: append
        result=[...result,ns];
      }
    }
  }
  return result;
}

// ── AI Assistant Panel ─────────────────────────────────────────────
function AIAssistantPanel({stops=[],vehicle={},prefs={},fuel={},finance={},memberships={},trip={},callAI,aiPurchased,aiFreeCalls,onShowAIUpgrade,onAddStop,onRequestMapRoute}){
  const T=useTheme();
  const [mode,setMode]=useState("planner");
  const [input,setInput]=useState("");
  const [messages,setMessages]=useState([]);
  const [loading,setLoading]=useState(false);
  const [pendingStops,setPendingStops]=useState(null);
  const [pendingModifications,setPendingModifications]=useState(null);
  const [routeReady,setRouteReady]=useState(()=>!!_currentRouteCoords&&_currentRouteCoords.length>1);
  const [calcingRoute,setCalcingRoute]=useState(false);
  const messagesEndRef=useRef(null);

  // Auto-calculate route when panel opens if not already done
  useEffect(()=>{
    if(!_currentRouteCoords||_currentRouteCoords.length<2){
      const namedStops=stops.filter(s=>s.active&&s.name&&(s.lat||s.lon));
      if(namedStops.length>=2){
        setCalcingRoute(true);
        // Geocode any stops missing coords then calculate route
        const calcRoute=async()=>{
          try{
            // Geocode SEQUENTIALLY (not Promise.all) to respect Nominatim's
            // 1 req/sec rate limit — parallel calls risk a temporary IP ban
            const withCoords=[];
            for(const s of stops.filter(s=>s.active&&s.name)){
              if(s.lat&&s.lon){withCoords.push(s);continue;}
              const r=await geocodeStop(s);
              withCoords.push(r?{...s,lat:r[0],lon:r[1]}:s);
            }
            const valid=withCoords.filter(s=>s.lat&&s.lon).map(s=>[s.lon,s.lat]);
            if(valid.length>=2){
              const coords=await roadRoute(valid);
              if(coords){
                _currentRouteCoords=coords;
                _currentRouteStops=withCoords.filter(s=>s.name).map(s=>s.name);
                setRouteReady(true);
              }
            }
          }catch(e){console.warn("AI panel route calc failed:",e);}
          setCalcingRoute(false);
        };
        calcRoute();
      }
    }
  },[]);

  const MODES=[
    {id:"general",icon:"💬",label:"Ask Anything"},
    {id:"planner",icon:"🗺",label:"Plan My Route"},
    {id:"fuel",icon:"⛽",label:"Fuel Stops"},
    {id:"boondock",icon:"🌲",label:"Free Camping"},
    {id:"campground",icon:"🏕",label:"Campgrounds"},
    {id:"budget",icon:"💰",label:"Budget"},
  ];

  const QUICK_PROMPTS={
    planner:[
      "Plan me a 2-week loop starting from my home through the Smoky Mountains and back",
      "Add fuel stops to my existing route based on my tank range",
      "Suggest 3 overnight stops between my first and second stop",
      "Build me a scenic route from my home to my first stop with interesting places along the way",
    ],
    fuel:["Where should I fill up between my stops to save the most?","Add fuel stops to my route based on my tank range","Which fuel cards save the most for my route?"],
    boondock:["Find me free overnight parking near my stops and add the best ones to my route","Are there any Cabela's near my route for free camping?","Add a boondocking stop between each of my main stops"],
    campground:["Suggest campgrounds near each of my stops","Which stops have Good Sam discounts nearby?","Find pet-friendly campgrounds on my route and add them"],
    budget:["How does my trip budget compare to average RV costs?","Where can I cut costs on this trip?","What's my estimated total trip cost?"],
    general:["What features does this app have?","How do I use the propane tracker?","How do I publish my travel journal?"],
  };

  useEffect(()=>{
    messagesEndRef.current?.scrollIntoView({behavior:"smooth"});
  },[messages]);

  const send=async(text)=>{
    const q=text||input.trim();
    if(!q||loading) return;
    const canUse=aiPurchased||(aiFreeCalls===null)||(aiFreeCalls>0);
    if(!canUse){onShowAIUpgrade&&onShowAIUpgrade();return;}
    setInput("");
    setMessages(prev=>[...prev,{role:"user",text:q}]);
    setLoading(true);
    const ctx=buildTripContext({stops,vehicle,prefs,fuel,finance,memberships,trip});
    const response=await callAIWithContext(callAI,q,ctx,mode);
    setLoading(false);
    if(!response){
      setMessages(prev=>[...prev,{role:"ai",text:"Sorry, I couldn't get a response. Please try again."}]);
      return;
    }
    // Check for stop suggestion
    const suggested=parseAIStopSuggestions(response);
    if(suggested&&suggested.length>0) setPendingStops(suggested);
    const modifications=parseAIStopModifications(response);
    if(modifications&&modifications.length>0) setPendingModifications(modifications);
    // Clean response — remove all JSON blocks from display
    const displayText=response
      .replace(/<ADD_STOPS>[\s\S]*?<\/ADD_STOPS>/g,"")
      .replace(/<ADD_STOP>[\s\S]*?<\/ADD_STOP>/g,"")
      .replace(/<MODIFY_STOPS>[\s\S]*?<\/MODIFY_STOPS>/g,"")
      .trim();
    const hasChanges=(!!suggested&&suggested.length>0)||(!!modifications&&modifications.length>0);
    setMessages(prev=>[...prev,{role:"ai",text:displayText,hasStop:hasChanges}]);
  };

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100%",minHeight:400,maxHeight:"80vh"}}>
      <SecHead icon="🤖" title="AI Travel Assistant" sub="Ask anything about your trip, get personalized suggestions, or let AI find your next stop"/>

      {/* Route status banner */}
      {calcingRoute&&<div style={{background:T.accent+"18",border:`1px solid ${T.accent}33`,borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:12,color:T.accent,display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
        <span style={{animation:"spin 1s linear infinite",display:"inline-block"}}>⟳</span>
        Calculating your route for better suggestions...
      </div>}
      {!calcingRoute&&routeReady&&messages.length===0&&<div style={{background:T.free+"11",border:`1px solid ${T.free}33`,borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:12,color:T.free,flexShrink:0}}>
        ✓ Route calculated — AI has your full route map for accurate suggestions
      </div>}
      {!calcingRoute&&!routeReady&&stops.filter(s=>s.active&&s.name).length<2&&messages.length===0&&<div style={{background:"#f59e0b11",border:"1px solid #f59e0b33",borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:12,color:"#b45309",flexShrink:0}}>
        💡 Add at least 2 stops to your trip first, then AI can plan your route accurately
      </div>}

      {/* Mode selector */}
      <div style={{display:"flex",gap:6,overflowX:"auto",scrollbarWidth:"none",paddingBottom:8,marginBottom:8,flexShrink:0}}>
        {MODES.map(m=>(
          <button key={m.id} onClick={()=>setMode(m.id)}
            style={{padding:"6px 12px",borderRadius:20,border:`1px solid ${mode===m.id?T.accent:T.border}`,background:mode===m.id?T.accent+"22":"transparent",color:mode===m.id?T.accent:T.muted,fontSize:12,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap",flexShrink:0,display:"flex",alignItems:"center",gap:5}}>
            {m.icon} {m.label}
          </button>
        ))}
      </div>

      {/* Quick prompts */}
      {messages.length===0&&QUICK_PROMPTS[mode]&&(
        <div style={{marginBottom:12,flexShrink:0}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:6,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Quick questions</div>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {QUICK_PROMPTS[mode].map((q,i)=>(
              <button key={i} onClick={()=>send(q)}
                style={{padding:"8px 12px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,textAlign:"left",fontSize:12,color:T.text,cursor:"pointer",lineHeight:1.4}}>
                {q}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Messages */}
      <div style={{flex:1,overflowY:"auto",marginBottom:12,display:"flex",flexDirection:"column",gap:10}}>
        {messages.map((msg,i)=>(
          <div key={i} style={{display:"flex",gap:8,alignItems:"flex-start",flexDirection:msg.role==="user"?"row-reverse":"row"}}>
            <div style={{width:28,height:28,borderRadius:"50%",background:msg.role==="user"?T.accent:T.bgLite,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,flexShrink:0,border:`1px solid ${T.border}`}}>
              {msg.role==="user"?"👤":"🤖"}
            </div>
            <div style={{maxWidth:"82%",padding:"10px 12px",borderRadius:12,background:msg.role==="user"?T.accent+"22":T.bgLite,border:`1px solid ${msg.role==="user"?T.accent+"44":T.border}`,fontSize:13,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap"}}>
              {msg.text}
            </div>
          </div>
        ))}
        {loading&&(
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <div style={{width:28,height:28,borderRadius:"50%",background:T.bgLite,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,border:`1px solid ${T.border}`}}>🤖</div>
            <div style={{padding:"10px 14px",background:T.bgLite,borderRadius:12,border:`1px solid ${T.border}`,fontSize:13,color:T.muted}}>
              <span style={{animation:"pulse 1.5s infinite"}}>Thinking...</span>
            </div>
          </div>
        )}
        <div ref={messagesEndRef}/>
      </div>

      {/* Pending stop suggestions — single or multiple */}
      {pendingStops&&pendingStops.length>0&&(
        <div style={{marginBottom:10,padding:"12px 14px",background:T.free+"11",border:`2px solid ${T.free}44`,borderRadius:12,flexShrink:0}}>
          <div style={{fontSize:12,fontWeight:700,color:T.free,marginBottom:8}}>
            📍 AI Suggested {pendingStops.length===1?"Stop":pendingStops.length+" Stops"}
          </div>
          {pendingStops.map((s,i)=>(
            <div key={s.id} style={{marginBottom:6,padding:"8px 10px",background:T.bgLite,borderRadius:8,border:`1px solid ${T.border}`}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text}}>{s.name}{s.state?", "+s.state:""}</div>
              {s.minNights>0&&<div style={{fontSize:11,color:T.muted}}>{s.minNights} night{s.minNights!==1?"s":""}{s.afterStop&&s.afterStop!=="last"?" · after "+s.afterStop:""}</div>}
              {s.notes&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic",marginTop:2}}>{s.notes}</div>}
            </div>
          ))}
          <div style={{display:"flex",gap:8,marginTop:10}}>
            <button onClick={()=>{
              if(onAddStop){
                const names=pendingStops.map(s=>s.name).join(", ");
                onAddStop(pendingStops, pendingModifications||[]);
                const modMsg=pendingModifications&&pendingModifications.length>0?" and updated "+pendingModifications.length+" existing stop"+(pendingModifications.length!==1?"s":""):"";
                setMessages(prev=>[...prev,{role:"ai",text:"✓ Added "+pendingStops.length+" stop"+(pendingStops.length!==1?"s":"")+" to your route: "+names+modMsg+". Head to the Stops tab and tap Recalculate Dates to update your timeline."}]);
              }
              setPendingStops(null);
              setPendingModifications(null);
            }} style={{flex:1,padding:"9px",background:T.free,color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>
              ✓ Add {pendingStops.length===1?"Stop":"All "+pendingStops.length+" Stops"} to Route
            </button>
            <button onClick={()=>setPendingStops(null)}
              style={{padding:"9px 14px",background:"none",border:`1px solid ${T.border}`,borderRadius:8,fontSize:12,color:T.muted,cursor:"pointer"}}>
              Skip
            </button>
          </div>
        </div>
      )}

      {/* Pending stop modifications */}
      {pendingModifications&&pendingModifications.length>0&&(
        <div style={{marginBottom:10,padding:"12px 14px",background:"#f59e0b11",border:`2px solid #f59e0b44`,borderRadius:12,flexShrink:0}}>
          <div style={{fontSize:12,fontWeight:700,color:"#f59e0b",marginBottom:8}}>
            ✏️ AI Suggests Updating {pendingModifications.length} Existing Stop{pendingModifications.length!==1?"s":""}
          </div>
          {pendingModifications.map((m,i)=>(
            <div key={i} style={{marginBottom:6,padding:"8px 10px",background:T.bgLite,borderRadius:8,border:`1px solid ${T.border}`}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text}}>{m.name}</div>
              {m.minNights!==undefined&&<div style={{fontSize:11,color:T.muted}}>Change to {m.minNights} night{m.minNights!==1?"s":""}</div>}
              {m.notes&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic"}}>{m.notes}</div>}
            </div>
          ))}
          <div style={{display:"flex",gap:8,marginTop:10}}>
            <button onClick={()=>{
              if(onAddStop&&pendingModifications){
                onAddStop([],pendingModifications);
                setMessages(prev=>[...prev,{role:"ai",text:"✓ Updated "+pendingModifications.length+" stop"+(pendingModifications.length!==1?"s":"")+" on your route."}]);
              }
              setPendingModifications(null);
            }} style={{flex:1,padding:"9px",background:"#f59e0b",color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>
              ✓ Apply Changes
            </button>
            <button onClick={()=>setPendingModifications(null)}
              style={{padding:"9px 14px",background:"none",border:`1px solid ${T.border}`,borderRadius:8,fontSize:12,color:T.muted,cursor:"pointer"}}>
              Skip
            </button>
          </div>
        </div>
      )}

      {/* Input */}
      <div style={{display:"flex",gap:8,flexShrink:0}}>
        <input
          value={input}
          onChange={e=>setInput(e.target.value)}
          onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();send();}}}
          placeholder={`Ask about ${mode==="planner"?"your route plan — or say 'plan me a trip to...'" :mode==="fuel"?"fuel stops":mode==="boondock"?"free camping":mode==="campground"?"campgrounds":mode==="budget"?"your budget":"your trip"}...`}
          style={{flex:1,background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"10px 14px",fontSize:13,outline:"none",fontFamily:"inherit"}}
        />
        <button onClick={()=>send()} disabled={loading||!input.trim()}
          style={{padding:"10px 16px",background:loading?T.border:T.accent,color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:14,cursor:loading?"not-allowed":"pointer",flexShrink:0}}>
          {loading?"⏳":"Send"}
        </button>
      </div>
      {aiFreeCalls!==null&&!aiPurchased&&<div style={{fontSize:10,color:T.muted,textAlign:"center",marginTop:6}}>{aiFreeCalls} free AI {aiFreeCalls===1?"use":"uses"} remaining</div>}
    </div>
  );
}

// ── SaveConsentModal ───────────────────────────────────────────────
function SaveConsentModal({onDecide}){
  const T=useTheme();
  return<div style={{position:"fixed",inset:0,background:"#000a",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
    <div className="modal-anim" style={{background:T.bgMid,border:`1px solid ${T.accent}`,borderRadius:12,padding:32,maxWidth:480,width:"100%"}}>
      <div style={{fontSize:36,marginBottom:12,textAlign:"center"}}>💾</div>
      <h2 style={{fontFamily:T.F.head,fontSize:26,letterSpacing:2,color:T.accent,textAlign:"center",marginBottom:12}}>Save Your Trip?</h2>
      <p style={{fontSize:14,color:T.muted,lineHeight:1.7,marginBottom:8}}>Would you like your trip stops, preferences, and settings saved in this browser?</p>
      <div style={{background:T.bgLite,borderRadius:8,padding:"10px 14px",marginBottom:20,border:`1px solid ${T.border}`}}>
        <div style={{fontSize:12,color:T.free,fontWeight:600,marginBottom:4}}>🔒 Privacy Note</div>
        <div style={{fontSize:12,color:T.muted,lineHeight:1.6}}>Your <strong style={{color:T.text}}>income is never saved</strong> - it resets each visit. Only trip data is saved locally. Nothing sent to any server.</div>
      </div>
      <div style={{display:"flex",gap:10,flexDirection:"column"}}>
        <Btn variant="primary" onClick={()=>onDecide(true)} style={{justifyContent:"center",fontSize:14,padding:"12px 16px"}}>✓ Yes, save my trip data</Btn>
        <Btn variant="ghost" onClick={()=>onDecide(false)} style={{justifyContent:"center",fontSize:13}}>No thanks - I'll use Export/Import</Btn>
      </div>
    </div>
  </div>;
}

// ── Finance calc ───────────────────────────────────────────────────
function calcFinance(f){return{mth:parseFloat(f.monthlyTakeHome)||0};}

function calcTrip(stops,vehicle,fuel,finance,prefs){
  const active=stops.filter(s=>s.active);
  const mpg=Math.max(parseFloat(vehicle.mpg)||8,1),fp=Math.max(parseFloat(fuel.avgPricePerGallon)||3.30,0.01);
  const spd=Math.max(parseFloat(prefs.avgSpeedMph)||60,1),maxHrs=parseFloat(prefs.maxDriveHours)||7;
  const maxDailyMiles=spd*maxHrs;
  let totMi=0,totGal=0,totFuel=0,totNights=0,totLodge=0,runDate="";
  const ps=active.map((s,i)=>{
    const mi=parseFloat(s.distFromPrev)||0,price=parseFloat(s.fuelPriceOverride)||fp;
    const isHikeVehicle=vehicle.rvType==="🥾 Hike / Walk";
    const gal=isHikeVehicle?0:(mpg>0?mi/mpg:0),fc=isHikeVehicle?0:gal*price;
    const hikeHrs=isHikeVehicle&&spd>0?mi/spd:0;
    totMi+=mi;totGal+=gal;totFuel+=fc;
    const daysNeeded=driveDaysNeeded(mi,maxDailyMiles),driveHrsEst=spd>0?mi/spd:0;
    // Multi-driver: no daily limit warnings - two drivers can share any distance
    const exceedsDaily=prefs.multiDriver?false:(mi>maxDailyMiles);
    const milesPerDay=daysNeeded>0?Math.ceil(mi/daysNeeded):0;
    let nights=0,arr="",dep="",travelDate="",departDayOfWeek="";
    if(s.type==="home"){arr=s.arriveDate||"";nights=0;dep=arr;travelDate=arr;} // home: runDate=arriveDate always
    else if(s.fixedDates&&s.arriveDate&&s.departDate){arr=s.arriveDate;dep=s.departDate;nights=Math.max(0,daysBetween(s.arriveDate,s.departDate));travelDate=arr;}
    else{const bd=runDate||"";const nextArrival=bd?addDays(bd,1):"";
      travelDate=nextArrival?nextTravelDay(nextArrival,prefs.travelDays):"";arr=travelDate?addDays(travelDate,Math.max(0,daysNeeded-1)):(s.arriveDate||"");if(s.arriveDate&&!travelDate)arr=s.arriveDate;nights=parseInt(s.minNights)||0;dep=arr?addDays(arr,nights):"";}
    if(travelDate){const d=new Date(travelDate+"T00:00:00");departDayOfWeek=DOW[d.getDay()];}
    runDate=dep||runDate;
    // Monthly rate support: use monthlyRate×numMonths when isMonthlyRate
    const effectiveNights=s.isMonthlyRate?(parseInt(s.numMonths)||1)*30:nights;
    const rate=s.isFree?0:(s.isMonthlyRate?(parseFloat(s.monthlyRate)||0)*(parseInt(s.numMonths)||1):((parseFloat(s.nightlyRate)||0)*nights));
    const lc=s.isFree?0:(s.isMonthlyRate?rate:rate); // already computed
    if(s.type!=="home"&&s.type!=="waypoint"){totNights+=effectiveNights;totLodge+=lc;}
    // Fuel range warning: flag if leg exceeds 75% of full tank range
    const tankRange=mpg*Math.max(parseFloat(vehicle.tankGallons)||100,1);
    const fuelRangeWarning=!isHikeVehicle&&mi>tankRange*0.75&&mi>0;
    const milesUntilEmpty=tankRange; // full tank range
    return{...s,mi,gal,fc,nights,rate,lc,arr,dep,daysNeeded,driveHrsEst,exceedsDaily,milesPerDay,travelDate,departDayOfWeek,hikeHrs,fuelRangeWarning,tankRange:Math.round(tankRange)};
  });
  const{mth}=calcFinance(finance),mo=totNights/30;
  // Groceries: use % of income if entered, else $600/month estimate for full-time RV
  const grocEst=mth>0?mth*0.20*mo:600*mo;
  const misc={propane:90*mo,maint:150*mo,groceries:grocEst,entertain:200*mo,emergency:(totFuel+totLodge)*0.10};
  const totMisc=Object.values(misc).reduce((a,b)=>a+b,0),grand=totFuel+totLodge+totMisc;
  const totalDays=totNights>0?totNights:1;
  const monthsOfIncome=mth>0?grand/mth:null;
  return{stops:ps,totMi,totGal,totFuel,totNights,totLodge,misc,totMisc,grand,cpd:grand/totalDays,cpm:totMi>0?grand/totMi:0,maxDailyMiles,monthsOfIncome};
}

const STOP_TYPES=[{v:"home",l:"🏠 Home / Departure"},{v:"family",l:"👨‍👩‍👧 Family Visit"},{v:"tourist",l:"🏔 Tourist/Sightseeing"},{v:"workhub",l:"💻 Remote Work Hub"},{v:"event",l:"🎸 Event / Festival"},{v:"transit",l:"🚐 Transit / Overnight"},{v:"free",l:"🌲 Free Camping"}];
const STCOL={home:"#9494a0",family:"#2a8a54",tourist:"#9b59b6",workhub:"#2255a4",event:"#f5c518",transit:"#4a4a56",free:"#27ae60"};
const US_STATES=["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

// ── ChangePasswordCard ───────────────────────────────────────────
function ChangePasswordCard(){
  const T=useTheme();
  const [newPwd,setNewPwd]=useState("");
  const [pwdMsg,setPwdMsg]=useState("");
  const [pwdErr,setPwdErr]=useState("");
  const [saving,setSaving]=useState(false);
  const doChange=async()=>{
    if(newPwd.length<6){setPwdErr("Password must be at least 6 characters.");return;}
    setSaving(true);setPwdErr("");setPwdMsg("");
    const{error}=await supabase.auth.updateUser({password:newPwd});
    setSaving(false);
    if(error){setPwdErr(error.message);}
    else{setPwdMsg("✓ Password updated successfully!");setNewPwd("");}
  };
  return<div style={{display:"flex",flexDirection:"column",gap:10}}>
    <div style={{display:"flex",gap:8,alignItems:"flex-end",flexWrap:"wrap"}}>
      <div style={{flex:1,minWidth:200}}>
        <Label style={{fontSize:11,marginBottom:4}}>New Password</Label>
        <Inp type="password" value={newPwd} onChange={e=>setNewPwd(e.target.value)} placeholder="Enter new password (min 6 chars)" onKeyDown={e=>e.key==="Enter"&&doChange()}/>
      </div>
      <Btn onClick={doChange} disabled={saving||!newPwd} style={{background:saving?T.border:T.blue,color:"#fff",border:"none",flexShrink:0}}>{saving?"Saving...":"Update Password"}</Btn>
    </div>
    {pwdErr&&<div style={{fontSize:12,color:T.danger}}>{pwdErr}</div>}
    {pwdMsg&&<div style={{fontSize:12,color:T.free,fontWeight:600}}>{pwdMsg}</div>}
  </div>;
}

// ── Section: Vehicle ───────────────────────────────────────────────
function VehicleSection({data,onChange,onOpenHowTo,onTabChange}){
  const T=useTheme();const f=(k,v)=>onChange({...data,[k]:v});
  const isRV=["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper"].includes(data.rvType);
  const isBike=data.rvType==="Bicycle";
  const isMoto=data.rvType==="Motorcycle";
  const isHike=data.rvType==="🥾 Hike / Walk";
  const range=data.mpg&&data.tankGallons&&!isBike?data.mpg*data.tankGallons:null;

  return<div className="anim">
    <SecHead icon={isHike?"🥾":isBike?"🚲":isMoto?"🏍":isRV?"🚐":"🚗"} title={isRV?"Your RV":isMoto?"Your Motorcycle":isBike?"Your Bicycle":isHike?"Hike / Walk Settings":"Your Vehicle"} sub={isHike?"Set your pace and daily distance for hike/walk trip planning.":"Specs determine your daily range, fuel costs, and travel fit."}/>
    <QuickTipBar tabId="vehicle" onOpenHowTo={onOpenHowTo}/>
    <WhatNextBanner message="Now add your destination stops." tab="stops" btnLabel="Add Stops" onTabChange={onTabChange}/>
    {!["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper"].includes(data.rvType)&&data.rvType!=="🥾 Hike / Walk"&&<div style={{background:"#f59e0b22",border:"1px solid #f59e0b55",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:13,color:"#f59e0b",display:"flex",gap:10,alignItems:"center"}}>
      <span style={{fontSize:18}}>⚠️</span>
      <span><strong>Side vehicle mode</strong> - trip summary, fuel costs, and routing still use your primary RV specs. Switch back to an RV type to affect main trip calculations. Side trip planning coming soon.</span>
    </div>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:16}}>
      <div><Label>Vehicle Type</Label><Sel value={data.rvType} onChange={e=>{
          const vt=e.target.value;
          const updates={rvType:vt};
          const isCurrentRV=["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper"].includes(data.rvType);
          const isNewRV=["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper"].includes(vt);
          // Save primary RV specs before switching to non-RV
          if(isCurrentRV&&!isNewRV){updates._rvType=data.rvType;updates._mpg=data.mpg;updates._tank=data.tankGallons;updates._fuelType=data.fuelType;}
          if(vt==="Motorcycle"){updates.mpg=50;updates.tankGallons=5;updates.rvLength=8;updates.rvHeightFt=4;updates.rvHeightIn=6;updates.fuelType="Gasoline";updates.towVehicle=false;}
          else if(vt==="Car / SUV"){updates.mpg=28;updates.tankGallons=15;updates.rvLength=15;updates.rvHeightFt=5;updates.rvHeightIn=6;updates.fuelType="Gasoline";updates.towVehicle=false;}
          else if(vt==="Bicycle"){updates.mpg=999;updates.tankGallons=0;updates.rvLength=6;updates.rvHeightFt=3;updates.rvHeightIn=0;updates.fuelType="Electric/Hybrid";updates.towVehicle=false;}
          else if(vt==="🥾 Hike / Walk"){updates.mpg=2.5;updates.tankGallons=15;updates.rvLength=0;updates.rvHeightFt=0;updates.rvHeightIn=0;updates.fuelType="Electric/Hybrid";updates.towVehicle=false;}
          else if(vt==="Class A Motorhome"){updates.mpg=data._mpg||8;updates.tankGallons=data._tank||100;updates.rvLength=36;updates.rvHeightFt=13;updates.rvHeightIn=0;updates.fuelType=data._fuelType||"Diesel";}
          onChange({...data,...updates});
        }}>{["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper","─────────────","Motorcycle","Car / SUV","Bicycle","🥾 Hike / Walk"].map(v=><option key={v} disabled={v.startsWith("─")}>{v}</option>)}</Sel></div>
      {!isBike&&!isHike&&<div><Label>Fuel Type</Label><Sel value={data.fuelType} onChange={e=>f("fuelType",e.target.value)}>{["Diesel","Gasoline","Propane","Electric/Hybrid"].map(v=><option key={v}>{v}</option>)}</Sel></div>}
      {!isHike&&<div><Label>{isBike?"Speed (mph)":isMoto?"Miles Per Gallon":"Miles Per Gallon"}</Label><Inp type="number" min={1} max={999} value={data.mpg} onChange={e=>f("mpg",e.target.value)} placeholder={isBike?"12":"8"}/></div>}
      {!isBike&&!isHike&&<div><Label>Tank Capacity (gal)</Label><Inp type="number" min={1} max={300} value={data.tankGallons} onChange={e=>f("tankGallons",e.target.value)} placeholder={isMoto?"5":isRV?"100":"15"}/></div>}
      {isHike&&<div><Label>Max Daily Distance (mi)</Label><Inp type="number" min={1} max={50} value={data.tankGallons||15} onChange={e=>f("tankGallons",parseFloat(e.target.value)||15)} placeholder="15"/><div style={{fontSize:11,color:T.muted,marginTop:3}}>Max miles per day on foot</div></div>}
      {isRV&&<div><Label>RV Length (ft)</Label><Inp type="number" min={10} max={60} value={data.rvLength} onChange={e=>f("rvLength",e.target.value)} placeholder="36"/></div>}
      {isRV&&<div>
        <Label>RV Height</Label>
        <div style={{display:"flex",gap:6}}>
          <div style={{flex:1}}><Inp type="number" min={8} max={16} value={data.rvHeightFt??13} onChange={e=>{const v=e.target.value;f("rvHeightFt",v===""?13:parseInt(v)||13);}} placeholder="13"/><div style={{fontSize:10,color:"#94a3b8",marginTop:3,textAlign:"center"}}>feet</div></div>
          <div style={{flex:1}}><Inp type="number" min={0} max={11} value={data.rvHeightIn??0} onChange={e=>{const v=e.target.value;f("rvHeightIn",v===""?0:parseInt(v)||0);}} placeholder="0"/><div style={{fontSize:10,color:"#94a3b8",marginTop:3,textAlign:"center"}}>inches</div></div>
        </div>
      </div>}
      {isRV&&<div style={{gridColumn:"1/-1",display:"flex",gap:12,alignItems:"flex-end",flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",paddingBottom:6}}><Tog value={data.towVehicle} onChange={v=>{f("towVehicle",v);}} label="Towing a vehicle?"/></div>
        {data.towVehicle&&<div style={{flex:1,minWidth:140}}>
          <Label>Tow Type</Label>
          <Sel value={data.towType||"Car/SUV"} onChange={e=>{
            const lengths={"Car/SUV":15,"Truck":20,"Jeep":14,"Motorcycle":8,"Trailer":20,"Custom":data.towLength||15};
            const newLen=e.target.value!=="Custom"?lengths[e.target.value]||15:data.towLength||15;
            onChange({...data,towType:e.target.value,towLength:newLen});
          }}>
            {["Car/SUV","Truck","Jeep","Motorcycle","Trailer","Custom"].map(v=><option key={v}>{v}</option>)}
          </Sel>
        </div>}
        {data.towVehicle&&<div style={{width:100}}>
          <Label>Tow Length (ft)</Label>
          <Inp type="number" min={5} max={40} value={data.towLength||15} onChange={e=>f("towLength",parseFloat(e.target.value)||15)}/>
        </div>}
      </div>}
    </div>
    {(()=>{
      const totalIn=(parseInt(data.rvHeightFt)||13)*12+(parseInt(data.rvHeightIn)||0);
      const clearanceWarn=totalIn>162; // 13'6" = 162 inches - standard US low bridge
      return<Card style={{marginTop:16,padding:"12px 16px"}} accent={T.accent}><div style={{display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
        {range&&<><span style={{fontSize:13,color:T.muted}}>Max range: <strong style={{color:T.accent}}>{range.toLocaleString()} mi</strong></span><span style={{fontSize:13,color:T.muted}}>Safe fill-up: <strong style={{color:T.accent}}>{Math.round(range*.75).toLocaleString()} mi</strong></span></>}
        <span style={{fontSize:13,color:T.muted}}>Height: <strong style={{color:clearanceWarn?T.danger:T.accent}}>{data.rvHeightFt??13}'{data.rvHeightIn??0}"</strong></span>
        {data.towVehicle&&<span style={{fontSize:13,color:T.muted}}>Combined: <strong style={{color:T.accent}}>{parseInt(data.rvLength||36)+parseInt(data.towLength||15)+5} ft</strong> <span style={{fontSize:11,color:T.muted}}>(+5ft hitch)</span></span>}
        {(data.towVehicle?(parseInt(data.rvLength||36)+parseInt(data.towLength||15)+5):(parseInt(data.rvLength||36)))>45&&<div style={{width:"100%",marginTop:8,padding:"8px 12px",background:T.danger+"18",border:"1px solid "+T.danger+"44",borderRadius:8,fontSize:12,color:T.danger,fontWeight:600,lineHeight:1.5,wordBreak:"break-word"}}>⚠ {data.towVehicle?"Combined":"RV"} length - verify pull-through availability at fuel stops and campsites</div>}
        {["Fifth Wheel","Travel Trailer","Toy Hauler"].includes(data.rvType)&&<div style={{width:"100%",marginTop:12,padding:"10px 14px",background:T.bgLite,borderRadius:10,border:"1px solid "+T.border}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>🚛 Tow Vehicle (Truck)</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
            <div><Label>Year</Label><Inp value={data.towTruckYear||""} onChange={e=>onChange({...data,towTruckYear:e.target.value})} placeholder="2021"/></div>
            <div><Label>Make</Label><Inp value={data.towTruckMake||""} onChange={e=>onChange({...data,towTruckMake:e.target.value})} placeholder="Ford"/></div>
            <div><Label>Model</Label><Inp value={data.towTruckModel||""} onChange={e=>onChange({...data,towTruckModel:e.target.value})} placeholder="F-350"/></div>
          </div>
          <div style={{marginTop:8}}><Label>Current Odometer (mi)</Label><Inp type="number" value={data.towTruckOdometer||""} onChange={e=>onChange({...data,towTruckOdometer:e.target.value})} placeholder="87500"/></div>
        </div>}
        {clearanceWarn&&<Badge color={T.danger}>⚠ Over 13'6" - check bridge clearances</Badge>}
      </div></Card>;
    })()}

    {/* ── Weight & Load Calculator ── */}
    {isRV&&<WeightCalculator data={data} onChange={onChange}/>}
  </div>;
}

// ── Weight & Load Calculator ───────────────────────────────────────
function WeightCalculator({data,onChange}){
  const T=useTheme();
  const f=(k,v)=>onChange({...data,[k]:v});
  const [showLoaded,setShowLoaded]=useState(false);

  // Legal weight limits (US Federal)
  const LEGAL_SINGLE_AXLE=20000;  // lbs
  const LEGAL_TANDEM_AXLE=34000;  // lbs
  const LEGAL_GROSS=80000;        // lbs GVW on interstate
  const LEGAL_COMBO=80000;        // lbs combination vehicle

  const gvwr=parseFloat(data.gvwr)||0;
  const gcwr=parseFloat(data.gcwr)||0;
  const dryWeight=parseFloat(data.dryWeight)||0;
  const payload=parseFloat(data.payload)||0;
  const towCap=parseFloat(data.towCapacity)||0;
  const tongueWt=parseFloat(data.tongueWeight)||0;
  const loadedRV=parseFloat(data.loadedWeightRV)||0;
  const loadedTow=parseFloat(data.loadedWeightTow)||0;

  // Calculated values
  const calcPayload=gvwr&&dryWeight?gvwr-dryWeight:payload;
  const totalLoaded=loadedRV+(data.towVehicle?loadedTow:0)+(data.towVehicle?tongueWt:0);
  const rvPctGVWR=gvwr?Math.round((loadedRV/gvwr)*100):0;
  const gcwrPct=gcwr&&totalLoaded?Math.round((totalLoaded/gcwr)*100):0;
  const overGVWR=gvwr&&loadedRV>gvwr;
  const overGCWR=gcwr&&totalLoaded>gcwr;
  const overLegal=totalLoaded>LEGAL_GROSS;
  const tongueWtPct=loadedTow?Math.round((tongueWt/loadedTow)*100):0;
  const tongueWtGood=tongueWtPct>=10&&tongueWtPct<=15;

  const pctBar=(pct,warn,danger)=>{
    const color=pct>=(danger||100)?T.danger:pct>=(warn||85)?'#f59e0b':T.free;
    return(
      <div style={{height:8,background:T.border,borderRadius:4,overflow:"hidden",marginTop:4}}>
        <div style={{height:"100%",width:`${Math.min(pct,100)}%`,background:color,borderRadius:4,transition:"width .3s"}}/>
      </div>
    );
  };

  return(
    <Card style={{marginTop:16}} accent={T.accent}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted}}>⚖️ Weight & Load Calculator</div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setShowLoaded(false)} style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${!showLoaded?T.accent:T.border}`,background:!showLoaded?T.accent+"22":"none",color:!showLoaded?T.accent:T.muted,fontSize:11,fontWeight:700,cursor:"pointer"}}>📋 Specs</button>
          <button onClick={()=>setShowLoaded(true)} style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${showLoaded?T.accent:T.border}`,background:showLoaded?T.accent+"22":"none",color:showLoaded?T.accent:T.muted,fontSize:11,fontWeight:700,cursor:"pointer"}}>⚖️ Weigh-In</button>
        </div>
      </div>

      {!showLoaded&&<>
        {/* Specs tab — manufacturer ratings */}
        <div style={{fontSize:12,color:T.muted,marginBottom:12,lineHeight:1.5}}>Enter your RV's rated specifications from the manufacturer door sticker or owner's manual.</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10,marginBottom:12}}>
          <div>
            <Label>GVWR (lbs)</Label>
            <Inp type="number" value={data.gvwr||""} onChange={e=>f("gvwr",e.target.value)} placeholder="e.g. 26000"/>
            <div style={{fontSize:10,color:T.muted,marginTop:2}}>Gross Vehicle Weight Rating</div>
          </div>
          {data.towVehicle&&<div>
            <Label>GCWR (lbs)</Label>
            <Inp type="number" value={data.gcwr||""} onChange={e=>f("gcwr",e.target.value)} placeholder="e.g. 35000"/>
            <div style={{fontSize:10,color:T.muted,marginTop:2}}>Gross Combined Weight Rating</div>
          </div>}
          <div>
            <Label>Dry / UVW (lbs)</Label>
            <Inp type="number" value={data.dryWeight||""} onChange={e=>f("dryWeight",e.target.value)} placeholder="e.g. 18500"/>
            <div style={{fontSize:10,color:T.muted,marginTop:2}}>Unloaded Vehicle Weight</div>
          </div>
          {data.towVehicle&&<div>
            <Label>Tow Capacity (lbs)</Label>
            <Inp type="number" value={data.towCapacity||""} onChange={e=>f("towCapacity",e.target.value)} placeholder="e.g. 18000"/>
            <div style={{fontSize:10,color:T.muted,marginTop:2}}>Max tow vehicle can pull</div>
          </div>}
        </div>
        {gvwr&&dryWeight?(
          <div style={{background:T.bgLite,borderRadius:8,padding:"10px 12px",display:"flex",gap:16,flexWrap:"wrap"}}>
            <div>
              <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Payload Capacity</div>
              <div style={{fontSize:18,fontWeight:800,color:T.accent}}>{calcPayload.toLocaleString()} lbs</div>
              <div style={{fontSize:10,color:T.muted}}>People + gear + water + food</div>
            </div>
            {data.towVehicle&&towCap?<div>
              <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Tongue Weight Range</div>
              <div style={{fontSize:18,fontWeight:800,color:T.accent}}>{Math.round(towCap*.10).toLocaleString()}–{Math.round(towCap*.15).toLocaleString()} lbs</div>
              <div style={{fontSize:10,color:T.muted}}>10–15% of trailer weight (ideal)</div>
            </div>:null}
          </div>
        ):null}
      </>}

      {showLoaded&&<>
        {/* Weigh-In tab — actual measured weights */}
        <div style={{fontSize:12,color:T.muted,marginBottom:12,lineHeight:1.5}}>
          Enter weights from a CAT scale, Loves, Pilot, or Flying J weigh station. Weigh fully loaded — tanks full, all gear aboard.
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10,marginBottom:12}}>
          <div>
            <Label>RV Loaded Weight (lbs)</Label>
            <Inp type="number" value={data.loadedWeightRV||""} onChange={e=>f("loadedWeightRV",e.target.value)} placeholder="Actual scale weight"/>
          </div>
          {data.towVehicle&&<>
            <div>
              <Label>Tow Vehicle Weight (lbs)</Label>
              <Inp type="number" value={data.loadedWeightTow||""} onChange={e=>f("loadedWeightTow",e.target.value)} placeholder="Tow vehicle on scale"/>
            </div>
            <div>
              <Label>Tongue / Pin Weight (lbs)</Label>
              <Inp type="number" value={data.tongueWeight||""} onChange={e=>f("tongueWeight",e.target.value)} placeholder="Tongue scale reading"/>
            </div>
          </>}
          <div>
            <Label>Weigh Station</Label>
            <Inp value={data.weightStationName||""} onChange={e=>f("weightStationName",e.target.value)} placeholder="e.g. Loves Tuscaloosa AL"/>
          </div>
          <div>
            <Label>Date Weighed</Label>
            <Inp type="date" value={data.lastWeighDate||""} onChange={e=>f("lastWeighDate",e.target.value)}/>
          </div>
        </div>

        {/* Live analysis */}
        {loadedRV>0&&<div style={{display:"flex",flexDirection:"column",gap:10}}>

          {/* RV vs GVWR */}
          {gvwr>0&&<div style={{background:T.bgLite,borderRadius:8,padding:"10px 12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:12,fontWeight:700,color:T.text}}>RV vs GVWR</div>
              <div style={{fontSize:12,fontWeight:700,color:overGVWR?T.danger:T.free}}>
                {loadedRV.toLocaleString()} / {gvwr.toLocaleString()} lbs ({rvPctGVWR}%)
              </div>
            </div>
            {pctBar(rvPctGVWR,85,100)}
            {overGVWR&&<div style={{marginTop:6,fontSize:11,color:T.danger,fontWeight:700}}>⚠ OVER GVWR — illegal to operate. Reduce load by {(loadedRV-gvwr).toLocaleString()} lbs minimum.</div>}
            {!overGVWR&&rvPctGVWR>=85&&<div style={{marginTop:4,fontSize:11,color:"#f59e0b"}}>⚠ Approaching GVWR limit — consider reducing load.</div>}
            {!overGVWR&&rvPctGVWR<85&&<div style={{marginTop:4,fontSize:11,color:T.free}}>✓ Within GVWR limits</div>}
          </div>}

          {/* Combined vs GCWR */}
          {data.towVehicle&&gcwr>0&&totalLoaded>0&&<div style={{background:T.bgLite,borderRadius:8,padding:"10px 12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:12,fontWeight:700,color:T.text}}>Combined vs GCWR</div>
              <div style={{fontSize:12,fontWeight:700,color:overGCWR?T.danger:T.free}}>
                {totalLoaded.toLocaleString()} / {gcwr.toLocaleString()} lbs ({gcwrPct}%)
              </div>
            </div>
            {pctBar(gcwrPct,85,100)}
            {overGCWR&&<div style={{marginTop:6,fontSize:11,color:T.danger,fontWeight:700}}>⚠ OVER GCWR — illegal and unsafe. Reduce combined weight by {(totalLoaded-gcwr).toLocaleString()} lbs.</div>}
            {!overGCWR&&<div style={{marginTop:4,fontSize:11,color:T.free}}>✓ Within GCWR limits</div>}
          </div>}

          {/* Federal gross weight */}
          {totalLoaded>0&&<div style={{background:T.bgLite,borderRadius:8,padding:"10px 12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:12,fontWeight:700,color:T.text}}>Federal Gross Weight Limit</div>
              <div style={{fontSize:12,fontWeight:700,color:overLegal?T.danger:T.free}}>
                {(data.towVehicle?totalLoaded:loadedRV).toLocaleString()} / {LEGAL_GROSS.toLocaleString()} lbs
              </div>
            </div>
            {pctBar(Math.round(((data.towVehicle?totalLoaded:loadedRV)/LEGAL_GROSS)*100),85,100)}
            {overLegal
              ?<div style={{marginTop:6,fontSize:11,color:T.danger,fontWeight:700}}>⚠ OVER federal 80,000 lb limit — oversize/overweight permits required on interstates.</div>
              :<div style={{marginTop:4,fontSize:11,color:T.free}}>✓ Within federal interstate limit</div>
            }
          </div>}

          {/* Tongue weight analysis */}
          {data.towVehicle&&tongueWt>0&&loadedTow>0&&<div style={{background:T.bgLite,borderRadius:8,padding:"10px 12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontSize:12,fontWeight:700,color:T.text}}>Tongue Weight</div>
              <div style={{fontSize:12,fontWeight:700,color:tongueWtGood?T.free:T.danger}}>
                {tongueWtPct}% of trailer weight {tongueWtGood?"✓":"⚠"}
              </div>
            </div>
            {!tongueWtGood&&tongueWtPct<10&&<div style={{marginTop:6,fontSize:11,color:T.danger,fontWeight:700}}>⚠ Tongue weight too low ({tongueWtPct}%) — trailer may sway. Move cargo forward in trailer.</div>}
            {!tongueWtGood&&tongueWtPct>15&&<div style={{marginTop:6,fontSize:11,color:T.danger,fontWeight:700}}>⚠ Tongue weight too high ({tongueWtPct}%) — front of tow vehicle may lift. Move cargo rearward in trailer.</div>}
            {tongueWtGood&&<div style={{marginTop:4,fontSize:11,color:T.free}}>✓ Tongue weight is in the ideal 10–15% range</div>}
          </div>}

          {/* Summary badges */}
          {data.lastWeighDate&&<div style={{fontSize:11,color:T.muted,textAlign:"right"}}>
            Last weighed: {new Date(data.lastWeighDate+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}
            {data.weightStationName?" at "+data.weightStationName:""}
          </div>}
        </div>}

        {loadedRV===0&&<div style={{textAlign:"center",padding:"20px 0",color:T.muted,fontSize:13}}>
          Enter your RV's loaded weight from the scale to see analysis and legal weight checks.
        </div>}
      </>}
    </Card>
  );
}

// ── Section: Travel Prefs ──────────────────────────────────────────
function WhatNextBanner({message,tab,btnLabel,onTabChange}){
  const T=useTheme();
  return<div style={{marginTop:16,background:T.accent+"12",border:`1px solid ${T.accent}33`,borderRadius:10,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
    <div style={{fontSize:12,color:T.muted}}>✓ <strong style={{color:T.accent}}>Looking good!</strong> {message}</div>
    {onTabChange&&<button onClick={()=>onTabChange(tab)} style={{background:T.accent,color:"#fff",border:"none",borderRadius:7,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0}}>{btnLabel} →</button>}
  </div>;
}

function PrefsSection({data,onChange,onOpenHowTo}){
  const T=useTheme();const f=(k,v)=>onChange({...data,[k]:v});
  const isMulti=data.multiDriver||false;
  const maxMiles=Math.round((parseFloat(data.maxDriveHours)||7)*(parseFloat(data.avgSpeedMph)||55));
  const tdi={any:{detail:"Maximum flexibility."},weekends:{detail:"Sat/Sun only - zero lost workdays."},weekdays:{detail:"Mon-Fri - avoids weekend rush."},friday:{detail:"Fri/Sat/Sun - great balance."}};
  return<div className="anim">
    <SecHead icon="🗺" title="Travel Style & Drive Preferences" sub="These settings shape your itinerary dates, drive-day warnings, and trip analysis."/>
    <QuickTipBar tabId="prefs" onOpenHowTo={onOpenHowTo}/>
    <Card style={{marginBottom:20}} accent={T.accent}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>Daily Drive Limits</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:20}}>
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <Label>{isMulti?"Total Drive Hours (multi-driver)":"Max Hours Per Day"}</Label>
            <Tog value={isMulti} onChange={v=>f("multiDriver",v)} label="👥 Multi-driver"/>
          </div>
          {isMulti
            ?<><Inp type="number" min={1} max={48} step={0.5} value={data.maxDriveHours} onChange={e=>f("maxDriveHours",parseFloat(e.target.value)||7)} placeholder="e.g. 20"/>
              <div style={{fontSize:11,color:T.muted,marginTop:4}}>No daily limit warnings. Enter total hours two drivers can share.</div></>
            :<><Inp type="range" min={2} max={12} step={0.5} value={data.maxDriveHours} onChange={e=>f("maxDriveHours",e.target.value)} style={{padding:"10px 0",background:"transparent",border:"none"}}/>
              <div style={{textAlign:"center",fontSize:12,color:T.text,marginBottom:2,fontWeight:500,fontFamily:T.F.cond,letterSpacing:.5,opacity:.7}}>← drag to adjust →</div></>
          }
          <div style={{textAlign:"center",fontFamily:T.F.head,fontSize:28,color:T.accent,lineHeight:1}}>{data.maxDriveHours} hrs{isMulti?" total":"/day"}</div>
          <div style={{textAlign:"center",fontSize:13,color:T.muted,marginTop:4}}>≈ {maxMiles} miles max</div>
        </div>
        <div><Label>Avg Speed (mph)</Label><Inp type="range" min={40} max={70} step={1} value={data.avgSpeedMph} onChange={e=>f("avgSpeedMph",e.target.value)} style={{padding:"10px 0",background:"transparent",border:"none"}}/><div style={{textAlign:"center",fontSize:12,color:T.text,marginBottom:2,fontWeight:500,fontFamily:T.F.cond,letterSpacing:.5,opacity:.7}}>← drag to adjust →</div><div style={{textAlign:"center",fontFamily:T.F.head,fontSize:28,color:T.accent,lineHeight:1}}>{data.avgSpeedMph} mph</div><div style={{textAlign:"center",fontSize:13,color:T.muted,marginTop:4}}>typical highway speed</div></div>
      </div>
    </Card>
    <Card style={{marginBottom:20}} accent={T.border}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>When You Travel</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:16}}>
        <div><Label>Preferred Travel Days</Label><Sel value={data.travelDays} onChange={e=>f("travelDays",e.target.value)}><option value="any">Any day</option><option value="weekends">Weekends only (Sat/Sun)</option><option value="weekdays">Weekdays (Mon-Fri)</option><option value="friday">Fridays + weekends</option></Sel><div style={{fontSize:12,color:T.green,marginTop:6}}>{(tdi[data.travelDays]||tdi.any).detail}</div></div>
        <div><Label>Default Departure Time</Label><Inp type="time" value={data.preferDepartTime} onChange={e=>f("preferDepartTime",e.target.value)} style={{fontSize:16}}/><div style={{fontSize:12,color:T.muted,marginTop:6}}>Override per stop in the Stops tab</div></div>
        <div style={{display:"flex",flexDirection:"column",gap:10,justifyContent:"flex-end"}}><Tog value={data.avoidHolidays} onChange={v=>f("avoidHolidays",v)} label="Flag holiday travel?"/></div>
      </div>
    </Card>
    <Card accent={T.border}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>Camping Style</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:16}}>
        <div><Label>Boondocking Comfort</Label><Sel value={data.boondockComfort} onChange={e=>f("boondockComfort",e.target.value)}><option value="love">Love it - maximize free nights</option><option value="ok">OK occasionally</option><option value="rarely">Prefer hookups mostly</option><option value="never">Hookups always</option></Sel></div>
        <div><Label>Hookup Preference</Label><Sel value={data.hookupPref} onChange={e=>f("hookupPref",e.target.value)}><option value="full">Full hookup</option><option value="electric">Electric only</option><option value="dry">Dry camping</option><option value="flexible">Flexible</option></Sel></div>
      </div>
    </Card>
  </div>;
}

// ── Section: Finance ───────────────────────────────────────────────
function FinanceSection({data,onChange,onOpenHowTo}){
  const T=useTheme();const f=(k,v)=>onChange({...data,[k]:v});
  const mth=parseFloat(data.monthlyTakeHome)||0;
  const totalPct=[data.budgetLodgingPct,data.budgetFuelPct,data.budgetGroceryPct,data.budgetUtilityPct,data.budgetEntertainPct,data.budgetMaintPct,data.budgetPersonalPct,data.budgetSavingsPct].reduce((a,b)=>a+parseFloat(b||0),0);
  return<div className="anim">
    <SecHead icon="💵" title="Income & Budget" sub="Enter your monthly take-home pay. Income is never saved - resets each visit."/>
    <QuickTipBar tabId="finance" onOpenHowTo={onOpenHowTo}/>
    <Card style={{marginBottom:20}} accent={T.accent}>
      <div style={{display:"flex",alignItems:"flex-start",gap:16,flexWrap:"wrap"}}>
        <div style={{flex:1,minWidth:200}}>
          <Label>Monthly Take-Home Pay (after tax)</Label>
          <Inp type="number" min={0} value={data.monthlyTakeHome} onChange={e=>f("monthlyTakeHome",e.target.value)} placeholder="e.g. 4500" style={{fontSize:18}}/>
          <div style={{display:"flex",alignItems:"flex-start",gap:8,marginTop:8,background:T.free+"12",border:"1px solid "+T.free+"44",borderRadius:8,padding:"8px 10px"}}>
            <span style={{fontSize:16,flexShrink:0}}>🔒</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:T.free,marginBottom:1}}>Your income is private and never saved</div>
              <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>This number is only used to calculate your budget breakdown below. It is not stored anywhere and resets every time you open the app.</div>
            </div>
          </div>
        </div>
        {mth>0&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:10,flex:2,minWidth:280}}>
          <StatBox label="Lodging Budget/Mo" value={fmt$(mth*(parseFloat(data.budgetLodgingPct)||35)/100)} sub={data.budgetLodgingPct+"%"} accent={T.blue}/>
          <StatBox label="Fuel Budget/Mo" value={fmt$(mth*(parseFloat(data.budgetFuelPct)||12)/100)} sub={data.budgetFuelPct+"%"} accent={T.accentAlt}/>
          <StatBox label="Grocery Budget/Mo" value={fmt$(mth*(parseFloat(data.budgetGroceryPct)||20)/100)} sub={data.budgetGroceryPct+"%"} accent={T.green}/>
        </div>}
      </div>
    </Card>
    <Card accent={totalPct>100?T.danger:T.border}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <span style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase"}}>Monthly Budget %s</span>
        <Badge color={totalPct>100?T.danger:totalPct===100?T.free:T.accent}>{fmtDec(totalPct,0)}% {totalPct>100?"⚠ OVER":totalPct<100?`(${100-totalPct}% unallocated)`:"✓"}</Badge>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(170px,1fr))",gap:10}}>
        {[["budgetLodgingPct","Lodging %"],["budgetFuelPct","Fuel %"],["budgetGroceryPct","Groceries %"],["budgetUtilityPct","Utilities %"],["budgetEntertainPct","Entertainment %"],["budgetMaintPct","Maintenance %"],["budgetPersonalPct","Personal %"],["budgetSavingsPct","Savings %"]].map(([k,l])=><div key={k}><Label>{l}</Label><Inp type="number" min={0} max={100} value={data[k]} onChange={e=>f(k,e.target.value)} placeholder="%"/></div>)}
      </div>
    </Card>
  </div>;
}

// ── Section: Fuel ──────────────────────────────────────────────────
function FuelSection({data,onChange,memberships,fuelPrices,onOpenHowTo}){
  const T=useTheme();const f=(k,v)=>onChange({...data,[k]:v});
  return<div className="anim">
    <SecHead icon="⛽" title="Fuel Planning" sub="EIA regional averages auto-fill from your departure state. Updated weekly."/>
    <QuickTipBar tabId="fuel" onOpenHowTo={onOpenHowTo}/>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:16,marginBottom:16}}>
      <div><Label>Avg Fuel Price / Gallon ($)</Label><Inp type="number" step={.01} min={1} max={8} value={data.avgPricePerGallon} onChange={e=>f("avgPricePerGallon",e.target.value)} placeholder="3.30"/></div>
      <div><Label>Fill-Up Strategy</Label><Sel value={data.fuelStrategy} onChange={e=>f("fuelStrategy",e.target.value)}><option value="fill-when-cheap">Fill full when cheapest</option><option value="topoff">Top off constantly</option><option value="minimal">Minimum to reach next stop</option></Sel></div>
    </div>
    {fuelPrices&&Object.keys(fuelPrices).length>0&&<Card style={{marginBottom:16}} accent={T.accentAlt}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:10}}>⛽ EIA Regional Averages (Updated Weekly)</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
        {Object.entries(fuelPrices).map(([region,price])=><div key={region} style={{background:T.bgLite,borderRadius:6,padding:"6px 10px",fontSize:12}}><span style={{color:T.muted}}>{region}: </span><strong style={{color:T.accent}}>${price}</strong></div>)}
      </div>
      <div style={{fontSize:11,color:T.muted,marginTop:8}}>Source: U.S. Energy Information Administration · Weekly update · {data._autoRegion?<span style={{color:T.free}}>✓ Auto-set from your location ({data._autoRegion})</span>:"Regional average"}</div>
    </Card>}
    <Card style={{padding:14}} accent={T.accent}><div style={{fontSize:13,color:T.muted,lineHeight:1.9}}><strong style={{color:T.text}}>💡 Fuel Tips: </strong>Gulf Coast & Midwest typically cheapest. Use GasBuddy or Trucker Path for station-level prices.{memberships?.goodSam&&<span> <strong style={{color:T.free}}>Good Sam</strong> discount active.</span>}</div></Card>
  </div>;
}

// ── Section: Memberships ───────────────────────────────────────────
function MembershipsSection({data,onChange,onOpenHowTo}){
  const T=useTheme();const f=(k,v)=>onChange({...data,[k]:v});
  const MEMS=[
    {k:"goodSam",l:"Good Sam Club",cost:29,b:"10-15% off at 2,000+ parks",col:"#e74c3c",url:"https://www.goodsam.com/rv-parks-campgrounds/",login:"https://www.goodsam.com/account/login",signup:"https://www.goodsam.com/club-memberships"},
    {k:"passportAmerica",l:"Passport America",cost:44,b:"50% off at 1,800+ parks (off-peak)",col:"#3498db",url:"https://www.passportamerica.com/campgrounds/",login:"https://www.passportamerica.com/login",signup:"https://www.passportamerica.com/join"},
    {k:"harvestHosts",l:"Harvest Hosts",cost:99,b:"Free stays at 5,000+ farms & wineries",col:T.free,url:"https://harvesthosts.com/hosts/",login:"https://harvesthosts.com/sign-in",signup:"https://harvesthosts.com/plans"},
    {k:"koaValueKard",l:"KOA Value Kard",cost:0,b:"10% off every KOA night - free to join",col:"#f39c12",url:"https://koa.com/campgrounds/",login:"https://koa.com/value-kard-rewards",signup:"https://koa.com/value-kard-rewards"},
    {k:"thousandTrails",l:"Thousand Trails",cost:0,b:"Unlimited stays at 80+ resorts/year",col:"#9b59b6",url:"https://thousandtrails.com/campgrounds/",login:"https://www.thousandtrails.com/login",signup:"https://www.thousandtrails.com/memberships"},
  ];
  const active=MEMS.filter(m=>data[m.k]);
  return<div className="anim">
    <SecHead icon="🎫" title="Memberships & Discounts" sub="Toggle memberships. Map pins will show membership-specific search links for each stop."/>
    <QuickTipBar tabId="memberships" onOpenHowTo={onOpenHowTo}/>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(270px,1fr))",gap:12}}>
      {MEMS.map(m=><div key={m.k} onClick={()=>f(m.k,!data[m.k])} style={{background:T.bgMid,border:`1px solid ${data[m.k]?m.col:T.border}`,borderLeft:`4px solid ${data[m.k]?m.col:T.border}`,borderRadius:10,padding:"14px 16px",cursor:"pointer"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}><span style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:data[m.k]?m.col:T.text}}>{m.l}</span><div style={{width:20,height:20,borderRadius:"50%",background:data[m.k]?m.col:T.border,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"#fff",fontWeight:700}}>{data[m.k]?"✓":""}</div></div>
        <div style={{fontSize:12,color:T.muted,marginBottom:8}}>{m.b}</div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:4}}>
          <div style={{fontSize:11,color:T.border}}>{m.cost>0?"~$"+m.cost+"/year":"Free"}</div>
          <div style={{display:"flex",gap:6}}>
            {data[m.k]&&<a href={m.login} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()} style={{fontSize:10,color:"#fff",background:m.col,borderRadius:4,padding:"2px 7px",textDecoration:"none",fontWeight:600}}>🔑 Login</a>}
            {!data[m.k]&&<a href={m.signup} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()} style={{fontSize:10,color:m.col,border:"1px solid "+m.col+"66",borderRadius:4,padding:"2px 7px",textDecoration:"none",fontWeight:600}}>➕ Join</a>}
            <a href={m.url} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()} style={{fontSize:10,color:m.col,textDecoration:"none",fontWeight:600}}>Find Camps →</a>
          </div>
        </div>
      </div>)}
    </div>
    {active.length>0&&<Card style={{marginTop:12,padding:12}} accent={T.free}><div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}><span style={{fontSize:13}}><strong style={{color:T.free}}>{active.length} membership{active.length>1?"s":""}</strong> · Annual cost: <strong style={{color:T.accent}}>{fmt$(active.reduce((a,m)=>a+m.cost,0))}</strong></span><span style={{fontSize:11,color:T.muted,fontStyle:"italic"}}>ℹ️ For planning only - no charges are made here</span></div></Card>}
  </div>;
}


// ── SideTripCard ────────────────────────────────────────────────────
const SIDE_TRIP_VEHICLES=["Motorcycle","Car / SUV","Bicycle","🥾 Hike / Walk","Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer"];
const mkSideTrip=()=>({
  roundTrip:true,
  id:uid(),
  name:"",
  vehicleType:"Motorcycle",
  mpg:50,
  mode:"standalone", // "addtotrip" | "standalone"
  waypoints:[{id:uid(),name:"",state:""}],
  totalMiles:0,
  fuelCost:0,
  notes:"",
  routeCoords:null,
  directions:[],
  repeatDays:1,        // how many days to repeat this ride
  repeatEnabled:false, // whether repeat mode is on
});

function SideTripCard({sideTrip,stopName,stopState,fuelPrice,onUpdate,onDelete,onCreateNewTrip}){
  const T=useTheme();
  const [open,setOpen]=useState(true);
  const [routing,setRouting]=useState(false);
  const [routeResult,setRouteResult]=useState(null);
  const f=(k,v)=>onUpdate({...sideTrip,[k]:v});
  const updateWp=(i,field,val)=>onUpdate({...sideTrip,waypoints:sideTrip.waypoints.map((w,wi)=>wi===i?{...w,[field]:val}:w)});
  const addWp=()=>{if(sideTrip.waypoints.length>=5)return;onUpdate({...sideTrip,waypoints:[...sideTrip.waypoints,{id:uid(),name:"",state:""}]});};
  const delWp=(i)=>onUpdate({...sideTrip,waypoints:sideTrip.waypoints.filter((_,wi)=>wi!==i)});

  const calcRoute=async()=>{
    const filtered=sideTrip.waypoints.filter(w=>w.name.trim());
    const wps=sideTrip.roundTrip
      ?[{name:stopName,state:stopState||""}, ...filtered, {name:stopName,state:stopState||""}]
      :[{name:stopName,state:stopState||""}, ...filtered];
    if(wps.length<2){return;}
    setRouting(true);
    try{
      const sleep=ms=>new Promise(r=>setTimeout(r,ms));
      // Use shared geocodeStop helper — handles ORS→Nominatim→campground fallbacks
      const geoWp=async(wp)=>{
        // Build a stop-like object so geocodeStop can use its full fallback chain
        const pseudo={name:wp.name||"",state:wp.state||"",type:"tourist",address:""};
        const result=await geocodeStop(pseudo);
        if(result){
          // geocodeStop returns [lat,lon]; ORS needs [lon,lat]
          return[result[1],result[0]];
        }
        return null;
      };
      const geocoded=[];
      for(const wp of wps){
        const coords=await geoWp(wp);
        if(coords) geocoded.push(coords);
      }
      if(geocoded.length<2){
        console.warn("Side trip geocoding: got",geocoded.length,"of",wps.length,"points. Waypoints:",wps.map(w=>w.name+(w.state?", "+w.state:"")));
        alert("Could not find one or more locations on the map.\n\nMake sure:\n• The parent stop has a State selected\n• Each waypoint has a State selected\n\nExample: Stop = Hill City, State = SD  /  Waypoint = Sturgis, State = SD");
        setRouting(false);return;
      }
      await sleep(300);
      const profile=sideTrip.vehicleType==="Bicycle"||sideTrip.vehicleType==="🥾 Hike / Walk"?sideTrip.vehicleType==="🥾 Hike / Walk"?"foot-walking":"cycling-regular":"driving-car";
      let res=null,totalMi=0,steps=[],coords=null;
      // Calculate total miles leg by leg using roadMiles (OSRM→ORS→straight-line)
      let totalStraight=0;
      for(let gi=1;gi<geocoded.length;gi++){
        const[lon1,lat1]=geocoded[gi-1],[lon2,lat2]=geocoded[gi];
        const legMi=await roadMiles(lat1,lon1,lat2,lon2);
        totalMi+=legMi||0;
        // Accumulate straight-line for fallback
        const R=3959,toR=Math.PI/180;
        const dLat=(lat2-lat1)*toR,dLon=(lon2-lon1)*toR;
        const a=Math.sin(dLat/2)**2+Math.cos(lat1*toR)*Math.cos(lat2*toR)*Math.sin(dLon/2)**2;
        totalStraight+=R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
      }
      if(!totalMi) totalMi=Math.round(totalStraight*1.25);
      // Get route geometry for map display
      coords=await roadRoute(geocoded)||geocoded;
      const mpg=Math.max(parseFloat(sideTrip.mpg)||50,1);
      const fuelCost=parseFloat(((totalMi/mpg)*(fuelPrice||3.30)).toFixed(2));
      setRouteResult({totalMi,fuelCost,steps});
      const effectiveFuel=sideTrip.repeatEnabled?(fuelCost*(sideTrip.repeatDays||1)):fuelCost;
      onUpdate({...sideTrip,totalMiles:totalMi,fuelCost,totalFuelCost:effectiveFuel,directions:steps,routeCoords:coords});
    }catch(e){console.warn("Side trip route failed:",e);}
    setRouting(false);
  };

  const fmt$=n=>"$"+Math.round(n).toLocaleString();
  const isBike=sideTrip.vehicleType==="Bicycle";

  return(
    <div style={{background:T.bg,border:`2px solid #f59e0b`,borderRadius:12,padding:12,marginTop:8}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:open?12:0}}>
        <span style={{fontSize:16}}>🏍</span>
        <div style={{flex:1,fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#f59e0b"}}>{sideTrip.name||"Side Trip"}</div>
        {sideTrip.totalMiles>0&&<span style={{fontSize:11,color:T.muted}}>{sideTrip.totalMiles} mi · {fmt$(sideTrip.fuelCost)}</span>}
        <button onClick={()=>setOpen(o=>!o)} style={{background:"none",border:"none",cursor:"pointer",color:T.muted,fontSize:13}}>{open?"▲":"▼"}</button>
        <button onClick={onDelete} style={{background:"none",border:`1px solid ${T.danger}44`,borderRadius:6,padding:"2px 7px",color:T.danger,fontSize:11,cursor:"pointer"}}>✕</button>
      </div>
      {open&&<div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
          <div>
            <Label style={{fontSize:11}}>Trip Name</Label>
            <Inp value={sideTrip.name} onChange={e=>f("name",e.target.value)} placeholder="e.g. Hill Country Loop"/>
          </div>
          <div>
            <Label style={{fontSize:11}}>Vehicle</Label>
            <Sel value={sideTrip.vehicleType} onChange={e=>{
              const vt=e.target.value;
              const mpgMap={"Motorcycle":50,"Car / SUV":28,"Bicycle":999,"🥾 Hike / Walk":2.5,"Class A Motorhome":8,"Class B Campervan":18,"Class C Motorhome":14,"5th Wheel":12,"Travel Trailer":12};
              f("vehicleType",vt);onUpdate({...sideTrip,vehicleType:vt,mpg:mpgMap[vt]||30});
            }}>
              {SIDE_TRIP_VEHICLES.map(v=><option key={v}>{v}</option>)}
            </Sel>
          </div>
          {!isBike&&<div>
            <Label style={{fontSize:11}}>MPG</Label>
            <Inp type="number" min={1} max={200} value={sideTrip.mpg} onChange={e=>f("mpg",parseFloat(e.target.value)||50)} placeholder="50"/>
          </div>}
          <div style={{display:"flex",alignItems:"flex-end",paddingBottom:6}}>
            <Tog value={sideTrip.roundTrip!==false} onChange={v=>f("roundTrip",v)} label="Round trip (returns to stop)"/>
          </div>
          <div>
            <Label style={{fontSize:11}}>Add to Trip</Label>
            <Sel value={sideTrip.mode} onChange={e=>f("mode",e.target.value)}>
              <option value="standalone">Standalone (separate plan)</option>
              <option value="addtotrip">Add to Overall Trip Costs</option>
            </Sel>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <Tog value={sideTrip.repeatEnabled||false} onChange={v=>f("repeatEnabled",v)} label="🔁 Repeat this ride on multiple days"/>
          </div>
          {sideTrip.repeatEnabled&&<div style={{gridColumn:"1/-1",background:"#f59e0b10",border:"1px solid #f59e0b33",borderRadius:8,padding:"10px 12px"}}>
            <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <Label style={{fontSize:11,marginBottom:0}}>Number of days:</Label>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <button onClick={()=>f("repeatDays",Math.max(1,(sideTrip.repeatDays||1)-1))} style={{width:28,height:28,borderRadius:6,border:"1px solid #f59e0b55",background:"none",color:"#f59e0b",fontSize:16,cursor:"pointer",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>-</button>
                  <span style={{fontSize:16,fontWeight:700,color:"#f59e0b",minWidth:24,textAlign:"center"}}>{sideTrip.repeatDays||1}</span>
                  <button onClick={()=>f("repeatDays",Math.min(30,(sideTrip.repeatDays||1)+1))} style={{width:28,height:28,borderRadius:6,border:"1px solid #f59e0b55",background:"none",color:"#f59e0b",fontSize:16,cursor:"pointer",fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>
                </div>
              </div>
              {sideTrip.totalMiles>0&&<div style={{display:"flex",gap:12,flexWrap:"wrap",marginLeft:"auto"}}>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:18,fontWeight:800,color:"#f59e0b"}}>{(sideTrip.totalMiles*(sideTrip.repeatDays||1)).toLocaleString()}</div>
                  <div style={{fontSize:10,color:"#f59e0b",opacity:.7,textTransform:"uppercase",letterSpacing:.5}}>Total Miles</div>
                </div>
                {!isBike&&<div style={{textAlign:"center"}}>
                  <div style={{fontSize:18,fontWeight:800,color:"#f59e0b"}}>${Math.round(sideTrip.fuelCost*(sideTrip.repeatDays||1)).toLocaleString()}</div>
                  <div style={{fontSize:10,color:"#f59e0b",opacity:.7,textTransform:"uppercase",letterSpacing:.5}}>Total Fuel</div>
                </div>}
              </div>}
            </div>
            {sideTrip.totalMiles>0&&<div style={{marginTop:8,fontSize:12,color:"#f59e0b",opacity:.8}}>
              {sideTrip.totalMiles} mi/day × {sideTrip.repeatDays||1} day{(sideTrip.repeatDays||1)>1?"s":""}{!isBike?" · $"+sideTrip.fuelCost.toFixed(2)+"/day":""}
            </div>}
          </div>}
        </div>

        <Label style={{fontSize:11,marginBottom:6}}>Waypoints <span style={{color:T.muted,fontWeight:400}}>(starts and ends at {stopName}{stopState?" ("+stopState+")":""} · max 5)</span></Label>
        {sideTrip.waypoints.map((wp,i)=>(
          <div key={wp.id} style={{display:"flex",gap:6,marginBottom:6,alignItems:"center"}}>
            <span style={{fontSize:11,color:T.muted,width:20,textAlign:"right",flexShrink:0}}>{i+1}.</span>
            <Inp value={wp.name} onChange={e=>updateWp(i,"name",e.target.value)} placeholder="City or place name" style={{flex:2}}/>
            <Sel value={wp.state||""} onChange={e=>updateWp(i,"state",e.target.value)} style={{flex:1,fontSize:11}}>
              <option value="">State</option>
              {["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"].map(s=><option key={s}>{s}</option>)}
            </Sel>
            {sideTrip.waypoints.length>1&&<button onClick={()=>delWp(i)} style={{background:"none",border:`1px solid ${T.danger}44`,borderRadius:5,padding:"2px 6px",color:T.danger,fontSize:11,cursor:"pointer",flexShrink:0}}>✕</button>}
          </div>
        ))}
        <div style={{display:"flex",gap:8,marginTop:8,flexWrap:"wrap"}}>
          {sideTrip.waypoints.length<5&&<button onClick={addWp} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:7,padding:"5px 12px",fontSize:11,color:T.muted,cursor:"pointer"}}>+ Add Waypoint</button>}
          <CoachMark coachId="sidetrip-calc-route" message="Tap here to calculate your route and miles once your waypoints are set" position="top" active={!routing&&sideTrip.waypoints.some(w=>w.name.trim())&&!sideTrip.totalMiles}>
            <button onClick={calcRoute} disabled={routing} style={{background:routing?T.border:"#f59e0b",border:"none",borderRadius:7,padding:"5px 14px",fontSize:11,fontWeight:700,color:"#fff",cursor:routing?"not-allowed":"pointer"}}>
              {routing?"⏳ Routing...":"🗺 Calculate Route"}
            </button>
          </CoachMark>
          <button onClick={onCreateNewTrip} style={{background:"none",border:`1px solid ${T.accent}55`,borderRadius:7,padding:"5px 12px",fontSize:11,color:T.accent,cursor:"pointer"}} title="Save current trip and start a new one with this vehicle">
            ➕ Create as New Trip
          </button>
        </div>

        {routeResult&&<div style={{marginTop:10,background:T.bgLite,borderRadius:8,padding:10}}>
          <div style={{display:"flex",gap:16,flexWrap:"wrap",marginBottom:8}}>
            <span style={{fontSize:13,fontWeight:700,color:"#f59e0b"}}>{routeResult.totalMiles} mi {sideTrip.roundTrip!==false?"round trip":"one way"}</span>
            {sideTrip.repeatEnabled&&(sideTrip.repeatDays||1)>1&&<span style={{fontSize:13,fontWeight:700,color:"#f59e0b",opacity:.8}}>× {sideTrip.repeatDays} days = {(routeResult.totalMiles*(sideTrip.repeatDays||1)).toLocaleString()} mi total</span>}
            {!isBike&&<span style={{fontSize:13,color:T.muted}}>Fuel: <strong style={{color:T.accent}}>{fmt$(routeResult.fuelCost)}/day</strong>{sideTrip.repeatEnabled&&(sideTrip.repeatDays||1)>1&&<span style={{color:T.accent}}> · {fmt$(routeResult.fuelCost*(sideTrip.repeatDays||1))} total</span>}</span>}
            <span style={{fontSize:11,color:T.muted}}>{sideTrip.mode==="addtotrip"?"✓ Added to trip totals":"Standalone plan"}</span>
          </div>
          {routeResult.steps.length>0&&<details style={{fontSize:11,color:T.muted}}>
            <summary style={{cursor:"pointer",fontWeight:600,marginBottom:4}}>Turn-by-turn directions ({routeResult.steps.length} steps)</summary>
            <div style={{maxHeight:180,overflowY:"auto",marginTop:6}}>
              {routeResult.steps.map((st,i)=><div key={i} style={{padding:"2px 0",borderBottom:`1px solid ${T.border}55`}}><span style={{color:T.muted,marginRight:8}}>{st.distance>0?st.distance+" mi":""}</span>{st.instruction}</div>)}
            </div>
          </details>}
        </div>}

        <div style={{marginTop:8}}>
          <Label style={{fontSize:11}}>Notes</Label>
          <Inp value={sideTrip.notes} onChange={e=>f("notes",e.target.value)} placeholder="Gear needed, lunch spots, fuel stops..."/>
        </div>
        {(routeResult||sideTrip.totalMiles>0)&&<button onClick={()=>{
          const win=window.open("","_blank","width=800,height=600");
          if(!win) return;
          const steps=sideTrip.directions||[];
          const totalHrs=sideTrip.vehicleType==="🥾 Hike / Walk"?sideTrip.totalMiles/(parseFloat(sideTrip.mpg)||2.5):null;
          const printHtml=[
            "<!DOCTYPE html><html><head><title>"+(sideTrip.name||"Side Trip")+"</title>",
            "<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Arial,sans-serif;padding:24px;font-size:13px;color:#111}",
            "h1{font-size:22px;font-weight:900;border-bottom:3px solid #f59e0b;padding-bottom:8px;margin-bottom:16px}",
            "h2{font-size:14px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#666;margin:16px 0 8px}",
            ".meta{display:flex;gap:20px;flex-wrap:wrap;margin-bottom:16px;padding:12px;background:#fffbeb;border-radius:6px;border-left:4px solid #f59e0b}",
            ".meta-item{font-size:12px}.meta-item strong{display:block;font-size:16px;color:#f59e0b}",
            "table{width:100%;border-collapse:collapse}th{background:#1a1a1e;color:#f59e0b;padding:5px 8px;text-align:left;font-size:11px}",
            "td{padding:4px 8px;border-bottom:1px solid #f0f0f0;font-size:11px}",
            ".no-print{margin:12px 0}@media print{.no-print{display:none}}</style></head><body>",
            "<h1>\uD83C\uDFCD " + (sideTrip.name||"Side Trip") + "</h1>",
            "<div class=\"meta\">",
            "<div class=\"meta-item\"><strong>"+sideTrip.vehicleType+"</strong>Vehicle</div>",
            "<div class=\"meta-item\"><strong>"+(stopName||"Base Stop")+"</strong>Starting From</div>",
            "<div class=\"meta-item\"><strong>"+sideTrip.totalMiles+" mi</strong>"+(sideTrip.roundTrip!==false?"Round Trip":"One Way")+"</div>",
            sideTrip.repeatEnabled&&(sideTrip.repeatDays||1)>1?"<div class=\"meta-item\"><strong>"+(sideTrip.repeatDays)+" days</strong>Repeated Daily</div>":"",
            sideTrip.repeatEnabled&&(sideTrip.repeatDays||1)>1?"<div class=\"meta-item\"><strong>"+(sideTrip.totalMiles*(sideTrip.repeatDays||1))+" mi total</strong>All Days Combined</div>":"",
            totalHrs?"<div class=\"meta-item\"><strong>~"+Math.floor(totalHrs)+"h "+Math.round((totalHrs%1)*60)+"m</strong>Est. Time</div>":"<div class=\"meta-item\"><strong>$"+Math.round(sideTrip.fuelCost)+"</strong>Est. Fuel</div>",
            "<div class=\"meta-item\"><strong>"+(sideTrip.mode==="addtotrip"?"Yes":"No")+"</strong>Added to Trip</div>",
            "</div>",
            "<h2>Waypoints</h2><ul style=\"margin:0 0 16px 20px\">",
            (sideTrip.waypoints||[]).filter(w=>w.name).map((w,i)=>"<li style=\"padding:3px 0\">"+(i+1)+". "+w.name+(w.state?", "+w.state:"")+"</li>").join(""),
            "</ul>",
            steps.length>0?"<h2>Turn-by-Turn Directions</h2><table><thead><tr><th>Miles</th><th>Direction</th></tr></thead><tbody>"+steps.map(st=>"<tr><td>"+(st.distance>0?st.distance+" mi":"")+"</td><td>"+st.instruction+"</td></tr>").join("")+"</tbody></table>":"",
            sideTrip.notes?"<h2>Notes</h2><p style=\"font-size:12px;color:#444;margin-top:4px\">"+sideTrip.notes+"</p>":"",
            "<div class=\"no-print\" style=\"margin-top:16px\"><button onclick=\"window.print()\" style=\"background:#f59e0b;color:#fff;border:none;padding:10px 24px;font-size:14px;font-weight:700;border-radius:6px;cursor:pointer\">Print / Save as PDF</button></div>",
            "</body></html>"
          ].join("");
          win.document.write(printHtml);
          win.document.close();win.focus();
        }} style={{marginTop:10,background:"none",border:`1px solid #f59e0b55`,borderRadius:8,padding:"6px 14px",color:"#f59e0b",fontSize:11,fontWeight:700,cursor:"pointer",width:"100%"}}>🖨 Print Side Trip PDF</button>}
      </div>}
    </div>
  );
}

// ── StopCard ───────────────────────────────────────────────────────
function StopCard({stop,idx,total,onChange,onDelete,onUp,onDown,memberships,prevStop,fuelPrice,onCreateNewTrip,callAI}){
  const T=useTheme();
  const hasName=!!(stop.name&&stop.name.trim()&&stop.name!=="Home / Departure");
  const [open,setOpen]=useState(idx<2||!hasName); // auto-expand blank stops
  const [calcingMi,setCalcingMi]=useState(false);
  const [draft,setDraft]=useState(null); // null = not editing - user must click Edit
  const editing=false; // edit mode removed — all fields save immediately
  const cur=stop; // always use live stop
  const tc=STCOL[cur.type]||T.muted;
  // All fields save immediately — no edit mode needed
  const f=(k,v)=>onChange({...stop,[k]:v});
  const startEdit=()=>{}; // kept for compatibility but unused
  const addSideTrip=()=>onChange({...stop,sideTrips:[...(stop.sideTrips||[]),mkSideTrip()]});
  const updateSideTrip=(i,st)=>{
    // Always write to real stop (not draft) so routeCoords persist on the map
    const updated={...stop,sideTrips:(stop.sideTrips||[]).map((s,si)=>si===i?st:s)};
    onChange(updated);
    // Also keep draft in sync if editing
    if(draft) setDraft(updated);
  };
  const deleteSideTrip=(i)=>onChange({...stop,sideTrips:(stop.sideTrips||[]).filter((_,si)=>si!==i)});
  const saveEdit=()=>{
    if(draft) onChange(draft);
    setDraft(null);
  };
  const cancelEdit=()=>setDraft(null);

  // Auto-calc miles fires when stop is saved (not on every keystroke)
  // Shared helper: geocode both stops then get ORS driving miles
  const autoCalcMiles=async(curStop,prevStop_)=>{
    setCalcingMi(true);
    try{
      // Use stored coords when available to avoid unnecessary geocoding
      const getCoords=async(s)=>{
        const lat=parseFloat(s?.lat),lon=parseFloat(s?.lon);
        if(s?.lat&&s?.lon&&!isNaN(lat)&&lat!==0&&lon!==0) return[lat,lon];
        return geocodeStop(s);
      };
      const [c1,c2]=await Promise.all([getCoords(prevStop_||prevStop),getCoords(curStop||stop)]);
      if(!c1||!c2){setCalcingMi(false);return;}
      const miles=await roadMiles(c1[0],c1[1],c2[0],c2[1]);
      if(miles) onChange({...stop,distFromPrev:miles});
    }catch(e){console.warn("autoCalcMiles failed:",e);}
    setCalcingMi(false);
  };

  // Auto-trigger when name/address changes and miles are 0
  useEffect(()=>{
    if(!stop.name||!prevStop?.name) return;
    if(parseFloat(stop.distFromPrev)>0) return;
    const timer=setTimeout(()=>autoCalcMiles(stop,prevStop),1800);
    return()=>clearTimeout(timer);
  },[stop.name, stop.address, prevStop?.name]);
  const memberLinks=[];
  if(memberships?.goodSam&&cur.name) memberLinks.push({l:"Good Sam",url:`https://www.goodsam.com/rv-parks-campgrounds/?q=${encodeURIComponent(cur.name)}`,col:"#e74c3c"});
  if(memberships?.passportAmerica&&cur.name) memberLinks.push({l:"Passport America",url:`https://www.passportamerica.com/campgrounds/?search=${encodeURIComponent(cur.name)}`,col:"#3498db"});
  if(memberships?.harvestHosts&&cur.name) memberLinks.push({l:"Harvest Hosts",url:`https://harvesthosts.com/hosts/?location=${encodeURIComponent(cur.name)}`,col:T.free});
  if(memberships?.koaValueKard&&cur.name) memberLinks.push({l:"KOA",url:`https://koa.com/campgrounds/?q=${encodeURIComponent(cur.name)}`,col:"#f39c12"});
  return<Card accent={cur.active?tc:T.border} style={{opacity:cur.active?1:.5,transition:"opacity .2s"}}>
    <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:open?14:0,flexWrap:"wrap",overflow:"hidden",maxWidth:"100%"}}>

      <div onClick={()=>setOpen(o=>!o)} style={{display:"flex",alignItems:"center",gap:6,flex:1,minWidth:0,cursor:"pointer"}}>
        <div style={{background:tc+"22",border:`1px solid ${tc}44`,borderRadius:"50%",width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,flexShrink:0,fontWeight:700,color:tc}}>{idx+1}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:cur.name?T.text:T.accent,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{cur.name||(idx===0?"🏠 Set your home city":"✏️ Tap to open")}</div>
          {cur.type!=="home"&&cur.distFromPrev>0&&<div style={{marginBottom:4}}><span style={{background:T.accent+"18",color:T.accent,border:"1px solid "+T.accent+"33",borderRadius:6,padding:"2px 8px",fontSize:10,fontWeight:700}}>🚗 {cur.distFromPrev.toLocaleString()} mi</span><span style={{background:T.bgLite,color:T.muted,borderRadius:6,padding:"2px 8px",fontSize:10,marginLeft:4}}>{(cur.distFromPrev/60).toFixed(1)} hrs from prev</span></div>}
      <div style={{display:"flex",gap:5,flexWrap:"wrap",marginTop:2}}><Badge color={tc}>{STOP_TYPES.find(t=>t.v===cur.type)?.l?.replace(/.*\s/,"")||cur.type}</Badge>{cur.isFree&&<Badge color={T.free}>FREE</Badge>}{cur.fixedDates&&<Badge color={T.accent}>Fixed</Badge>}{!cur.active&&<Badge color={T.danger}>SKIPPED</Badge>}</div>
        </div>
      </div>
      <div style={{display:"flex",gap:3,flexShrink:0,flexWrap:"wrap",justifyContent:"flex-end",maxWidth:"calc(100vw - 140px)"}}>
        <Tog value={cur.active} onChange={v=>f("active",v)} label=""/>
        <Btn variant="ghost" style={{padding:"2px 5px",minWidth:0,fontSize:11}} onClick={e=>{e.stopPropagation();onUp&&onUp(idx);}} disabled={idx===0}>↑</Btn>
        <Btn variant="ghost" style={{padding:"2px 5px",minWidth:0,fontSize:11}} onClick={e=>{e.stopPropagation();onDown&&onDown(idx);}} disabled={idx===total-1}>↓</Btn>
        <Btn variant="ghost" style={{padding:"2px 5px",minWidth:0,fontSize:11}} onClick={()=>setOpen(o=>!o)}>{open?"▲":"▼"}</Btn>
        {idx>0&&<Btn variant="danger" style={{padding:"2px 5px",minWidth:0,fontSize:11}} title="Delete this stop" onClick={()=>onDelete(stop.id)}>✕</Btn>}

      </div>
    </div>

    {open&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(175px,1fr))",gap:12}}>
      {/* ── Stop Name + State — side by side, state drives geocoding ── */}
      <div style={{gridColumn:"1/-1",display:"grid",gridTemplateColumns:"1fr auto",gap:10,alignItems:"flex-start"}}>
        <div>
          <Label>Stop Name <span style={{fontWeight:400,fontSize:11,color:T.muted}}>— campground, city, or landmark</span></Label>
          <Inp value={cur.name} onChange={e=>{
            const newName=e.target.value;
            const nameChanged=newName.trim()!==cur.name.trim();
            if(editing){
              setDraft(d=>({...d,name:newName,lat:nameChanged?null:d.lat,lon:nameChanged?null:d.lon,distFromPrev:nameChanged?0:d.distFromPrev}));
            } else {
              onChange({...stop,name:newName,lat:nameChanged?null:stop.lat,lon:nameChanged?null:stop.lon,distFromPrev:nameChanged?0:stop.distFromPrev});
            }
          }} placeholder={cur.type==="home"?"e.g. Foley":"e.g. Fergus Falls  or  Palmer Gulch KOA"}/>
        </div>
        <div style={{minWidth:100}}>
          <Label>State {!cur.state&&<span style={{fontWeight:600,fontSize:10,color:T.danger}}>★ required</span>}</Label>
          <Sel value={cur.state||""} onChange={e=>f("state",e.target.value)} style={{borderColor:!cur.state?T.danger+"88":undefined}}>
            <option value="">-- State --</option>
            {US_STATES.map(s=><option key={s} value={s}>{s}</option>)}
          </Sel>
          {!cur.state&&<div style={{fontSize:10,color:T.danger,marginTop:2,fontWeight:600}}>Select your state</div>}
        </div>
      </div>
      {cur.type==="home"&&<div style={{gridColumn:"1/-1"}}><Label>Home City or Address <span style={{fontWeight:400,fontSize:10,color:T.muted}}>(for map centering)</span></Label><Inp value={cur.homeCity||""} onChange={e=>f("homeCity",e.target.value)} placeholder="e.g. Foley  or  123 Main St, Foley"/><div style={{fontSize:11,color:T.muted,marginTop:4}}>Optional — improves map accuracy. Select your state above for routing.</div></div>}
      <div><Label>Stop Type</Label><Sel value={cur.type} onChange={e=>f("type",e.target.value)}>{STOP_TYPES.filter(t=>idx>0||t.v==="home").map(t=><option key={t.v} value={t.v}>{t.l}</option>)}</Sel></div>
      <div style={{gridColumn:"1/-1"}}><Label>Address <span style={{fontWeight:400,fontSize:10,color:T.muted}}>(optional - improves map accuracy)</span></Label><Inp value={cur.address||""} onChange={e=>{
              if(editing){setDraft(d=>({...d,address:e.target.value,lat:null,lon:null,distFromPrev:0}));}
              else{onChange({...stop,address:e.target.value,lat:null,lon:null,distFromPrev:0});}
            }} placeholder="e.g. 1234 Camp Rd, Amarillo, TX 79101"/><div style={{fontSize:11,color:T.muted,marginTop:3}}>{cur.lat?<span style={{display:"flex",alignItems:"center",gap:8}}>✓ Pinned: {parseFloat(cur.lat).toFixed(4)}, {parseFloat(cur.lon).toFixed(4)}<button onClick={()=>onChange({...stop,lat:null,lon:null,distFromPrev:0})} style={{background:"none",border:"1px solid "+T.danger+"66",borderRadius:4,color:T.danger,fontSize:10,padding:"1px 6px",cursor:"pointer",lineHeight:1.4}}>✕ Clear Pin</button></span>:"Leave blank to use city/state for routing"}</div></div>
      <div><Label>Miles from Prev Stop</Label><div style={{display:"flex",gap:6,alignItems:"flex-start"}}><Inp type="number" min={0} value={cur.distFromPrev} onChange={e=>f("distFromPrev",e.target.value)} placeholder="0" style={{flex:1}}/>{idx>0&&prevStop?.name&&cur.name&&<button title="Auto-calculate driving miles from the previous stop using OpenRouteService routing" onClick={()=>{(async()=>{
  setCalcingMi(true);
  try{
    const getC=async(s)=>{const la=parseFloat(s?.lat),lo=parseFloat(s?.lon);if(s?.lat&&s?.lon&&!isNaN(la)&&la!==0)return[la,lo];return geocodeStop(s);};
    const [c1,c2]=await Promise.all([getC(prevStop),getC(cur)]);
    if(!c1||!c2){setCalcingMi(false);return;}
    const miles=await roadMiles(c1[0],c1[1],c2[0],c2[1]);
    if(miles) f("distFromPrev",miles);
  }catch(e){console.warn("Calc miles failed:",e);}
  setCalcingMi(false);
})();}} disabled={calcingMi} style={{background:calcingMi?"#94a3b8":T.accent,color:"#fff",border:"none",borderRadius:6,padding:"8px 10px",cursor:calcingMi?"not-allowed":"pointer",fontSize:12,fontWeight:700,whiteSpace:"nowrap",flexShrink:0}}>{calcingMi?"⏳…":"📍 Calc"}</button>}</div></div>
      {cur.type!=="home"&&<div style={{gridColumn:"1/-1"}}>
        <Label>⏱ Stay Duration</Label>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
          {[
            {label:"1 Night",min:1,max:1},
            {label:"Weekend",min:2,max:3},
            {label:"3-4 Days",min:3,max:4},
            {label:"1 Week",min:7,max:7},
            {label:"2 Weeks",min:14,max:14},
            {label:"3 Weeks",min:21,max:21},
            {label:"1 Month",min:30,max:30},
            {label:"Custom",min:null,max:null},
          ].map(opt=>{
            const isActive=opt.min===null
              ?(cur.minNights!==1&&cur.minNights!==2&&cur.minNights!==3&&cur.minNights!==7&&cur.minNights!==14&&cur.minNights!==21&&cur.minNights!==30)
              :(parseInt(cur.minNights)===opt.min&&parseInt(cur.maxNights)===opt.max);
            return<button key={opt.label} onClick={()=>{
              if(opt.min!==null){
                // Update both in one call to avoid stale closure overwrite
                onChange({...stop,minNights:opt.min,maxNights:opt.max});
              } else {
                document.getElementById(`minnights-${stop.id}`)?.focus();
              }
            }} style={{padding:"6px 14px",borderRadius:20,border:`1px solid ${isActive?T.accent:T.border}`,background:isActive?T.accent+"22":"transparent",color:isActive?T.accent:T.muted,fontSize:12,fontWeight:isActive?700:400,cursor:"pointer",fontFamily:T.F.cond,letterSpacing:.3,transition:"all .15s"}}>{opt.label}</button>;
          })}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <div><Label style={{fontSize:11}}>Min Nights</Label><Inp id={`minnights-${stop.id}`} type="number" min={0} max={365} value={cur.minNights} onChange={e=>{const v=parseInt(e.target.value)||0;f("minNights",v);if(v>parseInt(cur.maxNights||0))f("maxNights",v);}}/></div>
          <div><Label style={{fontSize:11}}>Max Nights</Label><Inp type="number" min={0} max={365} value={cur.maxNights} onChange={e=>f("maxNights",parseInt(e.target.value)||0)}/></div>
        </div>
        {cur.arriveDate&&cur.minNights>0&&<div style={{marginTop:6,fontSize:11,color:T.free,fontWeight:600}}>
          📅 Departs: {(()=>{const d=new Date(cur.arriveDate+"T00:00:00");d.setDate(d.getDate()+parseInt(cur.minNights));return d.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});})()}
        </div>}
      </div>}
      <div><Label>{cur.type==="home"?"Departure Time":"Depart Time Override"}</Label><Inp type="time" value={cur.preferDepartTime||""} onChange={e=>f("preferDepartTime",e.target.value)}/>{cur.type!=="home"&&<div style={{fontSize:11,color:T.muted,marginTop:4}}>Leave blank to use global setting</div>}</div>
      <div style={{display:"flex",flexDirection:"column",gap:10,justifyContent:"flex-end"}}><Tog value={cur.isFree} onChange={v=>f("isFree",v)} label="Free camping?"/><Tog value={cur.fixedDates} onChange={v=>f("fixedDates",v)} label="Fixed dates?"/></div>
      {!cur.isFree&&<div><Label>Nightly Rate ($) Est.</Label>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          <Inp type="number" min={0} value={cur.nightlyRate} onChange={e=>f("nightlyRate",e.target.value)} placeholder="45" style={{flex:1}}/>
          <button onClick={()=>f("isMonthlyRate",!cur.isMonthlyRate)} title="Switch to monthly rate" style={{padding:"4px 8px",borderRadius:6,border:"1px solid "+(cur.isMonthlyRate?T.accent:T.border),background:cur.isMonthlyRate?T.accent:"none",color:cur.isMonthlyRate?"#fff":T.muted,fontSize:10,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap",flexShrink:0}}>Monthly</button>
        </div></div>}
      {!cur.isFree&&cur.isMonthlyRate&&<div style={{background:T.accent+"10",border:"1px solid "+T.accent+"33",borderRadius:8,padding:"8px 10px",marginTop:-4,marginBottom:6}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:10,color:T.accent,marginBottom:6}}>📅 Monthly Stay</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <div><Label>Monthly Rate ($)</Label><Inp type="number" min={0} value={cur.monthlyRate} onChange={e=>f("monthlyRate",e.target.value)} placeholder="600"/></div>
          <div><Label>Months</Label><Inp type="number" min={1} max={24} value={cur.numMonths} onChange={e=>f("numMonths",parseInt(e.target.value)||1)} placeholder="1"/></div>
        </div>
        <div style={{fontSize:11,color:T.accent,fontWeight:600,marginTop:6}}>Total: ${Math.round((parseFloat(cur.monthlyRate)||0)*(parseInt(cur.numMonths)||1)).toLocaleString()} · {(parseInt(cur.numMonths)||1)*30} nights</div>
      </div>}
      {!cur.isFree&&<div><Label>Actual Paid ($) <span style={{fontWeight:400,fontSize:10,color:T.free}}>live tracking</span></Label><Inp type="number" min={0} value={cur.actualLodge||""} onChange={e=>f("actualLodge",parseFloat(e.target.value)||0)} placeholder="Leave blank if not yet visited" style={{borderColor:cur.actualLodge?T.free:undefined}}/>{cur.actualLodge>0&&cur.nightlyRate>0&&<div style={{fontSize:11,marginTop:3,color:cur.actualLodge<cur.nightlyRate*((cur.minNights+cur.maxNights)/2)?T.free:T.danger}}>{cur.actualLodge<cur.nightlyRate*((cur.minNights+cur.maxNights)/2)?"✓ Under estimate":"⚠ Over estimate"}</div>}</div>}
      {cur.fixedDates&&<><div><Label>Arrive Date</Label><Inp type="date" value={cur.arriveDate} onChange={e=>f("arriveDate",e.target.value)}/></div><div><Label>Depart Date</Label><Inp type="date" value={cur.departDate} onChange={e=>f("departDate",e.target.value)}/></div></>}
      {cur.type==="home"&&(
        <div style={{gridColumn:"1/-1",background:T.accent+"11",border:`2px solid ${T.accent}33`,borderRadius:10,padding:"12px 14px"}}>
          <Label style={{color:T.accent,fontWeight:700}}>📅 Trip Departure Date <span style={{fontWeight:400,fontSize:11,color:T.muted}}>— all stop dates chain from this</span></Label>
          <Inp type="date" value={cur.arriveDate||""} onChange={e=>f("arriveDate",e.target.value)}
            style={{borderColor:cur.arriveDate?T.accent:T.danger+"88",marginTop:4}}/>
          {!cur.arriveDate&&<div style={{fontSize:11,color:T.danger,fontWeight:600,marginTop:4}}>⚠ Set your departure date — all other stop dates depend on this</div>}
          {cur.arriveDate&&<div style={{fontSize:12,color:T.free,fontWeight:600,marginTop:6}}>✓ Trip starts {new Date(cur.arriveDate+"T00:00:00").toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}</div>}
          <div style={{fontSize:11,color:T.muted,marginTop:4}}>Every stop's arrive and depart date calculates automatically from this date + driving time + nights at each stop.</div>
        </div>
      )}
      {cur.type!=="home"&&!cur.fixedDates&&<>
        <div>
          <Label>Arrive Date{cur.arriveDate&&<span style={{fontSize:10,color:T.free,marginLeft:6,fontWeight:400}}>✓ auto-calculated</span>}</Label>
          <Inp type="date" value={cur.arriveDate||""} onChange={e=>f("arriveDate",e.target.value)}
            style={{borderColor:cur.arriveDate?T.free+"66":undefined}}/>
          <div style={{fontSize:11,color:T.muted,marginTop:3}}>
            {cur.arriveDate?"Calculated from home departure + prior stops":"Set home departure date to auto-calculate"}
          </div>
        </div>
        <div>
          <Label>Depart Date{cur.departDate&&<span style={{fontSize:10,color:T.free,marginLeft:6,fontWeight:400}}>✓ auto-calculated</span>}</Label>
          <Inp type="date" value={cur.departDate||""} onChange={e=>f("departDate",e.target.value)}
            style={{borderColor:cur.departDate?T.free+"66":undefined}}/>
          {cur.arriveDate&&cur.minNights>0&&<button onClick={()=>{
            const dep=addDays(cur.arriveDate,parseInt(cur.minNights)||0);
            f("departDate",dep);
          }} style={{marginTop:4,padding:"3px 10px",background:T.free+"22",border:`1px solid ${T.free}44`,borderRadius:6,fontSize:10,color:T.free,fontWeight:700,cursor:"pointer"}}>🗓 Set from Arrive + Nights</button>}
          <div style={{fontSize:11,color:T.muted,marginTop:3}}>
            {cur.departDate?"Calculated from arrive date + min nights":"Set arrive date and min nights, then tap button above"}
          </div>
        </div>
      </>}
      <div><Label>Fuel Override ($/gal)</Label><Inp type="number" step={.01} value={cur.fuelPriceOverride} onChange={e=>f("fuelPriceOverride",e.target.value)} placeholder="Use avg"/></div>
      {/* Side Trips */}
      {open&&(stop.sideTrips||[]).map((st,i)=>(
        <div key={st.id} style={{gridColumn:"1/-1"}}>
          <SideTripCard sideTrip={st} stopName={cur.name} stopState={cur.state||""} fuelPrice={fuelPrice} onUpdate={updated=>updateSideTrip(i,updated)} onDelete={()=>deleteSideTrip(i)} onCreateNewTrip={()=>onCreateNewTrip&&onCreateNewTrip(st)}/>
        </div>
      ))}
      {open&&<div style={{gridColumn:"1/-1",marginTop:4}}>
        <button onClick={addSideTrip} style={{background:"none",border:"2px dashed #f59e0b66",borderRadius:10,padding:"8px 16px",color:"#f59e0b",fontSize:12,fontWeight:700,cursor:"pointer",width:"100%",letterSpacing:.3}}>🏍 + Add Side Trip (motorcycle, car, bicycle day trip)</button>
      </div>}
      <div style={{gridColumn:"1/-1"}}><Label>Notes / Reservation #</Label><textarea name="stop-notes" id={`stop-notes-${stop.id}`} value={cur.notes} onChange={e=>f("notes",e.target.value)} placeholder="Confirmation #, park names, booking links, tips..." style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:6,color:T.text,padding:"8px 10px",fontSize:13,width:"100%",minHeight:64,resize:"vertical",outline:"none",fontFamily:T.F.body}} onFocus={e=>e.target.style.borderColor=T.accent} onBlur={e=>e.target.style.borderColor=T.border}/></div>
      {cur.type!=="home"&&<LocalFavoritesCard stop={editing?draft:stop} onChange={updated=>{
          if(editing) setDraft(updated); else onChange(updated);
        }} callAI={callAI}/> }
      {cur.name&&cur.name.length>2&&cur.type!=="home"&&<div style={{gridColumn:"1/-1",marginTop:4}}>
        <Label>🔗 Find &amp; Book</Label>
        <div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:4}}>
          {[[`https://www.recreation.gov/search?q=${encodeURIComponent(cur.name+(cur.state?", "+cur.state:""))}`,"🏛 Rec.gov","#3b82f6"],
            [`https://www.campendium.com/search?q=${encodeURIComponent(cur.name+(cur.state?", "+cur.state:""))}`,"🏕 Campendium","#22c55e"],
            [`https://thedyrt.com/search?query=${encodeURIComponent(cur.name+(cur.state?", "+cur.state:""))}`,"🏔 The Dyrt","#f59e0b"],
            [`https://www.campspot.com/search?q=${encodeURIComponent(cur.name+(cur.state?", "+cur.state:""))}`,"📅 Campspot","#8b5cf6"],
            [`https://www.sanidumps.com/list.php?state=${encodeURIComponent(cur.state||"")}`,"🚰 Dump Stations","#14b8a6"],
            [`https://www.google.com/search?q=${encodeURIComponent("RV campground "+cur.name+(cur.state?", "+cur.state:""))}`,"🔍 Google","#6b7280"],
          ].map(([url,label,color])=><a key={label} href={url} target="_blank" rel="noopener noreferrer" style={{fontSize:11,fontWeight:600,color,border:`1px solid ${color}44`,borderRadius:6,padding:"3px 10px",textDecoration:"none",background:color+"12"}}>{label}</a>)}
        </div>
      </div>}
      {memberLinks.length>0&&<div style={{gridColumn:"1/-1"}}><Label>🎫 Membership Campground Search</Label><div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:4}}>{memberLinks.map(ml=><a key={ml.l} href={ml.url} target="_blank" rel="noopener noreferrer" style={{padding:"5px 12px",borderRadius:6,background:ml.col+"22",color:ml.col,border:`1px solid ${ml.col}44`,fontSize:12,fontWeight:600,textDecoration:"none",fontFamily:T.F.cond,letterSpacing:.5}}>{ml.l} →</a>)}</div></div>}
    </div>}
  </Card>;
}


// ── Import Stops Modal ─────────────────────────────────────────────
function ImportStopsModal({onClose,onImport}){
  const T=useTheme();
  const [mode,setMode]=useState("ai"); // "ai" | "csv"
  const [aiText,setAiText]=useState("");
  const [preview,setPreview]=useState(null);
  const [error,setError]=useState("");
  const fileRef=useRef(null);

  const STOP_TYPES=["family","transit","event","home","other"];

  const parseWithAI=()=>{
    if(!aiText.trim()){setError("Please enter your stop list.");return;}
    setError("");setPreview(null);
    // Local parser - no API needed
    const US_STATE_LIST=["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
    const STATE_NAMES={"alabama":"AL","alaska":"AK","arizona":"AZ","arkansas":"AR","california":"CA","colorado":"CO","connecticut":"CT","delaware":"DE","florida":"FL","georgia":"GA","hawaii":"HI","idaho":"ID","illinois":"IL","indiana":"IN","iowa":"IA","kansas":"KS","kentucky":"KY","louisiana":"LA","maine":"ME","maryland":"MD","massachusetts":"MA","michigan":"MI","minnesota":"MN","mississippi":"MS","missouri":"MO","montana":"MT","nebraska":"NE","nevada":"NV","new hampshire":"NH","new jersey":"NJ","new mexico":"NM","new york":"NY","north carolina":"NC","north dakota":"ND","ohio":"OH","oklahoma":"OK","oregon":"OR","pennsylvania":"PA","rhode island":"RI","south carolina":"SC","south dakota":"SD","tennessee":"TN","texas":"TX","utah":"UT","vermont":"VT","virginia":"VA","washington":"WA","west virginia":"WV","wisconsin":"WI","wyoming":"WY"};
    // Split on newlines or semicolons
    const lines=aiText.split(/[\n;]+/).map(l=>l.trim()).filter(l=>l.length>2);
    if(!lines.length){setError("No stops found. Enter one stop per line.");return;}
    const parsed=lines.map(line=>{
      let name="",state="",minNights=3,maxNights=7,nightlyRate=0,isFree=false,type="other",notes="";
      let work=line;
      // Extract rate: $45/night $45 per night
      const rateM=work.match(/\$(\d+(?:\.\d+)?)(?:\/night|\s*per\s*night)?/i);
      if(rateM){nightlyRate=parseFloat(rateM[1]);work=work.replace(rateM[0],"").trim();}
      // Extract nights: 14 nights, 2 weeks, 1 month
      const nightsM=work.match(/(\d+)\s*nights?/i);
      const weeksM=work.match(/(\d+)\s*weeks?/i);
      const monthsM=work.match(/(\d+)\s*months?/i);
      if(nightsM){minNights=maxNights=parseInt(nightsM[1]);work=work.replace(nightsM[0],"").trim();}
      else if(weeksM){minNights=maxNights=parseInt(weeksM[1])*7;work=work.replace(weeksM[0],"").trim();}
      else if(monthsM){minNights=maxNights=parseInt(monthsM[1])*30;work=work.replace(monthsM[0],"").trim();}
      // Free indicators
      if(/free|boondock|walmart|casino|blm|harvest host/i.test(work)){isFree=true;if(!nightlyRate)nightlyRate=0;}
      // Type keywords
      if(/family|visit|grandma|grandpa|relative|cousin|aunt|uncle|parents|kids/i.test(work)) type="family";
      else if(/festival|event|concert|show|fair|rally|rodeo/i.test(work)) type="event";
      else if(/overnight|transit|pass.?through|one.?night|boondock|walmart/i.test(work)) type="transit";
      else if(/work|remote|hub|office/i.test(work)) type="workhub";
      // Extract state - 2-letter at end or after comma, or full state name
      const stateAbbrM=work.match(/\b([A-Z]{2})\b(?=[,\s]|$)/);
      if(stateAbbrM&&US_STATE_LIST.includes(stateAbbrM[1])){
        state=stateAbbrM[1];
        work=work.replace(stateAbbrM[0],"").trim();
      } else {
        for(const[sn,sc] of Object.entries(STATE_NAMES)){
          if(work.toLowerCase().includes(sn)){state=sc;work=work.replace(new RegExp(sn,"i"),"").trim();break;}
        }
      }
      // Notes - anything after a dash or in parens
      const notesM=work.match(/[--](.+)$|\((.+)\)/);
      if(notesM){notes=(notesM[1]||notesM[2]||"").trim();work=work.replace(notesM[0],"").trim();}
      // Clean up remaining commas, extra spaces - what remains is the name
      name=work.replace(/[,;]+/g," ").replace(/\s+/g," ").trim();
      // Remove type keywords from name
      name=name.replace(/\b(family visit|overnight|boondock|transit|free camping|event)\b/gi,"").replace(/\s+/g," ").trim();
      if(!name) name="Unnamed Stop";
      return{name,state,type,minNights,maxNights,nightlyRate,isFree,notes,arriveDate:"",departDate:""};
    }).filter(p=>p.name&&p.name!=="Unnamed Stop"||lines.length===1);
    if(!parsed.length){setError("Could not parse any stops. Try: \"Austin TX 4 nights $45/night, Santa Fe NM 3 nights\"");return;}
    setPreview(parsed);
  };

  const parseCSV=e=>{
    const file=e.target.files?.[0];
    if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      try{
        const lines=ev.target.result.split(/\r?\n/).filter(l=>l.trim());
        if(lines.length<2){setError("CSV must have a header row and at least one data row.");return;}
        const headers=lines[0].split(",").map(h=>h.trim().toLowerCase().replace(/[^a-z]/g,""));
        const rows=lines.slice(1).map(line=>{
          // Handle quoted fields
          const cols=[];let cur="",inQ=false;
          for(const ch of line){if(ch==='"')inQ=!inQ;else if(ch===","&&!inQ){cols.push(cur.trim());cur="";}else cur+=ch;}
          cols.push(cur.trim());
          const obj={};headers.forEach((h,i)=>obj[h]=cols[i]||"");
          return obj;
        }).filter(r=>r.name||r.location||r.city);
        const mapped=rows.map(r=>{
          const name=(r.name||r.location||r.city||"").trim();
          const state=(r.state||"").trim().toUpperCase().slice(0,2);
          const minN=parseInt(r.minnights||r.nights||r.min||1)||1;
          const maxN=parseInt(r.maxnights||r.nights||r.max||minN)||minN;
          const rate=parseFloat(r.nightlyrate||r.rate||r.cost||0)||0;
          const freeStr=(r.free||r.isfree||"").toString().toLowerCase().trim();
          const isFree=freeStr==="true"||freeStr==="1"||freeStr==="yes";
          const type=(()=>{const t=(r.type||"").toLowerCase().trim();const valid=["home","family","tourist","workhub","event","transit","free"];return valid.includes(t)?t:"other";})();
          return{name,state,type,minNights:minN,maxNights:maxN,nightlyRate:rate,isFree,notes:r.notes||r.note||"",arriveDate:r.arrivedate||r.arrive||"",departDate:r.departdate||r.depart||""};
        });
        setPreview(mapped);setError("");
      }catch(e){setError("Could not read CSV. Make sure it's saved as .csv format.");}
    };
    reader.readAsText(file);
  };

  const downloadTemplate=()=>{
    const csv=`Name,State,Type,Min Nights,Max Nights,Nightly Rate,Free,Arrive Date,Depart Date,Notes
Houston,TX,family,7,14,35,false,,,Visiting grandkids
San Antonio,TX,event,5,5,45,false,2025-10-15,2025-10-20,Fiesta festival
Dodge City,KS,transit,1,1,0,true,,,Walmart boondock
Denver,CO,other,10,21,55,false,,,Sightseeing Rocky Mountains
`;
    const a=document.createElement("a");a.href="data:text/csv;charset=utf-8,"+encodeURIComponent(csv);a.download="rv_stops_template.csv";a.click();
  };

  const [importSuccess2,setImportSuccess2]=useState(false);
  const commitImport=()=>{
    if(!preview?.length)return;
    const validTypes=["home","family","tourist","workhub","event","transit","free","other"];
    const newStops=preview.map(p=>mkStop({
      name:p.name||"",
      state:p.state||"",
      type:validTypes.includes(p.type)?p.type:"other",
      minNights:parseInt(p.minNights)||1,
      maxNights:parseInt(p.maxNights)||parseInt(p.minNights)||1,
      nightlyRate:parseFloat(p.nightlyRate)||0,
      isFree:p.isFree===true||p.isFree==="true",
      arriveDate:p.arriveDate||"",
      departDate:p.departDate||"",
      notes:p.notes||"",
      active:true,
    }));
    onImport(newStops);
    setImportSuccess2(true);
    setTimeout(()=>{setImportSuccess2(false);onClose();},1200);
  };

  const updatePreviewRow=(i,field,val)=>{
    setPreview(prev=>prev.map((r,ri)=>ri===i?{...r,[field]:val}:r));
  };

  return<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:9999,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
    <div className="modal-anim" style={{background:T.bgMid,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:700,maxHeight:"92vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 -8px 40px rgba(0,0,0,0.35)"}}>
      {/* Header */}
      <div style={{padding:"20px 24px 0",flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
          <div>
            <div style={{fontFamily:T.F.head,fontWeight:900,fontSize:22,color:T.text}}>Import Stops</div>
            <div style={{fontSize:12,color:T.muted,marginTop:2}}>Add multiple stops at once - AI or CSV</div>
          </div>
          <button onClick={onClose} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,width:36,height:36,fontSize:18,cursor:"pointer",color:T.muted,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
        </div>
        {/* Mode tabs */}
        <div style={{display:"flex",gap:0,borderBottom:`1px solid ${T.border}`}}>
          {[{id:"ai",label:"✨ AI Smart Import"},{id:"csv",label:"📄 CSV / Spreadsheet"}].map(m=>
            <button key={m.id} onClick={()=>{setMode(m.id);setPreview(null);setError("");}} style={{padding:"10px 20px",background:"none",border:"none",borderBottom:mode===m.id?`2px solid ${T.accent}`:"2px solid transparent",color:mode===m.id?T.accent:T.muted,fontFamily:T.F.cond,fontWeight:700,fontSize:13,cursor:"pointer",letterSpacing:.5,marginBottom:-1}}>{m.label}</button>
          )}
        </div>
      </div>

      {/* Body */}
      <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
        {mode==="ai"&&!preview&&<>
          <div style={{fontSize:13,color:T.muted,marginBottom:12,lineHeight:1.6}}>Type or paste your trip stops in plain English. Be as detailed or brief as you like - AI will extract city, nights, type, and cost.</div>
          <div style={{background:T.bgLite,borderRadius:10,padding:12,marginBottom:12,fontSize:12,color:T.muted,lineHeight:1.7,borderLeft:`3px solid ${T.accent}`}}>
            <strong style={{color:T.accent}}>Examples:</strong><br/>
            "Houston TX 7 nights family visit $35/night, San Antonio TX 5 nights Fiesta festival $45/night"<br/>
            "Denver CO 2 weeks sightseeing, Dodge City KS 1 night free Walmart stop, Salt Lake City UT 10 days"<br/>
            "Yellowstone 5 nights camping $28, Grand Teton 3 nights $32"
          </div>
          <div style={{position:"relative"}}>
            <textarea name="ai-import-text" id="ai-import-text" value={aiText} onChange={e=>setAiText(e.target.value)} placeholder="One stop per line. e.g.:\nWeatherford TX 14 nights $45/night family visit\nDodge City KS 1 night free boondock\nDenver CO 2 weeks $55/night sightseeing" style={{width:"100%",minHeight:140,background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,color:T.text,padding:"12px 44px 12px 14px",fontSize:14,fontFamily:"inherit",resize:"vertical",outline:"none",lineHeight:1.6,boxSizing:"border-box"}} onFocus={e=>{e.target.style.borderColor=T.accent;e.target.style.boxShadow=`0 0 0 3px ${T.accent}22`;}} onBlur={e=>{e.target.style.borderColor=T.border;e.target.style.boxShadow="none";}}/>
            {(typeof window!=="undefined"&&(window.SpeechRecognition||window.webkitSpeechRecognition))&&(
              <button onClick={()=>{
                const SR=window.SpeechRecognition||window.webkitSpeechRecognition;
                const recognition=new SR();
                recognition.lang="en-US";
                recognition.continuous=false;
                recognition.interimResults=false;
                recognition.onresult=e=>{
                  const transcript=e.results[0][0].transcript;
                  setAiText(prev=>prev?prev+" "+transcript:transcript);
                };
                recognition.onerror=e=>setError("Voice input error: "+e.error);
                recognition.start();
              }} title="Speak your stops" style={{position:"absolute",top:10,right:10,background:T.accent,color:"#fff",border:"none",borderRadius:8,width:32,height:32,cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>🎤</button>
            )}
          </div>
          {error&&<div style={{color:T.danger,fontSize:12,marginTop:8,padding:"8px 12px",background:T.danger+"11",borderRadius:6}}>{error}</div>}
        </>}

        {mode==="csv"&&!preview&&<>
          <div style={{fontSize:13,color:T.muted,marginBottom:16,lineHeight:1.6}}>Upload a CSV file with your stops. Use the template for the correct column format.</div>
          <button onClick={downloadTemplate} style={{display:"flex",alignItems:"center",gap:8,padding:"10px 18px",background:T.accent+"15",border:`1px dashed ${T.accent}`,borderRadius:10,color:T.accent,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:T.F.cond,marginBottom:20,width:"100%",justifyContent:"center"}}>
            ⬇ Download CSV Template
          </button>
          <div style={{background:T.bgLite,borderRadius:10,padding:12,marginBottom:16,fontSize:12,color:T.muted,lineHeight:1.7}}>
            <strong style={{color:T.text}}>Column Guide:</strong><br/>
            <strong>Name</strong> - City name &nbsp;·&nbsp; <strong>State</strong> - 2-letter state &nbsp;·&nbsp; <strong>Type</strong> - family / transit / event / other<br/>
            <strong>Min/Max Nights</strong> - stay range &nbsp;·&nbsp; <strong>Nightly Rate</strong> - cost in $ &nbsp;·&nbsp; <strong>Free</strong> - true/false &nbsp;·&nbsp; <strong>Notes</strong> - anything extra
          </div>
          <div onClick={()=>fileRef.current?.click()} style={{border:`2px dashed ${T.border}`,borderRadius:12,padding:"32px 20px",textAlign:"center",cursor:"pointer",transition:"border-color .2s"}} onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent} onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
            <div style={{fontSize:36,marginBottom:8}}>📂</div>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:T.text,marginBottom:4}}>Click to upload CSV</div>
            <div style={{fontSize:12,color:T.muted}}>or drag and drop · .csv files only</div>
          </div>
          <input ref={fileRef} name="csv-upload" id="csv-upload" type="file" accept=".csv" style={{display:"none"}} onChange={parseCSV}/>
          {error&&<div style={{color:T.danger,fontSize:12,marginTop:12,padding:"8px 12px",background:T.danger+"11",borderRadius:6}}>{error}</div>}
        </>}

        {/* Preview table */}
        {preview&&<>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.accent,letterSpacing:.5,textTransform:"uppercase"}}>✓ {preview.length} stop{preview.length!==1?"s":""} ready to import</div>
              <div style={{fontSize:12,color:T.muted,marginTop:2}}>Review and edit before adding to your trip</div>
            </div>
            <button onClick={()=>setPreview(null)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:7,padding:"5px 12px",color:T.muted,fontSize:12,cursor:"pointer",fontFamily:T.F.cond}}>← Back</button>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {preview.map((row,i)=><div key={i} style={{background:T.bg,borderRadius:10,padding:"12px 14px",border:`1px solid ${T.border}`}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:8,alignItems:"start"}}>
                <input name={`preview-name-${i}`} id={`preview-name-${i}`} value={row.name} onChange={e=>updatePreviewRow(i,"name",e.target.value)} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:7,color:T.text,padding:"7px 10px",fontSize:14,fontWeight:600,outline:"none",width:"100%"}}/>
                <button onClick={()=>setPreview(prev=>prev.filter((_,ri)=>ri!==i))} style={{background:"none",border:`1px solid ${T.danger}44`,borderRadius:7,width:32,height:34,color:T.danger,cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
              </div>
              <div style={{display:"flex",gap:8,marginTop:8,flexWrap:"wrap"}}>
                <select name={`preview-type-${i}`} id={`preview-type-${i}`} value={row.type} onChange={e=>updatePreviewRow(i,"type",e.target.value)} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:7,color:T.text,padding:"5px 8px",fontSize:12,cursor:"pointer",outline:"none"}}>
                  {["family","transit","event","other"].map(t=><option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
                </select>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <input type="number" name={`preview-min-${i}`} id={`preview-min-${i}`} value={row.minNights} onChange={e=>updatePreviewRow(i,"minNights",parseInt(e.target.value)||1)} style={{width:52,background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:7,color:T.text,padding:"5px 7px",fontSize:12,textAlign:"center",outline:"none"}}/>
                  <span style={{fontSize:11,color:T.muted}}>-</span>
                  <input type="number" name={`preview-max-${i}`} id={`preview-max-${i}`} value={row.maxNights} onChange={e=>updatePreviewRow(i,"maxNights",parseInt(e.target.value)||1)} style={{width:52,background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:7,color:T.text,padding:"5px 7px",fontSize:12,textAlign:"center",outline:"none"}}/>
                  <span style={{fontSize:11,color:T.muted}}>nights</span>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <span style={{fontSize:12,color:T.muted}}>$</span>
                  <input type="number" name={`preview-rate-${i}`} id={`preview-rate-${i}`} value={row.nightlyRate} onChange={e=>updatePreviewRow(i,"nightlyRate",parseFloat(e.target.value)||0)} style={{width:60,background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:7,color:T.text,padding:"5px 7px",fontSize:12,textAlign:"center",outline:"none"}}/>
                  <span style={{fontSize:11,color:T.muted}}>/night</span>
                </div>
                <label style={{display:"flex",alignItems:"center",gap:5,fontSize:12,color:T.muted,cursor:"pointer"}}>
                  <input type="checkbox" name={`preview-free-${i}`} id={`preview-free-${i}`} checked={!!row.isFree} onChange={e=>updatePreviewRow(i,"isFree",e.target.checked)} style={{cursor:"pointer"}}/>Free
                </label>
              </div>
              {row.notes&&<div style={{fontSize:11,color:T.muted,marginTop:6,fontStyle:"italic"}}>{row.notes}</div>}
            </div>)}
          </div>
        </>}
      </div>

      {/* Footer */}
      <div style={{padding:"16px 24px",borderTop:`1px solid ${T.border}`,background:T.bgMid,flexShrink:0,display:"flex",gap:10}}>
        {!preview&&mode==="ai"&&<button onClick={parseWithAI} disabled={!aiText.trim()} style={{flex:2,background:T.accent,border:"none",borderRadius:10,padding:"13px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:"#fff",cursor:"pointer",boxShadow:`0 3px 12px ${T.accent}55`,letterSpacing:.5,textTransform:"uppercase",transition:"all .2s"}}>"✨ Parse Stops"</button>}
        {!preview&&mode==="csv"&&<button onClick={()=>fileRef.current?.click()} style={{flex:2,background:T.accent,border:"none",borderRadius:10,padding:"13px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:"#fff",cursor:"pointer",boxShadow:`0 3px 12px ${T.accent}55`,letterSpacing:.5,textTransform:"uppercase"}}>📂 Choose CSV File</button>}
        {importSuccess2&&<div style={{flex:2,background:T.free,borderRadius:10,padding:"13px",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontFamily:T.F.cond,fontWeight:700,fontSize:14,letterSpacing:.5}}>✓ {preview?.length} Stop{preview?.length!==1?"s":""} Added!</div>}
{!importSuccess2&&preview&&<button onClick={commitImport} style={{flex:2,background:T.free,border:"none",borderRadius:10,padding:"13px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:"#fff",cursor:"pointer",boxShadow:`0 3px 12px ${T.free}55`,letterSpacing:.5,textTransform:"uppercase"}}>➕ Add {preview.length} Stop{preview.length!==1?"s":""} to Trip</button>}
        <button onClick={onClose} style={{flex:1,background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"13px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:T.muted,cursor:"pointer"}}>Cancel</button>
      </div>
    </div>
  </div>;
}


// ── Look Ahead Section ─────────────────────────────────────────────
function LookAheadSection({stops,onOpenHowTo}){
  const T=useTheme();
  const [results,setResults]=useState({});  // keyed by stop id
  const [loading,setLoading]=useState({});
  const [expanded,setExpanded]=useState({});
  // ORS_KEY from env (defined at module top)

  const activeStops=stops.filter(s=>s.active&&s.name&&s.name.trim().length>2);

  const geocode=async(stop)=>{
    // Use stored coords first if available
    const storedLat=parseFloat(stop.lat),storedLon=parseFloat(stop.lon);
    if(stop.lat&&stop.lon&&!isNaN(storedLat)&&storedLat!==0) return[storedLat,storedLon];
    // Fall back to geocodeStop shared helper
    const r=await geocodeStop(stop);
    if(r) return r;
    throw new Error("Not found");
  };

  const fetchNearby=async(lat,lon,label)=>{
    const rad=60*1609; // 60 miles in meters
    const bbox=`${lat-0.9},${lon-1.2},${lat+0.9},${lon+1.2}`;
    const queries=[
      {key:"campgrounds",icon:"🏕",label:"Campgrounds",q:`[out:json][timeout:12];(node["tourism"="camp_site"](${bbox});node["tourism"="caravan_site"](${bbox}););out 8;`},
      {key:"rvparks",icon:"🚐",label:"RV Parks",q:`[out:json][timeout:12];(node["amenity"="rv_park"](${bbox});node["tourism"="caravan_site"]["fee"="yes"](${bbox}););out 6;`},
      {key:"fuel",icon:"⛽",label:"Fuel Stops",q:`[out:json][timeout:10];node["amenity"="fuel"](${bbox});out 8;`},
      {key:"walmart",icon:"🏪",label:"Walmart / Overnight",q:`[out:json][timeout:10];node["name"~"Walmart",i](${bbox});out 5;`},
      {key:"outdoor",icon:"🎣",label:"Cabela's / Bass Pro / Scheels",q:`[out:json][timeout:10];(node["name"~"Cabela",i](${bbox});node["name"~"Bass Pro",i](${bbox});node["name"~"Scheels",i](${bbox}););out 8;`},
      {key:"cracker",icon:"🍳",label:"Cracker Barrel",q:`[out:json][timeout:10];node["name"~"Cracker Barrel",i](${bbox});out 5;`},
      {key:"loves",icon:"🛣",label:"Love's / Pilot / Flying J",q:`[out:json][timeout:10];node["name"~"Love's|Loves|Pilot|Flying J",i](${bbox});out 6;`},
      {key:"trails",icon:"🥾",label:"Trails",q:`[out:json][timeout:10];node["highway"="trailhead"](${bbox});out 6;`},
    ];

    // Also fetch Recreation.gov federal campgrounds
    let fedParks=[];
    try{
      const recGovUrl=`https://ridb.recreation.gov/api/v1/facilities?latitude=${lat}&longitude=${lon}&radius=60&activity=CAMPING&limit=8&apikey=`;
      // Recreation.gov needs an API key - use as search link instead
      fedParks=[{name:"Search Recreation.gov",distance:"60mi radius",isLink:true,url:`https://www.recreation.gov/search?lat=${lat}&lng=${lon}&radius=60&activity=CAMPING`}];
    }catch(e){}

    const allResults={};
    await Promise.all(queries.map(async q=>{
      try{
        const r=await fetch("https://overpass-api.de/api/interpreter",{method:"POST",body:q.q});
        const d=await r.json();
        allResults[q.key]={icon:q.icon,label:q.label,items:d.elements.slice(0,8).map(el=>({
          name:el.tags?.name||el.tags?.operator||"Unnamed",
          distance:calcDist(lat,lon,el.lat||el.center?.lat,el.lon||el.center?.lon),
          url:el.tags?.website||el.tags?.["contact:website"]||null,
          lat:el.lat||el.center?.lat||null,
          lon:el.lon||el.center?.lon||null,
          phone:el.tags?.phone||el.tags?.["contact:phone"]||null,
          address:[el.tags?.["addr:housenumber"],el.tags?.["addr:street"],el.tags?.["addr:city"]].filter(Boolean).join(" ")||null,
        })).sort((a,b)=>a.distance-b.distance)};
      }catch(e){allResults[q.key]={icon:q.icon,label:q.label,items:[]};}
    }));

    allResults.federal={icon:"🌲",label:"Federal Parks (Recreation.gov)",items:fedParks};
    return allResults;
  };

  const calcDist=(lat1,lon1,lat2,lon2)=>{
    const R=3959;
    const dLat=(lat2-lat1)*Math.PI/180;
    const dLon=(lon2-lon1)*Math.PI/180;
    const a=Math.sin(dLat/2)**2+Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)**2;
    return Math.round(R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)));
  };

  const handleLookAhead=async(stop)=>{
    setLoading(p=>({...p,[stop.id]:true}));
    setExpanded(p=>({...p,[stop.id]:true}));
    try{
      const [lat,lon]=await geocode(stop);
      const res=await fetchNearby(lat,lon,stop.name);
      setResults(p=>({...p,[stop.id]:res}));
    }catch(e){
      setResults(p=>({...p,[stop.id]:{error:true}}));
    }
    setLoading(p=>({...p,[stop.id]:false}));
  };

  const handleAllStops=async()=>{
    for(const s of activeStops){
      await handleLookAhead(s);
      await new Promise(r=>setTimeout(r,600)); // rate limit
    }
  };

  if(activeStops.length===0) return(
    <div className="anim">
      <SecHead icon="🔍" title="Look Ahead" sub="See what's within 60 miles of each stop - campgrounds, fuel, trails, federal parks, and more."/>
      <QuickTipBar tabId="lookahead" onOpenHowTo={onOpenHowTo}/>
      <Card style={{padding:24,textAlign:"center"}}><div style={{fontSize:13,color:T.muted}}>Add named stops in the Stops tab to use Look Ahead.</div></Card>
    </div>
  );

  return(
    <div className="anim">
      <SecHead icon="🔍" title="Look Ahead" sub="What's within 60 miles of each stop - campgrounds, RV parks, fuel, trails & federal parks."/>
      <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
        <Btn onClick={handleAllStops} style={{background:T.accent,color:"#fff"}}>🔍 Look Ahead - All Stops</Btn>
        <div style={{fontSize:12,color:T.muted}}>Or click individual stops below · 60 mile radius · Live data</div>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {activeStops.map((stop,i)=>{
          const res=results[stop.id];
          const isLoading=loading[stop.id];
          const isExpanded=expanded[stop.id];
          const totalFound=res&&!res.error?Object.values(res).reduce((s,c)=>s+(c.items?.length||0),0):0;
          return(
            <Card key={stop.id} style={{padding:0,overflow:"hidden"}}>
              <div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:12,justifyContent:"space-between",flexWrap:"wrap",borderBottom:isExpanded&&res?`1px solid ${T.border}`:"none"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{background:T.accent,color:"#fff",borderRadius:"50%",width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,flexShrink:0}}>{i+1}</div>
                  <div>
                    <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:T.text}}>{stop.name}</div>
                    <div style={{fontSize:11,color:T.muted}}>{stop.minNights} nights · {stop.state||"No state set"}</div>
                  </div>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  {res&&!res.error&&<div style={{fontSize:12,color:T.free,fontWeight:600}}>✓ {totalFound} found</div>}
                  {res?.error&&<div style={{fontSize:12,color:T.danger}}>⚠ Could not geocode</div>}
                  <Btn onClick={()=>handleLookAhead(stop)} variant="ghost" style={{fontSize:12,padding:"6px 14px"}} disabled={isLoading}>
                    {isLoading?"⏳ Searching…":"🔍 Look Ahead"}
                  </Btn>
                  {res&&<Btn variant="ghost" onClick={()=>setExpanded(p=>({...p,[stop.id]:!isExpanded}))} style={{fontSize:12,padding:"6px 10px"}}>{isExpanded?"▲":"▼"}</Btn>}
                </div>
              </div>
              {isExpanded&&res&&!res.error&&(
                <div style={{padding:"14px 16px"}}>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:10}}>
                    {Object.entries(res).map(([key,cat])=>(
                      <div key={key} style={{background:T.bgLite,borderRadius:8,padding:"10px 12px",border:`1px solid ${T.border}`}}>
                        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.accent,marginBottom:8}}>{cat.icon} {cat.label} <span style={{color:T.muted,fontWeight:400}}>({cat.items?.length||0})</span></div>
                        {cat.items?.length===0&&<div style={{fontSize:11,color:T.muted}}>None found nearby</div>}
                        {cat.items?.map((item,j)=>{
                          const mapsQ=item.lat&&item.lon
                            ?`${item.lat},${item.lon}`
                            :encodeURIComponent((item.name||"")+(item.address?", "+item.address:""));
                          const mapsUrl=`https://www.google.com/maps/dir/?api=1&destination=${mapsQ}`;
                          return(
                            <div key={j} style={{padding:"6px 0",borderBottom:j<cat.items.length-1?`1px solid ${T.border}44`:"none"}}>
                              {item.isLink?(
                                <a href={item.url} target="_blank" rel="noopener noreferrer" style={{color:T.accent,textDecoration:"none",fontWeight:600,fontSize:12}}>{item.name} →</a>
                              ):(
                                <>
                                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:3}}>
                                    <span style={{fontSize:12,fontWeight:600,color:T.text,flex:1}}>{item.name}</span>
                                    <span style={{color:T.muted,flexShrink:0,fontSize:11,marginTop:1}}>{item.distance} mi</span>
                                  </div>
                                  {item.address&&<div style={{fontSize:10,color:T.muted,marginBottom:3}}>📍 {item.address}</div>}
                                  {item.phone&&<div style={{fontSize:10,color:T.muted,marginBottom:3}}>📞 <a href={`tel:${item.phone}`} style={{color:T.accent,textDecoration:"none"}}>{item.phone}</a></div>}
                                  <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                                    {item.url&&<a href={item.url.startsWith("http")?item.url:"https://"+item.url} target="_blank" rel="noopener noreferrer" style={{fontSize:10,padding:"2px 7px",background:T.accent+"22",border:`1px solid ${T.accent}44`,borderRadius:4,color:T.accent,textDecoration:"none",fontWeight:600}}>🌐 Website</a>}
                                    <a href={mapsUrl} target="_blank" rel="noopener noreferrer" style={{fontSize:10,padding:"2px 7px",background:"#16a34a22",border:"1px solid #16a34a44",borderRadius:4,color:"#16a34a",textDecoration:"none",fontWeight:600}}>🗺 Directions</a>
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                  <div style={{marginTop:10,display:"flex",gap:8,flexWrap:"wrap"}}>
                    <a href={`https://www.recreation.gov/search?q=${encodeURIComponent(stop.name)}&activity=CAMPING`} target="_blank" rel="noopener noreferrer" style={{padding:"5px 12px",background:T.free+"22",border:`1px solid ${T.free}44`,borderRadius:6,color:T.free,fontSize:11,fontWeight:600,textDecoration:"none"}}>🌲 Recreation.gov →</a>
                    <a href={`https://www.campendium.com/search?q=${encodeURIComponent(stop.name)}`} target="_blank" rel="noopener noreferrer" style={{padding:"5px 12px",background:T.accent+"22",border:`1px solid ${T.accent}44`,borderRadius:6,color:T.accent,fontSize:11,fontWeight:600,textDecoration:"none"}}>🏕 Campendium →</a>
                    <a href={`https://freecampsites.net/#!${encodeURIComponent(stop.name)}`} target="_blank" rel="noopener noreferrer" style={{padding:"5px 12px",background:"#f59e0b22",border:"1px solid #f59e0b44",borderRadius:6,color:"#f59e0b",fontSize:11,fontWeight:600,textDecoration:"none"}}>🆓 FreeCampsites →</a>
                    <a href={`https://www.google.com/maps/search/RV+parks+near+${encodeURIComponent(stop.name)}`} target="_blank" rel="noopener noreferrer" style={{padding:"5px 12px",background:"#ef444422",border:"1px solid #ef444444",borderRadius:6,color:"#ef4444",fontSize:11,fontWeight:600,textDecoration:"none"}}>📍 Google Maps →</a>
                  </div>
                </div>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
}

function StopsSection({stops,onChange,memberships,onOpenHowTo,onAIBuilder,onHuntPlanner,aiPurchased,aiFreeCalls,onTabChange,callAI,prefs={}}){
  const T=useTheme();
  const [showImport,setShowImport]=useState(false);
  const add=()=>onChange([...stops,mkStop()]);
  const addBdk=()=>onChange([...stops,mkStop({type:"transit",isFree:true,nightlyRate:0,distFromPrev:100,minNights:1,maxNights:1,name:"Boondock / Overnight Stop"})]);
  const addEvt=()=>onChange([...stops,mkStop({type:"event",fixedDates:true})]);
  const namedCount=stops.filter(s=>s.type!=="home"&&s.name&&s.name.trim()).length;
  const del=id=>onChange(stops.filter(s=>s.id!==id));
    // Helper: propagate dates through chain — used by Recalculate button
  const propagateDates=(list)=>{
    let runDate="";
    return list.map((s)=>{
      if(s.type==="home"){runDate=s.arriveDate||"";return s;}
      if(s.fixedDates&&s.arriveDate&&s.departDate){runDate=s.departDate;return s;}
      if(!runDate) return s;
      const mi=parseFloat(s.distFromPrev)||0;
      const driveHrs=mi>0?mi/60:0;
      const daysNeeded=driveHrs>8?2:1;
      const arr=addDays(runDate,daysNeeded);
      const nights=parseInt(s.minNights)||0;
      const dep=arr?addDays(arr,nights):"";
      runDate=dep||runDate;
      return{...s,arriveDate:arr,departDate:dep};
    });
  };
  const upd=u=>{
    const next=stops.map(s=>s.id===u.id?u:s);
    onChange(next);
  };
  const up=i=>{if(i===0)return;const a=[...stops];[a[i-1],a[i]]=[a[i],a[i-1]];onChange(a);};
  const dn=i=>{if(i===stops.length-1)return;const a=[...stops];[a[i],a[i+1]]=[a[i+1],a[i]];onChange(a);};
  const handleImport=newStops=>{
    // Remove blank unnamed non-home stops before appending imported ones
    const cleaned=stops.filter(s=>s.type==="home"||s.name.trim()!=="");
    onChange([...cleaned,...newStops]);
  };
  return<div className="anim">
    {showImport&&<ImportStopsModal onClose={()=>setShowImport(false)} onImport={handleImport}/>}
    <SecHead icon="📍" title="Trip Stops" sub="Add every stop. Toggle OFF to skip. Use Auto-Calculate Miles on the Map tab to fill distances automatically."/>
    <QuickTipBar tabId="stops" onOpenHowTo={onOpenHowTo}/>
    <div style={{display:"flex",gap:10,marginBottom:12,flexWrap:"wrap"}}>
      <Card accent={T.accent} style={{flex:1,minWidth:240,padding:"12px 16px",background:T.accent+"08"}}>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <div style={{flex:1}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.accent}}>✨ Add Stops by Typing</div>
            <div style={{fontSize:11,color:T.muted,marginTop:2}}>Type naturally: "Austin TX 4 nights $45" - one per line</div>
          </div>
          <Btn onClick={()=>setShowImport(true)} style={{background:T.accent,color:"#fff",border:"none",flexShrink:0,padding:"7px 14px",fontSize:12}}>✨ Parser</Btn>
        </div>
      </Card>
      <Card accent="#16a34a" style={{flex:1,minWidth:200,padding:"12px 16px",background:"#16a34a08"}}>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <div style={{flex:1}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#16a34a"}}>🦌 AI Hunt Planner</div>
            <div style={{fontSize:11,color:T.muted,marginTop:2}}>Plan your RV hunting road trip - species, state, public land</div>
          </div>
          <Btn onClick={onHuntPlanner} style={{background:"#16a34a",color:"#fff",border:"none",flexShrink:0,padding:"7px 14px",fontSize:12}}>🦌 Hunt Plan</Btn>
        </div>
      </Card>
      <Card accent="#7c3aed" style={{flex:1,minWidth:240,padding:"12px 16px",background:"#7c3aed08"}}>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <div style={{flex:1}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#7c3aed"}}>✨ AI Route Planner</div>
            <div style={{fontSize:11,color:T.muted,marginTop:2}}>{stops.filter(s=>s.active&&s.name&&s.type!=="home").length>0?"Optimize existing stops or plan a new route":"Plan full route from home to destination"}{aiFreeCalls!==null&&!aiPurchased?" · "+aiFreeCalls+" free left":""}</div>
          </div>
          <Btn onClick={onAIBuilder} style={{background:"#7c3aed",color:"#fff",border:"none",flexShrink:0,padding:"7px 14px",fontSize:12}}>✨ Plan Route</Btn>
        </div>
      </Card>
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:10}}>{stops.map((s,i)=><StopCard key={s.id} stop={s} idx={i} total={stops.length} onChange={upd} onDelete={del} onUp={up} onDown={dn} memberships={memberships} prevStop={i>0?stops[i-1]:null} fuelPrice={3.30} callAI={callAI} onCreateNewTrip={st=>{
          if(window.confirm("Create a new trip for this side trip vehicle?\n\nThis will export and reset the planner with "+st.vehicleType+" pre-selected.\n\nExport your current trip first!")){
            onChange([]);
          }
        }} callAI={callAI}/>)}</div>
    {stops.filter(s=>s.active&&s.name&&s.type!=="home").length>0&&
      stops.filter(s=>s.active&&s.distFromPrev>0).length===0&&
      <WhatNextBanner message="Great! Now calculate driving miles so your Summary fills in." tab="map" btnLabel="Go to Map" onTabChange={onTabChange}/>
    }
    <div style={{display:"flex",gap:10,marginTop:14,flexWrap:"wrap"}}>
      <CoachMark coachId="stops-add-first" message="Start here — tap to add your first destination" position="top" active={stops.filter(s=>s.active&&s.name&&s.type!=="home").length===0}>
        <Btn onClick={add}>+ Add Stop</Btn>
      </CoachMark>
      <Btn onClick={()=>{
        const homeStop=stops.find(s=>s.type==="home");
        if(!homeStop?.arriveDate){alert("Set your Home departure date first — open the Home stop card and set the Departure Date.");return;}
        onChange(propagateDates(stops));
      }} variant="ghost" title="Recalculate all stop arrive/depart dates from home departure date">🗓 Recalculate Dates</Btn>
      <Btn variant="ghost" onClick={addBdk}>+ Boondock Stop</Btn>
      <Btn variant="ghost" onClick={addEvt}>+ Fixed-Date Event</Btn>
      <Btn variant="danger" onClick={()=>{if(window.confirm("Remove all stops and start fresh? Your home stop will be kept."))onChange([stops.find(s=>s.type==="home")||mkStop({name:"Home / Departure",type:"home",minNights:0,maxNights:0,nightlyRate:0,distFromPrev:0}),mkStop(),mkStop()]);}} style={{marginLeft:"auto",fontSize:11,padding:"6px 12px"}}>🗑 Clear Stops</Btn>
    </div>
  </div>;
}

function BoondockSection({onOpenHowTo}){
  const T=useTheme();
  const tips=[{i:"🏪",t:"Walmart / Sam's Club",d:"Most allow free RV overnight. Call ahead. Self-contained only."},{i:"🎰",t:"Casino Parking",d:"Most casinos welcome self-contained RVs. Some have dump stations."},{i:"🛣",t:"Pilot / Flying J / Love's",d:"Designated RV spots, dump stations ($10-15). Use Trucker Path."},{i:"🌲",t:"BLM & National Forest",d:"FREE dispersed camping. 14-night limit. Apps: FreeRoam, freecampsites.net"},{i:"🏕",t:"State & County Parks",d:"$15-35/night with hookups. Book via each state's reservation site."},{i:"🍷",t:"Harvest Hosts ($99/yr)",d:"Free stays at 5,000+ wineries, farms, breweries."},{i:"🅿",t:"Rest Areas",d:"Many states allow 8-10 hrs overnight. Rules vary."},{i:"📱",t:"Apps to Use",d:"FreeCampsites.net · Campendium · iOverlander · Boondockers Welcome · AllStays"}];
  return<div className="anim">
    <SecHead icon="🌲" title="Free Camping Guide" sub="Smart boondocking saves $300-$1,500+ on a long trip."/>
    <QuickTipBar tabId="boondocking" onOpenHowTo={onOpenHowTo}/>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(275px,1fr))",gap:12}}>{tips.map((t,i)=><Card key={i} style={{padding:"14px 16px"}}><div style={{fontSize:22,marginBottom:6}}>{t.i}</div><div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:T.accent,marginBottom:6}}>{t.t}</div><div style={{fontSize:12,color:T.muted,lineHeight:1.6}}>{t.d}</div></Card>)}</div>
  </div>;
}

// ── Map Section ────────────────────────────────────────────────────

function MapSection({stops,memberships,onAddStop,mapFilters:mapFiltersProp,setMapFilters:setMapFiltersProp,onOpenHowTo,prefs,vehicle,onLiveEta,prevGpsPosRef,prevGpsTimeRef,onMapSnapshot,liveEta,callAI,emergency,aiPurchased,aiFreeCalls,fuelApps}){
  // ── GPS / Travel Mode functions ──
  const updateUserMarker=(lat,lon)=>{
    const L=window.L,map=mapInstanceRef.current;
    if(!L||!map) return;
    if(!userMarkerRef.current){
      userMarkerRef.current=L.circleMarker([lat,lon],{radius:8,fillColor:"#22c55e",fillOpacity:1,color:"#fff",weight:2}).addTo(map);
    } else {
      userMarkerRef.current.setLatLng([lat,lon]);
    }
  };
  const locateMe=()=>{
    if(!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(pos=>{
      const lat=pos.coords.latitude,lon=pos.coords.longitude;
      setUserPos([lat,lon]);
      updateUserMarker(lat,lon);
      mapInstanceRef.current?.setView([lat,lon],12);
    },err=>console.warn("GPS:",err.message));
  };
  const toggleTracking=()=>{tracking?setTracking(false):(locateMe(),setTracking(true));};
  const startTravelMode=()=>{setTravelMode(true);locateMe();};
  const stopTravelMode=()=>{setTravelMode(false);};
  const refreshTravelLayers=()=>{if(userPos){mapInstanceRef.current?.setView(userPos,11);}else{locateMe();}applyActiveFilters();};
  const findNearbyStops=()=>{if(!userPos){locateMe();return;}applyActiveFilters();};

  const T=useTheme();
  const mapRef=useRef(null);
  const mapInstanceRef=useRef(null);
  const layerGroupsRef=useRef({});
  const userMarkerRef=useRef(null);
  const routeLayerRef=useRef(null);
  const stopMarkersGroupRef=useRef(null);
  const mapDrawTimerRef=useRef(null);
  const mapDrawAbortRef=useRef(null);
  const trackingRef=useRef(null);
  const [layers,setLayers]=useState({campgrounds:false,fuel:false,golf:false,trails:false,weather:false,rvparks:false,sidetrips:false});
  // amenity filter tags used to enrich Overpass queries
  const AMENITY_TAGS={fullHookups:'"hookup"="electric;water;sewer"',electric:'"electric_hookup"~"yes|30A|50A"',water:'"water_hookup"="yes"',amp50:'"amp"="50"',dumpStation:'"sanitary_dump_station"="yes"',propane:'"gas:lpg"="yes"',showers:'"shower"="yes"',laundry:'"laundry"="yes"',pool:'"swimming_pool"="yes"',petFriendly:'"dog"~"yes|leashed"',wifi:'"internet_access"~"wlan|yes"',cableTV:'"cabletv"="yes"',firewood:'"firewood"="yes"',rvStorage:'"storage"="yes"'};
  const [locating,setLocating]=useState(false);
  const [userPos,setUserPos]=useState(null);
  const [nearbyResults,setNearbyResults]=useState([]);
  const [searchingNearby,setSearchingNearby]=useState(false);
  const [midpointSuggestions,setMidpointSuggestions]=useState([]);
  const [mapReady,setMapReady]=useState(false);
  // Re-trigger map sizing when tab becomes visible
  const prevTabRef=useRef(null);
  const [tracking,setTracking]=useState(false);
  const [offRouteAlert,setOffRouteAlert]=useState(false);
  const [calcingMiles,setCalcingMiles]=useState(false);
  const [waypointMode,setWaypointMode]=useState(false);
  const [routeProfile,setRouteProfile]=useState("driving-car"); // driving-car | driving-hgv | cycling-regular | foot-walking
  const [showFilterModal,setShowFilterModal]=useState(false);
  const [mapRefreshKey,setMapRefreshKey]=useState(0);
  const showFullRoute=()=>setMapRefreshKey(k=>k+1);
  // mapFilters lifted to AppInner - use prop or fall back to local state
  const [localMapFilters,setLocalMapFilters]=useState({
    campgrounds:false,fuel:false,golf:false,trails:false,rvparks:false,weather:false,
    fullHookups:false,electric:false,water:false,amp50:false,dumpStation:false,
    propane:false,showers:false,laundry:false,pool:false,petFriendly:false,
    wifi:false,cableTV:false,firewood:false,rvStorage:false,
  });
  const mapFilters=mapFiltersProp||localMapFilters;
  const setMapFilters=setMapFiltersProp||setLocalMapFilters;
  const [travelMode,setTravelMode]=useState(false);
  const [travelLayerResults,setTravelLayerResults]=useState([]);
  const [coPilotMsg,setCoPilotMsg]=useState("");
  const [coPilotLoading,setCoPilotLoading]=useState(false);
  const [showCoPilot,setShowCoPilot]=useState(false);
  const [coPilotInput,setCoPilotInput]=useState("");
  const lastCoPilotMilesRef=useRef(0);
  const coPilotBriefingDoneRef=useRef(false);
  const [refreshingTravel,setRefreshingTravel]=useState(false);
  const [lastTravelPos,setLastTravelPos]=useState(null);
  const travelLayerGroupRef=useRef(null);
  // ── AI Co-Pilot helper ──
  const askCoPilot=async(question,auto=false)=>{
    if(!callAI||(!aiPurchased&&!aiFreeCalls)) return;
    setCoPilotLoading(true);
    if(!auto) setShowCoPilot(true);
    const pos=userPos?`GPS: ${userPos[0].toFixed(4)}, ${userPos[1].toFixed(4)}`:"GPS not active";
    const today=new Date().toISOString().slice(0,10);
    const nextStop=stops.find(s=>s.active&&s.type!=="home"&&(!s.arr||s.arr>=today)&&s.name);
    const tankRange=Math.round((parseFloat(vehicle?.mpg)||8)*(parseFloat(vehicle?.tankGallons)||100));
    const activeRoadside=(emergency?.roadside||[]).filter(r=>r.active);
    const roadsideSummary=activeRoadside.length>0?activeRoadside.map(r=>r.providerName+(r.coverageNotes?" ("+r.coverageNotes+")":"")).join(", "):"None on file";
    const context="You are an AI co-pilot for an RV traveler.\nCurrent position: "+pos+"\n"
      +"Vehicle: "+(vehicle?.rvType||"RV")+", "+(vehicle?.mpg||8)+" MPG, "+(vehicle?.tankGallons||100)+" gal tank (range ~"+tankRange+" mi)\n"
      +"Next stop: "+(nextStop?.name||"none")+(nextStop?.state?", "+nextStop.state:"")+"\n"
      +"Miles to next stop: "+(nextStop?.mi||"unknown")+"\n"
      +"Travel mode: "+(travelMode?"active":"off")+"\n"
      +"GPS tracking: "+(tracking?"active":"off")+"\n"
      +"Roadside assistance: "+roadsideSummary;
    const result=await callAI(question,context);
    setCoPilotMsg(result||"Unable to get response. Please try again.");
    setCoPilotLoading(false);
  };

  const morningBriefing=async()=>{
    if(coPilotBriefingDoneRef.current) return;
    coPilotBriefingDoneRef.current=true;
    const today=new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"});
    const nextStop=stops.find(s=>s.active&&s.type!=="home"&&s.name);
    const tankRange=Math.round((parseFloat(vehicle?.mpg)||8)*(parseFloat(vehicle?.tankGallons)||100));
    const activeRoadside2=(emergency?.roadside||[]).filter(r=>r.active);
    const roadsideNote=activeRoadside2.length>0?"Active roadside: "+activeRoadside2.map(r=>r.providerName).join(", ")+". ":"";
    const prompt="Give a friendly morning travel briefing for today ("+today+"). "
      +"Next destination: "+(nextStop?.name||"unknown")+(nextStop?.state?", "+nextStop.state:"")+", "
      +"approximately "+(nextStop?.mi||"unknown")+" miles away. Vehicle has ~"+tankRange+" mile range per tank. "
      +"Max drive hours: "+(prefs?.maxDriveHours||7)+". "+roadsideNote
      +"Cover: drive time estimate, when to fuel up, and one encouraging tip. Keep it under 150 words and conversational.";
    setCoPilotLoading(true);
    setShowCoPilot(true);
    const result=await callAI(prompt,"You are a friendly RV travel co-pilot giving a morning briefing. Be warm, practical, and concise.");
    setCoPilotMsg(result||"Good morning! Have a safe trip today.");
    setCoPilotLoading(false);
  };

  // Exclude the default home label - only geocode if home has a real city name set
  const namedStops=stops.filter(s=>s.active&&(s.name||s.address)&&s.name!=="Home / Departure");
  const homeStop=stops.find(s=>s.type==="home"&&s.active);

  useEffect(()=>{
    if(!document.getElementById("leaflet-css")){const link=document.createElement("link");link.id="leaflet-css";link.rel="stylesheet";link.href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";document.head.appendChild(link);}
    if(!document.getElementById("html2canvas-js")){const hc=document.createElement("script");hc.id="html2canvas-js";hc.src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";document.head.appendChild(hc);}
    if(!document.getElementById("leaflet-js")){const script=document.createElement("script");script.id="leaflet-js";script.src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";script.onload=()=>setMapReady(true);document.head.appendChild(script);}else if(window.L){setMapReady(true);}
  },[]);

  // ── Effect 1: Create map (only when Leaflet loads) ──
  useEffect(()=>{
    if(!mapReady||!mapRef.current) return;
    if(mapInstanceRef.current) return; // already created
    const L=window.L;
    const map=L.map(mapRef.current,{zoomControl:true});
    mapInstanceRef.current=map;
    L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",{attribution:'© OpenStreetMap © CARTO',subdomains:"abcd",maxZoom:19}).addTo(map);
    // Create custom panes so stop pins always render above filter markers
    map.createPane("filterPane").style.zIndex=400;    // filter markers (F, R etc) - below stops
    map.createPane("stopPane").style.zIndex=500;      // numbered stop pins - always on top
    map.createPane("sidePane").style.zIndex=450;      // side trip markers
    layerGroupsRef.current={
      campgrounds:L.layerGroup({pane:"filterPane"}),
      fuel:L.layerGroup({pane:"filterPane"}),
      golf:L.layerGroup({pane:"filterPane"}),
      trails:L.layerGroup({pane:"filterPane"}),
      weather:L.layerGroup({pane:"filterPane"}),
      rvparks:L.layerGroup({pane:"filterPane"}),
      sidetrips:L.layerGroup({pane:"sidePane"}),
    };
    travelLayerGroupRef.current=L.layerGroup().addTo(map);
    stopMarkersGroupRef.current=L.layerGroup({pane:"stopPane"}).addTo(map);
    setLayers({campgrounds:false,fuel:false,golf:false,trails:false,weather:false,rvparks:false,sidetrips:false});
    window._assignCampground=(stopId,name,address,lat,lon)=>{
      onAddStop&&onAddStop([{id:stopId,name,address,lat,lon}],'assign');
      mapInstanceRef.current?.closePopup();
    };
  },[mapReady]);

  // ── Effect 1c: Auto-start GPS if permission already granted ──
  useEffect(()=>{
    if(!mapReady) return;
    if(navigator.permissions){
      navigator.permissions.query({name:"geolocation"}).then(result=>{
        if(result.state==="granted"){
          // Permission already granted - auto-show location
          navigator.geolocation.getCurrentPosition(pos=>{
            const lat=pos.coords.latitude,lon=pos.coords.longitude;
            setUserPos([lat,lon]);
            updateUserMarker(lat,lon);
            // Auto-start continuous tracking
            if(!trackingRef.current){
              setTracking(true);
              trackingRef.current=navigator.geolocation.watchPosition(pos2=>{
                const la=pos2.coords.latitude,lo=pos2.coords.longitude,now=Date.now();
                setUserPos([la,lo]);
                updateUserMarker(la,lo);
                if(onLiveEta){
                  let mph=pos2.coords.speed!=null&&pos2.coords.speed>0?pos2.coords.speed*2.237:(parseFloat(prefs?.avgSpeedMph)||60);
                  const today=new Date().toISOString().slice(0,10);
                  const nextStop=stops.find(s=>s.active&&s.type!=="home"&&(!s.arr||s.arr>=today)&&s.name);
                  if(nextStop&&nextStop.lat&&nextStop.lon){
                    const distMi=Math.sqrt(Math.pow((la-parseFloat(nextStop.lat))*69,2)+Math.pow((lo-parseFloat(nextStop.lon))*69*Math.cos(la*Math.PI/180),2));
                    const eta=new Date(now+(distMi/mph)*3600000);
                    onLiveEta({eta,nextStop:nextStop.name,miles:Math.round(distMi),mph:Math.round(mph)});
                  }
                }
              },{enableHighAccuracy:true,timeout:10000,maximumAge:30000});
            }
          },{timeout:5000});
        }
      }).catch(()=>{});
    }
  },[mapReady]);

  // ── Effect 1b: Re-apply saved filters after map + layer groups are ready ──
  // Uses polling to confirm layerGroupsRef is populated before applying
  


  // ── Effect 2: Update markers and route when stops/profile change ──
  // Debounced: wait 800ms after stops settle before geocoding to avoid abort loops
  const stopsDrawTimerRef=useRef(null);
  const renderGenRef=useRef(0); // increments each render; OSRM callback checks this
  useEffect(()=>{
    if(!mapReady||!mapRef.current||!mapInstanceRef.current) return;
    // Invalidate map size in case container was resized while on another tab
    try{mapInstanceRef.current.invalidateSize();}catch{}
    if(stopsDrawTimerRef.current) clearTimeout(stopsDrawTimerRef.current);
    stopsDrawTimerRef.current=setTimeout(()=>{
    if(mapDrawAbortRef.current) mapDrawAbortRef.current.abort();
    const abortCtrl=new AbortController();
    mapDrawAbortRef.current=abortCtrl;
    // Increment render generation — stale OSRM callbacks check this before drawing
    const myGen=++renderGenRef.current;
    const L=window.L;
    const map=mapInstanceRef.current;

    // Build full stop list for map - home always first if it has homeCity, state, or name
    // Non-home stops need a name. First active stop always included as route origin.
    const allMapStops=stops.filter(s=>{
      if(!s.active) return false;
      if(s.type==="home") return !!(s.address||s.homeCity||s.state||s.name);
      return !!(s.name||s.address||(s.lat&&s.lon));
    });
    const buildQ=s=>{
      const st=(s.state||"").trim();
      // Check if state abbrev already appears in string (handles "Louisville, KY" with state="KY")
      const stInStr=(str)=>{
        if(!st||!str) return false;
        const u=str.toUpperCase(),su=st.toUpperCase();
        return u.includes(", "+su)||u.includes(" "+su+",")||u.endsWith(" "+su)||u.endsWith(","+su)||u.includes("("+su+")");
      };
      const withState=(str)=>str+(st&&!stInStr(str)?", "+st:"")+", USA";
      if(s.type==="home"){
        const addr=(s.address||"").trim();
        const city=(s.homeCity||"").trim();
        const nm=(s.name||"").trim();
        const isGeneric=!nm||nm.toLowerCase().includes("home")||nm.toLowerCase().includes("departure");
        const parsedCity=!isGeneric?nm.split(",")[0].trim():"";
        if(addr) return withState(addr);
        if(city) return withState(city);
        if(parsedCity) return withState(parsedCity);
        return st?st+", USA":"";
      }
      const addr=(s.address||"").trim();
      if(addr) return withState(addr);
      const nm=(s.name||"").trim();
      const isDefault=!nm||nm==="Boondock / Overnight Stop"||nm==="Transit Stop";
      if(isDefault) return st?st+", USA":"";
      return withState(nm);
    };

    if(namedStops.length===0){
      const homeQuery=(homeStop?.address||homeStop?.homeCity)||(homeStop?.state?`${homeStop.state}, USA`:null);
      if(homeQuery){
        fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(homeQuery)}&format=json&limit=1`,{headers:{"Accept-Language":"en"}})
          .then(r=>r.json()).then(d=>{if(d&&d.length)map.setView([parseFloat(d[0].lat),parseFloat(d[0].lon)],8);else map.setView([30.4,-87.7],6);}).catch(()=>map.setView([30.4,-87.7],6));
      } else if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(
          pos=>map.setView([pos.coords.latitude,pos.coords.longitude],9),
          ()=>map.setView([30.4,-87.7],6),
          {timeout:5000,maximumAge:300000}
        );
      } else {map.setView([30.4,-87.7],6);}
      return;
    }

    // Clear only stop markers and route - preserve layer groups (campgrounds etc)
    const stopMarkersGroup=stopMarkersGroupRef.current;
    if(stopMarkersGroup) stopMarkersGroup.clearLayers();
    if(routeLayerRef.current&&mapInstanceRef.current){
      try{mapInstanceRef.current.removeLayer(routeLayerRef.current);}catch{}
      routeLayerRef.current=null;
    }
    const coords=new Array(allMapStops.length).fill(null);
    // Use module-level geocodeStop for consistency across the whole app
    const sleep=(ms)=>new Promise(r=>setTimeout(r,ms));
    const coordsToSave=[];
    const geocodeAllSeq=async()=>{
      let pinCount=0;
      for(let i=0;i<allMapStops.length;i++){
        if(abortCtrl.signal.aborted) break;
        const s=allMapStops[i];
        // 1. Use stored coords first (AI-applied stops, fuel stops with known coords)
        if(s.lat&&s.lon&&parseFloat(s.lat)!==0&&parseFloat(s.lon)!==0){
          coords[i]=[parseFloat(s.lat),parseFloat(s.lon)];
        } else {
          // 2. Geocode using shared helper (ORS→Nominatim→fallbacks)
          if(i>0) await sleep(100);
          if(abortCtrl.signal.aborted) break;
          const result=await geocodeStop(s);
          if(abortCtrl.signal.aborted) break;
          if(!result) continue;
          coords[i]=result;
          // Track which stops need their coords saved (batched after render)
          if(!s.lat||!s.lon||parseFloat(s.lat||0)===0){
            coordsToSave.push({id:s.id,lat:result[0],lon:result[1]});
          }
        }
        // 3. Render marker — only runs when coords[i] is set
        const lat=coords[i][0];
        const lon=coords[i][1];
        const isFuelStop=s.subtype==="fuel_stop"||s.fuelStop||(s.type==="transit"&&s.isFree&&parseInt(s.minNights)===0);
        const tc=isFuelStop?"#f59e0b":(STCOL[s.type]||T.muted);
        const nights=isFuelStop?0:(s.nights||parseInt(s.minNights)||0);
        const fuelBrand=s.notes?s.notes.split(".")[0].trim():"";
        const cost=isFuelStop?("Fuel: "+(fuelBrand||"Fuel Stop")):(s.isFree?"Free":(s.nightlyRate?"$"+s.nightlyRate+"/night":"-"));
        const memLinks=[];
        if(memberships?.goodSam) memLinks.push(`<a href="https://www.goodsam.com/rv-parks-campgrounds/?q=${encodeURIComponent(s.name)}" target="_blank" style="padding:3px 8px;background:#e74c3c22;border:1px solid #e74c3c44;border-radius:4px;color:#e74c3c;font-size:11px;font-weight:600;text-decoration:none">Good Sam</a>`);
        if(memberships?.passportAmerica) memLinks.push(`<a href="https://www.passportamerica.com/campgrounds/?search=${encodeURIComponent(s.name)}" target="_blank" style="padding:3px 8px;background:#3498db22;border:1px solid #3498db44;border-radius:4px;color:#3498db;font-size:11px;font-weight:600;text-decoration:none">Passport America</a>`);
        if(memberships?.harvestHosts) memLinks.push(`<a href="https://harvesthosts.com/hosts/?location=${encodeURIComponent(s.name)}" target="_blank" style="padding:3px 8px;background:#27ae6022;border:1px solid #27ae6044;border-radius:4px;color:#27ae60;font-size:11px;font-weight:600;text-decoration:none">Harvest Hosts</a>`);
        if(memberships?.koaValueKard) memLinks.push(`<a href="https://koa.com/campgrounds/?q=${encodeURIComponent(s.name)}" target="_blank" style="padding:3px 8px;background:#f39c1222;border:1px solid #f39c1244;border-radius:4px;color:#f39c12;font-size:11px;font-weight:600;text-decoration:none">KOA</a>`);
        // Fuel app links for fuel stops
        const FA=fuelApps||{gasbuddy:true,truckerpath:true};
        const fuelAppDefs=[
          {key:"gasbuddy",   label:"GasBuddy",      url:`https://www.gasbuddy.com/home?search=${encodeURIComponent(s.name)}`},
          {key:"upside",     label:"GetUpside",     url:"https://upside.com/"},
          {key:"mudflap",    label:"Mudflap",       url:"https://www.mudflap.com/"},
          {key:"truckerpath",label:"Trucker Path",  url:"https://www.truckerpath.com/fuel"},
          {key:"routefuel",  label:"RouteFuel",     url:"https://routefuel.com/"},
          {key:"waze",       label:"Waze",          url:`https://www.waze.com/ul?q=gas+station+near+${encodeURIComponent(s.name)}`},
          {key:"colonialcoin",label:"Colonial Coin",url:"https://colonialcoin.com/"},
        ];
        const enabledApps=fuelAppDefs.filter(a=>FA[a.key]);
        const fuelAppLinks=isFuelStop&&enabledApps.length>0?`
          <div style="border-top:1px solid #eee;padding-top:6px;margin-top:4px">
            <div style="font-size:10px;color:#999;margin-bottom:4px;text-transform:uppercase;letter-spacing:.5px">⛽ Your Fuel Apps</div>
            <div style="display:flex;gap:5px;flex-wrap:wrap">
              ${enabledApps.map(a=>`<a href="${a.url}" target="_blank" style="padding:3px 8px;background:#f59e0b22;border:1px solid #f59e0b44;border-radius:4px;color:#b45309;font-size:11px;font-weight:600;text-decoration:none">${a.label}</a>`).join("")}
            </div>
          </div>`:"";
        pinCount++;
        const pinLabel=isFuelStop?"⛽":String(pinCount);
        const pinSize=isFuelStop?14:13;
        const icon=L.divIcon({html:`<div style="background:${tc};color:#fff;width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:${pinSize}px;border:2px solid #fff;box-shadow:0 2px 8px #0008">${pinLabel}</div>`,className:"",iconSize:[32,32],iconAnchor:[16,16]});
        const markerOptions={icon,pane:"stopPane"};
        const popup=`<div style="font-family:sans-serif;min-width:220px;padding:6px">
          <div style="font-size:15px;font-weight:700;margin-bottom:4px">${s.name}</div>
          <div style="color:#666;font-size:12px;margin-bottom:6px">${isFuelStop?"⛽ Fuel Stop":(STOP_TYPES.find(t=>t.v===s.type)?.l||s.type)}</div>
          ${nights?`<div style="font-size:12px;margin-bottom:2px">🌙 <strong>${nights} nights</strong></div>`:""}
          <div style="font-size:12px;margin-bottom:8px">💰 ${cost}</div>
          ${s.notes?`<div style="font-size:11px;color:#888;border-top:1px solid #eee;padding-top:4px;margin-bottom:8px">${s.notes}</div>`:""}
          <div style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:6px">
            ${(()=>{
              const sn=encodeURIComponent((s.name||"").trim()||(s.homeCity||"")||(s.state||""));
              const loc=(s.name||s.homeCity||s.state||"");
              return (isFuelStop?"":`<a href="https://www.campendium.com/search?q=${sn}" target="_blank" style="padding:3px 8px;background:#27ae6022;border:1px solid #27ae6044;border-radius:4px;color:#27ae60;font-size:11px;font-weight:600;text-decoration:none">🏕 Campendium</a>`)+
              (loc?`<a href="https://www.google.com/maps/search/${encodeURIComponent(loc)}" target="_blank" style="padding:3px 8px;background:#2255a422;border:1px solid #2255a444;border-radius:4px;color:#2255a4;font-size:11px;font-weight:600;text-decoration:none">📍 Google Maps</a>`:"");
            })()}
          </div>
          ${memLinks.length>0?`<div style="border-top:1px solid #eee;padding-top:6px"><div style="font-size:10px;color:#999;margin-bottom:4px;text-transform:uppercase;letter-spacing:.5px">Your Memberships</div><div style="display:flex;gap:5px;flex-wrap:wrap">${memLinks.join("")}</div></div>`:""}
          ${fuelAppLinks}
        </div>`;
        const sm=L.marker([lat,lon],markerOptions).bindPopup(popup,{maxWidth:280}).bindTooltip(
          (isFuelStop?"⛽ Fuel: "+(fuelBrand||"Fuel Stop"):"")+
          (s.type==="home"?"🏠 ":"")+
          "<strong>"+s.name+"</strong>"+
          (isFuelStop?"":"<br/>"+nights+" nights · "+cost),
          {direction:"top",offset:[0,-18]}
        );
        if(stopMarkersGroupRef.current) stopMarkersGroupRef.current.addLayer(sm); else sm.addTo(map);
      } // end for loop
    }; // end geocodeAllSeq

    geocodeAllSeq().then(()=>{
      // Batch-save geocoded coords back to stops (avoids re-triggering map render)
      if(coordsToSave.length>0&&onAddStop){
        // Use setTimeout to defer until after current render cycle
        setTimeout(()=>onAddStop(coordsToSave),0);
      }
      const valid=coords.filter(Boolean);
      if(!valid.length){map.setView([30.4,-87.7],6);return;}
      if(valid.length===1){map.setView(valid[0],8);return;}
      map.fitBounds(L.latLngBounds(valid).pad(0.2));
      // Re-apply active filters ONLY if layers have no markers yet
      // (prevents re-firing Overpass on every stop reorder or tab return)
      const hasExistingMarkers=poiKeys.some(k=>{
        const grp=layerGroupsRef.current[k];
        return mapFilters[k]&&grp&&grp.getLayers&&grp.getLayers().length>0;
      });
      if(!hasExistingMarkers&&poiKeys.some(k=>mapFilters[k])){
        setTimeout(()=>applyActiveFilters(),800);
      } else if(hasExistingMarkers){
        // Just re-add existing marker layers to the map (they may have been cleared)
        poiKeys.filter(k=>mapFilters[k]).forEach(k=>{
          const grp=layerGroupsRef.current[k];
          if(grp&&mapInstanceRef.current&&!mapInstanceRef.current.hasLayer(grp)){
            mapInstanceRef.current.addLayer(grp);
          }
        });
      }
      if(valid.length>=2){
        // Draw route using already-geocoded stop coordinates.
        // valid = array of [lat,lon] — already correct for Leaflet.
        // Attempt OSRM road-following route; fall back to straight-line instantly.
        if(routeLayerRef.current) map.removeLayer(routeLayerRef.current);
        const routeColor=routeProfile==="driving-hgv"?"#f59e0b":T.accent;
        // Draw immediate straight-line so user sees something right away
        // First remove any existing line from a previous render
        if(routeLayerRef.current){try{map.removeLayer(routeLayerRef.current);}catch{} routeLayerRef.current=null;}
        routeLayerRef.current=L.polyline(valid,{color:routeColor,weight:3,opacity:.7,dashArray:"8,5"}).addTo(map);
        // Then try OSRM in the background for a road-following upgrade
        (async()=>{
          try{
            const pts=valid.map(c=>[c[1],c[0]]); // [lon,lat] for OSRM
            const roadCoords=await roadRoute(pts);
            if(roadCoords&&roadCoords.length>1){
              // OSRM returns GeoJSON [lon,lat] — swap to Leaflet [lat,lon]
              const latlngs=roadCoords.map(c=>[c[1],c[0]]);
              // Sanity check: first coord should be near first valid stop
              const firstStop=valid[0];
              const firstRoute=latlngs[0];
              const latDiff=Math.abs(firstStop[0]-firstRoute[0]);
              const lonDiff=Math.abs(firstStop[1]-firstRoute[1]);
              if(latDiff<5&&lonDiff<5){
                // Only draw if this is still the current render (not superseded by a newer one)
                if(renderGenRef.current!==myGen){
                  return;
                }
                if(routeLayerRef.current) map.removeLayer(routeLayerRef.current);
                routeLayerRef.current=L.polyline(latlngs,{color:routeColor,weight:4,opacity:.9}).addTo(map);
                // Save route geometry for AI context
                _currentRouteCoords=roadCoords; // [lon,lat] format
                _currentRouteStops=allMapStops.filter(s=>s.name).map(s=>s.name);
              } else {
                console.warn("OSRM coords sanity check failed — keeping straight-line. LatDiff:",latDiff,"LonDiff:",lonDiff);
              }
            }
          }catch(err){
            console.warn("Road route upgrade failed:",err.message);
            // Straight-line is already showing — nothing to do
          }
          // Midpoint suggestions for long legs
          const suggestions=[];
          for(let j=1;j<allMapStops.length;j++){
            if(coords[j-1]&&coords[j]&&parseFloat(allMapStops[j].distFromPrev)>350){
              suggestions.push({from:allMapStops[j-1].name,to:allMapStops[j].name,midLat:(coords[j-1][0]+coords[j][0])/2,midLon:(coords[j-1][1]+coords[j][1])/2,miles:parseFloat(allMapStops[j].distFromPrev)||0,idx:j});
            }
          }
          if(suggestions.length>0){
            Promise.all(suggestions.map(sg=>
              fetch(`https://nominatim.openstreetmap.org/reverse?lat=${sg.midLat}&lon=${sg.midLon}&format=json`,{headers:{"Accept-Language":"en"}})
                .then(r=>r.json()).then(d=>({...sg,city:d.address?.city||d.address?.town||d.address?.village||d.address?.county||"Midpoint",state:d.address?.state_code||""}))
                .catch(()=>({...sg,city:"Midpoint",state:""}))
            )).then(r=>setMidpointSuggestions(r));
          }
        })();
      }
    });
    return()=>{
      if(mapDrawAbortRef.current) mapDrawAbortRef.current.abort();
    };
    },800); // end debounce
    return()=>{
      if(stopsDrawTimerRef.current) clearTimeout(stopsDrawTimerRef.current);
      if(mapDrawAbortRef.current) mapDrawAbortRef.current.abort();
    };
  },[mapReady,JSON.stringify(stops.map((s,i)=>i+":"+s.id+":"+s.name+":"+s.state+":"+(s.active?1:0))),routeProfile,mapRefreshKey]);

  const toggleLayer=async(key,filtersOverride,forceOn)=>{
    const newVal=forceOn!==undefined?forceOn:!layers[key];
    setLayers(prev=>({...prev,[key]:newVal}));
    const L=window.L,map=mapInstanceRef.current,group=layerGroupsRef.current[key];
    if(!L||!map||!group) return;
    if(!newVal){map.removeLayer(group);return;}
    map.addLayer(group);
    // If group already has markers, just show them — no need to re-fetch
    if(group.getLayers&&group.getLayers().length>0&&!forceOn) return;
    group.clearLayers(); // redraw fresh only when forceOn (explicit Apply) or empty
    // ── Side Trips layer ──
    if(key==="sidetrips"){
      let hasSideTrips=false;
      // Debug: log what we have
      const allST=stops.flatMap(s=>(s.sideTrips||[]).map(st=>({stopName:s.name,stName:st.name,hasCoords:!!(st.routeCoords&&st.routeCoords.length),coordLen:st.routeCoords?.length||0})));
      stops.forEach(stop=>{
        if(!stop.sideTrips||!stop.sideTrips.length) return;
        stop.sideTrips.forEach(st=>{
          if(!st.routeCoords||!st.routeCoords.length){
            console.warn("[SideTrips] No routeCoords for",st.name,"on stop",stop.name);
            return;
          }
          hasSideTrips=true;
          const latlngs=st.routeCoords.map(c=>[c[1],c[0]]);
          // Pick vehicle emoji
          const vEmoji={"Motorcycle":"🏍","Car / SUV":"🚗","Bicycle":"🚲","🥾 Hike / Walk":"🥾"}[st.vehicleType]||"🏍";
          const isRoundTrip=st.roundTrip!==false;
          // Draw the route line
          L.polyline(latlngs,{color:"#f59e0b",weight:4,opacity:.9,dashArray:"10,5"})
            .bindTooltip(`${vEmoji} ${st.name||"Side Trip"} · ${st.totalMiles} mi · ${st.vehicleType}`,{direction:"top",sticky:true})
            .bindPopup(`<div style="font-family:sans-serif;min-width:200px;padding:8px">
              <div style="font-size:15px;font-weight:700;margin-bottom:4px">${vEmoji} ${st.name||"Side Trip"}</div>
              <div style="color:#666;font-size:12px;margin-bottom:8px">${st.vehicleType} · ${isRoundTrip?"Round Trip":"One Way"}</div>
              <div style="font-size:12px;margin-bottom:3px">📍 Base: <strong>${stop.name}</strong></div>
              <div style="font-size:12px;margin-bottom:3px">📏 ${st.totalMiles} mi${isRoundTrip?" round trip":""}</div>
              <div style="font-size:12px;margin-bottom:6px">⛽ Est. fuel: <strong>$${Math.round(st.fuelCost)}</strong>${st.repeatEnabled&&(st.repeatDays||1)>1?` × ${st.repeatDays} days = $${Math.round(st.fuelCost*(st.repeatDays||1))} total`:""}</div>
              <div style="font-size:11px;color:#999">${st.mode==="addtotrip"?"✓ Added to trip totals":"Standalone plan"}</div>
            </div>`,{maxWidth:240})
            .addTo(group);
          // Helper: emoji divIcon
          const emojiIcon=(emoji,size)=>L.divIcon({
            html:`<div style="font-size:${size}px;line-height:1;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.5))">${emoji}</div>`,
            className:"",iconSize:[size,size],iconAnchor:[size/2,size/2]
          });
          // Start marker — vehicle emoji at departure point
          if(latlngs.length>0){
            L.marker(latlngs[0],{icon:emojiIcon(vEmoji,28)})
              .bindTooltip(`${vEmoji} Start: ${stop.name}`,{direction:"top"})
              .addTo(group);
          }
          // Waypoint markers — numbered flags along the route at each waypoint
          const wps=(st.waypoints||[]).filter(w=>w.name&&w.name.trim());
          wps.forEach((wp,wi)=>{
            // Find the coord closest to the middle of this leg
            const wpFraction=(wi+1)/(wps.length+1);
            const wpIdx=Math.round(wpFraction*(latlngs.length-1));
            const wpLatLng=latlngs[Math.min(wpIdx,latlngs.length-1)];
            if(wpLatLng){
              L.marker(wpLatLng,{icon:emojiIcon("📍",24)})
                .bindTooltip(`📍 ${wp.name}${wp.state?", "+wp.state:""}`,{direction:"top"})
                .addTo(group);
            }
          });
          // End marker — destination flag (only if not round trip, or show at furthest point)
          if(latlngs.length>1){
            const midIdx=Math.round((latlngs.length-1)/2);
            const endLatLng=isRoundTrip?latlngs[midIdx]:latlngs[latlngs.length-1];
            L.marker(endLatLng,{icon:emojiIcon("🏁",28)})
              .bindTooltip(isRoundTrip?`🏁 Destination: ${wps[0]?.name||"Waypoint"}${wps[0]?.state?", "+wps[0].state:""}`:`🏁 End: ${wps[wps.length-1]?.name||"Destination"}`,{direction:"top"})
              .addTo(group);
          }
        });
      });
      if(!hasSideTrips) alert("No side trip routes calculated yet. Add a side trip to a stop, enter waypoints, and click 🗺 Calculate Route first.");
      return;
    }
    // Always refresh on explicit toggle
    group.clearLayers();
    let b,bbox;
    try{b=map.getBounds();bbox=b.getSouth().toFixed(4)+","+b.getWest().toFixed(4)+","+b.getNorth().toFixed(4)+","+b.getEast().toFixed(4);}catch(e){console.warn("[Filter] Map not ready");setCalcingMiles(false);return;}

    // ── Weather layer: show forecast badge above each named stop ──
    if(key==="weather"){
      const WX={0:"☀️",1:"🌤",2:"⛅",3:"☁️",45:"🌫",48:"🌫",51:"🌦",53:"🌦",55:"🌧",
        61:"🌧",63:"🌧",65:"🌧",71:"🌨",73:"🌨",75:"❄️",77:"🌨",80:"🌦",81:"🌧",82:"⛈",
        85:"🌨",86:"❄️",95:"⛈",96:"⛈",99:"⛈"};
      const WX_DESC={0:"Clear",1:"Mostly Clear",2:"Partly Cloudy",3:"Overcast",45:"Foggy",48:"Icy Fog",
        51:"Lt Drizzle",53:"Drizzle",55:"Hvy Drizzle",61:"Lt Rain",63:"Rain",65:"Hvy Rain",
        71:"Lt Snow",73:"Snow",75:"Hvy Snow",77:"Snow Grains",80:"Lt Showers",81:"Showers",82:"Hvy Showers",
        85:"Snow Showers",86:"Hvy Snow",95:"Thunderstorm",96:"Hail Storm",99:"Hvy Hail"};
      const tempCol=(hi)=>hi>=95?"#ef4444":hi>=85?"#f97316":hi>=70?"#e8a30a":hi>=55?"#27ae60":hi>=40?"#38bdf8":"#818cf8";
      if(namedStops.length===0){alert("Add named stops to see weather forecasts on the map.");return;}
      // Sequential to avoid 429 rate limit
      const weatherSleep=(ms)=>new Promise(r=>setTimeout(r,ms));
      (async()=>{for(const s of namedStops){
        try{
          let lat,lon;
          // Use stored coordinates first (fuel stops, AI-applied stops)
          if(s.lat&&s.lon&&parseFloat(s.lat)!==0&&parseFloat(s.lon)!==0){
            lat=parseFloat(s.lat);lon=parseFloat(s.lon);
          } else {
            const geoQW=s.address?(s.address+(s.state?", "+s.state:"")+", USA"):(s.name+(s.state?", "+s.state:"")+", USA");
            const geo=await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(geoQW)}&format=json&limit=1&countrycodes=us`,{headers:{"Accept-Language":"en"}}).then(r=>r.json());
            if(!geo?.length) continue;
            lat=parseFloat(geo[0].lat);lon=parseFloat(geo[0].lon);
          }
          const wx=await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&daily=weathercode,temperature_2m_max,temperature_2m_min,precipitation_probability_max,windspeed_10m_max&temperature_unit=fahrenheit&windspeed_unit=mph&timezone=auto&forecast_days=14`).then(r=>r.json());
          if(!wx?.daily) return;
          // Find day closest to arrival date, else use today
          let dayIdx=0;
          if(s.arriveDate){
            const arrive=new Date(s.arriveDate+"T00:00:00");
            let closest=Infinity;
            wx.daily.time.forEach((t,i)=>{const diff=Math.abs(new Date(t+"T00:00:00")-arrive);if(diff<closest){closest=diff;dayIdx=i;}});
          }
          const code=parseInt(wx.daily.weathercode[dayIdx])||0;
          const emoji=WX[code]||"🌡";
          const hi=Math.round(parseFloat(wx.daily.temperature_2m_max[dayIdx]));
          const lo=Math.round(parseFloat(wx.daily.temperature_2m_min[dayIdx]));
          const rain=Math.round(parseFloat(wx.daily.precipitation_probability_max[dayIdx])||0);
          const wind=Math.round(parseFloat(wx.daily.windspeed_10m_max[dayIdx])||0);
          const tc=tempCol(hi);
          // Build 5-day mini forecast for popup
          const miniRows=[0,1,2,3,4].map(offset=>{
            const i=Math.min(dayIdx+offset,wx.daily.time.length-1);
            const c=parseInt(wx.daily.weathercode[i])||0;
            const d=new Date(wx.daily.time[i]+"T00:00:00");
            const dow=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][d.getDay()];
            const h=Math.round(parseFloat(wx.daily.temperature_2m_max[i]));
            const l=Math.round(parseFloat(wx.daily.temperature_2m_min[i]));
            const r=Math.round(parseFloat(wx.daily.precipitation_probability_max[i])||0);
            const w=Math.round(parseFloat(wx.daily.windspeed_10m_max[i])||0);
            return`<tr style="border-bottom:1px solid #f0f0f0${offset===0?" background:#fffbea":""}"><td style="padding:5px 8px;font-weight:${offset===0?700:400};font-size:11px">${dow} ${wx.daily.time[i].slice(5)}</td><td style="padding:5px 8px;font-size:16px;text-align:center">${WX[c]||"🌡"}</td><td style="padding:5px 8px;font-size:11px;color:#999">${WX_DESC[c]||""}</td><td style="padding:5px 8px;font-size:11px;font-weight:700;color:${tempCol(h)};text-align:right">${h}°</td><td style="padding:5px 8px;font-size:11px;color:#999;text-align:right">${l}°</td><td style="padding:5px 8px;font-size:11px;color:${r>50?"#e74c3c":r>20?"#e8a30a":"#27ae60"};text-align:right">💧${r}%</td><td style="padding:5px 8px;font-size:11px;color:#999;text-align:right">💨${w}</td></tr>`;
          }).join("");
          const wxIcon=L.divIcon({
            html:`<div style="background:${tc};color:#fff;border-radius:10px;padding:4px 8px;border:2px solid #fff;box-shadow:0 2px 8px #0008;font-family:sans-serif;font-size:12px;font-weight:700;white-space:nowrap;display:flex;align-items:center;gap:4px;cursor:pointer"><span style="font-size:16px">${emoji}</span>${hi}°${rain>50?'<span style="font-size:10px"> 💧</span>':''}${wind>25?'<span style="font-size:10px"> 💨</span>':''}</div>`,
            className:"",iconAnchor:[-6,42]
          });
          const arrLabel=s.arriveDate?`Around your arrival (${s.arriveDate})`:"Today's forecast";
          L.marker([lat,lon],{icon:wxIcon,zIndexOffset:500}).addTo(group)
            .bindTooltip(`<strong>${s.name}</strong> - ${emoji} ${hi}°/${lo}°F · 💧${rain}% · 💨${wind}mph`,{direction:"top",offset:[20,-18]})
            .bindPopup(`<div style="font-family:sans-serif;min-width:300px;padding:4px">
              <div style="font-weight:700;font-size:14px;margin-bottom:4px">🌤 ${s.name}</div>
              <div style="font-size:11px;color:#888;margin-bottom:10px">${arrLabel}</div>
              <table style="width:100%;border-collapse:collapse">
                <thead><tr style="border-bottom:2px solid #f5c518"><th style="padding:4px 8px;text-align:left;font-size:10px;color:#999">Day</th><th></th><th style="font-size:10px;color:#999">Cond</th><th style="font-size:10px;color:#999;text-align:right">Hi</th><th style="font-size:10px;color:#999;text-align:right">Lo</th><th style="font-size:10px;color:#999;text-align:right">Rain</th><th style="font-size:10px;color:#999;text-align:right">Wind</th></tr></thead>
                <tbody>${miniRows}</tbody>
              </table>
              <div style="font-size:10px;color:#bbb;margin-top:8px;border-top:1px solid #eee;padding-top:6px">Open-Meteo · Temp °F · Wind mph · ${s.arriveDate?"Highlighted row = arrival day":"Showing next 5 days"}</div>
            </div>`,{maxWidth:340});
        }catch(e){}
        await weatherSleep(300);
      }})(); // end sequential weather loop
      return;
    }

    // Query around each named stop (30 mile radius) instead of map viewport
    // Viewport bbox fails when route spans multiple states - Overpass times out
    const RADIUS_DEG=0.45; // ~30 miles
    const cfgMap={
      campgrounds:{q:(lat,lon)=>{
        const activeF=Object.keys(AMENITY_TAGS).filter(k=>(filtersOverride||mapFilters)[k]);
        const amenityFilter=activeF.map(k=>`[${AMENITY_TAGS[k]}]`).join("");
        return`[out:json][timeout:25];(node["tourism"~"camp_site|caravan_site"]${amenityFilter}(around:100000,${lat},${lon});way["tourism"~"camp_site|caravan_site"]${amenityFilter}(around:100000,${lat},${lon}););out center 60;`;
      },emoji:"🏕",color:"#27ae60"},
      fuel:{q:(lat,lon)=>`[out:json][timeout:25];(node["amenity"="fuel"](around:100000,${lat},${lon});way["amenity"="fuel"](around:100000,${lat},${lon}););out center 60;`,emoji:"GAS",color:"#e8a30a",label:"Fuel"},
      golf:{q:(lat,lon)=>`[out:json][timeout:25];(way["leisure"="golf_course"](around:100000,${lat},${lon});node["leisure"="golf_course"](around:100000,${lat},${lon}););out center 50;`,emoji:"⛳",color:"#2a8a54"},
      trails:{q:(lat,lon)=>`[out:json][timeout:25];(node["tourism"="trailhead"](around:100000,${lat},${lon});way["route"="hiking"](around:100000,${lat},${lon}););out center 60;`,emoji:"🥾",color:"#9b59b6"},
      rvparks:{q:(lat,lon)=>`[out:json][timeout:25];(node["tourism"="caravan_site"](around:100000,${lat},${lon});node["amenity"="rv_park"](around:100000,${lat},${lon});node["tourism"="camp_site"]["tents"="no"](around:100000,${lat},${lon}););out center 60;`,emoji:"🚐",color:"#f5c518"},
    };
    const cfg=cfgMap[key];
    if(!cfg){return;}
    // Geocode each named stop and query around it
    // Only query around next upcoming stop - not home, not past stops, not all stops
    // In planning mode: query around all stops (up to 5) or map center
    const today=new Date().toISOString().slice(0,10);
    const ICONS={fuel:"F",campgrounds:"C",rvparks:"R",trails:"T",golf:"G"};
    const layerIcon=ICONS[key]||cfg.emoji||"?";
    // Get map center for the query
    // Build query points from all stops - geocode if no stored coords
    const seenGrid=new Set();
    const addQueryPoint=(lat,lon)=>{
      if(!lat||!lon||isNaN(lat)||isNaN(lon)) return;
      const cell=Math.round(lat)+","+Math.round(lon);
      if(!seenGrid.has(cell)){seenGrid.add(cell);}
    };
    // Use shared geocodeStop for CORS-safe geocoding (ORS→Nominatim→fallback)
    const queryPoints=[];
    const allStopsForQuery=[...namedStops];
    if(homeStop) allStopsForQuery.unshift(homeStop);
    for(const s of allStopsForQuery){
      let lat=s.lat?parseFloat(s.lat):null;
      let lon=s.lon?parseFloat(s.lon):null;
      if(!lat||!lon||isNaN(lat)||lat===0){
        const r=await geocodeStop(s);
        if(r){lat=r[0];lon=r[1];}
      }
      if(lat&&lon&&!isNaN(lat)&&!isNaN(lon)){
        const cell=Math.round(lat)+","+Math.round(lon);
        if(!seenGrid.has(cell)){seenGrid.add(cell);queryPoints.push([lat,lon]);}
      }
    }
    if(queryPoints.length===0){
      try{const mc=mapInstanceRef.current.getCenter();queryPoints.push([mc.lat,mc.lng]);}
      catch(e){setCalcingMiles(false);return;}
    }
    setCalcingMiles(true);
    const OVERPASS_ENDPOINTS=[
      "https://overpass.openstreetmap.ru/api/interpreter",   // Russian mirror - good CORS
      "https://maps.mail.ru/osm/tools/overpass/api/interpreter", // mail.ru mirror
      "https://overpass.kumi.systems/api/interpreter",
      "https://overpass-api.de/api/interpreter",
      "https://lz4.overpass-api.de/api/interpreter",
    ];
    // Track which endpoint works to avoid retrying failed ones
    let goodEndpoint=null;
    const abortCtrl=new AbortController();
    setTimeout(()=>abortCtrl.abort(),60000);
    try{
      const placedCoords=new Set(); // deduplicate markers across point queries
      for(const [clat,clon] of queryPoints){
        if(abortCtrl.signal.aborted) break;
        const query=cfg.q(clat,clon);
        const tryOrder=goodEndpoint
          ?[goodEndpoint,...OVERPASS_ENDPOINTS.filter(e=>e!==goodEndpoint)]
          :OVERPASS_ENDPOINTS;
        // Check filter cache first
        const cacheKey=key+":"+clat.toFixed(2)+":"+clon.toFixed(2);
        const cached=_filterCache.get(cacheKey);
        const cachedTime=_filterCacheTime.get(cacheKey)||0;
        let data=null;
        if(cached&&(Date.now()-cachedTime)<FILTER_CACHE_MS){
          data={elements:cached};
        } else {
          for(const ep of tryOrder){
            if(abortCtrl.signal.aborted) break;
            try{
              const epCtrl=new AbortController();
              const epTimer=setTimeout(()=>epCtrl.abort(),12000);
              const res=await fetch(ep,{
                method:"POST",
                headers:{"Content-Type":"application/x-www-form-urlencoded"},
                body:"data="+encodeURIComponent(query),
                signal:epCtrl.signal
              });
              clearTimeout(epTimer);
              if(!res.ok) continue;
              data=await res.json();
              goodEndpoint=ep;
              // Cache the results
              if(data?.elements){
                _filterCache.set(cacheKey,data.elements);
                _filterCacheTime.set(cacheKey,Date.now());
              }
              break;
            }catch(e){
              if(!abortCtrl.signal.aborted) console.warn("[Filter] Failed:",ep,e.message);
            }
          }
        }
        if(!data||abortCtrl.signal.aborted) continue;
        const elements=data.elements||[];
        let pointAdded=0;
        elements.forEach(el=>{
          if(pointAdded>=40) return;
          const elat=el.lat||(el.center?.lat);
          const elon=el.lon||(el.center?.lon);
          if(!elat||!elon) return;
          // Deduplicate markers
          const coordKey=elat.toFixed(4)+","+elon.toFixed(4);
          if(placedCoords.has(coordKey)) return;
          placedCoords.add(coordKey);
          pointAdded++;
          const name=el.tags?.name||(layerIcon+" Stop");
          const website=el.tags?.website||el.tags?.["contact:website"]||"";
          const phone=el.tags?.phone||"";
          const addr=[el.tags?.["addr:housenumber"],el.tags?.["addr:street"],el.tags?.["addr:city"]].filter(Boolean).join(" ");
          const icon=L.divIcon({
            html:"<div style='background:"+cfg.color+";color:#fff;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;border:1.5px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,0.35);opacity:0.9'>"+layerIcon+"</div>",
            className:"",iconSize:[20,20],iconAnchor:[10,10]
          });
          const mk=L.marker([elat,elon],{icon,pane:"filterPane"});
          const popHtml="<div style='font-family:sans-serif;min-width:160px;padding:4px'>"
            +"<div style='font-size:13px;font-weight:700;margin-bottom:3px'>"+name+"</div>"
            +(addr?"<div style='font-size:11px;color:#666;margin-bottom:2px'>"+addr+"</div>":"")
            +(phone?"<div style='margin-top:4px'><a href='tel:"+phone+"' style='font-size:11px;color:#2255a4;text-decoration:none'>Call "+phone+"</a></div>":"")
            +(website?"<div style='margin-top:3px'><a href='"+(website.startsWith("http")?website:"https://"+website)+"' target='_blank' style='font-size:11px;color:#2255a4;text-decoration:none'>Website</a></div>":"")
            +"</div>";
          mk.bindPopup(popHtml,{maxWidth:220});
          mk.bindTooltip(name,{direction:"top",offset:[0,-14]});
          group.addLayer(mk);
        });
      }
    }catch(e){
      console.warn("[Filter] Error:",e.message);
    }finally{
      setCalcingMiles(false);
    }
  };


  const calcMiles=async()=>{
    setCalcingMiles(true);
    // Use shared geocodeStop for all stops - handles ORS→Nominatim→campground fallbacks
    const calcStops=stops.filter(s=>{
      if(!s.active) return false;
      // Include if it has any geocodable info
      return !!(s.state||s.name||s.address||s.homeCity);
    });
    if(calcStops.length<2){setCalcingMiles(false);alert("Add at least 2 stops with names or addresses to calculate miles.");return;}
    // Use stored lat/lon first — only geocode stops without coords
    const coords=[];
    for(const s of calcStops){
      // Use stored coords if available (set by map render)
      const storedLat=parseFloat(s.lat);
      const storedLon=parseFloat(s.lon);
      if(s.lat&&s.lon&&!isNaN(storedLat)&&storedLat!==0&&storedLon!==0){
        coords.push([storedLat,storedLon]);
        continue;
      }
      // Only geocode stops without stored coords
      const c=await geocodeStop(s);
      coords.push(c);
      if(!c) console.warn("calcMiles: could not geocode",s.name,s.state);
    }
    const updates=[];
    const failedLegs=[];
    for(let i=1;i<calcStops.length;i++){
      if(!coords[i-1]||!coords[i]){
        failedLegs.push(calcStops[i].name||"(unnamed)");
        continue;
      }
      const miles=await roadMiles(coords[i-1][0],coords[i-1][1],coords[i][0],coords[i][1]);
      updates.push({id:calcStops[i].id,miles:miles||0});
    }
    if(updates.length>0&&onAddStop){
      onAddStop(updates);
      if(failedLegs.length>0){
        alert("Calculated "+updates.length+" legs. Could not locate these stops: "+failedLegs.join(", ")+". Make sure each stop has a State selected.");
      }
    } else {
      const nullStops=calcStops.filter((_,i)=>!coords[i]).map(s=>s.name||s.homeCity||s.address||"(unnamed)");
      alert(nullStops.length>0
        ?"Could not locate these stops: "+nullStops.join(", ")+". Make sure each stop has a State selected."
        :"Could not calculate miles. Check your internet connection and try again.");
    }
    setCalcingMiles(false);
  };

  const layerConfig=[{key:"campgrounds",label:"🏕 Campgrounds",color:T.free},{key:"fuel",label:"⛽ Fuel",color:T.accentAlt},{key:"golf",label:"⛳ Golf",color:T.green},{key:"trails",label:"🥾 Trails",color:"#9b59b6"},{key:"weather",label:"🌤 Weather",color:"#38bdf8"},{key:"rvparks",label:"🚐 RV Parks",color:"#f5c518"},{key:"sidetrips",label:"🏍 Side Trips",color:"#f59e0b"}];

  const poiKeys=["campgrounds","fuel","golf","trails","rvparks","weather"];
  const amenityKeys=["fullHookups","electric","water","amp50","dumpStation","propane","showers","laundry","pool","petFriendly","wifi","cableTV","firewood","rvStorage"];
  const activePOI=poiKeys.filter(k=>mapFilters[k]);
  const activeAmenities=amenityKeys.filter(k=>mapFilters[k]);
  const totalActive=activePOI.length+activeAmenities.length;

  const applyFilters=()=>{
    // Sync mapFilters POI keys → layers state, then fetch
    const newLayers={campgrounds:mapFilters.campgrounds,fuel:mapFilters.fuel,golf:mapFilters.golf,trails:mapFilters.trails,weather:mapFilters.weather,rvparks:mapFilters.rvparks};
    setLayers(newLayers);
    setShowFilterModal(false);
    // Trigger fetch for each active POI layer
    poiKeys.filter(k=>mapFilters[k]).forEach(k=>toggleLayer(k,mapFilters,true));
  };

  // Auto-apply saved filters when map becomes ready (e.g. after tab switch or page load)
    // ── Persistent filter application ──
  // Filters are applied via applyActiveFilters() called from the filter modal
  // and when the map tab becomes active. No useEffect race conditions.
  const applyActiveFilters=()=>{
    const activePOI=poiKeys.filter(k=>mapFilters[k]);
    // Defer DOM-heavy Leaflet work to avoid blocking UI thread (INP)
    setTimeout(()=>{
      // Clear all layers
      poiKeys.forEach(k=>{
        const grp=layerGroupsRef.current[k];
        if(grp&&mapInstanceRef.current) try{mapInstanceRef.current.removeLayer(grp);grp.clearLayers();}catch{}
      });
      if(activePOI.length===0) return;
      const newLayers={};
      poiKeys.forEach(k=>{newLayers[k]=mapFilters[k];});
      setLayers(newLayers);
      // Stagger each filter slightly so browser can breathe between them
      activePOI.forEach((k,i)=>setTimeout(()=>toggleLayer(k,mapFilters,true),i*50));
    },0);
  };

  // Auto-apply filters when they change (but not on first mount)
  const filtersAppliedRef=useRef(false);
  // Re-apply filters when filter selection changes
  const prevFiltersRef=useRef("");
  const filtersDrawnRef=useRef(false); // tracks if filters have been drawn this session
  useEffect(()=>{
    if(!mapReady||!mapInstanceRef.current) return;
    const filterStr=JSON.stringify(mapFilters);
    const filtersChanged=filterStr!==prevFiltersRef.current;
    prevFiltersRef.current=filterStr;
    // Only re-apply if: (1) filters actually changed, or (2) never drawn yet this mount
    if(!filtersChanged&&filtersDrawnRef.current) return;
    // Check if any active filter layer already has markers (tab return case)
    const activeKeys=poiKeys.filter(k=>mapFilters[k]);
    if(!filtersChanged&&activeKeys.some(k=>{
      const grp=layerGroupsRef.current[k];
      return grp&&grp.getLayers&&grp.getLayers().length>0;
    })){
      // Layers have markers — just re-add them to the map (they were cleared on nav away)
      activeKeys.forEach(k=>{
        const grp=layerGroupsRef.current[k];
        if(grp&&mapInstanceRef.current&&!mapInstanceRef.current.hasLayer(grp)){
          mapInstanceRef.current.addLayer(grp);
        }
      });
      filtersDrawnRef.current=true;
      return;
    }
    filtersDrawnRef.current=false;
    const t=setTimeout(()=>{
      try{
        mapInstanceRef.current.getCenter();
        applyActiveFilters();
        filtersDrawnRef.current=true;
      }catch{}
    },300);
    return()=>clearTimeout(t);
  },[JSON.stringify(mapFilters),mapReady]);

  const filterGroups=[
    {id:"poi",title:"📍 Map Layers",sub:"What to show on the map",filters:[
      {key:"campgrounds",label:"🏕 Campgrounds",desc:"RV-friendly campsites"},
      {key:"rvparks",label:"🚐 RV Parks",desc:"Dedicated RV parks & resorts"},
      {key:"fuel",label:"⛽ Fuel Stops",desc:"Gas stations along route"},
      {key:"trails",label:"🥾 Hiking Trails",desc:"Trailheads & paths"},
      {key:"golf",label:"⛳ Golf Courses",desc:"Golf courses nearby"},
      {key:"weather",label:"🌤 Weather",desc:"Forecast at each stop"},
    ]},
    {id:"hookups",title:"🔌 Hookups & Power",sub:"Filter campgrounds by utility",filters:[
      {key:"fullHookups",label:"Full Hookups (E-W-S)",desc:"Electric, water & sewer"},
      {key:"electric",label:"Electric",desc:"Any electric hookup"},
      {key:"amp50",label:"50 Amp",desc:"50 amp service"},
      {key:"water",label:"Water",desc:"Water hookup"},
      {key:"dumpStation",label:"Dump Station",desc:"Sanitary dump on-site"},
      {key:"propane",label:"Propane",desc:"Propane fill available"},
    ]},
    {id:"amenities",title:"🏊 Amenities & Facilities",sub:"Filter by campground features",filters:[
      {key:"showers",label:"Showers",desc:"Shower facilities"},
      {key:"laundry",label:"Laundry",desc:"On-site laundry"},
      {key:"pool",label:"Pool",desc:"Swimming pool"},
      {key:"wifi",label:"WiFi / Internet",desc:"Internet access"},
      {key:"cableTV",label:"Cable TV",desc:"Cable TV hookup"},
      {key:"petFriendly",label:"Pet Friendly",desc:"Dogs allowed"},
      {key:"firewood",label:"Firewood",desc:"Firewood for sale"},
      {key:"rvStorage",label:"RV Storage",desc:"On-site storage"},
    ]},
  ];

  return<div className="anim">
    <SecHead icon="🗺" title="Trip Map" sub="Live interactive map. Hover markers for info · Click for details & links · Your memberships show on stop pins."/>
    {/* Low-bridge warning banner */}
    {((parseInt(vehicle?.rvHeightFt)||13)*12+(parseInt(vehicle?.rvHeightIn)||0))>150&&<Card accent="#f59e0b" style={{marginBottom:12,padding:"10px 14px",background:"#f59e0b12"}}>
      <div style={{display:"flex",alignItems:"flex-start",gap:8,flexWrap:"wrap"}}>
        <span style={{fontSize:18,flexShrink:0}}>⚠</span>
        <div style={{flex:1,minWidth:0,fontSize:12,lineHeight:1.5,color:T.text,wordBreak:"break-word"}}>
          <strong style={{color:"#f59e0b"}}>Low-bridge warning - your RV is {vehicle.rvHeightFt}ft {vehicle.rvHeightIn}in tall.</strong>
          <br/>Default driving directions may route under bridges too low for your RV. Use <strong>RV Life</strong>, <strong>CoPilot RV</strong>, or Google Maps with <strong>avoid highways</strong> near known problem areas (NE US especially: NY parkways, MA, NJ). Always verify clearance on rural roads.
        </div>
      </div>
    </Card>}
    <QuickTipBar tabId="map" onOpenHowTo={onOpenHowTo}/>
    <Card style={{marginBottom:12,padding:"14px 18px"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:6}}>Active Layers</div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
            {activePOI.length===0&&activeAmenities.length===0&&<span style={{fontSize:12,color:T.muted,fontStyle:"italic"}}>No layers selected - open filters to get started</span>}
            {activePOI.map(k=>{const lc=layerConfig.find(l=>l.key===k);return lc?<span key={k} style={{display:"inline-flex",alignItems:"center",gap:4,padding:"4px 10px",borderRadius:20,background:lc.color+"22",border:`1px solid ${lc.color}55`,color:lc.color,fontSize:12,fontWeight:600}}>{lc.label}<button onClick={()=>{setMapFilters(p=>({...p,[k]:false}));toggleLayer(k,mapFilters,false);}} style={{background:"none",border:"none",cursor:"pointer",color:lc.color,fontSize:14,lineHeight:1,padding:"0 0 0 2px",fontWeight:900}}>×</button></span>:null;})}
            {activeAmenities.map(k=><span key={k} style={{display:"inline-flex",alignItems:"center",gap:4,padding:"4px 10px",borderRadius:20,background:T.accent+"18",border:`1px solid ${T.accent}44`,color:T.accent,fontSize:11,fontWeight:600}}>{k}<button onClick={()=>setMapFilters(p=>({...p,[k]:false}))} style={{background:"none",border:"none",cursor:"pointer",color:T.accent,fontSize:14,lineHeight:1,padding:"0 0 0 2px",fontWeight:900}}>×</button></span>)}
          </div>
        </div>
        <div style={{display:"flex",gap:8,flexShrink:0}}>
          {totalActive>0&&<button onClick={()=>{const reset={};[...poiKeys,...amenityKeys].forEach(k=>reset[k]=false);setMapFilters(prev=>({...prev,...reset}));setLayers({campgrounds:false,fuel:false,golf:false,trails:false,weather:false,rvparks:false});Object.values(layerGroupsRef.current).forEach(g=>{try{mapInstanceRef.current?.removeLayer(g);}catch{}});}} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 14px",color:T.muted,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:T.F.cond}}>✕ Clear All</button>}
          <button onClick={()=>setShowFilterModal(true)} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"9px 18px",fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:.5,textTransform:"uppercase",cursor:"pointer",display:"flex",alignItems:"center",gap:8,boxShadow:`0 2px 8px ${T.accent}44`}}>
            🗂 Map Filters{totalActive>0&&<span style={{background:"#fff",color:T.accent,borderRadius:10,padding:"1px 7px",fontSize:11,fontWeight:900,minWidth:20,textAlign:"center"}}>{totalActive}</span>}
          </button>
        </div>
      </div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,marginTop:10,flexWrap:"wrap"}}>
        <div style={{fontSize:11,color:T.muted}}>Hover any marker for quick info · Click for full details · Amenity filters apply to campground results</div>
        <button onClick={showFullRoute} style={{padding:"5px 12px",background:"transparent",border:`1px solid ${T.border}`,borderRadius:6,color:T.muted,fontSize:11,fontWeight:600,cursor:"pointer",flexShrink:0}}>🔄 Refresh Map</button>
        <button onClick={()=>{
          const map=mapInstanceRef.current;
          const lg=layerGroupsRef.current;
          if(!map||!window.html2canvas){alert("Map not ready or html2canvas not loaded yet. Try again in a moment.");return;}
          // Hide layer groups and travel layer temporarily
          const hidden=[];
          Object.values(lg||{}).forEach(g=>{if(map.hasLayer(g)){map.removeLayer(g);hidden.push(g);}});
          // Also hide travel mode layer
          if(travelLayerGroupRef.current&&map.hasLayer(travelLayerGroupRef.current)){
            map.removeLayer(travelLayerGroupRef.current);hidden.push(travelLayerGroupRef.current);
          }
          // Hide user location marker
          if(userMarkerRef.current&&map.hasLayer(userMarkerRef.current)){
            map.removeLayer(userMarkerRef.current);hidden.push(userMarkerRef.current);
          }
          (async()=>{
            await new Promise(r=>setTimeout(r,300));
            try{
              const canvas=await window.html2canvas(map.getContainer(),{useCORS:true,allowTaint:true,scale:1.5,logging:false});
              const img=canvas.toDataURL("image/jpeg",0.85);
              onMapSnapshot&&onMapSnapshot(img);
              alert("Map captured! Go to the Print tab to include it in your PDF.");
            }catch(e){alert("Map capture failed. Make sure the map is fully loaded.");}
            hidden.forEach(g=>g.addTo(map));
          })();
        }} style={{padding:"5px 12px",background:T.blue+"22",border:`1px solid ${T.blue}55`,borderRadius:6,color:T.blue,fontSize:11,fontWeight:600,cursor:"pointer",flexShrink:0}}>📸 Capture Map</button>
        <button onClick={()=>{toggleLayer("sidetrips").catch(()=>{});}} style={{padding:"5px 12px",background:layers.sidetrips?"#f59e0b22":"transparent",border:`1px solid ${layers.sidetrips?"#f59e0b":T.border}`,borderRadius:6,color:layers.sidetrips?"#f59e0b":T.muted,fontSize:11,fontWeight:layers.sidetrips?700:400,cursor:"pointer",flexShrink:0,transition:"all .15s"}}>🏍 Side Trips</button>
      </div>
    </Card>

    {/* ── Map Filter Modal ── */}
    {showFilterModal&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:9999,display:"flex",alignItems:"flex-end",justifyContent:"center",padding:0}} onClick={e=>{if(e.target===e.currentTarget)setShowFilterModal(false);}}>
      <div className="modal-anim" style={{background:T.bgMid,borderRadius:"20px 20px 0 0",width:"100%",maxWidth:620,maxHeight:"88vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 -8px 40px rgba(0,0,0,0.3)"}}>
        {/* Modal Header */}
        <div style={{padding:"20px 24px 16px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
          <div>
            <div style={{fontFamily:T.F.head,fontWeight:900,fontSize:22,color:T.text,letterSpacing:.5}}>Map Filters</div>
            <div style={{fontSize:12,color:T.muted,marginTop:2}}>{totalActive>0?`${totalActive} filter${totalActive!==1?"s":""} active`:"Select what to show on the map"}</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            {totalActive>0&&<button onClick={()=>{const reset={};[...poiKeys,...amenityKeys].forEach(k=>reset[k]=false);(()=>{const nf={...mapFilters,...reset};setMapFilters(nf);try{localStorage.setItem("rv-map-filters",JSON.stringify(nf));}catch{}applyActiveFilters();})();}} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 14px",color:T.muted,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:T.F.cond}}>Clear All</button>}
            <button onClick={()=>setShowFilterModal(false)} style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,width:36,height:36,fontSize:18,cursor:"pointer",color:T.muted,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
          </div>
        </div>
        {/* Modal Scroll Body */}
        <div style={{overflowY:"auto",flex:1,padding:"0 0 8px"}}>
          {filterGroups.map(group=><div key={group.id} style={{padding:"20px 24px 8px"}}>
            <div style={{fontFamily:T.F.cond,fontWeight:800,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.accent,marginBottom:2}}>{group.title}</div>
            <div style={{fontSize:12,color:T.muted,marginBottom:14}}>{group.sub}</div>
            <div style={{background:T.bg,borderRadius:12,border:`1px solid ${T.border}`,overflow:"hidden"}}>
              {group.filters.map((f,fi)=><div key={f.key} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 18px",borderBottom:fi<group.filters.length-1?`1px solid ${T.border}`:"none",transition:"background .1s"}} onMouseEnter={e=>e.currentTarget.style.background=T.bgLite} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <div style={{flex:1}}>
                  <div style={{fontSize:15,fontWeight:600,color:T.text}}>{f.label}</div>
                  <div style={{fontSize:12,color:T.muted,marginTop:1}}>{f.desc}</div>
                </div>
                <button onClick={()=>(()=>{const nf={...mapFilters,[f.key]:!mapFilters[f.key]};setMapFilters(nf);setTimeout(()=>{try{localStorage.setItem("rv-map-filters",JSON.stringify(nf));}catch{}},0);})()} style={{background:mapFilters[f.key]?T.accent:T.border,border:"none",borderRadius:14,width:52,height:28,cursor:"pointer",position:"relative",transition:"background .2s",flexShrink:0,marginLeft:16}}>
                  <div style={{position:"absolute",top:3,left:mapFilters[f.key]?26:3,width:22,height:22,borderRadius:"50%",background:"#fff",transition:"left .2s",boxShadow:"0 1px 3px rgba(0,0,0,0.25)"}}/>
                </button>
              </div>)}
            </div>
          </div>)}
          <div style={{padding:"12px 24px",background:T.bgLite,margin:"8px 24px",borderRadius:10,fontSize:12,color:T.muted,lineHeight:1.6}}>
            💡 <strong>Tip:</strong> Amenity filters (hookups, showers, etc.) refine campground search results using OpenStreetMap community data. Coverage varies - not all parks have complete amenity tags.
          </div>
        </div>
        {/* Modal Footer */}
        <div style={{padding:"16px 24px",borderTop:`1px solid ${T.border}`,background:T.bgMid,flexShrink:0,display:"flex",gap:10,flexWrap:"wrap"}}>
          <button onClick={()=>{setShowFilterModal(false);}} style={{flex:1,background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"13px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:T.muted,cursor:"pointer",minWidth:80}}>Close</button>
          <button onClick={()=>{
            _filterCache.clear();_filterCacheTime.clear();
            poiKeys.forEach(k=>{const g=layerGroupsRef.current[k];if(g)g.clearLayers();});
            filtersDrawnRef.current=false;
            applyActiveFilters();
          }} style={{flex:1,background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:10,padding:"13px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:T.text,cursor:"pointer",minWidth:80}}>🔄 Refresh</button>
          <button onClick={applyFilters} style={{flex:2,background:T.accent,border:"none",borderRadius:10,padding:"13px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:"#fff",cursor:"pointer",boxShadow:`0 3px 12px ${T.accent}55`,letterSpacing:.5,textTransform:"uppercase",minWidth:120}}>✓ Apply {totalActive>0&&`(${totalActive})`}</button>
        </div>
      </div>
    </div>}
        {stops.filter(s=>s.active&&s.name&&s.type!=="home"&&!(s.distFromPrev>0)).length>0&&
    !calcingMiles&&
    <div style={{marginBottom:12,background:T.accent+"15",border:`2px solid ${T.accent}`,borderRadius:12,padding:"14px 18px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
      <div>
        <div style={{fontFamily:T.F.cond,fontWeight:800,fontSize:15,color:T.accent,marginBottom:3}}>🚗 Step: Calculate Your Driving Miles</div>
        <div style={{fontSize:12,color:T.muted}}>Your stops need driving distances before the Summary can calculate costs and dates.</div>
      </div>
      <CoachMark coachId="map-auto-calc" message="Tap here to calculate driving miles for all your stops at once" position="top" active={stops.filter(s=>s.active&&s.name&&s.type!=="home"&&!(s.distFromPrev>0)).length>0}>
        <Btn onClick={calcMiles} data-action="calcmiles" style={{background:T.accent,color:"#fff",border:"none",flexShrink:0,fontWeight:800}}>
          {calcingMiles?"⏳ Calculating...":"🚗 Auto-Calculate Miles"}
        </Btn>
      </CoachMark>
    </div>}
{namedStops.length===0?<Card style={{padding:40,textAlign:"center",marginBottom:12}}><div style={{fontSize:48,marginBottom:12}}>🗺</div><div style={{fontFamily:T.F.head,fontSize:22,color:T.muted}}>Add named stops to see your route</div><div style={{fontSize:13,color:T.muted,marginTop:8}}>💡 Tip: Set your Home City in the first stop to include your departure on the map</div></Card>:
      <div ref={mapRef} style={{width:"100%",height:"min(540px,55vh)",borderRadius:10,overflow:"hidden",border:`1px solid ${T.border}`,marginBottom:12}}/>}
    {/* ── AI Co-Pilot Panel ── */}
    {(travelMode||tracking)&&callAI&&<div style={{marginBottom:12}}>
      <div style={{background:"linear-gradient(135deg,#1e1b4b,#312e81)",border:"1px solid #6366f144",borderRadius:12,padding:"12px 16px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:showCoPilot?10:0}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:20}}>🤖</span>
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#a5b4fc",letterSpacing:.5}}>AI CO-PILOT</div>
              <div style={{fontSize:10,color:"#6366f1"}}>Live travel assistant</div>
            </div>
          </div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <button onClick={morningBriefing} style={{background:"#6366f122",border:"1px solid #6366f144",borderRadius:7,padding:"5px 10px",color:"#a5b4fc",fontSize:11,fontWeight:600,cursor:"pointer"}}>☀️ Briefing</button>
            <button onClick={()=>askCoPilot("What fuel stops are coming up in the next 100 miles along my route? Give specific Love's, Pilot, or Flying J locations.",true)} style={{background:"#f59e0b22",border:"1px solid #f59e0b44",borderRadius:7,padding:"5px 10px",color:"#f59e0b",fontSize:11,fontWeight:600,cursor:"pointer"}}>⛽ Fuel</button>
            <button onClick={()=>askCoPilot("What overnight stops or campgrounds are near my current position? Include free options like Walmart and Cabela's.",true)} style={{background:"#27ae6022",border:"1px solid #27ae6044",borderRadius:7,padding:"5px 10px",color:"#27ae60",fontSize:11,fontWeight:600,cursor:"pointer"}}>🏕 Camps</button>
            <button onClick={()=>askCoPilot("Are there any road hazards, weather concerns, or points of interest near my current route I should know about?",true)} style={{background:"#ef444422",border:"1px solid #ef444444",borderRadius:7,padding:"5px 10px",color:"#ef4444",fontSize:11,fontWeight:600,cursor:"pointer"}}>⚠️ Alerts</button>
            <button onClick={()=>setShowCoPilot(s=>!s)} style={{background:"none",border:"1px solid #6366f144",borderRadius:7,padding:"5px 8px",color:"#6366f1",fontSize:11,cursor:"pointer"}}>{showCoPilot?"▲":"▼"}</button>
          </div>
        </div>
        {showCoPilot&&<div>
          {coPilotLoading&&<div style={{color:"#a5b4fc",fontSize:12,padding:"8px 0"}}>🤖 Co-pilot thinking...</div>}
          {coPilotMsg&&!coPilotLoading&&<div style={{background:"rgba(0,0,0,0.3)",borderRadius:8,padding:"10px 12px",fontSize:12,color:"#e0e7ff",lineHeight:1.7,whiteSpace:"pre-wrap",marginBottom:8}}>{coPilotMsg}</div>}
          <div style={{display:"flex",gap:6}}>
            <input value={coPilotInput} onChange={e=>setCoPilotInput(e.target.value)}
              onKeyDown={e=>{if(e.key==="Enter"&&coPilotInput.trim()){askCoPilot(coPilotInput,true);setCoPilotInput("");}}} 
              placeholder="Ask your co-pilot anything..."
              style={{flex:1,background:"rgba(0,0,0,0.3)",border:"1px solid #6366f144",borderRadius:7,color:"#e0e7ff",padding:"8px 10px",fontSize:12,outline:"none"}}/>
            <button onClick={()=>{if(coPilotInput.trim()){askCoPilot(coPilotInput,true);setCoPilotInput("");}}} disabled={coPilotLoading||!coPilotInput.trim()}
              style={{background:"#6366f1",border:"none",borderRadius:7,padding:"8px 12px",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>Ask</button>
          </div>
        </div>}
      </div>
    </div>}
    {/* ── Travel Mode Banner ── */}
    {offRouteAlert&&<div style={{background:"linear-gradient(135deg,#7f1d1d,#dc2626)",border:"2px solid #ef4444",borderRadius:12,padding:"12px 18px",marginBottom:12,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
      <div>
        <div style={{fontFamily:T.F.cond,fontWeight:900,fontSize:15,color:"#fff",letterSpacing:1,marginBottom:2}}>⚠️ OFF ROUTE - More than 5 miles from planned route</div>
        <div style={{fontSize:12,color:"#fca5a5"}}>Your GPS position is significantly off the planned route.</div>
      </div>
      <div style={{display:"flex",gap:8}}>
        <Btn onClick={()=>{setOffRouteAlert(false);setMapReady(false);setTimeout(()=>setMapReady(true),100);}} style={{background:"#ef4444",color:"#fff",border:"none",fontSize:12}}>🔄 Recalculate Route</Btn>
        <Btn onClick={()=>setOffRouteAlert(false)} variant="ghost" style={{fontSize:12,color:"#fff",border:"1px solid #ef444466"}}>Dismiss</Btn>
      </div>
    </div>}
    {travelMode&&<div style={{background:"linear-gradient(135deg,#0f4c1a,#1a7a2e)",border:"2px solid #27ae60",borderRadius:12,padding:"14px 18px",marginBottom:12,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
      <div>
        <div style={{fontFamily:T.F.cond,fontWeight:900,fontSize:16,color:"#fff",letterSpacing:1,marginBottom:3}}>🛣 TRAVEL MODE ACTIVE</div>
        <div style={{fontSize:12,color:"#86efac"}}>Showing {Object.keys(layers).filter(k=>layers[k]&&k!=="weather"&&k!=="sidetrips").length||3} layer{Object.keys(layers).filter(k=>layers[k]&&k!=="weather"&&k!=="sidetrips").length!==1?"s":""} within 30 miles of your position · {travelLayerResults.length} results found</div>
        {lastTravelPos&&<div style={{fontSize:11,color:"#4ade80",marginTop:2}}>📍 Last updated: {lastTravelPos[0].toFixed(4)}, {lastTravelPos[1].toFixed(4)}</div>}
      </div>
      <div style={{display:"flex",gap:8}}>
        <Btn onClick={refreshTravelLayers} variant="success" style={{fontSize:12,padding:"8px 14px"}} disabled={refreshingTravel}>{refreshingTravel?"⏳ Refreshing...":"🔄 Refresh Nearby"}</Btn>
        <Btn onClick={stopTravelMode} variant="danger" style={{fontSize:12,padding:"8px 14px"}}>⏹ Exit Travel Mode</Btn>
      </div>
    </div>}

            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
      <Card style={{padding:14}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:8}}>📍 Live Location</div>
        {!travelMode?<>
          <Btn onClick={showFullRoute} style={{width:"100%",justifyContent:"center",fontSize:12,marginBottom:8,background:T.accent,color:"#fff",border:"none"}}>🗺 Show Full Route</Btn>
          <Btn onClick={tracking?toggleTracking:locateMe} variant={tracking?"danger":"success"} style={{width:"100%",justifyContent:"center",fontSize:12,marginBottom:8}}>
            {tracking?"⏹ Stop GPS":locating?"🔍 Locating...":"📍 Enable GPS"}
          </Btn>
          {!tracking&&userPos&&<div style={{fontSize:11,color:T.free,marginTop:-4,marginBottom:8,textAlign:"center"}}>✓ Location active - GPS auto-tracking on</div>}
          <Btn onClick={findNearbyStops} variant={userPos?"primary":"ghost"} style={{width:"100%",justifyContent:"center",fontSize:12,marginBottom:8}}>{searchingNearby?"🔍 Searching...":"🛑 Find Stops Near Me"}</Btn>
          <Btn onClick={startTravelMode} variant="success" style={{width:"100%",justifyContent:"center",fontSize:12,fontWeight:700}}>{locating?"🔍 Getting Location...":"🛣 Start Travel Mode"}</Btn>
          {tracking&&liveEta&&<div style={{marginTop:8,background:"#14532d",border:"1px solid #22c55e44",borderRadius:10,padding:"10px 14px",display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
            <div style={{fontSize:20}}>🎯</div>
            <div style={{flex:1}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#22c55e"}}>ETA: {new Date(liveEta.eta).toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit",hour12:true})}</div>
              <div style={{fontSize:11,color:"#86efac",marginTop:2}}>→ {liveEta.nextStop} · {liveEta.miles} mi remaining · {liveEta.mph} mph</div>
            </div>
          </div>}
        </>:<>
          <div style={{fontSize:12,color:T.free,marginBottom:8,fontWeight:600}}>🟢 Travel Mode On</div>
          <Btn onClick={showFullRoute} style={{width:"100%",justifyContent:"center",fontSize:12,marginBottom:8,background:T.accent,color:"#fff",border:"none"}}>🗺 Show Full Route</Btn>
          <Btn onClick={refreshTravelLayers} variant="primary" style={{width:"100%",justifyContent:"center",fontSize:12,marginBottom:8}} disabled={refreshingTravel}>{refreshingTravel?"⏳ Refreshing...":"🔄 Refresh Nearby Layers"}</Btn>
          <Btn onClick={stopTravelMode} variant="danger" style={{width:"100%",justifyContent:"center",fontSize:12}}>⏹ Exit Travel Mode</Btn>
          {tracking&&<div style={{fontSize:11,color:T.free,marginTop:6,textAlign:"center"}}>🟢 GPS tracking active</div>}
        </>}
      </Card>
      <Card style={{padding:14}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:8}}>🗺 Route Profile</div>
        <div style={{display:"flex",gap:5,marginBottom:10,flexWrap:"wrap"}}>
          {[
            {key:"driving-car",label:"🚗 Fastest",desc:"Highways preferred"},
            {key:"driving-hgv",label:"🚛 RV Route",desc:"Large vehicle routing"},
          ].map(p=>(
            <button key={p.key} onClick={()=>setRouteProfile(p.key)} title={p.desc}
              style={{padding:"5px 10px",borderRadius:8,border:`1px solid ${routeProfile===p.key?T.accent:T.border}`,background:routeProfile===p.key?T.accent+"22":"transparent",color:routeProfile===p.key?T.accent:T.muted,fontSize:11,fontWeight:routeProfile===p.key?700:400,cursor:"pointer"}}>
              {p.label}
            </button>
          ))}
        <button onClick={()=>{
          const map=mapInstanceRef.current;
          const L=window.L;
          if(!map||!L) return;
          // Show instruction without alert
          setWaypointMode(true);
          map.getContainer().style.cursor="crosshair";
          map.getContainer().title="Click map to add a stop";
          const handler=e=>{
            if(!e.latlng) return;
            const {lat,lng}=e.latlng;
            map.off("click",handler);
            map.getContainer().style.cursor="";
            map.getContainer().title="";
            setWaypointMode(false);
            // Reverse geocode to get city name
            fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`)
              .then(r=>r.json())
              .then(d=>{
                const city=d?.address?.city||d?.address?.town||d?.address?.village||d?.address?.county||"";
                const state=d?.address?.state_code||d?.address?.state||"";
                const name=city?(city+(state?", "+state:"")):`${lat.toFixed(3)}, ${lng.toFixed(3)}`;
                // Add as actual trip stop so it affects routing and layers
                onAddStop&&onAddStop([{
                  id:"wp_"+Date.now(),
                  isWaypoint:true,
                  name,
                  lat,
                  lon:lng,
                  state,
                  type:"transit",
                  isFree:true,
                  minNights:1,
                  maxNights:1,
                  nightlyRate:0,
                  distFromPrev:0,
                  active:true,
                  notes:"Added via map waypoint",
                  address:"",
                  homeCity:"",
                  fixedDates:false,
                  arriveDate:"",
                  departDate:"",
                }],"addstop");
              })
              .catch(()=>{
                // Fallback if reverse geocode fails
                onAddStop&&onAddStop([{
                  id:"wp_"+Date.now(),
                  isWaypoint:true,
                  name:`Stop at ${lat.toFixed(3)}, ${lng.toFixed(3)}`,
                  lat,lon:lng,state:"",type:"transit",isFree:true,
                  minNights:1,maxNights:1,nightlyRate:0,distFromPrev:0,
                  active:true,notes:"Added via map waypoint",
                  address:"",homeCity:"",fixedDates:false,arriveDate:"",departDate:"",
                }],"addstop");
              });
          };
          map.on("click",handler);
        }} style={{padding:"5px 10px",borderRadius:8,border:`1px solid ${waypointMode?T.accent:T.border}`,background:waypointMode?T.accent+"22":"transparent",color:waypointMode?T.accent:T.muted,fontSize:11,cursor:"pointer"}}>
          {waypointMode?"🎯 Click map to place stop":"📍 Add Stop via Map"}
        </button>
        </div>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:8}}>📐 Auto-Calculate Miles</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:10,lineHeight:1.5}}>Uses OpenRouteService to calculate exact driving miles between all stops.</div>
        <Btn onClick={calcMiles} variant="ghost" style={{width:"100%",justifyContent:"center",fontSize:12}} disabled={calcingMiles}>{calcingMiles?"⏳ Calculating...":"🚗 Calculate Driving Miles"}</Btn>
        <div style={{fontSize:11,color:T.muted,marginTop:6}}>Updates Miles from Prev Stop for all stops automatically.</div>
      </Card>
    </div>

    {/* ── Travel Mode Results List ── */}
    {travelMode&&travelLayerResults.length>0&&<Card accent="#27ae60" style={{marginBottom:12,padding:"14px 16px"}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:"#27ae60",marginBottom:10}}>🛣 Within 30 Miles of You ({travelLayerResults.length} results)</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:8}}>
        {travelLayerResults.map((r,i)=><div key={i} style={{background:T.bgLite,borderRadius:8,padding:"10px 12px",borderLeft:`3px solid ${r.color}`,display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
          <div style={{minWidth:0}}>
            <div style={{fontSize:11,fontWeight:700,color:r.color,marginBottom:1,textTransform:"uppercase",letterSpacing:.5}}>{r.emoji} {r.label}</div>
            <div style={{fontSize:12,fontWeight:600,color:T.text,marginBottom:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name}</div>
            <div style={{display:"flex",gap:8}}>
              <span style={{fontSize:12,fontWeight:700,color:r.color}}>{r.distMi} mi</span>
              <span style={{fontSize:11,color:T.muted}}>~{r.timeLabel}</span>
            </div>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:4,flexShrink:0}}>
            {r.website&&<a href={r.website.startsWith("http")?r.website:"https://"+r.website} target="_blank" rel="noopener noreferrer" style={{padding:"3px 8px",background:T.blue+"22",border:`1px solid ${T.blue}44`,borderRadius:5,color:T.blue,fontSize:10,fontWeight:600,textDecoration:"none",textAlign:"center"}}>🌐 Site</a>}
            <a href={`https://www.google.com/maps/dir/${userPos?.[0]},${userPos?.[1]}/${r.lat},${r.lon}`} target="_blank" rel="noopener noreferrer" style={{padding:"3px 8px",background:"#27ae6022",border:"1px solid #27ae6044",borderRadius:5,color:"#27ae60",fontSize:10,fontWeight:600,textDecoration:"none",textAlign:"center"}}>🗺 Go</a>
          </div>
        </div>)}
      </div>
    </Card>}
    {travelMode&&refreshingTravel&&<Card style={{padding:16,textAlign:"center",marginBottom:12}}><div style={{color:T.muted,fontSize:13}}>🔍 Searching within 30 miles of your position...</div></Card>}
    {midpointSuggestions.length>0&&<Card accent={T.accentAlt} style={{marginBottom:12,padding:"14px 16px"}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.accentAlt,marginBottom:10}}>⚠ Long Legs - Suggested Overnight Stops</div>
      {midpointSuggestions.map((sg,i)=><div key={i} style={{background:T.bgLite,borderRadius:8,padding:"12px 14px",marginBottom:8}}>
        <div style={{fontSize:13,color:T.text,marginBottom:4}}><strong>{sg.from}</strong> → <strong>{sg.to}</strong> <span style={{color:T.muted}}>({sg.miles} miles)</span></div>
        <div style={{fontSize:12,color:T.muted,marginBottom:8}}>Suggested overnight near: <strong style={{color:T.accent}}>{sg.city}{sg.state?`, ${sg.state}`:""}</strong></div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {[{l:"🏕 Campendium",url:`https://www.campendium.com/search?q=${encodeURIComponent(sg.city)}`,c:T.free},{l:"Good Sam",url:`https://www.goodsam.com/rv-parks-campgrounds/?q=${encodeURIComponent(sg.city)}`,c:"#e74c3c"},{l:"Recreation.gov",url:`https://www.recreation.gov/search?q=${encodeURIComponent(sg.city)}`,c:T.blue},{l:"KOA",url:`https://koa.com/campgrounds/?q=${encodeURIComponent(sg.city)}`,c:"#f39c12"},{l:"AllStays",url:`https://www.allstays.com/apps/rv-parks.htm?search=${encodeURIComponent(sg.city)}`,c:T.border}].map(lnk=><a key={lnk.l} href={lnk.url} target="_blank" rel="noopener noreferrer" style={{padding:"4px 10px",background:lnk.c+"22",border:`1px solid ${lnk.c}44`,borderRadius:6,color:lnk.c,fontSize:11,fontWeight:600,textDecoration:"none"}}>{lnk.l} →</a>)}
        </div>
      </div>)}
    </Card>}
    {nearbyResults.length>0&&<Card accent={T.blue} style={{padding:"14px 16px"}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.blue,marginBottom:10}}>🛑 Stops Near You ({nearbyResults.length} found)</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:8}}>
        {nearbyResults.map((r,i)=><div key={i} style={{background:T.bgLite,borderRadius:8,padding:"10px 12px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
          <div style={{minWidth:0}}><div style={{fontSize:12,fontWeight:600,color:T.text,marginBottom:2}}>{r.type}</div><div style={{fontSize:12,color:T.muted,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.name}</div><div style={{fontSize:11,color:T.border}}>{r.dist} mi away</div></div>
          <div style={{display:"flex",flexDirection:"column",gap:4,flexShrink:0}}>
            {r.website&&<a href={r.website} target="_blank" rel="noopener noreferrer" style={{padding:"3px 8px",background:T.blue+"22",border:`1px solid ${T.blue}44`,borderRadius:5,color:T.blue,fontSize:10,fontWeight:600,textDecoration:"none",textAlign:"center"}}>🌐 Site</a>}
            <a href={`https://www.google.com/maps?q=${r.lat},${r.lon}`} target="_blank" rel="noopener noreferrer" style={{padding:"3px 8px",background:T.free+"22",border:`1px solid ${T.free}44`,borderRadius:5,color:T.free,fontSize:10,fontWeight:600,textDecoration:"none",textAlign:"center"}}>📍 Go</a>
            <button onClick={()=>onAddStop&&onAddStop([{id:"nb_"+Date.now(),name:r.name,type:"transit",isFree:r.type.match(/Walmart|Casino|Rest/i)?true:false,nightlyRate:r.type.match(/Walmart|Casino|Rest/i)?0:45,minNights:1,maxNights:1,distFromPrev:0,active:true,notes:r.type+" - "+r.dist+" mi from current location",address:"",homeCity:"",fixedDates:false,arriveDate:"",departDate:"",lat:r.lat,lon:r.lon,sideTrips:[]}],"addstop")} style={{padding:"3px 8px",background:"#f59e0b22",border:"1px solid #f59e0b44",borderRadius:5,color:"#f59e0b",fontSize:10,fontWeight:600,cursor:"pointer",textAlign:"center"}}>➕ Add Stop</button>
          </div>
        </div>)}
      </div>
    </Card>}
    {searchingNearby&&nearbyResults.length===0&&<Card style={{padding:16,textAlign:"center"}}><div style={{color:T.muted,fontSize:13}}>🔍 Searching for stops near your location...</div></Card>}
  </div>;
}

// ── Results Section ────────────────────────────────────────────────

// ── Trip History Section ───────────────────────────────────────────
function TripHistorySection({currentTrip,stops,vehicle,finance,actuals,onArchive,onOpenHowTo,callAI,aiPurchased,aiFreeCalls}){
  const T=useTheme();
  const [history,setHistory]=useState(()=>{try{const h=localStorage.getItem("rv_trip_history");return h?JSON.parse(h):[];}catch{return[];}});
  const [expanded,setExpanded]=useState(null);
  const [archiving,setArchiving]=useState(false);
  const [tripName,setTripName]=useState("");
  const [showArchiveModal,setShowArchiveModal]=useState(false);

  const saveHistory=h=>{setHistory(h);try{localStorage.setItem("rv_trip_history",JSON.stringify(h));}catch{}};

  const totalActualLodge=stops.reduce((s,st)=>s+(parseFloat(st.actualLodge)||0),0);
  const totalActualSpend=totalActualLodge+(actuals.fuel||0)+(actuals.food||0)+(actuals.activities||0)+(actuals.maintenance||0)+(actuals.other||0);
  const hasActuals=totalActualSpend>0;

  const doArchive=()=>{
    if(!tripName.trim()){alert("Please give this trip a name.");return;}
    setArchiving(true);
    const record={
      id:Date.now(),
      name:tripName.trim(),
      archivedAt:new Date().toISOString(),
      stops:stops.map(s=>({name:s.name,state:s.state,type:s.type,minNights:s.minNights,maxNights:s.maxNights,nightlyRate:s.nightlyRate,isFree:s.isFree,distFromPrev:s.distFromPrev||0,actualLodge:s.actualLodge||0,notes:s.notes||'',active:s.active,arriveDate:s.arriveDate||'',departDate:s.departDate||'',address:s.address||'',lat:s.lat||null,lon:s.lon||null})),
      estimates:{total:currentTrip.grand,fuel:currentTrip.totFuel,lodging:currentTrip.totLodge,miles:currentTrip.totMi,nights:currentTrip.totNights},
      actuals:{...actuals,lodging:totalActualLodge,total:totalActualSpend},
      vehicle:{type:vehicle.rvType,mpg:vehicle.mpg,length:vehicle.rvLength,height:(vehicle.rvHeightFt??13)+"'"+(vehicle.rvHeightIn??0)+'"'},
    };
    const updated=[record,...history];
    saveHistory(updated);
    setArchiving(false);
    setShowArchiveModal(false);
    setTripName("");
    onArchive();
  };

  const deleteTrip=id=>{if(!window.confirm("Delete this archived trip?"))return;saveHistory(history.filter(h=>h.id!==id));};

  const fmt$=n=>n==null?"-":"$"+Math.round(n).toLocaleString();
  const fmtDiff=(est,act)=>{if(!act)return null;const diff=act-est;const pct=est>0?Math.abs(diff/est*100).toFixed(0):0;return{diff,pct,over:diff>0};};

  return<div className="anim">
    <SecHead icon="📚" title="Trip History" sub="Archive completed trips and compare estimates vs actuals."/>
    <QuickTipBar tabId="history" onOpenHowTo={onOpenHowTo}/>

    {/* Archive current trip card */}
    <Card accent={T.accent} style={{marginBottom:20,padding:"18px 20px"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontFamily:T.F.cond,fontWeight:800,fontSize:14,color:T.accent,letterSpacing:.5,textTransform:"uppercase",marginBottom:4}}>📦 Archive Current Trip</div>
          <div style={{fontSize:13,color:T.muted,lineHeight:1.5}}>When your trip is complete, archive it to save all stops, estimates, and actuals. Your planner will reset for the next trip.</div>
          {hasActuals&&<div style={{marginTop:8,display:"flex",gap:12,flexWrap:"wrap"}}>
            <span style={{fontSize:13,color:T.muted}}>Est: <strong style={{color:T.accent}}>{fmt$(currentTrip.grand)}</strong></span>
            <span style={{fontSize:13,color:T.muted}}>Actual: <strong style={{color:totalActualSpend>currentTrip.grand?T.danger:T.free}}>{fmt$(totalActualSpend)}</strong></span>
            {fmtDiff(currentTrip.grand,totalActualSpend)&&<span style={{fontSize:12,color:totalActualSpend>currentTrip.grand?T.danger:T.free,fontWeight:700}}>{totalActualSpend>currentTrip.grand?"⚠ ":"✓ "}{fmtDiff(currentTrip.grand,totalActualSpend).pct}% {totalActualSpend>currentTrip.grand?"over":"under"} budget</span>}
          </div>}
        </div>
        {callAI&&(aiPurchased||(aiFreeCalls!==null&&aiFreeCalls>0))&&<Btn onClick={async()=>{
          const p=`Write a warm, engaging trip narrative summary:\nVehicle: ${vehicle.rvType}\nTotal miles: ${currentTrip.totMi}\nTotal nights: ${currentTrip.totNights}\nEstimated cost: $${Math.round(currentTrip.grand)}\nStops visited: ${stops.filter(s=>s.active&&s.name&&s.type!=="home").map(s=>s.name+(s.state?", "+s.state:"")).join(" → ")}\n\nWrite 2-3 paragraphs as if recounting the journey. Make it personal, vivid and memorable.`;
          const result=await callAI(p,"You are a travel writer helping RVers capture journey memories. Write warmly and vividly in first person.");
          if(result) window.open("data:text/plain,"+encodeURIComponent(result),"_blank");
        }} variant="ghost" style={{whiteSpace:"nowrap"}}>✨ AI Narrative</Btn>}
        <Btn onClick={()=>setShowArchiveModal(true)} variant="primary" style={{whiteSpace:"nowrap"}}>📦 Archive & Reset Trip</Btn>
      </div>
    </Card>

    {/* Archive modal */}
    {showArchiveModal&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={e=>{if(e.target===e.currentTarget)setShowArchiveModal(false);}}>
      <div className="modal-anim" style={{background:T.bgMid,borderRadius:16,padding:28,maxWidth:440,width:"100%",boxShadow:"0 8px 40px rgba(0,0,0,0.4)"}}>
        <div style={{fontSize:36,textAlign:"center",marginBottom:12}}>📦</div>
        <div style={{fontFamily:T.F.head,fontSize:22,color:T.accent,textAlign:"center",marginBottom:6}}>Archive This Trip</div>
        <div style={{fontSize:13,color:T.muted,textAlign:"center",marginBottom:20,lineHeight:1.6}}>Give this trip a name. Your planner will reset for your next trip. All data is saved in this browser.</div>
        <Label>Trip Name</Label>
        <Inp value={tripName} onChange={e=>setTripName(e.target.value)} placeholder="e.g. Summer 2025 Southwest Loop" onKeyDown={e=>e.key==="Enter"&&doArchive()}/>
        {hasActuals&&<div style={{marginTop:12,padding:"10px 14px",background:T.bgLite,borderRadius:8,fontSize:12,color:T.muted}}>
          <div style={{marginBottom:4,fontWeight:600,color:T.text}}>What will be saved:</div>
          {[["Estimated Total",fmt$(currentTrip.grand)],["Actual Total",fmt$(totalActualSpend)],["Total Miles",currentTrip.totMi?.toLocaleString()+" mi"],["Nights on road",currentTrip.totNights+" nights"],["Stops",stops.filter(s=>s.active).length]].map(([l,v])=><div key={l} style={{display:"flex",justifyContent:"space-between"}}><span>{l}</span><strong>{v}</strong></div>)}
        </div>}
        <div style={{display:"flex",gap:10,marginTop:20}}>
          <Btn onClick={()=>setShowArchiveModal(false)} variant="ghost" style={{flex:1,justifyContent:"center"}}>Cancel</Btn>
          <Btn onClick={doArchive} variant="primary" style={{flex:2,justifyContent:"center"}} disabled={archiving}>{archiving?"Archiving...":"📦 Archive & Reset"}</Btn>
        </div>
      </div>
    </div>}

    {/* History list */}
    {history.length===0&&<Card style={{padding:40,textAlign:"center"}}>
      <div style={{fontSize:48,marginBottom:12}}>📭</div>
      <div style={{fontFamily:T.F.head,fontSize:20,color:T.muted,marginBottom:8}}>No archived trips yet</div>
      <div style={{fontSize:13,color:T.muted}}>Plan and complete a trip, then archive it here to build your travel history.</div>
    </Card>}

    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {history.map(trip=>{
        const isOpen=expanded===trip.id;
        const diff=fmtDiff(trip.estimates.total,trip.actuals.total);
        return<Card key={trip.id} style={{padding:0,overflow:"hidden"}}>
          {/* Trip header row */}
          <div style={{padding:"16px 20px",cursor:"pointer",display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}} onClick={()=>setExpanded(isOpen?null:trip.id)}>
            <div style={{flex:1,minWidth:200}}>
              <div style={{fontFamily:T.F.cond,fontWeight:800,fontSize:16,color:T.text,marginBottom:3}}>{trip.name}</div>
              <div style={{fontSize:12,color:T.muted}}>Archived {new Date(trip.archivedAt).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})} · {trip.vehicle.type} · {trip.stops.filter(s=>s.active).length} stops</div>
            </div>
            <div style={{display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
              <div style={{textAlign:"center"}}><div style={{fontFamily:T.F.head,fontSize:20,color:T.accent,fontWeight:900}}>{(trip.estimates.miles||0).toLocaleString()}</div><div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>miles</div></div>
              <div style={{textAlign:"center"}}><div style={{fontFamily:T.F.head,fontSize:20,color:T.blue,fontWeight:900}}>{trip.estimates.nights}</div><div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>nights</div></div>
              <div style={{textAlign:"center"}}><div style={{fontFamily:T.F.head,fontSize:20,color:T.muted,fontWeight:900,textDecoration:"line-through"}}>{fmt$(trip.estimates.total)}</div><div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>estimated</div></div>
              {trip.actuals.total>0&&<div style={{textAlign:"center"}}><div style={{fontFamily:T.F.head,fontSize:20,fontWeight:900,color:diff?.over?T.danger:T.free}}>{fmt$(trip.actuals.total)}</div><div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:1}}>actual</div></div>}
              {diff&&<div style={{padding:"4px 10px",borderRadius:20,background:(diff.over?T.danger:T.free)+"22",border:`1px solid ${diff.over?T.danger:T.free}55`,color:diff.over?T.danger:T.free,fontSize:11,fontWeight:700}}>{diff.over?"⚠":"✓"} {diff.pct}% {diff.over?"over":"under"}</div>}
            </div>
            <div style={{fontSize:18,color:T.muted,flexShrink:0}}>{isOpen?"▲":"▼"}</div>
          </div>

          {/* Expanded detail */}
          {isOpen&&<div style={{borderTop:`1px solid ${T.border}`,padding:"16px 20px"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:12,marginBottom:16}}>
              {/* Spending breakdown */}
              <div style={{background:T.bgLite,borderRadius:10,padding:"14px 16px"}}>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,textTransform:"uppercase",letterSpacing:1,color:T.muted,marginBottom:10}}>Spending Breakdown</div>
                {[["Fuel",trip.estimates.fuel,trip.actuals.fuel],["Lodging",trip.estimates.lodging,trip.actuals.lodging],["Food",null,trip.actuals.food],["Activities",null,trip.actuals.activities],["Maintenance",null,trip.actuals.maintenance],["Other",null,trip.actuals.other]].map(([l,est,act])=>(est||act)?<div key={l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}><span style={{fontSize:13,color:T.muted}}>{l}</span><div style={{display:"flex",gap:10}}>{est?<span style={{fontSize:12,color:T.muted,textDecoration:"line-through"}}>{fmt$(est)}</span>:null}<span style={{fontSize:13,fontWeight:600,color:act>est&&est?T.danger:T.free}}>{fmt$(act)}</span></div></div>:null)}
                <div style={{borderTop:`1px solid ${T.border}`,paddingTop:8,marginTop:4,display:"flex",justifyContent:"space-between"}}><span style={{fontWeight:700,fontSize:13}}>Total</span><span style={{fontWeight:900,fontSize:14,color:diff?.over?T.danger:T.free}}>{fmt$(trip.actuals.total||trip.estimates.total)}</span></div>
              </div>
              {/* Stops list */}
              <div style={{background:T.bgLite,borderRadius:10,padding:"14px 16px"}}>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,textTransform:"uppercase",letterSpacing:1,color:T.muted,marginBottom:10}}>Stops ({trip.stops.filter(s=>s.active).length})</div>
                <div style={{display:"flex",flexDirection:"column",gap:5,maxHeight:200,overflowY:"auto"}}>
                  {trip.stops.filter(s=>s.active).map((s,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:12,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1}}>{s.name||"(unnamed)"}</span>
                    <div style={{display:"flex",gap:8,flexShrink:0,marginLeft:8}}>
                      <span style={{fontSize:11,color:T.muted}}>{s.minNights}-{s.maxNights}n</span>
                      {s.actualLodge>0&&<span style={{fontSize:11,fontWeight:700,color:T.free}}>{fmt$(s.actualLodge)}</span>}
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <Btn variant="ghost" style={{fontSize:12}} onClick={()=>deleteTrip(trip.id)}>🗑 Delete</Btn>
            </div>
          </div>}
        </Card>;
      })}
    </div>
  </div>;
}


// ── AIToolsPanel ──────────────────────────────────────────────────
function AIToolsPanel({T,aiFreeCalls,aiPurchased,children}){
  const [aiOpen,setAiOpen]=useState(false);

  return(
    <div style={{marginBottom:12}}>
      <button onClick={()=>setAiOpen(o=>!o)} style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",background:"linear-gradient(135deg,#7c3aed18,#4f46e518)",border:"1px solid #7c3aed33",borderRadius:aiOpen?"12px 12px 0 0":"12px",padding:"10px 16px",cursor:"pointer"}}>
        <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:700,fontSize:13,color:"#7c3aed",letterSpacing:.5}}>✨ AI Trip Tools{aiFreeCalls!==null&&!aiPurchased?` · ${aiFreeCalls} free left`:aiPurchased?" · Unlimited":""}</div>
        <div style={{fontSize:12,color:"#7c3aed"}}>{aiOpen?"▲ Hide":"▼ Show AI Tools"}</div>
      </button>
      {aiOpen&&<div style={{border:"1px solid #7c3aed33",borderTop:"none",borderRadius:"0 0 12px 12px",padding:"14px 18px",background:"transparent"}}>
        {children}
      </div>}
    </div>
  );
}

function ResultsSection({trip,finance,memberships,prefs,actuals={},setActuals,stops=[],onOpenHowTo,vehicle={},fuel={},callAI,aiFreeCalls,aiPurchased,onShowAIUpgrade,onAIFuel,onAIStops,rvMaintenance}){
  const T=useTheme();
  const [mileView,setMileView]=useState('total');
  const [aiReview,setAiReview]=useState("");
  const [aiLoading,setAiLoading]=useState(false);
  const [showAiReview,setShowAiReview]=useState(false);
  const fin=calcFinance(finance);
  const hasData=trip.stops.some(s=>s.mi>0||s.nights>0);
  const fmt$=n=>n==null?"-":"$"+Math.round(n).toLocaleString();
  const totalActualLodge=stops.reduce((s,st)=>s+(parseFloat(st.actualLodge)||0),0);
  const totalActualSpend=totalActualLodge+(actuals.fuel||0)+(actuals.food||0)+(actuals.activities||0)+(actuals.maintenance||0)+(actuals.other||0);
  const hasActuals=totalActualSpend>0;
  const updA=(k,v)=>setActuals&&setActuals(p=>({...p,[k]:parseFloat(v)||0}));
  const freeNights=trip.stops.filter(s=>s.active&&s.isFree).reduce((a,s)=>a+s.nights,0);
  const [aiFixes,setAiFixes]=useState([]);
  const [aiConflicts,setAiConflicts]=useState("");
  const [aiWeather,setAiWeather]=useState("");
  const [aiBudget,setAiBudget]=useState("");
  const [aiRoute,setAiRoute]=useState("");
  const [aiMembership,setAiMembership]=useState("");
  const [aiActivePanel,setAiActivePanel]=useState("");
  const [aiPanelLoading,setAiPanelLoading]=useState(false);

  const runAIPanel=async(panelKey,prompt,system)=>{
    if(!callAI){onShowAIUpgrade&&onShowAIUpgrade();return;}
    setAiActivePanel(panelKey);setAiPanelLoading(true);
    const result=await callAI(prompt,system||"You are an expert RV trip planning assistant. Be concise and actionable.");
    const setter={conflicts:setAiConflicts,weather:setAiWeather,budget:setAiBudget,route:setAiRoute,membership:setAiMembership}[panelKey];
    setter&&setter(result||"Unable to get response.");
    setAiPanelLoading(false);
  };

  const handleAIReview=async()=>{
    if(!callAI){onShowAIUpgrade&&onShowAIUpgrade();return;}
    setAiLoading(true);setShowAiReview(true);setAiFixes([]);
    const activeStops=trip.stops.filter(s=>s.active&&s.name);
    const tripSummary={
      totalMiles:trip.totMi,totalNights:trip.totNights,totalCost:Math.round(trip.grand),
      fuelCost:Math.round(trip.totFuel),lodgingCost:Math.round(trip.totLodge),
      vehicle:vehicle.rvType,mpg:vehicle.mpg,tankGallons:vehicle.tankGallons,
      maxDriveHours:prefs.maxDriveHours,avgSpeed:prefs.avgSpeedMph,
      stops:activeStops.map(s=>({name:s.name,state:s.state,nights:s.nights,miles:s.mi,isFree:s.isFree,exceedsDaily:s.exceedsDaily,fuelRangeWarning:s.fuelRangeWarning,tankRange:s.tankRange})),
    };
    const prompt=`Review this RV trip and respond with a JSON object with two fields:\n\n${JSON.stringify(tripSummary,null,2)}\n\nRespond with ONLY this JSON structure:\n{"review":"your friendly analysis under 250 words","fixes":[{"issue":"brief issue description","suggestion":"what to do","stopName":"City Name","stopState":"TX","insertAfterStop":"stop name to insert after","type":"transit","isFree":true,"nights":1,"nightlyRate":0}]}\n\nOnly include fixes array items for legs that EXCEED the daily drive limit or have fuel range warnings. Leave fixes as empty array [] if no issues. Return only valid JSON.`;
    const result=await callAI(prompt,"You are an expert RV trip planner. Return ONLY valid JSON with a review string and fixes array. No markdown, no extra text.");
    try{
      const clean=(result||"").replace(/```json|```/g,"").trim();
      const parsed=JSON.parse(clean);
      setAiReview(parsed.review||result||"Unable to get AI review.");
      setAiFixes(Array.isArray(parsed.fixes)?parsed.fixes:[]);
    }catch{
      setAiReview(result||"Unable to get AI review. Please try again.");
      setAiFixes([]);
    }
    setAiLoading(false);
  };
  const warningLegs=trip.stops.filter(s=>s.active&&s.exceedsDaily);
  const tips=[];
  if(!memberships.goodSam&&trip.grand>3000)tips.push("Good Sam ($44/yr) saves 10-15% at thousands of parks.");
  if(!memberships.harvestHosts)tips.push("Harvest Hosts ($99/yr): free stays at farms, wineries, breweries.");
  if(!memberships.passportAmerica&&trip.totNights>30)tips.push("Passport America ($44/yr): 50% off at 1,800+ parks off-peak.");
  if(freeNights===0&&trip.totNights>14)tips.push("No free camping nights. Even 4-5 Walmart nights/month saves $180-225.");
  const fuelRangeLegs=trip.stops.filter(s=>s.active&&s.fuelRangeWarning);
  if(fuelRangeLegs.length>0)tips.push(`⛽ ${fuelRangeLegs.length} leg${fuelRangeLegs.length>1?"s":""} exceed${fuelRangeLegs.length===1?"s":""} 75% of your tank range (${fuelRangeLegs[0].tankRange} mi). Plan fuel stops ahead.`);
  if(warningLegs.length>0)tips.push(`${warningLegs.length} leg${warningLegs.length>1?"s":""} exceed your ${Math.round(trip.maxDailyMiles)}-mile daily limit.`);
  return<div className="anim">
    <SecHead icon="📊" title="Trip Summary & Itinerary" sub="All numbers update live as you edit."/>
    <QuickTipBar tabId="results" onOpenHowTo={onOpenHowTo}/>
    {/* Maintenance Warnings */}
    {rvMaintenance&&(()=>{
      const urgent=RV_SERVICE_TEMPLATES.filter(t=>t.id!=="custom").filter(t=>{
        const logs=(rvMaintenance.logs||[]).filter(l=>l.serviceId===t.id).sort((a,b)=>new Date(b.date)-new Date(a.date));
        const last=logs[0]; if(!last) return false;
        const daysSince=Math.floor((new Date()-new Date(last.date))/86400000);
        if(t.intervalMi>0){
          const milesSince=(parseFloat(rvMaintenance.currentOdometer)||0)-(parseFloat(last.odometer)||0);
          return milesSince>t.intervalMi*0.9||daysSince>t.intervalDays*0.9;
        }
        return t.intervalDays>0&&daysSince>t.intervalDays*0.9;
      });
      if(!urgent.length) return null;
      return<Card accent={T.danger} style={{marginBottom:12,padding:"12px 16px"}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.danger,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>🔧 Maintenance Due</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:8}}>Service items approaching or past due based on your maintenance log.</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6,maxWidth:"100%"}}>
          {urgent.map(t=><span key={t.id} style={{background:T.danger+"18",border:`1px solid ${T.danger}33`,borderRadius:6,padding:"3px 10px",fontSize:11,fontWeight:700,color:T.danger,wordBreak:"break-word"}}>{t.icon} {t.name}</span>)}
        </div>
      </Card>;
    })()}
    {/* AI Tools - collapsible */}
    <AIToolsPanel T={T} aiFreeCalls={aiFreeCalls} aiPurchased={aiPurchased}>
    {/* AI Review Panel */}
    <Card accent="#7c3aed" style={{marginBottom:12,padding:"14px 18px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
        <div>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#7c3aed",letterSpacing:.5}}>✨ AI Trip Review</div>
          <div style={{fontSize:11,color:T.muted,marginTop:2}}>Get personalized analysis of your itinerary, warnings, and savings tips{aiFreeCalls!==null&&!aiPurchased?` · ${aiFreeCalls} free request${aiFreeCalls!==1?"s":""} remaining`:aiPurchased?" · Unlimited":""}</div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          {showAiReview&&<button onClick={()=>{setShowAiReview(false);setAiReview("");}} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 10px",color:T.muted,fontSize:11,cursor:"pointer"}}>✕ Close</button>}
          <button onClick={handleAIReview} disabled={aiLoading} style={{background:aiLoading?"#7c3aed88":"#7c3aed",color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:700,cursor:aiLoading?"not-allowed":"pointer",display:"flex",alignItems:"center",gap:6}}>
            {aiLoading?"⏳ Analyzing...":"✨ Review My Trip"}
          </button>
        </div>
      </div>
      {showAiReview&&<div style={{marginTop:12,padding:"12px 14px",background:T.bgLite,borderRadius:8,fontSize:13,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap"}}>
        {aiLoading?"🤔 Analyzing your trip plan...":aiReview}
      </div>}
      {aiFixes.length>0&&<div style={{marginTop:12,display:"flex",flexDirection:"column",gap:8}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,letterSpacing:1,textTransform:"uppercase"}}>🔧 AI Suggested Fixes</div>
        {aiFixes.map((fix,i)=>(
          <div key={i} style={{background:T.danger+"12",border:`1px solid ${T.danger}33`,borderRadius:10,padding:"12px 14px"}}>
            <div style={{fontWeight:600,fontSize:13,color:T.danger,marginBottom:4}}>⚠ {fix.issue}</div>
            <div style={{fontSize:12,color:T.muted,marginBottom:8}}>{fix.suggestion}</div>
            {fix.stopName&&<button onClick={()=>{
              // Find the stop to insert after
              const afterIdx=stops.findIndex(s=>s.name&&fix.insertAfterStop&&s.name.toLowerCase().includes(fix.insertAfterStop.toLowerCase()));
              const insertAt=afterIdx>=0?afterIdx+1:stops.length;
              const newStop={...mkStop(),name:fix.stopName,state:fix.stopState||"",type:fix.type||"transit",isFree:fix.isFree||true,nightlyRate:fix.nightlyRate||0,minNights:fix.nights||1,maxNights:fix.nights||1,notes:"Added by AI - "+fix.suggestion};
              const newStops=[...stops];
              newStops.splice(insertAt,0,newStop);
              setActuals&&setActuals(a=>a);
              // Update stops via parent
              const evt=new CustomEvent("rv-add-stop",{detail:{stops:newStops}});
              window.dispatchEvent(evt);
              setAiFixes(prev=>prev.filter((_,fi)=>fi!==i));
            }} style={{background:T.free,color:"#fff",border:"none",borderRadius:7,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>➕ Add {fix.stopName}{fix.stopState?", "+fix.stopState:""} as Stop</button>}
          </div>
        ))}
      </div>}
      {!aiPurchased&&aiFreeCalls===0&&<div style={{marginTop:10,fontSize:11,color:"#7c3aed",textAlign:"center",cursor:"pointer",textDecoration:"underline"}} onClick={onShowAIUpgrade}>Upgrade for unlimited AI reviews →</div>}
      {(aiPurchased||(aiFreeCalls!==null&&aiFreeCalls>0))&&<div style={{display:"flex",gap:8,marginTop:10,flexWrap:"wrap"}}>
        <button onClick={onAIFuel} style={{flex:1,background:"#f59e0b18",border:"1px solid #f59e0b44",borderRadius:8,padding:"8px 12px",color:"#f59e0b",fontSize:12,fontWeight:600,cursor:"pointer",justifyContent:"center"}}>⛽ Fuel Planner</button>
        <button onClick={onAIStops} style={{flex:1,background:"#05966918",border:"1px solid #05966944",borderRadius:8,padding:"8px 12px",color:"#059669",fontSize:12,fontWeight:600,cursor:"pointer",justifyContent:"center"}}>📍 Stop Ideas</button>
        <button onClick={()=>{const p=`Analyze this trip for scheduling conflicts, timing issues, or logistical problems:\n${JSON.stringify({stops:trip.stops.filter(s=>s.active&&s.name).map(s=>({name:s.name,arr:s.arr,dep:s.dep,nights:s.nights,miles:s.mi,exceedsDaily:s.exceedsDaily})),maxDriveHours:prefs.maxDriveHours,travelDays:prefs.travelDays})}\nList any conflicts, overlapping dates, unrealistic drive times, or missing info. Be specific.`;runAIPanel("conflicts",p,"You are an RV trip logistics expert. Find scheduling conflicts and issues. Be specific and concise.");}} style={{flex:1,background:"#ef444418",border:"1px solid #ef444444",borderRadius:8,padding:"8px 12px",color:"#ef4444",fontSize:12,fontWeight:600,cursor:"pointer",justifyContent:"center"}}>⚡ Conflicts</button>
        <button onClick={()=>{const activeS=trip.stops.filter(s=>s.active&&s.name&&s.arr);const p=`Check weather concerns for these RV trip stops and dates:\n${activeS.map(s=>s.name+(s.state?", "+s.state:"")+" arriving "+s.arr).join("\n")}\nFor each stop, note any seasonal weather risks, road conditions, or timing concerns. Keep it brief and practical.`;runAIPanel("weather",p,"You are an RV travel weather advisor.");}} style={{flex:1,background:"#38bdf818",border:"1px solid #38bdf844",borderRadius:8,padding:"8px 12px",color:"#38bdf8",fontSize:12,fontWeight:600,cursor:"pointer",justifyContent:"center"}}>🌤 Weather</button>
      </div>}
      {(aiPurchased||(aiFreeCalls!==null&&aiFreeCalls>0))&&<div style={{display:"flex",gap:8,marginTop:6,flexWrap:"wrap"}}>
        <button onClick={()=>{const p=`This RV trip costs $${Math.round(trip.grand)} total. Budget breakdown: fuel $${Math.round(trip.totFuel)}, lodging $${Math.round(trip.totLodge)}. Stops: ${trip.stops.filter(s=>s.active&&s.name).map(s=>s.name+(s.isFree?" (free)":"$"+Math.round(s.lc))).join(", ")}. Suggest specific ways to reduce cost by 20% or more. Be concrete.`;runAIPanel("budget",p,"You are an expert RV budget advisor. Give specific, actionable savings suggestions.");}} style={{flex:1,background:"#27ae6018",border:"1px solid #27ae6044",borderRadius:8,padding:"8px 12px",color:"#27ae60",fontSize:12,fontWeight:600,cursor:"pointer",justifyContent:"center"}}>💰 Budget Optimizer</button>
        <button onClick={()=>{const p=`Review this stop order and suggest if reordering would reduce total miles or make more geographic sense: ${trip.stops.filter(s=>s.active&&s.name).map((s,i)=>i+". "+s.name+(s.state?", "+s.state:"")+" ("+s.mi+" mi)").join(", ")}. Only suggest changes if they clearly improve the route. Total current miles: ${trip.totMi}.`;runAIPanel("route",p,"You are an expert route optimization advisor for RV trips.");}} style={{flex:1,background:"#9b59b618",border:"1px solid #9b59b644",borderRadius:8,padding:"8px 12px",color:"#9b59b6",fontSize:12,fontWeight:600,cursor:"pointer",justifyContent:"center"}}>🗺 Route Optimizer</button>
        <button onClick={()=>{const p=`Based on this RV trip (${trip.totNights} nights, ${trip.totMi} miles, $${Math.round(trip.totLodge)} lodging), which memberships would actually save money? Calculate real savings for: Good Sam (10-15% at 2000+ parks, $29/yr), Passport America (50% off-peak, $44/yr), Harvest Hosts (free stays farms/wineries, $99/yr), KOA Value Kard (10% off KOA, free). Be specific with dollar amounts.`;runAIPanel("membership",p,"You are an RV membership savings advisor. Calculate specific dollar savings.");}} style={{flex:1,background:"#f39c1218",border:"1px solid #f39c1244",borderRadius:8,padding:"8px 12px",color:"#f39c12",fontSize:12,fontWeight:600,cursor:"pointer",justifyContent:"center"}}>🎫 Membership Advisor</button>
      </div>}
      {/* AI Panel Results */}
      {aiActivePanel&&({conflicts:aiConflicts,weather:aiWeather,budget:aiBudget,route:aiRoute,membership:aiMembership}[aiActivePanel])&&<div style={{marginTop:10,background:T.bgLite,borderRadius:8,padding:"12px 14px"}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,letterSpacing:1,textTransform:"uppercase"}}>
            {{conflicts:"⚡ Conflicts",weather:"🌤 Weather",budget:"💰 Budget",route:"🗺 Route",membership:"🎫 Membership"}[aiActivePanel]}
          </div>
          <button onClick={()=>setAiActivePanel("")} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:12}}>✕</button>
        </div>
        {aiPanelLoading?<div style={{color:T.muted,fontSize:12}}>🤖 Analyzing...</div>
        :<div style={{fontSize:13,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap"}}>{({conflicts:aiConflicts,weather:aiWeather,budget:aiBudget,route:aiRoute,membership:aiMembership}[aiActivePanel])}</div>}
      </div>}
    </Card>
    </AIToolsPanel>

    {/* ── Live Actuals Tracker ── */}
    <Card accent={hasActuals?T.free:T.border} style={{marginBottom:16,padding:"16px 20px"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <div>
          <div style={{fontFamily:T.F.cond,fontWeight:800,fontSize:13,letterSpacing:.5,textTransform:"uppercase",color:hasActuals?T.free:T.muted}}>🧾 Live Actuals Tracker</div>
          <div style={{fontSize:12,color:T.muted,marginTop:2}}>Enter what you've actually spent as you travel · Lodging actuals are entered per stop</div>
        </div>
        {hasActuals&&<div style={{textAlign:"right"}}>
          <div style={{fontSize:12,color:T.muted}}>Total Actual</div>
          <div style={{fontFamily:T.F.head,fontSize:22,fontWeight:900,color:totalActualSpend>trip.grand?T.danger:T.free}}>{fmt$(totalActualSpend)}</div>
          <div style={{fontSize:11,color:T.muted}}>vs est. {fmt$(trip.grand)} <span style={{fontWeight:700,color:totalActualSpend>trip.grand?T.danger:T.free}}>{totalActualSpend>trip.grand?"⚠ over":"✓ under"}</span></div>
        </div>}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:10}}>
        {[
          {k:"fuel",label:"⛽ Fuel Spent",est:trip.totFuel},
          {k:"food",label:"🛒 Food & Groceries",est:null},
          {k:"activities",label:"🎪 Activities & Fun",est:null},
          {k:"maintenance",label:"🔧 Repairs/Maintenance",est:null},
          {k:"other",label:"💳 Other",est:null},
        ].map(({k,label,est})=><div key={k}>
          <div style={{fontSize:11,fontWeight:600,color:T.muted,marginBottom:4}}>{label}</div>
          <div style={{position:"relative"}}>
            <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:13,color:T.muted,pointerEvents:"none"}}>$</span>
            <input type="number" name={`actual-${k}`} id={`actual-${k}`} min={0} value={actuals[k]||""} onChange={e=>updA(k,e.target.value)} placeholder="0" style={{background:T.bgLite,border:`1px solid ${(actuals[k]>0&&est&&actuals[k]>est)?T.danger:(actuals[k]>0?T.free:T.border)}`,borderRadius:8,color:T.text,padding:"8px 10px 8px 24px",fontSize:14,width:"100%",outline:"none",transition:"border-color .15s"}} onFocus={e=>{e.target.style.borderColor=T.accent;e.target.style.boxShadow=`0 0 0 3px ${T.accent}22`;}} onBlur={e=>{e.target.style.borderColor=(actuals[k]>0&&est&&actuals[k]>est)?T.danger:(actuals[k]>0?T.free:T.border);e.target.style.boxShadow="none";}}/>
          </div>
          {est&&actuals[k]>0&&<div style={{fontSize:10,marginTop:3,color:actuals[k]>est?T.danger:T.free}}>{actuals[k]>est?`⚠ $${Math.round(actuals[k]-est)} over`:`✓ $${Math.round(est-actuals[k])} under`} est.</div>}
          {est&&<div style={{fontSize:10,color:T.muted,marginTop:est&&actuals[k]>0?0:3}}>Est: {fmt$(est)}</div>}
        </div>)}
        {/* Lodging summary from stops */}
        <div>
          <div style={{fontSize:11,fontWeight:600,color:T.muted,marginBottom:4}}>🏕 Lodging (from stops)</div>
          <div style={{background:T.bgLite,border:`1px solid ${totalActualLodge>0?T.free:T.border}`,borderRadius:8,padding:"9px 12px",fontSize:14,color:totalActualLodge>0?T.free:T.muted,fontWeight:totalActualLodge>0?700:400}}>{totalActualLodge>0?fmt$(totalActualLodge):"Enter in each stop"}</div>
          {totalActualLodge>0&&<div style={{fontSize:10,color:T.muted,marginTop:3}}>vs est. {fmt$(trip.totLodge)}</div>}
        </div>
      </div>
    </Card>

    {!hasData?<Card style={{padding:"32px 24px",textAlign:"center"}}>
      <div style={{fontSize:48,marginBottom:12}}>🗺</div>
      <div style={{fontFamily:T.F.head,fontSize:20,color:T.muted,marginBottom:16}}>Your itinerary will appear here</div>
      <div style={{fontSize:13,color:T.muted,marginBottom:20,lineHeight:1.7}}>Complete these steps to generate your trip summary:</div>
      <div style={{display:"flex",flexDirection:"column",gap:8,maxWidth:360,margin:"0 auto",textAlign:"left"}}>
        {[
          {done:vehicle.rvType&&vehicle.mpg>0,label:"Set your vehicle type and MPG",tab:"vehicle",btn:"→ Vehicle Setup"},
          {done:stops.filter(s=>s.active&&s.name&&s.type!=="home").length>0,label:"Add your destination stops",tab:"stops",btn:"→ Add Stops"},
          {done:stops.filter(s=>s.active&&s.distFromPrev>0).length>0,label:"Calculate driving miles",tab:"map",btn:"→ Map & Calculate"},
        ].map((step,i)=>(
          <div key={i} onClick={()=>onOpenHowTo&&!step.done?undefined:undefined} style={{display:"flex",gap:10,alignItems:"center",padding:"10px 14px",background:step.done?T.free+"12":T.bgLite,borderRadius:8,border:`1px solid ${step.done?"#27ae6033":T.border}`}}>
            <div style={{width:24,height:24,borderRadius:"50%",background:step.done?"#27ae60":T.border,color:"#fff",fontSize:12,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{step.done?"✓":i+1}</div>
            <div style={{flex:1,fontSize:12,color:step.done?T.muted:T.text}}>{step.label}</div>
            {!step.done&&<button onClick={()=>{}} style={{background:T.accent,color:"#fff",border:"none",borderRadius:6,padding:"4px 10px",fontSize:11,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>{step.btn}</button>}
          </div>
        ))}
      </div>
    </Card>:<>
      {trip.totMi>0&&trip.totFuel===0&&<Card accent={T.accentAlt} style={{marginBottom:16,padding:"12px 16px"}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.accentAlt,marginBottom:4}}>⛽ Fuel Estimate Pending</div>
        <div style={{fontSize:12,color:T.muted}}>Some stops don't have miles yet. Click 📍 Calc on each stop or use <strong>🚗 Auto-Calculate Miles</strong> on the Map tab to get fuel cost estimates. Estimated total: <strong style={{color:T.accent}}>~{fmt$(trip.totMi/Math.max(parseFloat(vehicle.mpg)||8,1)*parseFloat(fuel.avgPricePerGallon||3.30))}</strong> ({trip.totMi.toLocaleString()} mi ÷ {vehicle.mpg} MPG × ${fuel.avgPricePerGallon}/gal)</div>
      </Card>}
      {warningLegs.length>0&&<Card accent={T.danger} style={{marginBottom:16,padding:"12px 16px"}}><div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.danger,marginBottom:8,textTransform:"uppercase"}}>⚠ Drive Limit Warnings</div>{warningLegs.map(s=><div key={s.id} style={{fontSize:13,color:T.muted,marginBottom:4,display:"flex",gap:8,flexWrap:"wrap",wordBreak:"break-word"}}><span style={{color:T.danger,flexShrink:0}}>→</span><span style={{flex:1,minWidth:0}}><strong style={{color:T.text}}>{s.name||"Unnamed"}</strong>: {s.mi.toLocaleString()} mi needs <strong style={{color:T.danger}}>{s.daysNeeded} drive days</strong></span></div>)}</Card>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(145px,1fr))",gap:12,marginBottom:20}}>
        <div style={{gridColumn:"1/-1",display:"flex",gap:6,marginBottom:4,alignItems:"center"}}>
          <span style={{fontSize:11,color:T.muted,fontWeight:600}}>Miles View:</span>
          {["total","legs"].map(v=><button key={v} onClick={()=>setMileView(v)} style={{padding:"4px 12px",borderRadius:20,border:`1px solid ${mileView===v?T.accent:T.border}`,background:mileView===v?T.accent+"22":"transparent",color:mileView===v?T.accent:T.muted,fontSize:11,fontWeight:mileView===v?700:400,cursor:"pointer"}}>{v==="total"?"🗺 Full Trip":"📍 By Stop"}</button>)}
        </div>
        {mileView==="total"?(
          <StatBox label="Total Miles" value={trip.totMi.toLocaleString()} sub={`${trip.stops.filter(s=>s.active&&s.mi>0).length} legs calculated`}/>
        ):(
          <div style={{gridColumn:"1/-1",background:T.bgLite,borderRadius:10,padding:"12px 14px",border:`1px solid ${T.border}`}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:8,textTransform:"uppercase",letterSpacing:1}}>Miles Per Stop</div>
            {trip.stops.filter(s=>s.active&&s.mi>0).map((s,i)=>(
              <div key={s.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"5px 0",borderBottom:`1px solid ${T.border}44`,fontSize:12}}>
                <span style={{color:T.text,flex:1}}><span style={{color:T.muted,marginRight:6}}>{i+1}.</span>{s.name||"(unnamed)"}</span>
                <span style={{color:T.accent,fontWeight:700,marginRight:12}}>{s.mi.toLocaleString()} mi</span>
                <span style={{color:T.muted,fontSize:11}}>{s.fc>0?fmt$(s.fc)+" fuel":"-"}</span>
              </div>
            ))}
            <div style={{display:"flex",justifyContent:"space-between",marginTop:8,paddingTop:6,borderTop:`2px solid ${T.border}`,fontSize:12,fontWeight:700}}>
              <span style={{color:T.text}}>Total</span>
              <span style={{color:T.accent}}>{trip.totMi.toLocaleString()} mi</span>
              <span style={{color:T.blue}}>{fmt$(trip.totFuel)} fuel</span>
            </div>
          </div>
        )}
        <StatBox label="Total Nights" value={trip.totNights} sub={`${(trip.totNights/30).toFixed(1)} months`} accent={T.green}/>
        <StatBox label="Fuel Cost" value={hasActuals&&actuals.fuel>0?`${fmt$(actuals.fuel)}`:fmt$(trip.totFuel)} sub={hasActuals&&actuals.fuel>0?`Est. ${fmt$(trip.totFuel)}`:`${fmtDec(trip.totGal,0)} gallons`} accent={T.blue}/>
        <StatBox label="Lodging Cost" value={totalActualLodge>0?fmt$(totalActualLodge):fmt$(trip.totLodge)} sub={totalActualLodge>0?`Est. ${fmt$(trip.totLodge)}`:`${freeNights} free nights`} accent={T.muted}/>
        <StatBox label="Grand Total" value={hasActuals?fmt$(totalActualSpend):fmt$(trip.grand)} sub={hasActuals?`Est. ${fmt$(trip.grand)}`:"incl. food/misc"} accent={hasActuals?(totalActualSpend>trip.grand?T.danger:T.free):T.accent}/>
        <StatBox label="Per Day" value={fmt$(trip.cpd)} sub="all-in" accent={T.accentAlt}/>
        {trip.monthsOfIncome!=null&&fin.mth>0&&<StatBox label="Months of Income" value={fmtDec(trip.monthsOfIncome,1)} sub="to cover trip" accent={T.free}/>}
      </div>
      <Card style={{marginBottom:20}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:14,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>Cost Breakdown</div>
        {[{l:"Fuel",v:trip.totFuel,c:T.blue},{l:"Lodging",v:trip.totLodge,c:T.green},{l:"Groceries",v:trip.misc.groceries,c:T.free},{l:"Propane & Utilities",v:trip.misc.propane,c:T.accentAlt},{l:"Maintenance",v:trip.misc.maint,c:T.muted},{l:"Entertainment",v:trip.misc.entertain,c:"#9b59b6"},{l:"Emergency Fund",v:trip.misc.emergency,c:T.danger}].map(({l,v,c})=>{const pct=trip.grand>0?v/trip.grand*100:0;return<div key={l} style={{marginBottom:10}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}><span style={{fontSize:13}}>{l}</span><span style={{fontSize:13,fontWeight:600}}>{fmt$(v)} <span style={{fontSize:11,color:T.muted}}>({fmtDec(pct,1)}%)</span></span></div><div style={{height:6,background:T.bgLite,borderRadius:3,overflow:"hidden"}}><div style={{height:"100%",width:`${Math.min(pct,100)}%`,background:c,borderRadius:3,transition:"width .5s"}}/></div></div>;})}
      </Card>
      <Card style={{marginBottom:20}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:14,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>Full Itinerary</div>
        <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch",maxWidth:"100%"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12,minWidth:600}}>
            <thead><tr style={{borderBottom:`1px solid ${T.border}`}}>{["#","Stop","Depart","Time","Drive","Arrive","Depart","Nights","Miles","Fuel","Lodging","Total"].map(h=><th key={h} style={{padding:"5px 8px",textAlign:"left",fontFamily:T.F.cond,fontWeight:600,fontSize:10,color:T.muted,whiteSpace:"nowrap",textTransform:"uppercase"}}>{h}</th>)}</tr></thead>
            <tbody>{trip.stops.map((s,i)=>{const tc2=STCOL[s.type]||T.muted;const isWarn=s.exceedsDaily&&s.active;const dtLabel=s.preferDepartTime||prefs.preferDepartTime||"07:00";const driveInfo=s.mi>0?(s.exceedsDaily?<WarnBadge>{s.daysNeeded}d/{s.mi.toLocaleString()}mi</WarnBadge>:s.fuelRangeWarning?<span style={{color:"#f59e0b",fontSize:11}}>⛽ {fmtDec(s.driveHrsEst,1)}hrs ⚠fuel</span>:<span style={{color:T.green,fontSize:11}}>{fmtDec(s.driveHrsEst,1)}hrs ✓</span>):"-";return<tr key={s.id} style={{borderBottom:`1px solid ${T.bgLite}`,opacity:s.active?1:.45,background:isWarn?T.danger+"12":"transparent"}}><td style={{padding:"7px 8px",color:T.muted}}>{i+1}</td><td style={{padding:"7px 8px",maxWidth:130}}><div style={{fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.name||"(unnamed)"}</div><Badge color={tc2}>{STOP_TYPES.find(t=>t.v===s.type)?.l?.replace(/.*\s/,"")||s.type}</Badge></td><td style={{padding:"7px 8px",whiteSpace:"nowrap"}}>{s.travelDate&&s.mi>0?<><span style={{color:T.accent}}>{s.departDayOfWeek}</span> <span style={{color:T.muted,fontSize:11}}>{fmtDate(s.travelDate)}</span></>:"-"}</td><td style={{padding:"7px 8px",whiteSpace:"nowrap",color:T.muted,fontSize:11}}>{s.mi>0?dtLabel:"-"}</td><td style={{padding:"7px 8px",whiteSpace:"nowrap"}}>{driveInfo}</td><td style={{padding:"7px 8px",color:T.muted,whiteSpace:"nowrap"}}>{fmtDate(s.arr)}</td><td style={{padding:"7px 8px",color:T.muted,whiteSpace:"nowrap"}}>{fmtDate(s.dep)}</td><td style={{padding:"7px 8px",textAlign:"center"}}>{s.nights||"-"}</td><td style={{padding:"7px 8px",textAlign:"center",color:T.muted}}>{s.mi>0?s.mi.toLocaleString():"-"}</td><td style={{padding:"7px 8px",color:s.fc>0?T.blue:T.muted}}>{vehicle.rvType==="🥾 Hike / Walk"?(s.mi>0?`~${Math.floor(s.hikeHrs||0)}h ${Math.round(((s.hikeHrs||0)%1)*60)}m`:"-"):(s.fc>0?fmt$(s.fc):s.mi>0?("~"+fmt$(s.mi/Math.max(parseFloat(vehicle.mpg)||8,1)*parseFloat(fuel.avgPricePerGallon||3.30))):"-")}</td><td style={{padding:"7px 8px",color:s.isFree?T.free:T.text}}>{s.isFree?"FREE":s.lc>0?fmt$(s.lc):"-"}</td><td style={{padding:"7px 8px",fontWeight:600,color:T.accent}}>{s.fc+s.lc>0?fmt$(s.fc+s.lc):"-"}</td></tr>;})}
            <tr style={{borderTop:`2px solid ${T.accent}`,background:T.bgLite}}><td colSpan={7} style={{padding:"7px 8px",fontFamily:T.F.cond,fontWeight:700,textTransform:"uppercase",color:T.accent,fontSize:12}}>TOTALS</td><td style={{padding:"7px 8px",textAlign:"center",fontWeight:700}}>{trip.totNights}</td><td style={{padding:"7px 8px",textAlign:"center",fontWeight:700}}>{trip.totMi.toLocaleString()}</td><td style={{padding:"7px 8px",fontWeight:700,color:T.blue}}>{fmt$(trip.totFuel)}</td><td style={{padding:"7px 8px",fontWeight:700}}>{fmt$(trip.totLodge)}</td><td style={{padding:"7px 8px",fontWeight:700,color:T.accent}}>{fmt$(trip.totFuel+trip.totLodge)}</td></tr>
            </tbody>
          </table>
        </div>
      </Card>
      {tips.length>0&&<Card accent={T.free}><div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:14,letterSpacing:1,textTransform:"uppercase",color:T.free,marginBottom:12}}>💡 Savings Tips</div>{tips.map((t,i)=><div key={i} style={{display:"flex",gap:10,marginBottom:8,fontSize:13}}><span style={{color:T.free,flexShrink:0}}>→</span><span style={{color:T.muted}}>{t}</span></div>)}</Card>}
    </>}
  </div>;
}

// ── Quick Links ────────────────────────────────────────────────────
function QuickLinksSection({data,onChange,onOpenHowTo}){
  const T=useTheme();
  const [newName,setNewName]=useState("");const [newUrl,setNewUrl]=useState("");const [newIcon,setNewIcon]=useState("🔗");const [newCat,setNewCat]=useState("Other");
  const add=()=>{if(!newName||!newUrl)return;const url=newUrl.startsWith("http")?newUrl:"https://"+newUrl;onChange([...data,{id:uid(),name:newName,url,icon:newIcon,category:newCat}]);setNewName("");setNewUrl("");setNewIcon("🔗");setNewCat("Other");};
  const remove=id=>onChange(data.filter(l=>l.id!==id));
  const cats=[...new Set(data.map(l=>l.category))].filter(Boolean);
  return<div className="anim">
    <SecHead icon="🔗" title="Quick Links" sub="One-tap access to your favorite RV apps. Add your own below."/>
    <QuickTipBar tabId="quicklinks" onOpenHowTo={onOpenHowTo}/>
    {cats.map(cat=><div key={cat} style={{marginBottom:20}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:10}}>{cat}</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(155px,1fr))",gap:10}}>
        {data.filter(l=>l.category===cat).map(l=><div key={l.id} style={{background:T.bgMid,border:`1px solid ${T.border}`,borderRadius:8,overflow:"hidden"}}>
          <a href={l.url} target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",textDecoration:"none",color:T.text}}><span style={{fontSize:22}}>{l.icon}</span><span style={{fontFamily:T.F.cond,fontWeight:600,fontSize:14}}>{l.name}</span></a>
          <div style={{padding:"0 8px 8px",textAlign:"right"}}><button onClick={()=>remove(l.id)} style={{background:"none",border:"none",color:T.danger,cursor:"pointer",fontSize:11}}>remove</button></div>
        </div>)}
      </div>
    </div>)}
    <Card accent={T.accent} style={{marginTop:8}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>+ Add Custom Link</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10,marginBottom:10}}>
        <div><Label>Name</Label><Inp value={newName} onChange={e=>setNewName(e.target.value)} placeholder="App or site name"/></div>
        <div><Label>URL</Label><Inp value={newUrl} onChange={e=>setNewUrl(e.target.value)} placeholder="www.example.com"/></div>
        <div><Label>Icon (emoji)</Label><Inp value={newIcon} onChange={e=>setNewIcon(e.target.value)} placeholder="🔗" style={{fontSize:20}}/></div>
        <div><Label>Category</Label><Inp value={newCat} onChange={e=>setNewCat(e.target.value)} placeholder="e.g. Camping"/></div>
      </div>
      <Btn onClick={add} disabled={!newName||!newUrl}>+ Add Link</Btn>
    </Card>
  </div>;
}

// ── Export/Import ──────────────────────────────────────────────────
function ExportImport({allData,onImport,user,onSyncNow,onPullCloud,onOpenHowTo}){
  const T=useTheme();
  const [importError,setImportError]=useState("");const [importSuccess,setImportSuccess]=useState(false);const fileRef=useRef();
  const [syncing,setSyncing]=useState(false);
  const doSyncNow=async()=>{setSyncing(true);await onSyncNow?.();setSyncing(false);};
  const doPullCloud=async()=>{await onPullCloud?.();};
  const doExport=()=>{const blob=new Blob([JSON.stringify({...allData,finance:{...allData.finance,monthlyTakeHome:""},exportedAt:new Date().toISOString()},null,2)],{type:"application/json"});const url=URL.createObjectURL(blob);const a=document.createElement("a");a.href=url;a.download=`rv-trip-${new Date().toISOString().slice(0,10)}.json`;a.click();URL.revokeObjectURL(url);};
  const doImport=e=>{const file=e.target.files[0];if(!file)return;setImportError("");setImportSuccess(false);const reader=new FileReader();reader.onload=ev=>{try{const d=JSON.parse(ev.target.result);if(!d.vehicle||!d.stops)throw new Error("Invalid file.");onImport(d);setImportSuccess(true);setTimeout(()=>setImportSuccess(false),3000);}catch(err){setImportError(err.message);}};reader.readAsText(file);e.target.value="";};
  return<div className="anim">
    <SecHead icon="💾" title="Export & Import Trip" sub="Save as a file for any device. Income never included."/>
    <QuickTipBar tabId="exportimport" onOpenHowTo={onOpenHowTo}/>
        {/* Cloud Sync Section */}
    {user&&<Card accent={T.blue} style={{marginBottom:16,padding:20}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:T.blue,marginBottom:4}}>☁️ Cloud Sync</div>
      <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.6}}>Your trip is automatically synced to the cloud every few seconds when you are signed in. Use these buttons to manually sync or pull the latest version from another device.</div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        <Btn onClick={doSyncNow} disabled={syncing} style={{background:T.blue,color:"#fff",border:"none"}}>
          {syncing?"⏳ Syncing...":"☁️ Push to Cloud"}
        </Btn>
        <Btn onClick={doPullCloud} variant="ghost">
          📥 Pull from Cloud
        </Btn>
      </div>
      <div style={{marginTop:10,fontSize:11,color:T.muted}}>Signed in as: <strong style={{color:T.text}}>{user.email}</strong> · Trip syncs across all devices automatically</div>
    </Card>}
    {!user&&<Card style={{marginBottom:16,padding:16,background:T.bgLite,border:`1px dashed ${T.border}`}}>
      <div style={{fontSize:12,color:T.muted}}>☁️ <strong>Cloud sync</strong> - Sign in to automatically sync your trip across all devices (web + phone app).</div>
    </Card>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16}}>
      <Card accent={T.blue}><div style={{fontSize:32,marginBottom:10}}>📤</div><div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:18,color:T.accent,marginBottom:8}}>Export Your Trip</div><div style={{fontSize:13,color:T.muted,marginBottom:8,lineHeight:1.6}}>Downloads all stops and settings as a .json file.</div><div style={{fontSize:12,color:T.free,marginBottom:16}}>🔒 Income never included</div><Btn variant="success" onClick={doExport} style={{width:"100%",justifyContent:"center"}}>⬇ Download Trip File</Btn></Card>
      <Card accent={T.green}><div style={{fontSize:32,marginBottom:10}}>📥</div><div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:18,color:T.accent,marginBottom:8}}>Import a Trip</div><div style={{fontSize:13,color:T.muted,marginBottom:16,lineHeight:1.6}}>Load a previously saved file. <strong style={{color:T.danger}}>Replaces all current data.</strong></div><input ref={fileRef} name="json-import" id="json-import" type="file" accept=".json" onChange={doImport} style={{display:"none"}}/><Btn variant="ghost" onClick={()=>fileRef.current.click()} style={{width:"100%",justifyContent:"center"}}>📂 Choose Trip File</Btn>{importSuccess&&<div style={{marginTop:10,color:T.free,fontSize:13,fontWeight:600}}>✓ Trip loaded!</div>}{importError&&<div style={{marginTop:10,color:T.danger,fontSize:12}}>{importError}</div>}</Card>
    </div>
  </div>;
}

// ── Settings Section ───────────────────────────────────────────────
function SettingsSection({data,onChange,onOpenHowTo,user}){
  const T=useTheme();const f=(k,v)=>onChange({...data,[k]:v});
  return<div className="anim">
    <SecHead icon="⚙️" title="Settings" sub="Customize the look and feel of your RV Travel Mate."/>
    <QuickTipBar tabId="settings" onOpenHowTo={onOpenHowTo}/>
    <Card style={{marginBottom:16}} accent={T.accent}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>🎨 Theme</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10}}>
        {Object.entries(THEMES).map(([key,theme])=><button key={key} onClick={()=>f("themeKey",key)} style={{padding:"14px 12px",borderRadius:10,border:`2px solid ${data.themeKey===key?theme.accent:theme.border}`,background:theme.bgMid,cursor:"pointer",textAlign:"left",transition:"all .2s"}}>
          <div style={{width:32,height:32,borderRadius:8,background:theme.accent,marginBottom:8}}/>
          <div style={{fontFamily:theme.font==="Barlow"?"'Barlow Condensed',sans-serif":`'${theme.font}',sans-serif`,fontWeight:700,fontSize:13,color:theme.text,marginBottom:2}}>{theme.name}</div>
          <div style={{display:"flex",gap:4,marginTop:4}}>{[theme.accent,theme.green,theme.blue,theme.danger].map((c,i)=><div key={i} style={{width:12,height:12,borderRadius:"50%",background:c}}/> )}</div>
          {data.themeKey===key&&<div style={{marginTop:6,fontSize:10,color:theme.accent,fontWeight:700}}>✓ ACTIVE</div>}
        </button>)}
      </div>
    </Card>
    <Card style={{marginBottom:16}} accent={T.border}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>🔤 Font Style</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
        {Object.entries(FONTS).map(([key,font])=><button key={key} onClick={()=>f("fontKey",key)} style={{padding:"14px 16px",borderRadius:10,border:`2px solid ${data.fontKey===key?T.accent:T.border}`,background:T.bgLite,cursor:"pointer",textAlign:"left",transition:"all .2s"}}>
          <div style={{fontFamily:font.body,fontSize:16,fontWeight:600,color:T.text,marginBottom:4}}>Aa - {font.name.split(" - ")[1]}</div>
          <div style={{fontFamily:font.body,fontSize:12,color:T.muted}}>{font.name.split(" - ")[0]}</div>
          {data.fontKey===key&&<div style={{marginTop:6,fontSize:10,color:T.accent,fontWeight:700}}>✓ ACTIVE</div>}
        </button>)}
      </div>
    </Card>
    <Card style={{marginBottom:16}} accent={T.border}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:6}}>🔠 Text Size</div>
      <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.5}}>If the text feels too small, increase it here. Takes effect immediately across the whole app.</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
        {[
          {key:"normal", label:"Normal", sample:"Aa", desc:"Default size"},
          {key:"large",  label:"Large",  sample:"Aa", desc:"Easier to read"},
          {key:"xlarge", label:"Largest",sample:"Aa", desc:"Maximum size"},
        ].map(opt=>{
          const active=(data.fontScale||"normal")===opt.key;
          return(
            <button key={opt.key} onClick={()=>f("fontScale",opt.key)}
              style={{padding:"14px 10px",borderRadius:10,border:"2px solid "+(active?T.accent:T.border),background:active?T.accent+"18":T.bgLite,cursor:"pointer",textAlign:"center",transition:"all .15s"}}>
              <div style={{fontFamily:T.F.body,fontWeight:700,color:active?T.accent:T.text,marginBottom:4,
                fontSize:opt.key==="normal"?"18px":opt.key==="large"?"22px":"26px"}}>{opt.sample}</div>
              <div style={{fontSize:13,fontWeight:700,color:active?T.accent:T.text}}>{opt.label}</div>
              <div style={{fontSize:11,color:T.muted,marginTop:2}}>{opt.desc}</div>
              {active&&<div style={{marginTop:6,fontSize:10,color:T.accent,fontWeight:700}}>✓ ACTIVE</div>}
            </button>
          );
        })}
      </div>
    </Card>
    <Card accent={T.border}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:14}}>⚡ Display Options</div>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Tog value={data.compactMode||false} onChange={v=>f("compactMode",v)} label="Compact Mode - tighter spacing for mobile/small screens"/>
        <Tog value={data.tipsEnabled!==false} onChange={v=>f("tipsEnabled",v)} label="💡 Show Tips on Startup - displays a rotating tip each time the app loads"/>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8,padding:"10px 14px",background:T.bgLite,borderRadius:8,border:"1px solid "+T.border}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:T.text}}>🔄 Reset Page Tips</div>
            <div style={{fontSize:11,color:T.muted,marginTop:2}}>Show the "What is this page?" tip again on every tab — useful if you want a refresher.</div>
          </div>
<button onClick={()=>{try{localStorage.removeItem("rv-page-tips-seen");}catch{}alert("Page tips have been reset! They will show again as you visit each tab.");}} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0,minHeight:40}}>Reset Tips</button>
          <button onClick={()=>{try{localStorage.removeItem("rv-welcome-seen");}catch{}window.location.reload();}} style={{background:T.accentAlt||T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0,minHeight:40}}>👋 Welcome Tour</button>
        </div>
        <Tog value={data.financeFullMode||false} onChange={v=>f("financeFullMode",v)} label="💰 Finances - Full Mode (income + expenses). Off = expense tracking only."/>
      </div>
    </Card>

    {user&&<Card accent={T.blue} style={{marginTop:16}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:12}}>🔑 Change Password</div>
      <ChangePasswordCard/>
    </Card>}
    <Card accent={T.accentAlt} style={{marginTop:16}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:6}}>⛽ Fuel Price Apps</div>
      <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.5}}>Choose which fuel price apps appear on fuel stop cards and the map popup. Tap a fuel stop pin on the map to see quick links to compare prices.</div>
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {[
          {key:"gasbuddy",  label:"GasBuddy",         desc:"Most popular free fuel price app",              icon:"⛽"},
          {key:"upside",    label:"GetUpside",         desc:"Earn cashback on fuel purchases",               icon:"💰"},
          {key:"mudflap",   label:"Mudflap",           desc:"Discounted diesel for RVs & trucks",            icon:"🚛"},
          {key:"truckerpath",label:"Trucker Path",     desc:"Trucker-focused fuel finder with DEF & scales", icon:"🛣"},
          {key:"routefuel", label:"RouteFuel",         desc:"Lock in fuel prices before you drive",          icon:"🔒"},
          {key:"waze",      label:"Waze",              desc:"GPS + nearby gas prices integrated",            icon:"🗺"},
          {key:"colonialcoin",label:"Colonial Coin",   desc:"Member fuel discounts at Flying J / Pilot",    icon:"🏅"},
        ].map(app=>{
          const enabled=(data.fuelApps||{})[app.key]!==false&&(data.fuelApps||{})[app.key]!==undefined?(data.fuelApps||{})[app.key]:false;
          return(
            <div key={app.key} onClick={()=>{const cur=(data.fuelApps||{});f("fuelApps",{...cur,[app.key]:!enabled});}}
              style={{display:"flex",gap:12,alignItems:"center",padding:"10px 12px",background:enabled?T.accent+"18":T.bgLite,border:"1px solid "+(enabled?T.accent+"55":T.border),borderRadius:10,cursor:"pointer",transition:"all .15s"}}>
              <span style={{fontSize:22,flexShrink:0}}>{app.icon}</span>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:700,color:enabled?T.accent:T.text}}>{app.label}</div>
                <div style={{fontSize:11,color:T.muted,marginTop:1}}>{app.desc}</div>
              </div>
              <div style={{width:22,height:22,borderRadius:"50%",border:"2px solid "+(enabled?T.accent:T.border),background:enabled?T.accent:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {enabled&&<span style={{fontSize:12,color:"#fff",fontWeight:900}}>✓</span>}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
    <Card accent={T.danger} style={{marginTop:16}}>
      <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:8}}>🔧 Data & Storage</div>
      <div style={{fontSize:13,color:T.muted,marginBottom:12,lineHeight:1.6}}>Reset your save preference to see the consent prompt again. Use this if you want to change whether your trip data is saved in this browser.</div>
      <Btn variant="ghost" style={{color:T.danger,borderColor:T.danger+"66",fontSize:12}} onClick={()=>{try{localStorage.removeItem("rv-save-consent");localStorage.removeItem("rv-trip-planner-v3");}catch{}window.location.reload();}}>🔄 Reset Save Preference & Reload</Btn>
    </Card>
  </div>;
}


// ── Weather Section ────────────────────────────────────────────────
// Uses Open-Meteo (free, no API key needed) + Nominatim geocoding
function WeatherSection({stops,onOpenHowTo}){
  const T=useTheme();
  const [forecasts,setForecasts]=useState({});
  const [loading,setLoading]=useState({});
  const [error,setError]=useState({});
  // Exclude the default home label - only geocode if home has a real city name set
  const namedStops=stops.filter(s=>s.active&&s.name&&s.name!=="Home / Departure");

  const WX_CODES={0:"☀️ Clear",1:"🌤 Mostly Clear",2:"⛅ Partly Cloudy",3:"☁️ Overcast",
    45:"🌫 Foggy",48:"🌫 Icy Fog",51:"🌦 Light Drizzle",53:"🌦 Drizzle",55:"🌧 Heavy Drizzle",
    61:"🌧 Light Rain",63:"🌧 Rain",65:"🌧 Heavy Rain",71:"🌨 Light Snow",73:"🌨 Snow",75:"❄️ Heavy Snow",
    77:"🌨 Snow Grains",80:"🌦 Light Showers",81:"🌧 Showers",82:"⛈ Heavy Showers",
    85:"🌨 Snow Showers",86:"❄️ Heavy Snow Showers",95:"⛈ Thunderstorm",96:"⛈ Hail Storm",99:"⛈ Heavy Hail Storm"};

  const fetchForecast=async(stop)=>{
    if(forecasts[stop.id]||loading[stop.id]) return;
    setLoading(prev=>({...prev,[stop.id]:true}));
    setError(prev=>({...prev,[stop.id]:null}));
    try{
      const geoQT=stop.address?(stop.address+(stop.state?", "+stop.state:"")+", USA"):(stop.name+(stop.state?", "+stop.state:"")+", USA");
      const geo=await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(geoQT)}&format=json&limit=1&countrycodes=us`,{headers:{"Accept-Language":"en"}}).then(r=>r.json());
      if(!geo||!geo.length) throw new Error("Location not found");
      const lat=parseFloat(geo[0].lat),lon=parseFloat(geo[0].lon);
      const wx=await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&daily=weathercode,temperature_2m_max,temperature_2m_min,precipitation_probability_max,windspeed_10m_max&temperature_unit=fahrenheit&windspeed_unit=mph&timezone=auto&forecast_days=14`).then(r=>r.json());
      if(!wx?.daily) throw new Error("Weather data unavailable");
      setForecasts(prev=>({...prev,[stop.id]:{lat,lon,days:wx.daily.time.map((date,i)=>({
        date,
        high:Math.round(parseFloat(wx.daily.temperature_2m_max[i])),
        low:Math.round(parseFloat(wx.daily.temperature_2m_min[i])),
        precip:Math.round(parseFloat(wx.daily.precipitation_probability_max[i])||0),
        wind:Math.round(parseFloat(wx.daily.windspeed_10m_max[i])||0),
        code:parseInt(wx.daily.weathercode[i])||0,
      }))}}));
    }catch(e){setError(prev=>({...prev,[stop.id]:e.message}));}
    setLoading(prev=>({...prev,[stop.id]:false}));
  };

  const getDayOfWeek=(dateStr)=>{const d=new Date(dateStr+"T00:00:00");return["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][d.getDay()];};
  const getMonth=(dateStr)=>{const d=new Date(dateStr+"T00:00:00");return["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][d.getMonth()];};
  const getDay=(dateStr)=>new Date(dateStr+"T00:00:00").getDate();

  const tempColor=(hi)=>hi>=95?"#ef4444":hi>=85?"#f97316":hi>=70?"#f5c518":hi>=55?"#4ade80":hi>=40?"#38bdf8":"#818cf8";
  const precipColor=(p)=>p>=70?"#ef4444":p>=40?"#f97316":p>=20?"#f5c518":"#4ade80";

  return<div className="anim">
    <SecHead icon="🌤" title="Weather Forecast" sub="14-day forecast per stop. Your planned stay dates are highlighted - yellow = arrive, blue = staying, red = depart. Powered by Open-Meteo."/>
    <QuickTipBar tabId="weather" onOpenHowTo={onOpenHowTo}/>
    {namedStops.length===0?<Card style={{padding:"32px 24px",textAlign:"center"}}>
      <div style={{fontSize:48,marginBottom:12}}>🌤</div>
      <div style={{fontFamily:T.F.head,fontSize:20,color:T.muted,marginBottom:8}}>Add stops to see weather forecasts</div>
      <div style={{fontSize:13,color:T.muted,lineHeight:1.7}}>Once you add named stops in <strong>Trip → Stops</strong>, the 14-day forecast for each stop's arrival date will appear here automatically.</div>
    </Card>:
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      {namedStops.map(stop=>{
        const wx=forecasts[stop.id];
        const isLoading=loading[stop.id];
        const err=error[stop.id];
        return<Card key={stop.id} accent={wx?T.blue:T.border}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10,marginBottom:wx?16:0}}>
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:18,color:T.text}}>{stop.name}</div>
              <div style={{fontSize:12,color:T.muted,marginTop:2}}>{STOP_TYPES.find(t=>t.v===stop.type)?.l||stop.type} · {stop.minNights||0} nights</div>
            </div>
            {!wx&&<Btn onClick={()=>fetchForecast(stop)} variant="ghost" style={{fontSize:13}} disabled={isLoading}>
              {isLoading?"⏳ Loading...":"🌤 Load Forecast"}
            </Btn>}
            {!wx&&stop.arriveDate&&!isLoading&&<div style={{fontSize:11,color:T.accent,marginTop:4}}>📅 Has dates - load to see stay highlights</div>}
            {wx&&<div style={{fontSize:11,color:T.muted}}>14-day forecast · Open-Meteo</div>}
          </div>
          {err&&<div style={{color:T.danger,fontSize:13,marginTop:8,wordBreak:"break-word"}}>⚠ {err} - check the stop name is a recognizable city.</div>}
          {wx&&<div style={{overflowX:"auto"}}>
            <div style={{display:"flex",gap:6,minWidth:"max-content"}}>
              {wx.days.map((day,i)=>{
                const cond=WX_CODES[day.code]||"🌡 Unknown";
                const emoji=cond.split(" ")[0];
                const desc=cond.split(" ").slice(1).join(" ");
                // Highlight days within the planned stay
                const isArriveDay=stop.arriveDate&&day.date===stop.arriveDate;
                const isDepartDay=stop.departDate&&day.date===stop.departDate;
                const isStayDay=stop.arriveDate&&stop.departDate&&day.date>=stop.arriveDate&&day.date<=stop.departDate;
                const dayBg=isArriveDay?"#f5c51833":isStayDay?T.accent+"15":isDepartDay?"#ef444415":T.bgLite;
                const dayBorder=isArriveDay?"#f5c518":isStayDay?T.accent+"44":isDepartDay?"#ef444444":T.border;
                return<div key={i} style={{background:dayBg,borderRadius:8,padding:"10px 8px",minWidth:72,textAlign:"center",border:`1px solid ${dayBorder}`,position:"relative"}}>
                  {isArriveDay&&<div style={{position:"absolute",top:-8,left:"50%",transform:"translateX(-50%)",background:"#f5c518",color:"#000",fontSize:8,fontWeight:700,padding:"1px 5px",borderRadius:4,whiteSpace:"nowrap"}}>ARRIVE</div>}
                  {isDepartDay&&<div style={{position:"absolute",top:-8,left:"50%",transform:"translateX(-50%)",background:"#ef4444",color:"#fff",fontSize:8,fontWeight:700,padding:"1px 5px",borderRadius:4,whiteSpace:"nowrap"}}>DEPART</div>}
                  <div style={{fontSize:10,color:T.muted,fontWeight:600,textTransform:"uppercase"}}>{getDayOfWeek(day.date)}</div>
                  <div style={{fontSize:10,color:T.border,marginBottom:6}}>{getMonth(day.date)} {getDay(day.date)}</div>
                  <div style={{fontSize:22,marginBottom:4}}>{emoji}</div>
                  <div style={{fontSize:9,color:T.muted,marginBottom:6,lineHeight:1.3,height:24,overflow:"hidden"}}>{desc}</div>
                  <div style={{fontWeight:700,fontSize:13,color:tempColor(day.high)}}>{day.high}°</div>
                  <div style={{fontSize:11,color:T.muted,marginBottom:4}}>{day.low}°</div>
                  <div style={{fontSize:10,borderTop:`1px solid ${T.border}`,paddingTop:4,marginTop:2}}>
                    <div style={{color:precipColor(day.precip)}}>💧{day.precip}%</div>
                    <div style={{color:T.muted}}>💨{day.wind}mph</div>
                  </div>
                </div>;
              })}
            </div>
            <div style={{display:"flex",gap:16,flexWrap:"wrap",marginTop:10,fontSize:11,color:T.muted}}>
              <span>🌡 Temp colors: <span style={{color:"#ef4444"}}>95°+</span> <span style={{color:"#f97316"}}>85°+</span> <span style={{color:"#f5c518"}}>70°+</span> <span style={{color:"#4ade80"}}>55°+</span> <span style={{color:"#38bdf8"}}>&lt;55°</span></span>
              <span>💧 Rain: <span style={{color:"#ef4444"}}>70%+</span> <span style={{color:"#f97316"}}>40%+</span> <span style={{color:"#f5c518"}}>20%+</span> <span style={{color:"#4ade80"}}>&lt;20%</span></span>
            </div>
          </div>}
        </Card>;
      })}
    </div>}
    <Card style={{marginTop:16,padding:14}} accent={T.border}>
      <div style={{fontSize:12,color:T.muted,lineHeight:1.8}}>
        <strong style={{color:T.text}}>ℹ About Weather Forecasts: </strong>
        Forecasts are reliable for about 7 days ahead - beyond that use as a general guide only. Data from <strong style={{color:T.text}}>Open-Meteo</strong> (free, no account needed, updated hourly). Temperature in °F. Precipitation shows % chance of rain/snow.
      </div>
    </Card>
  </div>;
}

// ── Print Section ──────────────────────────────────────────────────
function PrintSection({trip,stops,vehicle,prefs,finance,memberships,onOpenHowTo,mapSnapshot,setMapSnapshot,rvMaintenance,finances,campgroundJournal=[]}){
  const T=useTheme();
  const hasData=trip.stops.some(s=>s.mi>0||s.nights>0);
  const [inclMap,setInclMap]=useState(true);
  const [inclDirections,setInclDirections]=useState(true);
  const [mapScope,setMapScope]=useState("full"); // "full" or leg index "0","1" etc
  const [directions,setDirections]=useState({}); // {legKey: [{instruction,distance}]}
  const [fetchingDirs,setFetchingDirs]=useState(false);
  const [mapImgData,setMapImgData]=useState(null);
  const [capturingMap,setCapturingMap]=useState(false);
  const namedActiveStops=stops.filter(s=>s.active&&(s.name||s.address));

  const freeNights=trip.stops.filter(s=>s.active&&s.isFree).reduce((a,s)=>a+s.nights,0);
  const tips=[];
  if(!memberships.goodSam&&trip.grand>3000) tips.push("Good Sam ($44/yr) saves 10-15% at thousands of parks.");
  if(!memberships.harvestHosts) tips.push("Harvest Hosts ($99/yr): free stays at farms, wineries, breweries.");
  if(freeNights===0&&trip.totNights>14) tips.push("No free camping nights. Even 4-5 Walmart nights saves $180-225/month.");

  // Capture map snapshot - hides layer groups temporarily
  const captureMap=async()=>{
    // Use pre-captured snapshot if available
    if(mapSnapshot) return mapSnapshot;
    setCapturingMap(true);
    try{
      // Geocode all active named stops to get lat/lon
      const stopsToMap=mapScope==="full"
        ?namedActiveStops
        :namedActiveStops.slice(parseInt(mapScope),parseInt(mapScope)+2);
      const geocoded=[];
      for(const s of stopsToMap){
        // Use stored coords first — set by the live map after rendering
        const storedLat=parseFloat(s.lat);
        const storedLon=parseFloat(s.lon);
        if(s.lat&&s.lon&&!isNaN(storedLat)&&storedLat!==0&&storedLon!==0){
          geocoded.push({s,lat:storedLat,lon:storedLon});
          continue;
        }
        // Fall back to geocoding
        const r=await geocodeStop(s);
        if(r) geocoded.push({s,lat:r[0],lon:r[1]});
        else if(s.state){
          // Last resort: state center
          const rc=await geocodePlace(s.state+", USA");
          if(rc) geocoded.push({s,lat:rc[0],lon:rc[1]});
        }
        await new Promise(res=>setTimeout(res,200));
      }
      if(geocoded.length<1){setCapturingMap(false);return null;}
      // Build staticmap URL using geoapify (free, no key needed for basic use,
      // allows browser CORS, renders proper map tiles with numbered markers)
      const W=900,H=500;
      // Calculate bounding box with padding
      const lats=geocoded.map(g=>g.lat);
      const lons=geocoded.map(g=>g.lon);
      const minLat=Math.min(...lats),maxLat=Math.max(...lats);
      const minLon=Math.min(...lons),maxLon=Math.max(...lons);
      const padLat=(maxLat-minLat)*0.2||0.5;
      const padLon=(maxLon-minLon)*0.2||0.5;
      // Use OpenStreetMap static map tile approach via a canvas-based render
      // Build an img tag URL using staticmap.openstreetmap.de
      const markerParams=geocoded.map((g,i)=>{
        const isFuel=g.s.subtype==="fuel_stop"||g.s.fuelStop;
        const color=isFuel?"orange":"blue";
        const label=isFuel?"G":String(i+1);
        return `markers=color:${color}|label:${label}|${g.lat},${g.lon}`;
      }).join("&");
      const pathCoords=geocoded.map(g=>`${g.lat},${g.lon}`).join("|");
      // Use Maps.co static map API (free, no key, CORS-friendly)
      const staticUrl=`https://maps.geoapify.com/v1/staticmap?style=osm-bright&width=${W}&height=${H}&`+
        `area=rect:${minLon-padLon},${minLat-padLat},${maxLon+padLon},${maxLat+padLat}&`+
        geocoded.map((g,i)=>{
          const isFuel=g.s.subtype==="fuel_stop"||g.s.fuelStop;
          const color=isFuel?"ffaa00":"1d6ed8";
          const label=isFuel?"G":String(i+1);
          return `marker=lonlat:${g.lon},${g.lat};type:awesome;color:%23${color};text:${label}`;
        }).join("&")+
        `&geometry=polyline:${geocoded.map(g=>`[${g.lon},${g.lat}]`).join(",")};linecolor:%231d6ed8;linewidth:3`+
        `&apiKey=YOUR_GEOAPIFY_KEY`;
      // Fallback: build a simple HTML map preview instead
      // since Geoapify requires a key. Use a data URI with OSM tiles rendered inline.
      // Best no-key option: openstreetmap static image via overpass/OSM services
      // Actually use the simplest approach: encode coords into an SVG map placeholder
      // that shows stop markers in roughly correct relative positions
      const svgMap=buildSVGRouteMap(geocoded,W,H);
      setCapturingMap(false);
      return svgMap;
    }catch(e){console.warn("Map capture failed:",e);setCapturingMap(false);return null;}
  };

  // Build an SVG map showing stop positions in correct relative lat/lon positions
  const buildSVGRouteMap=(geocoded,W,H)=>{
    if(!geocoded.length) return null;
    const lats=geocoded.map(g=>g.lat);
    const lons=geocoded.map(g=>g.lon);
    const minLat=Math.min(...lats),maxLat=Math.max(...lats);
    const minLon=Math.min(...lons),maxLon=Math.max(...lons);
    const padLat=(maxLat-minLat)*0.15||0.3;
    const padLon=(maxLon-minLon)*0.15||0.3;
    const bLat=minLat-padLat,tLat=maxLat+padLat;
    const bLon=minLon-padLon,tLon=maxLon+padLon;
    // Project lat/lon to SVG x/y (mercator approximation)
    const px=(lon)=>Math.round(((lon-bLon)/(tLon-bLon))*W);
    const py=(lat)=>Math.round(((tLat-lat)/(tLat-bLat))*H);
    const points=geocoded.map(g=>({x:px(g.lon),y:py(g.lat),s:g.s}));
    // Build polyline path
    const polyline=points.map((p,i)=>(i===0?"M":"L")+p.x+","+p.y).join(" ");
    // Build SVG
    const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" style="background:#e8f4f8;font-family:Arial,sans-serif">
      <!-- Grid lines for visual reference -->
      <rect width="${W}" height="${H}" fill="#dde8f0" rx="0"/>
      ${Array.from({length:8},(_,i)=>`<line x1="${Math.round(W*i/7)}" y1="0" x2="${Math.round(W*i/7)}" y2="${H}" stroke="#c8d8e8" stroke-width="0.5"/>`).join("")}
      ${Array.from({length:6},(_,i)=>`<line x1="0" y1="${Math.round(H*i/5)}" x2="${W}" y2="${Math.round(H*i/5)}" stroke="#c8d8e8" stroke-width="0.5"/>`).join("")}
      <!-- Route line -->
      <path d="${polyline}" fill="none" stroke="#1d6ed8" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="8,4"/>
      <!-- Stop markers -->
      ${points.map((p,i)=>{
        const isFuel=p.s.subtype==="fuel_stop"||p.s.fuelStop;
        const color=isFuel?"#f59e0b":(p.s.type==="home"?"#27ae60":"#1d6ed8");
        const label=isFuel?"⛽":(p.s.type==="home"?"🏠":String(i+1));
        const isText=["⛽","🏠"].includes(label);
        return`<g>
          <circle cx="${p.x}" cy="${p.y}" r="14" fill="${color}" stroke="white" stroke-width="2" filter="url(#shadow)"/>
          <text x="${p.x}" y="${p.y}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${isText?"12":"11"}" font-weight="bold">${label}</text>
          <text x="${p.x}" y="${p.y+24}" text-anchor="middle" fill="#1a1a2e" font-size="9" font-weight="600">${(p.s.name||"").split(",")[0].substring(0,16)}</text>
        </g>`;
      }).join("")}
      <defs>
        <filter id="shadow"><feDropShadow dx="0" dy="1" stdDeviation="2" flood-opacity="0.3"/></filter>
      </defs>
      <!-- Legend -->
      <rect x="8" y="${H-38}" width="280" height="30" rx="4" fill="white" fill-opacity="0.85"/>
      <text x="16" y="${H-18}" fill="#1a1a2e" font-size="9">🗺 RV Travel Mate Route Map · ${geocoded.length} stops · Positions are approximate</text>
    </svg>`;
    return "data:image/svg+xml;base64,"+btoa(unescape(encodeURIComponent(svg)));
  };

  // Fetch turn-by-turn directions for a leg or full route
  const fetchDirections=async()=>{
    if(!inclDirections) return {};
    setFetchingDirs(true);
    const sleep=ms=>new Promise(r=>setTimeout(r,ms));
    const dirs={};
    try{
      const legsToFetch=mapScope==="full"
        ?namedActiveStops.map((_,i)=>i).filter(i=>i<namedActiveStops.length-1)
        :[parseInt(mapScope)].filter(i=>i<namedActiveStops.length-1);
      for(const li of legsToFetch){
        const s1=namedActiveStops[li],s2=namedActiveStops[li+1];
        const q1=s1.address||(s1.name+(s1.state?", "+s1.state:"")+", USA");
        const q2=s2.address||(s2.name+(s2.state?", "+s2.state:"")+", USA");
        if(li>legsToFetch[0]) await sleep(600); // extra delay between legs
        const [g1,g2]=await Promise.all([
          fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q1)}&format=json&limit=1&countrycodes=us`,{headers:{"Accept-Language":"en"}}).then(r=>r.json()).catch(()=>[]),
          fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q2)}&format=json&limit=1&countrycodes=us`,{headers:{"Accept-Language":"en"}}).then(r=>r.json()).catch(()=>[])
        ]);
        if(!g1?.length||!g2?.length) continue;
        const c1=[parseFloat(g1[0].lon),parseFloat(g1[0].lat)];
        const c2=[parseFloat(g2[0].lon),parseFloat(g2[0].lat)];
        await sleep(300);
        // Try RV-safe routing first, fall back to driving-car
        let res=await fetch("https://api.openrouteservice.org/v2/directions/driving-hgv/json",{
          method:"POST",
          headers:{"Content-Type":"application/json","Authorization":ORS_KEY},
          body:JSON.stringify({coordinates:[c1,c2],instructions:true,units:"mi"})
        }).then(r=>r.json()).catch(()=>null);
        if(!res?.routes?.[0]){
          await sleep(300);
          res=await fetch("https://api.openrouteservice.org/v2/directions/driving-car/json",{
            method:"POST",
            headers:{"Content-Type":"application/json","Authorization":ORS_KEY},
            body:JSON.stringify({coordinates:[c1,c2],instructions:true,units:"mi"})
          }).then(r=>r.json()).catch(()=>null);
        }
        const steps=res?.routes?.[0]?.segments?.[0]?.steps||[];
        const totalMi=Math.round((res?.routes?.[0]?.summary?.distance||0)/1609.34);
        dirs[li]={
          from:s1.name,to:s2.name,totalMi,
          steps:steps.map(st=>({
            instruction:st.instruction||"",
            distance:Math.round(st.distance/1609.34*10)/10,
            type:st.type
          })).filter(st=>st.instruction)
        };
      }
    }catch(e){console.warn("Directions fetch failed:",e);}
    setFetchingDirs(false);
    return dirs;
  };

  // ── Print Maintenance Report ──
  const printMaintenance=()=>{
    if(!rvMaintenance||!rvMaintenance.logs) return;
    const win=window.open("","_blank","width=1000,height=800");
    if(!win){alert("Pop-up blocked - allow pop-ups and try again.");return;}
    const currentYear=new Date().getFullYear();
    const sorted=[...rvMaintenance.logs].sort((a,b)=>new Date(b.date)-new Date(a.date));
    const totalCost=rvMaintenance.logs.reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
    const thisYearCost=rvMaintenance.logs.filter(l=>l.date&&new Date(l.date).getFullYear()===currentYear).reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
    const catCosts=rvMaintenance.logs.reduce((a,l)=>{a[l.category]=(a[l.category]||0)+(parseFloat(l.cost)||0);return a;},{});
    const tireYears=rvMaintenance.tireInstallDate?((new Date()-new Date(rvMaintenance.tireInstallDate))/31557600000).toFixed(1):null;
    const html="<!DOCTYPE html><html><head><title>RV Maintenance Report</title><style>"
      +"body{font-family:Arial,sans-serif;margin:0;padding:40px;color:#222;max-width:900px;margin:0 auto;}"
      +"h1{color:#1a1a2e;font-size:28px;margin-bottom:4px;}"
      +"h2{color:#f59e0b;font-size:16px;text-transform:uppercase;letter-spacing:1px;margin:24px 0 12px;border-bottom:2px solid #f59e0b;padding-bottom:4px;}"
      +"table{width:100%;border-collapse:collapse;margin-bottom:20px;font-size:13px;}"
      +"th{background:#1a1a2e;color:#fff;padding:8px 12px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.5px;}"
      +"td{padding:8px 12px;border-bottom:1px solid #eee;}"
      +"tr:nth-child(even){background:#f9f9f9;}"
      +".stat-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-bottom:24px;}"
      +".stat-box{background:#f5f5f5;border-radius:8px;padding:14px;text-align:center;}"
      +".stat-val{font-size:24px;font-weight:800;color:#f59e0b;}"
      +".stat-lbl{font-size:11px;color:#666;text-transform:uppercase;letter-spacing:.5px;margin-top:4px;}"
      +".warn{color:#ef4444;font-weight:700;}"
      +".ok{color:#22c55e;font-weight:700;}"
      +"@media print{button{display:none!important}}"
      +"</style></head><body>"
      +"<div style='display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;'>"
      +"<div><h1>🔧 RV Maintenance Report</h1><p style='color:#666;margin:0'>"+vehicle.rvType+" · Generated "+new Date().toLocaleDateString("en-US",{weekday:"long",year:"numeric",month:"long",day:"numeric"})+"</p></div>"
      +"<button onclick='window.print()' style='background:#f59e0b;color:#fff;border:none;padding:10px 24px;font-size:14px;font-weight:700;border-radius:6px;cursor:pointer'>🖨 Print / Save PDF</button>"
      +"</div>"
      +"<div class='stat-grid'>"
      +"<div class='stat-box'><div class='stat-val'>"+parseInt(rvMaintenance.currentOdometer||0).toLocaleString()+"</div><div class='stat-lbl'>Current Miles</div></div>"
      +"<div class='stat-box'><div class='stat-val'>"+(rvMaintenance.generatorHours||0)+"</div><div class='stat-lbl'>Generator Hours</div></div>"
      +"<div class='stat-box'><div class='stat-val'>$"+Math.round(thisYearCost).toLocaleString()+"</div><div class='stat-lbl'>"+currentYear+" Costs</div></div>"
      +"<div class='stat-box'><div class='stat-val'>$"+Math.round(totalCost).toLocaleString()+"</div><div class='stat-lbl'>Lifetime Costs</div></div>"
      +"</div>"
      +(tireYears?"<p><strong>Tire Age:</strong> "+tireYears+" years (installed "+rvMaintenance.tireInstallDate+") "+(parseFloat(tireYears)>7?"<span class='warn'>⚠ REPLACEMENT DUE</span>":parseFloat(tireYears)>5?"<span class='warn'>⚠ Approaching replacement age</span>":"<span class='ok'>✓ OK</span>")+"</p>":"")
      +"<h2>📋 Service History ("+sorted.length+" records)</h2>"
      +"<table><thead><tr><th>Date</th><th>Service</th><th>Category</th><th>Odometer</th><th>Gen Hrs</th><th>Shop</th><th>Cost</th><th>Notes</th></tr></thead><tbody>"
      +sorted.map(l=>"<tr>"
        +"<td>"+l.date+"</td>"
        +"<td><strong>"+l.serviceName+"</strong></td>"
        +"<td>"+l.category+"</td>"
        +"<td>"+(l.odometer?parseInt(l.odometer).toLocaleString()+" mi":"-")+"</td>"
        +"<td>"+(l.genHours||"-")+"</td>"
        +"<td>"+(l.shop||"-")+"</td>"
        +"<td>"+(l.cost?"$"+parseFloat(l.cost).toFixed(2):"-")+"</td>"
        +"<td>"+(l.notes||"")+"</td>"
        +"</tr>"
      ).join("")
      +"</tbody></table>"
      +"<h2>💰 Cost by Category</h2>"
      +"<table><thead><tr><th>Category</th><th>Total Cost</th><th>Records</th></tr></thead><tbody>"
      +Object.entries(catCosts).sort((a,b)=>b[1]-a[1]).map(([cat,cost])=>{
        const recs=rvMaintenance.logs.filter(l=>l.category===cat).length;
        return "<tr><td>"+cat+"</td><td>$"+Math.round(cost).toLocaleString()+"</td><td>"+recs+"</td></tr>";
      }).join("")
      +"</tbody></table>"
      +((rvMaintenance.fillups||[]).length>0
        ?"<h2>⛽ Fuel Fill-up Log ("+rvMaintenance.fillups.length+" records)</h2>"
        +"<table><thead><tr><th>Date</th><th>Odometer</th><th>Gallons</th><th>Price/Gal</th><th>Total</th><th>Station</th><th>Real MPG</th></tr></thead><tbody>"
        +[...rvMaintenance.fillups].sort((a,b)=>parseFloat(b.odometer)-parseFloat(a.odometer)).map((fu,i,arr)=>{
          const prev=arr[i+1];
          const miles=prev?parseFloat(fu.odometer)-parseFloat(prev.odometer):0;
          const mpg=(miles>0&&parseFloat(fu.gallons)>0)?(miles/parseFloat(fu.gallons)).toFixed(1):null;
          return "<tr><td>"+fu.date+"</td><td>"+parseInt(fu.odometer||0).toLocaleString()+" mi</td><td>"+fu.gallons+" gal</td><td>$"+(parseFloat(fu.pricePerGal||0).toFixed(3))+"</td><td>$"+(parseFloat(fu.totalCost||fu.gallons*fu.pricePerGal||0).toFixed(2))+"</td><td>"+(fu.station||"-")+"</td><td>"+(mpg?"<strong>"+mpg+" MPG</strong>":"-")+"</td></tr>";
        }).join("")
        +"</tbody></table>"
        :"")
      +"</body></html>";
    win.document.write(html);
    win.document.close();
  };

  // ── Print Finances Annual Report ──
  const printFinances=()=>{
    const months=finances?.months||{};
    const now=new Date();
    const yr=now.getFullYear();
    const monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];
    const yearMonths=Array.from({length:12},(_,i)=>{const key=`${yr}-${String(i+1).padStart(2,"0")}`;return{key,month:i,data:months[key]||mkMonth()};});
    const monthTotal=(m)=>EXPENSE_CATS.reduce((a,c)=>a+(m.expenses[c.id]||0),0);
    const annualTotal=yearMonths.reduce((a,m)=>a+monthTotal(m.data),0);
    const catTotals=EXPENSE_CATS.map(c=>({...c,total:yearMonths.reduce((a,m)=>a+(m.data.expenses[c.id]||0),0)})).filter(c=>c.total>0).sort((a,b)=>b.total-a.total);
    const win=window.open("","_blank","width=1000,height=800");
    if(!win){alert("Pop-up blocked - allow pop-ups and try again.");return;}
    const rows=yearMonths.map((m,i)=>{
      const tot=monthTotal(m.data);
      if(tot===0&&!m.data.notes) return "";
      return "<tr><td>"+monthNames[i]+"</td><td><strong>$"+Math.round(tot).toLocaleString()+"</strong></td><td>"+(m.data.expenses.campsite>0?"$"+Math.round(m.data.expenses.campsite):"-")+"</td><td>"+(m.data.expenses.fuel>0?"$"+Math.round(m.data.expenses.fuel):"-")+"</td><td style='color:"+(m.data.expenses.maint_repair>0?"#ef4444":"inherit")+"'>"+(m.data.expenses.maint_repair>0?"$"+Math.round(m.data.expenses.maint_repair):"-")+"</td><td>"+((m.data.expenses.groceries||0)+(m.data.expenses.dining||0)>0?"$"+Math.round((m.data.expenses.groceries||0)+(m.data.expenses.dining||0)):"-")+"</td><td>"+(m.data.nights>0?m.data.nights+"n":"")+"</td><td style='font-size:11px;color:#666'>"+( m.data.notes||"")+"</td></tr>";
    }).join("");
    const html="<!DOCTYPE html><html><head><title>Annual Expense Report "+yr+"</title><style>"
      +"body{font-family:Arial,sans-serif;padding:40px;color:#222;max-width:960px;margin:0 auto;}"
      +"h1{color:#1a1a2e;margin-bottom:4px;}h2{color:#f59e0b;font-size:15px;text-transform:uppercase;letter-spacing:1px;margin:20px 0 10px;border-bottom:2px solid #f59e0b33;padding-bottom:4px;}"
      +"table{width:100%;border-collapse:collapse;font-size:13px;margin-bottom:20px;}"
      +"th{background:#1a1a2e;color:#fff;padding:8px 10px;text-align:left;font-size:11px;text-transform:uppercase;}"
      +"td{padding:7px 10px;border-bottom:1px solid #eee;}"
      +"tr:nth-child(even){background:#f9f9f9;}"
      +".stat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:24px;}"
      +".stat-box{background:#f5f5f5;border-radius:8px;padding:14px;text-align:center;}"
      +".stat-val{font-size:26px;font-weight:800;color:#f59e0b;}"
      +".stat-lbl{font-size:11px;color:#666;text-transform:uppercase;margin-top:4px;}"
      +"@media print{button{display:none!important}}"
      +"</style></head><body>"
      +"<div style='display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:16px;'>"
      +"<div><h1>💰 Annual Expense Report - "+yr+"</h1><p style='color:#666;margin:0'>"+vehicle.rvType+" · Full-timer spending summary</p></div>"
      +"<button onclick='window.print()' style='background:#f59e0b;color:#fff;border:none;padding:10px 20px;font-size:13px;font-weight:700;border-radius:6px;cursor:pointer'>🖨 Print / Save PDF</button>"
      +"</div>"
      +"<div class='stat-grid'>"
      +"<div class='stat-box'><div class='stat-val'>$"+Math.round(annualTotal).toLocaleString()+"</div><div class='stat-lbl'>Annual Total</div></div>"
      +"<div class='stat-box'><div class='stat-val'>$"+Math.round(annualTotal/12).toLocaleString()+"</div><div class='stat-lbl'>Monthly Average</div></div>"
      +"<div class='stat-box'><div class='stat-val'>$"+Math.round(annualTotal/365).toLocaleString()+"</div><div class='stat-lbl'>Daily Average</div></div>"
      +"</div>"
      +"<h2>📅 Month by Month</h2>"
      +"<table><thead><tr><th>Month</th><th>Total</th><th>Campsite</th><th>Fuel</th><th>Repairs</th><th>Food</th><th>Nights</th><th>Notes</th></tr></thead><tbody>"+rows+"</tbody></table>"
      +"<h2>📊 Category Breakdown</h2>"
      +"<table><thead><tr><th>Category</th><th>Annual Total</th><th>Monthly Avg</th><th>% of Total</th></tr></thead><tbody>"
      +catTotals.map(c=>"<tr><td>"+c.icon+" "+c.label+"</td><td>$"+Math.round(c.total).toLocaleString()+"</td><td>$"+Math.round(c.total/12).toLocaleString()+"</td><td>"+(annualTotal>0?(c.total/annualTotal*100).toFixed(1)+"%":"-")+"</td></tr>").join("")
      +"</tbody></table>"
      +"</body></html>";
    win.document.write(html);win.document.close();
  };

  // ── Print Local Favorites ──
  const printLocalFavorites=()=>{
    const favStops=stops.filter(s=>s.localFavorites&&s.localFavorites.length>0);
    if(!favStops.length){alert("No Local Favorites saved yet. Add some from your stop cards.");return;}
    const win=window.open("","_blank","width=800,height=700");
    if(!win){alert("Pop-up blocked.");return;}
    const catLabels={restaurants:"🍽 Restaurants",attractions:"🏛 Attractions",practical:"🛒 Practical",services:"🔧 Services"};
    const stopHtml=favStops.map(stop=>{
      const byCat={};
      (stop.localFavorites||[]).forEach(f=>{if(!byCat[f.cat])byCat[f.cat]=[];byCat[f.cat].push(f);});
      return "<div style='margin-bottom:24px;page-break-inside:avoid;'>"
        +"<h2 style='color:#1a1a2e;font-size:16px;margin-bottom:8px;border-bottom:2px solid #f59e0b;padding-bottom:4px;'>📍 "+stop.name+(stop.state?", "+stop.state:"")+"</h2>"
        +Object.entries(byCat).map(([cat,items])=>"<div style='margin-bottom:10px;'><strong style='font-size:12px;color:#666;text-transform:uppercase;letter-spacing:.5px;'>"+catLabels[cat]+"</strong><ul style='margin:6px 0;padding-left:20px;'>"+items.map(i=>"<li style='margin-bottom:4px;font-size:14px;'>"+i.name+(i.note?" <em style='color:#666;font-size:12px;'>- "+i.note+"</em>":"")+"</li>").join("")+"</ul></div>").join("")
        +"</div>";
    }).join("");
    const html="<!DOCTYPE html><html><head><title>RV Travel Mate - Local Favorites</title><style>"
      +"body{font-family:Arial,sans-serif;padding:40px;color:#222;max-width:700px;margin:0 auto;}"
      +"h1{color:#1a1a2e;margin-bottom:4px;}"
      +"@media print{button{display:none!important}}"
      +"</style></head><body>"
      +"<div style='display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;'>"
      +"<div><h1>⭐ Local Favorites</h1><p style='color:#666;margin:0'>"+favStops.length+" stops with recommendations</p></div>"
      +"<button onclick='window.print()' style='background:#f59e0b;color:#fff;border:none;padding:10px 20px;font-size:13px;font-weight:700;border-radius:6px;cursor:pointer'>🖨 Print / Save PDF</button>"
      +"</div>"
      +stopHtml+"</body></html>";
    win.document.write(html);win.document.close();
  };

  // ── Print Checklist ──
  const printChecklist=()=>{
    const STORE="rv-checklists";
    let lists;
    try{const s=localStorage.getItem(STORE);lists=s?JSON.parse(s):DEFAULT_CHECKLISTS;}catch{lists=DEFAULT_CHECKLISTS;}
    const win=window.open("","_blank","width=800,height=700");
    if(!win){alert("Pop-up blocked - allow pop-ups and try again.");return;}
    const renderList=(title,items)=>{
      return "<h2 style='color:#1a1a2e;font-size:16px;text-transform:uppercase;letter-spacing:1px;margin:24px 0 8px;border-bottom:2px solid #1a1a2e;padding-bottom:4px;'>"+title+"</h2>"
        +"<table style='width:100%;border-collapse:collapse;margin-bottom:16px;'>"
        +items.map((item,i)=>"<tr style='border-bottom:1px solid #eee'><td style='padding:10px 8px;width:32px;text-align:center;'><div style='width:18px;height:18px;border:2px solid #ccc;border-radius:4px;display:inline-block;'></div></td><td style='padding:10px 8px;font-size:14px;color:#333;'>"+item.text+"</td></tr>").join("")
        +"</table>";
    };
    const html="<!DOCTYPE html><html><head><title>RV Travel Mate Checklists</title><style>"
      +"body{font-family:Arial,sans-serif;padding:40px;color:#222;max-width:700px;margin:0 auto;}"
      +"h1{color:#1a1a2e;margin-bottom:4px;}"
      +"@media print{button{display:none!important}}"
      +"</style></head><body>"
      +"<div style='display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;'>"
      +"<h1>✅ RV Travel Mate Checklists</h1>"
      +"<button onclick='window.print()' style='background:#1a1a2e;color:#fff;border:none;padding:10px 20px;font-size:13px;font-weight:700;border-radius:6px;cursor:pointer'>🖨 Print / Save PDF</button>"
      +"</div>"
      +"<p style='color:#666;margin-bottom:24px;'>"+vehicle.rvType+" · "+new Date().toLocaleDateString()+"</p>"
      +renderList("🚪 Pre-Departure Checklist",lists.departure||[])
      +renderList("🏕 Arrival Checklist",lists.arrival||[])
      +renderList("📅 Monthly Maintenance Checklist",lists.monthly||[])
      +"</body></html>";
    win.document.write(html);
    win.document.close();
  };

  const doPrint=()=>{
    const win=window.open("","_blank","width=1100,height=800");
    if(!win){alert("Pop-up blocked - please allow pop-ups for this site and try again.");return;}
    win.document.write("<html><body style='font-family:Arial;padding:40px;text-align:center'><h2>⏳ Preparing your itinerary...</h2><p>Fetching directions and capturing map. This may take a few seconds.</p></body></html>");
    // Now fetch async
    (async()=>{
    const [fetchedDirs,imgData]=await Promise.all([
      inclDirections?fetchDirections():Promise.resolve({}),
      inclMap?captureMap():Promise.resolve(null),
    ]);
    const finalDirs=fetchedDirs||{};
    win.document.open();
    const rows=trip.stops.map((s,i)=>{
      const warn=s.exceedsDaily&&s.active;
      const dtLabel=s.preferDepartTime||prefs.preferDepartTime||"07:00";
      const stopSideTrips=(stops.find(st=>st.id===s.id)?.sideTrips||[]).filter(st=>st.totalMiles>0);
      const notesHtml=s.notes?`<div style="font-size:10px;color:#666;margin-top:3px;font-style:italic">${s.notes}</div>`:"";
      const sideTripsHtml=stopSideTrips.length>0?stopSideTrips.map(st=>`<div style="font-size:10px;color:#b45309;margin-top:2px">🏍 ${st.name||"Side Trip"}: ${st.totalMiles}mi · $${Math.round(st.fuelCost)}</div>`).join(""):"";
      return`<tr style="${warn?"background:#fff3cd":""}">
        <td>${i+1}</td>
        <td><strong>${s.name||"(unnamed)"}</strong><br/><small>${STOP_TYPES.find(t=>t.v===s.type)?.l?.replace(/.*\s/,"")||s.type}</small>${notesHtml}${sideTripsHtml}</td>
        <td>${s.travelDate&&s.mi>0?`${s.departDayOfWeek} ${fmtDate(s.travelDate)}`:"-"}</td>
        <td>${s.mi>0?dtLabel:"-"}</td>
        <td>${s.mi>0?(s.exceedsDaily?`⚠ ${s.daysNeeded} days/${s.mi.toLocaleString()}mi`:`${fmtDec(s.driveHrsEst,1)} hrs`):"-"}</td>
        <td>${fmtDate(s.arr)}</td>
        <td>${fmtDate(s.dep)}</td>
        <td style="text-align:center">${s.nights||"-"}</td>
        <td style="text-align:center">${s.mi>0?s.mi.toLocaleString():"-"}</td>
        <td>${s.fc>0?fmt$(s.fc):"-"}</td>
        <td>${s.isFree?"<span style='color:green;font-weight:700'>FREE</span>":s.lc>0?fmt$(s.lc):"-"}</td>
        <td><strong>${s.fc+s.lc>0?fmt$(s.fc+s.lc):"-"}</strong></td>
      </tr>`;
    }).join("");
    win.document.write(`<!DOCTYPE html><html><head><title>RV Trip Itinerary</title><script src='https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'><\/script><style>
      *{box-sizing:border-box;margin:0;padding:0}
      body{font-family:Arial,sans-serif;color:#111;background:#fff;padding:24px;font-size:12px}
      .header{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:4px solid #f5c518;padding-bottom:12px;margin-bottom:20px}
      .title{font-size:28px;font-weight:900;letter-spacing:3px;color:#1a1a1e}
      .subtitle{font-size:12px;color:#666;margin-top:4px}
      .stats{display:flex;gap:16px;flex-wrap:wrap;margin-bottom:20px;padding:12px;background:#f9f9f9;border-radius:6px}
      .stat{border-left:3px solid #f5c518;padding-left:10px}
      .stat-val{font-size:18px;font-weight:900;color:#1a1a1e}
      .stat-lbl{font-size:9px;text-transform:uppercase;letter-spacing:1px;color:#888}
      .no-print{margin:16px 0;display:flex;gap:10px}
      .btn-print{background:#1d6ed8;color:#fff;border:none;padding:10px 24px;font-size:14px;font-weight:700;border-radius:6px;cursor:pointer;letter-spacing:.5px}
      .btn-close{background:#eee;color:#333;border:none;padding:10px 24px;font-size:14px;font-weight:700;border-radius:6px;cursor:pointer}
      @media print{.no-print{display:none!important}}
      table{width:100%;border-collapse:collapse;margin-bottom:20px;font-size:11px}
      th{background:#1a1a1e;color:#f5c518;padding:6px 8px;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.5px}
      td{padding:6px 8px;border-bottom:1px solid #f0f0f0;vertical-align:top}
      tr:nth-child(even){background:#fafafa}
      .tfoot td{background:#f5f5f5;font-weight:700;border-top:2px solid #f5c518}
      .breakdown{display:grid;grid-template-columns:1fr 1fr;gap:20px;margin-bottom:20px}
      .section-title{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#666;margin-bottom:8px;padding-bottom:4px;border-bottom:2px solid #f5c518}
      .breakdown-row{display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px solid #f0f0f0;font-size:11px}
      .tips{padding:12px;background:#f0fff4;border:1px solid #27ae60;border-left:4px solid #27ae60;border-radius:4px;margin-bottom:20px}
      .tip{font-size:11px;color:#2d6a4f;padding:3px 0}
      .footer{display:flex;justify-content:space-between;padding-top:12px;border-top:2px solid #eee;font-size:10px;color:#aaa;margin-top:8px}
      .kofi{background:#FF5E5B;color:#fff;padding:3px 10px;border-radius:4px;font-weight:700}
      @media print{body{padding:12px}@page{margin:.5in;size:landscape}}
    </style></head><body>
      <div class="header">
        <div><div class="title">🚐 RV TRAVEL MATE</div><div class="subtitle">Generated from RV Travel Mate · rv-trip-planner-rjlq.vercel.app · Printed ${new Date().toLocaleDateString()}</div></div>
        <div style="text-align:right;font-size:11px;color:#666">${vehicle.rvType} · ${vehicle.mpg} MPG · ${vehicle.fuelType}<br/>Max ${Math.round(trip.maxDailyMiles)} mi/day · Avg ${prefs.avgSpeedMph} mph</div>
      </div>
      <div class="stats">
        <div class="stat"><div class="stat-val">${trip.totMi.toLocaleString()} mi</div><div class="stat-lbl">Total Miles</div></div>
        <div class="stat"><div class="stat-val">${trip.totNights} nights</div><div class="stat-lbl">On the Road</div></div>
        <div class="stat"><div class="stat-val">${fmt$(trip.totFuel)}</div><div class="stat-lbl">Fuel Cost</div></div>
        <div class="stat"><div class="stat-val">${fmt$(trip.totLodge)}</div><div class="stat-lbl">Lodging Cost</div></div>
        <div class="stat"><div class="stat-val">${fmt$(trip.grand)}</div><div class="stat-lbl">Grand Total</div></div>
        <div class="stat"><div class="stat-val">${fmt$(trip.cpd)}</div><div class="stat-lbl">Per Day</div></div>
        <div class="stat"><div class="stat-val">${freeNights}</div><div class="stat-lbl">Free Nights</div></div>
      </div>
      ${(imgData||mapSnapshot)?"<div style='margin-bottom:24px'><div class='section-title'>Route Map - "+(mapScope==="full"?"Full Route":"Leg "+(parseInt(mapScope)+1))+"</div><img src='"+(imgData||mapSnapshot)+"' style='width:100%;max-height:400px;object-fit:cover;border-radius:6px;border:1px solid #eee;margin-top:8px' alt='Route Map'/></div>":""}
      ${Object.keys(finalDirs).length>0?"<div style='margin-bottom:24px'><div class='section-title'>Turn-by-Turn Directions</div>"+Object.entries(finalDirs).map(([li,leg])=>"<div style='margin-top:14px;page-break-inside:avoid'><div style='font-weight:700;font-size:12px;color:#1a1a1e;margin-bottom:6px;padding:6px 10px;background:#f5f5f5;border-radius:4px'>Leg "+(parseInt(li)+1)+": "+leg.from+" to "+leg.to+" · "+leg.totalMi+" miles</div><table style='width:100%;border-collapse:collapse;font-size:10px;margin-bottom:4px'><thead><tr><th style='background:#1a1a1e;color:#f5c518;padding:4px 8px;text-align:left;width:60px'>Miles</th><th style='background:#1a1a1e;color:#f5c518;padding:4px 8px;text-align:left'>Direction</th></tr></thead><tbody>"+leg.steps.map((st,si)=>"<tr style='"+(si%2===0?"background:#fafafa":"")+"'><td style='padding:3px 8px;color:#666;white-space:nowrap'>"+(st.distance>0?st.distance+" mi":"")+"</td><td style='padding:3px 8px'>"+st.instruction+"</td></tr>").join("")+"</tbody></table></div>").join("")+"</div>":""}
      <table>
        <thead><tr><th>#</th><th>Stop</th><th>Drive Date</th><th>Depart</th><th>Drive</th><th>Arrive</th><th>Depart</th><th>Nights</th><th>Miles</th><th>Fuel</th><th>Lodging</th><th>Total</th></tr></thead>
        <tbody>${rows}</tbody>
        <tfoot><tr class="tfoot"><td colspan="7">TOTALS</td><td style="text-align:center">${trip.totNights}</td><td style="text-align:center">${trip.totMi.toLocaleString()}</td><td>${fmt$(trip.totFuel)}</td><td>${fmt$(trip.totLodge)}</td><td>${fmt$(trip.totFuel+trip.totLodge)}</td></tr></tfoot>
      </table>
      <div class="breakdown">
        <div>
          <div class="section-title">Cost Breakdown</div>
          ${[["Fuel",trip.totFuel],["Lodging",trip.totLodge],["Groceries",trip.misc.groceries],["Propane & Utilities",trip.misc.propane],["Maintenance",trip.misc.maint],["Entertainment",trip.misc.entertain],["Emergency Fund",trip.misc.emergency],["Grand Total",trip.grand]].map(([l,v])=>"<div class='breakdown-row'><span>"+l+"</span><span><strong>"+fmt$(v)+"</strong>"+(trip.grand>0&&l!=="Grand Total"?" <small style='color:#999'>("+((v/trip.grand)*100).toFixed(1)+"%)</small>":"")+"</span></div>").join("")}
        </div>
        <div>
          <div class="section-title">Vehicle & Settings</div>
          ${[["RV Type",vehicle.rvType],["Fuel Type",vehicle.fuelType],["MPG",vehicle.mpg],["Tank",vehicle.tankGallons+" gal"],["RV Height",(vehicle.rvHeightFt??13)+"' "+(vehicle.rvHeightIn??0)+'"'],["Max Drive/Day",Math.round(trip.maxDailyMiles)+" mi"],["Avg Speed",prefs.avgSpeedMph+" mph"],["Travel Days",prefs.travelDays],["Free Nights",freeNights+" nights"]].map(([l,v])=>"<div class='breakdown-row'><span style='color:#666'>"+l+"</span><span><strong>"+v+"</strong></span></div>").join("")}
          ${Object.entries(memberships).filter(([k,v])=>v).length>0?"<div class='section-title' style='margin-top:12px'>Active Memberships</div>"+Object.entries(memberships).filter(([k,v])=>v).map(([k])=>"<div class='breakdown-row'><span>✓ "+(k==="goodSam"?"Good Sam":k==="passportAmerica"?"Passport America":k==="harvestHosts"?"Harvest Hosts":k==="koaValueKard"?"KOA Value Kard":"Thousand Trails")+"</span></div>").join(""):""}
        </div>
      </div>
      ${(()=>{
        // Journal section
        const journalEntries=typeof campgroundJournal!=="undefined"?campgroundJournal:[];
        if(journalEntries.length>0) return "<div style=\"margin-bottom:20px\"><div class=\"section-title\">📓 Travel Journal</div>"+
          journalEntries.map(e=>`<div style=\"margin-bottom:14px;padding:12px;border:1px solid #e2e8f0;border-radius:8px\">
            <div style=\"font-size:14px;font-weight:700;margin-bottom:4px\">${e.title||e.campground||"Journal Entry"} ${["","⭐","⭐⭐","⭐⭐⭐","⭐⭐⭐⭐","⭐⭐⭐⭐⭐"][e.rating||5]}</div>
            <div style=\"font-size:11px;color:#666;margin-bottom:6px\">${[e.campground,e.siteNumber?"Site #"+e.siteNumber:"",e.hookups,e.date].filter(Boolean).join(" · ")}</div>
            ${e.body?`<div style=\"font-size:12px;line-height:1.7;margin-bottom:6px\">${e.body}</div>`:""}
            ${e.tips?`<div style=\"font-size:11px;color:#92400e;background:#fef3c7;padding:6px 8px;border-radius:4px\">💡 ${e.tips}</div>`:""}
          </div>`).join("")+"</div>";
        return "";
      })()}
      ${(()=>{
        const allSideTrips=stops.flatMap(s=>(s.sideTrips||[]).filter(st=>st.totalMiles>0).map(st=>({...st,stopName:s.name,stopState:s.state||""})));
        if(!allSideTrips.length) return "";
        return "<div style='margin-bottom:20px'><div class='section-title'>🏍 Side Trips</div><table><thead><tr><th>Trip Name</th><th>Vehicle</th><th>Base Stop</th><th>Waypoints</th><th>Miles</th><th>Est. Fuel</th><th>Days</th><th>Notes</th></tr></thead><tbody>"+
          allSideTrips.map(st=>`<tr><td><strong>${st.name||"Side Trip"}</strong></td><td>${st.vehicleType}</td><td>${st.stopName}</td><td>${(st.waypoints||[]).filter(w=>w.name).map(w=>w.name+(w.state?", "+w.state:"")).join(" → ")||"-"}</td><td>${st.totalMiles} mi${st.roundTrip!==false?" (RT)":""}</td><td>$${Math.round(st.fuelCost)}${st.repeatEnabled&&(st.repeatDays||1)>1?"/day":""}</td><td>${st.repeatEnabled&&(st.repeatDays||1)>1?st.repeatDays+" days":"-"}</td><td style="font-size:10px;color:#666">${st.notes||"-"}</td></tr>`).join("")+
          "</tbody></table></div>";
      })()}
      ${tips.length>0?"<div class='tips'><div class='section-title' style='color:#27ae60;border-color:#27ae60'>Savings Tips</div>"+tips.map(t=>"<div class='tip'>→ "+t+"</div>").join("")+"</div>":""}
      <div class="footer">
        <span>RV Travel Mate · Free & Open Source · rv-trip-planner-rjlq.vercel.app</span>
        <span class="kofi">☕ ko-fi.com/rvtripplanner</span>
      </div>
    </body></html>`);
    win.document.write('<div class="no-print"><button class="btn-print" onclick="window.print()">🖨 Print / Save as PDF</button><button class="btn-close" onclick="window.close()">✕ Close</button></div>');
    win.document.close();win.focus();
    })();
  };

  return<div className="anim">
    <SecHead icon="🖨" title="Print Itinerary" sub="Opens a clean print-ready version of your full trip. In the print dialog, choose 'Save as PDF' to save a file."/>
    <QuickTipBar tabId="print" onOpenHowTo={onOpenHowTo}/>
    {!hasData?<Card style={{padding:40,textAlign:"center"}}><div style={{fontSize:48,marginBottom:12}}>🖨</div><div style={{fontFamily:T.F.head,fontSize:22,color:T.muted}}>Add stops with distances to generate your itinerary</div></Card>:<>
      {/* Map & Directions options */}
      <Card accent={T.blue} style={{marginBottom:16,padding:16}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,letterSpacing:1,textTransform:"uppercase",color:T.blue,marginBottom:12}}>🗺 Map & Directions</div>
        <div style={{display:"flex",gap:16,flexWrap:"wrap",marginBottom:12}}>
          <Tog value={inclMap} onChange={setInclMap} label="Include map image"/>
          <Tog value={inclDirections} onChange={setInclDirections} label="Include turn-by-turn directions"/>
        </div>
        {(inclMap||inclDirections)&&<div>
          <Label style={{fontSize:11,marginBottom:6}}>Scope</Label>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <button onClick={()=>setMapScope("full")} style={{padding:"5px 12px",borderRadius:20,border:`1px solid ${mapScope==="full"?T.blue:T.border}`,background:mapScope==="full"?T.blue+"22":"transparent",color:mapScope==="full"?T.blue:T.muted,fontSize:11,fontWeight:mapScope==="full"?700:400,cursor:"pointer"}}>Full Route</button>
            {namedActiveStops.slice(0,-1).map((s,i)=>(
              <button key={i} onClick={()=>setMapScope(String(i))} style={{padding:"5px 12px",borderRadius:20,border:`1px solid ${mapScope===String(i)?T.blue:T.border}`,background:mapScope===String(i)?T.blue+"22":"transparent",color:mapScope===String(i)?T.blue:T.muted,fontSize:11,fontWeight:mapScope===String(i)?700:400,cursor:"pointer"}}>
                Leg {i+1}: {s.name?.split(",")[0]||`Stop ${i+1}`} → {namedActiveStops[i+1]?.name?.split(",")[0]||`Stop ${i+2}`}
              </button>
            ))}
          </div>
        </div>}
        {(capturingMap||fetchingDirs)&&<div style={{marginTop:10,fontSize:12,color:T.muted}}>⏳ {capturingMap?"Capturing map...":"Fetching directions..."}</div>}
        {inclMap&&<div style={{marginTop:8,fontSize:11,color:T.free,display:"flex",alignItems:"center",gap:6}}>
          <span>✓</span><span>A route map will be generated automatically from your stop locations when you print. {mapSnapshot?"A manually captured map is also available.":<span style={{color:T.muted}}>Or go to the Map tab and click 📸 Capture Map for a live screenshot.</span>}</span>
        </div>}
      </Card>
      <Card accent={T.accent} style={{marginBottom:16,padding:20}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:14}}>
          <div>
            <div style={{fontFamily:T.F.head,fontSize:24,color:T.accent,marginBottom:6}}>Ready to Print</div>
            <div style={{fontSize:13,color:T.muted,lineHeight:1.7}}>
              Your itinerary is ready. Click Print to open a clean print-ready version in a new tab.<br/>
              <strong style={{color:T.text}}>To save as PDF:</strong> In the print dialog, change printer to <strong style={{color:T.text}}>"Save as PDF"</strong>
            </div>
          </div>
          <Btn onClick={doPrint} variant="primary" style={{fontSize:15,padding:"12px 28px",flexShrink:0}}>🖨 Print / Save as PDF</Btn>
        </div>
      </Card>
      {/* Additional Print Reports */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:12,marginBottom:16}}>
        <Card accent="#f59e0b" style={{padding:"14px 18px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#f59e0b",marginBottom:6}}>🔧 Maintenance Report</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:10,lineHeight:1.5}}>Full service history, costs by category, tire age, generator hours, and fuel fill-up log.</div>
          <Btn onClick={printMaintenance} variant="ghost" style={{width:"100%",justifyContent:"center",borderColor:"#f59e0b44",color:"#f59e0b",fontSize:12}}>🖨 Print Maintenance Report</Btn>
          {(!rvMaintenance||!(rvMaintenance.logs||[]).length)&&<div style={{fontSize:11,color:T.muted,marginTop:6,textAlign:"center"}}>Log services in 🔧 My RV first</div>}
        </Card>
        <Card accent={T.free} style={{padding:"14px 18px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.free,marginBottom:6}}>✅ Trip Checklists</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:10,lineHeight:1.5}}>Pre-departure, arrival, and monthly maintenance checklists - all with printable checkboxes.</div>
          <Btn onClick={printChecklist} variant="ghost" style={{width:"100%",justifyContent:"center",borderColor:T.free+"44",color:T.free,fontSize:12}}>🖨 Print Checklists</Btn>
        </Card>
        <Card accent="#f59e0b" style={{padding:"14px 18px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#f59e0b",marginBottom:6}}>💰 Annual Expense Report</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:10,lineHeight:1.5}}>Full-year spending breakdown by category, month-by-month table, and totals. Great for tax prep.</div>
          <Btn onClick={printFinances} variant="ghost" style={{width:"100%",justifyContent:"center",borderColor:"#f59e0b44",color:"#f59e0b",fontSize:12}}>🖨 Print Expense Report</Btn>
        </Card>
        <Card accent="#f59e0b" style={{padding:"14px 18px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#f59e0b",marginBottom:6}}>⭐ Local Favorites</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:10,lineHeight:1.5}}>All restaurants, attractions, and tips saved across your stops - your personal RV travel guide.</div>
          <Btn onClick={printLocalFavorites} variant="ghost" style={{width:"100%",justifyContent:"center",borderColor:"#f59e0b44",color:"#f59e0b",fontSize:12}}>🖨 Print Local Favorites</Btn>
        </Card>
      </div>
      <Card style={{padding:16}} accent={T.border}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,letterSpacing:1,textTransform:"uppercase",color:T.muted,marginBottom:12}}>📄 What's Included in Your Printout</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:8}}>
          {["✅ Full itinerary table - all stops in order","✅ Drive dates, day of week, depart time","✅ Miles, drive hours per leg","✅ ⚠ Drive limit warnings highlighted","✅ Arrival & departure dates","✅ Fuel cost and lodging per stop","✅ Complete cost breakdown with %","✅ Vehicle specs & settings","✅ Active memberships listed","✅ Savings tips","✅ Free nights count","✅ Ko-fi support link"].map((item,i)=><div key={i} style={{fontSize:12,color:T.muted,display:"flex",gap:6}}><span>{item}</span></div>)}
        </div>
        <div style={{fontSize:12,color:T.muted,borderTop:`1px solid ${T.border}`,paddingTop:12,marginTop:12}}>
          💡 <strong style={{color:T.text}}>Tip:</strong> Print in <strong style={{color:T.text}}>Landscape</strong> orientation for the best fit. The itinerary table is wide - landscape gives you more columns per row.
        </div>
      </Card>
    </>}
  </div>;
}

function HowToSection({onClose}){
  const T=useTheme();
  const [open,setOpen]=useState(()=>{
    try{const t=sessionStorage.getItem("howto-target");if(t){sessionStorage.removeItem("howto-target");return t;}return null;}catch{return null;}
  });
  const sections=[
    {id:"start",icon:"🚀",title:"Quick Start - Plan Your First Trip in 5 Minutes",content:[
      "1. 🚐 Setup → RV - enter your RV type, MPG, and tank size.",
      "2. 🚐 Setup → Travel - set your max drive hours and preferred travel days (weekends, weekdays, any).",
      "3. 🚐 Setup → Budget - enter your monthly take-home pay (never saved, resets each visit).",
      "4. 📍 Trip → Stops - add each destination. Enter a name, then click the 📍 Calc button next to Miles to auto-fill driving distance from the previous stop.",
      "5. 📍 Trip → Map - verify your route, toggle layers, or click Auto-Calculate Miles to fill all stops at once.",
      "6. 📊 Output → Summary - your full itinerary, costs, and drive warnings appear automatically.",
      "Every number updates live as you make changes!",
    ]},
    {id:"tabs",icon:"📑",title:"Tab Groups - What Each Section Contains",content:[
      "── 🚐 SETUP ──",
      "Vehicle - Vehicle type selection (RV types, Motorcycle, Car/SUV, Bicycle, 🥾 Hike/Walk). MPG and tank drive all fuel calculations. RV-specific fields hide for non-RV types.",
      "⛽ Fuel Range Warnings - legs that exceed 75% of your tank range show a yellow ⛽ warning in the Summary table. Plan fuel stops ahead for those legs.",
      "🎣 Cabela's/Bass Pro, Cracker Barrel, Love's - now searchable in Find Stops Near Me and Look Ahead as preferred overnight stops.",
      "Towing a vehicle? Toggle it on to reveal Tow Type and Tow Length fields. The stats card shows your combined length (RV + tow + 5ft hitch) and warns if over 45ft.",
      "🥾 Hike / Walk mode - set your pace (mph) and max daily distance. Trip summary shows walk time instead of fuel cost. Routes use walking paths via OpenRouteService.",
      "Travel - Max drive hours/day, average speed, preferred travel days, default departure time, holiday flagging.",
      "Budget - Monthly take-home and budget category splits. Income is never saved.",
      "Fuel - Base fuel price. Auto-fills from EIA regional data based on your home state or GPS location. Disable VPN for accurate GPS detection.",
      "Members - Toggle memberships (Good Sam, Passport America, Harvest Hosts, KOA, Thousand Trails). For planning only - no charges here.",
      "── 📍 TRIP ──",
      "Stops - Add every destination. Name, stop type, state, miles, nights, nightly rate. Use 📍 Calc for auto driving miles. Dates auto-chain. Actual Paid field for live cost tracking.",
      "Look Ahead - Search what's within 60 miles of each stop: campgrounds, RV parks, fuel, trails, Walmart, and federal parks. Filter-aware. Links to Recreation.gov, Campendium, FreeCampsites.",
      "Free Camping - Guide to Walmart, BLM, casinos, Harvest Hosts, rest areas, and boondocking apps.",
      "Map - Live route map with dashed route line. Map Filters modal with 20 amenity filters. Toggle layers. GPS tracking, Travel Mode, Find Stops Near Me.",
      "Weather - 14-day forecast per stop from Open-Meteo (free, no account). Click Load Forecast on any named stop.",
      "── 📊 OUTPUT ──",
      "Summary - Full itinerary table, stat boxes, cost breakdown bars, Live Actuals Tracker, and savings tips. All live.",
      "Print - Opens a new window with your formatted itinerary. Click Print / Save as PDF inside that window.",
      "🔧 Print Maintenance Report - prints your full service history, costs by year and category, tire age, generator hours, and fuel fill-up log. Great for resale documentation.",
      "✅ Print Checklists - prints pre-departure, arrival, and monthly maintenance checklists with empty checkboxes ready to use.",
      "💰 Print Expense Report - annual full-timer spending report with month-by-month breakdown, category totals, and daily/monthly averages. Great for tax prep.",
      "⭐ Print Local Favorites - your personal travel guide. All restaurants, attractions, and tips saved across all your stops printed in one document.",
      "💰 Finances tab - track monthly full-timer expenses by category. Auto-fills fuel and maintenance from your logs. Annual dashboard shows trends and donut chart breakdown.",
      "⭐ Local Favorites - each stop card has a collapsible Local Favorites section. Add restaurants, attractions, practical tips, and services. Saved with the stop and printable.",
      "Quick Links - One-tap links to RV apps. Add your own custom links.",
      "── ⚙️ MORE ──",
      "Save/Load - Export trip as .json file. Import to restore. Income never included in exports.",
      "Settings - 5 themes (Clean Light default), 4 fonts, compact mode, reset preferences. Sign Out button.",
      "How To - You're here! Print button opens a formatted printable guide.",
      "── 📚 HISTORY ──",
      "Trip History - Archive completed trips for comparison. See estimated vs actual spending, % over/under budget, and full stop list per archived trip.",
    ]},
    {id:"stops",icon:"📍",title:"How to Add & Configure Stops",content:[
      "Every stop needs: a Name, Miles from Prev Stop, and Min Nights to generate a full itinerary.",
      "New to the app? A Quick Start guide appears at the top - click any step to jump directly to that section.",
      "✨ AI Trip Review - always free in the Summary tab. Click 'Review My Trip' for personalized analysis, warnings, and savings suggestions.",
      "🔧 My RV Tab - New section for maintenance tracking, fill-up log, and checklists. Access from the 🔧 My RV tab group.",
      "🔧 Maintenance Tracker - log every service (oil changes, tires, generator, roof inspection) with date, odometer, and cost. App warns when service is due based on mileage and time intervals.",
      "⛽ Fill-up Log - log every fuel fill-up. App calculates your real MPG between fill-ups and compares to your estimated MPG. Tracks total fuel spend.",
      "✅ Checklists - pre-departure, arrival, and monthly maintenance checklists. Check off items as you go. Add custom items. Reset between trips.",
      "🔗 Find & Book - each stop card has booking links for Recreation.gov, Campendium, The Dyrt, Campspot, and Dump Stations. Appears when a stop has a name entered.",
      "Multi-Driver Mode - in Travel Preferences, enable Multi-Driver to remove the daily drive limit cap. Useful when sharing driving duties. Suppresses daily limit warnings.",
      "✨ AI Route Planner - in the Stops tab, click 'Plan Route'. Choose a route style (Balanced, Scenic, Fastest, Budget, Adventure), optionally describe your trip, and AI plans a geographically intelligent route. If you have existing stops, choose Replace (fresh route) or Merge (keep fixed-date stops, AI fills gaps). Review each suggested stop, accept/reject individually, then apply.",
      "🤖 AI Co-Pilot - appears on the Map tab when GPS tracking or Travel Mode is active. Get live fuel stops, campground suggestions, weather alerts, and ask anything.",
      "⚡ AI Conflict Detector, 🌤 Weather, 💰 Budget Optimizer, 🗺 Route Optimizer, 🎫 Membership Advisor - all in the Summary tab AI panel.",
      "✨ AI Trip Narrative - in the History tab, click AI Narrative before archiving to generate a personal travel story of your journey.",
      "⛽ AI Fuel Planner - in the Summary tab, click 'AI Fuel Planner' for smart fuel stop recommendations based on your tank range and route.",
      "📍 AI Stop Suggestions - in the Summary tab, click 'AI Stop Suggestions' for personalized overnight stop recommendations along your route.",
      "✨ AI Features - tap the ✨ AI button in the header to see AI features and free trial status. No purchase required to try - 5 free requests included.",
      "AI Pro features (Trip Builder, Fuel Planner, Stop Suggestions) unlock with a one-time $9.99 purchase. AI Trip Review is always free.",
      "🚀 Setup Wizard - click the Setup button in the header to open a step-by-step wizard. Works anytime and pre-fills with your current data.",
      "The wizard covers Vehicle → Travel Style → Fuel → Memberships → Stops in 5 guided steps with Next/Back navigation.",
      "✨ Add Stops by Typing - a parser card is always visible at the top of the Stops page. Click Open Parser, type destinations naturally one per line, and click Parse Stops.",
      "⏱ Stay Duration quick-select: 1 Night, Weekend, 3-4 Days, 1 Week, 2 Weeks, 3 Weeks, 1 Month, or Custom (edit min/max directly).",
      "📍 Calc button - appears next to Miles when both the current and previous stop have names. Automatically calls the routing API to fill in exact driving miles.",
      "🚗 Auto-Calculate Miles (Map tab) - fills driving miles for ALL stops at once. Use this for your first setup.",
      "Dates auto-calculate: set your Home stop Departure Date and all arrivals/departures chain forward automatically based on drive time + min nights + preferred travel days.",
      "Optional Arrive/Depart Date fields - override auto-calculated dates if needed. Leave blank to let the app calculate.",
      "Fixed Dates toggle - for events or family visits where arrival and departure are locked.",
      "Toggle a stop OFF to skip it - all costs and dates recalculate around the skipped stop.",
      "Reorder stops with the ▲▼ buttons - the map route and all dates automatically recalculate after you move a stop.",
      "Delete a stop with the ✕ button - the map rerenders and dates rechain immediately.",
      "After reordering, miles between stops become stale - run 🚗 Calculate Driving Miles on the Map tab to update them.",
      "Add a State to unlock membership campground search links on each stop card.",
      "Notes field - add park names, booking links, or tips for each stop.",
    ]},
    {id:"map",icon:"🗺",title:"Using the Map",content:[
      "Numbered colored pins show your stops in order. Click any pin for details, campground links, and membership search.",
      "Route line - a dashed line connects all stops using real road routing via OpenRouteService.",
      "Map auto-centers on your home city, or uses GPS if no home city is set.",
      "Toggle 6 map layers - each fetches live data from OpenStreetMap when enabled:",
      "  🏕 Campgrounds - RV-friendly campsites and campgrounds near your current map view.",
      "  ⛽ Fuel - Gas stations and fuel stops.",
      "  ⛳ Golf - Golf courses.",
      "  🥾 Trails - Hiking trailheads and paths.",
      "  🌤 Weather - Forecast badge floats above each stop pin. Shows temp, rain chance, wind. Click for 5-day popup. Highlights your arrival day.",
      "  🚐 RV Parks - Dedicated RV parks and caravan sites (separate from general campgrounds).",
      "Map auto-recalculates when you add, delete, reorder, or edit+save any stop - no manual refresh needed.",
      "Layers reset when you update stops - just re-toggle to reload fresh data.",
      "🗂 Map Filters - click the Map Filters button to open the filter modal with 3 groups: Map Layers, Hookups & Power (full hookups, 50amp, water, dump station, propane), and Amenities (showers, laundry, pool, wifi, pet friendly, and more). Active filters show as removable chips above the map.",
      "🛣 Travel Mode - click Start Travel Mode to get GPS and automatically pull all layer data within 30 miles of your current live position. Refreshes as you move.",
      "Midpoint suggestions appear for any leg over 350 miles - shows a nearby city with campground search links.",
      "📍 Enable GPS - one tap shows your location (blue dot) and starts auto-tracking. Button turns red when active.",
      "⏹ Stop GPS - tap the red button to disable GPS tracking.",
      "🛑 Find Stops Near Me - campgrounds, Walmarts, casinos, fuel within 40 miles.",
    ]},
    {id:"weather",icon:"🌤",title:"Weather Forecasts",content:[
      "Two ways to see weather: the Weather tab (full 14-day view) and the Map weather layer (badge on each stop pin).",
      "Weather tab - click Load Forecast on any named stop to see a 14-day day-by-day forecast.",
      "Each day card shows: weather emoji, condition description, high/low temps, rain chance %, and wind speed.",
      "Color coding - temps: red=95°+, orange=85°+, yellow=70°+, green=55°+, blue=below 55°. Rain: red=70%+, orange=40%+.",
      "Map weather layer - click 🌤 Weather toggle to show a forecast badge above each stop pin.",
      "Weather geocoding uses your stop's city name AND state - so Foley AL resolves correctly instead of Foley Oregon.",
      "Badges show the forecast for your arrival date (or today if no date set). Click a badge for a 5-day popup table.",
      "Forecasts are most reliable within 7 days. Beyond that, use as a general guide.",
      "Powered by Open-Meteo - free, no account needed, updated hourly.",
      "Note: VPN use may affect location detection and geocoding accuracy.",
    ]},
    {id:"gps",icon:"📍",title:"GPS & Live Location",content:[
      "The app uses your browser's built-in geolocation - no extra app or account needed.",
      "On a laptop: uses WiFi/IP positioning. On a phone or tablet: uses GPS chip for precise location.",
      "Important: if you are using a VPN, GPS and fuel region auto-detection will use the VPN's exit location, not your real location. Disable VPN for accurate results.",
      "Fuel region auto-detect - on load the app checks your home stop state. If blank, it asks for GPS to detect your state and set the correct EIA regional fuel price.",
      "Tap 📍 Enable GPS on the Map tab - shows your location and starts continuous auto-tracking in one tap.",
      "📍 Enable GPS button on the Map tab - one tap enables location AND starts continuous tracking. Tap ⏹ Stop GPS to turn it off.",
      "GPS auto-starts when you visit the Map tab if you've previously granted location permission to the browser.",
      "🎯 Live ETA - when GPS tracking is active, the app calculates your estimated arrival time at the next stop.",
      "ETA shows in two places: the header stats bar (replaces Daily Max) and a green card on the Map tab.",
      "ETA uses GPS speed if available, otherwise falls back to your Avg Speed setting in Travel preferences.",
      "ETA updates every 30 seconds with the continuous tracking cycle. Clears automatically when tracking stops.",
      "Tap 🛣 Start Travel Mode for full travel features including nearby stop search, AI Co-Pilot, and live ETA.",
      "Click Find Stops Near Me to search for campgrounds, Walmart, casinos, rest areas, and fuel stops within 40 miles.",
    ]},
    {id:"memberships",icon:"🎫",title:"Memberships & Savings",content:[
      "Toggle memberships on the 🚐 Setup → Members tab.",
      "For planning purposes only - no charges, no signups happen in this app.",
      "Active memberships appear as quick-search links on every stop card and map pin popup.",
      "Good Sam ($44/yr) - 10-15% off at 2,000+ parks.",
      "Passport America ($44/yr) - 50% off at 1,800+ parks off-peak.",
      "Harvest Hosts ($99/yr) - Free stays at 5,000+ farms, wineries, and breweries.",
      "KOA Value Kard ($33/yr) - 10% off every KOA night.",
      "Thousand Trails ($500/yr) - Unlimited stays at 80+ resorts per year.",
      "Annual cost summary shows at the bottom of the Members tab.",
    ]},
    {id:"print",icon:"🖨",title:"Printing & Saving Your Itinerary",content:[
      "Go to 📊 Output → Print to access the print view.",
      "Click the Print / Save as PDF button - this opens a new formatted window with your full itinerary.",
      "To save as PDF: in the print dialog, change the destination/printer to 'Save as PDF'. Landscape orientation recommended.",
      "The print view includes: full stop table, stats row, cost breakdown, vehicle specs, memberships, and savings tips.",
      "Drive warning legs are highlighted in yellow. Free camping nights show as green FREE.",
      "🗺 Map & Directions section - toggle 'Include map image' and/or 'Include turn-by-turn directions' before printing.",
      "📸 Capture Map - go to the Map tab and click '📸 Capture Map' to take a screenshot of your route (layers hidden automatically). Then return to Print.",
      "The Print tab shows a green ✓ when a map is captured and ready, or a warning if none has been captured yet.",
      "Scope selector - choose Full Route or an individual leg (e.g. Leg 1: Foley → Alexandria) for the map and directions.",
      "Map layers (campgrounds, fuel, weather) are automatically hidden from the map image so only your route and stop pins show.",
      "Turn-by-turn directions use RV-safe routing and show mileage per step. They print before the itinerary table.",
      "The app stays fully usable while the print window is open - it will not lock up.",
    ]},
    {id:"lookahead",icon:"🔍",title:"Look Ahead - What Is Near Each Stop",content:[
      "Look Ahead searches a 60-mile radius around each stop and returns live data from OpenStreetMap and direct links to campground databases.",
      "Go to 📍 Trip → Look Ahead to access the feature.",
      "Click 🔍 Look Ahead on an individual stop, or click Look Ahead - All Stops to run it for your entire trip at once.",
      "Results are grouped by category: Campgrounds, RV Parks, Fuel Stops, Walmart/Overnight, Trails, and Federal Parks.",
      "Each result shows the name and distance in miles from the stop.",
      "Direct links to Recreation.gov, Campendium, FreeCampsites.net, and Google Maps appear at the bottom of each stop's results.",
      "Recreation.gov - links directly to a 60-mile radius search for federal campgrounds (National Parks, National Forests, BLM).",
      "Results require the stop to have a name. Add a city and state for best accuracy.",
      "Rate limits apply - the All Stops search adds a short delay between stops to avoid API throttling.",
    ]},
    {id:"actuals",icon:"🧾",title:"Live Actuals Tracker - Real vs Estimated",content:[
      "Track what you actually spend vs what you estimated - in real time as your trip progresses.",
      "Per-stop actual cost: on each stop card in the Stops tab, enter the Actual Paid ($) amount after your stay.",
      "The field turns green if under estimate, red if over estimate.",
      "Live Actuals panel: go to 📊 Output → Summary. The Live Actuals Tracker panel at the top shows fuel, food, activities, maintenance, and other categories.",
      "Each category shows your estimate alongside the actual, with a green/red indicator.",
      "Lodging actuals pull automatically from the per-stop Actual Paid fields.",
      "The header total updates: when actuals are entered it shows ✓ Actual Total (green) or ⚠ Over Budget (red) instead of Est. Total.",
    ]},
    {id:"history",icon:"📚",title:"Trip History & Archive",content:[
      "Archive a completed trip so you can compare it to future trips or review your actual spending.",
      "Go to 📚 History → Trip History.",
      "Click 📦 Archive & Reset Trip - you'll be asked to name the trip (e.g. 'Sturgis 2026').",
      "The app saves a snapshot of all stops, estimates, actuals, vehicle info, miles, and nights.",
      "After archiving, the current trip resets (stops and actuals clear) so you can start planning a new one.",
      "Archived trips show: estimated total, actual total, % over or under budget, a full spending breakdown, and the complete stop list.",
      "You can delete individual archived trips. History is stored separately from your current trip data.",
    ]},
    {id:"import",icon:"✨",title:"Import Stops - AI & CSV",content:[
      "Bulk-add stops to your trip without entering them one by one.",
      "In the Stops tab, click the ✨ Import Stops button (purple, bottom right).",
      "AI Smart Import tab - paste plain text like '3 nights in Amarillo TX, then KOA Albuquerque for 2 nights at $55/night' and the AI parses it into stops automatically.",
      "CSV / Spreadsheet tab - upload a .csv file. Click Download Template to get the correct column format.",
      "CSV columns: Name, City/State, Type, Nights, Rate, Free (yes/no), Notes.",
      "Both methods show an editable preview before committing - you can adjust any field before adding to your trip.",
      "Imports append to existing stops without clearing your current trip.",
    ]},
    {id:"auth",icon:"🔒",title:"Login & Account (Beta)",content:[
      "RVParkMate uses Supabase authentication for tester access during the private beta.",
      "On first visit you will see a login screen - enter the email and password provided by your coordinator.",
      "Your session stays active - you won't need to log in again on the same device/browser.",
      "Sign Out button is in the footer bar at the bottom of the app.",
      "Contact srector210@gmail.com to request tester access.",
    ]},
    {id:"pwa",icon:"📱",title:"Install as a Phone App (PWA)",content:[
      "RVParkMate can be installed to your phone's home screen and launched like a native app - no app store needed.",
      "iPhone/iPad: open the site in Safari → tap the Share button → tap 'Add to Home Screen' → tap Add.",
      "Android: open in Chrome → tap the 3-dot menu → tap 'Add to Home Screen' or 'Install App'.",
      "Once installed, it launches fullscreen without the browser bar, just like a real app.",
      "The app icon (two interlocking map pins - RV Travel Mate) will appear on your home screen.",
      "A service worker caches the app shell for faster loads. API calls (maps, weather, campgrounds) always fetch fresh data.",
    ]},
    {id:"themes",icon:"🎨",title:"Themes & Customization",content:[
      "Go to ⚙️ More → Settings to change the app theme and font.",
      "5 themes: Clean Light (default - white/blue), Asphalt (dark/yellow), Midnight (navy/blue), Forest (dark green), Desert (warm orange).",
      "4 font options: Inter (default - modern), Barlow (classic RV), DM Sans (friendly), Outfit (bold modern).",
      "Compact Mode tightens spacing for easier use on mobile or smaller screens.",
      "Your theme and font choices are saved automatically with your trip data.",
      "Reset Preferences button in Settings restores all defaults without clearing your stops.",
    ]},
    {id:"sidetrips",icon:"🏍",title:"Side Trips - Day Trips from Any Stop",content:[
      "A side trip is a day ride or excursion attached to any stop - motorcycle loop, car day trip, bicycle trail, or even a short RV hop.",
      "To add: open any stop card (✏️ Edit not required) and click '🏍 + Add Side Trip' at the bottom of the expanded card.",
      "Name your side trip, choose your vehicle type (Motorcycle, Car/SUV, Bicycle, or any RV type), and enter up to 5 waypoints.",
      "The route always starts and ends at the parent stop - making it a round trip loop automatically.",
      "Click '🗺 Calculate Route' to get mileage and turn-by-turn directions for your side trip.",
      "Mode - Standalone: side trip costs and miles are separate from your main trip totals.",
      "Mode - Add to Overall Trip: side trip fuel cost and miles roll into your main trip summary and grand total.",
      "Click '➕ Create as New Trip' to reset the planner for a completely separate trip with that vehicle type.",
      "Side trips print as a sub-section under their parent stop in the Print itinerary.",
      "🖨 Print Side Trip PDF - each side trip card has its own print button for a standalone PDF with route, waypoints, directions, and notes.",
      "Bicycle routing uses cycling paths instead of roads. All other vehicles use RV-safe routing.",
    ]},
    {id:"returnhome",icon:"🏠",title:"Return Home & Trip Inverse",content:[
      "Go to 📚 History → Return Home to access both features.",
      "🔄 Inverse Trip - reverses all stop order for your return journey. Home stays at position 1.",
      "After inverting, miles between stops are cleared - run 🚗 Calculate Driving Miles on the Map tab to recalculate.",
      "Dates also clear on inverse so they can rechain from your new departure date.",
      "A confirmation dialog appears before inverting - you cannot undo without re-inverting.",
      "🏠 Route Home - plans the fastest RV-safe drive from your last stop back home.",
      "Route Home splits the total drive into daily legs based on your Max Drive Hours setting.",
      "Each leg shows miles, estimated fuel cost, and drive hours. Overnight legs include campground search links.",
      "Set your Home City on the Home stop first - Route Home uses it as the destination.",
    ]},
    {id:"tips",icon:"💡",title:"Tips & Help System",content:[
      "A rotating tips window appears each time the app loads (if enabled in Settings).",
      "Tips cycle through all 20 categories before repeating - covering map, stops, saving money, print, side trips, and more.",
      "Click '💡 Tips' in the header bar to open the tips window manually at any time.",
      "Use ← Prev and Next → to browse tips. Each tip shows its category tag.",
      "To turn off startup tips: go to ⚙️ Settings → toggle '💡 Show Tips on Startup' off.",
      "The How To tab (this page) has detailed guides for every feature - click '? How To' on any section's tip bar.",
    ]},
    {id:"saving",icon:"💾",title:"Saving & Sharing Your Trip",content:[
      "On first visit you'll be asked if you want to enable browser auto-saving.",
      "YES - stops, preferences, memberships, and settings auto-save in this browser. Income is never saved.",
      "NO - use Export/Import (⚙️ More → Save/Load) to download your trip as a .json file.",
      "To use on another device - export on one device, import on the other.",
      "To share with a travel partner - export and email or text the .json file.",
      "Trip data is stored locally in your browser only - nothing is sent to any server.",
      "Switching browsers or clearing browser data will reset the app. Use Export to back up important trips.",
    ]},
  ];
  const printGuide=()=>{
    const win=window.open("","_blank","width=900,height=700");
    win.document.write(`<!DOCTYPE html><html><head><title>RV Travel Mate - User Guide</title><style>
      *{box-sizing:border-box;margin:0;padding:0}
      body{font-family:Arial,sans-serif;color:#111;background:#fff;padding:28px;font-size:13px;max-width:800px;margin:0 auto}
      h1{font-size:30px;font-weight:900;letter-spacing:3px;color:#1a1a1e;margin-bottom:4px}
      .subtitle{color:#666;font-size:13px;margin-bottom:24px;padding-bottom:16px;border-bottom:4px solid #f5c518}
      h2{font-size:14px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:#1a1a1e;margin:20px 0 8px;display:flex;align-items:center;gap:8px}
      h2 span{font-size:18px}
      .section{margin-bottom:16px;padding:14px 16px;border:1px solid #eee;border-left:4px solid #f5c518;border-radius:4px;page-break-inside:avoid}
      .line{font-size:12px;color:#444;line-height:1.9;padding:1px 0}
      .footer{margin-top:28px;padding-top:12px;border-top:2px solid #f5c518;display:flex;justify-content:space-between;font-size:11px;color:#999}
      .kofi{background:#FF5E5B;color:#fff;padding:4px 12px;border-radius:4px;font-weight:700;font-size:11px}
      @media print{body{padding:16px}}
    </style></head><body>
      <h1>🚐 RV TRAVEL MATE</h1>
      <div class="subtitle">Complete User Guide · rv-trip-planner-rjlq.vercel.app · Free & Open Source</div>
      ${sections.map(s=>"<div class='section'><h2><span>"+s.icon+"</span>"+s.title+"</h2>"+s.content.map(line=>"<div class='line'>"+line+"</div>").join("")+"</div>").join("")}
      <div class="footer">
        <span>RV Travel Mate · Free · Open Source · No ads · Income never stored</span>
        <span class="kofi">☕ ko-fi.com/rvtripplanner</span>
      </div>
    </body></html>`);
    win.document.close();
    win.focus();
    setTimeout(()=>win.print(),400);
  };

  return<div className="anim">
    <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:4,gap:12}}>
      <SecHead icon="📖" title="How To Use This App" sub="Everything you need to plan a great RV trip."/>
      {onClose&&<button onClick={onClose} title="Go back to previous tab" style={{background:"none",border:"1px solid "+T.border,borderRadius:8,padding:"6px 16px",color:T.muted,fontSize:13,cursor:"pointer",fontFamily:"sans-serif",flexShrink:0,marginTop:4}}>✕ Close</button>}
    </div>
    <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap"}}>
      <Btn onClick={()=>setOpen(open===null?"all":null)} variant="ghost" style={{fontSize:12}}>
        {open==="all"?"▲ Collapse All":"▼ Expand All"}
      </Btn>
      <Btn onClick={printGuide} variant="ghost" style={{fontSize:12}}>🖨 Print / Save as PDF</Btn>
      <div style={{fontSize:12,color:T.muted,display:"flex",alignItems:"center"}}>Print dialog → "Save as PDF" for a shareable guide</div>
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {sections.map(s=>{const isOpen=open==="all"||open===s.id;return<div key={s.id} style={{background:T.bgMid,border:`1px solid ${isOpen?T.accent:T.border}`,borderRadius:10,overflow:"hidden",transition:"border-color .2s"}}>
        <button onClick={()=>setOpen(isOpen&&open!=="all"?null:s.id)} style={{width:"100%",background:"none",border:"none",color:T.text,cursor:"pointer",padding:"16px 20px",display:"flex",alignItems:"center",gap:12,textAlign:"left"}}>
          <span style={{fontSize:22,flexShrink:0}}>{s.icon}</span>
          <span style={{fontFamily:T.F.cond,fontWeight:700,fontSize:16,flex:1}}>{s.title}</span>
          <span style={{color:T.muted,fontSize:18,flexShrink:0}}>{isOpen?"▲":"▼"}</span>
        </button>
        {isOpen&&<div style={{padding:"0 20px 20px",borderTop:`1px solid ${T.border}`}}>{s.content.map((line,i)=><div key={i} style={{fontSize:13,color:T.muted,lineHeight:1.8,paddingTop:i===0?14:2}}>{line}</div>)}</div>}
      </div>;})}
    </div>
    <Card style={{marginTop:16,padding:20}} accent={T.accent}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:T.accent,marginBottom:4}}>☕ Support This App</div>
          <div style={{fontSize:13,color:T.muted,lineHeight:1.6}}>RV Travel Mate is free and open source. No ads, no subscriptions. If it's been useful for your travels, a small donation helps keep it improving!</div>
        </div>
        <a href={KOFI_URL} target="_blank" rel="noopener noreferrer" style={{padding:"12px 24px",background:"#FF5E5B",color:"#fff",borderRadius:8,fontWeight:700,fontSize:14,textDecoration:"none",fontFamily:T.F.cond,letterSpacing:.5,whiteSpace:"nowrap",flexShrink:0}}>☕ Buy Me a Coffee</a>
      </div>
    </Card>
  </div>;
}


// ── Return Home Planner ────────────────────────────────────────────
function ReturnHomeSection({stops,vehicle,fuel,prefs,onOpenHowTo,onInverseTrip}){
  const T=useTheme();
  const [loading,setLoading]=useState(false);
  const [legs,setLegs]=useState([]);
  const [error,setError]=useState('');
  const [confirmInverse,setConfirmInverse]=useState(false);

  const homeStop=stops.find(s=>s.type==='home'&&s.active);
  const lastStop=[...stops].reverse().find(s=>s.active&&s.type!=='home'&&s.name);
  const mpg=Math.max(parseFloat(vehicle.mpg)||8,1);
  const fp=parseFloat(fuel.avgPricePerGallon)||3.30;
  const maxHrs=Math.max(parseFloat(prefs.maxDriveHours)||7,0.5);
  const spd=Math.max(parseFloat(prefs.avgSpeedMph)||60,1);
  const maxDailyMi=Math.round(spd*maxHrs);

  const planRoute=async()=>{
    if(!homeStop||(!homeStop.homeCity&&!homeStop.state)){setError('Set your Home City on the Home stop first.');return;}
    if(!lastStop){setError('No completed stops found to return from.');return;}
    setLoading(true);setError('');setLegs([]);
    try{
      // Use shared geocodeStop helper — handles stored coords, ORS, Nominatim, fallbacks
      const [startCoords,endCoords]=await Promise.all([
        geocodeStop(lastStop),
        geocodeStop(homeStop),
      ]);
      if(!startCoords||!endCoords){
        setError('Could not locate start or home stop. Make sure both have a State selected.');
        setLoading(false);return;
      }
      // Use roadMiles for reliable CORS-safe distance (OSRM→ORS→straight-line)
      const totalMi=await roadMiles(startCoords[0],startCoords[1],endCoords[0],endCoords[1]);
      if(!totalMi){setError('Could not calculate route distance. Check your internet connection.');setLoading(false);return;}
      const numDays=Math.ceil(totalMi/maxDailyMi);
      const miPerDay=Math.ceil(totalMi/numDays);

      // Build daily legs
      const builtLegs=[];
      let remaining=totalMi;
      let fromName=lastStop.name+(lastStop.state?', '+lastStop.state:'');
      for(let d=0;d<numDays;d++){
        const legMi=d===numDays-1?remaining:Math.min(miPerDay,remaining);
        remaining-=legMi;
        const isLast=d===numDays-1;
        builtLegs.push({
          day:d+1,
          from:d===0?fromName:`Day ${d} overnight stop`,
          to:isLast?(homeStop.homeCity||homeStop.state+', Home'):(`Overnight Stop ${d+1}`),
          miles:legMi,
          fuel:parseFloat((legMi/mpg*fp).toFixed(2)),
          isHome:isLast,
          driveHrs:parseFloat((legMi/spd).toFixed(1)),
        });
      }
      setLegs(builtLegs);
    }catch(e){setError('Route planning failed. Check your internet connection.');}
    setLoading(false);
  };

  const fmt$=n=>'$'+Math.round(n).toLocaleString();
  const totalFuel=legs.reduce((s,l)=>s+l.fuel,0);
  const totalMi=legs.reduce((s,l)=>s+l.miles,0);

  const analyzeMonth=async()=>{
    if(!callAI) return;
    setAiBudgetLoading(true);
    const budgets=finances.budgets||{};
    const catLines=EXPENSE_CATS.filter(c=>c.group!=="Hunting"||settings?.huntingEnabled).filter(c=>(mData.expenses[c.id]||0)>0).map(c=>{
      const actual=mData.expenses[c.id]||0;
      const budget=budgets[c.id]||0;
      const over=budget>0?(actual>budget?" OVER $"+Math.round(actual-budget):" under $"+Math.round(budget-actual)):"";
      return c.label+": $"+Math.round(actual)+(budget>0?" (budget $"+Math.round(budget)+over+")":"");
    }).join(", ");
    const p="Analyze this full-timer RV monthly budget for "+monthNames[selMonth]+" "+selYear+"."
      +"\nTotal spent: $"+Math.round(totalExp)
      +(fullMode?"\nIncome: $"+Math.round(totalInc)+" Net: $"+Math.round(net):"")
      +"\nNights: "+(mData.nights||0)+" Miles: "+(mData.miles||0)+" Cost/day: $"+(costPerDay>0?Math.round(costPerDay):"unknown")
      +"\nSpending: "+catLines
      +"\nGive 3-5 specific actionable insights. Flag over-budget categories, note patterns, suggest savings. Under 200 words.";
    const result=await callAI(p,"You are a financial advisor for full-time RVers. Give specific practical advice based on real spending numbers.");
    setAiBudgetMsg(result||"Unable to analyze.");
    setAiBudgetLoading(false);
  };

  return(
    <div className="anim">
      <SecHead icon="🏠" title="Return Home Planner" sub="Plan your drive home from the last stop based on your daily drive settings."/>
    <QuickTipBar tabId="returnhome" onOpenHowTo={onOpenHowTo}/>
    {/* ── Two main options ── */}
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:20}}>
      <Card accent={T.accentAlt} style={{padding:16}}>
        <div style={{fontSize:28,marginBottom:8}}>🔄</div>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:T.accentAlt,marginBottom:6}}>Inverse Trip</div>
        <div style={{fontSize:12,color:T.muted,lineHeight:1.5,marginBottom:10}}>Choose how you want to return home:</div>
        {!confirmInverse?(
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            <button onClick={()=>setConfirmInverse("retrace")} style={{padding:"9px 12px",background:T.accentAlt+"22",border:`1px solid ${T.accentAlt}44`,borderRadius:8,color:T.accentAlt,fontSize:12,fontWeight:700,cursor:"pointer",textAlign:"left"}}>
              <div>🔄 Retrace My Route</div>
              <div style={{fontSize:10,color:T.muted,fontWeight:400,marginTop:2}}>Reverse all stops in exact order — Sturgis → Hill City → Fergus Falls → home, keeping fuel stops</div>
            </button>
            <button onClick={()=>setConfirmInverse("direct")} style={{padding:"9px 12px",background:T.accentAlt+"11",border:`1px solid ${T.accentAlt}22`,borderRadius:8,color:T.accentAlt,fontSize:12,fontWeight:700,cursor:"pointer",textAlign:"left"}}>
              <div>🏁 Reverse Stop Order Only</div>
              <div style={{fontSize:10,color:T.muted,fontWeight:400,marginTop:2}}>Flip stop order for planning — map will find fastest roads between each stop</div>
            </button>
          </div>
        ):(
          <div style={{background:T.accentAlt+"11",border:`1px solid ${T.accentAlt}44`,borderRadius:8,padding:10}}>
            <div style={{fontSize:12,color:T.text,marginBottom:8,fontWeight:600}}>
              {confirmInverse==="retrace"?"Retrace your exact outbound route in reverse, keeping all stops and fuel stops?":"Reverse stop order only — map will route fastest roads between stops?"}
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>{if(onInverseTrip)onInverseTrip(confirmInverse);setConfirmInverse(false);}} style={{flex:1,padding:"8px 0",background:T.accentAlt,border:"none",borderRadius:6,color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer"}}>✓ Yes, Continue</button>
              <button onClick={()=>setConfirmInverse(false)} style={{flex:1,padding:"8px 0",background:"none",border:`1px solid ${T.border}`,borderRadius:6,color:T.muted,fontSize:12,fontWeight:700,cursor:"pointer"}}>✕ Cancel</button>
            </div>
          </div>
        )}
      </Card>
      <Card accent={T.accent} style={{padding:16}}>
        <div style={{fontSize:28,marginBottom:8}}>🏠</div>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:T.accent,marginBottom:6}}>Route Home</div>
        <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>Plan the fastest RV-safe drive home from your last stop, split into daily legs based on your max drive hours.</div>
        <div style={{marginTop:10,padding:"6px 14px",background:T.accent+"22",border:`1px solid ${T.accent}44`,borderRadius:8,color:T.accent,fontSize:12,fontWeight:700,display:"inline-block",cursor:"pointer"}} onClick={planRoute}>🏠 Plan Route Home</div>
      </Card>
    </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
        <Card style={{padding:16}}>
          <div style={{fontSize:12,color:T.muted,marginBottom:4,fontWeight:600}}>🚐 Returning From</div>
          <div style={{fontSize:15,fontWeight:700,color:T.text}}>{lastStop?lastStop.name+(lastStop.state?', '+lastStop.state:''):'No last stop found'}</div>
          {lastStop?.departDate&&<div style={{fontSize:11,color:T.muted,marginTop:2}}>Departed: {lastStop.departDate}</div>}
        </Card>
        <Card style={{padding:16}}>
          <div style={{fontSize:12,color:T.muted,marginBottom:4,fontWeight:600}}>🏠 Returning To</div>
          <div style={{fontSize:15,fontWeight:700,color:T.text}}>{homeStop?.homeCity||homeStop?.state||'Set Home City on Home stop'}</div>
          <div style={{fontSize:11,color:T.muted,marginTop:2}}>Max {maxDailyMi} mi/day · {maxHrs}hrs</div>
        </Card>
      </div>

      {error&&<Card style={{padding:12,marginBottom:12,background:T.danger+'15',border:`1px solid ${T.danger}44`}}><div style={{fontSize:13,color:T.danger}}>{error}</div></Card>}

      {loading&&<div style={{padding:"12px",color:T.muted,fontSize:13,marginBottom:12}}>⏳ Planning route...</div>}

      {legs.length>0&&(
        <div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:10,marginBottom:16}}>
            {[
              {l:'Total Miles',v:totalMi.toLocaleString()+' mi',c:T.accent},
              {l:'Drive Days',v:legs.length+' days',c:T.blue},
              {l:'Est. Fuel Cost',v:fmt$(totalFuel),c:T.accentAlt},
              {l:'Miles/Day',v:Math.round(totalMi/legs.length)+' mi',c:T.muted},
            ].map(({l,v,c})=>(
              <div key={l} style={{background:T.bgMid,borderRadius:10,padding:'10px 14px',borderTop:`2px solid ${c}`}}>
                <div style={{fontFamily:T.F.head,fontSize:20,fontWeight:900,color:c}}>{v}</div>
                <div style={{fontSize:10,color:T.muted,textTransform:'uppercase',letterSpacing:1,marginTop:3}}>{l}</div>
              </div>
            ))}
          </div>

          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {legs.map(leg=>(
              <Card key={leg.day} style={{padding:14,borderLeft:`3px solid ${leg.isHome?T.free:T.accent}`}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8}}>
                  <div>
                    <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:14,color:leg.isHome?T.free:T.accent,marginBottom:2}}>
                      {leg.isHome?'🏠':'🌙'} Day {leg.day}{leg.isHome?' - Arrive Home':'- Overnight Stop'}
                    </div>
                    <div style={{fontSize:12,color:T.muted}}>{leg.from} → {leg.to}</div>
                  </div>
                  <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
                    <div style={{textAlign:'center'}}>
                      <div style={{fontSize:15,fontWeight:700,color:T.accent}}>{leg.miles} mi</div>
                      <div style={{fontSize:10,color:T.muted,textTransform:'uppercase'}}>miles</div>
                    </div>
                    <div style={{textAlign:'center'}}>
                      <div style={{fontSize:15,fontWeight:700,color:T.accentAlt}}>{fmt$(leg.fuel)}</div>
                      <div style={{fontSize:10,color:T.muted,textTransform:'uppercase'}}>fuel est.</div>
                    </div>
                    <div style={{textAlign:'center'}}>
                      <div style={{fontSize:15,fontWeight:700,color:T.muted}}>{leg.driveHrs}h</div>
                      <div style={{fontSize:10,color:T.muted,textTransform:'uppercase'}}>drive</div>
                    </div>
                  </div>
                </div>
                {!leg.isHome&&(
                  <div style={{marginTop:8,display:'flex',gap:6,flexWrap:'wrap'}}>
                    <a href={`https://www.campendium.com/search?q=${encodeURIComponent(leg.to)}`} target="_blank" rel="noopener noreferrer" style={{padding:'3px 10px',background:T.free+'22',border:`1px solid ${T.free}44`,borderRadius:5,color:T.free,fontSize:11,fontWeight:600,textDecoration:'none'}}>🏕 Campendium</a>
                    <a href={`https://freecampsites.net/#!${encodeURIComponent(leg.to)}`} target="_blank" rel="noopener noreferrer" style={{padding:'3px 10px',background:'#f59e0b22',border:'1px solid #f59e0b44',borderRadius:5,color:'#f59e0b',fontSize:11,fontWeight:600,textDecoration:'none'}}>🆓 FreeCampsites</a>
                    <a href={`https://www.google.com/maps/search/RV+park+campground+near+${encodeURIComponent(leg.to)}`} target="_blank" rel="noopener noreferrer" style={{padding:'3px 10px',background:'#ef444422',border:'1px solid #ef444444',borderRadius:5,color:'#ef4444',fontSize:11,fontWeight:600,textDecoration:'none'}}>📍 Google Maps</a>
                  </div>
                )}
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Grouped Tab Bar ───────────────────────────────────────────────
function GroupedTabBar({groups,tab,setTab,trip,sidebarCollapsed,setSidebarCollapsed}){
  const T=useTheme();
  const [openGroup,setOpenGroup]=useState(null);
  const [dropdownPos,setDropdownPos]=useState({left:0,top:0});
  const [isWide,setIsWide]=useState(()=>typeof window!=="undefined"&&window.innerWidth>=768);
  // sidebarCollapsed/setSidebarCollapsed now come from AppInner via props
  // Fallback to local state if not provided (shouldn't happen)
  const [_localCollapsed,_setLocalCollapsed]=useState(()=>typeof window!=="undefined"&&window.innerWidth<768);
  const collapsed=sidebarCollapsed!==undefined?sidebarCollapsed:_localCollapsed;
  const setCollapsed=setSidebarCollapsed||_setLocalCollapsed;
  const [expandedGroups,setExpandedGroups]=useState(()=>{
    // Default: expand the group containing the active tab
    const activeGroup=groups.find(g=>g.tabs.some(t=>t.id===tab));
    return activeGroup?{[activeGroup.id]:true}:{};
  });
  const activeGroup=groups.find(g=>g.tabs.some(t=>t.id===tab));

  useEffect(()=>{
    const check=()=>setIsWide(window.innerWidth>=768);
    window.addEventListener("resize",check);
    return()=>window.removeEventListener("resize",check);
  },[]);

  // When tab changes expand its group
  useEffect(()=>{
    if(activeGroup) setExpandedGroups(prev=>({...prev,[activeGroup.id]:true}));
  },[tab]);

  // Sync collapsed state to body class for CSS offset
  useEffect(()=>{
    if(isWide){
      document.body.classList.toggle("sidebar-collapsed",collapsed);
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  },[collapsed,isWide]);

  // Track viewport width for responsive switching
  useEffect(()=>{
    const check=()=>{}; // ribbon always shown, no resize needed
    window.addEventListener("resize",check);
    return()=>window.removeEventListener("resize",check);
  },[]);

  // Close dropdown on outside click (mobile mode)
  useEffect(()=>{
    const handler=()=>setOpenGroup(null);
    document.addEventListener("click",handler);
    return()=>document.removeEventListener("click",handler);
  },[]);

  const handleGroupClick=(e,gId)=>{
    e.stopPropagation();
    if(openGroup===gId){setOpenGroup(null);return;}
    const rect=e.currentTarget.getBoundingClientRect();
    setDropdownPos({left:rect.left,top:rect.bottom});
    setOpenGroup(gId);
  };

  const openGroupData=groups.find(g=>g.id===openGroup);

  // ── SIDEBAR NAV (desktop >= 768px) ────────────────────────────────
  const [tabRowScrolled,setTabRowScrolled]=useState(false);
  const [showScrollHint,setShowScrollHint]=useState(true);
  const [scrollPct,setScrollPct]=useState(0);
  const tabRow1Ref=useRef(null);
  const handleTabScroll=(e)=>{
    const el=e.target;
    const pct=el.scrollLeft/(el.scrollWidth-el.clientWidth)||0;
    setScrollPct(pct);
    if(el.scrollLeft>10){setTabRowScrolled(true);setShowScrollHint(false);}
  };

  {
    const isMobile=!isWide;
    const mobileOpen=!collapsed&&isMobile;
    return(
      <>
      {/* Mobile overlay backdrop — tap to close */}
      {mobileOpen&&<div onClick={()=>setSidebarCollapsed(true)}
        style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:199,touchAction:"none"}}/>}
      <div style={{
        position:"fixed",top:0,left:0,bottom:0,
        width:isMobile?(collapsed?0:240):(collapsed?52:220),
        background:T.bgMid,
        borderRight:sidebarCollapsed&&isMobile?"none":`1px solid ${T.border}`,
        zIndex:200,
        display:"flex",
        flexDirection:"column",
        transition:"width .25s ease",
        overflow:"hidden",
        boxShadow:mobileOpen?"4px 0 24px rgba(0,0,0,0.35)":"2px 0 12px rgba(0,0,0,0.15)",
      }}>
        {/* Sidebar header */}
        {!(collapsed&&isMobile)&&<div style={{padding:"10px 12px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0,background:T.bg,minHeight:52}}>
          {(!collapsed||isMobile)&&<div style={{fontFamily:T.F.head,fontSize:12,fontWeight:900,color:T.accent,letterSpacing:1,whiteSpace:"nowrap",overflow:"hidden"}}>RV TRAVEL MATE</div>}
          {collapsed&&!isMobile&&<span style={{fontSize:18}}>🚐</span>}
          <button onClick={()=>setCollapsed(c=>!c)}
            style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:20,padding:"2px 6px",flexShrink:0,lineHeight:1,fontWeight:700}}>
            {collapsed?"☰":"✕"}
          </button>
        </div>}
        {/* Nav groups */}
        <div style={{flex:1,overflowY:"auto",overflowX:"hidden",padding:"4px 0",scrollbarWidth:"thin"}}>
          {groups.map(g=>{
            const isAG=activeGroup?.id===g.id;
            const isExp=expandedGroups[g.id]||false;
            const hasData=g.id==="output"&&trip.totMi>0;
            const emoji=g.label.split(" ")[0];
            const gLabel=g.label.split(" ").slice(1).join(" ");
            if(collapsed){return(
              <div key={g.id}>
                <button onClick={()=>{setTab(g.tabs[0].id);setCollapsed(false);}} title={g.label}
                  style={{width:"100%",padding:"10px 0",background:isAG?T.accent+"22":"transparent",border:"none",borderLeft:isAG?`3px solid ${T.accent}`:"3px solid transparent",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,position:"relative"}}>
                  {emoji}
                  {hasData&&<div style={{position:"absolute",top:6,right:8,width:6,height:6,borderRadius:"50%",background:T.accent}}/>}
                </button>
              </div>
            );}
            return(
              <div key={g.id} style={{marginBottom:1}}>
                <button onClick={()=>setExpandedGroups(prev=>({...prev,[g.id]:!prev[g.id]}))}
                  style={{width:"100%",padding:"7px 12px",background:isAG?T.accent+"18":"transparent",border:"none",borderLeft:isAG?`3px solid ${T.accent}`:"3px solid transparent",cursor:"pointer",display:"flex",alignItems:"center",gap:7,textAlign:"left"}}>
                  <span style={{fontSize:15,flexShrink:0}}>{emoji}</span>
                  <span style={{fontFamily:T.F.cond,fontWeight:700,fontSize:10,color:isAG?T.accent:T.muted,textTransform:"uppercase",letterSpacing:.5,flex:1,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{gLabel}</span>
                  {hasData&&<span style={{width:6,height:6,borderRadius:"50%",background:T.accent,flexShrink:0,display:"inline-block"}}/>}
                  <span style={{fontSize:10,color:T.muted,flexShrink:0,display:"inline-block",transform:isExp?"rotate(90deg)":"none",transition:"transform .15s"}}>›</span>
                </button>
                {isExp&&<div>
                  {g.tabs.map(t=>{
                    const isActive=tab===t.id;
                    const tEmoji=t.l.split(" ")[0];
                    const tLabel=t.l.split(" ").slice(1).join(" ")||t.l;
                    return(
                      <button key={t.id} onClick={()=>{setTab(t.id);if(isMobile)setCollapsed(true);}}
                        style={{width:"100%",padding:"6px 12px 6px 32px",background:isActive?T.accent+"22":"transparent",border:"none",borderLeft:isActive?`3px solid ${T.accent}`:"3px solid transparent",cursor:"pointer",display:"flex",alignItems:"center",gap:6,textAlign:"left",transition:"background .1s"}}
                        onMouseEnter={e=>{if(!isActive)e.currentTarget.style.background=T.accent+"0d";}}
                        onMouseLeave={e=>{if(!isActive)e.currentTarget.style.background="transparent";}}>
                        <span style={{fontSize:12,flexShrink:0}}>{tEmoji}</span>
                        <span style={{fontFamily:T.F.body,fontSize:12,color:isActive?T.accent:T.text,fontWeight:isActive?700:400,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{tLabel}</span>
                      </button>
                    );
                  })}
                </div>}
              </div>
            );
          })}
        </div>
        {!collapsed&&<div style={{padding:"8px 12px",borderTop:`1px solid ${T.border}`,flexShrink:0}}>
          <div style={{fontSize:9,color:T.muted,textAlign:"center",letterSpacing:.5,opacity:.7}}>A Horizn Product</div>
        </div>}
      </div>
      </>
    );
  }


  // Mobile dropdown removed — sidebar handles all screen sizes
}






// ── FINANCE CATEGORIES ────────────────────────────────────────────
const EXPENSE_CATS=[
  // Living
  {id:"campsite",icon:"🏕",label:"Campsite/Hookups",group:"Living",color:"#22c55e"},
  {id:"groceries",icon:"🛒",label:"Groceries",group:"Living",color:"#16a34a"},
  {id:"dining",icon:"🍽",label:"Dining Out",group:"Living",color:"#f59e0b"},
  {id:"entertainment",icon:"🎉",label:"Entertainment",group:"Living",color:"#8b5cf6"},
  {id:"clothing",icon:"👗",label:"Clothing",group:"Living",color:"#ec4899"},
  // Vehicle
  {id:"fuel",icon:"⛽",label:"Fuel",group:"Vehicle",color:"#f97316"},
  {id:"maint_routine",icon:"🛢",label:"Routine Maintenance",group:"Vehicle",color:"#f59e0b"},
  {id:"maint_repair",icon:"💧",label:"Unexpected Repairs",group:"Vehicle",color:"#ef4444"},
  {id:"maint_appliance",icon:"❄️",label:"Appliance Repairs",group:"Vehicle",color:"#06b6d4"},
  {id:"maint_emergency",icon:"🚨",label:"Emergency Roadside",group:"Vehicle",color:"#dc2626"},
  {id:"insurance_rv",icon:"🛡",label:"RV Insurance",group:"Vehicle",color:"#6366f1"},
  {id:"registration",icon:"📋",label:"Registration/Tags",group:"Vehicle",color:"#6b7280"},
  {id:"tolls",icon:"🅿",label:"Tolls/Parking",group:"Vehicle",color:"#9ca3af"},
  // Utilities
  {id:"phone",icon:"📱",label:"Phone/Internet",group:"Utilities",color:"#3b82f6"},
  {id:"propane",icon:"🔥",label:"Propane",group:"Utilities",color:"#f97316"},
  {id:"water",icon:"🚰",label:"Water/Dump Fees",group:"Utilities",color:"#0ea5e9"},
  {id:"streaming",icon:"📺",label:"Subscriptions",group:"Utilities",color:"#7c3aed"},
  // Healthcare
  {id:"health_ins",icon:"💊",label:"Health Insurance",group:"Healthcare",color:"#ef4444"},
  {id:"medical",icon:"🏥",label:"Medical/Dental",group:"Healthcare",color:"#f87171"},
  {id:"prescriptions",icon:"💉",label:"Prescriptions",group:"Healthcare",color:"#fca5a5"},
  // Financial
  {id:"savings",icon:"🏦",label:"Savings",group:"Financial",color:"#22c55e"},
  {id:"debt",icon:"💳",label:"Debt Payments",group:"Financial",color:"#ef4444"},
  {id:"storage",icon:"📦",label:"Storage Unit",group:"Financial",color:"#6b7280"},
  {id:"mail",icon:"✉",label:"Mail/Domicile",group:"Financial",color:"#6b7280"},
  {id:"pets",icon:"🐾",label:"Pets",group:"Financial",color:"#f59e0b"},
  {id:"misc",icon:"📎",label:"Miscellaneous",group:"Financial",color:"#9ca3af"},
  // Hunting group
  {id:"hunt_license",icon:"🏷",label:"Hunt License/Tag",group:"Hunting",color:"#16a34a"},
  {id:"hunt_lease",icon:"🌲",label:"Hunt Lease",group:"Hunting",color:"#15803d"},
  {id:"hunt_guide",icon:"🧭",label:"Guide Fees",group:"Hunting",color:"#166534"},
  {id:"hunt_processing",icon:"🔪",label:"Processing/Butcher",group:"Hunting",color:"#14532d"},
  {id:"hunt_taxidermy",icon:"🦌",label:"Taxidermist",group:"Hunting",color:"#4ade80"},
  {id:"hunt_gear",icon:"🎯",label:"Hunting Gear/Ammo",group:"Hunting",color:"#86efac"},
  {id:"hunt_fuel",icon:"⛽",label:"Hunt Trip Fuel",group:"Hunting",color:"#bbf7d0"},
  {id:"hunt_misc",icon:"🐗",label:"Hunt Misc",group:"Hunting",color:"#dcfce7"},
];

const INCOME_CATS=[
  {id:"inc_job",icon:"💼",label:"Remote Job/Salary",color:"#22c55e"},
  {id:"inc_freelance",icon:"🔨",label:"Freelance/Contract",color:"#16a34a"},
  {id:"inc_retirement",icon:"🏦",label:"Retirement/SS",color:"#3b82f6"},
  {id:"inc_rental",icon:"🏠",label:"Rental Income",color:"#8b5cf6"},
  {id:"inc_investment",icon:"📈",label:"Investment/Dividends",color:"#f59e0b"},
  {id:"inc_other",icon:"💰",label:"Other Income",color:"#6b7280"},
];

const mkMonth=()=>({
  expenses:Object.fromEntries(EXPENSE_CATS.map(c=>[c.id,0])),
  income:Object.fromEntries(INCOME_CATS.map(c=>[c.id,0])),
  notes:"",
  state:"",
  nights:0,
  miles:0,
});

// ── SERVICE TEMPLATES ─────────────────────────────────────────────
const RV_SERVICE_TEMPLATES=[
  // motorized=only for Class A/B/C; towable=only for 5th wheel/TT; all=everyone
  {id:"oil",icon:"🛢",name:"Oil Change",category:"Engine",intervalMi:5000,intervalDays:180,unit:"miles",color:"#f59e0b",rvTypes:"motorized"},
  {id:"transmission",icon:"⚙️",name:"Transmission Fluid",category:"Engine",intervalMi:30000,intervalDays:730,unit:"miles",color:"#6366f1",rvTypes:"motorized"},
  {id:"airfilter",icon:"💨",name:"Air Filter",category:"Engine",intervalMi:20000,intervalDays:365,unit:"miles",color:"#06b6d4",rvTypes:"motorized"},
  {id:"coolant",icon:"❄️",name:"Coolant Flush",category:"Engine",intervalMi:30000,intervalDays:730,unit:"miles",color:"#3b82f6",rvTypes:"motorized"},
  {id:"generator",icon:"⚡",name:"Generator Service",category:"Systems",intervalMi:0,intervalDays:365,unit:"hours",genHours:100,color:"#f59e0b",rvTypes:"motorized"},
  {id:"tires_rotate",icon:"🔄",name:"Tire Rotation",category:"Tires",intervalMi:7500,intervalDays:180,unit:"miles",color:"#3b82f6",rvTypes:"all"},
  {id:"tires_replace",icon:"🛞",name:"Tire Replacement",category:"Tires",intervalMi:0,intervalDays:1825,unit:"years",color:"#ef4444",rvTypes:"all"},
  {id:"brakes",icon:"🛑",name:"Brake Inspection",category:"Safety",intervalMi:20000,intervalDays:365,unit:"miles",color:"#dc2626",rvTypes:"all"},
  {id:"bearings",icon:"🔩",name:"Wheel Bearing Repack",category:"Safety",intervalMi:12000,intervalDays:365,unit:"miles",color:"#7c3aed",rvTypes:"towable"},
  {id:"hitch",icon:"🔗",name:"Hitch / Kingpin Inspection",category:"Towing",intervalMi:0,intervalDays:180,unit:"months",color:"#f59e0b",rvTypes:"towable"},
  {id:"brakecontroller",icon:"🛑",name:"Brake Controller Check",category:"Towing",intervalMi:0,intervalDays:365,unit:"annual",color:"#dc2626",rvTypes:"towable"},
  {id:"safetychains",icon:"⛓",name:"Safety Chains Inspection",category:"Towing",intervalMi:0,intervalDays:365,unit:"annual",color:"#6366f1",rvTypes:"towable"},
  {id:"landinggear",icon:"🦵",name:"Landing Gear Lubrication",category:"Towing",intervalMi:0,intervalDays:90,unit:"months",color:"#8b5cf6",rvTypes:"towable"},
  {id:"roof",icon:"🏠",name:"Roof Seal Inspection",category:"Structure",intervalMi:0,intervalDays:365,unit:"annual",color:"#14b8a6",rvTypes:"all"},
  {id:"slideout",icon:"↔️",name:"Slideout Lubrication",category:"Structure",intervalMi:0,intervalDays:90,unit:"months",color:"#8b5cf6",rvTypes:"all"},
  {id:"battery",icon:"🔋",name:"Battery Check",category:"Electrical",intervalMi:0,intervalDays:180,unit:"months",color:"#22c55e",rvTypes:"all"},
  {id:"propane",icon:"🔥",name:"Propane System Check",category:"Systems",intervalMi:0,intervalDays:365,unit:"annual",color:"#f97316",rvTypes:"all"},
  {id:"waterheater",icon:"🚿",name:"Water Heater Anode",category:"Systems",intervalMi:0,intervalDays:365,unit:"annual",color:"#0ea5e9",rvTypes:"all"},
  {id:"sanitize",icon:"💧",name:"Tank Sanitization",category:"Systems",intervalMi:0,intervalDays:180,unit:"months",color:"#10b981",rvTypes:"all"},
  {id:"custom",icon:"🔧",name:"Custom Service",category:"Other",intervalMi:0,intervalDays:365,unit:"annual",color:"#6b7280",rvTypes:"all"},
];

// Tow vehicle maintenance templates
const TOW_VEHICLE_TEMPLATES=[
  {id:"tow_oil",icon:"🛢",name:"Oil Change",category:"Engine",intervalMi:5000,intervalDays:180,unit:"miles",color:"#f59e0b"},
  {id:"tow_trans",icon:"⚙️",name:"Transmission Fluid",category:"Engine",intervalMi:30000,intervalDays:730,unit:"miles",color:"#6366f1"},
  {id:"tow_tires",icon:"🛞",name:"Tire Rotation / Replacement",category:"Tires",intervalMi:7500,intervalDays:365,unit:"miles",color:"#3b82f6"},
  {id:"tow_brakes",icon:"🛑",name:"Brake Inspection",category:"Safety",intervalMi:20000,intervalDays:365,unit:"miles",color:"#dc2626"},
  {id:"tow_coolant",icon:"❄️",name:"Coolant Flush",category:"Engine",intervalMi:50000,intervalDays:730,unit:"miles",color:"#06b6d4"},
  {id:"tow_diff",icon:"⚙️",name:"Differential / Transfer Case Fluid",category:"Drivetrain",intervalMi:30000,intervalDays:730,unit:"miles",color:"#8b5cf6"},
  {id:"tow_hitch",icon:"🔗",name:"Ball / 5th Wheel Hitch Inspection",category:"Towing",intervalMi:0,intervalDays:180,unit:"months",color:"#f59e0b"},
  {id:"tow_payload",icon:"⚖️",name:"Verify Payload / GVWR Check",category:"Towing",intervalMi:0,intervalDays:365,unit:"annual",color:"#14b8a6"},
  {id:"tow_airfilter",icon:"💨",name:"Air Filter",category:"Engine",intervalMi:20000,intervalDays:365,unit:"miles",color:"#22c55e"},
  {id:"tow_custom",icon:"🔧",name:"Custom Service",category:"Other",intervalMi:0,intervalDays:365,unit:"annual",color:"#6b7280"},
];

const mkLog=(o={})=>({
  id:uid(),serviceId:"oil",serviceName:"Oil Change",category:"Engine",
  date:"",odometer:0,genHours:0,cost:0,shop:"",notes:"",
  nextDueMi:0,nextDueDate:"",nextDueGenHours:0,
  ...o
});

const mkFillup=(o={})=>({
  id:uid(),date:"",odometer:0,gallons:0,pricePerGal:0,
  totalCost:0,station:"",fuelType:"Diesel",notes:"",...o
});

// ── MaintenanceSection ────────────────────────────────────────────
// ── Tow Vehicle Maintenance Card ─────────────────────────────────────────
function TowVehicleMaintenanceCard({rvMaintenance,onChange,vehicle}){
  const T=useTheme();
  const m=rvMaintenance||{};
  const towLogs=m.towLogs||[];
  const [showAdd,setShowAdd]=useState(false);
  const [sel,setSel]=useState(TOW_VEHICLE_TEMPLATES[0]?.id||"tow_oil");
  const [date,setDate]=useState(new Date().toISOString().slice(0,10));
  const [odo,setOdo]=useState("");
  const [notes,setNotes]=useState("");
  const towOdo=parseFloat(vehicle?.towTruckOdometer)||0;

  const addLog=()=>{
    if(!date) return;
    const tmpl=TOW_VEHICLE_TEMPLATES.find(t=>t.id===sel)||TOW_VEHICLE_TEMPLATES[0];
    const log={id:uid(),serviceId:sel,serviceName:tmpl.name,category:tmpl.category,
      date,odometer:odo,notes,loggedAt:new Date().toISOString()};
    onChange({...m,towLogs:[log,...towLogs]});
    setShowAdd(false);setOdo("");setNotes("");
  };

  const getTowStatus=(tmpl)=>{
    const logs=towLogs.filter(l=>l.serviceId===tmpl.id).sort((a,b)=>new Date(b.date)-new Date(a.date));
    const last=logs[0];
    if(!last) return {status:"untracked",label:"Not logged"};
    const days=Math.floor((new Date()-new Date(last.date))/86400000);
    const mi=towOdo-(parseFloat(last.odometer)||0);
    let urgency="ok";
    if(tmpl.intervalDays>0&&days>tmpl.intervalDays) urgency="urgent";
    else if(tmpl.intervalDays>0&&days>tmpl.intervalDays*0.85) urgency="soon";
    if(tmpl.intervalMi>0&&mi>tmpl.intervalMi) urgency="urgent";
    else if(tmpl.intervalMi>0&&mi>tmpl.intervalMi*0.85) urgency=urgency==="urgent"?"urgent":"soon";
    const color=urgency==="urgent"?"#ef4444":urgency==="soon"?"#f59e0b":"#22c55e";
    return{status:"tracked",urgency,color,label:last.date,days,mi};
  };

  const make=vehicle?.towTruckMake||"";
  const model=vehicle?.towTruckModel||"";
  const year=vehicle?.towTruckYear||"";
  const title=(make||model||year)?[year,make,model].filter(Boolean).join(" "):"Tow Vehicle";

  return(
    <Card style={{marginBottom:16,padding:"14px 18px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:T.text}}>🚛 {title} Maintenance</div>
          <div style={{fontSize:11,color:T.muted,marginTop:2}}>Separate log for your tow vehicle / truck</div>
        </div>
        <Btn onClick={()=>setShowAdd(!showAdd)} style={{fontSize:12,padding:"6px 14px"}}>+ Log Service</Btn>
      </div>

      {showAdd&&<Card style={{marginBottom:12,padding:"12px 14px",background:T.bgLite}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
          <div><Label>Service</Label>
            <Sel value={sel} onChange={e=>setSel(e.target.value)}>
              {TOW_VEHICLE_TEMPLATES.filter(t=>t.id!=="tow_custom").map(t=><option key={t.id} value={t.id}>{t.icon} {t.name}</option>)}
            </Sel>
          </div>
          <div><Label>Date</Label><Inp type="date" value={date} onChange={e=>setDate(e.target.value)}/></div>
          <div><Label>Odometer (mi)</Label><Inp type="number" value={odo} onChange={e=>setOdo(e.target.value)} placeholder="e.g. 87500"/></div>
          <div><Label>Notes</Label><Inp value={notes} onChange={e=>setNotes(e.target.value)} placeholder="optional"/></div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <Btn onClick={addLog} style={{flex:1}}>Save</Btn>
          <Btn onClick={()=>setShowAdd(false)} style={{flex:1,background:"none",border:"1px solid "+T.border,color:T.muted}}>Cancel</Btn>
        </div>
      </Card>}

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:8,marginBottom:12}}>
        {TOW_VEHICLE_TEMPLATES.filter(t=>t.id!=="tow_custom").map(tmpl=>{
          const st=getTowStatus(tmpl);
          const color=st.status==="tracked"?st.color:T.muted;
          return(
            <div key={tmpl.id} style={{padding:"10px 12px",borderRadius:10,border:"1px solid "+color+"44",background:color+"0d"}}>
              <div style={{fontSize:18,marginBottom:4}}>{tmpl.icon}</div>
              <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:2}}>{tmpl.name}</div>
              <div style={{fontSize:10,color}}>{st.label}</div>
            </div>
          );
        })}
      </div>

      {towLogs.length>0&&<div>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Recent Service Log</div>
        {towLogs.slice(0,5).map(log=>{
          const tmpl=TOW_VEHICLE_TEMPLATES.find(t=>t.id===log.serviceId)||{icon:"🔧",color:"#6b7280"};
          return(
            <div key={log.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:"1px solid "+T.border}}>
              <span style={{fontSize:18}}>{tmpl.icon}</span>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600,color:T.text}}>{log.serviceName}</div>
                <div style={{fontSize:11,color:T.muted}}>{log.date}{log.odometer?" · "+parseInt(log.odometer).toLocaleString()+" mi":""}{log.notes?" · "+log.notes:""}</div>
              </div>
              <button onClick={()=>onChange({...m,towLogs:towLogs.filter(l=>l.id!==log.id)})}
                style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:16,padding:"2px 6px"}}>×</button>
            </div>
          );
        })}
      </div>}
    </Card>
  );
}


function MaintenanceSection({rvMaintenance,onChange,vehicle,stops,callAI,aiPurchased,aiFreeCalls}){
  const T=useTheme();
  // Filter templates by RV type
  const isTowing=["Fifth Wheel","Travel Trailer","Toy Hauler"].includes(vehicle?.rvType);
  const isMotorized=!isTowing;
  const FILTERED_TEMPLATES=RV_SERVICE_TEMPLATES.filter(t=>{
    if(t.rvTypes==="motorized") return isMotorized;
    if(t.rvTypes==="towable") return isTowing;
    return true; // "all"
  });
  const showTowVehicle=isTowing&&vehicle?.towVehicle;
  const m=rvMaintenance;
  const f=(k,v)=>onChange({...m,[k]:v});
  const [showAddLog,setShowAddLog]=useState(false);
  const [editLog,setEditLog]=useState(null);
  const [draft,setDraft]=useState(null);
  const [aiAdvice,setAiAdvice]=useState("");
  const [aiLoading,setAiLoading]=useState(false);
  const [activeTab,setActiveTab]=useState("overview");
  const [showTemplates,setShowTemplates]=useState(false);

  // Calculate running odometer: base + all trip miles from archived trips in history
  const tripMiles=stops.filter(s=>s.active&&s.distFromPrev>0).reduce((a,s)=>a+(parseFloat(s.distFromPrev)||0),0);
  const currentOdo=Math.max(parseFloat(m.currentOdometer)||0,0);

  // Figure out status of each service type
  const getServiceStatus=(tmpl)=>{
    const logs=m.logs.filter(l=>l.serviceId===tmpl.id).sort((a,b)=>new Date(b.date)-new Date(a.date));
    const last=logs[0];
    if(!last) return{status:"unknown",lastDate:null,nextDue:null,urgency:"none"};
    const lastDate=new Date(last.date);
    const now=new Date();
    const daysSince=Math.floor((now-lastDate)/86400000);

    let urgency="ok",nextDue="",daysUntil=0;

    if(tmpl.unit==="hours"){
      const curHours=parseFloat(m.generatorHours)||0;
      const lastHours=parseFloat(last.genHours)||0;
      const hoursSince=curHours-lastHours;
      const hoursUntil=tmpl.genHours-hoursSince;
      urgency=hoursUntil<10?"urgent":hoursUntil<25?"soon":"ok";
      nextDue=`${Math.round(hoursUntil)} gen-hrs`;
    } else if(tmpl.intervalMi>0){
      const milesSince=currentOdo-parseFloat(last.odometer||0);
      const milesUntil=tmpl.intervalMi-milesSince;
      daysUntil=tmpl.intervalDays>0?tmpl.intervalDays-daysSince:999;
      urgency=(milesUntil<200||daysUntil<14)?"urgent":(milesUntil<500||daysUntil<30)?"soon":"ok";
      nextDue=milesUntil>0?`${Math.round(milesUntil).toLocaleString()} mi`:"OVERDUE";
    } else {
      daysUntil=tmpl.intervalDays-daysSince;
      urgency=daysUntil<14?"urgent":daysUntil<30?"soon":"ok";
      nextDue=daysUntil>0?`${daysUntil}d`:"OVERDUE";
    }

    return{status:"tracked",lastDate:last.date,lastOdo:last.odometer,nextDue,urgency,daysSince,last};
  };

  const urgencyColor=(u)=>u==="urgent"?T.danger:u==="soon"?"#f59e0b":u==="ok"?T.free:T.muted;
  const urgencyBg=(u)=>u==="urgent"?T.danger+"18":u==="soon"?"#f59e0b18":u==="ok"?T.free+"12":T.bgLite;

  const openAdd=(tmpl)=>{
    const now=new Date().toISOString().slice(0,10);
    setDraft(mkLog({
      serviceId:tmpl.id,serviceName:tmpl.name,category:tmpl.category,
      date:now,odometer:currentOdo,genHours:parseFloat(m.generatorHours)||0,
      nextDueMi:tmpl.intervalMi>0?currentOdo+tmpl.intervalMi:0,
      nextDueDate:tmpl.intervalDays>0?new Date(Date.now()+tmpl.intervalDays*86400000).toISOString().slice(0,10):"",
    }));
    setShowAddLog(true);
  };

  const saveLog=()=>{
    if(!draft) return;
    const existing=m.logs.find(l=>l.id===draft.id);
    const newLogs=existing?m.logs.map(l=>l.id===draft.id?draft:l):[...m.logs,draft];
    f("logs",newLogs);
    setShowAddLog(false);setDraft(null);
  };

  const deleteLog=(id)=>{
    if(!window.confirm("Delete this service record?")) return;
    f("logs",m.logs.filter(l=>l.id!==id));
  };

  // Annual cost summary
  const currentYear=new Date().getFullYear();
  const thisYearLogs=m.logs.filter(l=>l.date&&new Date(l.date).getFullYear()===currentYear);
  const annualCost=thisYearLogs.reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
  const costByCategory=thisYearLogs.reduce((a,l)=>{a[l.category]=(a[l.category]||0)+(parseFloat(l.cost)||0);return a;},{});

  // Upcoming warnings (urgent or soon)
  const urgentItems=FILTERED_TEMPLATES.filter(t=>t.id!=="custom").map(t=>({...t,status:getServiceStatus(t)})).filter(t=>t.status.status==="tracked"&&(t.status.urgency==="urgent"||t.status.urgency==="soon"));

  const handleAIAdvice=async()=>{
    if(!callAI) return;
    setAiLoading(true);
    const logSummary=m.logs.slice(-10).map(l=>`${l.date}: ${l.serviceName} @ ${l.odometer} mi, $${l.cost}`).join("\n");
    const prompt=`Review this RV maintenance history and give specific advice:\n\nVehicle: ${vehicle.rvType}\nCurrent odometer: ${currentOdo} mi\nGenerator hours: ${m.generatorHours||0}\n\nRecent service log:\n${logSummary||"No logs yet"}\n\nUpcoming due: ${urgentItems.map(i=>i.name+" ("+i.status.nextDue+")").join(", ")||"None flagged"}\n\nAdvise on: what needs attention soon, any patterns you notice, and what to budget for next year. Keep it under 200 words.`;
    const result=await callAI(prompt,"You are an experienced RV mechanic and maintenance advisor. Be specific and practical.");
    setAiAdvice(result||"Unable to get advice.");
    setAiLoading(false);
  };

  // Tire age calculation
  const tireAge=()=>{
    if(!m.tireInstallDate) return null;
    const installed=new Date(m.tireInstallDate);
    const now=new Date();
    const years=((now-installed)/31557600000);
    return years;
  };
  const tireYears=tireAge();
  const tireWarn=tireYears!=null&&tireYears>5;
  const tireDanger=tireYears!=null&&tireYears>7;

  return(
    <div className="anim">
      <SecHead icon="🔧" title="RV Maintenance Tracker" sub="Track service history, get mileage-based reminders, and monitor annual costs."/>
      <QuickTipBar tabId="maintenance" onOpenHowTo={()=>{}}/>

      {/* Summary bar */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:10,marginBottom:16}}>
        <Card style={{padding:"12px 14px"}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:4,fontFamily:T.F.cond,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Odometer</div>
          <input type="number" value={m.currentOdometer||""} onChange={e=>f("currentOdometer",parseFloat(e.target.value)||0)}
            placeholder="47,250" style={{width:"100%",background:"none",border:"none",fontSize:20,fontWeight:800,color:T.accent,outline:"none",fontFamily:T.F.head}}/>
          <div style={{fontSize:10,color:T.muted}}>current miles</div>
        </Card>
        <Card style={{padding:"12px 14px"}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:4,fontFamily:T.F.cond,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Generator</div>
          <input type="number" value={m.generatorHours||""} onChange={e=>f("generatorHours",parseFloat(e.target.value)||0)}
            placeholder="87" style={{width:"100%",background:"none",border:"none",fontSize:20,fontWeight:800,color:T.accent,outline:"none",fontFamily:T.F.head}}/>
          <div style={{fontSize:10,color:T.muted}}>total hours</div>
        </Card>
        <Card style={{padding:"12px 14px",background:annualCost>0?T.free+"08":T.bgMid}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:4,fontFamily:T.F.cond,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>{currentYear} Costs</div>
          <div style={{fontSize:20,fontWeight:800,color:T.free,fontFamily:T.F.head}}>${Math.round(annualCost).toLocaleString()}</div>
          <div style={{fontSize:10,color:T.muted}}>{thisYearLogs.length} service{thisYearLogs.length!==1?"s":""}</div>
        </Card>
        <Card style={{padding:"12px 14px",background:tireDanger?T.danger+"18":tireWarn?"#f59e0b18":T.bgMid}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:4,fontFamily:T.F.cond,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Tire Age</div>
          {tireYears!=null
            ?<div style={{fontSize:18,fontWeight:800,color:tireDanger?T.danger:tireWarn?"#f59e0b":T.free,fontFamily:T.F.head}}>{tireYears.toFixed(1)}y {tireDanger?"⚠ Replace":""}  </div>
            :<input type="date" value={m.tireInstallDate||""} onChange={e=>f("tireInstallDate",e.target.value)}
                style={{width:"100%",background:"none",border:"none",fontSize:13,color:T.accent,outline:"none"}}/>}
          <div style={{fontSize:10,color:T.muted}}>{tireYears!=null?"install: "+m.tireInstallDate:"enter install date"}</div>
        </Card>
      </div>

      {/* Urgent warnings */}
      {urgentItems.length>0&&<Card accent={T.danger} style={{marginBottom:16,padding:"12px 16px"}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.danger,marginBottom:8,letterSpacing:1,textTransform:"uppercase"}}>⚠ Service Due Soon</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {urgentItems.map(item=>(
            <div key={item.id} style={{background:urgencyBg(item.status.urgency),border:`1px solid ${urgencyColor(item.status.urgency)}44`,borderRadius:8,padding:"6px 12px",display:"flex",gap:8,alignItems:"center"}}>
              <span style={{fontSize:16}}>{item.icon}</span>
              <div>
                <div style={{fontSize:12,fontWeight:700,color:urgencyColor(item.status.urgency)}}>{item.name}</div>
                <div style={{fontSize:11,color:T.muted}}>{item.status.nextDue} remaining</div>
              </div>
              <button onClick={()=>openAdd(item)} style={{background:urgencyColor(item.status.urgency),color:"#fff",border:"none",borderRadius:6,padding:"3px 8px",fontSize:11,fontWeight:700,cursor:"pointer",marginLeft:4}}>Log Service</button>
            </div>
          ))}
        </div>
      </Card>}

      {/* Sub tabs */}
      <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
        {[["overview","📋 Overview"],["history","📜 History"],["costs","💰 Costs"]].map(([id,label])=>(
          <button key={id} onClick={()=>setActiveTab(id)} style={{padding:"6px 14px",borderRadius:20,border:`1px solid ${activeTab===id?T.accent:T.border}`,background:activeTab===id?T.accent+"18":"transparent",color:activeTab===id?T.accent:T.muted,fontSize:12,fontWeight:activeTab===id?700:400,cursor:"pointer"}}>{label}</button>
        ))}
        {callAI&&<button onClick={handleAIAdvice} disabled={aiLoading} style={{marginLeft:"auto",background:"#7c3aed",color:"#fff",border:"none",borderRadius:20,padding:"6px 16px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
          {aiLoading?"⏳ Analyzing...":"✨ AI Maintenance Advisor"}
        </button>}
      </div>

      {aiAdvice&&<Card accent="#7c3aed" style={{marginBottom:14,padding:"12px 16px"}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:"#7c3aed"}}>✨ AI Maintenance Advisor</div>
          <button onClick={()=>setAiAdvice("")} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:12}}>✕</button>
        </div>
        <div style={{fontSize:13,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap"}}>{aiAdvice}</div>
      </Card>}

      {/* Overview tab */}
      {activeTab==="overview"&&<div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,letterSpacing:.5,textTransform:"uppercase"}}>All Services</div>
          <button onClick={()=>setShowTemplates(s=>!s)} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>➕ Log Service</button>
        </div>
        {showTemplates&&<Card style={{marginBottom:12,padding:14}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:10,textTransform:"uppercase",letterSpacing:.5}}>Select Service to Log:</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:8}}>
            {FILTERED_TEMPLATES.map(tmpl=>(
              <button key={tmpl.id} onClick={()=>{openAdd(tmpl);setShowTemplates(false);}} style={{display:"flex",gap:8,alignItems:"center",padding:"8px 12px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,cursor:"pointer",textAlign:"left"}}>
                <span style={{fontSize:18}}>{tmpl.icon}</span>
                <div>
                  <div style={{fontSize:12,fontWeight:700,color:T.text}}>{tmpl.name}</div>
                  <div style={{fontSize:10,color:T.muted}}>{tmpl.category} · {tmpl.intervalMi>0?tmpl.intervalMi.toLocaleString()+" mi":tmpl.intervalDays>0?Math.round(tmpl.intervalDays/30)+" mo":tmpl.genHours+" hrs"}</div>
                </div>
              </button>
            ))}
          </div>
        </Card>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:10}}>
          {FILTERED_TEMPLATES.filter(t=>t.id!=="custom").map(tmpl=>{
            const st=getServiceStatus(tmpl);
            const logged=m.logs.filter(l=>l.serviceId===tmpl.id);
            return(
              <Card key={tmpl.id} style={{padding:"12px 14px",background:st.status==="tracked"?urgencyBg(st.urgency):T.bgMid,borderLeft:`3px solid ${st.status==="tracked"?urgencyColor(st.urgency):T.border}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <span style={{fontSize:20}}>{tmpl.icon}</span>
                    <div>
                      <div style={{fontSize:12,fontWeight:700,color:T.text}}>{tmpl.name}</div>
                      <div style={{fontSize:10,color:T.muted}}>{tmpl.category}</div>
                    </div>
                  </div>
                  <button onClick={()=>openAdd(tmpl)} style={{background:T.accent,color:"#fff",border:"none",borderRadius:6,padding:"3px 8px",fontSize:10,fontWeight:700,cursor:"pointer",flexShrink:0}}>Log</button>
                </div>
                {st.status==="tracked"
                  ?<div>
                    <div style={{fontSize:11,color:T.muted}}>Last: {st.lastDate} @ {(st.lastOdo||0).toLocaleString()} mi</div>
                    <div style={{fontSize:12,fontWeight:700,color:urgencyColor(st.urgency),marginTop:2}}>
                      {st.nextDue==="OVERDUE"?"⚠ OVERDUE":st.nextDue+" remaining"}
                    </div>
                  </div>
                  :<div style={{fontSize:11,color:T.muted}}>No service logged yet</div>
                }
                {logged.length>0&&<div style={{fontSize:10,color:T.muted,marginTop:4}}>{logged.length} service record{logged.length!==1?"s":""}</div>}
              </Card>
            );
          })}
        </div>
      </div>}

      {/* History tab */}
      {activeTab==="history"&&<div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,letterSpacing:.5,textTransform:"uppercase"}}>Service History ({m.logs.length} records)</div>
          <button onClick={()=>setShowTemplates(s=>!s)} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>➕ Log Service</button>
        </div>
        {showTemplates&&<Card style={{marginBottom:12,padding:14}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:6}}>
            {FILTERED_TEMPLATES.map(tmpl=>(
              <button key={tmpl.id} onClick={()=>{openAdd(tmpl);setShowTemplates(false);}} style={{display:"flex",gap:6,alignItems:"center",padding:"6px 10px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:6,cursor:"pointer"}}>
                <span>{tmpl.icon}</span><span style={{fontSize:11,fontWeight:600,color:T.text}}>{tmpl.name}</span>
              </button>
            ))}
          </div>
        </Card>}
        {m.logs.length===0
          ?<Card style={{padding:40,textAlign:"center"}}><div style={{fontSize:40,marginBottom:8}}>🔧</div><div style={{color:T.muted,fontSize:14}}>No service records yet. Log your first service above.</div></Card>
          :[...m.logs].sort((a,b)=>new Date(b.date)-new Date(a.date)).map(log=>{
            const tmpl=RV_SERVICE_TEMPLATES.find(t=>t.id===log.serviceId)||RV_SERVICE_TEMPLATES[RV_SERVICE_TEMPLATES.length-1];
            return(
              <Card key={log.id} style={{marginBottom:8,padding:"12px 16px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:6}}>
                  <div style={{display:"flex",gap:10,alignItems:"center"}}>
                    <span style={{fontSize:24}}>{tmpl.icon}</span>
                    <div>
                      <div style={{fontWeight:700,fontSize:14,color:T.text}}>{log.serviceName}</div>
                      <div style={{fontSize:11,color:T.muted}}>{log.date} · {(log.odometer||0).toLocaleString()} mi{log.genHours>0?" · "+log.genHours+" gen-hrs":""}</div>
                      {log.shop&&<div style={{fontSize:11,color:T.muted}}>📍 {log.shop}</div>}
                      {log.notes&&<div style={{fontSize:12,color:T.text,marginTop:4,fontStyle:"italic"}}>"{log.notes}"</div>}
                    </div>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    {log.cost>0&&<div style={{fontFamily:T.F.head,fontWeight:800,fontSize:16,color:T.free}}>${parseFloat(log.cost).toFixed(2)}</div>}
                    <button onClick={()=>{setDraft({...log});setShowAddLog(true);}} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 8px",fontSize:11,cursor:"pointer",color:T.muted}}>✏ Edit</button>
                    <button onClick={()=>deleteLog(log.id)} style={{background:"none",border:`1px solid ${T.danger}44`,borderRadius:6,padding:"4px 8px",fontSize:11,cursor:"pointer",color:T.danger}}>✕</button>
                  </div>
                </div>
              </Card>
            );
          })
        }
      </div>}

      {/* Costs tab */}
      {activeTab==="costs"&&<div>
        <Card style={{marginBottom:12,padding:"16px 20px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}}>💰 Annual Cost Summary</div>
          {[currentYear,currentYear-1,currentYear-2].map(yr=>{
            const logs=m.logs.filter(l=>l.date&&new Date(l.date).getFullYear()===yr);
            const total=logs.reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
            if(logs.length===0) return null;
            const cats=logs.reduce((a,l)=>{a[l.category]=(a[l.category]||0)+(parseFloat(l.cost)||0);return a;},{});
            return(
              <div key={yr} style={{marginBottom:16}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:8}}>
                  <div style={{fontFamily:T.F.cond,fontWeight:800,fontSize:16,color:T.text}}>{yr}</div>
                  <div style={{fontFamily:T.F.head,fontWeight:800,fontSize:20,color:T.free}}>${Math.round(total).toLocaleString()}</div>
                </div>
                {Object.entries(cats).map(([cat,cost])=>(
                  <div key={cat} style={{display:"flex",justifyContent:"space-between",marginBottom:4,padding:"4px 8px",background:T.bgLite,borderRadius:6}}>
                    <span style={{fontSize:12,color:T.muted}}>{cat}</span>
                    <span style={{fontSize:12,fontWeight:600,color:T.text}}>${Math.round(cost).toLocaleString()}</span>
                  </div>
                ))}
                <div style={{fontSize:11,color:T.muted,marginTop:4}}>{logs.length} service records · avg ${Math.round(total/Math.max(logs.length,1))}/service</div>
              </div>
            );
          })}
          {m.logs.length===0&&<div style={{textAlign:"center",color:T.muted,fontSize:13,padding:20}}>Log services to see cost breakdowns.</div>}
        </Card>
        {m.logs.length>0&&<Card style={{padding:"14px 18px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:10,textTransform:"uppercase",letterSpacing:.5}}>Cost Per Mile</div>
          {(()=>{
            const totalCost=m.logs.reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
            const totalMi=currentOdo>0?currentOdo:1;
            const cpm=totalCost/totalMi;
            return<div>
              <div style={{fontSize:28,fontWeight:800,color:T.accent,fontFamily:T.F.head}}>${cpm.toFixed(3)}<span style={{fontSize:14,color:T.muted}}>/mile</span></div>
              <div style={{fontSize:12,color:T.muted,marginTop:4}}>Based on ${Math.round(totalCost).toLocaleString()} total maintenance over {totalMi.toLocaleString()} miles</div>
            </div>;
          })()}
        </Card>}
      </div>}

      {/* Add/Edit Log Modal */}
      {showAddLog&&draft&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget){setShowAddLog(false);setDraft(null);}}}>
        <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:520,maxHeight:"90vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 24px 80px rgba(0,0,0,0.5)"}}>
          <div style={{background:T.accent,padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontFamily:T.F.cond,fontWeight:900,fontSize:18,color:"#fff"}}>🔧 {draft.serviceName}</div>
            <button onClick={()=>{setShowAddLog(false);setDraft(null);}} style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:"#fff",fontSize:16}}>✕</button>
          </div>
          <div style={{flex:1,overflowY:"auto",padding:"20px"}}>
            {draft.serviceId==="custom"&&<div style={{marginBottom:12}}>
              <Label>Service Name</Label>
              <Inp value={draft.serviceName} onChange={e=>setDraft(d=>({...d,serviceName:e.target.value}))} placeholder="e.g. Slideout Motor Repair"/>
            </div>}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
              <div><Label>Date</Label><Inp type="date" value={draft.date} onChange={e=>setDraft(d=>({...d,date:e.target.value}))}/></div>
              <div><Label>Odometer (mi)</Label><Inp type="number" value={draft.odometer} onChange={e=>setDraft(d=>({...d,odometer:parseFloat(e.target.value)||0}))}/></div>
              <div><Label>Cost ($)</Label><Inp type="number" step="0.01" value={draft.cost} onChange={e=>setDraft(d=>({...d,cost:parseFloat(e.target.value)||0}))}/></div>
              {(draft.serviceId==="generator")&&<div><Label>Generator Hours</Label><Inp type="number" value={draft.genHours} onChange={e=>setDraft(d=>({...d,genHours:parseFloat(e.target.value)||0}))}/></div>}
            </div>
            <div style={{marginBottom:12}}><Label>Shop / Location</Label><Inp value={draft.shop} onChange={e=>setDraft(d=>({...d,shop:e.target.value}))} placeholder="e.g. Camping World, Foley AL"/></div>
            <div style={{marginBottom:12}}><Label>Notes</Label><Inp value={draft.notes} onChange={e=>setDraft(d=>({...d,notes:e.target.value}))} placeholder="Parts used, observations, etc."/></div>
            <div style={{background:T.bgLite,borderRadius:10,padding:"12px 14px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>Next Service Due</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                {draft.nextDueMi>0&&<div><Label>Next Due (mi)</Label><Inp type="number" value={draft.nextDueMi} onChange={e=>setDraft(d=>({...d,nextDueMi:parseFloat(e.target.value)||0}))}/></div>}
                <div><Label>Next Due (date)</Label><Inp type="date" value={draft.nextDueDate} onChange={e=>setDraft(d=>({...d,nextDueDate:e.target.value}))}/></div>
              </div>
            </div>
          </div>
          <div style={{padding:"14px 20px",borderTop:`1px solid ${T.border}`,display:"flex",gap:10}}>
            <button onClick={()=>{setShowAddLog(false);setDraft(null);}} style={{flex:1,background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"11px",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>Cancel</button>
            <button onClick={saveLog} style={{flex:2,background:T.accent,color:"#fff",border:"none",borderRadius:10,padding:"11px",fontSize:13,fontWeight:700,cursor:"pointer"}}>💾 Save Service Record</button>
          </div>
        </div>
      </div>}
      {isTowing&&<TowVehicleMaintenanceCard rvMaintenance={rvMaintenance} onChange={onChange} vehicle={vehicle}/>}
    </div>
  );
}


// ── FillupSection ─────────────────────────────────────────────────
function FillupSection({rvMaintenance,onChange,vehicle}){
  const T=useTheme();
  const m=rvMaintenance;
  const f=(k,v)=>onChange({...m,[k]:v});
  const [showAdd,setShowAdd]=useState(false);
  const [draft,setDraft]=useState(null);

  const openAdd=()=>{
    const last=m.fillups.sort((a,b)=>new Date(b.date)-new Date(a.date))[0];
    setDraft(mkFillup({
      date:new Date().toISOString().slice(0,10),
      odometer:last?parseFloat(last.odometer)+200:parseFloat(m.currentOdometer)||0,
      fuelType:vehicle.fuelType||"Diesel",
    }));
    setShowAdd(true);
  };

  const saveFillup=()=>{
    if(!draft) return;
    const total=parseFloat(draft.gallons)*parseFloat(draft.pricePerGal);
    const existing=m.fillups.find(f=>f.id===draft.id);
    const upd={...draft,totalCost:isNaN(total)?0:parseFloat(total.toFixed(2))};
    const newFillups=existing?m.fillups.map(f=>f.id===upd.id?upd:f):[...m.fillups,upd];
    f("fillups",newFillups);
    setShowAdd(false);setDraft(null);
  };

  const deleteFillup=(id)=>{
    if(!window.confirm("Delete this fill-up record?")) return;
    f("fillups",m.fillups.filter(fu=>fu.id!==id));
  };

  // Calculate real MPG between consecutive fillups
  const sorted=[...m.fillups].sort((a,b)=>parseFloat(a.odometer)-parseFloat(b.odometer));
  const withMPG=sorted.map((fu,i)=>{
    if(i===0) return{...fu,realMpg:null};
    const prev=sorted[i-1];
    const miles=parseFloat(fu.odometer)-parseFloat(prev.odometer);
    const gals=parseFloat(fu.gallons);
    const mpg=(miles>0&&gals>0)?miles/gals:null;
    return{...fu,realMpg:mpg?parseFloat(mpg.toFixed(1)):null};
  }).reverse();

  const avgMpg=withMPG.filter(f=>f.realMpg).reduce((a,f,_,arr)=>a+f.realMpg/arr.length,0);
  const estMpg=parseFloat(vehicle.mpg)||8;
  const totalSpent=m.fillups.reduce((a,f)=>a+(parseFloat(f.totalCost)||0),0);
  const totalGal=m.fillups.reduce((a,f)=>a+(parseFloat(f.gallons)||0),0);

  return(
    <div className="anim">
      <SecHead icon="⛽" title="Fuel Fill-up Log" sub="Track every fill-up. Real MPG calculated automatically between entries."/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:10,marginBottom:16}}>
        <Card style={{padding:"12px 14px"}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:2,fontFamily:T.F.cond,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Real MPG</div>
          <div style={{fontSize:24,fontWeight:800,color:avgMpg>estMpg?T.free:avgMpg>0&&avgMpg<estMpg-1?T.danger:T.accent,fontFamily:T.F.head}}>{avgMpg>0?avgMpg.toFixed(1):"-"}</div>
          <div style={{fontSize:10,color:T.muted}}>est. {estMpg} MPG</div>
        </Card>
        <Card style={{padding:"12px 14px"}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:2,fontFamily:T.F.cond,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Total Spent</div>
          <div style={{fontSize:22,fontWeight:800,color:T.text,fontFamily:T.F.head}}>${Math.round(totalSpent).toLocaleString()}</div>
          <div style={{fontSize:10,color:T.muted}}>{m.fillups.length} fill-ups</div>
        </Card>
        <Card style={{padding:"12px 14px"}}>
          <div style={{fontSize:11,color:T.muted,marginBottom:2,fontFamily:T.F.cond,fontWeight:600,textTransform:"uppercase",letterSpacing:.5}}>Total Gallons</div>
          <div style={{fontSize:22,fontWeight:800,color:T.accent,fontFamily:T.F.head}}>{totalGal.toFixed(1)}</div>
          <div style={{fontSize:10,color:T.muted}}>avg ${totalGal>0?(totalSpent/totalGal).toFixed(3):0}/gal</div>
        </Card>
      </div>
      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
        <button onClick={openAdd} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 18px",fontSize:12,fontWeight:700,cursor:"pointer"}}>➕ Log Fill-up</button>
      </div>
      {m.fillups.length===0
        ?<Card style={{padding:40,textAlign:"center"}}><div style={{fontSize:40,marginBottom:8}}>⛽</div><div style={{color:T.muted,fontSize:14}}>No fill-ups logged yet. Track every fill-up to see your real MPG.</div></Card>
        :withMPG.map(fu=>(
          <Card key={fu.id} style={{marginBottom:8,padding:"12px 16px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
              <div style={{display:"flex",gap:12,alignItems:"center"}}>
                <div style={{fontSize:28}}>⛽</div>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:T.text}}>{fu.date} · {parseFloat(fu.odometer||0).toLocaleString()} mi</div>
                  <div style={{fontSize:12,color:T.muted}}>{fu.gallons} gal @ ${parseFloat(fu.pricePerGal||0).toFixed(3)}/gal · {fu.fuelType}{fu.station?" · "+fu.station:""}</div>
                  {fu.realMpg&&<div style={{fontSize:12,fontWeight:700,color:fu.realMpg>estMpg?T.free:fu.realMpg<estMpg-1?T.danger:T.muted,marginTop:2}}>
                    Real MPG: {fu.realMpg} {fu.realMpg>estMpg?"✓ above est":"⚠ below est"}
                  </div>}
                </div>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <div style={{fontFamily:T.F.head,fontWeight:800,fontSize:18,color:T.accent}}>${parseFloat(fu.totalCost||fu.gallons*fu.pricePerGal||0).toFixed(2)}</div>
                <button onClick={()=>deleteFillup(fu.id)} style={{background:"none",border:`1px solid ${T.danger}44`,borderRadius:6,padding:"4px 8px",fontSize:11,cursor:"pointer",color:T.danger}}>✕</button>
              </div>
            </div>
          </Card>
        ))
      }
      {showAdd&&draft&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget){setShowAdd(false);setDraft(null);}}}>
        <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:440,boxShadow:"0 24px 80px rgba(0,0,0,0.5)",overflow:"hidden"}}>
          <div style={{background:T.accentAlt||T.accent,padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontFamily:T.F.cond,fontWeight:900,fontSize:16,color:"#fff"}}>⛽ Log Fill-up</div>
            <button onClick={()=>{setShowAdd(false);setDraft(null);}} style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:26,height:26,cursor:"pointer",color:"#fff",fontSize:14}}>✕</button>
          </div>
          <div style={{padding:20}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
              <div><Label>Date</Label><Inp type="date" value={draft.date} onChange={e=>setDraft(d=>({...d,date:e.target.value}))}/></div>
              <div><Label>Odometer (mi)</Label><Inp type="number" value={draft.odometer} onChange={e=>setDraft(d=>({...d,odometer:parseFloat(e.target.value)||0}))}/></div>
              <div><Label>Gallons</Label><Inp type="number" step="0.1" value={draft.gallons} onChange={e=>setDraft(d=>({...d,gallons:parseFloat(e.target.value)||0}))}/></div>
              <div><Label>Price/Gallon ($)</Label><Inp type="number" step="0.001" value={draft.pricePerGal} onChange={e=>setDraft(d=>({...d,pricePerGal:parseFloat(e.target.value)||0}))}/></div>
            </div>
            <div style={{marginBottom:12}}>
              <Label>Fuel Type</Label>
              <Sel value={draft.fuelType} onChange={e=>setDraft(d=>({...d,fuelType:e.target.value}))}>
                {["Diesel","Gasoline","Propane","Electric/Hybrid"].map(v=><option key={v}>{v}</option>)}
              </Sel>
            </div>
            <div style={{marginBottom:12}}><Label>Station</Label><Inp value={draft.station} onChange={e=>setDraft(d=>({...d,station:e.target.value}))} placeholder="e.g. Love's Travel Stop, Amarillo TX"/></div>
            {draft.gallons>0&&draft.pricePerGal>0&&<div style={{background:T.bgLite,borderRadius:8,padding:"10px 14px",marginBottom:12,textAlign:"center"}}>
              <div style={{fontSize:11,color:T.muted}}>Total Cost</div>
              <div style={{fontSize:24,fontWeight:800,color:T.accent,fontFamily:T.F.head}}>${(parseFloat(draft.gallons)*parseFloat(draft.pricePerGal)).toFixed(2)}</div>
            </div>}
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>{setShowAdd(false);setDraft(null);}} style={{flex:1,background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:11,color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>Cancel</button>
              <button onClick={saveFillup} style={{flex:2,background:T.accent,color:"#fff",border:"none",borderRadius:10,padding:11,fontSize:13,fontWeight:700,cursor:"pointer"}}>💾 Save Fill-up</button>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}


// ── ChecklistSection ──────────────────────────────────────────────
const DEFAULT_CHECKLISTS={
  departure:[
    {id:"c1",text:"Disconnect shore power / electric",done:false},
    {id:"c2",text:"Disconnect water hose",done:false},
    {id:"c3",text:"Disconnect sewer hose",done:false},
    {id:"c4",text:"Retract all slideouts",done:false},
    {id:"c5",text:"Retract awnings",done:false},
    {id:"c6",text:"Retract steps",done:false},
    {id:"c7",text:"Close all roof vents and windows",done:false},
    {id:"c8",text:"Secure all cabinet latches",done:false},
    {id:"c9",text:"Secure refrigerator latch",done:false},
    {id:"c10",text:"Check tire pressure",done:false},
    {id:"c11",text:"Check tow vehicle connection (if applicable)",done:false},
    {id:"c12",text:"Check all exterior lights (headlights, taillights, brake lights, turn signals)",done:false},
    {id:"c12b",text:"Check running lights and marker lights",done:false},
    {id:"c13",text:"Walk-around safety check",done:false},
    {id:"c14",text:"GPS route confirmed",done:false},
    {id:"c15",text:"Dump tanks if needed",done:false},
  ],
  arrival:[
    {id:"a1",text:"Level the RV",done:false},
    {id:"a2",text:"Deploy stabilizer jacks",done:false},
    {id:"a3",text:"Connect shore power",done:false},
    {id:"a4",text:"Connect water hose",done:false},
    {id:"a5",text:"Connect sewer hose",done:false},
    {id:"a6",text:"Extend slideouts",done:false},
    {id:"a7",text:"Extend awning",done:false},
    {id:"a8",text:"Deploy steps",done:false},
    {id:"a9",text:"Test propane appliances",done:false},
    {id:"a10",text:"Set up outdoor furniture",done:false},
    {id:"a11",text:"Check in at office (if applicable)",done:false},
  ],
  monthly:[
    {id:"m1",text:"Check roof for damage or soft spots",done:false},
    {id:"m2",text:"Lubricate slideout seals",done:false},
    {id:"m3",text:"Run generator under load (2+ hours)",done:false},
    {id:"m4",text:"Check battery water levels",done:false},
    {id:"m5",text:"Inspect tires for cracking or wear",done:false},
    {id:"m6",text:"Test smoke and CO detectors",done:false},
    {id:"m7",text:"Check propane levels",done:false},
    {id:"m8",text:"Flush water heater",done:false},
  ]
};

function ChecklistSection({vehicle}){
  const T=useTheme();
  const STORE="rv-checklists";
  // Generate vehicle-aware checklists
  const getDefaultLists=()=>{
    const isTowing=["Fifth Wheel","Travel Trailer","Toy Hauler"].includes(vehicle?.rvType);
    const isMotorized=["Class A","Class B","Class C","Class B+"].some(t=>vehicle?.rvType?.includes(t));
    const base=JSON.parse(JSON.stringify(DEFAULT_CHECKLISTS));
    if(isTowing){
      base.departure=[
        ...base.departure,
        {id:"tw1",text:"Check kingpin / hitch connection is locked",done:false},
        {id:"tw2",text:"Attach safety chains (crossed under tongue)",done:false},
        {id:"tw3",text:"Connect trailer brake controller - test activation",done:false},
        {id:"tw4",text:"Connect 7-pin electrical plug - verify lights",done:false},
        {id:"tw5",text:"Check tow vehicle tire pressure",done:false},
        {id:"tw6",text:"Check tongue / pin weight within tow vehicle limits",done:false},
        {id:"tw7",text:"Verify trailer brakes engaged (parking brake test)",done:false},
        {id:"tw8",text:"Check weight distribution bars / sway control (if equipped)",done:false},
        {id:"tw9",text:"Walk around: clearance lights, running lights, brake lights, turn signals",done:false},
        {id:"tw10",text:"Check trailer tongue jack fully retracted",done:false},
      ];
      base.arrival=[
        ...base.arrival,
        {id:"ta1",text:"Unhitch trailer - engage parking brake first",done:false},
        {id:"ta2",text:"Remove safety chains and electrical connection",done:false},
        {id:"ta3",text:"Deploy tongue / pin jack to support trailer",done:false},
      ];
    }
    if(isMotorized){
      base.departure=[
        {id:"mv1",text:"Check engine oil level",done:false},
        {id:"mv2",text:"Check coolant level",done:false},
        {id:"mv3",text:"Check windshield washer fluid",done:false},
        ...base.departure,
      ];
    }
    return base;
  };
  const [lists,setLists]=useState(()=>{
    try{const s=localStorage.getItem(STORE);return s?JSON.parse(s):getDefaultLists();}
    catch{return getDefaultLists();}
  });
  const [activeList,setActiveList]=useState("departure");
  const [newItem,setNewItem]=useState("");

  const save=(updated)=>{
    setLists(updated);
    try{localStorage.setItem(STORE,JSON.stringify(updated));}catch{}
  };

  const toggle=(id)=>{
    save({...lists,[activeList]:lists[activeList].map(item=>item.id===id?{...item,done:!item.done}:item)});
  };

  const addItem=()=>{
    if(!newItem.trim()) return;
    const item={id:uid(),text:newItem.trim(),done:false};
    save({...lists,[activeList]:[...lists[activeList],item]});
    setNewItem("");
  };

  const removeItem=(id)=>{
    save({...lists,[activeList]:lists[activeList].filter(i=>i.id!==id)});
  };

  const resetList=()=>{
    if(!window.confirm("Reset all checkboxes to unchecked?")) return;
    save({...lists,[activeList]:lists[activeList].map(i=>({...i,done:false}))});
  };
  const resetToDefaults=()=>{
    if(!window.confirm("Reset to default checklist for your RV type? Custom items will be lost.")) return;
    const defaults=getDefaultLists();
    save({...lists,[activeList]:defaults[activeList]});
  };

  const current=lists[activeList]||[];
  const doneCount=current.filter(i=>i.done).length;
  const pct=current.length>0?Math.round(doneCount/current.length*100):0;

  return(
    <div className="anim">
      <SecHead icon="✅" title="Trip Checklists" sub="Pre-departure, arrival, and monthly maintenance checklists. Check off as you go."/>
      <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
        {[["departure","🚪 Departure"],["arrival","🏕 Arrival"],["monthly","📅 Monthly"]].map(([id,label])=>(
          <button key={id} onClick={()=>setActiveList(id)} style={{flex:1,padding:"8px 12px",borderRadius:10,border:`1px solid ${activeList===id?T.accent:T.border}`,background:activeList===id?T.accent+"18":"transparent",color:activeList===id?T.accent:T.muted,fontSize:13,fontWeight:activeList===id?700:400,cursor:"pointer"}}>{label}</button>
        ))}
      </div>

      {/* Progress bar */}
      <div style={{marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <div style={{fontSize:13,fontWeight:700,color:pct===100?T.free:T.text}}>{doneCount} of {current.length} complete</div>
          <div style={{display:"flex",gap:8}}>
            <span style={{fontSize:13,fontWeight:800,color:pct===100?T.free:T.accent}}>{pct}%</span>
            <button onClick={resetList} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:6,padding:"2px 8px",fontSize:11,color:T.muted,cursor:"pointer"}}>↺ Reset</button>
          </div>
        </div>
        <div style={{height:8,background:T.bgLite,borderRadius:4,overflow:"hidden"}}>
          <div style={{height:"100%",width:pct+"%",background:pct===100?T.free:T.accent,borderRadius:4,transition:"width .3s"}}/>
        </div>
      </div>

      {pct===100&&<Card accent={T.free} style={{marginBottom:12,padding:"12px 16px",textAlign:"center"}}>
        <div style={{fontSize:24,marginBottom:4}}>🎉</div>
        <div style={{fontWeight:700,color:T.free}}>All done! You're ready to {activeList==="departure"?"hit the road":"settle in"}.</div>
      </Card>}

      {/* Checklist items */}
      <Card style={{marginBottom:12,padding:"8px 4px"}}>
        {current.map((item,i)=>(
          <div key={item.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderBottom:i<current.length-1?`1px solid ${T.border}`:""}}
            onClick={()=>toggle(item.id)} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",cursor:"pointer",borderBottom:i<current.length-1?`1px solid ${T.border}`:"",background:item.done?T.free+"08":"transparent"}}>
            <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${item.done?T.free:T.border}`,background:item.done?T.free:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all .15s"}}>
              {item.done&&<span style={{color:"#fff",fontSize:13,fontWeight:900}}>✓</span>}
            </div>
            <div style={{flex:1,fontSize:13,color:item.done?T.muted:T.text,textDecoration:item.done?"line-through":"none",transition:"all .2s"}}>{item.text}</div>
            <button onClick={e=>{e.stopPropagation();removeItem(item.id);}} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,opacity:.5,padding:"0 4px"}}>✕</button>
          </div>
        ))}
      </Card>

      {/* Add custom item */}
      <div style={{display:"flex",gap:8}}>
        <Inp value={newItem} onChange={e=>setNewItem(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")addItem();}} placeholder="Add custom checklist item..." style={{flex:1}}/>
        <button onClick={addItem} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"9px 16px",fontSize:13,fontWeight:700,cursor:"pointer",flexShrink:0}}>➕ Add</button>
      </div>
    </div>
  );
}


// ── FinancesMonthlySection ────────────────────────────────────────
function FinancesMonthlySection({finances,onChange,rvMaintenance,vehicle,stops,settings,callAI}){
  const T=useTheme();
  const fullMode=settings?.financeFullMode||false;
  const now=new Date();
  const [selYear,setSelYear]=useState(now.getFullYear());
  const [selMonth,setSelMonth]=useState(now.getMonth());
  const monthKey=`${selYear}-${String(selMonth+1).padStart(2,"0")}`;
  const months=finances.months||{};
  const mData=months[monthKey]||mkMonth();

  const setExp=(catId,val)=>{
    const updated={...months,[monthKey]:{...mData,expenses:{...mData.expenses,[catId]:parseFloat(val)||0}}};
    onChange({...finances,months:updated});
  };
  const setInc=(catId,val)=>{
    const updated={...months,[monthKey]:{...mData,income:{...mData.income,[catId]:parseFloat(val)||0}}};
    onChange({...finances,months:updated});
  };
  const setField=(k,v)=>{
    const updated={...months,[monthKey]:{...mData,[k]:v}};
    onChange({...finances,months:updated});
  };

  // Auto-pull from maintenance log and fillups for this month
  const autoFill=()=>{
    const yr=selYear,mo=selMonth+1;
    const inMonth=(date)=>{
      if(!date) return false;
      const d=new Date(date);
      return d.getFullYear()===yr&&d.getMonth()+1===mo;
    };
    const maintLogs=rvMaintenance?.logs||[];
    const fillups=rvMaintenance?.fillups||[];
    const routineCost=maintLogs.filter(l=>inMonth(l.date)&&["oil","transmission","tires_rotate","brakes","bearings","airfilter","coolant"].includes(l.serviceId)).reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
    const repairCost=maintLogs.filter(l=>inMonth(l.date)&&!["oil","transmission","tires_rotate","brakes","bearings","airfilter","coolant"].includes(l.serviceId)).reduce((a,l)=>a+(parseFloat(l.cost)||0),0);
    const fuelCost=fillups.filter(f=>inMonth(f.date)).reduce((a,f)=>a+(parseFloat(f.totalCost)||parseFloat(f.gallons)*parseFloat(f.pricePerGal)||0),0);
    // Get nights from stops in this month
    const stopsNights=stops.filter(s=>s.active&&s.arriveDate&&inMonth(s.arriveDate)).reduce((a,s)=>a+(s.nights||0),0);
    const updated={...months,[monthKey]:{...mData,
      expenses:{...mData.expenses,
        maint_routine:routineCost||mData.expenses.maint_routine,
        maint_repair:repairCost||mData.expenses.maint_repair,
        fuel:fuelCost||mData.expenses.fuel,
      },
      nights:stopsNights||mData.nights,
    }};
    onChange({...finances,months:updated});
    alert("Auto-filled fuel, maintenance, and nights from your logs for "+new Date(yr,mo-1).toLocaleString("default",{month:"long",year:"numeric"})+".");
  };

  const totalExp=EXPENSE_CATS.reduce((a,c)=>a+(mData.expenses[c.id]||0),0);
  const totalInc=fullMode?INCOME_CATS.reduce((a,c)=>a+(mData.income[c.id]||0),0):0;
  const net=totalInc-totalExp;
  const costPerDay=mData.nights>0?totalExp/mData.nights:mData.miles>0?totalExp/(mData.miles/60):0;

  const [aiBudgetMsg,setAiBudgetMsg]=useState("");
  const [aiBudgetLoading,setAiBudgetLoading]=useState(false);
  const huntOn=settings?.huntingEnabled||false;
  const visibleCats=EXPENSE_CATS.filter(c=>c.group!=="Hunting"||huntOn);
  const groups=[...new Set(visibleCats.map(c=>c.group))];
  const monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];



  const analyzeMonth=async()=>{
    if(!callAI){setAiBudgetMsg("AI not available. Please enable AI Co-Pilot in settings.");return;}
    setAiBudgetLoading(true);
    setAiBudgetMsg("");
    try{
      // Build expense summary for the selected month
      const expLines=EXPENSE_CATS
        .filter(c=>mData.expenses[c.id]>0)
        .map(c=>c.label+": $"+Math.round(mData.expenses[c.id]).toLocaleString())
        .join(", ");
      const totalExp=EXPENSE_CATS.reduce((a,c)=>a+(mData.expenses[c.id]||0),0);
      const totalInc=INCOME_CATS.reduce((a,c)=>a+(mData.income?.[c.id]||0),0);
      const budget=settings?.monthlyBudget||0;
      const monthName=monthNames[selMonth]+" "+selYear;
      const prompt=[
        "You are an RV full-timer budget advisor. Analyze this monthly spending snapshot and give concise, practical advice.",
        "Month: "+monthName,
        "Expenses: "+expLines,
        "Total Expenses: $"+Math.round(totalExp).toLocaleString(),
        totalInc>0?"Total Income: $"+Math.round(totalInc).toLocaleString():"",
        budget>0?"Monthly Budget Target: $"+budget.toLocaleString():"",
        mData.notes?"Notes: "+mData.notes:"",
        "Vehicle: "+(vehicle?.rvType||"RV")+", "+Math.round(vehicle?.mpg||8)+" MPG",
        "Give 3-4 specific insights: what's high, what looks good, and 1-2 actionable tips to reduce costs next month. Keep it under 150 words. Be direct and practical for full-time RVers."
      ].filter(Boolean).join("\n");
      const result=await callAI(prompt,{maxTokens:300});
      setAiBudgetMsg(result||"No analysis returned.");
    }catch(e){
      setAiBudgetMsg("Analysis failed: "+e.message);
    }finally{
      setAiBudgetLoading(false);
    }
  };


  return(
    <div className="anim">
      <SecHead icon="📅" title="Monthly Expense Log" sub="Track your full-timer spending month by month. Auto-fills from your maintenance and fuel logs."/>

      {/* Month selector */}
      <Card style={{marginBottom:14,padding:"12px 16px"}}>
        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
          <Sel value={selMonth} onChange={e=>setSelMonth(parseInt(e.target.value))} style={{flex:1,minWidth:120}}>
            {monthNames.map((m,i)=><option key={i} value={i}>{m}</option>)}
          </Sel>
          <Sel value={selYear} onChange={e=>setSelYear(parseInt(e.target.value))} style={{width:100}}>
            {[now.getFullYear(),now.getFullYear()-1,now.getFullYear()-2].map(y=><option key={y}>{y}</option>)}
          </Sel>
          <Btn onClick={autoFill} variant="ghost" style={{fontSize:12,borderColor:T.accent+"44",color:T.accent}}>⚡ Auto-fill from logs</Btn>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:8,marginTop:12}}>
          <div style={{background:T.danger+"12",borderRadius:8,padding:"8px 12px",textAlign:"center"}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:2}}>Total Spent</div>
            <div style={{fontSize:20,fontWeight:800,color:T.danger,fontFamily:T.F.head}}>${Math.round(totalExp).toLocaleString()}</div>
          </div>
          {fullMode&&<div style={{background:T.free+"12",borderRadius:8,padding:"8px 12px",textAlign:"center"}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:2}}>Total Income</div>
            <div style={{fontSize:20,fontWeight:800,color:T.free,fontFamily:T.F.head}}>${Math.round(totalInc).toLocaleString()}</div>
          </div>}
          {fullMode&&<div style={{background:(net>=0?T.free:T.danger)+"12",borderRadius:8,padding:"8px 12px",textAlign:"center"}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:2}}>Net</div>
            <div style={{fontSize:20,fontWeight:800,color:net>=0?T.free:T.danger,fontFamily:T.F.head}}>{net>=0?"+":""}{Math.round(net).toLocaleString()}</div>
          </div>}
          <div style={{background:T.accent+"12",borderRadius:8,padding:"8px 12px",textAlign:"center"}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:2}}>Cost/Day</div>
            <div style={{fontSize:20,fontWeight:800,color:T.accent,fontFamily:T.F.head}}>{costPerDay>0?"$"+Math.round(costPerDay):"-"}</div>
          </div>
        </div>
      </Card>

      {callAI&&totalExp>0&&<div style={{marginBottom:14}}>
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <button onClick={analyzeMonth} disabled={aiBudgetLoading} style={{background:aiBudgetLoading?"#7c3aed88":"#7c3aed",color:"#fff",border:"none",borderRadius:20,padding:"7px 18px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
            {aiBudgetLoading?"Analyzing...":"✨ Analyze This Month"}
          </button>
        </div>
        {aiBudgetMsg&&<Card accent="#7c3aed" style={{marginTop:8,padding:"12px 16px"}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:"#7c3aed"}}>✨ AI Budget Analysis - {monthNames[selMonth]} {selYear}</div>
            <button onClick={()=>setAiBudgetMsg("")} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:12}}>✕</button>
          </div>
          <div style={{fontSize:13,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap"}}>{aiBudgetMsg}</div>
        </Card>}
      </div>}
      {/* Income section (full mode only) */}
      {fullMode&&<Card accent={T.free} style={{marginBottom:14,padding:"14px 18px"}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.free,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}}>💰 Income</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
          {INCOME_CATS.map(cat=>(
            <div key={cat.id}>
              <div style={{fontSize:11,color:T.muted,marginBottom:4,display:"flex",alignItems:"center",gap:4}}>
                <span>{cat.icon}</span><span>{cat.label}</span>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                <span style={{color:T.muted,fontSize:14}}>$</span>
                <Inp type="number" step="1" value={mData.income[cat.id]||""} onChange={e=>setInc(cat.id,e.target.value)} placeholder="0" style={{flex:1}}/>
              </div>
            </div>
          ))}
        </div>
      </Card>}

      {/* Expenses by group */}
      {groups.map(group=>{
        const cats=EXPENSE_CATS.filter(c=>c.group===group);
        const groupTotal=cats.reduce((a,c)=>a+(mData.expenses[c.id]||0),0);
        return(
          <Card key={group} style={{marginBottom:12,padding:"14px 18px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>{group}</div>
              {groupTotal>0&&<div style={{fontSize:14,fontWeight:700,color:T.text}}>${Math.round(groupTotal).toLocaleString()}</div>}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(190px,1fr))",gap:10}}>
              {cats.map(cat=>(
                <div key={cat.id}>
                  <div style={{fontSize:11,color:T.muted,marginBottom:4,display:"flex",alignItems:"center",gap:4}}>
                    <span>{cat.icon}</span>
                    <span style={{color:(mData.expenses[cat.id]||0)>0?cat.color:T.muted}}>{cat.label}</span>
                    {(mData.expenses[cat.id]||0)>0&&<span style={{marginLeft:"auto",fontWeight:700,color:cat.color}}>${(mData.expenses[cat.id]||0).toLocaleString()}</span>}
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <span style={{color:T.muted,fontSize:14}}>$</span>
                    <Inp type="number" step="1" value={mData.expenses[cat.id]||""} onChange={e=>setExp(cat.id,e.target.value)} placeholder="0" style={{flex:1}}/>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        );
      })}

      {/* Month context */}
      <Card style={{marginBottom:14,padding:"14px 18px"}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:10,textTransform:"uppercase",letterSpacing:.5}}>📍 Month Context</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <div><Label>Nights camped</Label><Inp type="number" value={mData.nights||""} onChange={e=>setField("nights",parseInt(e.target.value)||0)} placeholder="28"/></div>
          <div><Label>Miles traveled</Label><Inp type="number" value={mData.miles||""} onChange={e=>setField("miles",parseInt(e.target.value)||0)} placeholder="800"/></div>
          <div style={{gridColumn:"1/-1"}}><Label>States visited / notes</Label><Inp value={mData.notes||""} onChange={e=>setField("notes",e.target.value)} placeholder="TX, NM - water pump repair in Albuquerque"/></div>
        </div>
      </Card>
    </div>
  );
}


// ── FinancesAnnualSection ─────────────────────────────────────────
function FinancesAnnualSection({finances,rvMaintenance}){
  const T=useTheme();
  const now=new Date();
  const [selYear,setSelYear]=useState(now.getFullYear());
  const months=finances.months||{};

  // Get all months for this year
  const yearMonths=Array.from({length:12},(_,i)=>{
    const key=`${selYear}-${String(i+1).padStart(2,"0")}`;
    return{key,month:i,data:months[key]||mkMonth()};
  });

  const monthNames=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const monthTotal=(m)=>EXPENSE_CATS.reduce((a,c)=>a+(m.expenses[c.id]||0),0);
  const monthIncome=(m)=>INCOME_CATS.reduce((a,c)=>a+(m.income[c.id]||0),0);

  const totals=yearMonths.map(m=>monthTotal(m.data));
  const incomes=yearMonths.map(m=>monthIncome(m.data));
  const maxTotal=Math.max(...totals,1);
  const annualTotal=totals.reduce((a,v)=>a+v,0);
  const annualIncome=incomes.reduce((a,v)=>a+v,0);
  const activeMonths=totals.filter(t=>t>0).length;
  const avgMonthly=activeMonths>0?annualTotal/activeMonths:0;

  // Category totals for the year
  const catTotals=EXPENSE_CATS.map(cat=>({
    ...cat,
    total:yearMonths.reduce((a,m)=>a+(m.data.expenses[cat.id]||0),0)
  })).filter(c=>c.total>0).sort((a,b)=>b.total-a.total);

  // Simple SVG donut chart
  const DonutChart=({data,size=160})=>{
    const total=data.reduce((a,d)=>a+d.value,0);
    if(total===0) return<div style={{width:size,height:size,borderRadius:"50%",background:T.bgLite,display:"flex",alignItems:"center",justifyContent:"center",color:T.muted,fontSize:12}}>No data</div>;
    let cumAngle=0;
    const paths=data.filter(d=>d.value>0).map(d=>{
      const pct=d.value/total;
      const angle=pct*360;
      const startAngle=cumAngle;
      cumAngle+=angle;
      const r=size/2*0.7,cx=size/2,cy=size/2,outerR=size/2*0.95;
      const toRad=a=>a*Math.PI/180;
      const x1=cx+outerR*Math.sin(toRad(startAngle));
      const y1=cy-outerR*Math.cos(toRad(startAngle));
      const x2=cx+outerR*Math.sin(toRad(cumAngle));
      const y2=cy-outerR*Math.cos(toRad(cumAngle));
      const x3=cx+r*Math.sin(toRad(cumAngle));
      const y3=cy-r*Math.cos(toRad(cumAngle));
      const x4=cx+r*Math.sin(toRad(startAngle));
      const y4=cy-r*Math.cos(toRad(startAngle));
      const large=angle>180?1:0;
      return<path key={d.id} d={`M${x1},${y1} A${outerR},${outerR} 0 ${large},1 ${x2},${y2} L${x3},${y3} A${r},${r} 0 ${large},0 ${x4},${y4} Z`} fill={d.color} opacity={.85}/>;
    });
    return<svg width={size} height={size} style={{borderRadius:"50%"}}>{paths}</svg>;
  };

  const donutData=catTotals.slice(0,8).map(c=>({id:c.id,value:c.total,color:c.color}));

  return(
    <div className="anim">
      <SecHead icon="📊" title="Annual Dashboard" sub="Full-year spending overview with trends and category breakdowns."/>

      {/* Year selector */}
      <div style={{display:"flex",gap:10,marginBottom:16,alignItems:"center"}}>
        <Sel value={selYear} onChange={e=>setSelYear(parseInt(e.target.value))} style={{width:120}}>
          {[now.getFullYear(),now.getFullYear()-1,now.getFullYear()-2].map(y=><option key={y}>{y}</option>)}
        </Sel>
        <div style={{flex:1}}/>
        {annualTotal>0&&<div style={{fontSize:13,color:T.muted}}>
          {activeMonths} month{activeMonths!==1?"s":""} tracked · avg <strong style={{color:T.accent}}>${Math.round(avgMonthly).toLocaleString()}/mo</strong>
        </div>}
      </div>

      {annualTotal===0?<Card style={{padding:40,textAlign:"center"}}><div style={{fontSize:40,marginBottom:8}}>📊</div><div style={{color:T.muted,fontSize:14}}>No data for {selYear} yet. Log expenses in the Monthly tab.</div></Card>:<>

        {/* Summary stats */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:10,marginBottom:16}}>
          {[
            {label:"Annual Total",val:"$"+Math.round(annualTotal).toLocaleString(),color:T.danger},
            {label:"Monthly Avg",val:"$"+Math.round(avgMonthly).toLocaleString(),color:T.accent},
            {label:"Annual Income",val:annualIncome>0?"$"+Math.round(annualIncome).toLocaleString():"-",color:T.free},
            {label:"Net Savings",val:annualIncome>0?(annualIncome-annualTotal>=0?"+":"")+("$"+Math.round(annualIncome-annualTotal).toLocaleString()):"-",color:annualIncome>annualTotal?T.free:T.danger},
          ].map((s,i)=><Card key={i} style={{padding:"12px 14px",textAlign:"center"}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:4}}>{s.label}</div>
            <div style={{fontSize:20,fontWeight:800,color:s.color,fontFamily:T.F.head}}>{s.val}</div>
          </Card>)}
        </div>

        {/* Monthly bar chart */}
        <Card style={{marginBottom:16,padding:"16px 18px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:14,textTransform:"uppercase",letterSpacing:.5}}>📈 Monthly Spending</div>
          <div style={{display:"flex",gap:4,alignItems:"flex-end",height:120}}>
            {yearMonths.map((m,i)=>{
              const total=totals[i];
              const pct=total/maxTotal;
              const hasData=total>0;
              return<div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                <div style={{fontSize:9,color:T.muted,fontWeight:600}}>{total>0?"$"+Math.round(total/1000)+"k":""}</div>
                <div style={{width:"100%",background:hasData?T.accent:T.bgLite,borderRadius:"4px 4px 0 0",height:Math.max(pct*90,hasData?4:2)+"px",transition:"height .3s",cursor:"default"}} title={monthNames[i]+": $"+Math.round(total).toLocaleString()}/>
                <div style={{fontSize:9,color:T.muted}}>{monthNames[i]}</div>
              </div>;
            })}
          </div>
        </Card>

        {/* Donut + category breakdown */}
        <div style={{display:"grid",gridTemplateColumns:"auto 1fr",gap:16,marginBottom:16,alignItems:"start"}}>
          <Card style={{padding:16,display:"flex",flexDirection:"column",alignItems:"center",gap:10}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>By Category</div>
            <DonutChart data={donutData}/>
            <div style={{fontSize:12,fontWeight:800,color:T.text}}>${Math.round(annualTotal).toLocaleString()}</div>
          </Card>
          <Card style={{padding:"14px 18px"}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}}>Top Expenses</div>
            {catTotals.map(cat=>{
              const pct=annualTotal>0?Math.round(cat.total/annualTotal*100):0;
              return<div key={cat.id} style={{marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                  <span style={{fontSize:12,color:T.text}}>{cat.icon} {cat.label}</span>
                  <span style={{fontSize:12,fontWeight:700,color:cat.color}}>${Math.round(cat.total).toLocaleString()} <span style={{fontSize:10,color:T.muted}}>({pct}%)</span></span>
                </div>
                <div style={{height:4,background:T.bgLite,borderRadius:2,overflow:"hidden"}}>
                  <div style={{height:"100%",width:pct+"%",background:cat.color,borderRadius:2,transition:"width .4s"}}/>
                </div>
              </div>;
            })}
          </Card>
        </div>

        {/* Monthly detail table */}
        <Card style={{padding:"14px 18px",overflowX:"auto"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}}>📋 Month-by-Month</div>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12,minWidth:500}}>
            <thead>
              <tr>
                <th style={{textAlign:"left",padding:"6px 8px",color:T.muted,fontWeight:600,borderBottom:`1px solid ${T.border}`}}>Month</th>
                <th style={{textAlign:"right",padding:"6px 8px",color:T.muted,fontWeight:600,borderBottom:`1px solid ${T.border}`}}>Total</th>
                <th style={{textAlign:"right",padding:"6px 8px",color:T.muted,fontWeight:600,borderBottom:`1px solid ${T.border}`}}>Campsite</th>
                <th style={{textAlign:"right",padding:"6px 8px",color:T.muted,fontWeight:600,borderBottom:`1px solid ${T.border}`}}>Fuel</th>
                <th style={{textAlign:"right",padding:"6px 8px",color:T.muted,fontWeight:600,borderBottom:`1px solid ${T.border}`}}>Repairs</th>
                <th style={{textAlign:"right",padding:"6px 8px",color:T.muted,fontWeight:600,borderBottom:`1px solid ${T.border}`}}>Food</th>
                <th style={{textAlign:"right",padding:"6px 8px",color:T.muted,fontWeight:600,borderBottom:`1px solid ${T.border}`}}>Notes</th>
              </tr>
            </thead>
            <tbody>
              {yearMonths.map((m,i)=>{
                const tot=monthTotal(m.data);
                if(tot===0&&!m.data.notes) return null;
                return<tr key={i} style={{borderBottom:`1px solid ${T.border}`,background:i%2===0?"transparent":T.bgLite+"44"}}>
                  <td style={{padding:"6px 8px",fontWeight:600,color:T.text}}>{monthNames[i]}</td>
                  <td style={{padding:"6px 8px",textAlign:"right",fontWeight:700,color:tot>avgMonthly*1.2?T.danger:T.text}}>${Math.round(tot).toLocaleString()}</td>
                  <td style={{padding:"6px 8px",textAlign:"right",color:T.muted}}>{m.data.expenses.campsite>0?"$"+Math.round(m.data.expenses.campsite):"-"}</td>
                  <td style={{padding:"6px 8px",textAlign:"right",color:T.muted}}>{m.data.expenses.fuel>0?"$"+Math.round(m.data.expenses.fuel):"-"}</td>
                  <td style={{padding:"6px 8px",textAlign:"right",color:m.data.expenses.maint_repair>0?T.danger:T.muted}}>{(m.data.expenses.maint_repair||0)>0?"$"+Math.round(m.data.expenses.maint_repair):"-"}</td>
                  <td style={{padding:"6px 8px",textAlign:"right",color:T.muted}}>{((m.data.expenses.groceries||0)+(m.data.expenses.dining||0))>0?"$"+Math.round((m.data.expenses.groceries||0)+(m.data.expenses.dining||0)):"-"}</td>
                  <td style={{padding:"6px 8px",fontSize:11,color:T.muted,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.data.notes||""}</td>
                </tr>;
              })}
            </tbody>
          </table>
        </Card>
      </>}
    </div>
  );
}

// ── FinancesBudgetSection ─────────────────────────────────────────
function FinancesBudgetSection({finances,onChange}){
  const T=useTheme();
  const budgets=finances.budgets||{};
  const months=finances.months||{};
  const now=new Date();
  const curKey=`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}`;
  const curMonth=months[curKey]||mkMonth();
  const setBudget=(catId,val)=>onChange({...finances,budgets:{...budgets,[catId]:parseFloat(val)||0}});
  const monthlyTotal=EXPENSE_CATS.reduce((a,c)=>a+(budgets[c.id]||0),0);

  return(
    <div className="anim">
      <SecHead icon="🎯" title="Monthly Budget Targets" sub="Set a target for each category. Current month actuals shown alongside for comparison."/>
      <Card style={{marginBottom:14,padding:"12px 16px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.muted}}>TOTAL MONTHLY BUDGET</div>
          <div style={{fontSize:22,fontWeight:800,color:T.accent,fontFamily:T.F.head}}>${Math.round(monthlyTotal).toLocaleString()}</div>
        </div>
        <div style={{fontSize:11,color:T.muted,marginTop:4}}>Annual budget projection: ${Math.round(monthlyTotal*12).toLocaleString()}/year</div>
      </Card>
      {[...new Set(EXPENSE_CATS.map(c=>c.group))].map(group=>{
        const cats=EXPENSE_CATS.filter(c=>c.group===group);
        return<Card key={group} style={{marginBottom:12,padding:"14px 18px"}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:12,textTransform:"uppercase",letterSpacing:.5}}>{group}</div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {cats.map(cat=>{
              const budget=budgets[cat.id]||0;
              const actual=curMonth.expenses[cat.id]||0;
              const pct=budget>0?Math.min(actual/budget*100,100):0;
              const over=budget>0&&actual>budget;
              return<div key={cat.id}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <div style={{fontSize:12,color:T.text}}>{cat.icon} {cat.label}</div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    {actual>0&&<span style={{fontSize:11,color:over?T.danger:T.muted}}>actual: ${actual.toLocaleString()}</span>}
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <span style={{fontSize:12,color:T.muted}}>$</span>
                      <input type="number" value={budget||""} onChange={e=>setBudget(cat.id,e.target.value)} placeholder="0"
                        style={{width:80,background:T.bgLite,border:`1px solid ${over?T.danger:T.border}`,borderRadius:6,color:T.text,padding:"4px 8px",fontSize:12,outline:"none",textAlign:"right"}}/>
                    </div>
                  </div>
                </div>
                {budget>0&&<div style={{height:4,background:T.bgLite,borderRadius:2,overflow:"hidden"}}>
                  <div style={{height:"100%",width:pct+"%",background:over?T.danger:pct>80?"#f59e0b":T.free,borderRadius:2,transition:"width .3s"}}/>
                </div>}
              </div>;
            })}
          </div>
        </Card>;
      })}
    </div>
  );
}


// ── LocalFavoritesCard ────────────────────────────────────────────
function LocalFavoritesCard({stop,onChange,callAI}){
  const T=useTheme();
  const [open,setOpen]=useState(false);
  const [newItem,setNewItem]=useState({cat:"restaurants",name:"",note:"",url:"",address:""});
  const favs=stop.localFavorites||[];
  const [aiSug,setAiSug]=useState(false);
  const [aiRes,setAiRes]=useState(null);

  const suggestFavs=async()=>{
    if(!callAI||!stop.name) return;
    setAiSug(true);
    const city=stop.name+(stop.state?", "+stop.state:"");
    const p="Suggest local favorites for an RV traveler in "+city+". Return ONLY valid JSON: "+'{"restaurants":[{"name":"X","note":"Y","address":"full street address","url":"https://..."}],"attractions":[{"name":"X","note":"Y","address":"full street address","url":"https://..."}],"practical":[{"name":"X","note":"Y","address":"full street address","url":"https://..."}],"services":[{"name":"X","note":"Y","address":"full street address","url":"https://..."}]}'+". Max 3 per category. RV-friendly options only. Include real website URLs and full street addresses where known. No markdown.";
    const result=await callAI(p,"You are an experienced full-time RVer. Return only the JSON object, no other text.");
    try{setAiRes(JSON.parse((result||"").replace(/```json|```/g,"").trim()));}
    catch{}
    setAiSug(false);
  };

  const addSug=(cat,item)=>{
    onChange({...stop,localFavorites:[...favs,{id:uid(),cat,name:item.name,note:item.note||"",url:item.url||"",address:item.address||""}]});
  };

  const cats=[
    {id:"restaurants",icon:"🍽",label:"Restaurants"},
    {id:"attractions",icon:"🏛",label:"Attractions"},
    {id:"practical",icon:"🛒",label:"Practical"},
    {id:"services",icon:"🔧",label:"Services"},
  ];

  const addFav=()=>{
    if(!newItem.name.trim()) return;
    const updated=[...favs,{id:uid(),...newItem}];
    onChange({...stop,localFavorites:updated});
    setNewItem({cat:"restaurants",name:"",note:"",url:"",address:""});
  };

  const removeFav=(id)=>onChange({...stop,localFavorites:favs.filter(f=>f.id!==id)});

  const openDirections=(item)=>{
    // Prefer address, fall back to "name near city"
    const query=item.address&&item.address.trim()
      ?encodeURIComponent(item.address)
      :encodeURIComponent(item.name+(stop.name?", "+stop.name:""));
    window.open("https://www.google.com/maps/dir/?api=1&destination="+query,"_blank","noopener");
  };

  const openWebsite=(url)=>{
    let href=url.trim();
    if(!/^https?:\/\//i.test(href)) href="https://"+href;
    window.open(href,"_blank","noopener");
  };

  const btnBase={border:"none",borderRadius:5,padding:"3px 8px",fontSize:10,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:3,flexShrink:0,whiteSpace:"nowrap"};

  return(
    <div style={{gridColumn:"1/-1",marginTop:4}}>
      <button onClick={()=>setOpen(o=>!o)} style={{display:"flex",alignItems:"center",gap:8,background:"none",border:`1px solid ${open?"#f59e0b":T.border}`,borderRadius:8,padding:"6px 12px",cursor:"pointer",color:open?"#f59e0b":T.muted,fontSize:12,fontWeight:600,width:"100%",justifyContent:"space-between"}}>
        <span>⭐ Local Favorites {favs.length>0?`(${favs.length})`:""}</span>
        <span style={{fontSize:10}}>{open?"▲":"▼"}</span>
      </button>

      {open&&<div style={{border:`1px solid #f59e0b33`,borderTop:"none",borderRadius:"0 0 8px 8px",padding:"12px 14px",background:"#f59e0b08"}}>

        {/* Existing favorites */}
        {cats.map(cat=>{
          const items=favs.filter(f=>f.cat===cat.id);
          if(!items.length) return null;
          return(
            <div key={cat.id} style={{marginBottom:10}}>
              <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:.5}}>{cat.icon} {cat.label}</div>
              {items.map(item=>(
                <div key={item.id} style={{marginBottom:6,padding:"8px 10px",background:T.bgLite,borderRadius:8,border:`1px solid ${T.border}`}}>
                  {/* Name row */}
                  <div style={{display:"flex",gap:6,alignItems:"flex-start",marginBottom:item.note||item.url||item.address?4:0}}>
                    <div style={{flex:1,fontSize:13,fontWeight:600,color:T.text}}>{item.name}</div>
                    <button onClick={()=>removeFav(item.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:13,padding:"0 2px",flexShrink:0,lineHeight:1}}>✕</button>
                  </div>
                  {/* Note */}
                  {item.note&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic",marginBottom:4}}>"{item.note}"</div>}
                  {/* Address */}
                  {item.address&&item.address.trim()&&<div style={{fontSize:10,color:T.muted,marginBottom:5}}>📍 {item.address}</div>}
                  {/* Action buttons */}
                  {(item.url||item.address||item.name)&&(
                    <div style={{display:"flex",gap:5,flexWrap:"wrap",marginTop:2}}>
                      {item.url&&item.url.trim()&&(
                        <button onClick={()=>openWebsite(item.url)} style={{...btnBase,background:"#1d6ed8",color:"#fff"}}>
                          🌐 Website
                        </button>
                      )}
                      <button onClick={()=>openDirections(item)} style={{...btnBase,background:"#16a34a",color:"#fff"}}>
                        🗺 Directions
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          );
        })}

        {/* AI Suggestions */}
        {callAI&&stop.name&&stop.name.length>2&&<div style={{marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:aiRes?6:0}}>
            <div style={{fontSize:10,fontWeight:700,color:"#7c3aed",textTransform:"uppercase",letterSpacing:.5}}>✨ AI Suggestions</div>
            <button onClick={suggestFavs} disabled={aiSug} style={{background:"#7c3aed",color:"#fff",border:"none",borderRadius:6,padding:"3px 8px",fontSize:10,fontWeight:700,cursor:"pointer"}}>
              {aiSug?"⏳...":"✨ Suggest"}
            </button>
          </div>
          {aiRes&&<div style={{background:"#7c3aed08",border:"1px solid #7c3aed33",borderRadius:8,padding:"8px 10px"}}>
            {["restaurants","attractions","practical","services"].map(cat=>{
              const items=aiRes[cat]||[];
              if(!items.length) return null;
              const lbl={restaurants:"🍽 Restaurants",attractions:"🏛 Attractions",practical:"🛒 Practical",services:"🔧 Services"}[cat];
              return(
                <div key={cat} style={{marginBottom:6}}>
                  <div style={{fontSize:10,color:"#7c3aed",fontWeight:700,marginBottom:3}}>{lbl}</div>
                  {items.map((item,i)=>{
                    const added=favs.some(f=>f.name===item.name&&f.cat===cat);
                    return(
                      <div key={i} style={{display:"flex",gap:6,alignItems:"center",padding:"4px 0",borderBottom:`1px solid #7c3aed11`}}>
                        <div style={{flex:1}}>
                          <div style={{fontSize:12,fontWeight:600,color:T.text}}>{item.name}</div>
                          {item.note&&<div style={{fontSize:10,color:T.muted}}>{item.note}</div>}
                          {item.address&&<div style={{fontSize:10,color:T.muted}}>📍 {item.address}</div>}
                        </div>
                        {added
                          ?<span style={{fontSize:10,color:"#7c3aed",fontWeight:700}}>✓ Added</span>
                          :<button onClick={()=>addSug(cat,item)} style={{background:"#7c3aed",color:"#fff",border:"none",borderRadius:4,padding:"3px 8px",fontSize:10,fontWeight:700,cursor:"pointer"}}>+ Add</button>
                        }
                      </div>
                    );
                  })}
                </div>
              );
            })}
            <button onClick={()=>setAiRes(null)} style={{fontSize:10,color:T.muted,background:"none",border:"none",cursor:"pointer",marginTop:4}}>✕ Dismiss</button>
          </div>}
        </div>}

        {/* Add new */}
        <div style={{borderTop:favs.length||aiRes?`1px solid ${T.border}`:"none",paddingTop:favs.length||aiRes?10:0}}>
          <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>➕ Add Favorite</div>
          {/* Row 1: category + name */}
          <div style={{display:"grid",gridTemplateColumns:"auto 1fr",gap:8,marginBottom:6}}>
            <Sel value={newItem.cat} onChange={e=>setNewItem(n=>({...n,cat:e.target.value}))} style={{width:130}}>
              {cats.map(c=><option key={c.id} value={c.id}>{c.icon} {c.label}</option>)}
            </Sel>
            <Inp value={newItem.name} onChange={e=>setNewItem(n=>({...n,name:e.target.value}))} onKeyDown={e=>{if(e.key==="Enter"&&newItem.name.trim())addFav();}} placeholder="Name (e.g. Alley Rose Steakhouse)"/>
          </div>
          {/* Row 2: note */}
          <Inp value={newItem.note} onChange={e=>setNewItem(n=>({...n,note:e.target.value}))} placeholder="Note (optional): great prime rib, ask for corner booth..." style={{marginBottom:6}}/>
          {/* Row 3: address */}
          <Inp value={newItem.address} onChange={e=>setNewItem(n=>({...n,address:e.target.value}))} placeholder="📍 Address (optional, for directions)" style={{marginBottom:6}}/>
          {/* Row 4: url + add button */}
          <div style={{display:"flex",gap:8}}>
            <Inp value={newItem.url} onChange={e=>setNewItem(n=>({...n,url:e.target.value}))} onKeyDown={e=>{if(e.key==="Enter"&&newItem.name.trim())addFav();}} placeholder="🌐 Website URL (optional)" style={{flex:1}}/>
            <button onClick={addFav} style={{background:"#f59e0b",color:"#fff",border:"none",borderRadius:8,padding:"9px 14px",fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0}}>Add</button>
          </div>
        </div>

      </div>}
    </div>
  );
}


// ── EMERGENCY & CONTACTS ──────────────────────────────────────────
const ROADSIDE_PROVIDERS=[
  {id:"coachnet",name:"Coach-Net",phone:"1-800-863-9464",url:"https://www.coach-net.com",color:"#dc2626",icon:"🛡"},
  {id:"goodsam_road",name:"Good Sam Roadside",phone:"1-800-234-6765",url:"https://www.goodsam.com/roadside-assistance",color:"#e74c3c",icon:"🛡"},
  {id:"aaa_rv",name:"AAA RV Plus",phone:"1-800-222-4357",url:"https://www.aaa.com/rv",color:"#1d6ed8",icon:"🛡"},
  {id:"progressive_rv",name:"Progressive Roadside",phone:"1-800-776-4737",url:"https://www.progressive.com",color:"#3b82f6",icon:"🛡"},
  {id:"escapees",name:"Escapees ROAD",phone:"1-888-757-2582",url:"https://www.escapees.com/benefits/road-service/",color:"#7c3aed",icon:"🛡"},
  {id:"national_gen",name:"National General",phone:"1-888-293-5108",url:"https://www.nationalgeneral.com",color:"#059669",icon:"🛡"},
];

const mkRoadside=(o={})=>({id:uid(),providerId:"",providerName:"",phone:"",policyNumber:"",memberId:"",expiration:"",coverageNotes:"",active:true,...o});
const mkInsurance=(o={})=>({id:uid(),type:"RV Insurance",provider:"",policyNumber:"",phone:"",agentName:"",expiration:"",notes:"",...o});
const mkContact=(o={})=>({id:uid(),name:"",relationship:"",phone:"","email":"",notes:"",...o});
const mkDocument=(o={})=>({id:uid(),name:"",number:"",expiration:"",notes:"",...o});

function EmergencySection({emergency,onChange,vehicle,stops}){
  const T=useTheme();
  const m=emergency;
  const f=(k,v)=>onChange({...m,[k]:v});
  const [activeTab,setActiveTab]=useState("roadside");
  const [editId,setEditId]=useState(null);
  const [draft,setDraft]=useState(null);

  // GPS-based search helpers
  const homeStop=stops.find(s=>s.type==="home");
  const loc=homeStop?.homeCity||homeStop?.state||"";

  const openEdit=(item)=>{setDraft({...item});setEditId(item.id);};
  const cancelEdit=()=>{setDraft(null);setEditId(null);};

  // ── Roadside ──
  const addRoadside=(provider)=>{
    const item=mkRoadside({
      providerId:provider.id,
      providerName:provider.name,
      phone:provider.phone,
    });
    f("roadside",[...(m.roadside||[]),item]);
    setDraft(item);setEditId(item.id);
  };
  const saveRoadside=()=>{
    f("roadside",(m.roadside||[]).map(r=>r.id===draft.id?draft:r));
    cancelEdit();
  };
  const deleteRoadside=(id)=>{
    if(!window.confirm("Remove this roadside plan?")) return;
    f("roadside",(m.roadside||[]).filter(r=>r.id!==id));
  };

  // ── Insurance ──
  const addInsurance=()=>{
    const item=mkInsurance();
    f("insurance",[...(m.insurance||[]),item]);
    setDraft(item);setEditId(item.id);
  };
  const saveInsurance=()=>{
    f("insurance",(m.insurance||[]).map(r=>r.id===draft.id?draft:r));
    cancelEdit();
  };
  const deleteInsurance=(id)=>{
    if(!window.confirm("Remove this insurance card?")) return;
    f("insurance",(m.insurance||[]).filter(r=>r.id!==id));
  };

  // ── Contacts ──
  const addContact=()=>{
    const item=mkContact();
    f("contacts",[...(m.contacts||[]),item]);
    setDraft(item);setEditId(item.id);
  };
  const saveContact=()=>{
    f("contacts",(m.contacts||[]).map(r=>r.id===draft.id?draft:r));
    cancelEdit();
  };
  const deleteContact=(id)=>{
    if(!window.confirm("Remove this contact?")) return;
    f("contacts",(m.contacts||[]).filter(r=>r.id!==id));
  };

  // ── Documents ──
  const addDocument=()=>{
    const item=mkDocument();
    f("documents",[...(m.documents||[]),item]);
    setDraft(item);setEditId(item.id);
  };
  const saveDocument=()=>{
    f("documents",(m.documents||[]).map(r=>r.id===draft.id?draft:r));
    cancelEdit();
  };
  const deleteDocument=(id)=>{
    if(!window.confirm("Remove this document?")) return;
    f("documents",(m.documents||[]).filter(r=>r.id!==id));
  };

  // ── Print emergency card ──
  const printEmergencyCard=()=>{
    const win=window.open("","_blank","width=800,height=600");
    if(!win){alert("Pop-up blocked.");return;}
    const roadsideRows=(m.roadside||[]).filter(r=>r.active).map(r=>
      "<tr><td><strong>"+r.providerName+"</strong></td><td>"+r.phone+"</td><td>"+r.policyNumber+"</td><td>"+r.memberId+"</td><td>"+r.expiration+"</td></tr>"
    ).join("");
    const contactRows=(m.contacts||[]).map(c=>
      "<tr><td><strong>"+c.name+"</strong></td><td>"+c.relationship+"</td><td>"+c.phone+"</td></tr>"
    ).join("");
    const insRows=(m.insurance||[]).map(i=>
      "<tr><td><strong>"+i.type+"</strong></td><td>"+i.provider+"</td><td>"+i.policyNumber+"</td><td>"+i.phone+"</td><td>"+i.expiration+"</td></tr>"
    ).join("");
    const html="<!DOCTYPE html><html><head><title>RV Emergency Card</title><style>"
      +"body{font-family:Arial,sans-serif;padding:24px;color:#111;max-width:720px;margin:0 auto;font-size:13px;}"
      +"h1{color:#dc2626;font-size:22px;border-bottom:3px solid #dc2626;padding-bottom:6px;margin-bottom:16px;}"
      +"h2{color:#1a1a2e;font-size:13px;text-transform:uppercase;letter-spacing:1px;margin:16px 0 6px;border-bottom:1px solid #eee;padding-bottom:4px;}"
      +"table{width:100%;border-collapse:collapse;margin-bottom:12px;font-size:12px;}"
      +"th{background:#1a1a2e;color:#fff;padding:5px 8px;text-align:left;font-size:11px;}"
      +"td{padding:5px 8px;border-bottom:1px solid #f0f0f0;}"
      +".vin-box{background:#fff3cd;border:2px solid #f59e0b;border-radius:6px;padding:10px 14px;margin-bottom:12px;display:flex;gap:24px;flex-wrap:wrap;}"
      +".vin-item strong{display:block;font-size:15px;font-weight:900;}"
      +".vin-item span{font-size:10px;color:#666;text-transform:uppercase;letter-spacing:.5px;}"
      +"@media print{button{display:none!important}}"
      +"</style></head><body>"
      +"<div style='display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;'>"
      +"<h1 style='margin:0'>🆘 RV Emergency Information</h1>"
      +"<button onclick='window.print()' style='background:#dc2626;color:#fff;border:none;padding:8px 18px;font-size:13px;font-weight:700;border-radius:6px;cursor:pointer;'>🖨 Print / Laminate</button>"
      +"</div>"
      +"<p style='color:#666;margin-bottom:12px;font-size:12px;'>"+vehicle.rvType+" · Generated "+new Date().toLocaleDateString()+"</p>"
      +(m.vin||m.plate?"<div class='vin-box'>"
        +(m.vin?"<div class='vin-item'><span>VIN</span><strong>"+m.vin+"</strong></div>":"")
        +(m.plate?"<div class='vin-item'><span>License Plate</span><strong>"+m.plate+(m.plateState?" ("+m.plateState+")":"")+"</strong></div>":"")
        +"</div>":"")
      +(roadsideRows?"<h2>🛡 Roadside Assistance</h2><table><thead><tr><th>Provider</th><th>Phone</th><th>Policy #</th><th>Member ID</th><th>Expires</th></tr></thead><tbody>"+roadsideRows+"</tbody></table>":"")
      +(insRows?"<h2>📋 Insurance</h2><table><thead><tr><th>Type</th><th>Provider</th><th>Policy #</th><th>Phone</th><th>Expires</th></tr></thead><tbody>"+insRows+"</tbody></table>":"")
      +(contactRows?"<h2>👤 Emergency Contacts</h2><table><thead><tr><th>Name</th><th>Relationship</th><th>Phone</th></tr></thead><tbody>"+contactRows+"</tbody></table>":"")
      +"<p style='margin-top:16px;font-size:10px;color:#999;border-top:1px solid #eee;padding-top:8px;'>RV Travel Mate · Keep this card in your glovebox or posted inside a cabinet door</p>"
      +"</body></html>";
    win.document.write(html);win.document.close();
  };

  // Expiry warning helper
  const expiryWarn=(dateStr)=>{
    if(!dateStr) return null;
    const d=new Date(dateStr);
    const days=Math.floor((d-new Date())/86400000);
    if(days<0) return{label:"EXPIRED",color:T.danger};
    if(days<30) return{label:days+"d left",color:T.danger};
    if(days<90) return{label:days+"d left",color:"#f59e0b"};
    return null;
  };

  return(
    <div className="anim">
      <SecHead icon="🆘" title="Emergency & Contacts" sub="Quick access to roadside assistance, insurance, and emergency contacts - even offline."/>

      {/* Vehicle ID bar */}
      <Card accent={T.danger} style={{marginBottom:14,padding:"14px 18px"}}>
        <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.danger,marginBottom:10,textTransform:"uppercase",letterSpacing:.5}}>🚐 Vehicle Identification</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
          <div><Label>VIN</Label><Inp value={m.vin||""} onChange={e=>f("vin",e.target.value)} placeholder="1FDXE45P17HA12345"/></div>
          <div><Label>License Plate</Label><Inp value={m.plate||""} onChange={e=>f("plate",e.target.value)} placeholder="ABC-1234"/></div>
          <div><Label>Plate State</Label>
            <Sel value={m.plateState||""} onChange={e=>f("plateState",e.target.value)}>
              <option value="">-- State --</option>
              {["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"].map(s=><option key={s}>{s}</option>)}
            </Sel>
          </div>
        </div>
      </Card>

      {/* Sub tabs */}
      <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
        {[["roadside","🛡 Roadside"],["insurance","📋 Insurance"],["contacts","👤 Contacts"],["documents","📄 Documents"]].map(([id,label])=>(
          <button key={id} onClick={()=>setActiveTab(id)} style={{padding:"7px 16px",borderRadius:20,border:`1px solid ${activeTab===id?T.danger:T.border}`,background:activeTab===id?T.danger+"18":"transparent",color:activeTab===id?T.danger:T.muted,fontSize:12,fontWeight:activeTab===id?700:400,cursor:"pointer"}}>{label}</button>
        ))}
        <button onClick={printEmergencyCard} style={{marginLeft:"auto",background:T.danger,color:"#fff",border:"none",borderRadius:20,padding:"7px 16px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🖨 Print Card</button>
      </div>

      {/* ── Roadside Tab ── */}
      {activeTab==="roadside"&&<div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:8,marginBottom:16}}>
          {ROADSIDE_PROVIDERS.filter(p=>!(m.roadside||[]).some(r=>r.providerId===p.id)).map(provider=>(
            <button key={provider.id} onClick={()=>addRoadside(provider)} style={{display:"flex",gap:10,alignItems:"center",padding:"10px 14px",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:10,cursor:"pointer",textAlign:"left",transition:"all .15s"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor=provider.color}
              onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
              <span style={{fontSize:20}}>{provider.icon}</span>
              <div>
                <div style={{fontSize:12,fontWeight:700,color:T.text}}>{provider.name}</div>
                <div style={{fontSize:11,color:T.muted}}>{provider.phone}</div>
              </div>
              <span style={{marginLeft:"auto",fontSize:11,color:T.accent,fontWeight:700}}>+ Add</span>
            </button>
          ))}
        </div>
        {(m.roadside||[]).length===0&&<Card style={{padding:32,textAlign:"center"}}><div style={{fontSize:36,marginBottom:8}}>🛡</div><div style={{color:T.muted,fontSize:14}}>Add your roadside assistance plans above.</div></Card>}
        {(m.roadside||[]).map(r=>{
          const warn=expiryWarn(r.expiration);
          const isEditing=editId===r.id&&draft;
          return<Card key={r.id} accent={r.active?T.danger:T.border} style={{marginBottom:10,padding:"14px 18px"}}>
            {isEditing?<div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div><Label>Provider Name</Label><Inp value={draft.providerName} onChange={e=>setDraft(d=>({...d,providerName:e.target.value}))}/></div>
                <div><Label>Phone</Label><Inp value={draft.phone} onChange={e=>setDraft(d=>({...d,phone:e.target.value}))}/></div>
                <div><Label>Policy / Membership #</Label><Inp value={draft.policyNumber} onChange={e=>setDraft(d=>({...d,policyNumber:e.target.value}))} placeholder="123-456-789"/></div>
                <div><Label>Member ID</Label><Inp value={draft.memberId} onChange={e=>setDraft(d=>({...d,memberId:e.target.value}))}/></div>
                <div><Label>Expiration Date</Label><Inp type="date" value={draft.expiration} onChange={e=>setDraft(d=>({...d,expiration:e.target.value}))}/></div>
              </div>
              <div style={{marginBottom:10}}><Label>Coverage Notes</Label><Inp value={draft.coverageNotes} onChange={e=>setDraft(d=>({...d,coverageNotes:e.target.value}))} placeholder="e.g. Covers 100 miles towing, tire change, lockout"/></div>
              <div style={{display:"flex",gap:8}}>
                <Btn onClick={cancelEdit} variant="ghost" style={{fontSize:12}}>Cancel</Btn>
                <Btn onClick={saveRoadside} style={{fontSize:12,background:T.free,color:"#fff",border:"none"}}>💾 Save</Btn>
              </div>
            </div>:<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
              <div style={{display:"flex",gap:12,alignItems:"center"}}>
                <span style={{fontSize:28}}>🛡</span>
                <div>
                  <div style={{fontWeight:700,fontSize:15,color:T.text,marginBottom:2}}>{r.providerName}</div>
                  <a href={"tel:"+r.phone.replace(/[^+\d]/g,"")} style={{fontSize:16,fontWeight:800,color:T.danger,textDecoration:"none",display:"block",marginBottom:4}}>{r.phone}</a>
                  {r.policyNumber&&<div style={{fontSize:11,color:T.muted}}>Policy: <strong style={{color:T.text}}>{r.policyNumber}</strong></div>}
                  {r.memberId&&<div style={{fontSize:11,color:T.muted}}>Member ID: <strong style={{color:T.text}}>{r.memberId}</strong></div>}
                  {r.coverageNotes&&<div style={{fontSize:11,color:T.muted,marginTop:4,fontStyle:"italic"}}>"{r.coverageNotes}"</div>}
                </div>
              </div>
              <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
                {warn&&<span style={{fontSize:11,fontWeight:700,color:warn.color,background:warn.color+"18",padding:"3px 8px",borderRadius:6}}>⚠ {warn.label}</span>}
                {r.expiration&&!warn&&<span style={{fontSize:11,color:T.muted}}>Exp: {r.expiration}</span>}
                <a href={"tel:"+r.phone.replace(/[^+\d]/g,"")} style={{background:T.danger,color:"#fff",borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700,textDecoration:"none"}}>📞 Call Now</a>
                <Btn onClick={()=>openEdit(r)} variant="ghost" style={{fontSize:11,padding:"5px 10px"}}>✏ Edit</Btn>
                <Btn onClick={()=>deleteRoadside(r.id)} variant="ghost" style={{fontSize:11,padding:"5px 8px",color:T.danger,borderColor:T.danger+"44"}}>✕</Btn>
              </div>
            </div>}
          </Card>;
        })}
        {/* Live GPS service finder */}
        {loc&&<Card style={{marginTop:12,padding:"12px 16px"}} accent={T.border}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.muted,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>🔍 Find Services Near You</div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {[["🔧 RV Repair","rv repair shop near me"],["🚛 Towing","rv towing near me"],["🏥 Hospital","emergency hospital near me"],["⛽ Propane","propane fill rv near me"],["🔧 RV Parts","camping world rv parts near me"]].map(([label,query])=>(
              <a key={label} href={`https://www.google.com/maps/search/${encodeURIComponent(query)}`} target="_blank" rel="noopener noreferrer" style={{fontSize:11,fontWeight:600,color:T.accent,border:`1px solid ${T.accent}44`,borderRadius:6,padding:"4px 10px",textDecoration:"none",background:T.accent+"10"}}>{label}</a>
            ))}
          </div>
        </Card>}
      </div>}

      {/* ── Insurance Tab ── */}
      {activeTab==="insurance"&&<div>
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
          <Btn onClick={addInsurance} style={{background:T.accent,color:"#fff",border:"none",fontSize:12}}>➕ Add Insurance Card</Btn>
        </div>
        {(m.insurance||[]).length===0&&<Card style={{padding:32,textAlign:"center"}}><div style={{fontSize:36,marginBottom:8}}>📋</div><div style={{color:T.muted,fontSize:14}}>Add your RV insurance, health insurance, and other policies.</div></Card>}
        {(m.insurance||[]).map(ins=>{
          const warn=expiryWarn(ins.expiration);
          const isEditing=editId===ins.id&&draft;
          return<Card key={ins.id} style={{marginBottom:10,padding:"14px 18px"}}>
            {isEditing?<div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div><Label>Insurance Type</Label>
                  <Sel value={draft.type} onChange={e=>setDraft(d=>({...d,type:e.target.value}))}>
                    {["RV Insurance","Health Insurance","Life Insurance","Vehicle Insurance","Liability","Other"].map(v=><option key={v}>{v}</option>)}
                  </Sel>
                </div>
                <div><Label>Provider / Company</Label><Inp value={draft.provider} onChange={e=>setDraft(d=>({...d,provider:e.target.value}))} placeholder="e.g. Progressive, Good Sam"/></div>
                <div><Label>Policy Number</Label><Inp value={draft.policyNumber} onChange={e=>setDraft(d=>({...d,policyNumber:e.target.value}))}/></div>
                <div><Label>Claims / Main Phone</Label><Inp value={draft.phone} onChange={e=>setDraft(d=>({...d,phone:e.target.value}))}/></div>
                <div><Label>Agent Name</Label><Inp value={draft.agentName} onChange={e=>setDraft(d=>({...d,agentName:e.target.value}))}/></div>
                <div><Label>Expiration Date</Label><Inp type="date" value={draft.expiration} onChange={e=>setDraft(d=>({...d,expiration:e.target.value}))}/></div>
                <div style={{gridColumn:"1/-1"}}><Label>Notes</Label><Inp value={draft.notes} onChange={e=>setDraft(d=>({...d,notes:e.target.value}))} placeholder="Deductible, coverage limits, agent contact, etc."/></div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <Btn onClick={cancelEdit} variant="ghost" style={{fontSize:12}}>Cancel</Btn>
                <Btn onClick={saveInsurance} style={{fontSize:12,background:T.free,color:"#fff",border:"none"}}>💾 Save</Btn>
              </div>
            </div>:<div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
              <div>
                <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:4}}>
                  <span style={{fontSize:14,fontWeight:800,color:T.accent}}>{ins.type}</span>
                  {warn&&<span style={{fontSize:11,fontWeight:700,color:warn.color,background:warn.color+"18",padding:"2px 8px",borderRadius:6}}>⚠ {warn.label}</span>}
                </div>
                <div style={{fontSize:14,fontWeight:700,color:T.text}}>{ins.provider}</div>
                {ins.policyNumber&&<div style={{fontSize:12,color:T.muted}}>Policy: <strong style={{color:T.text}}>{ins.policyNumber}</strong></div>}
                {ins.phone&&<a href={"tel:"+ins.phone.replace(/[^+\d]/g,"")} style={{fontSize:13,fontWeight:700,color:T.danger,textDecoration:"none",display:"block"}}>{ins.phone}</a>}
                {ins.agentName&&<div style={{fontSize:11,color:T.muted}}>Agent: {ins.agentName}</div>}
                {ins.expiration&&<div style={{fontSize:11,color:T.muted}}>Expires: {ins.expiration}</div>}
                {ins.notes&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic",marginTop:4}}>"{ins.notes}"</div>}
              </div>
              <div style={{display:"flex",gap:6}}>
                {ins.phone&&<a href={"tel:"+ins.phone.replace(/[^+\d]/g,"")} style={{background:T.danger,color:"#fff",borderRadius:8,padding:"6px 12px",fontSize:11,fontWeight:700,textDecoration:"none"}}>📞 Call</a>}
                <Btn onClick={()=>openEdit(ins)} variant="ghost" style={{fontSize:11,padding:"5px 10px"}}>✏ Edit</Btn>
                <Btn onClick={()=>deleteInsurance(ins.id)} variant="ghost" style={{fontSize:11,padding:"5px 8px",color:T.danger,borderColor:T.danger+"44"}}>✕</Btn>
              </div>
            </div>}
          </Card>;
        })}
      </div>}

      {/* ── Contacts Tab ── */}
      {activeTab==="contacts"&&<div>
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
          <Btn onClick={addContact} style={{background:T.accent,color:"#fff",border:"none",fontSize:12}}>➕ Add Contact</Btn>
        </div>
        {(m.contacts||[]).length===0&&<Card style={{padding:32,textAlign:"center"}}><div style={{fontSize:36,marginBottom:8}}>👤</div><div style={{color:T.muted,fontSize:14}}>Add family members, a trusted mechanic, or anyone to call in an emergency.</div></Card>}
        {(m.contacts||[]).map(c=>{
          const isEditing=editId===c.id&&draft;
          return<Card key={c.id} style={{marginBottom:10,padding:"14px 18px"}}>
            {isEditing?<div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div><Label>Name</Label><Inp value={draft.name} onChange={e=>setDraft(d=>({...d,name:e.target.value}))} placeholder="Jane Smith"/></div>
                <div><Label>Relationship</Label><Inp value={draft.relationship} onChange={e=>setDraft(d=>({...d,relationship:e.target.value}))} placeholder="Spouse, Mechanic, Family..."/></div>
                <div><Label>Phone</Label><Inp value={draft.phone} onChange={e=>setDraft(d=>({...d,phone:e.target.value}))} placeholder="555-0101"/></div>
                <div><Label>Email</Label><Inp value={draft.email||""} onChange={e=>setDraft(d=>({...d,email:e.target.value}))} placeholder="optional"/></div>
                <div style={{gridColumn:"1/-1"}}><Label>Notes</Label><Inp value={draft.notes} onChange={e=>setDraft(d=>({...d,notes:e.target.value}))} placeholder="e.g. Has spare key, knows our rig, Foley AL mechanic"/></div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <Btn onClick={cancelEdit} variant="ghost" style={{fontSize:12}}>Cancel</Btn>
                <Btn onClick={saveContact} style={{fontSize:12,background:T.free,color:"#fff",border:"none"}}>💾 Save</Btn>
              </div>
            </div>:<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
              <div style={{display:"flex",gap:12,alignItems:"center"}}>
                <div style={{width:42,height:42,borderRadius:"50%",background:T.accent+"22",border:`2px solid ${T.accent}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>👤</div>
                <div>
                  <div style={{fontWeight:700,fontSize:14,color:T.text}}>{c.name||"(unnamed)"}</div>
                  {c.relationship&&<div style={{fontSize:11,color:T.accent,fontWeight:600}}>{c.relationship}</div>}
                  {c.phone&&<a href={"tel:"+c.phone.replace(/[^+\d]/g,"")} style={{fontSize:14,fontWeight:700,color:T.danger,textDecoration:"none",display:"block"}}>{c.phone}</a>}
                  {c.notes&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic"}}>"{c.notes}"</div>}
                </div>
              </div>
              <div style={{display:"flex",gap:6}}>
                {c.phone&&<a href={"tel:"+c.phone.replace(/[^+\d]/g,"")} style={{background:T.danger,color:"#fff",borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700,textDecoration:"none"}}>📞 Call</a>}
                {c.phone&&<a href={"sms:"+c.phone.replace(/[^+\d]/g,"")} style={{background:T.blue,color:"#fff",borderRadius:8,padding:"6px 14px",fontSize:12,fontWeight:700,textDecoration:"none"}}>💬 Text</a>}
                <Btn onClick={()=>openEdit(c)} variant="ghost" style={{fontSize:11,padding:"5px 10px"}}>✏ Edit</Btn>
                <Btn onClick={()=>deleteContact(c.id)} variant="ghost" style={{fontSize:11,padding:"5px 8px",color:T.danger,borderColor:T.danger+"44"}}>✕</Btn>
              </div>
            </div>}
          </Card>;
        })}
      </div>}

      {/* ── Documents Tab ── */}
      {activeTab==="documents"&&<div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <div style={{fontSize:12,color:T.muted}}>Track registration, licenses, and other expiring documents.</div>
          <Btn onClick={addDocument} style={{background:T.accent,color:"#fff",border:"none",fontSize:12}}>➕ Add Document</Btn>
        </div>
        {(m.documents||[]).length===0&&<Card style={{padding:32,textAlign:"center"}}><div style={{fontSize:36,marginBottom:8}}>📄</div><div style={{color:T.muted,fontSize:14}}>Track vehicle registration, driver licenses, and other important documents.</div></Card>}
        {(m.documents||[]).map(doc=>{
          const warn=expiryWarn(doc.expiration);
          const isEditing=editId===doc.id&&draft;
          return<Card key={doc.id} style={{marginBottom:10,padding:"14px 18px",borderLeft:`3px solid ${warn?warn.color:T.border}`}}>
            {isEditing?<div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div><Label>Document Type</Label>
                  <Sel value={draft.name} onChange={e=>setDraft(d=>({...d,name:e.target.value}))}>
                    {["Vehicle Registration","Driver License","RV Title","Health Insurance Card","Passport","Domicile Address","Mail Service","Park Pass","Custom"].map(v=><option key={v}>{v}</option>)}
                  </Sel>
                </div>
                <div><Label>Number / ID</Label><Inp value={draft.number} onChange={e=>setDraft(d=>({...d,number:e.target.value}))} placeholder="Doc number or ID"/></div>
                <div><Label>Expiration Date</Label><Inp type="date" value={draft.expiration} onChange={e=>setDraft(d=>({...d,expiration:e.target.value}))}/></div>
                <div style={{gridColumn:"1/-1"}}><Label>Notes / Location</Label><Inp value={draft.notes} onChange={e=>setDraft(d=>({...d,notes:e.target.value}))} placeholder="e.g. Stored in glovebox, renewal website, etc."/></div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <Btn onClick={cancelEdit} variant="ghost" style={{fontSize:12}}>Cancel</Btn>
                <Btn onClick={saveDocument} style={{fontSize:12,background:T.free,color:"#fff",border:"none"}}>💾 Save</Btn>
              </div>
            </div>:<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
              <div>
                <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:2}}>
                  <span style={{fontWeight:700,fontSize:14,color:T.text}}>{doc.name||"(unnamed)"}</span>
                  {warn&&<span style={{fontSize:11,fontWeight:700,color:warn.color,background:warn.color+"18",padding:"2px 8px",borderRadius:6}}>⚠ {warn.label}</span>}
                </div>
                {doc.number&&<div style={{fontSize:12,color:T.muted}}>ID: <strong style={{color:T.text}}>{doc.number}</strong></div>}
                {doc.expiration&&<div style={{fontSize:12,color:warn?warn.color:T.muted}}>Expires: {doc.expiration}</div>}
                {doc.notes&&<div style={{fontSize:11,color:T.muted,fontStyle:"italic",marginTop:2}}>"{doc.notes}"</div>}
              </div>
              <div style={{display:"flex",gap:6}}>
                <Btn onClick={()=>openEdit(doc)} variant="ghost" style={{fontSize:11,padding:"5px 10px"}}>✏ Edit</Btn>
                <Btn onClick={()=>deleteDocument(doc.id)} variant="ghost" style={{fontSize:11,padding:"5px 8px",color:T.danger,borderColor:T.danger+"44"}}>✕</Btn>
              </div>
            </div>}
          </Card>;
        })}
        {/* Expiry summary */}
        {(()=>{
          const expiring=[...(m.documents||[]),...(m.insurance||[]),...(m.roadside||[])].filter(d=>{
            const exp=d.expiration||d.exp;
            if(!exp) return false;
            const w=expiryWarn(exp);
            return w!=null;
          });
          if(!expiring.length) return null;
          return<Card accent={T.danger} style={{marginTop:12,padding:"12px 16px"}}>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.danger,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>⚠ Expiring Soon</div>
            {expiring.map((d,i)=>{
              const exp=d.expiration;
              const w=expiryWarn(exp);
              return<div key={i} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:i<expiring.length-1?`1px solid ${T.border}`:"none"}}>
                <span style={{fontSize:12,color:T.text}}>{d.name||d.providerName||d.type||d.provider}</span>
                <span style={{fontSize:11,fontWeight:700,color:w.color}}>{w.label}</span>
              </div>;
            })}
          </Card>;
        })()}
      </div>}
    </div>
  );
}




// ── Shared AI trip validation helpers ──
// Parses AI response robustly - handles markdown fences, partial JSON, common issues
function parseAITrip(raw){
  if(!raw){console.warn("[AI Parse] Empty response");return null;}
  // Strip markdown code fences
  let clean=raw.replace(/```json|```/gi,"").trim();
  // If AI wrapped in preamble text, find first { and last }
  const firstBrace=clean.indexOf("{");
  const lastBrace=clean.lastIndexOf("}");
  if(firstBrace>=0&&lastBrace>firstBrace){
    clean=clean.substring(firstBrace,lastBrace+1);
  }
  // Remove trailing commas before } or ] (common AI error)
  clean=clean.replace(/,(\s*[}\]])/g,"$1");
  try{
    const parsed=JSON.parse(clean);
    if(!parsed.stops||!Array.isArray(parsed.stops)){
      console.warn("[AI Parse] No stops array. Keys:",Object.keys(parsed||{}));
      return null;
    }
    return parsed;
  }catch(e){
    console.warn("[AI Parse] JSON error:",e.message);
    console.warn("[AI Parse] Cleaned text:",clean.substring(0,400));
    return null;
  }
}
// Validates a parsed trip - returns array of issues or [] if valid
function validateAITrip(parsed,maxDailyMi,isRoundTrip){
  const issues=[];
  if(!parsed||!parsed.stops||parsed.stops.length<2){
    issues.push("Not enough stops returned");
    return issues;
  }
  const stops=parsed.stops;
  // Check every non-first stop has distFromPrev
  for(let i=1;i<stops.length;i++){
    const d=parseInt(stops[i].distFromPrev)||0;
    if(d===0) issues.push("Stop "+(i+1)+" ("+stops[i].name+") missing distance from previous");
    if(d>maxDailyMi+50) issues.push("Leg to "+stops[i].name+" is "+d+" mi, exceeds max daily of "+maxDailyMi+" - needs overnight stop inserted");
  }
  // Check rates are realistic
  stops.forEach((s,i)=>{
    const r=parseFloat(s.nightlyRate)||0;
    if(r>200) issues.push(stops[i].name+" rate $"+r+"/night is unrealistically high");
  });
  // Check return home if round trip
  if(isRoundTrip){
    const hasReturn=stops.some((s,i)=>i>0&&(s.type==="home"||s.subtype==="return"||(s.name||"").toLowerCase().includes("home")));
    if(!hasReturn) issues.push("Round trip missing return home stop");
  }
  return issues;
}


// ── Hunt Season Data (typical windows - verify with state agency) ──
const STATE_HUNT_SEASONS={
  // Whitetail deer rifle seasons by state (approximate - verify current regs)
  AL:{whitetail:{archery:{label:"Oct 15 - Jan 31"},rifle:{label:"Nov 18 - Jan 31"},muzzle:{label:"Jan 1 - Jan 31"}}},
  AR:{whitetail:{archery:{label:"Sep 24 - Feb 28"},rifle:{label:"Nov 12 - Dec 4"},muzzle:{label:"Oct 22 - Oct 30"}}},
  CO:{elk:{archery:{label:"Aug 27 - Sep 25"},rifle:{label:"Oct 1 - Nov 6"},muzzle:{label:"Sep 10 - Sep 18"}},mule_deer:{archery:{label:"Aug 27 - Sep 25"},rifle:{label:"Oct 15 - Nov 6"}}},
  GA:{whitetail:{archery:{label:"Sep 10 - Oct 14"},rifle:{label:"Oct 21 - Jan 15"},muzzle:{label:"Oct 15 - Oct 20"}}},
  ID:{elk:{archery:{label:"Aug 30 - Sep 30"},rifle:{label:"Oct 10 - Nov 7"},muzzle:{label:"Oct 1 - Oct 9"}},mule_deer:{rifle:{label:"Oct 10 - Nov 7"}}},
  IL:{whitetail:{archery:{label:"Oct 1 - Jan 15"},rifle:{label:"Nov 18 - Dec 4"},muzzle:{label:"Oct 13 - Oct 21"}}},
  IN:{whitetail:{archery:{label:"Oct 1 - Jan 3"},rifle:{label:"Nov 18 - Dec 4"},muzzle:{label:"Oct 13 - Oct 18"}}},
  IA:{whitetail:{archery:{label:"Oct 1 - Jan 10"},rifle:{label:"Dec 3 - Dec 6"},muzzle:{label:"Oct 14 - Oct 22"}}},
  KS:{whitetail:{archery:{label:"Sep 15 - Dec 31"},rifle:{label:"Nov 30 - Dec 11"},muzzle:{label:"Sep 15 - Sep 30"}}},
  KY:{whitetail:{archery:{label:"Sep 3 - Jan 17"},rifle:{label:"Nov 12 - Nov 27"},muzzle:{label:"Oct 15 - Oct 23"}}},
  MI:{whitetail:{archery:{label:"Oct 1 - Nov 14"},rifle:{label:"Nov 15 - Nov 30"},muzzle:{label:"Dec 3 - Jan 1"}}},
  MN:{whitetail:{archery:{label:"Sep 17 - Dec 31"},rifle:{label:"Nov 5 - Nov 20"},muzzle:{label:"Nov 26 - Dec 11"}}},
  MS:{whitetail:{archery:{label:"Oct 1 - Nov 3"},rifle:{label:"Nov 4 - Jan 31"},muzzle:{label:"Oct 8 - Oct 16"}}},
  MO:{whitetail:{archery:{label:"Sep 15 - Nov 11"},rifle:{label:"Nov 12 - Nov 22"},muzzle:{label:"Oct 15 - Oct 23"}}},
  MT:{elk:{archery:{label:"Sep 3 - Oct 18"},rifle:{label:"Oct 22 - Nov 27"},muzzle:{label:"Sep 19 - Sep 27"}},mule_deer:{rifle:{label:"Oct 22 - Nov 27"}}},
  NE:{whitetail:{archery:{label:"Sep 15 - Jan 15"},rifle:{label:"Nov 12 - Nov 20"},muzzle:{label:"Dec 3 - Dec 11"}}},
  NM:{elk:{archery:{label:"Sep 1 - Sep 19"},rifle:{label:"Oct 14 - Oct 18"},muzzle:{label:"Oct 21 - Nov 6"}},mule_deer:{rifle:{label:"Nov 17 - Nov 27"}}},
  OH:{whitetail:{archery:{label:"Oct 1 - Feb 5"},rifle:{label:"Nov 28 - Dec 4"},muzzle:{label:"Jan 14 - Feb 5"}}},
  OK:{whitetail:{archery:{label:"Oct 1 - Jan 15"},rifle:{label:"Nov 19 - Dec 4"},muzzle:{label:"Oct 22 - Oct 30"}}},
  PA:{whitetail:{archery:{label:"Sep 17 - Nov 11"},rifle:{label:"Nov 28 - Dec 10"},muzzle:{label:"Oct 15 - Oct 23"}}},
  SD:{whitetail:{archery:{label:"Sep 15 - Jan 2"},rifle:{label:"Nov 19 - Jan 1"},muzzle:{label:"Dec 10 - Dec 18"}}},
  TN:{whitetail:{archery:{label:"Sep 24 - Feb 28"},rifle:{label:"Nov 19 - Jan 8"},muzzle:{label:"Oct 22 - Nov 5"}}},
  TX:{whitetail:{archery:{label:"Oct 1 - Nov 3"},rifle:{label:"Nov 5 - Jan 1"},muzzle:{label:"Jan 2 - Jan 15"}},elk:{rifle:{label:"Nov 1 - Jan 1"}}},
  WI:{whitetail:{archery:{label:"Sep 17 - Jan 8"},rifle:{label:"Nov 19 - Nov 27"},muzzle:{label:"Nov 28 - Dec 11"}}},
  WY:{elk:{archery:{label:"Sep 1 - Sep 30"},rifle:{label:"Oct 10 - Nov 6"},muzzle:{label:"Sep 15 - Sep 30"}},mule_deer:{rifle:{label:"Oct 1 - Oct 16"}}},
};
const HUNT_SEASONS_DATA={
  whitetail:{
    archery:{start:[10,1],end:[11,15],label:"Oct 1 - Nov 15 (typical archery)"},
    rifle:{start:[11,15],end:[12,15],label:"Nov 15 - Dec 15 (typical rifle)"},
    muzzle:{start:[12,15],end:[1,5],label:"Dec 15 - Jan 5 (typical muzzle)"},
    scouting:{start:[9,1],end:[9,30],label:"September (pre-season scouting)"},
  },
  elk:{
    archery:{start:[9,1],end:[9,30],label:"Sept 1-30 (rut/archery)"},
    rifle:{start:[10,15],end:[11,15],label:"Oct 15 - Nov 15 (typical rifle)"},
    muzzle:{start:[10,1],end:[10,14],label:"Early Oct (muzzle)"},
    scouting:{start:[8,15],end:[8,31],label:"Late August (scouting)"},
  },
  mule_deer:{
    archery:{start:[9,1],end:[9,30],label:"Sept 1-30 (archery)"},
    rifle:{start:[10,15],end:[11,15],label:"Oct 15 - Nov 15 (rifle)"},
    muzzle:{start:[11,1],end:[11,14],label:"Early Nov (muzzle)"},
    scouting:{start:[9,1],end:[9,15],label:"Early Sept (scouting)"},
  },
  turkey:{
    spring_turkey:{start:[4,1],end:[5,15],label:"April 1 - May 15 (spring)"},
    archery:{start:[9,15],end:[10,31],label:"Sept 15 - Oct 31 (fall archery)"},
    rifle:{start:[10,1],end:[10,31],label:"October (fall rifle)"},
    scouting:{start:[3,15],end:[3,31],label:"Late March (scouting/calling)"},
  },
  waterfowl:{
    waterfowl:{start:[10,15],end:[1,31],label:"Oct 15 - Jan 31 (duck/goose)"},
    scouting:{start:[10,1],end:[10,14],label:"Early Oct (scouting)"},
  },
  hog:{
    archery:{start:[1,1],end:[12,31],label:"Year-round (most states)"},
    rifle:{start:[1,1],end:[12,31],label:"Year-round (most states)"},
    scouting:{start:[1,1],end:[12,31],label:"Year-round"},
  },
  bear:{
    archery:{start:[9,1],end:[9,30],label:"Sept (archery)"},
    rifle:{start:[10,1],end:[11,30],label:"Oct-Nov (rifle)"},
    scouting:{start:[8,15],end:[8,31],label:"Late Aug (scouting)"},
  },
  pronghorn:{
    archery:{start:[8,15],end:[9,15],label:"Aug 15 - Sept 15 (archery)"},
    rifle:{start:[9,15],end:[10,15],label:"Sept 15 - Oct 15 (rifle)"},
    scouting:{start:[8,1],end:[8,14],label:"Early Aug (scouting)"},
  },
  upland:{
    rifle:{start:[10,15],end:[1,31],label:"Oct 15 - Jan 31 (pheasant/quail)"},
    archery:{start:[10,15],end:[1,31],label:"Oct 15 - Jan 31"},
    scouting:{start:[10,1],end:[10,14],label:"Early Oct (scouting)"},
  },
};

// Nonresident license cost estimates (USD, approximate - verify with state)
const NR_LICENSE_COSTS={
  // Costs in USD - approximate, verify with state agency before purchasing
  // Sources: state agency websites 2024-2025 season
  AL:{license:51,deer_tag:195,turkey_tag:75,otc:true,web:"outdooralabama.com",notes:"OTC deer/turkey. Quality public WMAs available."},
  AK:{license:160,deer_tag:300,elk_tag:500,otc:false,web:"adfg.alaska.gov",notes:"Most species require draw or registration permit. Brown bear/sheep require guide."},
  AZ:{license:65,deer_tag:300,elk_tag:700,otc:false,web:"azgfd.com",notes:"DRAW ONLY - apply Jan-Feb. Most tags very competitive. Bonus points accumulate."},
  AR:{license:50,deer_tag:35,turkey_tag:35,otc:true,web:"agfc.com",notes:"OTC. Good public land hunting. No bag limit on hogs."},
  CO:{license:56,deer_tag:411,elk_tag:657,otc:false,web:"cpw.state.co.us",notes:"DRAW ONLY for most units - apply by April. Preference points critical. Over-the-counter elk in limited units."},
  FL:{license:47,deer_tag:0,turkey_tag:0,otc:true,web:"myfwc.com",notes:"Tags included with license. WMA quota hunts via online reservation."},
  GA:{license:50,deer_tag:0,turkey_tag:0,otc:true,web:"georgiawildlife.com",notes:"Tags included. Quality deer management cooperatives available."},
  ID:{license:154,deer_tag:301,elk_tag:416,otc:true,web:"idfg.idaho.gov",notes:"Many units OTC. Controlled hunts require draw. Apply by May."},
  IL:{license:25,deer_tag:100,turkey_tag:35,otc:false,web:"dnr.illinois.gov",notes:"Firearm deer by county draw - apply by Aug 15. Archery OTC."},
  IN:{license:35,deer_tag:24,turkey_tag:27,otc:true,web:"in.gov/dnr",notes:"OTC. Unlimited deer tags. Good agricultural land hunting."},
  IA:{license:57,deer_tag:567,otc:false,web:"iowadnr.gov",notes:"DRAW ONLY - very competitive. Apply May 1-June 5. Trophy whitetail destination."},
  KS:{license:150,deer_tag:425,turkey_tag:55,otc:false,web:"ksoutdoors.com",notes:"DRAW ONLY for deer - apply by late April. World-class whitetail. Tags very limited for nonresidents."},
  KY:{license:55,deer_tag:25,turkey_tag:25,otc:true,web:"fw.ky.gov",notes:"OTC. Excellent public land (Daniel Boone NF). Good deer numbers."},
  LA:{license:60,deer_tag:0,turkey_tag:0,otc:true,web:"wlf.louisiana.gov",notes:"Tags included with license. WMA permits required for some areas."},
  ME:{license:26,deer_tag:75,moose_tag:585,otc:true,web:"mefishwildlife.com",notes:"Deer OTC. Moose by lottery only - very limited."},
  MI:{license:76,deer_tag:20,turkey_tag:15,otc:true,web:"michigan.gov/dnr",notes:"OTC deer/turkey. Bear/elk by draw. Apply by June."},
  MN:{license:49,deer_tag:49,turkey_tag:37,otc:true,web:"dnr.state.mn.us",notes:"OTC most zones. Moose/elk by lottery. Quality public land."},
  MS:{license:50,deer_tag:0,otc:true,web:"mdwfp.com",notes:"Tags included. Excellent public and private hunting. Long seasons."},
  MO:{license:42,deer_tag:17,turkey_tag:17,otc:true,web:"mdc.mo.gov",notes:"OTC. Elk by draw only. Quality Ozark public land hunting."},
  MT:{license:70,deer_tag:151,elk_tag:913,otc:false,web:"fwp.mt.gov",notes:"DRAW for most nonresident tags - apply by March 15. Combination licenses available. Limited quota."},
  NE:{license:57,deer_tag:97,otc:false,web:"outdoornebraska.gov",notes:"Some units OTC, others draw. Apply by June. Sandhills quality hunting."},
  NV:{license:142,deer_tag:300,elk_tag:1200,otc:false,web:"ndow.org",notes:"DRAW ONLY - nearly all tags. Apply by April. Bonus points critical."},
  NM:{license:65,deer_tag:215,elk_tag:700,otc:false,web:"wildlife.state.nm.us",notes:"DRAW - apply by March 20. Quality elk/mule deer. Nonresident limited."},
  NY:{license:70,deer_tag:35,turkey_tag:25,otc:true,web:"dec.ny.gov",notes:"OTC. Antlerless tags by zone. Sunday hunting limited."},
  NC:{license:40,deer_tag:0,turkey_tag:0,otc:true,web:"ncwildlife.org",notes:"Tags included. Game lands require permits for some hunts."},
  ND:{license:65,deer_tag:120,otc:false,web:"gf.nd.gov",notes:"DRAW for most units. Apply April-June. Pheasant OTC."},
  OH:{license:19,deer_tag:24,turkey_tag:24,otc:true,web:"ohiodnr.gov",notes:"OTC. Very affordable. Quality private land leases available."},
  OK:{license:55,deer_tag:27,turkey_tag:27,otc:true,web:"wildlifedepartment.com",notes:"OTC. Good WMA hunting. No quota on hogs."},
  OR:{license:80,deer_tag:181,elk_tag:437,otc:false,web:"dfw.state.or.us",notes:"DRAW for most units - apply by May 15. Some OTC elk units."},
  PA:{license:97,deer_tag:25,turkey_tag:25,otc:true,web:"pgc.pa.gov",notes:"OTC. Elk by draw - very limited. Good public land (State Forests)."},
  SD:{license:67,deer_tag:135,otc:false,web:"gfp.sd.gov",notes:"DRAW for deer, antelope, elk. Apply by June. Good pheasant OTC."},
  TN:{license:54,deer_tag:0,turkey_tag:0,otc:true,web:"tn.gov/twra",notes:"Tags included. WMA quota hunts available online."},
  TX:{license:68,deer_tag:0,otc:true,web:"tpwd.texas.gov",notes:"Tags included BUT most hunting is private land. Leases average $1,000-5,000/season. Public WMA hunts by draw."},
  UT:{license:65,deer_tag:233,elk_tag:480,otc:false,web:"wildlife.utah.gov",notes:"DRAW - apply by March. Very limited nonresident tags. Bonus points help."},
  VT:{license:28,deer_tag:57,otc:true,web:"vtfishandwildlife.com",notes:"OTC. Good numbers. No Sunday hunting."},
  VA:{license:45,deer_tag:23,turkey_tag:23,otc:true,web:"dwr.virginia.gov",notes:"OTC. Shenandoah NF and other quality public land."},
  WA:{license:98,deer_tag:102,elk_tag:335,otc:false,web:"wdfw.wa.gov",notes:"DRAW for most units - apply by May 31. Some OTC units available."},
  WV:{license:65,deer_tag:24,otc:true,web:"wvdnr.gov",notes:"OTC. Bear requires additional tag. Good public land."},
  WI:{license:165,deer_tag:20,turkey_tag:10,otc:true,web:"dnr.wisconsin.gov",notes:"OTC deer/turkey. Bear by draw. Good public land hunting."},
  WY:{license:46,deer_tag:235,elk_tag:586,otc:false,web:"wgfd.wyo.gov",notes:"DRAW - apply by Jan 31. Nonresident limited to 10-20% of tags. Quality hunts."},
};




// ── Shared vehicle context builder for AI planners ──
function buildVehicleContext(vehicle,prefs,fuel,memberships){
  const mpg=parseFloat(vehicle?.mpg)||8;
  const tank=parseFloat(vehicle?.tankGallons)||100;
  const tankRangeMi=Math.round(mpg*tank*0.85); // 15% safety buffer
  const fuelType=(vehicle?.fuelType||"diesel").toLowerCase();
  const isDiesel=fuelType.includes("diesel");
  const rvLen=parseInt(vehicle?.rvLength)||36;
  const towLen=vehicle?.towVehicle?parseInt(vehicle?.towLength||15)+5:0; // +5ft for hitch
  const combinedLen=rvLen+towLen;
  const heightFt=parseInt(vehicle?.rvHeightFt)||13;
  const heightIn=parseInt(vehicle?.rvHeightIn)||0;
  const totalHeightIn=heightFt*12+heightIn;
  const isTall=totalHeightIn>150; // over 12'6"
  const isLong=combinedLen>40;
  const isVeryLong=combinedLen>60;
  const avgPrice=parseFloat(fuel?.avgPricePerGallon)||3.50;

  // Active memberships
  const activeMembers=Object.entries(memberships||{})
    .filter(([k,v])=>v&&k!=="koaValueKard")
    .map(([k])=>({
      goodSam:"Good Sam Club (10% off at 2000+ parks)",
      passportAmerica:"Passport America (50% off at 1800+ parks)",
      harvestHosts:"Harvest Hosts (free stays at farms/breweries/wineries)",
      thousandTrails:"Thousand Trails (campground network)",
    }[k]||k))
    .filter(Boolean);

  const lines=[];
  lines.push("RV TYPE: "+(vehicle?.rvType||"RV"));
  lines.push("DIMENSIONS: "+rvLen+"ft RV"+(vehicle?.towVehicle?" + "+vehicle.towLength+"ft tow vehicle = "+combinedLen+"ft COMBINED total":"")+" | Height: "+heightFt+"ft "+heightIn+"in");
  lines.push("ENGINE/FUEL: "+fuelType+" | "+mpg+" MPG | "+tank+" gal tank | Range: ~"+tankRangeMi+" miles on a full tank");
  lines.push("FUEL STOPS: "+(tankRangeMi<300?"CRITICAL - range only "+tankRangeMi+"mi, must plan stops every "+(Math.round(tankRangeMi*0.8))+"mi":"Plan fuel stop on any leg over "+(Math.round(tankRangeMi*0.8))+"mi")
    +(isDiesel?" | DIESEL ONLY - specify diesel availability. Large rigs need truck stops (Pilot Flying J, Love's, TA/Petro) for pull-through lanes.":""));
  if(isVeryLong) lines.push("VERY LONG RIG ("+combinedLen+"ft): Requires truck stop fuel stations with pull-through lanes. Cannot use standard car-oriented gas stations. Plan fuel at Flying J, Pilot, Love's, or TA/Petro.");
  else if(isLong) lines.push("LONG RIG ("+combinedLen+"ft): Prefer truck stops or large travel centers for fueling.");
  if(isTall) lines.push("HEIGHT WARNING ("+heightFt+"ft "+heightIn+"in): Must avoid NY parkways, low bridges in MA/NJ/CT. Use RV-specific routing.");
  const effHrs=prefs?.multiDriver?Math.min(parseFloat(prefs?.maxDriveHours)||7,24):Math.min(parseFloat(prefs?.maxDriveHours)||7,12);
  const effMiDay=Math.round((parseFloat(prefs?.avgSpeedMph)||60)*effHrs);
  lines.push("DRIVE LIMITS: "+effHrs+" hrs/day"+(prefs?.multiDriver?" (MULTI-DRIVER - team driving allowed)":"")
    +" | "+(parseFloat(prefs?.avgSpeedMph)||60)+" mph avg | ~"+effMiDay+" miles/day target");
  if(activeMembers.length>0) lines.push("MEMBERSHIPS: "+activeMembers.join(" | "));
  lines.push("FUEL PRICE: ~$"+avgPrice+"/gal ("+fuelType+")");

  return lines.join("\n");
}

// ── Route Corridor Helpers for AI Hunt Planner ──
const ORS_KEY_HUNT=ORS_KEY; // from env

// Geocode a city string to [lon,lat]
async function geocodeCityForHunt(cityStr){
  if(!cityStr) return null;
  try{
    const r=await fetch("https://nominatim.openstreetmap.org/search?format=json&limit=1&q="+encodeURIComponent(cityStr+", USA"),
      {headers:{"Accept-Language":"en","User-Agent":"RVTravelMate/1.0"}});
    const d=await r.json();
    if(d&&d[0]) return [parseFloat(d[0].lon),parseFloat(d[0].lat)];
  }catch(e){console.warn("Geocode failed:",e);}
  return null;
}

// Get route waypoints from ORS between two [lon,lat] points
// Returns array of city names along the route
async function getRouteCorridorCities(fromCoord,toCoord){
  try{
    const body={
      coordinates:[fromCoord,toCoord],
      instructions:false,
      geometry:true,
      geometry_simplify:false,
    };
    const r=await fetch("https://api.openrouteservice.org/v2/directions/driving-car/geojson",{
      method:"POST",
      headers:{"Content-Type":"application/json","Authorization":ORS_KEY_HUNT},
      body:JSON.stringify(body)
    });
    if(!r.ok) return null;
    const d=await r.json();
    const coords=d?.features?.[0]?.geometry?.coordinates;
    if(!coords||coords.length<2) return null;

    // Sample ~8 evenly-spaced points along route for reverse geocoding
    const step=Math.floor(coords.length/8);
    const sampled=[];
    for(let i=step;i<coords.length-step;i+=step) sampled.push(coords[i]);

    // Reverse geocode each sampled point to get city name
    const cities=[];
    for(const [lon,lat] of sampled){
      try{
        const rr=await fetch("https://nominatim.openstreetmap.org/reverse?format=json&lat="+lat+"&lon="+lon,
          {headers:{"Accept-Language":"en","User-Agent":"RVTravelMate/1.0"}});
        const dd=await rr.json();
        const city=dd?.address?.city||dd?.address?.town||dd?.address?.county||"";
        const state=dd?.address?.state_code||dd?.address?.["ISO3166-2-lvl4"]?.replace("US-","")||"";
        if(city&&state){
          const cs=city+", "+state;
          if(!cities.includes(cs)) cities.push(cs);
        }
      }catch{}
      // Small delay to avoid Nominatim rate limit
      await new Promise(res=>setTimeout(res,300));
    }
    return cities.length>0?cities:null;
  }catch(e){
    console.warn("ORS corridor failed:",e);
    return null;
  }
}


// ── Batch geocode stops for map display ──
async function geocodeStopsForMap(stops){
  const results=[...stops];
  for(let i=0;i<results.length;i++){
    const s=results[i];
    if(s.lat&&s.lon) continue; // already has coords
    if(!s.name&&!s.address) continue;
    try{
      // For fuel stops: extract city from name like "Love's Travel Stop, Salina, KS"
      // by using the state field + last city-like part of name
      let geocodeStr=s.address||(s.name+(s.state?", "+s.state:"")+", USA");
      if(s.subtype==="fuel_stop"||s.fuelStop){
        // Use just the city+state for fuel stops - truck stop names don't geocode well
        const nameParts=s.name.split(",");
        const cityPart=nameParts.length>1?nameParts[nameParts.length-(s.state?1:2)].trim():"";
        geocodeStr=cityPart?(cityPart+(s.state?", "+s.state:"")+", USA"):(s.state?s.state+", USA":"");
      }
      const q=geocodeStr;
      const r=await fetch("https://nominatim.openstreetmap.org/search?q="+encodeURIComponent(q)+"&format=json&limit=1&countrycodes=us",
        {headers:{"Accept-Language":"en","User-Agent":"RVTravelMate/1.0"}});
      if(!r.ok) continue;
      const d=await r.json();
      if(d&&d[0]){
        results[i]={...s,lat:parseFloat(d[0].lat),lon:parseFloat(d[0].lon)};
      }
      // Small delay to respect Nominatim rate limit
      await new Promise(res=>setTimeout(res,200));
    }catch(e){
      console.warn("Geocode failed for",s.name,e.message);
    }
  }
  return results;
}

// ── AIHuntPlanner ─────────────────────────────────────────────────
// State hunting regulations data - common agency contacts
const HUNT_REGS={
  AL:{agency:"Alabama Dept of Conservation",web:"outdooralabama.com",phone:"334-242-3467",notes:"WMA permits required. Nonresident licenses available online."},
  AK:{agency:"Alaska Dept of Fish & Game",web:"adfg.alaska.gov",phone:"907-465-4100",notes:"Most big game requires drawing permit. Nonresidents need guide for brown bear, Dall sheep, mountain goat."},
  AZ:{agency:"Arizona Game & Fish",web:"azgfd.com",phone:"602-942-3000",notes:"Draw system - most tags require applying Jan-Feb. Over-the-counter limited."},
  AR:{agency:"Arkansas Game & Fish",web:"agfc.com",phone:"800-364-4263",notes:"Nonresident tags OTC. WMA permits for some units."},
  CO:{agency:"Colorado Parks & Wildlife",web:"cpw.state.co.us",phone:"303-297-1192",notes:"DRAW ONLY for most big game. Apply by early April. Preference points build over years."},
  FL:{agency:"Florida FWC",web:"myfwc.com",phone:"850-488-4676",notes:"WMA quota hunts via drawing. Nonresident licenses OTC for many species."},
  GA:{agency:"Georgia DNR",web:"georgiawildlife.com",phone:"770-918-6416",notes:"WMA hunts often require quota permit. Nonresident tags OTC."},
  ID:{agency:"Idaho Fish & Game",web:"idfg.idaho.gov",phone:"208-334-3700",notes:"Most nonresident tags OTC but limited quotas. Capped/controlled hunts require drawing."},
  IL:{agency:"Illinois DNR",web:"dnr.illinois.gov",phone:"217-782-6302",notes:"Firearm deer tags by county draw. Archery OTC. Apply by August."},
  IN:{agency:"Indiana DNR",web:"in.gov/dnr",phone:"317-232-4080",notes:"Most tags OTC. Reserved hunts via drawing in spring."},
  IA:{agency:"Iowa DNR",web:"iowadnr.gov",phone:"515-725-8200",notes:"Nonresident deer tags DRAW ONLY. Apply May 1-June 6. Very competitive."},
  KS:{agency:"Kansas Dept of Wildlife",web:"ksoutdoors.com",phone:"620-672-5911",notes:"Nonresident deer DRAW - apply by late April. Trophy whitetail state."},
  KY:{agency:"Kentucky Dept of Fish & Wildlife",web:"fw.ky.gov",phone:"800-858-1549",notes:"Nonresident OTC for deer. Quota hunts on some WMAs."},
  LA:{agency:"Louisiana Wildlife & Fisheries",web:"wlf.louisiana.gov",phone:"225-765-2800",notes:"WMA hunts often require permit. Nonresident OTC."},
  ME:{agency:"Maine Dept of Inland Fisheries",web:"mefishwildlife.com",phone:"207-287-8000",notes:"Moose permits via lottery. Deer tags OTC."},
  MD:{agency:"Maryland DNR",web:"dnr.maryland.gov",phone:"410-260-8540",notes:"Most tags OTC. Sunday hunting limited."},
  MA:{agency:"MassWildlife",web:"mass.gov/masswildlife",phone:"508-389-6300",notes:"Black bear, moose, paraplegic hunts via drawing."},
  MI:{agency:"Michigan DNR",web:"michigan.gov/dnr",phone:"517-284-9453",notes:"Elk, bear, turkey via drawing. Deer OTC. Bear apply by May."},
  MN:{agency:"Minnesota DNR",web:"dnr.state.mn.us",phone:"651-296-6157",notes:"Moose, elk, bear drawings. Deer tags OTC for most zones."},
  MS:{agency:"Mississippi Wildlife, Fisheries & Parks",web:"mdwfp.com",phone:"601-432-2199",notes:"Nonresident OTC. WMA permits for some areas."},
  MO:{agency:"Missouri Dept of Conservation",web:"mdc.mo.gov",phone:"573-751-4115",notes:"Nonresident OTC deer/turkey. Elk and bear via drawing."},
  MT:{agency:"Montana Fish, Wildlife & Parks",web:"fwp.mt.gov",phone:"406-444-2535",notes:"Nonresident deer/elk DRAW - apply by April 1. Competitive. Bonus points help."},
  NE:{agency:"Nebraska Game & Parks",web:"outdoornebraska.gov",phone:"402-471-0641",notes:"Nonresident deer DRAW for some units. Apply by June. Sandhill crane region."},
  NV:{agency:"Nevada Dept of Wildlife",web:"ndow.org",phone:"775-688-1500",notes:"Almost all big game DRAW ONLY. Apply by April. Bonus points matter."},
  NH:{agency:"NH Fish and Game",web:"wildlife.nh.gov",phone:"603-271-3421",notes:"Deer and bear OTC. Moose via lottery."},
  NJ:{agency:"New Jersey Fish & Wildlife",web:"state.nj.us/dep/fgw",phone:"609-292-2965",notes:"Nonresident OTC. WMA permits required."},
  NM:{agency:"New Mexico Game & Fish",web:"wildlife.state.nm.us",phone:"505-476-8000",notes:"All big game DRAW. Apply by mid-March. Guides help for nonresidents."},
  NY:{agency:"NY DEC",web:"dec.ny.gov",phone:"518-402-8883",notes:"Nonresident OTC deer/turkey. Bear and moose limited."},
  NC:{agency:"NC Wildlife Resources",web:"ncwildlife.org",phone:"919-707-0050",notes:"Nonresident OTC. Some game lands require permits."},
  ND:{agency:"ND Game & Fish",web:"gf.nd.gov",phone:"701-328-6300",notes:"Nonresident deer/pronghorn DRAW. Apply by April-June."},
  OH:{agency:"Ohio DNR",web:"ohiodnr.gov",phone:"800-945-3543",notes:"Nonresident OTC. Urban zones require special permits."},
  OK:{agency:"Oklahoma Dept of Wildlife",web:"wildlifedepartment.com",phone:"405-521-3851",notes:"Nonresident OTC for most species. WMA permits for some units."},
  OR:{agency:"Oregon Dept of Fish & Wildlife",web:"dfw.state.or.us",phone:"800-720-6339",notes:"Most big game DRAW - apply by May 15. Preference points."},
  PA:{agency:"PA Game Commission",web:"pgc.pa.gov",phone:"717-787-4250",notes:"Nonresident OTC. Elk via drawing only."},
  SD:{agency:"SD Game, Fish & Parks",web:"gfp.sd.gov",phone:"605-223-7660",notes:"Nonresident DRAW for deer, antelope, elk. Apply by June."},
  TN:{agency:"TN Wildlife Resources",web:"tn.gov/twra",phone:"615-781-6610",notes:"Nonresident OTC. Quota hunts on some WMAs."},
  TX:{agency:"Texas Parks & Wildlife",web:"tpwd.texas.gov",phone:"800-792-1112",notes:"Mostly private land - lease or public draw hunts. WMA hunts via drawing."},
  UT:{agency:"Utah Div of Wildlife",web:"wildlife.utah.gov",phone:"801-538-4700",notes:"Nearly all tags DRAW. Apply by early March. Nonresident limited."},
  VT:{agency:"VT Fish and Wildlife",web:"vtfishandwildlife.com",phone:"802-828-1000",notes:"Nonresident OTC deer. Moose via lottery."},
  VA:{agency:"VA Dept of Wildlife",web:"dwr.virginia.gov",phone:"804-367-1000",notes:"Nonresident OTC. Some WMA hunts by permit."},
  WA:{agency:"Washington Fish & Wildlife",web:"wdfw.wa.gov",phone:"360-902-2515",notes:"Most big game DRAW. Apply by mid-May. Multi-season permits available."},
  WV:{agency:"WV Division of Natural Resources",web:"wvdnr.gov",phone:"304-558-2771",notes:"Nonresident OTC. Bear requires additional license."},
  WI:{agency:"WI DNR",web:"dnr.wisconsin.gov",phone:"888-936-7463",notes:"Nonresident OTC deer and bear. Bear by drawing for zones."},
  WY:{agency:"WY Game & Fish",web:"wgfd.wyo.gov",phone:"307-777-4600",notes:"All big game DRAW. Apply by Jan 31 (most species). Nonresident limited to 10-20% of tags."},
};

function AIHuntPlanner({callAI,aiPurchased,aiFreeCalls,stops,vehicle,prefs,memberships,onStops,onClose,onShowAIUpgrade,onMapReset,onAutoCalc}){
  const T=useTheme();
  const [step,setStep]=useState("options");
  const [result,setResult]=useState(null);
  const [accepted,setAccepted]=useState({});
  const [mergeMode,setMergeMode]=useState("replace");
  const [error,setError]=useState("");

  // Load saved hunt planner prefs from localStorage
  const [savedHunt]=useState(()=>{try{return JSON.parse(localStorage.getItem("rv-hunt-prefs")||"{}");;}catch{return{};}});
  const [species,setSpecies]=useState(savedHunt.species||"whitetail");
  const [huntState,setHuntState]=useState(savedHunt.huntState||"");
  const [huntRegion,setHuntRegion]=useState(savedHunt.huntRegion||"any");
  const [customArea,setCustomArea]=useState(savedHunt.customArea||"");
  const [campStyle,setCampStyle]=useState(savedHunt.campStyle||"mixed");
  const [tripLength,setTripLength]=useState(savedHunt.tripLength||"7");
  const [season,setSeason]=useState(savedHunt.season||"archery");
  const [notes,setNotes]=useState(savedHunt.notes||"");
  const [departState,setDepartState]=useState(savedHunt.departState||"");
  const [departCity,setDepartCity]=useState(savedHunt.departCity||"");
  const [returnTo,setReturnTo]=useState(savedHunt.returnTo||"home");
  const [budget,setBudget]=useState(null); // estimated hunt budget
  const [budgetEdits,setBudgetEdits]=useState({});
  const [huntDepartDate,setHuntDepartDate]=useState("");
  const [huntReturnDate,setHuntReturnDate]=useState("");
  const [totalHunters,setTotalHunters]=useState(1);
  const [oosHunters,setOosHunters]=useState(1);

  const homeStop=stops.find(s=>s.type==="home");
  // Get real departure city - prefer homeCity, fall back to name only if not generic
  const _homeName=homeStop?.name||"";
  const _isGeneric=_homeName.toLowerCase().includes("home")||_homeName.toLowerCase().includes("departure")||_homeName.length<3;
  const _parsedHuntCity=!_isGeneric?_homeName.split(",")[0].trim():"";
  const homeCity=homeStop?.homeCity||_parsedHuntCity||"";
  const homeState=homeStop?.state||((!_isGeneric&&_homeName.includes(","))?_homeName.split(",")[1]?.trim():"");
  const homeFull=homeCity?(homeCity+(homeState?", "+homeState:"")):(homeState||_homeName||"");
  const hasExisting=stops.filter(s=>s.active&&s.type!=="home"&&s.name).length>0;
  const rawMaxHrs=parseFloat(prefs?.maxDriveHours)||7;
  // multiDriver allows 24hr driving - use actual setting, cap at 24
  const effectiveMaxHrs=prefs?.multiDriver?Math.min(rawMaxHrs,24):Math.min(rawMaxHrs,12);
  const maxDailyMi=Math.round((parseFloat(prefs?.avgSpeedMph)||60)*effectiveMaxHrs);
  const totalHeightIn=(parseInt(vehicle?.rvHeightFt)||13)*12+(parseInt(vehicle?.rvHeightIn)||0);
  const combinedLength=vehicle?.towVehicle?(parseInt(vehicle.rvLength||36)+parseInt(vehicle.towLength||15)+5):(parseInt(vehicle?.rvLength||36));

  const SPECIES=[
    {id:"whitetail",icon:"🦌",label:"Whitetail Deer"},
    {id:"elk",icon:"🫎",label:"Elk"},
    {id:"mule_deer",icon:"🦌",label:"Mule Deer"},
    {id:"turkey",icon:"🦃",label:"Wild Turkey"},
    {id:"waterfowl",icon:"🦆",label:"Waterfowl"},
    {id:"hog",icon:"🐗",label:"Wild Hog"},
    {id:"bear",icon:"🐻",label:"Black Bear"},
    {id:"pronghorn",icon:"🦌",label:"Pronghorn"},
    {id:"upland",icon:"🐦",label:"Upland Birds"},
  ];
  const CAMP=[
    {id:"rv_hookup",icon:"🔌",label:"Full Hookup",desc:"RV parks near hunting"},
    {id:"mixed",icon:"⚡",label:"Mixed",desc:"Some hookups, some boondocking"},
    {id:"boondock",icon:"🌲",label:"Boondocking",desc:"BLM, National Forest, free"},
  ];
  const SEASONS=[
    {id:"archery",label:"Archery"},
    {id:"rifle",label:"Rifle"},
    {id:"muzzle",label:"Muzzleloader"},
    {id:"spring_turkey",label:"Spring Turkey"},
    {id:"waterfowl",label:"Waterfowl"},
    {id:"scouting",label:"Scouting Trip"},
  ];
  const REGIONS=[
    {id:"any",label:"Any area"},
    {id:"nw",label:"NW"},
    {id:"ne",label:"NE"},
    {id:"sw",label:"SW"},
    {id:"se",label:"SE"},
    {id:"central",label:"Central"},
  ];
  const US_STATES=["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

  const activeMemberships=Object.entries(memberships||{}).filter(([k,v])=>v).map(([k])=>k).join(", ")||"none";

  // Auto-calculate departure date from season + travel time
  const calcDepartureDate=()=>{
    const seasonData=HUNT_SEASONS_DATA[species]?.[season];
    if(!seasonData) return null;
    const [mo,dy]=seasonData.start;
    const year=new Date().getFullYear();
    // Estimate travel days based on max daily miles
    const depart=departCity&&departState?departCity+", "+departState:departState||homeFull||"";
    // Rough estimate: assume 400mi/day average, target state is center
    // We'll just suggest arrive 2 days before season opens
    const openDate=new Date(year,mo-1,dy);
    const travelDays=2; // conservative default, AI will refine
    const departDate=new Date(openDate);
    departDate.setDate(departDate.getDate()-travelDays);
    // If date is in the past, use next year
    if(departDate < new Date()) departDate.setFullYear(year+1);
    return departDate.toISOString().split("T")[0];
  };

  // Calculate estimated hunt budget
  const calcBudget=()=>{
    const costs=NR_LICENSE_COSTS[huntState]||{};
    const specMap={whitetail:"deer",elk:"elk",mule_deer:"deer",turkey:"turkey",bear:"bear",pronghorn:"deer",waterfowl:"deer",hog:"deer",upland:"deer"};
    const sp=specMap[species]||"deer";
    const oos=Math.min(oosHunters,totalHunters);
    const inState=totalHunters-oos;
    // NR costs per OOS hunter
    const nrLicense=(costs.license||75)*oos;
    const nrTag=((costs[sp+"_tag"]||costs.deer_tag||50))*oos;
    // Estimate in-state costs as ~30% of NR (varies widely)
    const isLicense=inState>0?Math.round((costs.license||75)*0.3)*inState:0;
    const isTag=inState>0?Math.round((costs[sp+"_tag"]||costs.deer_tag||50)*0.3)*inState:0;
    const license=nrLicense+isLicense;
    const tag=nrTag+isTag;
    const processing=(species==="hog"?0:species==="turkey"?50:species==="waterfowl"?30:175)*totalHunters;
    const taxidermy=["whitetail","elk","mule_deer","bear","pronghorn"].includes(species)?350:0; // per trophy, user adjusts
    const guide=0;
    const lease=0;
    const gear=100*totalHunters;
    const misc=50*totalHunters;
    const total=license+tag+processing+taxidermy+gear+misc;
    return{license,tag,processing,taxidermy,guide,lease,gear,misc,total,
      notes:costs.notes||"",tagLabel:sp.charAt(0).toUpperCase()+sp.slice(1)+" tag",
      hunterNote:totalHunters>1?oos+" NR × $"+(costs.license||75)+" lic + $"+((costs[sp+"_tag"]||costs.deer_tag||50))+" tag"+(inState>0?"; "+inState+" in-state (~30% est)":""):"NR license+tag"};
  };

  const buildPrompt=(extraCorrection,corridorCities=[])=>{
    const speciesLabel=SPECIES.find(s=>s.id===species)?.label||species;
    const campLabel=CAMP.find(c=>c.id===campStyle)?.label||campStyle;
    const areaDesc=huntRegion!=="any"?huntRegion+" "+huntState:huntState;
    const areaTxt=customArea?customArea+" ("+areaDesc+")":areaDesc;
    const depart=departCity&&departState?departCity+", "+departState:departState?departState:homeFull||"unknown";
    const isRoundTrip=returnTo!=="none";
    const returnDest=returnTo==="home"?(homeFull||"home"):returnTo==="start"?depart:"";
    const maxHrs=parseFloat(prefs?.maxDriveHours)||7;
    const effHrs=prefs?.multiDriver?Math.min(maxHrs,24):Math.min(maxHrs,12);
    const effMiDay=Math.round((parseFloat(prefs?.avgSpeedMph)||60)*effHrs);
    const minLeg=Math.round(effMiDay*0.55);
    const mpg=parseFloat(vehicle?.mpg)||8;
    const tank=parseFloat(vehicle?.tankGallons)||100;
    const tankRange=Math.round(mpg*tank*0.85);
    const isDiesel=(vehicle?.fuelType||"diesel").toLowerCase().includes("diesel");
    const rvLen=parseInt(vehicle?.rvLength)||36;
    const towLen=vehicle?.towVehicle?parseInt(vehicle?.towLength||15)+5:0;
    const combined=rvLen+towLen;
    const heightIn=(parseInt(vehicle?.rvHeightFt)||13)*12+(parseInt(vehicle?.rvHeightIn)||0);

    const p=[];
    p.push("Plan a "+tripLength+"-day RV hunting trip. Departure: "+depart+". Hunt: "+areaTxt+". Species: "+speciesLabel+". Season: "+season+". Camp: "+campLabel+"."+(isRoundTrip?" Return: "+returnDest+".":" One-way."));
    p.push("RV: "+(vehicle?.rvType||"RV")+", "+combined+"ft total, "+mpg+"mpg, "+tank+"gal tank (~"+tankRange+"mi range), "+(heightIn>150?heightIn/12+"ft TALL - avoid low bridges":"")+(isDiesel?" DIESEL - needs truck stops":"")+".");
    p.push("Drive: "+effHrs+"hrs/day"+(prefs?.multiDriver?" MULTI-DRIVER":"")+", ~"+effMiDay+"mi/day max, min leg "+minLeg+"mi.");
    if(notes) p.push("Notes: "+notes);
    if(extraCorrection) p.push("Fix: "+extraCorrection);
    const isMultiDriver=prefs?.multiDriver&&effHrs>=12;
    if(isMultiDriver){
      p.push("MULTI-DRIVER TEAM: "+effHrs+"hrs/day driving. NO overnight lodging unless leg exceeds "+effMiDay+"mi. En-route fuel stops ONLY: type:transit subtype:fuel_stop isFree:true nightlyRate:0 minNights:0 - minNights MUST BE 0. Name fuel stops as the CITY (e.g. Oklahoma City, OK) NOT the truck stop brand. Put brand in notes. Fuel every "+Math.round(tankRange*0.8)+"mi"+(isDiesel?" diesel (Love's/Pilot/TA)":"")+".");
    } else {
      p.push("RULES: (1) No leg over "+effMiDay+"mi - insert overnight stop. (2) Min leg "+minLeg+"mi. (3) FUEL STOP if leg >"+Math.round(tankRange*0.85)+"mi"+(isDiesel?" - diesel truck stop":"")+". (4) Rates $30-75/nt, free=isFree:true. (5)"+(isRoundTrip?" Include return.":"")+" (6) Real city+state. (7) Public land for hunt camps.");
    }
    p.push("Stop types: overnight lodging=type:tourist, fuel stop=type:transit subtype:fuel_stop isFree:true nightlyRate:0 minNights:0, hunt camp=type:tourist subtype:hunt_camp.");
    if(huntDepartDate) p.push("Depart: "+huntDepartDate+"."+(huntReturnDate?" Return by: "+huntReturnDate+".":""));
    else if(HUNT_SEASONS_DATA[species]?.[season]){const sd=HUNT_SEASONS_DATA[species][season];p.push("Season opens ~"+["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][sd.start[0]-1]+" "+sd.start[1]+".");}
    p.push('Return ONLY JSON: {"summary":"brief","totalMiles":0,"stops":[{"name":"City, ST","state":"ST","type":"tourist","subtype":"hunt_camp|overnight|fuel_stop","minNights":1,"nightlyRate":45,"isFree":false,"distFromPrev":280,"driveHours":4.5,"why":"reason","huntAccess":"land name","campNotes":"details","fuelStop":false}]}');
    return p.join(" ");
  };

  const handlePlan=async()=>{
    if(!huntState){setError("Please select a hunting state.");return;}
    // Calculate budget estimates upfront
    const budgetEst=calcBudget();
    setBudget(budgetEst);
    setBudgetEdits({});
    if(!aiPurchased&&aiFreeCalls===0){onShowAIUpgrade&&onShowAIUpgrade();return;}
    // Save current prefs for next time
    try{localStorage.setItem("rv-hunt-prefs",JSON.stringify({species,huntState,huntRegion,customArea,campStyle,tripLength,season,notes,departState,departCity,returnTo}));}catch{}
    setStep("loading");setError("");
    const isRoundTrip=returnTo!=="none";

    // Skip corridor fetch - too unreliable on mobile (rate limits/timeouts)
    // AI uses geographic knowledge from explicit departure/destination in prompt
    const corridorCities=[];

    const sys="You are an expert RV hunting trip planner. Return ONLY valid JSON with complete trip including overnight stops, return legs, and realistic $30-150 nightly rates. Use real city names with state. Include multiple stops.";

    // First attempt
    let res=await callAI(buildPrompt(undefined,corridorCities),sys);
    if(res&&res.startsWith("__ERROR__:")){setError(res.replace("__ERROR__:",""));setStep("options");return;}
    let parsed=parseAITrip(res);
    let issues=parsed?validateAITrip(parsed,maxDailyMi,isRoundTrip):["Failed to parse response"];

    // Only retry if parse completely failed (not if just validation issues)
    if(!parsed){
      res=await callAI(buildPrompt("Previous response was not valid JSON - return ONLY a clean JSON object, no markdown, no preamble",corridorCities),sys);
      parsed=parseAITrip(res);
      issues=parsed?validateAITrip(parsed,maxDailyMi,isRoundTrip):["Failed to parse after retry"];
    }

    if(!parsed){
      setError("AI returned unexpected format. The raw response is in browser console (F12). Try simpler options or add more specific notes.");
      setStep("options");
      return;
    }

    // Even with minor issues, show results but warn
    setResult(parsed);
    const acc={};
    parsed.stops.forEach((_,i)=>acc[i]=true);
    setAccepted(acc);
    if(issues.length>0){
      setError("⚠ AI plan has "+issues.length+" issue(s) - review before applying: "+issues.slice(0,2).join("; "));
    }
    setStep("results");
  };

  const handleApply=()=>{
    if(!result) return;
    const newStops=result.stops
      .filter((_,i)=>accepted[i])
      .map(s=>({
        ...mkStop(),
        name:s.name||"",state:s.state||"",
        type:s.subtype==="fuel_stop"?"transit":(["home","tourist","family","transit","event","workhub","free"].includes(s.type)?s.type:"tourist"),
        minNights:s.subtype==="fuel_stop"?0:(parseInt(s.minNights)||1),
        maxNights:s.subtype==="fuel_stop"?0:(parseInt(s.maxNights||s.minNights)||3),
        nightlyRate:s.subtype==="fuel_stop"?0:(parseFloat(s.nightlyRate)||0),
        isFree:s.subtype==="fuel_stop"?true:(s.isFree||false),
        distFromPrev:parseInt(s.distFromPrev)||0,
        notes:(s.huntAccess?"Hunt: "+s.huntAccess+". ":"")+(s.campNotes||s.why||""),
        fixedDates:false,arriveDate:"",departDate:"",lat:null,lon:null,
      }));
    // Calculate departure date from season data
    const suggestedDeparture=huntDepartDate||calcDepartureDate();
    // Use functional update to get CURRENT stops state (avoids stale closure)
    const existingHuntStops=stops.filter(s=>s.active&&s.type!=="home"&&s.name).length;
    if(mergeMode==="replace"&&existingHuntStops>0){
      if(!window.confirm("Replace your "+existingHuntStops+" existing stop"+(existingHuntStops!==1?"s":"")+" with the new hunt plan? This cannot be undone."))return;
    }
    onStops(currentStops=>{
      const home=currentStops.find(s=>s.type==="home");
      if(mergeMode==="replace"){
        const freshList=home?[{...home,departDate:suggestedDeparture||home.departDate||"",fixedDates:!!suggestedDeparture}]:[];
        newStops.forEach(ns=>{if(ns.type!=="home")freshList.push(ns);});
        return freshList;
      } else {
        const existing=currentStops.filter(s=>s.type!=="home");
        const appended=newStops.filter(s=>s.type!=="home");
        const updatedHome=home?{...home,departDate:suggestedDeparture||home.departDate||""}:null;
        return updatedHome?[updatedHome,...existing,...appended]:[...existing,...appended];
      }
    });
    onStops(currentStops=>{
      const home=currentStops.find(s=>s.type==="home");
      if(mergeMode==="replace"){
        const freshList=home?[{...home,departDate:suggestedDeparture||home.departDate||"",fixedDates:!!suggestedDeparture}]:[];
        newStops.forEach(ns=>{if(ns.type!=="home")freshList.push(ns);});
        return freshList;
      } else {
        const existing=currentStops.filter(s=>s.type!=="home");
        const appended=newStops.filter(s=>s.type!=="home");
        return home?[home,...existing,...appended]:[...existing,...appended];
      }
    });
    onMapReset&&onMapReset();
    onAutoCalc&&onAutoCalc();
    onClose();
  };

  const acceptedCount=Object.values(accepted).filter(Boolean).length;
  const subtypeIcon={hunt_camp:"🏕",overnight:"🌙",travel:"🚗",transit:"🚗",meat_proc:"🔪",fuel_stop:"⛽",scouting:"🔭",home:"🏠",depart:"🏠",return:"🏠"};
  const regs=huntState&&HUNT_REGS[huntState];

  // Warnings based on RV specs
  const heightWarning=totalHeightIn>150;
  const lengthWarning=combinedLength>30;
  const towingNote=vehicle?.towVehicle;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:600,maxHeight:"92vh",display:"flex",flexDirection:"column",boxShadow:"0 24px 80px rgba(0,0,0,0.6)",overflow:"hidden"}}>
        <div style={{background:"linear-gradient(135deg,#166534,#15803d)",padding:"14px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            <div style={{fontFamily:T.F.cond,fontWeight:900,fontSize:20,color:"#fff"}}>🦌 AI Hunt Planner</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.8)",marginTop:1}}>
              {step==="options"&&"Plan your complete RV hunting road trip"}
              {step==="loading"&&"Scouting your route..."}
              {step==="results"&&(result?.stops?.length||0)+" stops · "+(result?.totalMiles||0).toLocaleString()+" mi"}
            </div>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:"#fff",fontSize:14}}>✕</button>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"14px 18px"}}>
          {step==="options"&&<div>
            {/* Species */}
            <div style={{marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Target Species</div>
              <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                {SPECIES.map(s=><button key={s.id} onClick={()=>setSpecies(s.id)} style={{padding:"5px 10px",borderRadius:20,border:"2px solid "+(species===s.id?"#16a34a":T.border),background:species===s.id?"#16a34a18":"transparent",color:species===s.id?"#16a34a":T.muted,fontSize:11,fontWeight:species===s.id?700:400,cursor:"pointer"}}>{s.icon} {s.label}</button>)}
              </div>
            </div>

            {/* Hunting location */}
            <div style={{background:T.bgLite,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:"#16a34a",marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>🎯 Hunting Location</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>State</div>
                  <select value={huntState} onChange={e=>setHuntState(e.target.value)} style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:huntState?T.text:T.muted,padding:"6px 8px",fontSize:12,outline:"none"}}>
                    <option value="">-- Select --</option>
                    {US_STATES.map(s=><option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Region</div>
                  <select value={huntRegion} onChange={e=>setHuntRegion(e.target.value)} style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"6px 8px",fontSize:12,outline:"none"}}>
                    {REGIONS.map(r=><option key={r.id} value={r.id}>{r.label}</option>)}
                  </select>
                </div>
              </div>
              <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Specific area (optional)</div>
              <input value={customArea} onChange={e=>setCustomArea(e.target.value)} placeholder="e.g. Flint Hills, near Dodge City, Pike National Forest" style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"6px 8px",fontSize:12,outline:"none",boxSizing:"border-box"}}/>
            </div>

            {/* Departure */}
            <div style={{background:T.bgLite,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.accent,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>🏠 Trip Starting From</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1.2fr",gap:8,marginBottom:6}}>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>State <span style={{fontSize:9}}>(default: home)</span></div>
                  <select value={departState} onChange={e=>setDepartState(e.target.value)} style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"6px 8px",fontSize:12,outline:"none"}}>
                    <option value="">Home ({homeState||"not set"})</option>
                    {US_STATES.map(s=><option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>City (optional)</div>
                  <input value={departCity} onChange={e=>setDepartCity(e.target.value)} placeholder={homeCity||"city name"} style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"6px 8px",fontSize:12,outline:"none",boxSizing:"border-box"}}/>
                </div>
              </div>
              <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Return to</div>
              <div style={{display:"flex",gap:4}}>
                {[["home","🏠 Home"],["start","↺ Starting point"],["none","➡ One-way"]].map(([id,label])=><button key={id} onClick={()=>setReturnTo(id)} style={{flex:1,padding:"5px 6px",borderRadius:6,border:"1px solid "+(returnTo===id?T.accent:T.border),background:returnTo===id?T.accent+"22":"transparent",color:returnTo===id?T.accent:T.muted,fontSize:11,fontWeight:returnTo===id?700:400,cursor:"pointer"}}>{label}</button>)}
              </div>
            </div>

            {/* Trip Dates */}
            <div style={{background:T.bgLite,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.accent,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>📅 Trip Dates</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Departure Date <span style={{fontSize:9}}>(or auto from season)</span></div>
                  <input type="date" value={huntDepartDate} onChange={e=>setHuntDepartDate(e.target.value)}
                    style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"7px 9px",fontSize:12,outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Must Return By</div>
                  <input type="date" value={huntReturnDate} onChange={e=>setHuntReturnDate(e.target.value)}
                    style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"7px 9px",fontSize:12,outline:"none",boxSizing:"border-box"}}/>
                </div>
              </div>
              {!huntDepartDate&&HUNT_SEASONS_DATA[species]?.[season]&&<div style={{fontSize:10,color:"#16a34a",marginTop:4}}>📅 Auto: {HUNT_SEASONS_DATA[species][season].label} - departure will be set when you apply</div>}
            </div>
            {/* Season + Length + Camp */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Season</div>
                <select value={season} onChange={e=>setSeason(e.target.value)} style={{width:"100%",background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none"}}>
                  {SEASONS.map(s=><option key={s.id} value={s.id}>{s.label}</option>)}
                </select>
              </div>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Trip Length</div>
                <select value={tripLength} onChange={e=>setTripLength(e.target.value)} style={{width:"100%",background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none"}}>
                  {["1","2","3","5","7","10","14","21"].map(d=><option key={d} value={d}>{d==="1"?"1 day":d+" days"}</option>)}
                </select>
              </div>
            </div>

            <div style={{marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Camp Style</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6}}>
                {CAMP.map(c=><button key={c.id} onClick={()=>setCampStyle(c.id)} style={{padding:"8px 6px",borderRadius:8,border:"2px solid "+(campStyle===c.id?"#16a34a":T.border),background:campStyle===c.id?"#16a34a18":"transparent",cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:16,marginBottom:2}}>{c.icon}</div>
                  <div style={{fontSize:11,fontWeight:700,color:campStyle===c.id?"#16a34a":T.text}}>{c.label}</div>
                  <div style={{fontSize:9,color:T.muted,marginTop:1,wordBreak:"break-word"}}>{c.desc}</div>
                </button>)}
              </div>
            </div>

            {/* Warnings based on RV */}
            {(heightWarning||lengthWarning)&&<div style={{background:"#f59e0b18",border:"1px solid #f59e0b44",borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:11,color:T.text,lineHeight:1.5,wordBreak:"break-word"}}>
              <div style={{fontWeight:700,color:"#f59e0b",marginBottom:4}}>⚠ Your RV specs will affect route suggestions:</div>
              {heightWarning&&<div>• Height {vehicle.rvHeightFt}&apos;{vehicle.rvHeightIn}&quot; - AI will avoid known low-bridge areas</div>}
              {lengthWarning&&<div>• Combined length {combinedLength}&apos; - AI will recommend larger campgrounds and wider forest roads</div>}
              {towingNote&&<div>• Towing - AI will suggest drop-and-go hunting (stay at RV, hunt via tow vehicle)</div>}
            </div>}

            {/* State regs preview */}
            {regs&&<div style={{background:T.accent+"12",border:"1px solid "+T.accent+"44",borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:11,color:T.text,lineHeight:1.5,wordBreak:"break-word"}}>
              <div style={{fontWeight:700,color:T.accent,marginBottom:4}}>📋 {huntState} - {regs.agency}</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:4}}>
                <a href={"tel:"+regs.phone.replace(/[^0-9]/g,"")} style={{color:T.accent,fontWeight:700,textDecoration:"none",fontSize:11}}>📞 {regs.phone}</a>
                <a href={"https://"+regs.web} target="_blank" rel="noopener noreferrer" style={{color:T.accent,fontWeight:700,textDecoration:"none",fontSize:11}}>🌐 {regs.web} →</a>
              </div>
              <div style={{fontStyle:"italic",color:T.muted}}>{regs.notes}</div>
            </div>}

            {/* Merge/Replace */}
            {hasExisting&&<div style={{marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Existing Stops</div>
              <div style={{display:"flex",gap:8}}>
                {[["replace","🔄 Replace"],["merge","🔀 Merge"]].map(([id,label])=><button key={id} onClick={()=>setMergeMode(id)} style={{flex:1,padding:"7px",borderRadius:8,border:"2px solid "+(mergeMode===id?"#16a34a":T.border),background:mergeMode===id?"#16a34a18":"transparent",color:mergeMode===id?"#16a34a":T.muted,fontSize:11,fontWeight:mergeMode===id?700:400,cursor:"pointer"}}>{label}</button>)}
              </div>
            </div>}

            {/* Hunter Count */}
            <div style={{background:T.bgLite,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.accent,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>👥 Party Size</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Total Hunters</div>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <button onClick={()=>setTotalHunters(h=>Math.max(1,h-1))} style={{width:28,height:28,borderRadius:6,border:"1px solid "+T.border,background:T.bg,color:T.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>−</button>
                    <span style={{fontSize:16,fontWeight:700,color:T.text,minWidth:24,textAlign:"center"}}>{totalHunters}</span>
                    <button onClick={()=>setTotalHunters(h=>h+1)} style={{width:28,height:28,borderRadius:6,border:"1px solid "+T.border,background:T.bg,color:T.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>
                  </div>
                </div>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Out-of-State</div>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <button onClick={()=>setOosHunters(h=>Math.max(0,h-1))} style={{width:28,height:28,borderRadius:6,border:"1px solid "+T.border,background:T.bg,color:T.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>−</button>
                    <span style={{fontSize:16,fontWeight:700,color:T.text,minWidth:24,textAlign:"center"}}>{Math.min(oosHunters,totalHunters)}</span>
                    <button onClick={()=>setOosHunters(h=>Math.min(h+1,totalHunters))} style={{width:28,height:28,borderRadius:6,border:"1px solid "+T.border,background:T.bg,color:T.text,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>
                  </div>
                  <div style={{fontSize:9,color:T.muted,marginTop:2}}>{Math.min(oosHunters,totalHunters)} NR · {totalHunters-Math.min(oosHunters,totalHunters)} in-state</div>
                </div>
              </div>
            </div>
            {/* Notes */}
            <div style={{marginBottom:8}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:.5}}>Notes <span style={{fontWeight:400,fontSize:10}}>(optional)</span></div>
              <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="e.g. meeting friends at hunt camp, need Cabelas stop in Dallas, prefer national forest land..." style={{width:"100%",background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none",resize:"vertical",minHeight:50,fontFamily:T.F.body,boxSizing:"border-box"}}/>
            </div>
            {error&&<div style={{padding:"8px 12px",background:T.danger+"18",borderRadius:8,fontSize:12,color:T.danger,wordBreak:"break-word"}}>{error}</div>}
          </div>}

          {step==="loading"&&<div style={{textAlign:"center",padding:"40px 20px"}}>
            <div style={{fontSize:48,marginBottom:16}}>🌲</div>
            <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:18,color:"#16a34a",marginBottom:8}}>Scouting Your Hunt Trip...</div>
            <div style={{fontSize:13,color:T.muted,lineHeight:1.7}}>Planning overnight stops, finding public land,<br/>checking RV clearances. About 15-20 seconds.</div>
          </div>}

          {step==="results"&&result&&<div>
            {result.summary&&<div style={{background:"#16a34a18",border:"1px solid #16a34a33",borderRadius:10,padding:"10px 14px",marginBottom:10,fontSize:12,color:T.text,lineHeight:1.6,wordBreak:"break-word"}}>
              <span style={{fontWeight:700,color:"#16a34a"}}>🦌 </span>{result.summary}
            </div>}
            {/* Regs banner */}
            {regs&&<div style={{background:T.accent+"12",border:"1px solid "+T.accent+"44",borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:11,lineHeight:1.5,wordBreak:"break-word"}}>
              <div style={{fontWeight:700,color:T.accent,marginBottom:3}}>📋 {huntState} - {regs.agency}</div>
              <div>{regs.web} · {regs.phone}</div>
              <div style={{marginTop:3,fontStyle:"italic",color:T.muted}}>{regs.notes}</div>
            </div>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginBottom:10}}>
              {[
                {l:"Total Miles",v:(result.totalMiles||0).toLocaleString(),c:"#16a34a"},
                {l:"Accepted",v:acceptedCount+"/"+result.stops.length,c:T.accent},
                {l:"Trip",v:tripLength+" days",c:T.blue},
              ].map((s,i)=><div key={i} style={{background:T.bgLite,borderRadius:8,padding:"6px",textAlign:"center"}}>
                <div style={{fontSize:14,fontWeight:800,color:s.c,fontFamily:T.F.head}}>{s.v}</div>
                <div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.3,marginTop:1}}>{s.l}</div>
              </div>)}
            </div>
            <div style={{display:"flex",gap:6,marginBottom:10}}>
              <button onClick={()=>{const a={};result.stops.forEach((_,i)=>a[i]=true);setAccepted(a);}} style={{flex:1,background:T.free+"22",border:"1px solid "+T.free+"44",borderRadius:8,padding:"5px",fontSize:10,fontWeight:700,color:T.free,cursor:"pointer"}}>✓ All</button>
              <button onClick={()=>{const a={};result.stops.forEach((_,i)=>a[i]=false);setAccepted(a);}} style={{flex:1,background:T.danger+"22",border:"1px solid "+T.danger+"44",borderRadius:8,padding:"5px",fontSize:10,fontWeight:700,color:T.danger,cursor:"pointer"}}>✕ None</button>
              <button onClick={()=>setStep("options")} style={{flex:1,background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,padding:"5px",fontSize:10,fontWeight:600,color:T.muted,cursor:"pointer"}}>↺ Re-plan</button>
            </div>
            {/* Trip Summary Card */}
            {(()=>{
              // Use state-specific season dates when available, fall back to generic
              const stateSeasonOverride=STATE_HUNT_SEASONS[huntState]?.[species]?.[season];
              const seasonData=stateSeasonOverride
                ?{...HUNT_SEASONS_DATA[species]?.[season],...stateSeasonOverride,
                   label:(stateSeasonOverride.label||"")+(huntState?" ("+huntState+" typical)":"")}
                :HUNT_SEASONS_DATA[species]?.[season];
              const suggestedDept=calcDepartureDate();
              const totalNights=result.stops.filter((_,i)=>accepted[i]).reduce((s,st)=>s+(st.type!=="home"?parseInt(st.minNights)||1:0),0);
              const estReturnDate=suggestedDept?new Date(new Date(suggestedDept).getTime()+(totalNights+2)*86400000).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}):null;
              const deptDisplay=suggestedDept?new Date(suggestedDept+"T00:00:00").toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",year:"numeric"}):null;
              const budgetTotal=budget?Object.keys(budget).filter(k=>["license","tag","processing","taxidermy","guide","lease","gear","misc"].includes(k)).reduce((s,k)=>s+(parseFloat(budgetEdits[k]!==undefined?budgetEdits[k]:budget[k])||0),0):0;
              const lodgeCost=result.stops.filter((_,i)=>accepted[i]).reduce((s,st)=>s+((st.isFree?0:(parseFloat(st.nightlyRate)||45))*(parseInt(st.minNights)||1)),0);
              return <div style={{background:T.bgLite,border:"1px solid "+T.border,borderRadius:10,padding:"10px 14px",marginBottom:10}}>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.accent,marginBottom:8}}>📋 Trip Summary</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                  {deptDisplay&&<div><div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Depart</div><div style={{fontSize:12,fontWeight:700,color:T.text}}>{deptDisplay}</div></div>}
                  {estReturnDate&&<div><div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Est. Return</div><div style={{fontSize:12,fontWeight:700,color:T.text}}>{estReturnDate}</div></div>}
                  <div><div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Total Miles</div><div style={{fontSize:12,fontWeight:700,color:"#16a34a"}}>{(result.totalMiles||0).toLocaleString()} mi</div></div>
                  <div><div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Nights</div><div style={{fontSize:12,fontWeight:700,color:T.blue}}>{totalNights} nights</div></div>
                  {lodgeCost>0&&<div><div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Est. Lodging</div><div style={{fontSize:12,fontWeight:700,color:T.accent}}>${Math.round(lodgeCost)}</div></div>}
                  {budgetTotal>0&&<div><div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.5}}>Hunt Budget</div><div style={{fontSize:12,fontWeight:700,color:"#f59e0b"}}>${Math.round(budgetTotal)}</div></div>}
                </div>
                {(lodgeCost+budgetTotal)>0&&<div style={{borderTop:"1px solid "+T.border,marginTop:8,paddingTop:6,display:"flex",justifyContent:"space-between"}}>
                  <div style={{fontSize:10,color:T.muted}}>Est. Total (lodging + hunt)</div>
                  <div style={{fontSize:13,fontWeight:800,color:T.text}}>${Math.round(lodgeCost+budgetTotal)}</div>
                </div>}
                {(stateSeasonOverride||seasonData)&&<div style={{marginTop:6,fontSize:10,color:"#16a34a",fontStyle:"italic"}}>📅 {(stateSeasonOverride||seasonData).label} - verify current regs</div>}
              </div>;
            })()}
            {/* Season dates banner - simplified */}
            {!calcDepartureDate()&&HUNT_SEASONS_DATA[species]?.[season]&&<div style={{background:"#16a34a12",border:"1px solid #16a34a33",borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:11,color:T.text,lineHeight:1.5}}>
              <div style={{fontWeight:700,color:"#16a34a",marginBottom:2}}>📅 Typical Season Window</div>
              <div>{HUNT_SEASONS_DATA[species][season].label}</div>
              <div style={{color:T.muted,marginTop:2,fontStyle:"italic"}}>Departure date auto-set when you apply. Always verify dates with state agency.</div>
            </div>}
            {/* Hunt Budget Card */}
            {budget&&<div style={{background:T.bgLite,border:"1px solid "+T.border,borderRadius:10,padding:"10px 12px",marginBottom:10}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.accent,marginBottom:8}}>💰 Estimated Hunt Budget</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                {[
                  {k:"license",l:"NR License"},
                  {k:"tag",l:budget.tagLabel||"Tag/Permit"},
                  {k:"processing",l:"Processing"},
                  {k:"taxidermy",l:"Taxidermist"},
                  {k:"guide",l:"Guide Fees"},
                  {k:"lease",l:"Lease Fees"},
                  {k:"gear",l:"Gear/Ammo"},
                  {k:"misc",l:"Misc"},
                ].map(({k,l})=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:6}}>
                    <div style={{fontSize:10,color:T.muted,flex:1}}>{l}</div>
                    <div style={{display:"flex",alignItems:"center",gap:2}}>
                      <span style={{fontSize:10,color:T.muted}}>$</span>
                      <input
                        type="text" inputMode="numeric"
                        defaultValue={budgetEdits[k]!==undefined?budgetEdits[k]:budget[k]}
                        style={{width:55,background:T.bg,border:"1px solid "+T.border,borderRadius:4,color:T.text,padding:"2px 4px",fontSize:11,textAlign:"right",outline:"none"}}
                        onFocus={e=>e.target.select()}
                        onBlur={e=>{const v=parseFloat(e.target.value)||0;setBudgetEdits(b=>({...b,[k]:v}));}}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div style={{borderTop:"1px solid "+T.border,marginTop:8,paddingTop:6,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{fontSize:11,color:T.muted}}>Estimated Total</div>
                <div style={{fontSize:14,fontWeight:800,color:T.accent,fontFamily:T.F.head}}>
                  ${Object.keys(budget).filter(k=>["license","tag","processing","taxidermy","guide","lease","gear","misc"].includes(k)).reduce((sum,k)=>sum+(budgetEdits[k]!==undefined?parseFloat(budgetEdits[k])||0:parseFloat(budget[k])||0),0).toLocaleString()}
                </div>
              </div>
              {budget.hunterNote&&<div style={{fontSize:10,color:T.accent,marginTop:3,fontWeight:600}}>👥 {totalHunters} hunter{totalHunters!==1?"s":""}: {budget.hunterNote}</div>}
              {budget.notes&&<div style={{fontSize:10,color:T.muted,marginTop:2,fontStyle:"italic"}}>⚠ {budget.notes}</div>}
              <div style={{fontSize:9,color:T.muted,marginTop:2,fontStyle:"italic"}}>Estimates only - verify current costs with state agency</div>
            </div>}
            {result.stops.map((s,i)=>{
              const isAcc=accepted[i];
              const icon=subtypeIcon[s.subtype]||"📍";
      const isFuelStop=s.subtype==="fuel_stop"||s.fuelStop;
              return<div key={i} onClick={()=>setAccepted(a=>({...a,[i]:!a[i]}))} style={{display:"flex",gap:8,padding:"9px 11px",borderRadius:10,marginBottom:5,cursor:"pointer",background:isAcc?"#16a34a0a":T.bgLite+"88",border:"2px solid "+(isAcc?"#16a34a":T.border+"44"),opacity:isAcc?1:0.5}}>
                <div style={{width:24,height:24,borderRadius:"50%",background:isAcc?"#16a34a":T.border,color:"#fff",fontSize:10,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{isAcc?"✓":i+1}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:4,alignItems:"flex-start"}}>
                    <div style={{fontWeight:700,fontSize:12,color:isFuelStop?"#f59e0b":T.text,wordBreak:"break-word",flex:1,minWidth:0}}>{icon} {s.name}{isFuelStop&&<span style={{fontSize:9,background:"#f59e0b22",color:"#f59e0b",borderRadius:4,padding:"1px 5px",marginLeft:5,fontWeight:600}}>FUEL STOP</span>}</div>
                    <div style={{display:"flex",gap:3,flexWrap:"wrap",flexShrink:0}}>
                      {s.driveHours>0&&<span style={{fontSize:9,color:T.muted,background:T.bgLite,padding:"1px 5px",borderRadius:6}}>🚗{s.driveHours}h</span>}
                      {s.distFromPrev>0&&<span style={{fontSize:9,color:T.muted,background:T.bgLite,padding:"1px 5px",borderRadius:6}}>{s.distFromPrev}mi</span>}
                      <span style={{fontSize:9,fontWeight:600,color:s.isFree?"#16a34a":T.accent,background:(s.isFree?"#16a34a":T.accent)+"18",padding:"1px 5px",borderRadius:6}}>{s.isFree?"FREE":"$"+s.nightlyRate}</span>
                    </div>
                  </div>
                  {s.minNights>0&&s.type!=="home"&&<div style={{fontSize:10,color:T.muted,marginTop:1}}>{s.minNights} nights</div>}
                  {s.huntAccess&&<div style={{fontSize:10,color:"#16a34a",marginTop:2,fontWeight:600,wordBreak:"break-word"}}>🎯 {s.huntAccess}</div>}
                  {s.campNotes&&<div style={{fontSize:10,color:T.muted,marginTop:1,fontStyle:"italic",wordBreak:"break-word"}}>{s.campNotes}</div>}
                  {s.fuelStop&&<div style={{fontSize:10,color:"#f59e0b",marginTop:1,fontWeight:600}}>⛽ Fuel recommended</div>}
                </div>
              </div>;
            })}
          </div>}
        </div>

        <div style={{padding:"10px 18px",borderTop:"1px solid "+T.border,display:"flex",gap:8,flexShrink:0}}>
          <button onClick={onClose} style={{flex:1,background:"none",border:"1px solid "+T.border,borderRadius:10,padding:"9px",color:T.muted,fontSize:12,fontWeight:600,cursor:"pointer"}}>Cancel</button>
          {step==="options"&&<button onClick={handlePlan} style={{flex:2,background:"#16a34a",color:"#fff",border:"none",borderRadius:10,padding:"9px",fontSize:12,fontWeight:700,cursor:"pointer"}}>🦌 Plan Hunt Trip</button>}
          {step==="results"&&<button onClick={handleApply} disabled={acceptedCount===0} style={{flex:2,background:acceptedCount>0?"#16a34a":T.border,color:"#fff",border:"none",borderRadius:10,padding:"9px",fontSize:12,fontWeight:700,cursor:acceptedCount>0?"pointer":"not-allowed"}}>✓ Add {acceptedCount} Stop{acceptedCount!==1?"s":""}</button>}
        </div>
      </div>
    </div>
  );
}


// ── AIStopBuilder ─────────────────────────────────────────────────
function AIStopBuilder({callAI,aiPurchased,aiFreeCalls,onStops,stops,vehicle,prefs,fuel,memberships,onClose,onShowAIUpgrade,onMapReset,onAutoCalc}){
  const T=useTheme();
  const homeStop=stops.find(s=>s.type==="home");
  // Extract real city from home stop - try homeCity field first, then parse name
  const _homeName=homeStop?.name||"";
  const _nameIsGeneric=_homeName.toLowerCase().includes("home")||_homeName.toLowerCase().includes("departure")||_homeName.length<3;
  const _parsedCity=!_nameIsGeneric?_homeName.split(",")[0].trim():"";
  const homeCity=homeStop?.homeCity||_parsedCity||"";
  const homeState=homeStop?.state||((!_nameIsGeneric&&_homeName.includes(","))?_homeName.split(",")[1]?.trim():"");
  const homeFull=homeCity?(homeCity+(homeState?", "+homeState:"")):(homeState||_homeName||"");
  const maxDailyMi=Math.round((parseFloat(prefs?.avgSpeedMph)||60)*(parseFloat(prefs?.maxDriveHours)||7));

  const [step,setStep]=useState("options");
  const [result,setResult]=useState(null);
  const [routeSummary,setRouteSummary]=useState(null);
  const [accepted,setAccepted]=useState({});
  const [mergeMode,setMergeMode]=useState("replace");
  const [error,setError]=useState("");
  const [loading,setLoading]=useState(false);

  // Load saved route planner prefs
  const [savedRoute]=useState(()=>{try{return JSON.parse(localStorage.getItem("rv-route-prefs")||"{}");;}catch{return{};}});
  const [destination,setDestination]=useState(savedRoute.destination||"");
  const [destState,setDestState]=useState(savedRoute.destState||"");
  const [routeStyle,setRouteStyle]=useState(savedRoute.routeStyle||"balanced");
  const [tripLength,setTripLength]=useState(savedRoute.tripLength||"7");
  const [returnTo,setReturnTo]=useState(savedRoute.returnTo||"home");
  const [notes,setNotes]=useState(savedRoute.notes||"");
  const [viaPoints,setViaPoints]=useState(savedRoute.viaPoints||"");
  const [departDate,setDepartDate]=useState(()=>homeStop?.departDate||"");
  const [returnDate,setReturnDate]=useState("");

  const hasExisting=stops.filter(s=>s.active&&s.type!=="home"&&s.name).length>0;
  const US_STATES=["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
  const STYLES=[
    {id:"balanced",icon:"⚖",label:"Balanced",desc:"Mix of speed and sights"},
    {id:"scenic",icon:"🏔",label:"Scenic",desc:"National parks & views"},
    {id:"fastest",icon:"⚡",label:"Fastest",desc:"Minimize drive time"},
    {id:"budget",icon:"💰",label:"Budget",desc:"Free camps & low cost"},
    {id:"adventure",icon:"🌲",label:"Adventure",desc:"Off the beaten path"},
  ];

  const buildPrompt=(extraCorrection,corridorCities=[])=>{
    const maxHrs=parseFloat(prefs?.maxDriveHours)||7;
    const flexMi=Math.round(maxDailyMi*1.15);
    const minLegMi=Math.round(maxDailyMi*0.55);
    const tankRangeMi=Math.round((vehicle?.mpg||8)*(vehicle?.tankGallons||100)*0.85);
    const isDiesel=(vehicle?.fuelType||"diesel").toLowerCase().includes("diesel");
    const effectiveMaxHrs=prefs?.multiDriver?Math.min(parseFloat(prefs?.maxDriveHours)||7,24):Math.min(parseFloat(prefs?.maxDriveHours)||7,12);
    const routeIsMultiDriver=prefs?.multiDriver&&effectiveMaxHrs>=12;
    const destFull=destination+(destState?", "+destState:"");
    const isRoundTrip=returnTo!=="none";
    const returnNote=returnTo==="home"?"Return to: "+homeFull:returnTo==="start"?"Return to: "+destFull:"One-way - no return leg";
    const p=[];
    const isRoundTrip2=returnTo!=="none";
    // Rough distance estimate for sanity check (will be refined by ORS)
    const estOnewayMi=corridorCities.length>0?Math.round(corridorCities.length*40):null;
    const estTotalMi=estOnewayMi?(isRoundTrip2?estOnewayMi*2:estOnewayMi):null;
    const isDayTrip=estTotalMi&&estTotalMi<maxDailyMi;
    const needsOvernights=!estTotalMi||(isRoundTrip2?estOnewayMi>maxDailyMi:estTotalMi>maxDailyMi);
    p.push("Plan a COMPLETE RV road trip. You are an expert RV trip planner with real US highway knowledge.");
    p.push("FROM: "+homeFull+". TO: "+destFull+". "+returnNote+".");
    const destNights=parseInt(tripLength)||7;
    const driveDays=isDayTrip?(routeIsMultiDriver?0:1):Math.ceil((estTotalMi||maxDailyMi*2)/maxDailyMi);
    const stayNights=Math.max(1,destNights-driveDays*(isRoundTrip2?2:1));
    p.push("Route style: "+routeStyle+". Trip length: "+tripLength+" days."+(estTotalMi?" Estimated total distance: ~"+estTotalMi+" miles.":"")
      +(isDayTrip
        ?" SHORT DRIVE ("+( estTotalMi||"<200")+" mi total) but "+tripLength+"-day trip: drive to destination day 1, stay "+stayNights+" nights at an RV park there, drive home on day "+tripLength+". Recommend a real RV park or campground at the destination."
        :" Add overnight driving stops only when a leg genuinely exceeds the daily drive limit. Destination stay: "+stayNights+" nights."));
    // Calculate dates deterministically
    if(departDate){
      const depDate=new Date(departDate+"T00:00:00");
      const retDate=new Date(depDate);
      retDate.setDate(retDate.getDate()+parseInt(tripLength)||7);
      const retStr=retDate.toISOString().slice(0,10);
      p.push("DATES: Departure "+departDate+". Must return by "+retStr+" ("+tripLength+" days total). "
        +"Set departDate:"+departDate+" on home stop. Calculate arriveDate and departDate for each stop so the trip fits within these dates.");
    } else if(returnDate){
      p.push("Must return by: "+returnDate+".");
    }
    const vehicleCtx=buildVehicleContext(vehicle,prefs,{avgPricePerGallon:3.50},memberships);
    p.push("VEHICLE AND FUEL DATA (use ALL of this):\n"+vehicleCtx);
    p.push("DRIVING: Target "+maxHrs+"-"+(maxHrs+1)+" hrs/day = "+maxDailyMi+"-"+flexMi+" mi/day. Maximize each day - 1hr over is fine to skip an unnecessary stop.");
    if(corridorCities.length>0) p.push("ROUTE CORRIDOR (ORS actual highway route): "+corridorCities.join(" to ")+". Use cities on or near this corridor.");
    else p.push("GEOGRAPHY: Trace the most direct US highway route between all points. All stops must be on the direct route - no detours.");
    if(viaPoints) p.push("MUST ROUTE THROUGH these cities in order: "+viaPoints+". Include each as a stop or ensure the route passes through them.");
    if(notes) p.push("USER NOTES: "+notes);
    if(extraCorrection) p.push("FIX FROM LAST ATTEMPT: "+extraCorrection);
    if(routeIsMultiDriver){
      p.push("MULTI-DRIVER ("+effectiveMaxHrs+"hrs/day): NO overnight lodging en route. En-route stops = fuel only. Fuel stop rules: type:transit subtype:fuel_stop isFree:true nightlyRate:0 minNights:0. Name fuel stop as the CITY only (e.g. Joplin, MO) - put truck stop brand in notes. Fuel every "+Math.round(tankRangeMi*0.8)+"mi"+(isDiesel?" diesel":"")+".");
      p.push("Destination is the ONLY multi-night stop. All en-route stops must have minNights:0.");
    } else {
      p.push("RULES: (1) Legs "+minLegMi+"-"+flexMi+"mi. (2) Overnight only if next city genuinely >"+( maxHrs+1)+"hrs. (3) Rates $30-75, free=isFree:true. Never >$150. (4) Return trip if round trip. (5) Avoid low bridges for tall RV.");
    }
    p.push("FUEL STOPS REQUIRED: Add type:transit subtype:fuel_stop whenever leg >"+Math.round(tankRangeMi*0.85)+"mi. IMPORTANT: name the stop as the CITY only (e.g. \"Salina, KS\" not \"Love's Travel Stop\") - put truck stop name in notes. isFree:true nightlyRate:0 minNights:0. Use real truck stops for diesel"+(isDiesel?" (diesel required)":"")+".");
    p.push('Return ONLY this JSON: {"summary":"2-sentence overview","totalMiles":0,"stops":[{"name":"City, ST","state":"ST","type":"home|tourist|family|transit|event|workhub|free","minNights":2,"nightlyRate":45,"isFree":false,"distFromPrev":320,"departDate":"","arriveDate":"","notes":"why"}]}. First stop home. Include return leg. 5-12 stops.');
    return p.join(" ");
  };

  const handleBuild=async()=>{
    if(!destination.trim()){setError("Please enter a destination.");return;}
    if(!aiPurchased&&aiFreeCalls===0){onShowAIUpgrade&&onShowAIUpgrade();return;}
    // Save prefs for next time
    try{localStorage.setItem("rv-route-prefs",JSON.stringify({destination,destState,routeStyle,tripLength,returnTo,notes,viaPoints}));}catch{}
    setLoading(true);setError("");setResult(null);

    let corridorCities=[];
    try{
      const destFull=destination+(destState?", "+destState:"");
      const corridorTimeout=new Promise((_,rej)=>setTimeout(()=>rej(new Error("timeout")),6000));
      const corridorFetch=(async()=>{
        const[fromCoord,toCoord]=await Promise.all([geocodeCityForHunt(homeFull),geocodeCityForHunt(destFull)]);
        if(fromCoord&&toCoord){
          const cities=await getRouteCorridorCities(fromCoord,toCoord);
          return cities||[];
        }
        return [];
      })();
      corridorCities=await Promise.race([corridorFetch,corridorTimeout]);
    }catch(e){
      console.warn("Corridor skipped:",e.message);
      corridorCities=[];
    }

    const sys="You are an expert RV trip planner. Return ONLY valid JSON object with stops array, realistic $30-150 rates, proper overnight stops. No markdown.";
    let res=await callAI(buildPrompt(undefined,corridorCities),sys);
    if(res&&res.startsWith("__ERROR__:")){setError(res.replace("__ERROR__:",""));setLoading(false);return;}
    let parsed=parseAITrip(res);
    let issues=parsed?validateAITrip(parsed,maxDailyMi,returnTo!=="none"):["Failed to parse"];
    if(!parsed){
      res=await callAI(buildPrompt("Previous response was not valid JSON - return ONLY a JSON object with stops array, no markdown",corridorCities),sys);
      if(res&&res.startsWith("__ERROR__:")){setError(res.replace("__ERROR__:",""));setLoading(false);return;}
      parsed=parseAITrip(res);
      issues=parsed?validateAITrip(parsed,maxDailyMi,returnTo!=="none"):["Failed after retry"];
    }
    if(!parsed){setError("AI returned unexpected format. Try adding more detail in Notes.");setLoading(false);return;}
    setRouteSummary({summary:parsed.summary,totalMiles:parsed.totalMiles});
    setResult(parsed.stops||[]);
    const acc={};(parsed.stops||[]).forEach((_,i)=>acc[i]=true);setAccepted(acc);
    if(issues.length>0) setError("⚠ "+issues.length+" issue(s): "+issues.slice(0,2).join("; "));
    setStep("results");
    setLoading(false);
  };

  const handleAdd=(mode)=>{
    if(mode==="replace"){
      const existingCount=stops.filter(s=>s.active&&s.type!=="home"&&s.name).length;
      if(existingCount>0&&!window.confirm("Replace your "+existingCount+" existing stop"+(existingCount!==1?"s":"")+" with the new AI plan? This cannot be undone."))return;
    }
    const newStops=result.filter((_,i)=>accepted[i]).map(s=>({
      ...mkStop(),
      name:s.name||"",state:s.state||"",homeCity:s.homeCity||"",
      type:(s.subtype==="fuel_stop"||s.fuelStop)?"transit":(["home","tourist","family","transit","event","workhub","free"].includes(s.type)?s.type:"tourist"),
      minNights:(s.subtype==="fuel_stop"||s.fuelStop)?0:(parseInt(s.minNights)||0),maxNights:(s.subtype==="fuel_stop"||s.fuelStop)?0:(parseInt(s.maxNights||s.minNights)||0),
      nightlyRate:(s.subtype==="fuel_stop"||s.fuelStop)?0:(parseFloat(s.nightlyRate)||0),isFree:(s.subtype==="fuel_stop"||s.fuelStop)?true:(s.isFree||false),
      notes:s.notes||"",distFromPrev:parseInt(s.distFromPrev)||0,
      arriveDate:s.arriveDate||"",departDate:s.departDate||"",
      fixedDates:!!(s.arriveDate||s.departDate),lat:null,lon:null,
    }));
    onStops(currentStops=>{
      const home=currentStops.find(s=>s.type==="home");
      const updatedHome=home?(departDate?{...home,departDate,fixedDates:true}:home):null;
      if(mode==="replace"){
        const freshList=updatedHome?[updatedHome]:[newStops.find(s=>s.type==="home")||{...mkStop(),type:"home",name:"Home"}];
        const homeNameLower=(updatedHome?.homeCity||updatedHome?.name||"").toLowerCase().split(",")[0].trim();
        newStops.filter(s=>{
          if(s.type==="home") return false;
          const sNameLower=(s.name||"").toLowerCase().split(",")[0].trim();
          if(homeNameLower&&sNameLower===homeNameLower) return false;
          return true;
        }).forEach(s=>freshList.push(s));
        return freshList;
      } else {
        const existing=currentStops.filter(s=>s.type!=="home");
        const existingNames=new Set(existing.map(s=>(s.name||"").toLowerCase().split(",")[0].trim()));
        const toAdd=newStops.filter(s=>s.type!=="home"&&!existingNames.has((s.name||"").toLowerCase().split(",")[0].trim()));
        const baseHome=updatedHome||{...mkStop(),type:"home",name:"Home"};
        return[baseHome,...existing,...toAdd];
      }
    });
    onMapReset&&onMapReset();
    onAutoCalc&&onAutoCalc();
    onClose();
  };

  const acceptedCount=Object.values(accepted).filter(Boolean).length;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.88)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:580,maxHeight:"92vh",display:"flex",flexDirection:"column",boxShadow:"0 24px 80px rgba(0,0,0,0.6)",overflow:"hidden"}}>
        <div style={{background:"linear-gradient(135deg,"+T.accent+","+T.blue+")",padding:"14px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            <div style={{fontFamily:T.F.cond,fontWeight:900,fontSize:20,color:"#fff"}}>✨ AI Route Planner</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.8)",marginTop:1}}>
              {step==="options"&&"Plan your complete RV road trip"}
              {step==="results"&&(result?.length||0)+" stops · "+((routeSummary?.totalMiles)||0).toLocaleString()+" mi"}
            </div>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:"#fff",fontSize:14}}>✕</button>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"14px 18px"}}>
          {step==="options"&&<div>
            {/* Departure */}
            <div style={{background:T.bgLite,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.accent,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>🏠 Departing From</div>
              <div style={{fontSize:13,color:T.text,fontWeight:600}}>{homeFull||"Not set - add your home city in Setup"}</div>
              {!homeFull&&<div style={{fontSize:11,color:T.danger,marginTop:4}}>⚠ Set your home city in Setup → Travel Style first</div>}
            </div>

            {/* Departure date */}
            <div style={{background:T.bgLite,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.accent,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>📅 Trip Dates</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Departure Date</div>
                  <input type="date" value={departDate} onChange={e=>setDepartDate(e.target.value)}
                    style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"7px 9px",fontSize:12,outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>Return By (optional)</div>
                  <input type="date" value={returnDate} onChange={e=>setReturnDate(e.target.value)}
                    style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"7px 9px",fontSize:12,outline:"none",boxSizing:"border-box"}}/>
                </div>
              </div>
            </div>
            {/* Destination */}
            <div style={{background:T.bgLite,borderRadius:10,padding:"10px 12px",marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:"#16a34a",marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>📍 Destination</div>
              <div style={{display:"grid",gridTemplateColumns:"1.5fr 1fr",gap:8}}>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>City</div>
                  <input value={destination} onChange={e=>setDestination(e.target.value)} placeholder="e.g. Nashville" style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"7px 9px",fontSize:13,outline:"none",boxSizing:"border-box"}}/>
                </div>
                <div>
                  <div style={{fontSize:10,color:T.muted,marginBottom:3}}>State</div>
                  <select value={destState} onChange={e=>setDestState(e.target.value)} style={{width:"100%",background:T.bg,border:"1px solid "+T.border,borderRadius:6,color:T.text,padding:"7px 9px",fontSize:13,outline:"none"}}>
                    <option value="">-- State --</option>
                    {US_STATES.map(s=><option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
            </div>

            {/* Route Style */}
            <div style={{marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Route Style</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6}}>
                {STYLES.map(s=><button key={s.id} onClick={()=>setRouteStyle(s.id)} style={{padding:"8px 6px",borderRadius:8,border:"2px solid "+(routeStyle===s.id?T.accent:T.border),background:routeStyle===s.id?T.accent+"18":"transparent",cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:16,marginBottom:2}}>{s.icon}</div>
                  <div style={{fontSize:11,fontWeight:700,color:routeStyle===s.id?T.accent:T.text}}>{s.label}</div>
                  <div style={{fontSize:9,color:T.muted,marginTop:1}}>{s.desc}</div>
                </button>)}
              </div>
            </div>

            {/* Trip Length + Return */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Trip Length</div>
                <select value={tripLength} onChange={e=>setTripLength(e.target.value)} style={{width:"100%",background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none"}}>
                  {["1","2","3","5","7","10","14","21"].map(d=><option key={d} value={d}>{d==="1"?"1 day":d+" days"}</option>)}
                </select>
              </div>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Return</div>
                <div style={{display:"flex",gap:4}}>
                  {[["home","🏠 Home"],["none","➡ One-way"]].map(([id,label])=><button key={id} onClick={()=>setReturnTo(id)} style={{flex:1,padding:"7px 4px",borderRadius:6,border:"1px solid "+(returnTo===id?T.accent:T.border),background:returnTo===id?T.accent+"22":"transparent",color:returnTo===id?T.accent:T.muted,fontSize:11,fontWeight:returnTo===id?700:400,cursor:"pointer"}}>{label}</button>)}
                </div>
              </div>
            </div>

            {/* Merge/Replace */}
            {hasExisting&&<div style={{marginBottom:12}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:.5}}>Existing Stops</div>
              <div style={{display:"flex",gap:8}}>
                {[["replace","🔄 Replace"],["merge","🔀 Merge"]].map(([id,label])=><button key={id} onClick={()=>setMergeMode(id)} style={{flex:1,padding:"7px",borderRadius:8,border:"2px solid "+(mergeMode===id?T.accent:T.border),background:mergeMode===id?T.accent+"18":"transparent",color:mergeMode===id?T.accent:T.muted,fontSize:11,fontWeight:mergeMode===id?700:400,cursor:"pointer"}}>{label}</button>)}
              </div>
            </div>}

            {/* Route via */}
            <div style={{marginBottom:10}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:.5}}>📍 Route Via <span style={{fontWeight:400,fontSize:10}}>(optional - cities to pass through)</span></div>
              <input value={viaPoints} onChange={e=>setViaPoints(e.target.value)} placeholder="e.g. Memphis TN, St. Louis MO (comma separated)" style={{width:"100%",background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,color:T.text,padding:"8px 10px",fontSize:12,outline:"none",boxSizing:"border-box"}}/>
              <div style={{fontSize:10,color:T.muted,marginTop:3}}>AI will route through these cities. You can also add Waypoint stops manually to the trip after planning.</div>
            </div>
            {/* Notes */}
            <div style={{marginBottom:8}}>
              <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:.5}}>Notes <span style={{fontWeight:400,fontSize:10}}>(optional)</span></div>
              <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="e.g. want to stop at Graceland, avoid tolls, need full hookups every 3 nights, departing Dec 1..." style={{width:"100%",background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,color:T.text,padding:"7px 10px",fontSize:12,outline:"none",resize:"vertical",minHeight:60,fontFamily:T.F.body,boxSizing:"border-box"}}/>
            </div>
            {error&&<div style={{padding:"8px 12px",background:T.danger+"18",borderRadius:8,fontSize:12,color:T.danger,wordBreak:"break-word"}}>{error}</div>}
          </div>}

          {step==="results"&&result&&<div>
            {routeSummary?.summary&&<div style={{background:T.accent+"12",border:"1px solid "+T.accent+"33",borderRadius:10,padding:"10px 14px",marginBottom:10,fontSize:12,color:T.text,lineHeight:1.6,wordBreak:"break-word"}}>
              <span style={{fontWeight:700,color:T.accent}}>✨ </span>{routeSummary.summary}
            </div>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginBottom:10}}>
              {[
                {l:"Total Miles",v:((routeSummary?.totalMiles)||0).toLocaleString()+" mi",c:"#16a34a"},
                {l:"Accepted",v:acceptedCount+"/"+result.length,c:T.accent},
                {l:"Trip",v:tripLength+" days",c:T.blue},
              ].map((s,i)=><div key={i} style={{background:T.bgLite,borderRadius:8,padding:"6px",textAlign:"center"}}>
                <div style={{fontSize:14,fontWeight:800,color:s.c,fontFamily:T.F.head}}>{s.v}</div>
                <div style={{fontSize:9,color:T.muted,textTransform:"uppercase",letterSpacing:.3,marginTop:1}}>{s.l}</div>
              </div>)}
            </div>
            <div style={{display:"flex",gap:6,marginBottom:10}}>
              <button onClick={()=>{const a={};result.forEach((_,i)=>a[i]=true);setAccepted(a);}} style={{flex:1,background:T.free+"22",border:"1px solid "+T.free+"44",borderRadius:8,padding:"5px",fontSize:10,fontWeight:700,color:T.free,cursor:"pointer"}}>✓ All</button>
              <button onClick={()=>{const a={};result.forEach((_,i)=>a[i]=false);setAccepted(a);}} style={{flex:1,background:T.danger+"22",border:"1px solid "+T.danger+"44",borderRadius:8,padding:"5px",fontSize:10,fontWeight:700,color:T.danger,cursor:"pointer"}}>✕ None</button>
              <button onClick={()=>setStep("options")} style={{flex:1,background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,padding:"5px",fontSize:10,fontWeight:600,color:T.muted,cursor:"pointer"}}>↺ Re-plan</button>
            </div>
            {error&&<div style={{padding:"7px 10px",background:T.danger+"18",borderRadius:8,fontSize:11,color:T.danger,marginBottom:8,wordBreak:"break-word"}}>{error}</div>}
            {result.map((s,i)=>{
              const isAcc=accepted[i];
              const tc=s.type==="home"?T.muted:s.type==="free"||s.isFree?"#16a34a":T.accent;
              return<div key={i} onClick={()=>setAccepted(a=>({...a,[i]:!a[i]}))} style={{display:"flex",gap:8,padding:"9px 11px",borderRadius:10,marginBottom:5,cursor:"pointer",background:isAcc?T.accent+"0a":T.bgLite+"88",border:"2px solid "+(isAcc?T.accent:T.border+"44"),opacity:isAcc?1:0.5}}>
                <div style={{width:24,height:24,borderRadius:"50%",background:isAcc?T.accent:T.border,color:"#fff",fontSize:10,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{isAcc?"✓":i+1}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:4,alignItems:"flex-start"}}>
                    {(()=>{
                    const isFS=s.subtype==="fuel_stop"||s.fuelStop;
                    return<div style={{fontWeight:700,fontSize:12,color:isFS?"#f59e0b":T.text,wordBreak:"break-word",flex:1}}>
                      {isFS?"⛽ ":""}{s.name}
                      {isFS&&<span style={{fontSize:9,background:"#f59e0b22",color:"#f59e0b",borderRadius:4,padding:"1px 5px",marginLeft:5,fontWeight:600}}>FUEL STOP</span>}
                    </div>;
                  })()}
                    <div style={{display:"flex",gap:3,flexWrap:"wrap",flexShrink:0}}>
                      {s.distFromPrev>0&&<span style={{fontSize:9,color:T.muted,background:T.bgLite,padding:"1px 5px",borderRadius:6}}>{s.distFromPrev}mi</span>}
                      <span style={{fontSize:9,fontWeight:600,color:s.isFree?"#16a34a":tc,background:(s.isFree?"#16a34a":tc)+"18",padding:"1px 5px",borderRadius:6}}>{s.isFree?"FREE":"$"+s.nightlyRate}</span>
                    </div>
                  </div>
                  {s.type!=="home"&&s.minNights>0&&<div style={{fontSize:10,color:T.muted,marginTop:1}}>{s.minNights} nights</div>}
                  {s.notes&&<div style={{fontSize:10,color:T.muted,marginTop:2,fontStyle:"italic",wordBreak:"break-word"}}>{s.notes}</div>}
                </div>
              </div>;
            })}
          </div>}
        </div>

        <div style={{padding:"10px 18px",borderTop:"1px solid "+T.border,display:"flex",gap:8,flexShrink:0}}>
          <button onClick={onClose} style={{flex:1,background:"none",border:"1px solid "+T.border,borderRadius:10,padding:"9px",color:T.muted,fontSize:12,fontWeight:600,cursor:"pointer"}}>Cancel</button>
          {step==="options"&&<button onClick={handleBuild} disabled={loading} style={{flex:2,background:loading?T.border:T.accent,color:"#fff",border:"none",borderRadius:10,padding:"9px",fontSize:12,fontWeight:700,cursor:loading?"not-allowed":"pointer"}}>
            {loading?"Planning your trip...":"✨ Plan My Trip"}
          </button>}
          {step==="results"&&<button onClick={()=>handleAdd(mergeMode)} disabled={acceptedCount===0} style={{flex:2,background:acceptedCount>0?T.accent:T.border,color:"#fff",border:"none",borderRadius:10,padding:"9px",fontSize:12,fontWeight:700,cursor:acceptedCount>0?"pointer":"not-allowed"}}>
            ✓ Add {acceptedCount} Stop{acceptedCount!==1?"s":""}
          </button>}
        </div>
      </div>
    </div>
  );
}


function AIFuelPlanner({callAI,trip,vehicle,fuel,stops,aiPurchased,aiFreeCalls,onClose,onShowAIUpgrade}){
  const T=useTheme();
  const [loading,setLoading]=useState(false);
  const [result,setResult]=useState("");
  const [error,setError]=useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{handleAnalyze();},[]);

  const handleAnalyze=async()=>{
    if(!aiPurchased&&aiFreeCalls===0){onShowAIUpgrade&&onShowAIUpgrade();return;}
    setLoading(true);setError("");setResult("");
    const tankRange=Math.round((parseFloat(vehicle.mpg)||8)*(parseFloat(vehicle.tankGallons)||100));
    const legs=trip.stops.filter(s=>s.active&&s.mi>0&&s.name).map(s=>({
      from:s.name,miles:s.mi,fuelRangeWarning:s.fuelRangeWarning,tankRange:s.tankRange
    }));
    const prompt=`Analyze fuel planning for this RV trip:

Vehicle: ${vehicle.rvType}, ${vehicle.mpg} MPG, ${vehicle.tankGallons} gallon tank
Full tank range: ${tankRange} miles
Current fuel price: $${fuel.avgPricePerGallon}/gallon
Fill-up strategy: ${fuel.fuelStrategy}

Legs with distances:
${legs.map((l,i)=>"Leg "+(i+1)+": "+l.from+" - "+l.miles+" miles"+(l.fuelRangeWarning?" EXCEEDS 75% TANK RANGE":"")).join("\n")}

Please provide:
1. Which legs need a fuel stop and roughly where (halfway point city if known)
2. Estimated gallons and cost per leg
3. Best fill-up strategy tips for this specific route
4. Any fuel stop chain recommendations (Love's, Pilot, Flying J) for RV-friendly stops
Keep it practical and under 400 words.`;

    const res=await callAI(prompt,"You are an expert RV fuel planning advisor. Give specific, practical fuel stop recommendations.");
    if(!res){setError("AI request failed. Please try again.");setLoading(false);return;}
    setResult(res);
    setLoading(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:560,maxHeight:"90vh",display:"flex",flexDirection:"column",boxShadow:"0 24px 80px rgba(0,0,0,0.5)",overflow:"hidden"}}>
        <div style={{background:"linear-gradient(135deg,#f59e0b,#d97706)",padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:22,color:"#fff"}}>⛽ AI Fuel Planner</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.8)",marginTop:2}}>Smart fuel stop recommendations for your route</div>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:30,height:30,cursor:"pointer",color:"#fff",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
          {loading&&<div style={{textAlign:"center",padding:"40px 0"}}><div style={{fontSize:32,marginBottom:12}}>⛽</div><div style={{color:T.muted,fontSize:14}}>Analyzing your fuel needs...</div></div>}
          {error&&<div style={{padding:"12px 14px",background:T.danger+"18",borderRadius:8,fontSize:13,color:T.danger}}>{error}</div>}
          {result&&<div style={{fontSize:13,color:T.text,lineHeight:1.8,whiteSpace:"pre-wrap"}}>{result}</div>}
        </div>
        <div style={{padding:"16px 24px",borderTop:`1px solid ${T.border}`,display:"flex",gap:10}}>
          <button onClick={onClose} style={{flex:1,background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"11px",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>Close</button>
          <button onClick={handleAnalyze} disabled={loading} style={{flex:1,background:loading?"#f59e0b88":"#f59e0b",color:"#fff",border:"none",borderRadius:10,padding:"11px",fontSize:13,fontWeight:700,cursor:loading?"not-allowed":"pointer"}}>
            {loading?"⏳ Analyzing...":"🔄 Re-analyze"}
          </button>
        </div>
      </div>
    </div>
  );
}


// ── AIStopSuggestions ─────────────────────────────────────────────
function AIStopSuggestions({callAI,trip,vehicle,prefs,stops,aiPurchased,aiFreeCalls,onClose,onShowAIUpgrade}){
  const T=useTheme();
  const [loading,setLoading]=useState(false);
  const [result,setResult]=useState("");
  const [error,setError]=useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{handleAnalyze();},[]);

  const handleAnalyze=async()=>{
    if(!aiPurchased&&aiFreeCalls===0){onShowAIUpgrade&&onShowAIUpgrade();return;}
    setLoading(true);setError("");setResult("");
    const namedStops=stops.filter(s=>s.active&&s.name&&s.type!=="home");
    const homeStop=stops.find(s=>s.type==="home");
    const prompt=`Suggest overnight stops for this RV trip and return structured JSON.

RV: ${vehicle.rvType}, ${vehicle.rvLength}ft long
Home base: ${homeStop?.homeCity||homeStop?.name||"Unknown"}
Max drive hours/day: ${prefs.maxDriveHours}, avg speed ${prefs.avgSpeedMph} mph
Travel days: ${prefs.travelDays}
Boondocking comfort: ${prefs.boondockComfort}
Hookup preference: ${prefs.hookupPref}

Current planned stops:
${namedStops.map((s,i)=>(i+1)+". "+s.name+(s.state?", "+s.state:"")+" ("+s.minNights+" nights)").join("\n")||"No stops planned yet"}

Return ONLY a JSON object with this structure:
{"summary":"2-3 sentence overview","suggestions":[{"name":"City, State","type":"campground|walmart|blm|cabelas|cracker_barrel|rest_area|rv_park","description":"why this stop is good","isFree":true,"estimatedCost":0,"searchTerms":"RV camping City State"}]}

Include 5-8 suggestions. Only return valid JSON.`;

    const res=await callAI(prompt,"You are an experienced full-time RVer with extensive knowledge of campgrounds, boondocking spots, and RV-friendly overnight locations across the US. Give specific, practical recommendations.");
    if(!res){setError("AI request failed. Please try again.");setLoading(false);return;}
    setResult(res);
    setLoading(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:560,maxHeight:"90vh",display:"flex",flexDirection:"column",boxShadow:"0 24px 80px rgba(0,0,0,0.5)",overflow:"hidden"}}>
        <div style={{background:"linear-gradient(135deg,#059669,#047857)",padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:22,color:"#fff"}}>📍 AI Stop Suggestions</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.8)",marginTop:2}}>Personalized overnight stop recommendations</div>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:30,height:30,cursor:"pointer",color:"#fff",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
          {loading&&<div style={{textAlign:"center",padding:"40px 0"}}><div style={{fontSize:32,marginBottom:12}}>📍</div><div style={{color:T.muted,fontSize:14}}>Finding the best stops for your route...</div></div>}
          {error&&<div style={{padding:"12px 14px",background:T.danger+"18",borderRadius:8,fontSize:13,color:T.danger}}>{error}</div>}
          {result&&(()=>{
            try{
              const parsed=JSON.parse(result.replace(/```json|```/g,"").trim());
              return<div>
                {parsed.summary&&<div style={{fontSize:13,color:T.text,lineHeight:1.7,marginBottom:14,padding:"10px 12px",background:T.bgLite,borderRadius:8}}>{parsed.summary}</div>}
                {(parsed.suggestions||[]).map((s,i)=>(
                  <div key={i} style={{background:T.bgLite,borderRadius:10,padding:"12px 14px",marginBottom:8}}>
                    <div style={{fontWeight:600,fontSize:13,color:T.text,marginBottom:4}}>{s.name}</div>
                    <div style={{fontSize:12,color:T.muted,marginBottom:8}}>{s.description}</div>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      <span style={{fontSize:10,background:s.isFree?"#27ae6018":"#3498db18",color:s.isFree?"#27ae60":"#3498db",border:"1px solid "+(s.isFree?"#27ae6044":"#3498db44"),borderRadius:6,padding:"2px 8px",fontWeight:600}}>{s.isFree?"FREE":"~$"+s.estimatedCost+"/night"}</span>
                      <a href={"https://www.campendium.com/search?q="+encodeURIComponent(s.searchTerms||s.name)} target="_blank" rel="noopener noreferrer" style={{fontSize:10,color:"#27ae60",border:"1px solid #27ae6044",borderRadius:6,padding:"2px 8px",textDecoration:"none",fontWeight:600}}>🏕 Campendium</a>
                      <a href={"https://www.recreation.gov/search?q="+encodeURIComponent(s.searchTerms||s.name)} target="_blank" rel="noopener noreferrer" style={{fontSize:10,color:"#3498db",border:"1px solid #3498db44",borderRadius:6,padding:"2px 8px",textDecoration:"none",fontWeight:600}}>🏛 Rec.gov</a>
                      <a href={"https://www.google.com/search?q="+encodeURIComponent("RV overnight "+s.searchTerms||s.name)} target="_blank" rel="noopener noreferrer" style={{fontSize:10,color:T.muted,border:`1px solid ${T.border}`,borderRadius:6,padding:"2px 8px",textDecoration:"none",fontWeight:600}}>🔍 Google</a>
                    </div>
                  </div>
                ))}
              </div>;
            }catch{
              return<div style={{fontSize:13,color:T.text,lineHeight:1.8,whiteSpace:"pre-wrap"}}>{result}</div>;
            }
          })()}
        </div>
        <div style={{padding:"16px 24px",borderTop:`1px solid ${T.border}`,display:"flex",gap:10}}>
          <button onClick={onClose} style={{flex:1,background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"11px",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>Close</button>
          <button onClick={handleAnalyze} disabled={loading} style={{flex:1,background:loading?"#05966988":"#059669",color:"#fff",border:"none",borderRadius:10,padding:"11px",fontSize:13,fontWeight:700,cursor:loading?"not-allowed":"pointer"}}>
            {loading?"⏳ Analyzing...":"🔄 New Suggestions"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── AIUpgradeModal ────────────────────────────────────────────────
function AIUpgradeModal({onClose,freeCalls,aiPurchased,lemonUrl}){
  const T=useTheme();
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:480,boxShadow:"0 24px 80px rgba(0,0,0,0.5)",overflow:"hidden"}}>
        <div style={{background:"linear-gradient(135deg,#7c3aed,#4f46e5)",padding:"28px 24px 24px",textAlign:"center",position:"relative"}}>
          <button onClick={onClose} style={{position:"absolute",top:12,right:12,background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:"#fff",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center",lineHeight:1}}>✕</button>
          <div style={{fontSize:48,marginBottom:8}}>✨</div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,fontSize:26,color:"#fff",marginBottom:4}}>RV Travel Mate AI</div>
          <div style={{fontSize:13,color:"rgba(255,255,255,0.8)"}}>Powered by advanced AI - no account required to try</div>
        </div>
        <div style={{padding:"24px"}}>
          {freeCalls>0&&!aiPurchased&&<div style={{background:"#7c3aed18",border:"1px solid #7c3aed44",borderRadius:10,padding:"12px 16px",marginBottom:16,textAlign:"center"}}>
            <div style={{fontWeight:700,color:"#7c3aed",fontSize:15}}>🎉 You have {freeCalls} free AI request{freeCalls!==1?"s":""} remaining</div>
            <div style={{fontSize:12,color:T.muted,marginTop:4}}>No purchase necessary to try AI features</div>
          </div>}
          {(!freeCalls||freeCalls<=0)&&!aiPurchased&&<div style={{background:T.bgLite,borderRadius:10,padding:"12px 16px",marginBottom:16}}>
            <div style={{fontWeight:700,color:T.text,fontSize:14,marginBottom:8}}>Your 5 free AI requests have been used</div>
            <div style={{fontSize:12,color:T.muted}}>Unlock unlimited AI features with a one-time purchase. No subscription required.</div>
          </div>}
          <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:20}}>
            {[
              {icon:"🗺",text:"AI Trip Review - analyze your itinerary for issues, warnings, and savings",free:true},
              {icon:"✨",text:"AI Stop Builder - describe a trip in plain English, AI creates your stops",free:false},
              {icon:"⛽",text:"AI Fuel Planner - smart fuel stop suggestions based on your tank range",free:false},
              {icon:"📍",text:"AI Stop Suggestions - personalized overnight stop recommendations",free:false},
            ].map((f,i)=>(
              <div key={i} style={{display:"flex",gap:10,alignItems:"center",padding:"8px 12px",background:T.bgLite,borderRadius:8}}>
                <span style={{fontSize:18}}>{f.icon}</span>
                <span style={{flex:1,fontSize:12,color:T.text}}>{f.text}</span>
                {f.free?<span style={{fontSize:10,color:T.free,fontWeight:700,background:T.free+"18",padding:"2px 7px",borderRadius:10}}>FREE</span>
                :<span style={{fontSize:10,color:"#7c3aed",fontWeight:700,background:"#7c3aed18",padding:"2px 7px",borderRadius:10}}>PRO</span>}
              </div>
            ))}
          </div>
          {!aiPurchased&&<a href={lemonUrl} target="_blank" rel="noopener noreferrer" style={{display:"block",background:"linear-gradient(135deg,#7c3aed,#4f46e5)",color:"#fff",textAlign:"center",borderRadius:12,padding:"14px",fontSize:15,fontWeight:700,textDecoration:"none",marginBottom:10,boxShadow:"0 4px 16px #7c3aed44"}}>
            🔓 Unlock All AI Features - $9.99 one-time
          </a>}
          {!aiPurchased&&<div style={{fontSize:11,color:T.muted,textAlign:"center",marginBottom:12}}>No subscription · One-time payment · Instant activation</div>}
          <button onClick={onClose} style={{width:"100%",background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"11px",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
            {aiPurchased?"✓ AI Features Unlocked - Close":"✕ Close"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── SetupWizard ──────────────────────────────────────────────────────

// WizardNumInput: key-based remount so defaultValue stays fresh, no hooks issues
function WizardNumInput({value,onChange,min,max,step,style,placeholder}){
  const T=useTheme();
  return<input
    key={"wni-"+value}
    type="text" inputMode="decimal"
    defaultValue={value??""}
    placeholder={placeholder}
    style={{background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,
      padding:"9px 12px",fontSize:14,width:"100%",outline:"none",boxSizing:"border-box",...style}}
    onFocus={e=>{e.target.style.borderColor=T.accent;e.target.style.boxShadow=`0 0 0 3px ${T.accent}22`;e.target.select();}}
    onBlur={e=>{
      e.target.style.borderColor=T.border;e.target.style.boxShadow="none";
      const v=parseFloat(e.target.value);
      if(!isNaN(v)&&v!==value)onChange(v);
    }}
  />;
}

function SetupWizard({vehicle,prefs,fuel,memberships,stops,onVehicle,onPrefs,onFuel,onMemberships,onStops,onClose}){
  const T=useTheme();
  const [step,setStep]=useState(0);
  const [showImport,setShowImport]=useState(false);

  const RV_TYPES=["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper","─────────────","Motorcycle","Car / SUV","Bicycle","🥾 Hike / Walk"];
  const TRAVEL_DAYS=[{v:"any",l:"Any Day"},{v:"weekends",l:"Weekends"},{v:"weekdays",l:"Weekdays"},{v:"friday",l:"Fri-Sun"}];
  const MEMS_LIST=[
    {k:"goodSam",l:"Good Sam Club",cost:"$29/yr",col:"#e74c3c"},
    {k:"passportAmerica",l:"Passport America",cost:"$44/yr",col:"#3498db"},
    {k:"harvestHosts",l:"Harvest Hosts",cost:"$99/yr",col:"#27ae60"},
    {k:"koaValueKard",l:"KOA Value Kard",cost:"Free",col:"#f39c12"},
    {k:"thousandTrails",l:"Thousand Trails",cost:"Varies",col:"#9b59b6"},
  ];

  const fv=(k,v)=>onVehicle({...vehicle,[k]:v});
  const fp=(k,v)=>onPrefs({...prefs,[k]:v});
  const ff=(k,v)=>onFuel({...fuel,[k]:v});
  const fm=(k,v)=>onMemberships({...memberships,[k]:v});

  const STEPS=[
    {icon:"🚐",title:"Your RV",desc:"What are you driving? We use this to estimate fuel costs and driving limits."},
    {icon:"🗺",title:"How You Like to Travel",desc:"How many hours a day do you prefer to drive? What days work best?"},
    {icon:"⛽",title:"Fuel",desc:"What are you paying for fuel? We'll estimate costs for the whole trip."},
    {icon:"🎫",title:"Memberships & Discounts",desc:"Do you belong to any camping clubs? We'll show member discounts along your route."},
    {icon:"📍",title:"Where Are You Going?",desc:"Add your first stop or two. You can always add more later — nothing is permanent."},
  ];

  const handleImport=newStops=>{
    const cleaned=stops.filter(s=>s.type==="home"||s.name.trim()!=="");
    onStops([...cleaned,...newStops]);
    setShowImport(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      {showImport&&<ImportStopsModal onClose={()=>setShowImport(false)} onImport={handleImport}/>}
      <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:540,maxHeight:"90vh",display:"flex",flexDirection:"column",boxShadow:"0 24px 80px rgba(0,0,0,0.5)",overflow:"hidden"}}>
        {/* Header */}
        <div style={{padding:"20px 24px 16px",borderBottom:`1px solid ${T.border}`}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:T.F.head,fontWeight:900,fontSize:20,color:T.text}}>👋 Let's Set Up Your Trip</div>
            <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,width:32,height:32,cursor:"pointer",color:T.muted,fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          </div>
          {/* Progress steps */}
          <div style={{display:"flex",gap:4,marginBottom:14}}>
            {STEPS.map((s,i)=>(
              <div key={i} onClick={()=>setStep(i)} style={{flex:1,cursor:"pointer",textAlign:"center"}}>
                <div style={{height:4,borderRadius:2,background:i<step?"#27ae60":i===step?T.accent:T.border,transition:"background .2s",marginBottom:4}}/>
                <div style={{fontSize:9,color:i<step?"#27ae60":i===step?T.accent:T.muted,fontWeight:i===step?700:400,textTransform:"uppercase",letterSpacing:.3,lineHeight:1.2}}>{i<step?"✓ ":""}{s.icon}</div>
              </div>
            ))}
          </div>
          <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
            <div style={{width:48,height:48,borderRadius:"50%",background:T.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,flexShrink:0,boxShadow:`0 2px 8px ${T.accent}44`}}>{STEPS[step].icon}</div>
            <div style={{flex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
                <div style={{fontFamily:T.F.head,fontWeight:800,fontSize:18,color:T.text}}>{STEPS[step].title}</div>
                <div style={{fontSize:11,color:T.muted,background:T.bgLite,borderRadius:10,padding:"1px 8px",border:`1px solid ${T.border}`}}>Step {step+1} of {STEPS.length}</div>
              </div>
              <div style={{fontSize:13,color:T.muted,lineHeight:1.5}}>{STEPS[step].desc}</div>
            </div>
          </div>
        </div>

        {/* Step content */}
        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>

          {/* Step 0: Vehicle */}
          {step===0&&(()=>{
            const isRV=["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper"].includes(vehicle.rvType);
            const isBike=vehicle.rvType==="Bicycle";
            const isHike=vehicle.rvType==="🥾 Hike / Walk";
            const WInp=({label,field,type="number",...rest})=>{
              // Controlled but commit-on-blur only - no parent re-render while typing
              const [localVal,setLocalVal]=useState(()=>vehicle[field]??"");
              const focused=useRef(false);
              // Sync from parent only when not focused (handles preset fills)
              if(!focused.current&&String(vehicle[field]??"")!==String(localVal)){
                // Direct state update during render is ok for derived state sync
                setLocalVal(vehicle[field]??"");
              }
              return(
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>{label}</div>
                <input
                  type={type==="number"?"text":type}
                  inputMode={type==="number"?"decimal":undefined}
                  value={localVal}
                  onChange={e=>setLocalVal(e.target.value)}
                  onFocus={e=>{focused.current=true;e.target.style.borderColor=T.accent;e.target.style.boxShadow=`0 0 0 3px ${T.accent}22`;e.target.select();}}
                  onBlur={e=>{
                    focused.current=false;
                    e.target.style.borderColor=T.border;e.target.style.boxShadow="none";
                    if(type==="number"){const v=parseFloat(e.target.value);if(!isNaN(v))fv(field,v);else setLocalVal(String(vehicle[field]??0));}
                    else fv(field,e.target.value);
                  }}
                  style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none",boxSizing:"border-box"}}
                  {...rest}
                />
              </div>);
            };
            return <div style={{display:"flex",flexDirection:"column",gap:14}}>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Vehicle Type</div>
                <select value={vehicle.rvType} onChange={e=>{
                  const vt=e.target.value;
                  const isNewRV=["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper"].includes(vt);
                  const updates={rvType:vt};
                  if(vt==="Motorcycle"){updates.mpg=50;updates.tankGallons=5;updates.rvLength=8;updates.rvHeightFt=4;updates.fuelType="Gasoline";updates.towVehicle=false;}
                  else if(vt==="Car / SUV"){updates.mpg=28;updates.tankGallons=15;updates.rvLength=15;updates.rvHeightFt=5;updates.fuelType="Gasoline";updates.towVehicle=false;}
                  else if(vt==="Bicycle"){updates.mpg=999;updates.tankGallons=0;updates.rvLength=6;updates.towVehicle=false;}
                  else if(vt==="🥾 Hike / Walk"){updates.mpg=2.5;updates.tankGallons=15;updates.rvLength=0;updates.towVehicle=false;}
                  else if(isNewRV){updates.mpg=vehicle._mpg||8;updates.tankGallons=vehicle._tank||100;updates.fuelType=vehicle._fuelType||"Diesel";}
                  onVehicle({...vehicle,...updates});
                }} style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none"}}>
                  {RV_TYPES.map(v=><option key={v} disabled={v.startsWith("─")}>{v}</option>)}
                </select>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                {!isHike&&<WInp label={isBike?"Speed (mph)":"MPG"} field="mpg"/>}
                {isHike&&<WInp label="Pace (mph)" field="mpg"/>}
                {!isBike&&!isHike&&<WInp label="Tank (gal)" field="tankGallons"/>}
                {isHike&&<WInp label="Max Daily Miles" field="tankGallons"/>}
                {!isBike&&!isHike&&<div>
                  <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Fuel Type</div>
                  <select value={vehicle.fuelType||"Diesel"} onChange={e=>fv("fuelType",e.target.value)} style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none"}}>
                    {["Diesel","Gasoline","Propane","Electric/Hybrid"].map(v=><option key={v}>{v}</option>)}
                  </select>
                </div>}
                {isRV&&<WInp label="RV Length (ft)" field="rvLength"/>}
                {isRV&&<WInp label="Height (ft)" field="rvHeightFt"/>}
                {isRV&&<WInp label="Height (in)" field="rvHeightIn"/>}
              </div>
              {isRV&&<div style={{background:T.bgLite,borderRadius:10,padding:12,display:"flex",flexDirection:"column",gap:10}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <Tog value={vehicle.towVehicle||false} onChange={v=>fv("towVehicle",v)} label=""/>
                  <div style={{fontWeight:600,fontSize:13}}>Towing a vehicle?</div>
                </div>
                {vehicle.towVehicle&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  <div>
                    <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Tow Type</div>
                    <select value={vehicle.towType||"Car/SUV"} onChange={e=>{
                      const lengths={"Car/SUV":15,"Truck":20,"Jeep":14,"Motorcycle":8,"Trailer":20,"Custom":vehicle.towLength||15};
                      onVehicle({...vehicle,towType:e.target.value,towLength:e.target.value!=="Custom"?lengths[e.target.value]:vehicle.towLength});
                    }} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none"}}>
                      {["Car/SUV","Truck","Jeep","Motorcycle","Trailer","Custom"].map(v=><option key={v}>{v}</option>)}
                    </select>
                  </div>
                  <WInp label="Tow Length (ft)" field="towLength"/>
                </div>}
                {vehicle.towVehicle&&<div style={{fontSize:11,color:T.muted}}>Combined length: <strong style={{color:T.accent}}>{(parseInt(vehicle.rvLength)||36)+(parseInt(vehicle.towLength)||15)+5} ft</strong> (incl. 5ft hitch)</div>}
              </div>}
            </div>;
          })()}


          {/* Step 1: Travel Style */}
          {step===1&&<div style={{display:"flex",flexDirection:"column",gap:14}}>
            {/* Home City / Departure Location */}
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Home / Departure City</div>
              <input
                type="text"
                defaultValue={stops.find(s=>s.type==="home")?.homeCity||""}
                placeholder="e.g. Foley, AL"
                style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none",boxSizing:"border-box"}}
                onFocus={e=>{e.target.style.borderColor=T.accent;e.target.style.boxShadow=`0 0 0 3px ${T.accent}22`;}}
                onBlur={e=>{
                  e.target.style.borderColor=T.border;e.target.style.boxShadow="none";
                  const val=e.target.value.trim();
                  onStops(prev=>prev.map(s=>s.type==="home"?{...s,homeCity:val,name:val||s.name}:s));
                }}
              />
              <div style={{fontSize:11,color:T.muted,marginTop:4}}>Used as your trip departure point and for AI trip planning</div>
            </div>
            {/* Home State */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Home State</div>
                <select
                  value={stops.find(s=>s.type==="home")?.state||""}
                  onChange={e=>{const val=e.target.value;onStops(prev=>prev.map(s=>s.type==="home"?{...s,state:val}:s));}}
                  style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none"}}
                >
                  <option value="">-- State --</option>
                  {["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"].map(s=><option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Depart Date</div>
                <input
                  type="date"
                  defaultValue={stops.find(s=>s.type==="home")?.departDate||""}
                  style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none",boxSizing:"border-box"}}
                  onFocus={e=>{e.target.style.borderColor=T.accent;e.target.style.boxShadow=`0 0 0 3px ${T.accent}22`;}}
                  onBlur={e=>{
                    e.target.style.borderColor=T.border;e.target.style.boxShadow="none";
                    const val=e.target.value;
                    onStops(prev=>prev.map(s=>s.type==="home"?{...s,departDate:val,fixedDates:!!val}:s));
                  }}
                />
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>{prefs.multiDriver?"Total Drive Hours":"Max Hours/Day"}</div>
                <WizardNumInput min={1} max={prefs.multiDriver?48:12} step={0.5} value={prefs.maxDriveHours} onChange={v=>fp("maxDriveHours",v)}/>
              </div>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Avg Speed (mph)</div>
                <input type="number" value={prefs.avgSpeedMph} onChange={e=>fp("avgSpeedMph",parseFloat(e.target.value)||60)} style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none",boxSizing:"border-box"}}/>
              </div>
            </div>
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:8,letterSpacing:1,textTransform:"uppercase"}}>Preferred Travel Days</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {TRAVEL_DAYS.map(d=>(
                  <button key={d.v} onClick={()=>fp("travelDays",d.v)} style={{padding:"8px 16px",borderRadius:20,border:`1px solid ${prefs.travelDays===d.v?T.accent:T.border}`,background:prefs.travelDays===d.v?T.accent+"22":"transparent",color:prefs.travelDays===d.v?T.accent:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
                    {d.l}
                  </button>
                ))}
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:T.bgLite,borderRadius:10}}>
              <Tog value={prefs.multiDriver} onChange={v=>fp("multiDriver",v)} label=""/>
              <div>
                <div style={{fontWeight:600,fontSize:13,color:T.text}}>👥 Multi-Driver Mode</div>
                <div style={{fontSize:11,color:T.muted}}>Two drivers sharing - removes daily hour warnings</div>
              </div>
            </div>
          </div>}

          {/* Step 2: Fuel & Budget */}
          {step===2&&<div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Avg Fuel Price ($/gal)</div>
              <input type="number" step={0.05} value={fuel.avgPricePerGallon} onChange={e=>ff("avgPricePerGallon",parseFloat(e.target.value)||3.30)} style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none",boxSizing:"border-box"}}/>
            </div>
            <div>
              <div style={{fontFamily:T.F.cond,fontWeight:600,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Monthly Take-Home Income (optional)</div>
              <input type="number" value={fuel.monthlyIncome||""} onChange={e=>ff("monthlyIncome",e.target.value)} placeholder="Leave blank to skip" style={{width:"100%",background:T.bgLite,border:`1px solid ${T.border}`,borderRadius:8,color:T.text,padding:"9px 12px",fontSize:14,outline:"none",boxSizing:"border-box"}}/>
              <div style={{fontSize:11,color:T.muted,marginTop:4}}>Used to show how many months of income your trip costs</div>
            </div>
          </div>}

          {/* Step 3: Memberships */}
          {step===3&&<div style={{display:"flex",flexDirection:"column",gap:8}}>
            <div style={{fontSize:12,color:T.muted,marginBottom:4}}>Toggle any memberships you have - they unlock discounts on stop pins and print summaries.</div>
            {MEMS_LIST.map(m=>(
              <div key={m.k} onClick={()=>fm(m.k,!memberships[m.k])} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:memberships[m.k]?m.col+"18":T.bgLite,border:`1px solid ${memberships[m.k]?m.col+"66":T.border}`,borderRadius:10,cursor:"pointer",transition:"all .15s"}}>
                <Tog value={memberships[m.k]} onChange={v=>{fm(m.k,v);}} label=""/>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600,fontSize:13,color:memberships[m.k]?m.col:T.text}}>{m.l}</div>
                  <div style={{fontSize:11,color:T.muted}}>{m.cost}</div>
                </div>
              </div>
            ))}
          </div>}

          {/* Step 4: Stops */}
          {step===4&&<div style={{display:"flex",flexDirection:"column",gap:12}}>
            <div style={{fontSize:12,color:T.muted}}>Add your destinations. You can always add more later in the Stops tab.</div>
            <button onClick={()=>setShowImport(true)} style={{width:"100%",background:T.accent,color:"#fff",border:"none",borderRadius:10,padding:"14px",fontSize:15,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              ✨ Add Stops by Typing
            </button>
            <div style={{fontSize:12,color:T.muted,textAlign:"center"}}>Type naturally: "Austin TX 4 nights $45 family" - one stop per line</div>
            {stops.filter(s=>s.type!=="home"&&s.name.trim()).length>0&&(
              <div style={{background:T.bgLite,borderRadius:10,padding:12}}>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:11,color:T.muted,marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Current Stops</div>
                {stops.filter(s=>s.type!=="home"&&s.name.trim()).map((s,i)=>(
                  <div key={s.id} style={{fontSize:13,color:T.text,padding:"3px 0",borderBottom:i<stops.filter(x=>x.type!=="home"&&x.name.trim()).length-1?`1px solid ${T.border}`:"none"}}>
                    {i+1}. {s.name}{s.state?", "+s.state:""} · {s.minNights} nights
                  </div>
                ))}
              </div>
            )}
          </div>}

        </div>

        {/* Footer */}
        <div style={{padding:"16px 24px",borderTop:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12}}>
          <button onClick={()=>step>0?setStep(s=>s-1):onClose()} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 18px",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:T.F.cond}}>
            {step===0?"✕ Close":"← Back"}
          </button>
          <div style={{fontSize:11,color:T.muted}}>{step+1} / {STEPS.length}</div>
          {step<STEPS.length-1
            ?<button onClick={()=>setStep(s=>s+1)} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"9px 24px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:T.F.cond,letterSpacing:.5}}>Next →</button>
            :<button onClick={onClose} style={{background:T.free,color:"#fff",border:"none",borderRadius:8,padding:"9px 24px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:T.F.cond,letterSpacing:.5}}>✓ Done!</button>
          }
        </div>
      </div>
    </div>
  );
}

// ── SetupGuideCard ──────────────────────────────────────────────────
function SetupGuideCard({trip,stops,onTabChange,pad}){
  const T=useTheme();
  const GUIDE_KEY="rv-setup-guide-hidden";
  const [hidden,setHidden]=useState(()=>{try{return localStorage.getItem(GUIDE_KEY)==="1";}catch{return false;}});
  const hasTrip=trip.totMi>0||stops.filter(s=>s.type!=="home"&&s.name&&s.name.trim()).length>1;
  if(hidden||hasTrip) return null;
  const steps=[
    {n:1,icon:"🚗",label:"Vehicle",tab:"vehicle",desc:"Enter your RV type, MPG and tank size"},
    {n:2,icon:"🗺",label:"Travel",tab:"prefs",desc:"Set max drive hours and travel days"},
    {n:3,icon:"📍",label:"Stops",tab:"stops",desc:"Add your destinations"},
    {n:4,icon:"🗺",label:"Map",tab:"map",desc:"Calculate driving miles for all stops"},
    {n:5,icon:"📊",label:"Summary",tab:"results",desc:"Your full itinerary appears automatically"},
  ];
  return(
    <div style={{maxWidth:960,margin:"0 auto",padding:`8px ${pad} 0`}}>
      <div style={{background:T.accent+"12",border:`1px solid ${T.accent}33`,borderRadius:12,padding:"14px 18px",display:"flex",gap:14,alignItems:"flex-start",flexWrap:"wrap"}}>
        <div style={{flex:1,minWidth:240}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:T.accent,marginBottom:10,letterSpacing:.5}}>🚀 QUICK START - Set up your trip in order:</div>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            {steps.map(step=>(
              <div key={step.n} onClick={()=>onTabChange(step.tab)}
                style={{display:"flex",gap:10,alignItems:"center",cursor:"pointer",padding:"5px 8px",borderRadius:6,transition:"background .1s"}}
                onMouseEnter={e=>e.currentTarget.style.background=T.accent+"15"}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <div style={{width:22,height:22,borderRadius:"50%",background:T.accent,color:"#fff",fontSize:11,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{step.n}</div>
                <div><span style={{fontFamily:T.F.cond,fontWeight:700,fontSize:12,color:T.accent}}>{step.icon} {step.label}</span><span style={{fontSize:11,color:T.muted,marginLeft:6}}>{step.desc}</span></div>
              </div>
            ))}
          </div>
        </div>
        <button onClick={()=>{setHidden(true);try{localStorage.setItem(GUIDE_KEY,"1");}catch{}}}
          style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 12px",color:T.muted,fontSize:11,cursor:"pointer",flexShrink:0,alignSelf:"flex-start"}}>
          ✕ Hide
        </button>
      </div>
    </div>
  );
}






// ── HELP CHAT ─────────────────────────────────────────────────────
const HELP_FAQS=[
  // ── Trip Planning ──
  {k:["miles","calculate","distance","calc"],a:"Go to the Map tab and tap Auto-Calculate Miles to fill all legs at once. Or tap the Calc button on any individual stop card."},
  {k:["add stop","new stop","create stop"],a:"On the Stops tab tap the + button at the bottom. You can also use the AI Route Planner to auto-generate a full itinerary."},
  {k:["ai","route planner","plan trip","ai plan"],a:"Tap ✨ AI Route Planner on the Stops tab. Enter your destination, trip length, and preferences. Multi-driver mode plans fuel stops only. Use 'Route Via' to pass through specific cities."},
  {k:["fuel stop","gas stop","fuel only","multi driver"],a:"In the AI Route Planner, toggle Multi-Driver to plan a fuel-stops-only trip. Fuel stops show as amber GAS pins on the map. Set your tank size in RV Settings for accurate spacing."},
  {k:["waypoint","via","route through","pass through"],a:"Add a Waypoint stop type (no nights/cost) to pull your route through a city. Or use the 'Route Via' field in the AI Route Planner to list comma-separated cities."},
  {k:["monthly stay","months","long term","seasonal"],a:"On any stop card, tap the Monthly button next to Nightly Rate. Enter the monthly rate and number of months. The trip summary shows total cost and nights correctly."},
  {k:["home","departure","home city"],a:"Set your home city in Settings or on the first stop card. The home stop is your starting point for all route calculations."},
  {k:["return trip","round trip","return home"],a:"After planning your outbound stops, tap the Return Home button to mirror the trip in reverse. Or use the AI planner with Round Trip enabled."},
  // ── Map ──
  {k:["map","route","show route","not showing"],a:"Go to the Map tab. Tap Auto-Calculate Miles first to geocode all stops. The route draws automatically. Tap 🔄 Refresh Map if it doesn't appear."},
  {k:["map filter","campground","fuel station","rv park","golf","trail"],a:"Tap Map Filters on the Map tab. Select categories (Fuel, Campgrounds, RV Parks, Golf, Trails). Tap Apply & Close. Results load around each stop on your route - allow 15-30 seconds."},
  {k:["filter not showing","filter not working","map filter clear"],a:"Filters load from Overpass API which can be slow. Wait 20-30 seconds after tapping Apply & Close. If still nothing, tap Clear All then re-select your filters. Filters save automatically and reload when you re-enter the Map tab."},
  {k:["map snapshot","capture map","print map","pdf map"],a:"On the Map tab, tap the 📷 Capture Map button. This saves a map image that will appear in your printed PDF. Then go to the Print tab."},
  // ── My RV ──
  {k:["maintenance","service","oil change","schedule"],a:"In the 🔧 My RV tab, open Maintenance Tracker. Service templates are filtered for your RV type - motorized RVs show engine items, towable RVs show hitch/landing gear items. Tap + Add Service Record to log any service."},
  {k:["tow vehicle","truck","fifth wheel maintenance","tow truck"],a:"If your RV type is Fifth Wheel, Travel Trailer, or Toy Hauler, a separate Tow Vehicle Maintenance card appears in the Maintenance Tracker. Enter your truck's year/make/model in RV Settings, then log oil changes, tire rotations, etc. separately."},
  {k:["checklist","departure","pre-trip","lights check"],a:"The ✅ Checklists section has departure, arrival, and monthly lists. Departure includes lights check, exterior walkthrough, and - for towable RVs - kingpin/hitch, safety chains, brake controller, and all trailer lighting checks. Tap items to check them off."},
  {k:["fillup","fuel log","mpg","fuel economy"],a:"In 🔧 My RV → Fill-up Log, record each fill-up. The app calculates real MPG between fill-ups. Your average appears in the summary."},
  // ── Finances ──
  {k:["budget","expense","finances","spending","monthly"],a:"The 💰 Finances tab has a Monthly Expense Log with 26 categories. Tap any month/year to enter spending. Tap ✨ Analyze This Month for AI insights on your spending patterns and cost-cutting tips."},
  {k:["ai budget","analyze spending","budget advisor"],a:"In Finances → Monthly tab, enter your expenses then tap ✨ Analyze This Month. The AI reviews your breakdown and gives specific tips for RV full-timers - what's high, what's good, and how to cut costs next month."},
  {k:["income","net","profit loss"],a:"Enable Full Finance Mode in Settings to add income tracking. The annual dashboard shows income vs expenses with donut charts."},
  // ── Hunt Planner ──
  {k:["hunt","hunting","deer","elk","season"],a:"Tap ✨ AI Hunt Planner on the Stops tab. Select species, state, and season type. The planner shows state-specific season dates for 25 states, calculates the best departure date, and plans RV-friendly camp spots near public land."},
  {k:["hunt season","archery","rifle","muzzleloader","season dates"],a:"The Hunt Planner shows actual state-specific season dates for AL, AR, CO, GA, ID, IL, IN, IA, KS, KY, MI, MN, MS, MO, MT, NE, NM, OH, OK, PA, SD, TN, TX, WI, and WY. Always verify with your state agency before purchasing tags."},
  // ── Emergency & Settings ──
  {k:["emergency","roadside","breakdown","contacts"],a:"The Emergency tab (in More) has one-tap call cards for Coach-Net, Good Sam, AAA, Progressive, and Escapees. It also stores your insurance cards and tracks document expiration dates."},
  {k:["local favorites","restaurants","attractions","suggest"],a:"On any stop card, expand Local Favorites. Tap ✨ AI Suggest to get AI-powered restaurant, attraction, and practical recommendations for that location based on your RV lifestyle."},
  {k:["weather","forecast","map weather"],a:"Enable the Weather filter on the Map tab to see weather forecasts pinned above each stop. The route tab also shows weather for upcoming stops."},
  {k:["password","change password","account"],a:"Go to Settings → Account → Change Password. Enter your current and new password."},
  {k:["sync","cloud","backup","save"],a:"Your trip data syncs to the cloud automatically every 12 seconds when connected. It also saves immediately when you close the app. Sign in to access your data from any device."},
  {k:["theme","dark mode","color","camo"],a:"Go to Settings → Appearance. Choose from Standard, Dark, Desert Camo, and Woodland Camo themes."},
  {k:["print","pdf","report"],a:"The Print tab generates a full trip report PDF including your route summary, cost breakdown, stop details, maintenance records, and map snapshot if captured. Open in a new tab and use your browser's Print → Save as PDF."},
  {k:["side trip","day trip","detour"],a:"On any stop card, tap + Add Side Trip to plan a day trip from that location. Add up to 5 waypoints with ORS routing. A toggle shows the round-trip option. Side trips appear as an amber layer on the map."},
];

function HelpChat({trip,stops,vehicle,tab,finances,rvMaintenance,callAI}){
  const T=useTheme();
  const [open,setOpen]=useState(false);
  const [msgs,setMsgs]=useState([{role:"a",text:"Hi! Ask me anything about RV Travel Mate - features, how-to, or troubleshooting. I can also see your current trip data to give personalized help."}]);
  const [input,setInput]=useState("");
  const [loading,setLoading]=useState(false);
  const endRef=useRef(null);
  const inputRef=useRef(null);

  useEffect(()=>{
    if(open&&endRef.current) setTimeout(()=>endRef.current.scrollIntoView({behavior:"smooth"}),100);
    if(open&&inputRef.current) setTimeout(()=>inputRef.current.focus(),150);
  },[open,msgs.length]);

  const tripContext=()=>{
    const named=stops.filter(s=>s.active&&s.name);
    const home=stops.find(s=>s.type==="home");
    const hasMiles=named.some(s=>s.distFromPrev>0);
    const hasDate=!!(home?.departDate||home?.arriveDate);
    return "Vehicle: "+vehicle.rvType+", "+vehicle.mpg+" MPG. "
      +"Stops: "+named.length+" ("+named.filter(s=>s.type!=="home").length+" destinations). "
      +(hasMiles?"Miles calculated: "+Math.round(trip.totMi||0)+" total. ":"Miles NOT calculated yet. ")
      +(hasDate?"Departure date set. ":"No departure date - dates won't calculate. ")
      +"Finance months logged: "+Object.keys(finances?.months||{}).length+". "
      +"Maintenance logs: "+(rvMaintenance?.logs||[]).length+". "
      +"Current tab: "+tab+".";
  };

  const findFaq=(q)=>{
    const ql=q.toLowerCase();
    let best=null; let bestScore=0;
    HELP_FAQS.forEach(faq=>{
      const score=faq.k.filter(k=>ql.includes(k)).length;
      if(score>bestScore){bestScore=score;best=faq;}
    });
    return bestScore>0?best:null;
  };

  const send=async(override)=>{
    const text=(override||input).trim();
    if(!text||loading) return;
    setMsgs(m=>[...m,{role:"u",text}]);
    if(!override) setInput("");
    setLoading(true);

    // Try FAQ first
    const faq=findFaq(text);
    if(faq){
      setTimeout(()=>{
        setMsgs(m=>[...m,{role:"a",text:faq.a}]);
        setLoading(false);
      },300);
      return;
    }

    // AI fallback
    if(callAI){
      const ctx=tripContext();
      const p="You are the help assistant for RV Travel Mate app. Answer this user question concisely (under 120 words). Reference specific tab names. User trip context: "+ctx+" Question: "+text;
      const res=await callAI(p,"You are a helpful RV Travel Mate app assistant. Give specific, practical answers referencing exact tab and feature names. Keep responses under 120 words.");
      setMsgs(m=>[...m,{role:"a",text:res||"Sorry, I couldn't get an answer. Try rephrasing your question."}]);
    } else {
      setMsgs(m=>[...m,{role:"a",text:"I don't have a specific answer for that. Check the How To tab in the More group for a full feature guide, or try rephrasing your question."}]);
    }
    setLoading(false);
  };

  const QUICK=["How do I calculate miles?","Why aren't my dates working?","How do I plan a route with AI?","What AI features are free?","How do I track maintenance?","What is Travel Mode?"];

  return(<>
    <button onClick={()=>setOpen(o=>!o)} style={{position:"fixed",bottom:24,right:16,zIndex:9990,width:50,height:50,borderRadius:"50%",background:open?T.bgMid:"linear-gradient(135deg,"+T.accent+","+T.blue+")",color:open?T.muted:"#fff",border:open?"1px solid "+T.border:"none",cursor:"pointer",fontSize:20,boxShadow:"0 4px 16px rgba(0,0,0,0.3)",display:"flex",alignItems:"center",justifyContent:"center"}}>
      {open?"✕":"❓"}
    </button>
    {open&&<div style={{position:"fixed",bottom:84,right:16,width:320,maxWidth:"calc(100vw - 32px)",height:440,maxHeight:"calc(100vh - 120px)",background:T.bgMid,borderRadius:16,border:"1px solid "+T.border,boxShadow:"0 8px 40px rgba(0,0,0,0.4)",zIndex:9989,display:"flex",flexDirection:"column",overflow:"hidden"}}>
      <div style={{background:"linear-gradient(135deg,"+T.accent+","+T.blue+")",padding:"10px 14px",display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
        <span style={{fontSize:18}}>🚐</span>
        <div style={{flex:1}}>
          <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:13,color:"#fff"}}>RV Travel Mate Help</div>
          <div style={{fontSize:10,color:"rgba(255,255,255,0.8)"}}>Always free · Knows your trip</div>
        </div>
        <button onClick={()=>{setMsgs([{role:"a",text:"Hi! Ask me anything about RV Travel Mate."}]);}} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:6,padding:"2px 8px",color:"#fff",fontSize:10,cursor:"pointer"}}>Clear</button>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"10px 12px",display:"flex",flexDirection:"column",gap:8}}>
        {msgs.map((m,i)=>(
          <div key={i} style={{display:"flex",justifyContent:m.role==="u"?"flex-end":"flex-start"}}>
            <div style={{maxWidth:"85%",padding:"7px 11px",borderRadius:m.role==="u"?"12px 12px 2px 12px":"12px 12px 12px 2px",background:m.role==="u"?T.accent:T.bgLite,color:m.role==="u"?"#fff":T.text,fontSize:12,lineHeight:1.6}}>{m.text}</div>
          </div>
        ))}
        {loading&&<div style={{display:"flex",justifyContent:"flex-start"}}><div style={{padding:"7px 11px",borderRadius:"12px 12px 12px 2px",background:T.bgLite,color:T.muted,fontSize:12}}>Thinking...</div></div>}
        <div ref={endRef}/>
      </div>
      {msgs.length===1&&<div style={{padding:"0 10px 6px",display:"flex",flexWrap:"wrap",gap:4}}>
        {QUICK.map(q=><button key={q} onClick={()=>send(q)} style={{background:T.bgLite,border:"1px solid "+T.border,borderRadius:10,padding:"3px 8px",fontSize:10,color:T.muted,cursor:"pointer"}}>{q}</button>)}
      </div>}
      <div style={{padding:"8px 10px",borderTop:"1px solid "+T.border,display:"flex",gap:6,flexShrink:0}}>
        <input ref={inputRef} value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();send();}}} placeholder="Ask anything about the app..." style={{flex:1,background:T.bgLite,border:"1px solid "+T.border,borderRadius:8,color:T.text,padding:"7px 9px",fontSize:12,outline:"none"}}/>
        <button onClick={()=>send()} disabled={loading||!input.trim()} style={{background:loading||!input.trim()?T.border:T.accent,color:"#fff",border:"none",borderRadius:8,width:32,height:32,cursor:loading||!input.trim()?"not-allowed":"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center"}}>→</button>
      </div>
    </div>}
  </>);
}

// ── MAIN APP ───────────────────────────────────────────────────────
function AppInner({user,onSignOut,proFromDB=false,proUntil=null,proLabel=null}){
  const [loaded,setLoaded]=useState(false);
  const [isOnline,setIsOnline]=useState(()=>typeof navigator!=="undefined"?navigator.onLine:true);
  useEffect(()=>{
    // Hide the pre-React loading screen now that React has mounted
    try{window.__hidePreLoader&&window.__hidePreLoader();}catch{}
    const goOnline=()=>setIsOnline(true);
    const goOffline=()=>setIsOnline(false);
    window.addEventListener("online",goOnline);
    window.addEventListener("offline",goOffline);
    return()=>{window.removeEventListener("online",goOnline);window.removeEventListener("offline",goOffline);};
  },[]);
  const [saveConsent,setSaveConsent]=useState(null);
  const [storageQuotaWarning,setStorageQuotaWarning]=useState(false);
  const [cloudSyncing,setCloudSyncing]=useState(false);
  const [cloudSyncMsg,setCloudSyncMsg]=useState('');
  // Simple data fingerprint - detects if data changed since last cloud load
  const hashTripData=(d)=>{
    if(!d) return "";
    const s=JSON.stringify({stops:d.stops,vehicle:d.vehicle,prefs:d.prefs,settings:d.settings});
    let h=0;for(let i=0;i<s.length;i++){h=(Math.imul(31,h)+s.charCodeAt(i))|0;}
    return String(h);
  };
  const cloudSyncTimer=useRef();
  const isLoadingRef=useRef(false); // blocks auto-save during applyTripData
  const pendingAutoCalcRef=useRef(false); // triggers auto-calc after AI applies stops
  const lastLoadedHashRef=useRef(null); // fingerprint of last cloud-loaded data
  const [showConsentModal,setShowConsentModal]=useState(false);
  const [showTips,setShowTips]=useState(false);
  const [showWizard,setShowWizard]=useState(()=>{
    // Auto-launch wizard for first-time users (all defaults intact, never dismissed)
    try{
      const dismissed=localStorage.getItem("rv-wizard-seen")==="1";
      if(dismissed) return false;
      return true; // First visit - show wizard
    }catch{return false;}
  });

  // ── Expose callAI to window for LocalFavoritesCard (stable ref) ──

  // ── Listen for AI Fix-It stop additions ──
  useEffect(()=>{
    const handler=(e)=>{
      if(e.detail?.stops) setStops(e.detail.stops);
    };
    window.addEventListener("rv-add-stop",handler);
    return()=>window.removeEventListener("rv-add-stop",handler);
  },[]);
  const [showWelcome,setShowWelcome]=useState(false);
  const [sidebarCollapsed,setSidebarCollapsed]=useState(()=>typeof window!=="undefined"&&window.innerWidth<768);
  const [showAIUpgrade,setShowAIUpgrade]=useState(false);
  const [showAIBuilder,setShowAIBuilder]=useState(false);
  const [showHuntPlanner,setShowHuntPlanner]=useState(false);
  const [showAIPicker,setShowAIPicker]=useState(false);
  const [showAIFuel,setShowAIFuel]=useState(false);
  const [showAIStops,setShowAIStops]=useState(false);
  const [aiFreeCalls,setAiFreeCalls]=useState(null); // null=loading, number=remaining
  const [aiPurchased,setAiPurchased]=useState(proFromDB);
  // Sync proFromDB when it changes (e.g. after login)
  useEffect(()=>{if(proFromDB)setAiPurchased(true);},[proFromDB]);
  const AI_FREE_LIMIT=5;
  const LEMON_URL=process.env.REACT_APP_LEMON_URL || "https://rvtravelmate.lemonsqueezy.com/checkout/buy/dc504f50-c79c-4744-9e60-d4c4d8518b91";
  const [liveEta,setLiveEta]=useState(null);
  const [mapSnapshot,setMapSnapshot]=useState(null); // base64 map image for print // {eta:Date, nextStop:string, miles:number, mph:number}
  const prevGpsPosRef=useRef(null); // for speed calculation from position changes
  const prevGpsTimeRef=useRef(null);
  const [tab,setTab]=useState("vehicle");
  const [prevTab,setPrevTab]=useState("vehicle");
  const [pageTipTab,setPageTipTab]=useState(null);

  // Fire first-visit tip and welcome modal on first load
  useEffect(()=>{
    if(!loaded) return;
    try{
      const seen=JSON.parse(localStorage.getItem("rv-page-tips-seen")||"{}");
      if(!seen["vehicle"]) setPageTipTab("vehicle");
      // Show welcome modal on very first visit
      const hasSeenWelcome=localStorage.getItem("rv-welcome-seen");
      if(!hasSeenWelcome) setShowWelcome(true);
    }catch{ setPageTipTab("vehicle"); }
  },[loaded]);

  const handleSetTab=(t)=>{
    if(t!=="howto") setPrevTab(t);
    setTab(t);
    if(PAGE_TIPS[t]){
      try{
        const seen=JSON.parse(localStorage.getItem("rv-page-tips-seen")||"{}");
        if(!seen[t]) setPageTipTab(t);
      }catch{ setPageTipTab(t); }
    }
  };
  const dismissPageTip=()=>{
    try{
      const seen=JSON.parse(localStorage.getItem("rv-page-tips-seen")||"{}");
      seen[pageTipTab]=true;
      localStorage.setItem("rv-page-tips-seen",JSON.stringify(seen));
    }catch{}
    setPageTipTab(null);
  };
  const [vehicle,setVehicle]=useState(DEF.vehicle);
  const [rvMaintenance,setRvMaintenance]=useState(DEF.rvMaintenance);
  const [toys,setToys]=useState(DEF.toys);
  const [propane,setPropane]=useState(DEF.propane);
  const [pets,setPets]=useState(DEF.pets);
  const [gymMemberships,setGymMemberships]=useState(DEF.gymMemberships);
  const [causes,setCauses]=useState(DEF.causes);
  const [motoEvents,setMotoEvents]=useState(DEF.motoEvents);
  const [cellNotes,setCellNotes]=useState(DEF.cellNotes);
  const [dumpNotes,setDumpNotes]=useState(DEF.dumpNotes);
  const [campgroundJournal,setCampgroundJournal]=useState(DEF.campgroundJournal);
  const [showPublishJournal,setShowPublishJournal]=useState(false);
  const [homeWatch,setHomeWatch]=useState(DEF.homeWatch);
  const [medications,setMedications]=useState(DEF.medications);
  const [tirePressure,setTirePressure]=useState(DEF.tirePressure);
  const [fuelCards,setFuelCards]=useState(DEF.fuelCards);
  const [finances,setFinances]=useState(DEF.finances);
  const [emergency,setEmergency]=useState(DEF.emergency);
  const [actuals,setActuals]=useState(DEF.actuals);
  const [mapFilters,setMapFilters]=useState(()=>{
    try{const s=localStorage.getItem("rv-map-filters");
      if(s){const p=JSON.parse(s);return{...DEF.mapFilters,...p};}
    }catch{}
    return DEF.mapFilters;
  });
  const [headerView,setHeaderView]=useState('full'); // 'full' | 'next'
  const [headerCollapsed,setHeaderCollapsed]=useState(false);
  const [headerPinned,setHeaderPinned]=useState(true);
  const [prefs,setPrefs]=useState(DEF.prefs);
  const [finance,setFinance]=useState(DEF.finance);
  const [fuel,setFuel]=useState(DEF.fuel);
  const [memberships,setMemberships]=useState(DEF.memberships);
  const [settings,setSettings]=useState(()=>{
    // Load settings immediately from dedicated key to prevent theme flash
    try{
      const saved=localStorage.getItem("rv-settings-v1");
      if(saved){
        const s=JSON.parse(saved);
        if(["desertcamo","woodlandcamo"].includes(s.themeKey))s.themeKey="clean";
        return{...DEF.settings,...s};
      }
    }catch{}
    return DEF.settings;
  });
  const [stops,setStops]=useState(DEF.stops);
  // Handler for AI-suggested stops and/or modifications
  // newStopsInput = array of new stops to add
  // modifications = array of existing stop changes
  const handleAIAddStop=(newStopsInput=[], modifications=[])=>{
    const newStopsArr=Array.isArray(newStopsInput)?newStopsInput.filter(s=>s.name):[newStopsInput].filter(s=>s&&s.name);
    setStops(prev=>{
      let next=prev;
      // Apply modifications to existing stops first
      if(modifications&&modifications.length>0){
        next=applyAIModifications(next,modifications);
      }
      // Then insert new stops
      if(newStopsArr.length>0){
        next=insertAIStops(next,newStopsArr);
      }
      return next;
    });
    setTab("stops");
  };
  const [quickLinks,setQuickLinks]=useState(DEF.quickLinks);
  const [fuelPrices,setFuelPrices]=useState({});
  const [saveMsg,setSaveMsg]=useState(false);
  const msgTimer=useRef();

  const T={...THEMES[settings.themeKey]||THEMES.asphalt,F:FONTS[settings.fontKey]||FONTS.Barlow};
  // Apply theme immediately on every render (CSS vars are cheap to set)
  try{injectStyles(T,T.F);}catch{}

  useEffect(()=>{
    injectStyles(T,T.F);
    try{localStorage.setItem("rv-settings-v1",JSON.stringify(settings));}catch{}
  },[settings.themeKey,settings.fontKey,settings]);

  // Helper to apply loaded data to state
  const applyTripData=d=>{
    isLoadingRef.current=true;
    if(d.vehicle)setVehicle(v=>({...DEF.vehicle,...d.vehicle}));
    if(d.prefs)setPrefs(v=>({...DEF.prefs,...d.prefs}));
    if(d.finance)setFinance(v=>({...DEF.finance,...d.finance,monthlyTakeHome:""}));
    if(d.fuel)setFuel(v=>({...DEF.fuel,...d.fuel}));
    if(d.memberships)setMemberships(v=>({...DEF.memberships,...d.memberships}));
    if(d.settings){const _s={...DEF.settings,...d.settings};if(["desertcamo","woodlandcamo"].includes(_s.themeKey))_s.themeKey="clean";setSettings(v=>({...v,..._s}));}
    if(d.stops){
      // Scrub stale lat/lon: only keep coords if address is also set
      // Coords without address are from old campground assigns that may be wrong
      const cleanStops=d.stops.map(s=>({
        ...s,
        lat:s.address&&s.address.trim()?s.lat:null,
        lon:s.address&&s.address.trim()?s.lon:null,
      }));
      setStops(cleanStops);
    }
    if(d.quickLinks)setQuickLinks(d.quickLinks);
    if(d.actuals)setActuals(v=>({...DEF.actuals,...d.actuals}));
    if(d.rvMaintenance)setRvMaintenance(v=>({...DEF.rvMaintenance,...d.rvMaintenance,logs:d.rvMaintenance.logs||[],fillups:d.rvMaintenance.fillups||[]}));
    if(d.toys)setToys(d.toys);
    if(d.propane)setPropane(d.propane);
    if(d.campgroundJournal)setCampgroundJournal(d.campgroundJournal);
    if(d.homeWatch)setHomeWatch(d.homeWatch);
    if(d.medications)setMedications(d.medications);
    if(d.tirePressure)setTirePressure(d.tirePressure);
    if(d.fuelCards)setFuelCards(d.fuelCards);
    if(d.pets)setPets(d.pets);
    if(d.gymMemberships)setGymMemberships(d.gymMemberships);
    if(d.causes)setCauses(d.causes);
    if(d.motoEvents)setMotoEvents(d.motoEvents);
    if(d.cellNotes)setCellNotes(d.cellNotes);
    if(d.dumpNotes)setDumpNotes(d.dumpNotes);
    if(d.finances)setFinances(v=>({...DEF.finances,...d.finances,months:d.finances.months||{}}));
    if(d.emergency)setEmergency(v=>({...DEF.emergency,...d.emergency,roadside:d.emergency.roadside||[],insurance:d.emergency.insurance||[],contacts:d.emergency.contacts||[],documents:d.emergency.documents||[]}));
    if(d.mapFilters)setMapFilters(v=>({...DEF.mapFilters,...d.mapFilters}));
    if(d.headerPinned!==undefined)setHeaderPinned(d.headerPinned);
    if(d.headerCollapsed!==undefined)setHeaderCollapsed(d.headerCollapsed);
    // Clear loading flag after a tick so auto-save useEffect doesn't fire
    // Store fingerprint of loaded data so auto-save can detect real changes
    const loadedHash=hashTripData({stops:d.stops,vehicle:d.vehicle,prefs:d.prefs,settings:d.settings});
    lastLoadedHashRef.current=loadedHash;
    // Use longer timeout to cover all React re-renders from state setters above
    setTimeout(()=>{isLoadingRef.current=false;},2000);
  };

  useEffect(()=>{
    const loadData=async()=>{
      try{
        const consent=localStorage.getItem("rv-save-consent");
        if(consent===null){setShowConsentModal(true);}
        else{
          setSaveConsent(consent==="true");
          // Try Supabase first if user is logged in
          if(user){
            try{
              const{data:cloudData,error}=await supabase
                .from("trip_data")
                .select("data")
                .eq("user_id",user.id)
                .single();
              if(!error&&cloudData?.data){
                const local=localStorage.getItem(STORE_KEY);
                const localTime=local?JSON.parse(local)?.savedAt||0:0;
                const cloudTime=cloudData.data?.savedAt||0;
                // Use whichever is newer
                if(cloudTime>=localTime){
                  applyTripData(cloudData.data);
                  setLoaded(true);
                  return;
                }
              }
            }catch(e){console.warn("Cloud load failed, using local:",e);}
          }
          // Fall back to localStorage
          if(consent==="true"){
            const raw=localStorage.getItem(STORE_KEY);
            if(raw){applyTripData({...JSON.parse(raw)});}
          }
        }
      }catch(e){console.warn("Load error:",e);}
      finally{setLoaded(true);}
    };
    loadData();
  },[]);

  const handleConsent=decision=>{setSaveConsent(decision);setShowConsentModal(false);try{localStorage.setItem("rv-save-consent",decision.toString());}catch{}};

  // ── Load AI usage status from Supabase ──
  useEffect(()=>{
    if(!user) return;
    (async()=>{
      try{
        const{data}=await supabase.from("ai_usage").select("free_calls_remaining,purchased").eq("user_id",user.id).maybeSingle();
        if(data){
          setAiFreeCalls(data.free_calls_remaining??AI_FREE_LIMIT);
          setAiPurchased(data.purchased||false);
        } else {
          await supabase.from("ai_usage").insert({user_id:user.id,free_calls_remaining:AI_FREE_LIMIT,purchased:false});
          setAiFreeCalls(AI_FREE_LIMIT);
        }
      }catch(e){setAiFreeCalls(AI_FREE_LIMIT);}
    })();
  },[user]);

  // ── AI call helper - routes through Supabase Edge Function ──
  const callAI=async(prompt,systemPrompt)=>{
    // Allow if purchased, or if free calls remain, or if count not yet loaded (null)
    const canUse=aiPurchased||(aiFreeCalls===null)||(aiFreeCalls>0);
    if(!canUse){setShowAIUpgrade(true);return null;}
    try{
      // Timeout entire AI call at 45 seconds to prevent infinite hang
      const aiTimeout=new Promise((_,rej)=>setTimeout(()=>rej(new Error("AI request timed out after 45s. Check your connection and try again.")),45000));
      const aiCall=(async()=>{
      const{data:{session}}=await supabase.auth.getSession();
      if(!session?.access_token){
        console.warn("AI: No session token - user may not be logged in");
        return null;
      }
      const SUPABASE_ANON_KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFweHhmZG56Z2xueHlyeWF3dWp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5MzA0MTYsImV4cCI6MjA4ODUwNjQxNn0.mI71JjApI_OV2Wq9vm8EibwZQvot3EVtvdfgRpVJZL0";
      const res=await fetch((process.env.REACT_APP_SUPABASE_URL || "https://qpxxfdnzglnxyryawujz.supabase.co") + "/functions/v1/ai-proxy",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "Authorization":"Bearer "+session.access_token,
          "apikey":SUPABASE_ANON_KEY
        },
        body:JSON.stringify({
          prompt,
          systemPrompt:systemPrompt||APP_SYSTEM_PROMPT,
        })
      });
      if(!res.ok){
        const errText=await res.text();
        console.warn("AI: Edge function error:",res.status,errText);
        if(res.status===429) throw new Error("Too many AI requests - please wait a moment and try again.");
        if(res.status===503||res.status===502) throw new Error("AI service temporarily unavailable - try again in a few seconds.");
        if(res.status===401||res.status===403) throw new Error("AI authorization error - please refresh the page.");
        throw new Error("AI request failed ("+res.status+") - please try again.");
      }
      const d=await res.json();
      if(d.error){console.warn("AI error from function:",d.error);return null;}
      if(d.freeCallsRemaining!==undefined){setAiFreeCalls(d.freeCallsRemaining);}
      return d.text||null;
      })(); // end aiCall
      return await Promise.race([aiCall,aiTimeout]);
    }catch(e){
      console.warn("AI call failed with exception:",e);
      // Return error object so callers can show specific messages
      if(e.message&&e.message.length<200) return "__ERROR__:"+e.message;
      return null;
    }
  };

  // Show tips on startup if enabled
  useEffect(()=>{
    if(loaded&&settings.tipsEnabled){
      const t=setTimeout(()=>setShowTips(true),1200);
      return()=>clearTimeout(t);
    }
  },[loaded]);

  useEffect(()=>{
    if(!loaded) return;
    if(isLoadingRef.current) return; // suppress during load/pull
    const tripData={vehicle,prefs,finance:{...finance,monthlyTakeHome:""},fuel,memberships,settings,stops,quickLinks,mapFilters,headerPinned,headerCollapsed,rvMaintenance,finances,emergency,toys,propane,campgroundJournal,homeWatch,medications,tirePressure,fuelCards,pets,gymMemberships,causes,motoEvents,cellNotes,dumpNotes,savedAt:Date.now()};
    // Always save to localStorage if consent given
    if(saveConsent===true){
      try{
        localStorage.setItem(STORE_KEY,JSON.stringify(tripData));
        setSaveMsg(true);if(msgTimer.current)clearTimeout(msgTimer.current);msgTimer.current=setTimeout(()=>setSaveMsg(false),2000);
        setStorageQuotaWarning(false);
      }catch(e){
        // localStorage quota exceeded — likely from journal photos that failed
        // to upload to Supabase and fell back to local base64 storage.
        // Don't fail silently: warn the user so they know local backup isn't working.
        // Cloud sync to Supabase (below) is unaffected and remains the source of truth.
        console.warn("localStorage save failed (quota likely exceeded):",e.name);
        setStorageQuotaWarning(true);
      }
    }
    // Also sync to Supabase if logged in (debounced 3s to avoid hammering)
    if(user){
      if(cloudSyncTimer.current) clearTimeout(cloudSyncTimer.current);
      cloudSyncTimer.current=setTimeout(async()=>{
        try{
          setCloudSyncing(true);
          // Re-check isLoadingRef before writing - prevents load overwriting cloud
          if(isLoadingRef.current){setCloudSyncing(false);return;}
          // Check if data actually changed since last cloud load
          const currentHash=hashTripData({stops:tripData.stops,vehicle:tripData.vehicle,prefs:tripData.prefs,settings:tripData.settings});
          if(lastLoadedHashRef.current&&currentHash===lastLoadedHashRef.current){
            // Data unchanged since load - skip write to prevent overwrite loop
            setCloudSyncing(false);return;
          }
          // Data changed - safe to write, clear fingerprint
          lastLoadedHashRef.current=null;
          const{error}=await supabase.from("trip_data").upsert({
            user_id:user.id,
            data:tripData,
          },{onConflict:"user_id"});
          if(error) console.warn("Cloud save error:",error);
          else{setCloudSyncMsg("☁️ Synced");setTimeout(()=>setCloudSyncMsg(""),2000);}
        }catch(e){console.warn("Cloud sync failed:",e);}
        finally{setCloudSyncing(false);}
      },3000); // 3s debounce
    }
  },[vehicle,prefs,finance,fuel,memberships,settings,stops,quickLinks,loaded,saveConsent,mapFilters]);

  useEffect(()=>{
    // Step 1: fetch EIA regional prices
    fetch(`https://api.eia.gov/v2/petroleum/pri/gnd/data/?api_key=${EIA_KEY}&frequency=weekly&data[0]=value&facets[duoarea][]=R10&facets[duoarea][]=R20&facets[duoarea][]=R30&facets[duoarea][]=R40&facets[duoarea][]=R50&facets[product][]=EPD2D&sort[0][column]=period&sort[0][direction]=desc&offset=0&length=10`)
      .then(r=>r.json()).then(d=>{
        if(!d?.response?.data)return;
        const names={"R10":"East Coast","R20":"Midwest","R30":"Gulf Coast","R40":"Rocky Mtn","R50":"West Coast"};
        const prices={},raw={};const seen=new Set();
        d.response.data.forEach(item=>{if(item.duoarea&&item.value&&!seen.has(item.duoarea)){seen.add(item.duoarea);const p=parseFloat(item.value).toFixed(2);prices[names[item.duoarea]||item.duoarea]=p;raw[item.duoarea]=p;}});
        setFuelPrices(prices);

        // Step 2: determine best state to use for fuel price
        // Priority: (a) home stop state if set, (b) GPS location, (c) fallback AL/Gulf Coast
        const homeStop=stops.find(s=>s.type==="home");
        const homeState=homeStop?.state;

        const applyPrice=(state)=>{
          const region=STATE_TO_EIA_REGION[state]||"R30";
          const rp=raw[region];
          const regionName=names[region]||"Gulf Coast";
          if(rp&&(!fuel.avgPricePerGallon||fuel.avgPricePerGallon===3.30)){
            setFuel(prev=>({...prev,avgPricePerGallon:parseFloat(rp),_autoRegion:regionName}));
          }
        };

        if(homeState){
          // Home stop state is already set - use it directly
          applyPrice(homeState);
        } else if(navigator.geolocation){
          // No home state - try GPS to detect user's state
          navigator.geolocation.getCurrentPosition(pos=>{
            const{latitude:lat,longitude:lon}=pos.coords;
            fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`,{headers:{"Accept-Language":"en"}})
              .then(r=>r.json()).then(geo=>{
                const detectedState=geo?.address?.state_code||geo?.address?.["ISO3166-2-lvl4"]?.replace("US-","")||"AL";
                applyPrice(detectedState);
                // Also pre-fill home stop state if it's empty
                setStops(prev=>prev.map(s=>s.type==="home"&&!s.state?{...s,state:detectedState}:s));
              }).catch(()=>applyPrice("AL"));
          },()=>applyPrice("AL"),{timeout:5000,maximumAge:300000});
        } else {
          applyPrice("AL");
        }
      }).catch(()=>{});
  },[]);

  // Always use RV-type vehicle for main trip calculations - memoized to prevent render loops
  const RV_TYPES=["Class A Motorhome","Class B Campervan","Class C Motorhome","5th Wheel","Travel Trailer","Toy Hauler","Pop-Up Trailer","Truck Camper"];
  const trip=useMemo(()=>{
    const isRV=RV_TYPES.includes(vehicle.rvType);
    const tv=isRV?vehicle:{...vehicle,rvType:vehicle._rvType||"Class A Motorhome",mpg:vehicle._mpg||8,tankGallons:vehicle._tank||100,fuelType:vehicle._fuelType||"Diesel"};
    const base=calcTrip(stops,tv,fuel,finance,prefs);
    const sideFuel=stops.flatMap(s=>s.sideTrips||[]).filter(st=>st.mode==="addtotrip").reduce((a,st)=>a+(st.fuelCost||0),0);
    const sideMiles=stops.flatMap(s=>s.sideTrips||[]).filter(st=>st.mode==="addtotrip").reduce((a,st)=>a+(st.totalMiles||0),0);
    return {...base,totFuel:base.totFuel+sideFuel,grand:base.grand+sideFuel,totMi:base.totMi+sideMiles};
  },[stops,vehicle,fuel,finance,prefs]);

  // ── Save immediately when user leaves app (tab hidden / window blur) ──
  useEffect(()=>{
    const saveNow=()=>{
      if(!user||!loaded||!saveConsent) return;
      if(cloudSyncTimer.current) clearTimeout(cloudSyncTimer.current);
      const tripData={vehicle,prefs,finance:{...finance,monthlyTakeHome:""},fuel,memberships,settings,stops,quickLinks,mapFilters,headerPinned,headerCollapsed,rvMaintenance,finances,emergency,toys,propane,campgroundJournal,homeWatch,medications,tirePressure,fuelCards,pets,gymMemberships,causes,motoEvents,cellNotes,dumpNotes,savedAt:Date.now()};
      try{localStorage.setItem(STORE_KEY,JSON.stringify(tripData));}catch{}
      // Also push to cloud immediately
      supabase.from("trip_data").upsert({user_id:user.id,data:tripData},{onConflict:"user_id"})
        .then(({error})=>{if(error)console.warn("Blur save error:",error);});
    };
    document.addEventListener("visibilitychange",()=>{if(document.visibilityState==="hidden")saveNow();});
    window.addEventListener("beforeunload",saveNow);
    return()=>{
      document.removeEventListener("visibilitychange",saveNow);
      window.removeEventListener("beforeunload",saveNow);
    };
  },[user,loaded,saveConsent,vehicle,prefs,finance,fuel,memberships,settings,stops,quickLinks,mapFilters,headerPinned,headerCollapsed,rvMaintenance,finances,emergency]);

  // ── Auto-calculate miles after AI applies stops ──
  useEffect(()=>{
    if(!pendingAutoCalcRef.current) return;
    pendingAutoCalcRef.current=false;
    const needsCalc=stops.filter(s=>s.active&&s.name&&s.type!=="home"&&!(s.distFromPrev>0)).length>0;
    if(needsCalc&&tab==="stops"){
      // Switch to map tab and trigger calc after short delay
      setTimeout(()=>{
        handleSetTab("map");
        setTimeout(()=>{
          const calcBtn=document.querySelector("[data-action=calcmiles]");
          if(calcBtn) calcBtn.click();
        },500);
      },300);
    }
  },[stops,tab]);

  // ── Auto-sync calculated dates back into stop cards ──
  useEffect(()=>{
    if(!trip?.stops?.length) return;
    let changed=false;
    const updated=stops.map(s=>{
      const calc=trip.stops.find(c=>c.id===s.id);
      if(!calc) return s;
      if(s.fixedDates) return s;
      if(s.type==="home") return s; // home arriveDate is set by user - never auto-overwrite
      // Always use calc dates - they account for minNights, travel days, and chain
      const newArr=calc.arr||s.arriveDate||"";
      // Depart = arrive + minNights (always recalc so duration changes cascade)
      const newDep=newArr&&s.minNights>0?addDays(newArr,parseInt(s.minNights)||0):(calc.dep||s.departDate||"");
      if(newArr!==s.arriveDate||newDep!==s.departDate){
        changed=true;
        return{...s,arriveDate:newArr,departDate:newDep};
      }
      return s;
    });
    if(changed) setStops(updated);
  },[trip]);
  const allData={vehicle,prefs,finance,fuel,memberships,settings,stops,quickLinks,actuals,mapFilters};

  const onImport=d=>{
    if(d.vehicle)setVehicle({...DEF.vehicle,...d.vehicle});if(d.prefs)setPrefs({...DEF.prefs,...d.prefs});if(d.actuals)setActuals({...DEF.actuals,...d.actuals});
    if(d.mapFilters)setMapFilters({...DEF.mapFilters,...d.mapFilters});
    if(d.finance)setFinance({...DEF.finance,...d.finance,monthlyTakeHome:""});if(d.fuel)setFuel({...DEF.fuel,...d.fuel});
    if(d.memberships)setMemberships({...DEF.memberships,...d.memberships});if(d.settings)setSettings({...DEF.settings,...d.settings});
    if(d.stops){
            const cleanStops=d.stops.map(s=>({...s,lat:s.address&&s.address.trim()?s.lat:null,lon:s.address&&s.address.trim()?s.lon:null}));
            setStops(cleanStops);
          }if(d.quickLinks)setQuickLinks(d.quickLinks);
  };

  const clearAll=()=>{
    if(!window.confirm("Clear all trip data and start fresh? Your theme, vehicle setup and preferences will be kept."))return;
    // Keep settings (theme, font etc) and vehicle - only clear trip data
    setStops(DEF.stops);
    setQuickLinks(DEF.quickLinks);
    setActuals(DEF.actuals);
    setFinance(DEF.finance);
    // Save current non-trip data so it persists
    try{
      const keep={vehicle,prefs,fuel,memberships,settings,savedAt:Date.now(),stops:DEF.stops,quickLinks:DEF.quickLinks};
      localStorage.setItem(STORE_KEY,JSON.stringify(keep));
    }catch{}
  };

  // Trip Inverse handler - reverses stop order keeping home at position 1
  const inverseTrip=(mode="direct")=>{
    setStops(prev=>{
      const home=prev.find(s=>s.type==="home");
      const others=prev.filter(s=>s.type!=="home");
      if(!home&&others.length===0) return prev;

      if(mode==="retrace"){
        // ── Retrace mode: exact reverse of all stops INCLUDING fuel stops ──
        // User is physically at the last stop. Route: LastStop → ... → Home.
        // Keep lat/lon on all stops so OSRM retraces the exact same roads.
        // Home appears ONLY at the end as the destination — not at start.
        const reversed=[...others].reverse();
        const withDates=reversed.map(s=>({
          ...s,
          distFromPrev:0,arriveDate:"",departDate:"",
          // Preserve lat/lon — OSRM uses these to retrace exact outbound roads
        }));
        // Home as final destination (with its stored coords)
        const homeAsDest={
          ...home,id:uid(),type:"family",
          name:(home.homeCity||home.name||"Home")+(home.state?", "+home.state:""),
          notes:"🏠 Return Home",
          distFromPrev:0,arriveDate:"",departDate:"",
          minNights:0,maxNights:0,nights:0,nightlyRate:0,isFree:true,
          lat:home.lat||null,lon:home.lon||null,
        };
        // Temporarily set home as inactive — the reversed first stop IS the new origin
        // Route reads: Sturgis → Hill City → Fergus Falls → Louisville → Foley
        const inactiveHome={...home,active:false};
        return[inactiveHome,...withDates,homeAsDest];
      } else {
        // ── Direct mode: reverse stop order for planning, OSRM finds fastest roads ──
        // Keep home at position 0 for planning. Clear coords so OSRM routes fresh.
        const reversed=[...others].reverse();
        const cleared=reversed.map(s=>({
          ...s,
          distFromPrev:0,arriveDate:"",departDate:"",
          lat:null,lon:null,
        }));
        const homeAsDest={
          ...home,id:uid(),type:"family",
          name:(home.homeCity||home.name||"Home")+(home.state?", "+home.state:""),
          notes:"🏠 Return Home",
          distFromPrev:0,arriveDate:"",departDate:"",
          minNights:0,maxNights:0,nights:0,nightlyRate:0,isFree:true,
          lat:home.lat||null,lon:home.lon||null,
        };
        return[{...home,distFromPrev:0,arriveDate:"",departDate:""},...cleared,homeAsDest];
      }
    });
  };

  // Handler to open How To at a specific section
  const openHowTo=(sectionId)=>{
    handleSetTab("howto");
    // Store the target section in sessionStorage so HowToSection can auto-expand it
    try{sessionStorage.setItem("howto-target",sectionId);}catch{}
  };

  const TAB_GROUPS=[
    {id:"setup",  label:"🚗 Setup",   tabs:[{id:"vehicle",l:"🚗 Vehicle"},{id:"prefs",l:"🗺 Travel"},{id:"finance",l:"💵 Budget"},{id:"fuel",l:"⛽ Fuel"},{id:"memberships",l:"🎫 Members"}]},
    {id:"myrv",   label:"🔧 My RV",   tabs:[{id:"maintenance",l:"🔧 Maintenance"},{id:"fillups",l:"⛽ Fill-ups"},{id:"checklist",l:"✅ Checklist"},{id:"toys",l:"🏍 Toys"},{id:"tirepressure",l:"🛞 Tires"},{id:"propane",l:"🔥 Propane"},{id:"fuelcards",l:"💳 Fuel Cards"}]},
    {id:"finances",label:"💰 Finances", tabs:[{id:"monthly",l:"📅 Monthly"},{id:"annual",l:"📊 Annual"},{id:"budget",l:"🎯 Budget"}]},
    {id:"trip",   label:"📍 Trip",    tabs:[{id:"stops",l:"📍 Stops"},{id:"map",l:"🗺 Map"},{id:"lookahead",l:"🔍 Near Stops"},{id:"boondocking",l:"🌲 Free Camp"},{id:"weather",l:"🌤 Weather"},{id:"returnhome",l:"🏠 Return Home"},{id:"cellcoverage",l:"📶 Cell"},{id:"dumpstations",l:"🪣 Dumps"}]},
    {id:"output", label:"📊 Results", tabs:[{id:"results",l:"📊 Summary"},{id:"tripsplit",l:"🤝 Split"},{id:"print",l:"🖨 Print"},{id:"quicklinks",l:"🔗 Links"}]},
    {id:"history",label:"📚 History", tabs:[{id:"history",l:"📚 History"},{id:"journal",l:"📓 Journal"},{id:"narrative",l:"✨ Trip Story"}]},
    {id:"ai",     label:"🤖 AI Planner", tabs:[{id:"ai",l:"🤖 Plan My Route"},{id:"narrative",l:"✨ Trip Story"}]},
    {id:"more",   label:"⚙️ More",   tabs:[{id:"exportimport",l:"💾 Save/Load"},{id:"settings",l:"⚙️ Settings"},{id:"howto",l:"📖 How To"},{id:"emergency",l:"🆘 Emergency"}]},
    {id:"lifestyle",label:"🏡 Lifestyle", tabs:[{id:"homewatch",l:"🏠 Home Watch"},{id:"medications",l:"💊 Meds"},{id:"pets",l:"🐾 Pets"},{id:"gym",l:"🏋️ Gym"},{id:"events",l:"🎪 Events"}]},
  ];
  const activeGroup=TAB_GROUPS.find(g=>g.tabs.some(t=>t.id===tab));

  const compact=settings.compactMode;
  const pad=compact?"18px 16px 50px":"28px 20px 70px";

  if(!loaded)return<ThemeContext.Provider value={T}><div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:16}}><div style={{fontFamily:T.F.head,fontSize:40,color:T.accent,letterSpacing:4}}>RV TRAVEL MATE</div><div style={{color:T.muted,fontSize:14}}>Loading...</div></div></ThemeContext.Provider>;

  return(
    <ThemeContext.Provider value={T}>
      {/* Sidebar — fixed position, rendered outside content flow */}
      <GroupedTabBar groups={TAB_GROUPS} tab={tab} setTab={handleSetTab} trip={trip} compact={compact} sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed}/>
      {/* Main content area */}
      <div id="main-content" style={{minHeight:"100vh",background:T.bg,color:T.text,fontFamily:T.F.body,fontSize:settings.fontScale==="large"?"17px":settings.fontScale==="xlarge"?"19px":"15px",transition:"margin-left .2s ease"}}>
        {!isOnline&&<div style={{position:"fixed",top:0,left:0,right:0,zIndex:99999,background:"#b45309",color:"#fff",padding:"10px 16px",display:"flex",alignItems:"center",justifyContent:"center",gap:10,boxShadow:"0 2px 12px rgba(0,0,0,0.3)"}}>
          <span style={{fontSize:18,flexShrink:0}}>📵</span>
          <div style={{flex:1,textAlign:"center"}}>
            <span style={{fontWeight:700,fontSize:14}}>You appear to be offline.</span>
            <span style={{fontSize:13,marginLeft:8,opacity:.9}}>Maps, weather, and fuel prices need an internet connection. Your saved trip data is still available.</span>
          </div>
        </div>}
{/* ORS banner removed — OSRM handles routing without a key */}
        {showConsentModal&&<SaveConsentModal onDecide={handleConsent}/>}
      {showTips&&<TipsModal onClose={()=>setShowTips(false)}/>}
      {pageTipTab&&<PageTipModal tabId={pageTipTab} onClose={dismissPageTip}/>}
      {showHuntPlanner&&<AIHuntPlanner
        callAI={callAI} aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls}
        stops={stops} onStops={setStops}
        vehicle={vehicle} prefs={prefs} memberships={memberships}
        onClose={()=>setShowHuntPlanner(false)}
        onShowAIUpgrade={()=>{setShowHuntPlanner(false);setShowAIUpgrade(true);}}
        onMapReset={()=>{}}
        onAutoCalc={()=>{pendingAutoCalcRef.current=true;handleSetTab("map");}}
        
      />}
      {showAIBuilder&&<AIStopBuilder
        callAI={callAI} aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls}
        stops={stops} onStops={setStops}
        vehicle={vehicle} prefs={prefs} fuel={fuel} memberships={memberships}
        onClose={()=>setShowAIBuilder(false)}
        onShowAIUpgrade={()=>{setShowAIBuilder(false);setShowAIUpgrade(true);}}
        onMapReset={()=>{}}
        onAutoCalc={()=>{pendingAutoCalcRef.current=true;handleSetTab("map");}}
        
      />}
      {showAIFuel&&<AIFuelPlanner
        callAI={callAI} trip={trip} vehicle={vehicle} fuel={fuel} stops={stops}
        aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls}
        onClose={()=>setShowAIFuel(false)}
        onShowAIUpgrade={()=>{setShowAIFuel(false);setShowAIUpgrade(true);}}
      />}
      {showAIStops&&<AIStopSuggestions
        callAI={callAI} trip={trip} vehicle={vehicle} prefs={prefs} stops={stops}
        aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls}
        onClose={()=>setShowAIStops(false)}
        onShowAIUpgrade={()=>{setShowAIStops(false);setShowAIUpgrade(true);}}
      />}
      {storageQuotaWarning&&<div style={{position:"fixed",top:0,left:0,right:0,zIndex:99997,background:"#b45309",color:"#fff",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"center",gap:10,fontSize:12,boxShadow:"0 2px 12px rgba(0,0,0,0.3)"}}>
        <span>⚠️</span>
        <span>Local backup storage is full (likely from journal photos). Your data is still safely synced to the cloud, but won\'t be backed up on this device. Consider removing some photos or freeing space.</span>
        <button onClick={()=>setStorageQuotaWarning(false)} style={{background:"none",border:"none",color:"#fff",cursor:"pointer",fontSize:14,marginLeft:8}}>✕</button>
      </div>}
      <PWAInstallPrompt/>
      {showWelcome&&<WelcomeModal
          onClose={()=>{try{localStorage.setItem("rv-welcome-seen","1");}catch{}setShowWelcome(false);}}
          onStartWizard={()=>{try{localStorage.setItem("rv-welcome-seen","1");}catch{}setShowWelcome(false);setShowWizard(true);}}
        />}
      {showAIUpgrade&&<AIUpgradeModal
        onClose={()=>setShowAIUpgrade(false)}
        freeCalls={aiFreeCalls}
        aiPurchased={aiPurchased}
        lemonUrl={LEMON_URL}
      />}
      {showAIPicker&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div style={{background:T.bgMid,borderRadius:20,width:"100%",maxWidth:400,boxShadow:"0 24px 80px rgba(0,0,0,0.5)",overflow:"hidden"}}>
          <div style={{background:"linear-gradient(135deg,#7c3aed,#3b82f6)",padding:"16px 20px"}}>
            <div style={{fontFamily:T.F.cond,fontWeight:900,fontSize:20,color:"#fff"}}>✨ AI Trip Planner</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,0.8)",marginTop:2}}>Choose your planning mode</div>
          </div>
          <div style={{padding:"16px 20px",display:"flex",flexDirection:"column",gap:10}}>
            <button onClick={()=>{setShowAIPicker(false);setShowAIBuilder(true);}} style={{display:"flex",gap:14,alignItems:"center",padding:"14px 16px",borderRadius:12,border:"2px solid "+T.accent+"44",background:T.accent+"08",cursor:"pointer",textAlign:"left"}}>
              <div style={{fontSize:32,flexShrink:0}}>🗺</div>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:T.accent}}>Route Planner</div>
                <div style={{fontSize:12,color:T.muted,marginTop:2}}>Plan any RV road trip - choose destination, style, length. AI handles overnight stops and return.</div>
              </div>
            </button>
            <button onClick={()=>{setShowAIPicker(false);setShowHuntPlanner(true);}} style={{display:"flex",gap:14,alignItems:"center",padding:"14px 16px",borderRadius:12,border:"2px solid #16a34a44",background:"#16a34a08",cursor:"pointer",textAlign:"left"}}>
              <div style={{fontSize:32,flexShrink:0}}>🦌</div>
              <div>
                <div style={{fontFamily:T.F.cond,fontWeight:700,fontSize:15,color:"#16a34a"}}>Hunt Planner</div>
                <div style={{fontSize:12,color:T.muted,marginTop:2}}>Plan an RV hunting road trip - species, state, season. Includes regulations, license costs, public land.</div>
              </div>
            </button>
            <button onClick={()=>setShowAIPicker(false)} style={{padding:"9px",borderRadius:10,border:"1px solid "+T.border,background:"none",color:T.muted,fontSize:12,cursor:"pointer"}}>Cancel</button>
          </div>
        </div>
      </div>}
      {showWizard&&<SetupWizard
        vehicle={vehicle} prefs={prefs} fuel={fuel} memberships={memberships} stops={stops}
        onVehicle={setVehicle} onPrefs={setPrefs} onFuel={setFuel} onMemberships={setMemberships} onStops={setStops}
        onClose={()=>{
          setShowWizard(false);
          try{localStorage.setItem("rv-wizard-seen","1");}catch{}
        }}
      />}
        {/* ── Animated Header ── */}
        <div style={{background:T.headerGrad,padding:compact?"10px 16px 0":"14px 20px 0",position:headerPinned?"sticky":"relative",top:headerPinned?0:undefined,zIndex:headerPinned?150:undefined,overflow:"hidden",borderBottom:"1px solid "+T.border,boxShadow:headerPinned?"0 2px 12px rgba(0,0,0,0.15)":undefined}} ref={(el)=>{if(el&&headerPinned)document.documentElement.style.setProperty("--header-h",el.offsetHeight+"px")}}>
          <div style={{position:"relative",maxWidth:960,margin:"0 auto",paddingBottom:12}}>
            <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
              <div>
                <div style={{display:"flex",alignItems:"baseline",gap:8,flexWrap:"wrap"}}>
                  <span style={{fontFamily:T.F.head,fontSize:compact?18:26,fontWeight:900,letterSpacing:2,color:T.accent,lineHeight:1}}>RV TRAVEL MATE</span>
                </div>
                {/* Pro badge if user has promo */}
          {proFromDB&&proUntil&&<div style={{display:"inline-flex",alignItems:"center",gap:4,padding:"2px 8px",background:"#f59e0b22",border:"1px solid #f59e0b44",borderRadius:6,marginTop:4}}>
            <span style={{fontSize:10,color:"#f59e0b",fontWeight:700}}>⭐ PRO</span>
            {proLabel&&<span style={{fontSize:9,color:"#f59e0b",opacity:.8}}>· {proLabel}</span>}
          </div>}
          {/* Horizn branding */}
                <div style={{display:"flex",alignItems:"center",gap:5,marginTop:compact?2:4}}>
                  {/* Inline Horizn mini-logo mark */}
                  <svg width={compact?60:72} height={compact?16:20} viewBox="0 0 72 20" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="hzTextGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style={{stopColor:"#ffffff",stopOpacity:.9}}/>
                        <stop offset="100%" style={{stopColor:"#ffcc77",stopOpacity:.9}}/>
                      </linearGradient>
                      <linearGradient id="hzLineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style={{stopColor:"#ff6b2b",stopOpacity:0}}/>
                        <stop offset="50%" style={{stopColor:"#ffaa00",stopOpacity:1}}/>
                        <stop offset="100%" style={{stopColor:"#ff6b2b",stopOpacity:0}}/>
                      </linearGradient>
                    </defs>
                    {/* Horizon line */}
                    <rect x="0" y="11" width="72" height="1.2" fill="url(#hzLineGrad)" rx="1"/>
                    {/* Sun dot above line */}
                    <circle cx="36" cy="8" r="2.5" fill="#ffcc00" opacity="0.9"/>
                    <circle cx="36" cy="8" r="4" fill="#ff9500" opacity="0.25"/>
                    {/* HORIZN text below line */}
                    <text x="36" y="19" fontFamily="'Trebuchet MS','Arial Narrow',sans-serif" fontSize="7" fontWeight="900" letterSpacing="2.5" textAnchor="middle" fill="url(#hzTextGrad)">HORIZN</text>
                  </svg>
                  <span style={{fontFamily:"'Trebuchet MS',sans-serif",fontSize:compact?9:10,color:T.muted,letterSpacing:.5,opacity:.7}}>A Horizn Product</span>
                </div>
              </div>
              <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap",paddingTop:2}}>
                {/* Mobile hamburger — only shows when sidebar is closed on mobile */}
                <button
                  onClick={()=>setSidebarCollapsed(false)}
                  style={{display:"block",background:"none",border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",fontSize:18,cursor:"pointer",color:T.accent,lineHeight:1}}
                  title="Open menu">☰</button>
                {/* AI Planner quick-access button */}
                <button
                  onClick={()=>handleSetTab("ai")}
                  style={{display:"flex",alignItems:"center",gap:5,background:`linear-gradient(135deg,${T.accent},#7c3aed)`,border:"none",borderRadius:8,padding:"6px 12px",fontSize:12,fontWeight:700,cursor:"pointer",color:"#fff",whiteSpace:"nowrap",boxShadow:`0 2px 8px ${T.accent}44`}}
                  title="Open AI Route Planner">
                  🤖 AI Planner
                </button>
                {saveConsent===true&&<div style={{padding:"5px 12px",borderRadius:20,background:T.free+"20",border:`1px solid ${T.free}55`,fontSize:11,color:T.free,fontFamily:T.F.cond,fontWeight:700,letterSpacing:.5}}>✓ Auto-saving</div>}
                {cloudSyncMsg&&<div style={{padding:"5px 12px",borderRadius:20,background:T.blue+"20",border:`1px solid ${T.blue}55`,fontSize:11,color:T.blue,fontFamily:T.F.cond,fontWeight:700,letterSpacing:.5}}>{cloudSyncMsg}</div>}
                {cloudSyncing&&!cloudSyncMsg&&<div style={{padding:"5px 12px",borderRadius:20,background:T.muted+"20",border:`1px solid ${T.border}`,fontSize:11,color:T.muted,fontFamily:T.F.cond,fontWeight:700,letterSpacing:.5}}>⏳ Syncing...</div>}
                <a href={KOFI_URL} target="_blank" rel="noopener noreferrer" style={{padding:"6px 14px",borderRadius:20,background:"#FF5E5B",color:"#fff",fontSize:11,fontWeight:700,textDecoration:"none",fontFamily:T.F.cond,letterSpacing:.5,boxShadow:"0 2px 8px #FF5E5B44"}}>☕ Donate</a>
                <Btn variant="ghost" onClick={()=>setShowAIUpgrade(true)} style={{fontSize:11,padding:"5px 12px",borderRadius:20,background:"#7c3aed18",borderColor:"#7c3aed44",color:"#7c3aed"}} title="AI Features">
                  ✨ AI{aiFreeCalls!==null&&!aiPurchased&&aiFreeCalls>0?` (${aiFreeCalls} free)`:aiPurchased?" ✓":""}
                </Btn>
                <Btn variant="ghost" onClick={()=>setShowAIPicker(true)} style={{fontSize:11,padding:"5px 12px",borderRadius:20,background:"#7c3aed18",borderColor:"#7c3aed44",color:"#7c3aed",fontWeight:700}} title="AI Trip Planner">✨ AI Plan</Btn>
                <Btn variant="ghost" onClick={()=>setShowWizard(true)} style={{fontSize:11,padding:"5px 12px",borderRadius:20,background:T.accent+"18",borderColor:T.accent+"44",color:T.accent}} title="Setup Wizard">🚀 Setup</Btn>
                <Btn variant="ghost" onClick={()=>setShowTips(true)} style={{fontSize:11,padding:"5px 12px",borderRadius:20}} title="Show tips">💡 Tips</Btn>
                <Btn variant="ghost" onClick={()=>setTab("settings")} style={{fontSize:11,padding:"5px 12px",borderRadius:20}}>⚙️ Settings</Btn>
                <Btn variant="ghost" onClick={clearAll} style={{fontSize:11,padding:"5px 12px",borderRadius:20,color:T.danger,borderColor:T.danger+"55"}}>✕ Clear</Btn>
              </div>
            </div>
            {(trip.totMi>0||stops.filter(s=>s.active&&s.name&&s.type!=="home").length>0)&&<div style={{marginTop:12}}>
              {/* Toggle pills + collapse/pin controls */}
              <div style={{display:"flex",gap:6,marginBottom:headerCollapsed?0:8,alignItems:"center",flexWrap:"wrap"}}>
                {!headerCollapsed&&["full","next"].map(v=><button key={v} onClick={()=>setHeaderView(v)} style={{padding:"3px 12px",borderRadius:20,border:`1px solid ${headerView===v?T.accent:T.border}`,background:headerView===v?T.accent+"22":"transparent",color:headerView===v?T.accent:T.muted,fontSize:11,fontWeight:headerView===v?700:400,cursor:"pointer",transition:"all .15s"}}>{v==="full"?"🗺 Full Trip":"📍 Next Stop"}</button>)}
                <div style={{marginLeft:"auto",display:"flex",gap:4}}>
                  <button onClick={()=>setHeaderCollapsed(c=>!c)} title={headerCollapsed?"Expand the stats summary bar":"Collapse the stats summary bar to save screen space"} style={{padding:"3px 10px",borderRadius:20,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:11,cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
                    {headerCollapsed?"▼ Stats":"▲ Hide"}
                  </button>
                  <button onClick={()=>setHeaderPinned(p=>!p)} title={headerPinned?"Unpin - header scrolls away normally":"Pin - header sticks to top as you scroll down"} style={{padding:"3px 10px",borderRadius:20,border:`1px solid ${headerPinned?T.accent:T.border}`,background:headerPinned?T.accent+"18":"transparent",color:headerPinned?T.accent:T.muted,fontSize:11,cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
                    {headerPinned?"📌 Pinned":"📌 Pin"}
                  </button>
                </div>
              </div>
              {!headerCollapsed&&<div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              {(()=>{
                const totalActLodge=stops.reduce((s,st)=>s+(parseFloat(st.actualLodge)||0),0);
                const totalAct=totalActLodge+(actuals.fuel||0)+(actuals.food||0)+(actuals.activities||0)+(actuals.maintenance||0)+(actuals.other||0);
                const hasAct=totalAct>0;
                const over=hasAct&&totalAct>trip.grand;
                // Next stop: find first active stop with future/no arrive date
                const today=new Date().toISOString().slice(0,10);
                const nextStop=headerView==="next"?trip.stops.find(s=>s.active&&s.type!=="home"&&(!s.arr||s.arr>=today)):null;
                const etaStr=liveEta?new Date(liveEta.eta).toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit",hour12:true}):null;
                const statItems=headerView==="full"?[
                  {v:trip.totMi.toLocaleString()+" mi",l:"Total Miles",c:T.accent},
                  {v:trip.totNights+" nights",l:"On the Road",c:T.blue},
                  {v:hasAct?fmt$(totalAct):fmt$(trip.grand),l:hasAct?(over?"⚠ Over Budget":"✓ Actual Total"):"Est. Total",c:hasAct?(over?T.danger:T.free):T.green,sub:hasAct?`Est. ${fmt$(trip.grand)}`:null},
                  {v:vehicle.rvType==="🥾 Hike / Walk"?"🥾 Walk":fmt$(trip.cpd),l:vehicle.rvType==="🥾 Hike / Walk"?"Mode":"Per Day",c:T.accentAlt},
                  liveEta?{v:etaStr,l:`ETA · ${liveEta.miles}mi · ${liveEta.mph}mph`,c:"#22c55e",sub:liveEta.nextStop?.split(",")[0]}:{v:Math.round(trip.maxDailyMiles)+" mi",l:"Daily Max",c:T.muted},
                ]:nextStop?[
                  {v:(nextStop.mi||0).toLocaleString()+" mi",l:"Miles to Next",c:T.accent},
                  {v:nextStop.name||"Next Stop",l:"Destination",c:T.blue},
                  {v:nextStop.arr?new Date(nextStop.arr+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}):"TBD",l:"Arrive",c:T.green},
                  {v:fmt$(nextStop.fc||0),l:"Fuel Est.",c:T.accentAlt},
                  {v:nextStop.isFree?"FREE":fmt$(nextStop.lc||0),l:`${nextStop.nights||0} nights`,c:nextStop.isFree?T.free:T.muted},
                ]:[
                  {v:"No upcoming",l:"stops found",c:T.muted},
                ];
                return statItems.map(({v,l,c,sub})=>
                  <div key={l} style={{background:T.bgMid,borderRadius:10,padding:"8px 14px",borderTop:`2px solid ${c}`,boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>
                    <div style={{fontFamily:T.F.head,fontSize:17,color:c,lineHeight:1,fontWeight:900}}>{v}</div>
                    <div style={{fontSize:10,color:T.muted,letterSpacing:1,textTransform:"uppercase",marginTop:3}}>{l}</div>
                    {sub&&<div style={{fontSize:10,color:T.muted,marginTop:1}}>{sub}</div>}
                  </div>
                );
              })()}
              </div>}
            </div>}
          </div>
        </div>
        {/* ── Grouped Tab Bar ── */}
        {/* Sidebar nav rendered in outer layout */}
        <SetupGuideCard trip={trip} stops={stops} onTabChange={handleSetTab} pad={pad}/>
        {/* ── Progress Indicator ── */}
        {(()=>{
          const hasVehicle=vehicle.rvType&&vehicle.mpg>0;
          const hasHomeCity=stops.find(s=>s.type==="home"&&(s.homeCity||s.name!=="Home / Departure"));
          const hasStops=stops.filter(s=>s.active&&s.name&&s.type!=="home").length>0;
          const hasMiles=stops.filter(s=>s.active&&s.distFromPrev>0).length>0;
          const hasDate=stops.find(s=>s.type==="home"&&s.departDate);
          const steps=[
            {label:"Vehicle",done:hasVehicle,tab:"vehicle"},
            {label:"Home City",done:!!hasHomeCity,tab:"stops"},
            {label:"Stops",done:hasStops,tab:"stops"},
            {label:"Miles",done:hasMiles,tab:"map"},
            {label:"Dates",done:!!hasDate,tab:"stops"},
          ];
          const allDone=steps.every(s=>s.done);
          if(allDone) return null;
          const nextStep=steps.find(s=>!s.done);
          return<div style={{maxWidth:960,margin:"0 auto",padding:`4px ${pad} 0`}}>
            <div style={{display:"flex",alignItems:"center",gap:0,background:T.bgMid,borderRadius:10,overflow:"hidden",border:`1px solid ${T.border}`}}>
              {steps.map((s,i)=>(
                <div key={i} onClick={()=>handleSetTab(s.tab)} style={{flex:1,padding:"5px 4px",textAlign:"center",cursor:"pointer",background:s.done?"#27ae6018":s===nextStep?T.accent+"18":"transparent",borderRight:i<steps.length-1?`1px solid ${T.border}`:"none",transition:"background .15s"}}>
                  <div style={{fontSize:10,fontWeight:700,color:s.done?"#27ae60":s===nextStep?T.accent:T.muted,whiteSpace:"nowrap"}}>{s.done?"✓":s===nextStep?"→":""} {s.label}</div>
                </div>
              ))}
              <div style={{padding:"5px 8px",fontSize:10,color:T.muted,whiteSpace:"nowrap",flexShrink:0}}>Next: <strong style={{color:T.accent}}>{nextStep?.label}</strong></div>
            </div>
          </div>;
        })()}
        <div style={{maxWidth:960,margin:"0 auto",padding:pad}}>
          {tab==="ai"&&<div style={{padding:pad}}>
            <AIAssistantPanel
              stops={stops} vehicle={vehicle} prefs={prefs} fuel={fuel}
              finance={finance} memberships={memberships} trip={trip}
              callAI={callAI} aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls}
              onShowAIUpgrade={()=>setShowAIUpgrade(true)}
              onAddStop={handleAIAddStop}
              onRequestMapRoute={()=>setTab("map")}
            />
          </div>}
          {tab==="emergency"&&<div>
            <EmergencySection emergency={emergency} onChange={setEmergency} vehicle={vehicle} stops={stops}/>
            <div style={{padding:"0 20px 20px"}}><EmergencyResponseCard emergency={emergency} vehicle={vehicle} stops={stops}/></div>
          </div>}
          {tab==="monthly"&&<FinancesMonthlySection finances={finances} onChange={setFinances} rvMaintenance={rvMaintenance} vehicle={vehicle} stops={stops} callAI={callAI} settings={settings}/>}
          {tab==="annual"&&<FinancesAnnualSection finances={finances} rvMaintenance={rvMaintenance}/>}
          {tab==="budget"&&<FinancesBudgetSection finances={finances} onChange={setFinances}/>}
          {tab==="maintenance"&&<MaintenanceSection rvMaintenance={rvMaintenance} onChange={setRvMaintenance} vehicle={vehicle} stops={stops} />}
          {tab==="fillups"&&<FillupSection rvMaintenance={rvMaintenance} onChange={setRvMaintenance} vehicle={vehicle}/>}
          {tab==="checklist"&&<ChecklistSection vehicle={vehicle}/>}
          {tab==="toys"&&<ToysSection toys={toys} onChange={setToys}/>}
          {tab==="tirepressure"&&<TirePressureSection tirePressure={tirePressure} onChange={setTirePressure} vehicle={vehicle} stops={stops}/>}
          {tab==="propane"&&<PropaneSection propane={propane} onChange={setPropane} stops={stops}/>}
          {tab==="fuelcards"&&<FuelCardsSection fuelCards={fuelCards} onChange={setFuelCards}/>}
          {tab==="cellcoverage"&&<CellCoverageSection stops={stops} onChange={setCellNotes} cellNotes={cellNotes}/>}
          {tab==="dumpstations"&&<DumpStationSection stops={stops} dumpNotes={dumpNotes} onChange={setDumpNotes}/>}
          {tab==="tripsplit"&&<TripSplitSection trip={trip} stops={stops} vehicle={vehicle}/>}
          {tab==="homewatch"&&<HomeWatchSection homeWatch={homeWatch} onChange={setHomeWatch}/>}
          {tab==="pets"&&<PetSection pets={pets} onChange={setPets} stops={stops}/>}
          {tab==="gym"&&<GymSection gymMemberships={gymMemberships} onChange={setGymMemberships} stops={stops}/>}
          {tab==="events"&&<EventsSection stops={stops} causes={causes} onCauses={setCauses} motoEvents={motoEvents} onMotoEvents={setMotoEvents}/>}
          {tab==="medications"&&<MedicationSection medications={medications} onChange={setMedications} stops={stops}/>}
          {tab==="journal"&&<>
            <CampgroundJournal journal={campgroundJournal} onChange={setCampgroundJournal} stops={stops} onPublish={()=>setShowPublishJournal(true)}/>
            <div style={{padding:"0 20px 20px"}}>
              <JournalManageCard journal={campgroundJournal} stops={stops} user={user}/>
            </div>
            {showPublishJournal&&<PublishJournalModal journal={campgroundJournal} stops={stops} user={user} onClose={()=>setShowPublishJournal(false)}/>}
          </>}
          {tab==="narrative"&&<div style={{padding:pad}}><AITripNarrativeCard stops={stops} callAI={callAI} aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls} onShowAIUpgrade={()=>setShowAIUpgrade(true)}/></div>}
          {tab==="vehicle"&&<VehicleSection data={vehicle} onChange={setVehicle} onOpenHowTo={openHowTo} onTabChange={handleSetTab}/>}
          {tab==="prefs"&&<PrefsSection data={prefs} onChange={setPrefs} onOpenHowTo={openHowTo}/>}
          {tab==="finance"&&<FinanceSection data={finance} onChange={setFinance} onOpenHowTo={openHowTo}/>}
          {tab==="fuel"&&<FuelSection data={fuel} onChange={setFuel} memberships={memberships} fuelPrices={fuelPrices} onOpenHowTo={openHowTo}/>}
          {tab==="memberships"&&<MembershipsSection data={memberships} onChange={setMemberships} onOpenHowTo={openHowTo}/>}
          {tab==="stops"&&<StopsSection stops={stops} onChange={setStops} memberships={memberships} prefs={prefs} onOpenHowTo={openHowTo} onAIBuilder={()=>setShowAIBuilder(true)} onHuntPlanner={()=>setShowHuntPlanner(true)} aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls} onTabChange={handleSetTab} callAI={callAI}/>}
          {tab==="lookahead"&&<LookAheadSection stops={stops} onOpenHowTo={openHowTo}/>}
          {tab==="boondocking"&&<BoondockSection onOpenHowTo={openHowTo}/>}
          {tab==="map"&&<MapSection stops={stops} memberships={memberships} mapFilters={mapFilters} setMapFilters={setMapFilters} prefs={prefs} vehicle={vehicle} onLiveEta={setLiveEta} liveEta={liveEta} prevGpsPosRef={prevGpsPosRef} prevGpsTimeRef={prevGpsTimeRef} onMapSnapshot={setMapSnapshot} callAI={callAI} aiPurchased={aiPurchased} aiFreeCalls={aiFreeCalls} fuelApps={settings.fuelApps} onAddStop={(updates,mode)=>{
              if(mode==='assign'){
                // Campground assignment - update name/address/coords but KEEP miles, nights, dates
                setStops(prev=>prev.map(s=>{
                  const u=updates.find(u=>u.id===s.id);
                  if(!u) return s;
                  return{...s,
                    name:u.name||s.name,           // update to campground name
                    address:u.address||s.address,   // set address
                    lat:u.lat||s.lat,               // pin exact coords
                    lon:u.lon||s.lon,
                    // PRESERVE everything else: distFromPrev, minNights, nightlyRate, dates, etc.
                  };
                }));
                // Trigger miles recalc for affected stop after a short delay
                setTimeout(()=>{
                  setStops(prev=>{
                    const updated=updates[0];
                    if(!updated) return prev;
                    // Force miles recalc by clearing distFromPrev only if it was 0
                    return prev.map(s=>{
                      if(s.id!==updated.id) return s;
                      return s.distFromPrev>0?s:{...s,distFromPrev:0};
                    });
                  });
                },300);
              } else if(mode==='addstop'){
                // Add new stop from map waypoint click
                const newStop=updates[0];
                if(newStop){
                  setStops(prev=>{
                    // Insert after last active stop, before any inactive ones
                    const lastActiveIdx=prev.reduce((last,s,i)=>s.active?i:last,-1);
                    const insertAt=lastActiveIdx>=0?lastActiveIdx+1:prev.length;
                    const arr=[...prev];
                    arr.splice(insertAt,0,{...newStop,id:newStop.id||("wp_"+Date.now())});
                    return arr;
                  });
                }
              } else {
                // Miles update (from auto-calc or lat/lon cache)
                setStops(prev=>prev.map(s=>{
                  const u=updates.find(u=>u.id===s.id);
                  if(!u) return s;
                  return{...s,
                    distFromPrev:u.miles!==undefined?u.miles:s.distFromPrev,
                    lat:u.lat||s.lat,
                    lon:u.lon||s.lon,
                  };
                }));
              }
            }} emergency={emergency}/>}
          {tab==="results"&&<ResultsSection trip={trip} finance={finance} memberships={memberships} prefs={prefs} actuals={actuals} setActuals={setActuals} stops={stops} onOpenHowTo={openHowTo} vehicle={vehicle} fuel={fuel} callAI={callAI} aiFreeCalls={aiFreeCalls} aiPurchased={aiPurchased} onShowAIUpgrade={()=>setShowAIUpgrade(true)} onAIFuel={()=>setShowAIFuel(true)} onAIStops={()=>setShowAIStops(true)} rvMaintenance={rvMaintenance}/>}
          {tab==="quicklinks"&&<QuickLinksSection data={quickLinks} onChange={setQuickLinks} onOpenHowTo={openHowTo}/>}
          {tab==="weather"&&<WeatherSection stops={stops} onOpenHowTo={openHowTo}/>}
          {tab==="print"&&<PrintSection trip={trip} stops={stops} vehicle={vehicle} prefs={prefs} finance={finance} memberships={memberships} onOpenHowTo={openHowTo} mapSnapshot={mapSnapshot} setMapSnapshot={setMapSnapshot} rvMaintenance={rvMaintenance} finances={finances} campgroundJournal={campgroundJournal}/>}
          {tab==="exportimport"&&<ExportImport allData={allData} onImport={onImport} user={user}
            onSyncNow={async()=>{
              if(!user){alert("Sign in to use cloud sync.");return;}
              setCloudSyncing(true);
              const tripData={...allData,finance:{...allData.finance,monthlyTakeHome:""},savedAt:Date.now()};
              try{
                const{error}=await supabase.from("trip_data").upsert({user_id:user.id,data:tripData},{onConflict:"user_id"});
                if(error)alert("Sync failed: "+error.message);
                else{setCloudSyncMsg("☁️ Synced");setTimeout(()=>setCloudSyncMsg(""),3000);}
              }catch(e){alert("Sync error: "+e.message);}
              setCloudSyncing(false);
            }}
            onPullCloud={async()=>{
              if(!user){alert("Sign in to use cloud sync.");return;}
              try{
                const{data:cloudData,error}=await supabase.from("trip_data").select("data").eq("user_id",user.id).single();
                if(error||!cloudData?.data){alert("No cloud data found for your account.");return;}
                if(window.confirm("Replace your current trip with the cloud version? (saved "+new Date(cloudData.data?.savedAt||0).toLocaleString()+")")){
                  onImport(cloudData.data);
                  setCloudSyncMsg("☁️ Loaded from cloud");setTimeout(()=>setCloudSyncMsg(""),3000);
                }
              }catch(e){alert("Pull failed: "+e.message);}
            }}
           onOpenHowTo={openHowTo}/>}
          {tab==="settings"&&<SettingsSection data={settings} onChange={setSettings} onOpenHowTo={openHowTo} user={user}/>}
          {tab==="howto"&&<HowToSection onClose={()=>setTab(prevTab||"vehicle")}/>}
          {tab==="history"&&<TripHistorySection currentTrip={trip} stops={stops} vehicle={vehicle} finance={finance} actuals={actuals} onArchive={()=>{setStops(DEF.stops);setActuals(DEF.actuals);}} onOpenHowTo={openHowTo} />}
          {tab==="returnhome"&&<ReturnHomeSection stops={stops} vehicle={vehicle} fuel={fuel} prefs={prefs} onOpenHowTo={openHowTo} onInverseTrip={inverseTrip}/>}
        </div>
        <div style={{background:T.bgMid,padding:"14px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
          <span style={{fontSize:11,color:T.border}}>RV Travel Mate · Free · Open Source · Income never stored 🛣{user&&<span style={{marginLeft:8,color:T.muted}}> · {user.email}</span>}</span>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            {onSignOut&&<button onClick={onSignOut} style={{padding:"6px 14px",background:"transparent",color:T.muted,border:`1px solid ${T.border}`,borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:T.F.cond,letterSpacing:.5}}>Sign Out</button>}
            <a href={KOFI_URL} target="_blank" rel="noopener noreferrer" style={{padding:"6px 16px",background:"#FF5E5B",color:"#fff",borderRadius:6,fontSize:11,fontWeight:700,textDecoration:"none",fontFamily:T.F.cond,letterSpacing:.5}}>☕ Support This App</a>
          </div>
        </div>
        <HelpChat trip={trip} stops={stops} vehicle={vehicle} tab={tab} finances={finances} rvMaintenance={rvMaintenance} callAI={callAI}/>
        {saveMsg&&<div className="save-toast" style={{position:"fixed",bottom:24,right:24,zIndex:999,background:T.free,color:"#fff",borderRadius:8,padding:"10px 18px",fontFamily:T.F.cond,fontWeight:700,fontSize:14,boxShadow:"0 4px 20px #0008",pointerEvents:"none"}}>✓ Trip auto-saved</div>}
      </div>{/* end main-content */}
    </ThemeContext.Provider>
  );
}


// ── Login Screen ───────────────────────────────────────────────────
function LoginScreen({onLogin}){
  const [email,setEmail]=useState('');
  const [password,setPassword]=useState('');
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');
  const [showPwd,setShowPwd]=useState(false);
  const [forgotMode,setForgotMode]=useState(false);
  const [resetSent,setResetSent]=useState(false);
  const [isSignUp,setIsSignUp]=useState(()=>{
    // Auto-switch to signup if URL has ?signup=1 or ?promo=...
    const p=new URLSearchParams(window.location.search);
    return p.has("signup")||p.has("promo");
  });
  const [promoCode,setPromoCode]=useState(()=>{
    const p=new URLSearchParams(window.location.search);
    return (p.get("promo")||"").toUpperCase();
  });
  const [promoValid,setPromoValid]=useState(null); // null=unchecked, true=valid, false=invalid
  const [confirmPassword,setConfirmPassword]=useState('');

  // Valid promo codes — add new ones here
  const PROMOS={
    "D4J2025":{days:365,label:"Dough 4 Joe 2025",desc:"Thank you for supporting Dough 4 Joe! Enjoy 1 year of Pro access free."},
    "D4J2026":{days:365,label:"Dough 4 Joe 2026",desc:"Thank you for supporting Dough 4 Joe! Enjoy 1 year of Pro access free."},
    "HORIZN2025":{days:90,label:"Horizn Launch",desc:"Welcome! Enjoy 90 days of Pro access as our launch gift."},
    "RVMATE":{days:30,label:"RV Travel Mate",desc:"Welcome! Enjoy 30 days of Pro access."},
  };

  const checkPromo=(code)=>{
    const c=(code||"").toUpperCase().trim();
    setPromoCode(c);
    if(!c){setPromoValid(null);return;}
    setPromoValid(!!PROMOS[c]);
  };

  const applyPromo=async(userId,code)=>{
    const promo=PROMOS[code];
    if(!promo) return;
    const proUntil=new Date(Date.now()+promo.days*24*60*60*1000).toISOString();
    // Upsert profile with pro_until date
    await supabase.from("profiles").upsert({
      id:userId,
      pro_until:proUntil,
      promo_code:code,
      promo_label:promo.label,
    },{onConflict:"id"});
  };

  const handleForgotPassword=async()=>{
    if(!email.trim()){setError("Please enter your email address first.");return;}
    setLoading(true);setError("");
    const {error:err}=await supabase.auth.resetPasswordForEmail(email.trim(),{
      redirectTo:window.location.origin,
    });
    setLoading(false);
    if(err){setError(err.message);return;}
    setResetSent(true);
  };

  const handleLogin=async e=>{
    e.preventDefault();
    if(!email.trim()||!password.trim()){setError('Please enter your email and password.');return;}
    setLoading(true);setError('');
    const {data,error:err}=await supabase.auth.signInWithPassword({email:email.trim(),password});
    if(err){
      setError(err.message==='Invalid login credentials'?'Incorrect email or password. Try again or use Forgot Password.':err.message);
      setLoading(false);return;
    }
    onLogin(data.user);
  };

  const handleSignUp=async e=>{
    e.preventDefault();
    if(!email.trim()||!password.trim()){setError('Please enter your email and password.');return;}
    if(password!==confirmPassword){setError('Passwords do not match.');return;}
    if(password.length<6){setError('Password must be at least 6 characters.');return;}
    setLoading(true);setError('');
    const {data,error:err}=await supabase.auth.signUp({
      email:email.trim(),
      password,
      options:{data:{promo_code:promoCode||null}},
    });
    if(err){setError(err.message);setLoading(false);return;}
    // Apply promo code if valid
    if(data.user&&promoCode&&PROMOS[promoCode]){
      await applyPromo(data.user.id,promoCode);
    }
    // Some Supabase configs require email confirmation
    if(data.session){
      onLogin(data.user);
    } else {
      setError('');
      setLoading(false);
      // Show email confirmation message
      setResetSent(true);
    }
  };

  // Horizn brand colors
  const BG='#0f172a';
  const CARD='#1e293b';
  const BORDER='#334155';
  const ACCENT='#3b82f6';
  const TEXT='#f1f5f9';
  const MUTED='#64748b';
  const SUCCESS='#22c55e';
  const DANGER='#ef4444';

  const inputStyle={width:'100%',background:BG,border:'1px solid '+BORDER,borderRadius:8,color:TEXT,padding:'11px 14px',fontSize:15,outline:'none',boxSizing:'border-box',transition:'border-color .15s',fontFamily:"inherit"};

  return(
    <div style={{minHeight:'100vh',background:BG,display:'flex',alignItems:'center',justifyContent:'center',padding:20,fontFamily:"'Inter',-apple-system,sans-serif"}}>
      <div style={{width:'100%',maxWidth:440}}>

        {/* Logo */}
        <div style={{textAlign:'center',marginBottom:32}}>
          <div style={{fontSize:52,marginBottom:8}}>🚐</div>
          <div style={{fontSize:26,fontWeight:900,letterSpacing:2,color:ACCENT,marginBottom:4}}>RV TRAVEL MATE</div>
          <div style={{fontSize:12,color:MUTED,letterSpacing:2,textTransform:'uppercase'}}>by Horizn Software</div>
        </div>

        {/* Dough 4 Joe promo banner — shows when promo in URL */}
        {promoCode&&PROMOS[promoCode]&&<div style={{background:'linear-gradient(135deg,#dc262618,#f59e0b18)',border:'2px solid #dc262644',borderRadius:12,padding:'14px 16px',marginBottom:20,textAlign:'center'}}>
          <div style={{fontSize:20,marginBottom:4}}>❤️🏍</div>
          <div style={{fontSize:14,fontWeight:700,color:'#dc2626',marginBottom:4}}>Dough 4 Joe — Free Pro Access!</div>
          <div style={{fontSize:12,color:TEXT,lineHeight:1.6}}>{PROMOS[promoCode].desc}</div>
          <div style={{fontSize:11,color:MUTED,marginTop:6}}>Sign up below to redeem your <strong style={{color:'#f59e0b'}}>{PROMOS[promoCode].days} days</strong> of Pro access.</div>
        </div>}

        {/* Card */}
        <div style={{background:CARD,borderRadius:20,padding:32,border:'1px solid '+BORDER,boxShadow:'0 20px 60px rgba(0,0,0,0.5)'}}>

          {/* Sign in / Sign up toggle */}
          <div style={{display:'flex',background:BG,borderRadius:10,padding:4,marginBottom:28,gap:4}}>
            <button onClick={()=>{setIsSignUp(false);setError('');}} style={{flex:1,padding:'9px',borderRadius:8,background:!isSignUp?ACCENT:'transparent',color:!isSignUp?'#fff':MUTED,border:'none',fontWeight:700,fontSize:13,cursor:'pointer',transition:'all .15s'}}>
              Sign In
            </button>
            <button onClick={()=>{setIsSignUp(true);setError('');}} style={{flex:1,padding:'9px',borderRadius:8,background:isSignUp?ACCENT:'transparent',color:isSignUp?'#fff':MUTED,border:'none',fontWeight:700,fontSize:13,cursor:'pointer',transition:'all .15s'}}>
              Create Account
            </button>
          </div>

          {error&&<div style={{background:'#7f1d1d',border:'1px solid #ef444444',borderRadius:8,padding:'10px 14px',marginBottom:16,fontSize:13,color:'#fca5a5'}}>{error}</div>}
          {resetSent&&!isSignUp&&<div style={{background:'#14532d',border:'1px solid #22c55e44',borderRadius:8,padding:'10px 14px',marginBottom:16,fontSize:13,color:'#86efac'}}>✓ Password reset email sent! Check your inbox.</div>}
          {resetSent&&isSignUp&&<div style={{background:'#14532d',border:'1px solid #22c55e44',borderRadius:8,padding:'14px 16px',marginBottom:16,fontSize:13,color:'#86efac',textAlign:'center'}}>
            <div style={{fontSize:24,marginBottom:8}}>✅</div>
            <div style={{fontWeight:700,marginBottom:4}}>Account created!</div>
            <div>Check your email and click the confirmation link, then come back here to sign in.</div>
            {promoCode&&PROMOS[promoCode]&&<div style={{marginTop:8,color:'#f59e0b',fontWeight:600}}>Your {PROMOS[promoCode].days}-day Pro access will activate when you confirm your email.</div>}
          </div>}

          {/* Email */}
          <div style={{marginBottom:16}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:MUTED,marginBottom:6,letterSpacing:.5,textTransform:'uppercase'}}>Email Address</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
              placeholder="you@example.com" autoComplete="email"
              onKeyDown={e=>e.key==='Enter'&&(isSignUp?handleSignUp(e):handleLogin(e))}
              style={inputStyle}
              onFocus={e=>e.target.style.borderColor=ACCENT}
              onBlur={e=>e.target.style.borderColor=BORDER}/>
          </div>

          {/* Password */}
          <div style={{marginBottom:isSignUp?16:8}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:MUTED,marginBottom:6,letterSpacing:.5,textTransform:'uppercase'}}>Password</label>
            <div style={{position:'relative'}}>
              <input type={showPwd?'text':'password'} value={password} onChange={e=>setPassword(e.target.value)}
                placeholder={isSignUp?"Create a password (6+ characters)":"Your password"} autoComplete={isSignUp?"new-password":"current-password"}
                onKeyDown={e=>e.key==='Enter'&&(isSignUp?handleSignUp(e):handleLogin(e))}
                style={{...inputStyle,paddingRight:44}}
                onFocus={e=>e.target.style.borderColor=ACCENT}
                onBlur={e=>e.target.style.borderColor=BORDER}/>
              <button onClick={()=>setShowPwd(!showPwd)} style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:MUTED,fontSize:16,padding:4}}>
                {showPwd?'🙈':'👁'}
              </button>
            </div>
          </div>

          {/* Confirm password — signup only */}
          {isSignUp&&<div style={{marginBottom:16}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:MUTED,marginBottom:6,letterSpacing:.5,textTransform:'uppercase'}}>Confirm Password</label>
            <input type="password" value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)}
              placeholder="Repeat your password" autoComplete="new-password"
              style={{...inputStyle,borderColor:confirmPassword&&confirmPassword!==password?DANGER:BORDER}}
              onFocus={e=>e.target.style.borderColor=ACCENT}
              onBlur={e=>e.target.style.borderColor=confirmPassword&&confirmPassword!==password?DANGER:BORDER}/>
            {confirmPassword&&confirmPassword!==password&&<div style={{fontSize:11,color:DANGER,marginTop:4}}>Passwords do not match</div>}
          </div>}

          {/* Promo code — signup only */}
          {isSignUp&&<div style={{marginBottom:20}}>
            <label style={{display:'block',fontSize:11,fontWeight:700,color:MUTED,marginBottom:6,letterSpacing:.5,textTransform:'uppercase'}}>Promo Code <span style={{color:MUTED,fontWeight:400,textTransform:'none'}}>(optional)</span></label>
            <div style={{position:'relative'}}>
              <input value={promoCode} onChange={e=>checkPromo(e.target.value)}
                placeholder="e.g. D4J2025" autoComplete="off"
                style={{...inputStyle,textTransform:'uppercase',letterSpacing:1,borderColor:promoValid===true?SUCCESS:promoValid===false?DANGER:BORDER}}
                onFocus={e=>e.target.style.borderColor=ACCENT}
                onBlur={e=>e.target.style.borderColor=promoValid===true?SUCCESS:promoValid===false?DANGER:BORDER}/>
              {promoValid===true&&<span style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',color:SUCCESS,fontSize:16}}>✓</span>}
              {promoValid===false&&<span style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',color:DANGER,fontSize:14}}>✗</span>}
            </div>
            {promoValid===true&&PROMOS[promoCode]&&<div style={{marginTop:6,fontSize:12,color:SUCCESS,fontWeight:600}}>✓ {PROMOS[promoCode].label} — {PROMOS[promoCode].days} days Pro access!</div>}
            {promoValid===false&&<div style={{marginTop:4,fontSize:11,color:DANGER}}>Invalid promo code</div>}
          </div>}

          {/* Forgot password — login only */}
          {!isSignUp&&<div style={{textAlign:'right',marginBottom:20}}>
            <button onClick={handleForgotPassword} disabled={loading} style={{background:'none',border:'none',color:MUTED,fontSize:12,cursor:'pointer',textDecoration:'underline',padding:0}}>
              Forgot password?
            </button>
          </div>}

          {/* Submit */}
          {!resetSent&&<button
            onClick={isSignUp?handleSignUp:handleLogin} disabled={loading}
            style={{width:'100%',background:loading?BORDER:ACCENT,color:'#fff',border:'none',borderRadius:10,padding:'13px',fontSize:15,fontWeight:700,cursor:loading?'not-allowed':'pointer',letterSpacing:.5,transition:'all .15s',boxShadow:loading?'none':'0 4px 16px #3b82f644'}}
            onMouseEnter={e=>{if(!loading)e.target.style.background='#2563eb';}}
            onMouseLeave={e=>{if(!loading)e.target.style.background=ACCENT;}}>
            {loading?(isSignUp?'Creating account…':'Signing in…'):(isSignUp?'Create Account →':'Sign In →')}
          </button>}

          {/* Bottom note */}
          <div style={{marginTop:20,padding:'12px 14px',background:BG,borderRadius:8,border:'1px solid '+BORDER,fontSize:12,color:MUTED,lineHeight:1.7,textAlign:'center'}}>
            {isSignUp?"By creating an account you agree to use this app responsibly. Your data is stored securely and never sold.":"Don't have an account? Tap Create Account above — it's free to get started."}
          </div>
        </div>

        {/* Footer */}
        <div style={{textAlign:'center',marginTop:20,display:'flex',flexDirection:'column',gap:6}}>
          <div style={{fontSize:11,color:'#334155'}}>RV Travel Mate · A Horizn Product · {new Date().getFullYear()}</div>
          <a href="https://www.dough4joe.com" target="_blank" rel="noopener noreferrer" style={{fontSize:11,color:'#dc2626',textDecoration:'none',opacity:.7}}>❤️ Supporting Dough 4 Joe</a>
        </div>
      </div>
    </div>
  );
}

// ── Root App with Auth Gate ────────────────────────────────────────
function AuthGatedApp(){
  const [user,setUser]=useState(null);
  const [authLoading,setAuthLoading]=useState(true);

  const [proStatus,setProStatus]=useState(null); // null=loading, object=loaded

  const checkProStatus=async(userId)=>{
    if(!userId) return;
    try{
      const {data}=await supabase.from("profiles").select("pro_until,promo_code,promo_label").eq("id",userId).single();
      setProStatus(data||{});
    }catch{setProStatus({});}
  };

  useEffect(()=>{
    // Register service worker for PWA
    if('serviceWorker' in navigator){
      window.addEventListener('load',()=>{
        navigator.serviceWorker.register('/sw.js').catch(()=>{});
      });
    }
    // Check existing session
    supabase.auth.getSession().then(({data:{session}})=>{
      const u=session?.user??null;
      setUser(u);
      if(u) checkProStatus(u.id);
      setAuthLoading(false);
    });
    // Listen for auth changes
    const {data:{subscription}}=supabase.auth.onAuthStateChange((_event,session)=>{
      const u=session?.user??null;
      setUser(u);
      if(u) checkProStatus(u.id);
    });
    return()=>subscription.unsubscribe();
  },[]);

  if(authLoading){
    return(
      <div style={{minHeight:'100vh',background:'#0f172a',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:16}}>
        <img src="/icons/icon-192.png" alt="RVParkMate" style={{width:72,height:72,borderRadius:16}}/>
        <div style={{color:'#1d6ed8',fontSize:14,fontFamily:"'Inter',sans-serif",letterSpacing:2,textTransform:'uppercase'}}>RV Travel Mate</div>
      </div>
    );
  }

  if(!user) return <LoginScreen onLogin={setUser}/>;

  const isProUser=proStatus&&proStatus.pro_until&&new Date(proStatus.pro_until)>new Date();
  return <AppInner user={user} onSignOut={async()=>{await supabase.auth.signOut();setUser(null);setProStatus(null);}} proFromDB={isProUser} proUntil={proStatus?.pro_until} proLabel={proStatus?.promo_label}/>;
}

// ── Root: journal route check before auth ─────────────────────────
export default function App(){
  const path=window.location.pathname;
  const journalMatch=path.match(/^\/journal\/([a-z0-9-]+)$/i);
  if(journalMatch){
    return<PublicJournalViewer slug={journalMatch[1]}/>;
  }
  return<AuthGatedApp/>;
}
